import Vue from 'vue';
import { Checkbox, Popover, Submenu, Dialog, Dropdown, DropdownMenu, DropdownItem, Menu, MenuItem, MenuItemGroup, Input, Radio, RadioGroup, RadioButton, CheckboxButton, CheckboxGroup, Switch, Select, Option, OptionGroup, Tooltip, Form, FormItem, Tabs, TabPane, Alert, Upload, Progress, Spinner, Step, Scrollbar, Collapse, CollapseItem, Loading, Message } from 'element-ui';
import moment from 'moment';
import { debounce as debounce$1, isEqual } from 'lodash';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _library = false;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode:  'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var _functionToString = _shared('native-function-to-string', Function.toString);

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');

var TO_STRING = 'toString';
var TPL = ('' + _functionToString).split(TO_STRING);

_core.inspectSource = function (it) {
  return _functionToString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var en = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      // week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    }
  }
};
});

var lang = unwrapExports(en);

var zhCN = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    }
  }
};
});

unwrapExports(zhCN);

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var util = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;
exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;



var _vue2 = _interopRequireDefault(Vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {}
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
}
function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}
var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
}
var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = exports.isIE = function isIE() {
  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = exports.isEdge = function isEdge() {
  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};
});

unwrapExports(util);
var util_1 = util.isEdge;
var util_2 = util.isIE;
var util_3 = util.coerceTruthyValueToArray;
var util_4 = util.arrayFind;
var util_5 = util.arrayFindIndex;
var util_6 = util.escapeRegexpString;
var util_7 = util.valueEquals;
var util_8 = util.generateId;
var util_9 = util.getValueByPath;
var util_10 = util.noop;
var util_11 = util.hasOwn;
var util_12 = util.toObject;
var util_13 = util.getPropByPath;

var format = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = (0, util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
};



var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */
});

unwrapExports(format);

var locale = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.i18n = exports.use = exports.t = undefined;



var _zhCN2 = _interopRequireDefault(zhCN);



var _vue2 = _interopRequireDefault(Vue);



var _deepmerge2 = _interopRequireDefault(cjs);



var _format2 = _interopRequireDefault(format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format$1 = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = exports.t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format$1(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = exports.use = function use(l) {
  lang = l || lang;
};

var i18n = exports.i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

exports.default = { use: use, t: t, i18n: i18n };
});

var locale$1 = unwrapExports(locale);
var locale_1 = locale.i18n;
var locale_2 = locale.use;
var locale_3 = locale.t;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrastundefined.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrastundefined.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var vuePopper_min = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t(Popper);}(commonjsGlobal,function(e){function t(e,t,o){e&&t&&o&&(document.addEventListener?e.addEventListener(t,o,!1):e.attachEvent("on"+t,o));}function o(e,t,o){e&&t&&(document.removeEventListener?e.removeEventListener(t,o,!1):e.detachEvent("on"+t,o));}e=e&&e.hasOwnProperty("default")?e.default:e;var n={props:{tagName:{type:String,default:"span"},trigger:{type:String,default:"hover",validator:function(e){return ["clickToOpen","click","clickToToggle","hover","focus"].indexOf(e)>-1}},delayOnMouseOver:{type:Number,default:10},delayOnMouseOut:{type:Number,default:10},disabled:{type:Boolean,default:!1},content:String,enterActiveClass:String,leaveActiveClass:String,boundariesSelector:String,reference:{},forceShow:{type:Boolean,default:!1},dataValue:{default:null},appendToBody:{type:Boolean,default:!1},visibleArrow:{type:Boolean,default:!0},transition:{type:String,default:""},stopPropagation:{type:Boolean,default:!1},preventDefault:{type:Boolean,default:!1},options:{type:Object,default:function(){return {}}},rootClass:{type:String,default:""}},data:function(){return {referenceElm:null,popperJS:null,showPopper:!1,currentPlacement:"",popperOptions:{placement:"bottom",computeStyle:{gpuAcceleration:!1}}}},watch:{showPopper:function(e){e?(this.$emit("show",this),this.popperJS&&this.popperJS.enableEventListeners(),this.updatePopper()):(this.popperJS&&this.popperJS.disableEventListeners(),this.$emit("hide",this));},forceShow:{handler:function(e){this[e?"doShow":"doClose"]();},immediate:!0},disabled:function(e){e&&(this.showPopper=!1);}},created:function(){this.appendedArrow=!1,this.appendedToBody=!1,this.popperOptions=Object.assign(this.popperOptions,this.options);},mounted:function(){switch(this.referenceElm=this.reference||this.$slots.reference[0].elm,this.popper=this.$slots.default[0].elm,this.trigger){case"clickToOpen":t(this.referenceElm,"click",this.doShow),t(document,"click",this.handleDocumentClick);break;case"click":case"clickToToggle":t(this.referenceElm,"click",this.doToggle),t(document,"click",this.handleDocumentClick);break;case"hover":t(this.referenceElm,"mouseover",this.onMouseOver),t(this.popper,"mouseover",this.onMouseOver),t(this.referenceElm,"mouseout",this.onMouseOut),t(this.popper,"mouseout",this.onMouseOut);break;case"focus":t(this.referenceElm,"focus",this.onMouseOver),t(this.popper,"focus",this.onMouseOver),t(this.referenceElm,"blur",this.onMouseOut),t(this.popper,"blur",this.onMouseOut);}},methods:{doToggle:function(e){this.stopPropagation&&e.stopPropagation(),this.preventDefault&&e.preventDefault(),this.forceShow||(this.showPopper=!this.showPopper);},doShow:function(){this.showPopper=!0;},doClose:function(){this.showPopper=!1;},doDestroy:function(){this.showPopper||(this.popperJS&&(this.popperJS.destroy(),this.popperJS=null),this.appendedToBody&&(this.appendedToBody=!1,document.body.removeChild(this.popper.parentElement)));},createPopper:function(){var t=this;this.$nextTick(function(){if(t.visibleArrow&&t.appendArrow(t.popper),t.appendToBody&&!t.appendedToBody&&(t.appendedToBody=!0,document.body.appendChild(t.popper.parentElement)),t.popperJS&&t.popperJS.destroy&&t.popperJS.destroy(),t.boundariesSelector){var o=document.querySelector(t.boundariesSelector);o&&(t.popperOptions.modifiers=Object.assign({},t.popperOptions.modifiers),t.popperOptions.modifiers.preventOverflow=Object.assign({},t.popperOptions.modifiers.preventOverflow),t.popperOptions.modifiers.preventOverflow.boundariesElement=o);}t.popperOptions.onCreate=function(){t.$emit("created",t),t.$nextTick(t.updatePopper);},t.popperJS=new e(t.referenceElm,t.popper,t.popperOptions);});},destroyPopper:function(){o(this.referenceElm,"click",this.doToggle),o(this.referenceElm,"mouseup",this.doClose),o(this.referenceElm,"mousedown",this.doShow),o(this.referenceElm,"focus",this.doShow),o(this.referenceElm,"blur",this.doClose),o(this.referenceElm,"mouseout",this.onMouseOut),o(this.referenceElm,"mouseover",this.onMouseOver),o(document,"click",this.handleDocumentClick),this.showPopper=!1,this.doDestroy();},appendArrow:function(e){if(!this.appendedArrow){this.appendedArrow=!0;var t=document.createElement("div");t.setAttribute("x-arrow",""),t.className="popper__arrow",e.appendChild(t);}},updatePopper:function(){this.popperJS?this.popperJS.scheduleUpdate():this.createPopper();},onMouseOver:function(){var e=this;clearTimeout(this._timer),this._timer=setTimeout(function(){e.showPopper=!0;},this.delayOnMouseOver);},onMouseOut:function(){var e=this;clearTimeout(this._timer),this._timer=setTimeout(function(){e.showPopper=!1;},this.delayOnMouseOut);},handleDocumentClick:function(e){this.$el&&this.referenceElm&&!this.elementContains(this.$el,e.target)&&!this.elementContains(this.referenceElm,e.target)&&this.popper&&!this.elementContains(this.popper,e.target)&&(this.$emit("documentClick",this),this.forceShow||(this.showPopper=!1));},elementContains:function(e,t){return "function"==typeof e.contains&&e.contains(t)}},destroyed:function(){this.destroyPopper();}};const r=n;n.__file="popper.js.vue";return function(e,t,o,n,r,s,i,p,c,a){"function"==typeof i&&(c=p,p=i,i=!1);const d="function"==typeof o?o.options:o;let l;if(e&&e.render&&(d.render=e.render,d.staticRenderFns=e.staticRenderFns,d._compiled=!0,r&&(d.functional=!0)),n&&(d._scopeId=n),s?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),t&&t.call(this,c(e)),e&&e._registeredComponents&&e._registeredComponents.add(s);},d._ssrRegister=l):t&&(l=i?function(){t.call(this,a(this.$root.$options.shadowRoot));}:function(e){t.call(this,p(e));}),l)if(d.functional){const e=d.render;d.render=function(t,o){return l.call(o),e(t,o)};}else{const e=d.beforeCreate;d.beforeCreate=e?[].concat(e,l):[l];}return o}({render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o(e.tagName,{tag:"component"},[o("transition",{attrs:{name:e.transition,"enter-active-class":e.enterActiveClass,"leave-active-class":e.leaveActiveClass},on:{"after-leave":e.doDestroy}},[o("span",{directives:[{name:"show",rawName:"v-show",value:!e.disabled&&e.showPopper,expression:"!disabled && showPopper"}],ref:"popper",class:e.rootClass},[e._t("default",[e._v(e._s(e.content))])],2)]),e._v(" "),e._t("reference")],2)},staticRenderFns:[]},void 0,r,void 0,!1,void 0,void 0,void 0)});
});

/*!
 * vuejs-datepicker v1.5.3
 * (c) 2016-2018 Charlie Kassel
 * Released under the MIT License.
 */
var Language = function Language (language, months, monthsAbbr, days) {
  this.language = language;
  this.months = months;
  this.monthsAbbr = monthsAbbr;
  this.days = days;
  this.rtl = false;
  this.ymd = false;
  this.yearSuffix = '';
};

var prototypeAccessors = { language: { configurable: true },months: { configurable: true },monthsAbbr: { configurable: true },days: { configurable: true } };

prototypeAccessors.language.get = function () {
  return this._language
};

prototypeAccessors.language.set = function (language) {
  if (typeof language !== 'string') {
    throw new TypeError('Language must be a string')
  }
  this._language = language;
};

prototypeAccessors.months.get = function () {
  return this._months
};

prototypeAccessors.months.set = function (months) {
  if (months.length !== 12) {
    throw new RangeError(("There must be 12 months for " + (this.language) + " language"))
  }
  this._months = months;
};

prototypeAccessors.monthsAbbr.get = function () {
  return this._monthsAbbr
};

prototypeAccessors.monthsAbbr.set = function (monthsAbbr) {
  if (monthsAbbr.length !== 12) {
    throw new RangeError(("There must be 12 abbreviated months for " + (this.language) + " language"))
  }
  this._monthsAbbr = monthsAbbr;
};

prototypeAccessors.days.get = function () {
  return this._days
};

prototypeAccessors.days.set = function (days) {
  if (days.length !== 7) {
    throw new RangeError(("There must be 7 days for " + (this.language) + " language"))
  }
  this._days = days;
};

Object.defineProperties( Language.prototype, prototypeAccessors );

var en$1 = new Language(
  'English',
  ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
)
// eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,
  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear (date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear()
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth (date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth()
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate (date) {
    return this.useUtc ? date.getUTCDate() : date.getDate()
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay (date) {
    return this.useUtc ? date.getUTCDay() : date.getDay()
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours (date) {
    return this.useUtc ? date.getUTCHours() : date.getHours()
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes (date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes()
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear (date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value)
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth (date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value)
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate (date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value)
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates (date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }
    return d1.getTime() === d2.getTime()
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate (date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false
    }
    return !isNaN(date.getTime())
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr (date, days) {
    if (typeof date !== 'object') {
      throw TypeError('Invalid Type')
    }
    return days[this.getDay(date)]
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName (month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array')
    }
    if (typeof month === 'object') {
      return months[this.getMonth(month)]
    }
    if (typeof month === 'number') {
      return months[month]
    }
    throw TypeError('Invalid type')
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr (month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array')
    }
    if (typeof month === 'object') {
      return monthsAbbr[this.getMonth(month)]
    }
    if (typeof month === 'number') {
      return monthsAbbr[month]
    }
    throw TypeError('Invalid type')
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth (year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? (!(year % 4) && year % 100) || !(year % 400) ? 29 : 28 : 31
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix (day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st'
      case 2:
      case 22:
        return 'nd'
      case 3:
      case 23:
        return 'rd'
      default:
        return 'th'
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate (date, format, translation) {
    translation = (!translation) ? en$1 : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format
      .replace(/dd/, ('0' + day).slice(-2))
      .replace(/d/, day)
      .replace(/yyyy/, year)
      .replace(/yy/, String(year).slice(2))
      .replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months))
      .replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr))
      .replace(/MM/, ('0' + month).slice(-2))
      .replace(/M(?!a|ä|e)/, month)
      .replace(/su/, this.getNthSuffix(this.getDate(date)))
      .replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray (start, end) {
    var this$1 = this;

    var dates = [];
    while (start <= end) {
      dates.push(new Date(start));
      start = this$1.setDate(new Date(start), this$1.getDate(new Date(start)) + 1);
    }
    return dates
  }
};

var makeDateUtils = function (useUtc) { return (Object.assign({}, utils, {useUtc: useUtc})); };

Object.assign({}, utils)
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var DateInput = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'input-group' : _vm.bootstrapStyling}},[(_vm.calendarButton)?_c('span',{staticClass:"vdp-datepicker__calendar-button",class:{'input-group-prepend' : _vm.bootstrapStyling},style:({'cursor:not-allowed;' : _vm.disabled}),on:{"click":_vm.showCalendar}},[_c('span',{class:{'input-group-text' : _vm.bootstrapStyling}},[_c('i',{class:_vm.calendarButtonIcon},[_vm._v(" "+_vm._s(_vm.calendarButtonIconContent)+" "),(!_vm.calendarButtonIcon)?_c('span',[_vm._v("…")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('input',{ref:_vm.refName,class:_vm.computedInputClass,attrs:{"type":_vm.inline ? 'hidden' : 'text',"name":_vm.name,"id":_vm.id,"open-date":_vm.openDate,"placeholder":_vm.placeholder,"clear-button":_vm.clearButton,"disabled":_vm.disabled,"required":_vm.required,"readonly":!_vm.typeable,"autocomplete":"off"},domProps:{"value":_vm.formattedValue},on:{"click":_vm.showCalendar,"keyup":_vm.parseTypedDate,"blur":_vm.inputBlurred}}),_vm._v(" "),(_vm.clearButton && _vm.selectedDate)?_c('span',{staticClass:"vdp-datepicker__clear-button",class:{'input-group-append' : _vm.bootstrapStyling},on:{"click":function($event){_vm.clearDate();}}},[_c('span',{class:{'input-group-text' : _vm.bootstrapStyling}},[_c('i',{class:_vm.clearButtonIcon},[(!_vm.clearButtonIcon)?_c('span',[_vm._v("×")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_vm._t("afterDateInput")],2)},staticRenderFns: [],
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    }
  },
  computed: {
    formattedValue: function formattedValue () {
      if (!this.selectedDate) {
        return null
      }
      if (this.typedDate) {
        return this.typedDate
      }
      return typeof this.format === 'function'
        ? this.format(this.selectedDate)
        : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation)
    },

    computedInputClass: function computedInputClass () {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ')
        }
        return Object.assign({}, {'form-control': true}, this.inputClass)
      }
      return this.inputClass
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate () {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar () {
      this.$emit('showCalendar');
    },
    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate (event) {
      // close calendar if escape or enter are pressed
      if ([
        27, // escape
        13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = Date.parse(this.input.value);
        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(this.typedDate));
        }
      }
    },
    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred () {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },
    /**
     * emit a clearDate event
     */
    clearDate: function clearDate () {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted () {
    this.input = this.$el.querySelector('input');
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerDay = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDayView),expression:"showDayView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();}}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"day__month_btn",class:_vm.allowedToShowView('month') ? 'up' : '',on:{"click":_vm.showMonthCalendar}},[_vm._v(_vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName)+" "+_vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();}}},[_vm._v(">")])]),_vm._v(" "),_c('div',{class:_vm.isRtl ? 'flex-rtl' : ''},[_vm._l((_vm.daysOfWeek),function(d){return _c('span',{key:d.timestamp,staticClass:"cell day-header"},[_vm._v(_vm._s(d))])}),_vm._v(" "),(_vm.blankDays > 0)?_vm._l((_vm.blankDays),function(d){return _c('span',{key:d.timestamp,staticClass:"cell day blank"})}):_vm._e(),_vm._l((_vm.days),function(day){return _c('span',{key:day.timestamp,staticClass:"cell day",class:_vm.dayClasses(day),domProps:{"innerHTML":_vm._s(_vm.dayCellContent(day))},on:{"click":function($event){_vm.selectDate(day);}}})})],2)],2)},staticRenderFns: [],
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      default: function (day) { return day.date; }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek () {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays
      }
      return this.translation.days
    },
    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays () {
      var d = this.pageDate;
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1))
        : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6
      }
      return this.utils.getDay(dObj)
    },
    /**
     * @return {Object[]}
     */
    days: function days () {
      var this$1 = this;

      var d = this.pageDate;
      var days = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1))
        : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));
      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this$1.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedDate(dObj),
          isDisabled: this$1.isDisabledDate(dObj),
          isHighlighted: this$1.isHighlightedDate(dObj),
          isHighlightStart: this$1.isHighlightStart(dObj),
          isHighlightEnd: this$1.isHighlightEnd(dObj),
          isToday: this$1.utils.compareDates(dObj, new Date()),
          isWeekend: this$1.utils.getDay(dObj) === 0 || this$1.utils.getDay(dObj) === 6,
          isSaturday: this$1.utils.getDay(dObj) === 6,
          isSunday: this$1.utils.getDay(dObj) === 0
        });
        this$1.utils.setDate(dObj, this$1.utils.getDate(dObj) + 1);
      }
      return days
    },
    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName () {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName)
    },
    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName () {
      var yearSuffix = this.translation.yearSuffix;
      return ("" + (this.utils.getFullYear(this.pageDate)) + yearSuffix)
    },
    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd () {
      return this.translation.ymd && this.translation.ymd === true
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextMonthDisabled(this.pageTimestamp)
        : this.isPreviousMonthDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousMonthDisabled(this.pageTimestamp)
        : this.isNextMonthDisabled(this.pageTimestamp)
    }
  },
  methods: {
    selectDate: function selectDate (date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false
      }
      this.$emit('selectDate', date);
    },
    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth () {
      return this.utils.getMonth(this.pageDate)
    },
    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar () {
      this.$emit('showMonthCalendar');
    },
    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth (incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },
    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth () {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },
    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) &&
        this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d)
    },
    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth () {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },
    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) &&
        this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d)
    },
    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate (dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj)
    },
    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate (date) {
      var this$1 = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            disabledDates = true;
            return true
          }
        });
      }
      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true
            }
          }
        });
      }
      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates
    },
    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate (date) {
      var this$1 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            highlighted = true;
            return true
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted
    },
    dayClasses: function dayClasses (day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      }
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart (date) {
      return this.isHighlightedDate(date) &&
        (this.highlighted.from instanceof Date) &&
        (this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date)) &&
        (this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date)) &&
        (this.utils.getDate(this.highlighted.from) === this.utils.getDate(date))
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd (date) {
      return this.isHighlightedDate(date) &&
        (this.highlighted.to instanceof Date) &&
        (this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date)) &&
        (this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date)) &&
        (this.utils.getDate(this.highlighted.to) === this.utils.getDate(date))
    },
    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined (prop) {
      return typeof prop !== 'undefined' && prop
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerMonth = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMonthView),expression:"showMonthView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextYear() : _vm.previousYear();}}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"month__year_btn",class:_vm.allowedToShowView('year') ? 'up' : '',on:{"click":_vm.showYearCalendar}},[_vm._v(_vm._s(_vm.pageYearName))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousYear() : _vm.nextYear();}}},[_vm._v(">")])]),_vm._v(" "),_vm._l((_vm.months),function(month){return _c('span',{key:month.timestamp,staticClass:"cell month",class:{'selected': month.isSelected, 'disabled': month.isDisabled},on:{"click":function($event){$event.stopPropagation();_vm.selectMonth(month);}}},[_vm._v(_vm._s(month.month))])})],2)},staticRenderFns: [],
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  computed: {
    months: function months () {
      var this$1 = this;

      var d = this.pageDate;
      var months = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate()))
        : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 12; i++) {
        months.push({
          month: this$1.utils.getMonthName(i, this$1.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedMonth(dObj),
          isDisabled: this$1.isDisabledMonth(dObj)
        });
        this$1.utils.setMonth(dObj, this$1.utils.getMonth(dObj) + 1);
      }
      return months
    },
    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName () {
      var yearSuffix = this.translation.yearSuffix;
      return ("" + (this.utils.getFullYear(this.pageDate)) + yearSuffix)
    },
    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextYearDisabled(this.pageTimestamp)
        : this.isPreviousYearDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousYearDisabled(this.pageTimestamp)
        : this.isNextYearDisabled(this.pageTimestamp)
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth (month) {
      if (month.isDisabled) {
        return false
      }
      this.$emit('selectMonth', month);
    },
    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear (incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },
    /**
     * Decrements the year
     */
    previousYear: function previousYear () {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },
    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate)
    },
    /**
     * Increments the year
     */
    nextYear: function nextYear () {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },
    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate)
    },
    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar () {
      this.$emit('showYearCalendar');
    },
    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth (date) {
      return (this.selectedDate &&
        this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) &&
        this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date))
    },
    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth (date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (
          (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to)) ||
          this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)
        ) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (
          (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from)) ||
          this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)
        ) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerYear = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showYearView),expression:"showYearView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();}}},[_vm._v("<")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getPageDecade))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();}}},[_vm._v(">")])]),_vm._v(" "),_vm._l((_vm.years),function(year){return _c('span',{key:year.timestamp,staticClass:"cell year",class:{ 'selected': year.isSelected, 'disabled': year.isDisabled },on:{"click":function($event){$event.stopPropagation();_vm.selectYear(year);}}},[_vm._v(_vm._s(year.year))])})],2)},staticRenderFns: [],
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years () {
      var this$1 = this;

      var d = this.pageDate;
      var years = [];
      // set up a new date object to the beginning of the current 'page'7
      var dObj = this.useUtc
        ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate()))
        : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 10; i++) {
        years.push({
          year: this$1.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedYear(dObj),
          isDisabled: this$1.isDisabledYear(dObj)
        });
        this$1.utils.setFullYear(dObj, this$1.utils.getFullYear(dObj) + 1);
      }
      return years
    },
    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade () {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return (decadeStart + " - " + decadeEnd + yearSuffix)
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextDecadeDisabled(this.pageTimestamp)
        : this.isPreviousDecadeDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousDecadeDisabled(this.pageTimestamp)
        : this.isNextDecadeDisabled(this.pageTimestamp)
    }
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  methods: {
    selectYear: function selectYear (year) {
      if (year.isDisabled) {
        return false
      }
      this.$emit('selectYear', year);
    },
    changeYear: function changeYear (incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade () {
      if (this.isPreviousDecadeDisabled()) {
        return false
      }
      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      return Math.floor(this.utils.getFullYear(this.disabledDates.to) / 10) * 10 >= Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10
    },
    nextDecade: function nextDecade () {
      if (this.isNextDecadeDisabled()) {
        return false
      }
      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      return Math.ceil(this.utils.getFullYear(this.disabledDates.from) / 10) * 10 <= Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear (date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date)
    },
    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear (date) {
      var disabledDates = false;
      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=".rtl { direction: rtl; } .vdp-datepicker { position: relative; text-align: left; } .vdp-datepicker * { box-sizing: border-box; } .vdp-datepicker__calendar { position: absolute; z-index: 100; background: #fff; width: 300px; border: 1px solid #ccc; } .vdp-datepicker__calendar header { display: block; line-height: 40px; } .vdp-datepicker__calendar header span { display: inline-block; text-align: center; width: 71.42857142857143%; float: left; } .vdp-datepicker__calendar header .prev, .vdp-datepicker__calendar header .next { width: 14.285714285714286%; float: left; text-indent: -10000px; position: relative; } .vdp-datepicker__calendar header .prev:after, .vdp-datepicker__calendar header .next:after { content: ''; position: absolute; left: 50%; top: 50%; -webkit-transform: translateX(-50%) translateY(-50%); transform: translateX(-50%) translateY(-50%); border: 6px solid transparent; } .vdp-datepicker__calendar header .prev:after { border-right: 10px solid #000; margin-left: -5px; } .vdp-datepicker__calendar header .prev.disabled:after { border-right: 10px solid #ddd; } .vdp-datepicker__calendar header .next:after { border-left: 10px solid #000; margin-left: 5px; } .vdp-datepicker__calendar header .next.disabled:after { border-left: 10px solid #ddd; } .vdp-datepicker__calendar header .prev:not(.disabled), .vdp-datepicker__calendar header .next:not(.disabled), .vdp-datepicker__calendar header .up:not(.disabled) { cursor: pointer; } .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover { background: #eee; } .vdp-datepicker__calendar .disabled { color: #ddd; cursor: default; } .vdp-datepicker__calendar .flex-rtl { display: flex; width: inherit; flex-wrap: wrap; } .vdp-datepicker__calendar .cell { display: inline-block; padding: 0 5px; width: 14.285714285714286%; height: 40px; line-height: 40px; text-align: center; vertical-align: middle; border: 1px solid transparent; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year { cursor: pointer; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover { border: 1px solid #4bd; } .vdp-datepicker__calendar .cell.selected { background: #4bd; } .vdp-datepicker__calendar .cell.selected:hover { background: #4bd; } .vdp-datepicker__calendar .cell.selected.highlighted { background: #4bd; } .vdp-datepicker__calendar .cell.highlighted { background: #cae5ed; } .vdp-datepicker__calendar .cell.highlighted.disabled { color: #a3a3a3; } .vdp-datepicker__calendar .cell.grey { color: #888; } .vdp-datepicker__calendar .cell.grey:hover { background: inherit; } .vdp-datepicker__calendar .cell.day-header { font-size: 75%; white-space: nowrap; cursor: inherit; } .vdp-datepicker__calendar .cell.day-header:hover { background: inherit; } .vdp-datepicker__calendar .month, .vdp-datepicker__calendar .year { width: 33.333%; } .vdp-datepicker__clear-button, .vdp-datepicker__calendar-button { cursor: pointer; font-style: normal; } .vdp-datepicker__clear-button.disabled, .vdp-datepicker__calendar-button.disabled { color: #999; cursor: default; } "; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var Datepicker = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vdp-datepicker",class:[_vm.wrapperClass, _vm.isRtl ? 'rtl' : '']},[_c('date-input',{attrs:{"selectedDate":_vm.selectedDate,"resetTypedDate":_vm.resetTypedDate,"format":_vm.format,"translation":_vm.translation,"inline":_vm.inline,"id":_vm.id,"name":_vm.name,"refName":_vm.refName,"openDate":_vm.openDate,"placeholder":_vm.placeholder,"inputClass":_vm.inputClass,"typeable":_vm.typeable,"clearButton":_vm.clearButton,"clearButtonIcon":_vm.clearButtonIcon,"calendarButton":_vm.calendarButton,"calendarButtonIcon":_vm.calendarButtonIcon,"calendarButtonIconContent":_vm.calendarButtonIconContent,"disabled":_vm.disabled,"required":_vm.required,"bootstrapStyling":_vm.bootstrapStyling,"use-utc":_vm.useUtc},on:{"showCalendar":_vm.showCalendar,"closeCalendar":_vm.close,"typedDate":_vm.setTypedDate,"clearDate":_vm.clearDate}},[_vm._t("afterDateInput",null,{slot:"afterDateInput"})],2),_vm._v(" "),(_vm.allowedToShowView('day'))?_c('picker-day',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showDayView":_vm.showDayView,"fullMonthName":_vm.fullMonthName,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"highlighted":_vm.highlighted,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"pageTimestamp":_vm.pageTimestamp,"isRtl":_vm.isRtl,"mondayFirst":_vm.mondayFirst,"dayCellContent":_vm.dayCellContent,"use-utc":_vm.useUtc},on:{"changedMonth":_vm.handleChangedMonthFromDayPicker,"selectDate":_vm.selectDate,"showMonthCalendar":_vm.showMonthCalendar,"selectedDisabled":_vm.selectDisabledDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e(),_vm._v(" "),(_vm.allowedToShowView('month'))?_c('picker-month',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showMonthView":_vm.showMonthView,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"isRtl":_vm.isRtl,"use-utc":_vm.useUtc},on:{"selectMonth":_vm.selectMonth,"showYearCalendar":_vm.showYearCalendar,"changedYear":_vm.setPageDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e(),_vm._v(" "),(_vm.allowedToShowView('year'))?_c('picker-year',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showYearView":_vm.showYearView,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"isRtl":_vm.isRtl,"use-utc":_vm.useUtc},on:{"selectYear":_vm.selectYear,"changedDecade":_vm.setPageDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e()],1)},staticRenderFns: [],
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function (val) {
        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number'
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      default: 'dd MMM yyyy'
    },
    language: {
      type: Object,
      default: function () { return en$1; }
    },
    openDate: {
      validator: function (val) {
        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number'
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      default: 'day'
    },
    maximumView: {
      type: String,
      default: 'year'
    }
  },
  data: function data () {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,
      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,
      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,
      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    }
  },
  watch: {
    value: function value (value$1) {
      this.setValue(value$1);
    },
    openDate: function openDate () {
      this.setPageDate();
    },
    initialView: function initialView () {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView () {
      if (!this.initialView) {
        return this.minimumView
      }

      return this.initialView
    },
    pageDate: function pageDate () {
      return new Date(this.pageTimestamp)
    },

    translation: function translation () {
      return this.language
    },

    calendarStyle: function calendarStyle () {
      return {
        position: this.isInline ? 'static' : undefined
      }
    },
    isOpen: function isOpen () {
      return this.showDayView || this.showMonthView || this.showYearView
    },
    isInline: function isInline () {
      return !!this.inline
    },
    isRtl: function isRtl () {
      return this.translation.rtl === true
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate () {
      if (this.selectedDate === null) {
        this.setPageDate();
        return
      }
      this.setPageDate(this.selectedDate);
    },
    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar () {
      if (this.disabled || this.isInline) {
        return false
      }
      if (this.isOpen) {
        return this.close(true)
      }
      this.setInitialView();
      if (!this.isInline) {
        this.$emit('opened');
      }
    },
    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView () {
      var initialView = this.computedInitialView;
      if (!this.allowedToShowView(initialView)) {
        throw new Error(("initialView '" + (this.initialView) + "' cannot be rendered based on minimum '" + (this.minimumView) + "' and maximum '" + (this.maximumView) + "'"))
      }
      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break
        case 'month':
          this.showMonthCalendar();
          break
        default:
          this.showDayCalendar();
          break
      }
    },
    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView (view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);

      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex
    },
    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar () {
      if (!this.allowedToShowView('day')) {
        return false
      }
      this.close();
      this.showDayView = true;
      return true
    },
    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar () {
      if (!this.allowedToShowView('month')) {
        return false
      }
      this.close();
      this.showMonthView = true;
      return true
    },
    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar () {
      if (!this.allowedToShowView('year')) {
        return false
      }
      this.close();
      this.showYearView = true;
      return true
    },
    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate (timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },
    /**
     * Clear the selected date
     */
    clearDate: function clearDate () {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },
    /**
     * @param {Object} date
     */
    selectDate: function selectDate (date) {
      this.setDate(date.timestamp);
      if (!this.isInline) {
        this.close(true);
      }
      this.resetTypedDate = new Date();
    },
    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate (date) {
      this.$emit('selectedDisabled', date);
    },
    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth (month) {
      var date = new Date(month.timestamp);
      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },
    /**
     * @param {Object} year
     */
    selectYear: function selectYear (year) {
      var date = new Date(year.timestamp);
      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },
    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue (date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }
      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return
      }
      this.selectedDate = date;
      this.setPageDate(date);
    },
    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate (date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }
      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },
    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker (date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },
    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate (date) {
      this.setDate(date.getTime());
    },
    /**
     * Close all calendar layers
     * @param {Boolean} full - emit close event
     */
    close: function close (full) {
      this.showDayView = this.showMonthView = this.showYearView = false;
      if (!this.isInline) {
        if (full) {
          this.$emit('closed');
        }
        document.removeEventListener('click', this.clickOutside, false);
      }
    },
    /**
     * Initiate the component
     */
    init: function init () {
      if (this.value) {
        this.setValue(this.value);
      }
      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted () {
    this.init();
  }
}
// eslint-disable-next-line
;

var vClickOutside_umd = createCommonjsModule(function (module, exports) {
!function(e,n){module.exports=n();}(commonjsGlobal,function(){var e="__v-click-outside",n="undefined"!=typeof window,t="undefined"!=typeof navigator,i=n&&("ontouchstart"in window||t&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function o(n,t){var o=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return {handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||i,isActive:!(!1===e.isActive)}}(t.value),r=o.handler,d=o.middleware;o.isActive&&(n[e]=o.events.map(function(e){return {event:e,handler:function(e){return function(e){var n=e.el,t=e.event,i=e.handler,o=e.middleware,r=t.path||t.composedPath&&t.composedPath(),d=r?r.indexOf(n)<0:!n.contains(t.target);t.target!==n&&d&&o(t)&&i(t);}({event:e,el:n,handler:r,middleware:d})}}}),n[e].forEach(function(t){var i=t.event,o=t.handler;return setTimeout(function(){n[e]&&document.documentElement.addEventListener(i,o,!1);},0)}));}function r(n){(n[e]||[]).forEach(function(e){return document.documentElement.removeEventListener(e.event,e.handler,!1)}),delete n[e];}var d=n?{bind:o,update:function(e,n){var t=n.value,i=n.oldValue;JSON.stringify(t)!==JSON.stringify(i)&&(r(e),o(e,{value:t}));},unbind:r}:{};return {install:function(e){e.directive("click-outside",d);},directive:d}});

});

// Solution for https://github.com/vuejs/vue/issues/9200

/* eslint-disable consistent-return */
var doubleRequestAnimationFrame = function doubleRequestAnimationFrame(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(callback);
  });
};

var forceNextTick = function forceNextTick(callback) {
  if (callback && typeof callback === 'function') {
    doubleRequestAnimationFrame(callback);
  } else {
    return new Promise(function (resolve) {
      doubleRequestAnimationFrame(resolve);
    });
  }
};
/* eslint-enable consistent-return */


var VueForceNextTick = {
  /**
   * Expose $forceNextTick to be used.
   *
   * @param {object} Vue
   */
  install: function install(Vue) {
    /* eslint-disable no-param-reassign */
    Vue.$forceNextTick = forceNextTick;
    Vue.prototype.$forceNextTick = forceNextTick;
    /* eslint-enable no-param-reassign */
  }
};

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

// https://github.com/tc39/Array.prototype.includes

var $includes = _arrayIncludes(true);

_export(_export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_addToUnscopables('includes');

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var INCLUDES = 'includes';

_export(_export.P + _export.F * _failsIsRegexp(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~_stringContext(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * "TfTabs" is a wrapper component of el-tabs that will, time permitting,
 * be replaced with our own component that is prop/emit compatible with
 * the Element one. https://element.eleme.io/#/en-US/component/dialog#dialog
 *
 * @vuedoc
 * @exports TfTabs
 * @category components
 */
var script = {
  name: 'TfTabs',
  inheritAttrs: false,
  props: {
    /**
     * Currently only used by the `file` type, locked: true makes the
     * unselected tabs look disabled. Switching has to be disabled in
     * the implementation by reacting to @tab-click events.
     */
    locked: {
      type: Boolean,
      default: false
    },

    /**
     * The type of tab design that we're rendering.
     * Currently supporting `large` (default), `small`, `text`, and `file`
     */
    type: {
      type: String,
      default: 'large',
      validator: function validator(value) {
        return ['large', 'small', 'text', 'file'].includes(value);
      }
    }
  },
  computed: {
    /**
     * Apply an class based on the `type` prop. The default tab type, large, require no class.
     *
     * @returns {string}
     */
    tabClass: function tabClass() {
      var classes = this.locked ? ['locked'] : [];

      if (!['', 'large'].includes(this.type)) {
        classes.push("".concat(this.type, "-tabs"));
      }

      return classes;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "el-tabs",
    _vm._g(
      _vm._b(
        { class: _vm.tabClass },
        "el-tabs",
        Object.assign({}, _vm.$attrs, _vm.$props, { type: _vm.type }),
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var f$1 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$1
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$2 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$2
};

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

var setPrototypeOf = _setProto.set;
var _inheritIfRequired = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$3
};

var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var space = '[' + _stringWs + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = _fails(function () {
    return !!_stringWs[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  _export(_export.P + _export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(_defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

var _stringTrim = exporter;

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var gOPN = _objectGopn.f;
var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var $trim = _stringTrim.trim;
var NUMBER = 'Number';
var $Number = _global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = _cof(_objectCreate(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = _toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? _fails(function () { proto.valueOf.call(that); }) : _cof(that) != NUMBER)
        ? _inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = _descriptors ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (_has(Base, key = keys[j]) && !_has($Number, key)) {
      dP$1($Number, key, gOPD$1(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  _redefine(_global, NUMBER, $Number);
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The callout component is essentially a comment box that is to be attached to a plan design value.
 * Currently, callouts should only be made for values that are deviated from the in-force value.
 *
 * @vuedoc
 * @exports components/CpCallout
 * @category Components
 */
var script$1 = {
  name: 'CpCallout',
  props: {
    charLimit: {
      type: Number,
      default: 256
    },
    note: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localNote: null
    };
  },
  computed: {
    /**
     * Compute the remaining characters to be used for validation and template text.
     *
     * @returns {number} charLimit value
     */
    charsLeft: function charsLeft() {
      return this.charLimit - this.inputModel.length;
    },

    /**
     * Format the character count to be used within the template.
     *
     * @returns {string} formatted string
     */
    charsCountText: function charsCountText() {
      var count = Math.abs(this.charsLeft);
      var text = "".concat(count, " character");

      if (count !== 1) {
        text += 's';
      }

      if (this.limitExceeded) {
        text += ' over limit';
      }

      return text;
    },

    /**
     * Validate the input model against the note param for logic and style purposes.
     *
     * @returns {boolean} chars under charLimit
     */
    hasChanges: function hasChanges() {
      return this.inputModel && this.inputModel !== this.note;
    },

    /**
     * Character count validation used for logic and style purposes.
     *
     * @returns {boolean}
     */
    limitExceeded: function limitExceeded() {
      return this.charsLeft < 0;
    },
    inputModel: {
      /**
       * use localNote if exists otherwise grab from prop
       *
       * @returns {string}
       */
      get: function get() {
        return this.localNote === null ? this.note : this.localNote;
      },

      /**
       * set localNote data prop to new value
       *
       * @param {string} newValue
       */
      set: function set(newValue) {
        this.localNote = newValue;
      }
    }
  },
  watch: {
    /**
     * whenever visible becomes true, auto focus to the input text area.
     *
     * @param {boolean} isVisible
     */
    visible: function visible(isVisible) {
      var _this = this;

      if (isVisible && !this.readonly) {
        this.$nextTick(function () {
          setTimeout(function () {
            // we have to grab the textarea ref in order to do the next line
            var textarea = _this.$refs.calloutInput.$refs.textarea; // the next two lines ensure the text cursor starts at the end of the text value

            textarea.selectionEnd = textarea.value.length;
            textarea.selectionStart = textarea.selectionEnd;
            textarea.focus();
          }, 100);
        });
      }
    }
  },
  methods: {
    /**
     * click x closes call out and clears text
     */
    closeCallOut: function closeCallOut() {
      this.localNote = null;
      this.$emit('update:visible', false);
    },

    /**
     * clears local text in popover
     */
    clearLocalNote: function clearLocalNote() {
      this.localNote = null;
    },

    /**
     * Deletes a comment
     */
    removeCallOut: function removeCallOut() {
      this.localNote = null;
      this.$emit('removeCallout');
    },

    /**
     * Saves or Edits a Callout Note
     *
     */
    saveCallOut: function saveCallOut() {
      if (this.hasChanges && !this.limitExceeded) {
        if (this.note) {
          this.$emit('editCallout', this.localNote);
        } else {
          this.$emit('addCallout', this.localNote);
        }
      }
    }
  }
};

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-tooltip",
    {
      attrs: {
        "force-show": _vm.visible,
        "show-close": _vm.visible,
        options: { placement: "top-start" },
        "append-to-body": false,
        trigger: "clickToOpen"
      },
      on: { documentClick: _vm.closeCallOut, hide: _vm.closeCallOut }
    },
    [
      _c("template", { slot: "reference" }, [_vm._t("reference")], 2),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("header", [_c("h5", [_vm._v("Benefit call-out")])]),
          _vm._v(" "),
          _vm.readonly
            ? _c("p", { domProps: { textContent: _vm._s(_vm.note) } })
            : [
                _c("tf-input", {
                  ref: "calloutInput",
                  class: { error: _vm.limitExceeded },
                  attrs: { type: "textarea", rows: "6" },
                  model: {
                    value: _vm.inputModel,
                    callback: function($$v) {
                      _vm.inputModel = $$v;
                    },
                    expression: "inputModel"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "footer" }, [
                  _c(
                    "div",
                    {
                      staticClass: "small-text",
                      attrs: { "data-test-word-count": "" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "word-count",
                          class: { error: _vm.limitExceeded }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.charsCountText) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-group" },
                    [
                      _vm.note
                        ? _c("tf-button", {
                            attrs: {
                              "data-test-delete-button": "",
                              icon: "trash",
                              size: "text",
                              type: "decline"
                            },
                            on: { click: _vm.removeCallOut }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("tf-button", {
                        attrs: {
                          "data-test-save-button": "",
                          icon: "check",
                          size: "text",
                          disabled: _vm.limitExceeded || !_vm.hasChanges,
                          type: _vm.limitExceeded ? "decline" : "affirm"
                        },
                        on: { click: _vm.saveCallOut }
                      })
                    ],
                    1
                  )
                ])
              ]
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-99cd23da_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nsection[data-v-99cd23da] {\n  width: 273px;\n  text-align: left;\n  color: #999;\n}\nheader[data-v-99cd23da] {\n  margin-bottom: 10px;\n}\n.error.word-count[data-v-99cd23da] {\n  color: #f92f37;\n}\n.error[data-v-99cd23da]  .el-textarea__inner {\n  border-color: #f92f37;\n}\np[data-v-99cd23da] {\n  color: #000;\n}\n.footer[data-v-99cd23da] {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n/*# sourceMappingURL=CpCallout.vue.map */", map: {"version":3,"sources":["CpCallout.vue","/home/circleci/repo/src/components/CpCallout.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACyNpC;EACA,YAAA;EACA,gBAAA;EACA,WAAA;ADvNA;AC0NA;EACA,mBAAA;ADvNA;AC2NA;EACA,cAAA;ADxNA;AC2NA;EACA,qBAAA;ADzNA;AC6NA;EACA,WAAA;AD1NA;AC6NA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AD1NA;;AAEA,wCAAwC","file":"CpCallout.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nsection {\n  width: 273px;\n  text-align: left;\n  color: #999;\n}\n\nheader {\n  margin-bottom: 10px;\n}\n\n.error.word-count {\n  color: #f92f37;\n}\n.error ::v-deep .el-textarea__inner {\n  border-color: #f92f37;\n}\n\np {\n  color: #000;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n/*# sourceMappingURL=CpCallout.vue.map */","<template>\n  <tf-tooltip\n    :force-show=\"visible\"\n    :show-close=\"visible\"\n    :options=\"{ placement: 'top-start' }\"\n    :append-to-body=\"false\"\n    trigger=\"clickToOpen\"\n    @documentClick=\"closeCallOut\"\n    @hide=\"closeCallOut\"\n  >\n    <template slot=\"reference\">\n      <slot name=\"reference\" />\n    </template>\n    <section>\n      <header>\n        <h5>Benefit call-out</h5>\n      </header>\n      <p\n        v-if=\"readonly\"\n        v-text=\"note\"\n      />\n      <template v-else>\n        <tf-input\n          ref=\"calloutInput\"\n          v-model=\"inputModel\"\n          :class=\"{ error: limitExceeded }\"\n          type=\"textarea\"\n          rows=\"6\"\n        />\n        <div class=\"footer\">\n          <div\n            class=\"small-text\"\n            data-test-word-count\n          >\n            <div\n              class=\"word-count\"\n              :class=\"{ error: limitExceeded }\"\n            >\n              {{ charsCountText }}\n            </div>\n          </div>\n          <div class=\"btn-group\">\n            <tf-button\n              v-if=\"note\"\n              data-test-delete-button\n              icon=\"trash\"\n              size=\"text\"\n              type=\"decline\"\n              @click=\"removeCallOut\"\n            />\n            <tf-button\n              data-test-save-button\n              icon=\"check\"\n              size=\"text\"\n              :disabled=\"limitExceeded || !hasChanges\"\n              :type=\"limitExceeded ? 'decline' : 'affirm'\"\n              @click=\"saveCallOut\"\n            />\n          </div>\n        </div>\n      </template>\n    </section>\n  </tf-tooltip>\n</template>\n\n<script>\n  /**\n   * The callout component is essentially a comment box that is to be attached to a plan design value.\n   * Currently, callouts should only be made for values that are deviated from the in-force value.\n   *\n   * @vuedoc\n   * @exports components/CpCallout\n   * @category Components\n   */\n  export default {\n    name: 'CpCallout',\n    props: {\n      charLimit: {\n        type: Number,\n        default: 256,\n      },\n      note: {\n        type: String,\n        default: '',\n      },\n      readonly: {\n        type: Boolean,\n        default: false,\n      },\n      visible: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => ({\n      localNote: null,\n    }),\n    computed: {\n      /**\n       * Compute the remaining characters to be used for validation and template text.\n       *\n       * @returns {number} charLimit value\n       */\n      charsLeft() {\n        return this.charLimit - this.inputModel.length;\n      },\n      /**\n       * Format the character count to be used within the template.\n       *\n       * @returns {string} formatted string\n       */\n      charsCountText() {\n        const count = Math.abs(this.charsLeft);\n        let text = `${count} character`;\n\n        if (count !== 1) {\n          text += 's';\n        }\n\n        if (this.limitExceeded) {\n          text += ' over limit';\n        }\n\n        return text;\n      },\n      /**\n       * Validate the input model against the note param for logic and style purposes.\n       *\n       * @returns {boolean} chars under charLimit\n       */\n      hasChanges() {\n        return this.inputModel && this.inputModel !== this.note;\n      },\n      /**\n       * Character count validation used for logic and style purposes.\n       *\n       * @returns {boolean}\n       */\n      limitExceeded() {\n        return this.charsLeft < 0;\n      },\n      inputModel: {\n        /**\n         * use localNote if exists otherwise grab from prop\n         *\n         * @returns {string}\n         */\n        get() {\n          return this.localNote === null ? this.note : this.localNote;\n        },\n        /**\n         * set localNote data prop to new value\n         *\n         * @param {string} newValue\n         */\n        set(newValue) {\n          this.localNote = newValue;\n        },\n      },\n    },\n    watch: {\n      /**\n       * whenever visible becomes true, auto focus to the input text area.\n       *\n       * @param {boolean} isVisible\n       */\n      visible(isVisible) {\n        if (isVisible && !this.readonly) {\n          this.$nextTick(() => {\n            setTimeout(() => {\n              // we have to grab the textarea ref in order to do the next line\n              const { textarea } = this.$refs.calloutInput.$refs;\n              // the next two lines ensure the text cursor starts at the end of the text value\n              textarea.selectionEnd = textarea.value.length;\n              textarea.selectionStart = textarea.selectionEnd;\n              textarea.focus();\n            }, 100);\n          });\n        }\n      },\n    },\n    methods: {\n      /**\n       * click x closes call out and clears text\n       */\n      closeCallOut() {\n        this.localNote = null;\n        this.$emit('update:visible', false);\n      },\n      /**\n       * clears local text in popover\n       */\n      clearLocalNote() {\n        this.localNote = null;\n      },\n      /**\n       * Deletes a comment\n       */\n      removeCallOut() {\n        this.localNote = null;\n        this.$emit('removeCallout');\n      },\n      /**\n       * Saves or Edits a Callout Note\n       *\n       */\n      saveCallOut() {\n        if (this.hasChanges && !this.limitExceeded) {\n          if (this.note) {\n            this.$emit('editCallout', this.localNote);\n          } else {\n            this.$emit('addCallout', this.localNote);\n          }\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  section {\n    width: 273px;\n    text-align: left;\n    color: $tf-medium-gray;\n  }\n\n  header {\n    margin-bottom: 10px;\n  }\n\n  .error {\n    &.word-count {\n      color: $tf-red;\n    }\n\n    & ::v-deep .el-textarea__inner {\n      border-color: $tf-red;\n    }\n  }\n\n  p {\n    color: $tf-black;\n  }\n\n  .footer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 10px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = "data-v-99cd23da";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: 'AppConfirmEmail',
  props: {
    confirmEmailLink: {
      type: String,
      default: ''
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { staticClass: "auth-form" },
    [
      _c("auth-page-header", { attrs: { title: "Confirm Email Address" } }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Click below to confirm your email address and activate your ThreeFlow account."
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-group" },
        [
          _c("tf-button", {
            attrs: { type: "primary" },
            domProps: { textContent: _vm._s("Confirm email") }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("auth-page-footer")
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-52f85d5d_0", { source: ".btn-group[data-v-52f85d5d] {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppConfirmEmail.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/AppConfirmEmail.vue","AppConfirmEmail.vue"],"names":[],"mappings":"AA2BA;EACA,uBAAA;AC1BA;;AAEA,8CAA8C","file":"AppConfirmEmail.vue","sourcesContent":["<template>\n  <section class=\"auth-form\">\n    <auth-page-header title=\"Confirm Email Address\" />\n    <p>Click below to confirm your email address and activate your ThreeFlow account.</p>\n    <div class=\"btn-group\">\n      <tf-button\n        type=\"primary\"\n        v-text=\"'Confirm email'\"\n      />\n    </div>\n    <auth-page-footer />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppConfirmEmail',\n    props: {\n      confirmEmailLink: {\n        type: String,\n        default: '',\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .btn-group {\n    justify-content: center;\n  }\n</style>\n",".btn-group {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppConfirmEmail.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = "data-v-52f85d5d";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$3 = {
  name: 'AppForgotPasswordForm',
  props: {
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    checkInvited: {
      type: Boolean,
      default: false
    },
    documentId: {
      type: String,
      default: null
    },
    linkLogin: {
      type: [String, Object],
      required: true
    },
    projectId: {
      type: [String, Number],
      default: null
    },
    userInfo: {
      type: Object,
      required: true
    }
  },
  data: function data(vm) {
    return {
      btnDisable: false,
      forgotPasswordForm: {
        email: ''
      },
      notInvited: false,
      rules: {
        email: [{
          required: true,
          type: 'email',
          message: 'Please enter your company email.',
          trigger: 'blur'
        }, {
          validator: vm.validateEmail,
          trigger: 'none'
        }, {
          validator: vm.clearError,
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    /**
     * Watching the email field - and updating the vuex store with the new email
     *
     * @param {string} email
     */
    'forgotPasswordForm.email': function forgotPasswordFormEmail(email) {
      this.$emit('setUserEmail', email);
      this.notInvited = false;
    }
  },
  created: function created() {
    // We want the email address to persist across all login/forgotPW/registration forms
    this.forgotPasswordForm.email = this.userInfo.email;
  },
  methods: {
    /* eslint-disable-next-line jsdoc/require-param */

    /**
     * Clear out any displayed errors
     */
    clearError: function clearError(rule, value, callback) {
      callback();
    },

    /* eslint-disable-next-line jsdoc/require-param */

    /**
     * Method to validate the email address and see if this user was invited to the project
     */
    validateEmail: function validateEmail(rule, value, callback) {
      var _this = this;

      if (!this.forgotPasswordForm.email || !this.checkInvited) {
        callback();
        return;
      }

      this.accountService.checkInvitedToProject(this.forgotPasswordForm.email, this.projectId).then(function () {
        callback();
      }).catch(function (error) {
        _this.notInvited = true;
        _this.btnDisable = false;
        var errorMessage = error.response && error.response.status === 404 ? 'Sorry, this email doesn\'t exist in our system. Ensure you\'re using the company email you registered with, or contact support@threeflow.com.' : 'This email is not invited. Ensure you’re using your company email and that it has been invited, or contact support@threeflow.com.';
        callback(new Error(errorMessage));
      });
    },

    /**
     * On form submission we should validate and call the service to update the password (if valid).
     */
    submitForgotPassword: function submitForgotPassword() {
      var _this2 = this;

      this.btnDisable = true;
      this.$refs.forgotPasswordForm.validate(function (valid) {
        if (valid) {
          var data = {
            email: _this2.forgotPasswordForm.email,
            projectId: _this2.projectId
          }; // Attach documentId if present

          if (_this2.documentId) {
            data.documentId = _this2.documentId;
          }

          _this2.accountService.passwordReset(data).then(function () {
            /* We should set a flag to show the success message on
            the login screen and then redirect to the login form */
            _this2.$emit('setTempPasswordStatus', true);

            var redirectURL = _this2.$route.query.redirect || _this2.linkLogin;
            _this2.btnDisable = false;

            _this2.$router.push(redirectURL);
          });
        }

        _this2.btnDisable = false;
        return valid;
      });
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-form",
    {
      ref: "forgotPasswordForm",
      staticClass: "auth-form forgot-password",
      attrs: {
        model: _vm.forgotPasswordForm,
        rules: _vm.rules,
        "label-position": "top"
      },
      nativeOn: {
        submit: function($event) {
          $event.preventDefault();
          return _vm.submitForgotPassword($event)
        }
      }
    },
    [
      _c("auth-page-header", { attrs: { title: "Forgot Password" } }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Enter your email address below to be sent a temporary password."
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inputs-container" },
        [
          _c(
            "tf-form-item",
            {
              staticClass: "email-container",
              class: { "not-invited-error": _vm.notInvited },
              attrs: {
                for: "email-input",
                prop: "email",
                label: "Company email",
                size: "medium"
              }
            },
            [
              _c("tf-input", {
                attrs: { name: "email-input", placeholder: "Enter email" },
                model: {
                  value: _vm.forgotPasswordForm.email,
                  callback: function($$v) {
                    _vm.$set(_vm.forgotPasswordForm, "email", $$v);
                  },
                  expression: "forgotPasswordForm.email"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _c("tf-button", {
                attrs: {
                  disabled: !_vm.forgotPasswordForm.email || _vm.btnDisable,
                  name: "submit-button",
                  type: "primary",
                  "native-type": "submit"
                },
                domProps: { textContent: _vm._s("Email temporary password") }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "links-container" },
            [
              _c(
                "router-link",
                { attrs: { tag: "li", to: _vm.linkLogin } },
                [
                  _c("tf-button", {
                    attrs: { type: "primary", size: "text" },
                    domProps: { textContent: _vm._s("Sign in") }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("auth-page-footer")
    ],
    1
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-22ae80a8_0", { source: ".btn-group[data-v-22ae80a8] {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppForgotPasswordForm.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/AppForgotPasswordForm.vue","AppForgotPasswordForm.vue"],"names":[],"mappings":"AAgMA;EACA,uBAAA;AC/LA;;AAEA,oDAAoD","file":"AppForgotPasswordForm.vue","sourcesContent":["<template>\n  <tf-form\n    ref=\"forgotPasswordForm\"\n    :model=\"forgotPasswordForm\"\n    :rules=\"rules\"\n    label-position=\"top\"\n    class=\"auth-form forgot-password\"\n    @submit.native.prevent=\"submitForgotPassword\"\n  >\n    <auth-page-header title=\"Forgot Password\" />\n    <p>Enter your email address below to be sent a temporary password.</p>\n    <div class=\"inputs-container\">\n      <tf-form-item\n        :class=\"{'not-invited-error' : notInvited }\"\n        for=\"email-input\"\n        prop=\"email\"\n        class=\"email-container\"\n        label=\"Company email\"\n        size=\"medium\"\n      >\n        <tf-input\n          v-model=\"forgotPasswordForm.email\"\n          name=\"email-input\"\n          placeholder=\"Enter email\"\n        />\n      </tf-form-item>\n      <div class=\"btn-group\">\n        <tf-button\n          :disabled=\"!forgotPasswordForm.email || btnDisable\"\n          name=\"submit-button\"\n          type=\"primary\"\n          native-type=\"submit\"\n          v-text=\"'Email temporary password'\"\n        />\n      </div>\n      <ul class=\"links-container\">\n        <router-link\n          tag=\"li\"\n          :to=\"linkLogin\"\n        >\n          <tf-button\n            type=\"primary\"\n            size=\"text\"\n            v-text=\"'Sign in'\"\n          />\n        </router-link>\n      </ul>\n    </div>\n    <auth-page-footer />\n  </tf-form>\n</template>\n\n<script>\n  export default {\n    name: 'AppForgotPasswordForm',\n    props: {\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n      checkInvited: {\n        type: Boolean,\n        default: false,\n      },\n      documentId: {\n        type: String,\n        default: null,\n      },\n      linkLogin: {\n        type: [String, Object],\n        required: true,\n      },\n      projectId: {\n        type: [String, Number],\n        default: null,\n      },\n      userInfo: {\n        type: Object,\n        required: true,\n      },\n    },\n    data: (vm) => ({\n      btnDisable: false,\n      forgotPasswordForm: {\n        email: '',\n      },\n      notInvited: false,\n      rules: {\n        email: [\n          {\n            required: true,\n            type: 'email',\n            message: 'Please enter your company email.',\n            trigger: 'blur',\n          },\n          {\n            validator: vm.validateEmail,\n            trigger: 'none',\n          },\n          {\n            validator: vm.clearError,\n            trigger: 'change',\n          },\n        ],\n      },\n    }),\n    watch: {\n      /**\n       * Watching the email field - and updating the vuex store with the new email\n       *\n       * @param {string} email\n       */\n      'forgotPasswordForm.email': function (email) {\n        this.$emit('setUserEmail', email);\n        this.notInvited = false;\n      },\n    },\n    created() {\n      // We want the email address to persist across all login/forgotPW/registration forms\n      this.forgotPasswordForm.email = this.userInfo.email;\n    },\n    methods: {\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Clear out any displayed errors\n       */\n      clearError(rule, value, callback) {\n        callback();\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Method to validate the email address and see if this user was invited to the project\n       */\n      validateEmail(rule, value, callback) {\n        if (!this.forgotPasswordForm.email || !this.checkInvited) {\n          callback();\n\n          return;\n        }\n\n        this.accountService\n          .checkInvitedToProject(this.forgotPasswordForm.email, this.projectId)\n          .then(() => {\n            callback();\n          })\n          .catch((error) => {\n            this.notInvited = true;\n            this.btnDisable = false;\n            const errorMessage = error.response && error.response.status === 404\n              ? 'Sorry, this email doesn\\'t exist in our system. Ensure you\\'re using the company email you registered with, or contact support@threeflow.com.'\n              : 'This email is not invited. Ensure you’re using your company email and that it has been invited, or contact support@threeflow.com.';\n            callback(new Error(errorMessage));\n          });\n      },\n\n      /**\n       * On form submission we should validate and call the service to update the password (if valid).\n       */\n      submitForgotPassword() {\n        this.btnDisable = true;\n        this.$refs.forgotPasswordForm.validate((valid) => {\n          if (valid) {\n            const data = {\n              email: this.forgotPasswordForm.email,\n              projectId: this.projectId,\n            };\n\n            // Attach documentId if present\n            if (this.documentId) {\n              data.documentId = this.documentId;\n            }\n\n            this.accountService.passwordReset(data).then(() => {\n              /* We should set a flag to show the success message on\n             the login screen and then redirect to the login form */\n              this.$emit('setTempPasswordStatus', true);\n              const redirectURL = this.$route.query.redirect || this.linkLogin;\n              this.btnDisable = false;\n              this.$router.push(redirectURL);\n            });\n          }\n          this.btnDisable = false;\n\n          return valid;\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .btn-group {\n    justify-content: center;\n  }\n</style>\n",".btn-group {\n  justify-content: center;\n}\n\n/*# sourceMappingURL=AppForgotPasswordForm.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = "data-v-22ae80a8";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$4 = {
  name: 'AppLanding'
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("section", { staticClass: "auth-form" }, [
    _c("div", { staticClass: "small-tf-logo" }, [
      _vm._v("\n    WatchTower Technologies\n  ")
    ]),
    _vm._v(" "),
    _c("h2", [_vm._t("title")], 2),
    _vm._v(" "),
    _c("p", [_vm._t("description")], 2),
    _vm._v(" "),
    _c("a", {
      attrs: { href: "mailto:support@watchtowerbenefits.com" },
      domProps: { textContent: _vm._s("support@watchtowerbenefits.com") }
    })
  ])
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-6c398e41_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\na[data-v-6c398e41] {\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=AppLanding.vue.map */", map: {"version":3,"sources":["AppLanding.vue","/home/circleci/repo/src/components/AuthPages/AppLanding.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACkBpC;EACA,eAAA;ADhBA;;AAEA,yCAAyC","file":"AppLanding.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\na {\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=AppLanding.vue.map */","<template>\n  <section class=\"auth-form\">\n    <div class=\"small-tf-logo\">\n      WatchTower Technologies\n    </div>\n    <h2><slot name=\"title\" /></h2>\n    <p><slot name=\"description\" /></p>\n    <a\n      href=\"mailto:support@watchtowerbenefits.com\"\n      v-text=\"'support@watchtowerbenefits.com'\"\n    />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppLanding',\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/mixins';\n\n  a {\n    font-size: 14px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = "data-v-6c398e41";
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    browser,
    undefined,
    undefined
  );

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var at = _stringAt(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var _advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var _regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (_classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

// 21.2.5.3 get RegExp.prototype.flags

var _flags = function () {
  var that = _anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', _flags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var _regexpExec = patchedExec;

_export({
  target: 'RegExp',
  proto: true,
  forced: _regexpExec !== /./.exec
}, {
  exec: _regexpExec
});

var SPECIES = _wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

var _fixReWks = function (KEY, length, exec) {
  var SYMBOL = _wks(KEY);

  var DELEGATES_TO_SYMBOL = !_fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !_fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      _defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === _regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    _redefine(String.prototype, KEY, strfn);
    _hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

var max$1 = Math.max;
var min$2 = Math.min;
var floor$1 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
_fixReWks('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = _regexpExecAbstract(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max$1(min$2(_toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = _toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$5 = {
  name: 'AppLogin',
  props: {
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    auth: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    checkInvited: {
      type: Boolean,
      default: false
    },
    linkForgot: {
      type: [String, Object],
      default: ''
    },
    linkRedirect: {
      type: [String, Object],
      required: true
    },
    linkRegister: {
      type: [String, Object],
      default: ''
    },
    linkTerms: {
      type: [String, Object],
      default: ''
    },
    projectId: {
      type: [String, Number],
      default: null
    },
    tempPasswordSent: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data(vm) {
    return {
      autofilledPassword: false,
      formErrorMessage: null,
      inactivityMessage: null,
      loginForm: {
        email: '',
        password: '',
        rememberMe: false,
        showPassword: false
      },
      notInvited: false,
      passwordMessage: null,
      rules: {
        email: [{
          required: true,
          type: 'email',
          message: 'Please enter your company email.',
          trigger: 'blur'
        }, {
          validator: vm.clearError,
          trigger: 'change'
        }, {
          validator: vm.validateEmail,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: 'Please input your password.',
          trigger: 'none'
        }]
      }
    };
  },
  computed: {
    /**
     * If the user has provided both their email and password
     *
     * @returns {boolean}
     */
    validFields: function validFields() {
      return Boolean(this.loginForm.email && this.loginForm.password);
    }
  },
  watch: {
    /**
     * Watching the email field - emit with the new email
     *
     * @param {string} email
     */
    'loginForm.email': function loginFormEmail(email) {
      this.$emit('setUserEmail', email);
      this.notInvited = false;
    },

    /**
     * Watching to see if we need show the inactivity message
     *
     * @param {boolean} inactivity
     */
    'auth.inactive': function authInactive(inactivity) {
      if (inactivity) {
        this.showInactivityMessage();
      }
    }
  },
  created: function created() {
    var _this$$route$query = this.$route.query,
        email = _this$$route$query.email,
        pw = _this$$route$query.pw;

    if (email && pw) {
      this.loginForm.email = email;
      this.loginForm.password = pw;
      this.loginForm.showPassword = true;
      return;
    } // We want the email address to persist across all login/forgotPW/registration forms


    this.loginForm.email = this.userInfo.email;
    var savedEmail = window.localStorage.getItem('email');

    if (savedEmail) {
      this.loginForm.rememberMe = true;
    } // if we don't have an email already check if we "remembered one"


    if (!this.loginForm.email && savedEmail) {
      this.loginForm.email = savedEmail;
    }
  },

  /**
   * When the component is displayed in the DOM,
   * check if a password was just reset.
   * If the password was reset,
   * show a success message and emit setTempPasswordStatus so it's not shown again.
   */
  mounted: function mounted() {
    if (this.tempPasswordSent) {
      this.$emit('setTempPasswordStatus', false);
      var h = this.$createElement;
      this.passwordMessage = this.$message({
        showClose: true,
        message: h('p', {
          attrs: {
            class: 'paragraph-message'
          }
        }, [h('span', null, 'If an account exists with the email you entered, you will receive a temporary password. '), h('span', null, 'If you don\'t have an existing account or didn\'t receive the email, please contact '), h('a', {
          attrs: {
            class: 'resend-email-link',
            href: 'mailto:support@threeflow.com'
          }
        }, 'support@threeflow.com'), h('span', null, '.')]),
        customClass: 'large success forgot-pw-message',
        type: 'success',
        duration: 0
      });
    }

    if (this.auth.inactive) {
      this.showInactivityMessage();
    }
  },

  /**
   * Remove the event listeners we manually added in the mounted method.
   */
  beforeDestroy: function beforeDestroy() {
    if (this.passwordMessage) {
      this.passwordMessage.close();
    }

    if (this.formErrorMessage) {
      this.formErrorMessage.close();
    }

    if (this.inactivityMessage) {
      this.inactivityMessage.close();
    }
  },
  methods: {
    /**
     * there is a chrome bug that doesn't fire a change event when a field is auto filled
     * we can however check the animation change from being auto filled
     * however we still can't access the value of the password field
     * but since we know it was autofilled lets just enable the button
     *
     * @param {event} e
     */
    checkAnimation: function checkAnimation(e) {
      if (e.animationName === 'onAutoFillStart') {
        this.autofilledPassword = true;
      }
    },

    /* eslint-disable-next-line jsdoc/require-param */

    /**
     * Clear out any displayed errors
     */
    clearError: function clearError(rule, value, callback) {
      callback();
    },

    /* eslint-disable-next-line jsdoc/require-param */

    /**
     * Method to validate the email address and see if this user was invited to the project
     */
    validateEmail: function validateEmail(rule, value, callback) {
      var _this = this;

      if (!this.loginForm.email || !this.checkInvited) {
        callback();
        return;
      }

      this.accountService.checkInvitedToProject(this.loginForm.email, this.projectId).then(function () {
        callback();
      }).catch(function () {
        _this.notInvited = true;
        callback(new Error('This email is not invited. Ensure you’re using your company email and that it has been invited. Or contact support@threeflow.com.'));
      });
    },

    /**
     * Validate and call the accountService/authenticate method.
     */
    submitLogin: function submitLogin() {
      var _this2 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this2.accountService.authenticate({
            email: _this2.loginForm.email,
            password: _this2.loginForm.password,
            project_id: _this2.projectId
          }, _this2.loginForm.rememberMe).then(function () {
            var redirectURL = _this2.$route.query.redirect || _this2.linkRedirect;

            _this2.$router.replace(redirectURL);
          }).catch(function (error) {
            if (_this2.formErrorMessage) {
              _this2.formErrorMessage.close();
            }

            _this2.formErrorMessage = _this2.$message({
              showClose: true,
              message: error.response.data.message,
              customClass: 'error',
              type: 'error',
              duration: 0
            });
          });
        }

        return valid;
      });
    },

    /**
     * If the user was logged out due to inactivity we show a message at the top of the screen explaining why they were logged out
     */
    showInactivityMessage: function showInactivityMessage() {
      var h = this.$createElement;
      var message = h('p', {
        attrs: {
          class: 'paragraph-message'
        }
      }, [h('span', null, 'You have been signed out due to inactivity,'), h('br', null, null), h('span', null, 'or because you\'ve signed in on another device.'), h('br', null, null), h('span', null, 'All your changes are safe and sound.')]);
      this.inactivityMessage = this.$message({
        showClose: true,
        message: message,
        customClass: 'large warning',
        type: 'warning',
        duration: 0
      });
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-form",
    {
      ref: "loginForm",
      staticClass: "auth-form login",
      attrs: {
        model: _vm.loginForm,
        rules: _vm.rules,
        name: "auth-form",
        "label-position": "top"
      },
      nativeOn: {
        submit: function($event) {
          $event.preventDefault();
          return _vm.submitLogin($event)
        }
      }
    },
    [
      _c("auth-page-header", { attrs: { title: "Sign In to ThreeFlow" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inputs-container" },
        [
          _c(
            "tf-form-item",
            {
              staticClass: "email-container",
              class: { "not-invited-error": _vm.notInvited },
              attrs: {
                for: "app-login-email",
                prop: "email",
                label: "Company email",
                size: "medium"
              }
            },
            [
              _c("tf-input", {
                attrs: {
                  id: "app-login-email",
                  "data-test-input": "login email",
                  name: "email-input",
                  placeholder: "Enter email"
                },
                nativeOn: {
                  keydown: function($event) {
                    _vm.autofilledPassword = false;
                  }
                },
                model: {
                  value: _vm.loginForm.email,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "email", $$v);
                  },
                  expression: "loginForm.email"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "tf-form-item",
            {
              staticClass: "password-container",
              attrs: {
                for: "app-login-password",
                prop: "password",
                label: "Password",
                size: "medium"
              }
            },
            [
              _c("tf-input", {
                attrs: {
                  id: "app-login-password",
                  "data-test-input": "login password",
                  type: _vm.loginForm.showPassword ? "text" : "password",
                  name: "password-input",
                  placeholder: "Enter password"
                },
                nativeOn: {
                  animationstart: function($event) {
                    return _vm.checkAnimation($event)
                  },
                  keydown: function($event) {
                    _vm.autofilledPassword = false;
                  }
                },
                model: {
                  value: _vm.loginForm.password,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "password", $$v);
                  },
                  expression: "loginForm.password"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkbox-container" },
            [
              _c("tf-checkbox", {
                staticClass: "show-password-container",
                attrs: { name: "show-password", label: "Show password" },
                model: {
                  value: _vm.loginForm.showPassword,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "showPassword", $$v);
                  },
                  expression: "loginForm.showPassword"
                }
              }),
              _vm._v(" "),
              _c("tf-checkbox", {
                attrs: { name: "remember-user", label: "Remember me" },
                model: {
                  value: _vm.loginForm.rememberMe,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "rememberMe", $$v);
                  },
                  expression: "loginForm.rememberMe"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "auth-row" },
            [
              _vm.linkTerms
                ? _c(
                    "span",
                    { staticClass: "terms-container" },
                    [
                      _vm._v("\n        By signing in, you agree to\n        "),
                      _c("router-link", {
                        attrs: { to: _vm.linkTerms, target: "_blank" },
                        domProps: { textContent: _vm._s("Terms of use") }
                      }),
                      _vm._v(".\n      ")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("tf-button", {
                staticClass: "sign-in-btn",
                attrs: {
                  "data-test-button": "login",
                  disabled: !_vm.validFields && !_vm.autofilledPassword,
                  name: "submit-button",
                  type: "primary",
                  "native-type": "submit"
                },
                domProps: { textContent: _vm._s("Sign in") }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.linkForgot || _vm.linkRegister
            ? _c(
                "ul",
                {
                  class: [
                    {
                      "justify-content-spaced":
                        _vm.linkForgot && _vm.linkRegister
                    },
                    "links-container"
                  ]
                },
                [
                  _vm.linkForgot
                    ? _c(
                        "router-link",
                        { attrs: { tag: "li", to: _vm.linkForgot } },
                        [
                          _c("tf-button", {
                            attrs: {
                              id: "link-forgot-password",
                              type: "primary",
                              size: "text"
                            },
                            domProps: {
                              textContent: _vm._s("Forgot password?")
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.linkRegister
                    ? _c(
                        "router-link",
                        { attrs: { tag: "li", to: _vm.linkRegister } },
                        [
                          _c("tf-button", {
                            attrs: {
                              id: "link-register",
                              type: "primary",
                              size: "text"
                            },
                            domProps: {
                              textContent: _vm._s("Create an account")
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("auth-page-footer")
    ],
    1
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = function (inject) {
    if (!inject) return
    inject("data-v-d8f827ac_0", { source: ".auth-row[data-v-d8f827ac] {\n  display: flex;\n  margin: 33px 0 43px;\n  justify-content: space-between;\n}\n.checkbox-container[data-v-d8f827ac] {\n  display: flex;\n}\n.checkbox-container .el-checkbox + .el-checkbox[data-v-d8f827ac] {\n  margin-left: 30px;\n}\n.terms-container[data-v-d8f827ac] {\n  max-width: 183px;\n  line-height: 18px;\n}\n.tf-button.sign-in-btn[data-v-d8f827ac],\n.wt-button.sign-in-btn[data-v-d8f827ac] {\n  margin-left: auto;\n}\n.links-container[data-v-d8f827ac] {\n  justify-content: center;\n}\n.links-container.justify-content-spaced[data-v-d8f827ac] {\n  justify-content: space-between;\n}\n\n/*# sourceMappingURL=AppLogin.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/AppLogin.vue","AppLogin.vue"],"names":[],"mappings":"AAwZA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ACvZA;AD0ZA;EACA,aAAA;ACvZA;ADyZA;EACA,iBAAA;ACvZA;AD2ZA;EACA,gBAAA;EACA,iBAAA;ACxZA;AD2ZA;;EAEA,iBAAA;ACxZA;AD2ZA;EACA,uBAAA;ACxZA;AD2ZA;EACA,8BAAA;ACzZA;;AAEA,uCAAuC","file":"AppLogin.vue","sourcesContent":["<template>\n  <tf-form\n    ref=\"loginForm\"\n    :model=\"loginForm\"\n    :rules=\"rules\"\n    name=\"auth-form\"\n    label-position=\"top\"\n    class=\"auth-form login\"\n    @submit.native.prevent=\"submitLogin\"\n  >\n    <auth-page-header title=\"Sign In to ThreeFlow\" />\n    <div class=\"inputs-container\">\n      <tf-form-item\n        :class=\"{'not-invited-error' : notInvited }\"\n        for=\"app-login-email\"\n        prop=\"email\"\n        class=\"email-container\"\n        label=\"Company email\"\n        size=\"medium\"\n      >\n        <!-- Changing `autofilledPassword` for both inputs is required for disabling the button -->\n        <tf-input\n          id=\"app-login-email\"\n          v-model=\"loginForm.email\"\n          data-test-input=\"login email\"\n          name=\"email-input\"\n          placeholder=\"Enter email\"\n          @keydown.native=\"autofilledPassword = false\"\n        />\n      </tf-form-item>\n      <tf-form-item\n        for=\"app-login-password\"\n        prop=\"password\"\n        class=\"password-container\"\n        label=\"Password\"\n        size=\"medium\"\n      >\n        <tf-input\n          id=\"app-login-password\"\n          v-model=\"loginForm.password\"\n          data-test-input=\"login password\"\n          :type=\"loginForm.showPassword ? 'text' : 'password'\"\n          name=\"password-input\"\n          placeholder=\"Enter password\"\n          @animationstart.native=\"checkAnimation($event)\"\n          @keydown.native=\"autofilledPassword = false\"\n        />\n      </tf-form-item>\n      <!-- Checkbox row -->\n      <div class=\"checkbox-container\">\n        <tf-checkbox\n          v-model=\"loginForm.showPassword\"\n          class=\"show-password-container\"\n          name=\"show-password\"\n          label=\"Show password\"\n        />\n        <tf-checkbox\n          v-model=\"loginForm.rememberMe\"\n          name=\"remember-user\"\n          label=\"Remember me\"\n        />\n      </div>\n      <!-- Submit Btn -->\n      <div class=\"auth-row\">\n        <span\n          v-if=\"linkTerms\"\n          class=\"terms-container\"\n        >\n          By signing in, you agree to\n          <router-link\n            :to=\"linkTerms\"\n            target=\"_blank\"\n            v-text=\"'Terms of use'\"\n          />.\n        </span>\n        <tf-button\n          data-test-button=\"login\"\n          class=\"sign-in-btn\"\n          :disabled=\"!validFields && !autofilledPassword\"\n          name=\"submit-button\"\n          type=\"primary\"\n          native-type=\"submit\"\n          v-text=\"'Sign in'\"\n        />\n      </div>\n      <!-- Extra links -->\n      <ul\n        v-if=\"linkForgot || linkRegister\"\n        :class=\"[\n          { 'justify-content-spaced' : linkForgot && linkRegister },\n          'links-container'\n        ]\"\n      >\n        <router-link\n          v-if=\"linkForgot\"\n          tag=\"li\"\n          :to=\"linkForgot\"\n        >\n          <tf-button\n            id=\"link-forgot-password\"\n            type=\"primary\"\n            size=\"text\"\n            v-text=\"'Forgot password?'\"\n          />\n        </router-link>\n        <router-link\n          v-if=\"linkRegister\"\n          tag=\"li\"\n          :to=\"linkRegister\"\n        >\n          <tf-button\n            id=\"link-register\"\n            type=\"primary\"\n            size=\"text\"\n            v-text=\"'Create an account'\"\n          />\n        </router-link>\n      </ul>\n    </div>\n    <auth-page-footer />\n  </tf-form>\n</template>\n\n<script>\n  export default {\n    name: 'AppLogin',\n    props: {\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n      auth: {\n        type: Object,\n        default: () => ({}),\n      },\n      checkInvited: {\n        type: Boolean,\n        default: false,\n      },\n      linkForgot: {\n        type: [String, Object],\n        default: '',\n      },\n      linkRedirect: {\n        type: [String, Object],\n        required: true,\n      },\n      linkRegister: {\n        type: [String, Object],\n        default: '',\n      },\n      linkTerms: {\n        type: [String, Object],\n        default: '',\n      },\n      projectId: {\n        type: [String, Number],\n        default: null,\n      },\n      tempPasswordSent: {\n        type: Boolean,\n        default: false,\n      },\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    data: (vm) => ({\n      autofilledPassword: false,\n      formErrorMessage: null,\n      inactivityMessage: null,\n      loginForm: {\n        email: '',\n        password: '',\n        rememberMe: false,\n        showPassword: false,\n      },\n      notInvited: false,\n      passwordMessage: null,\n      rules: {\n        email: [\n          {\n            required: true,\n            type: 'email',\n            message: 'Please enter your company email.',\n            trigger: 'blur',\n          },\n          {\n            validator: vm.clearError,\n            trigger: 'change',\n          },\n          {\n            validator: vm.validateEmail,\n            trigger: 'blur',\n          },\n        ],\n        password: [\n          {\n            required: true,\n            message: 'Please input your password.',\n            trigger: 'none',\n          },\n        ],\n      },\n    }),\n    computed: {\n      /**\n       * If the user has provided both their email and password\n       *\n       * @returns {boolean}\n       */\n      validFields() {\n        return Boolean(this.loginForm.email && this.loginForm.password);\n      },\n    },\n    watch: {\n      /**\n       * Watching the email field - emit with the new email\n       *\n       * @param {string} email\n       */\n      'loginForm.email': function (email) {\n        this.$emit('setUserEmail', email);\n        this.notInvited = false;\n      },\n      /**\n       * Watching to see if we need show the inactivity message\n       *\n       * @param {boolean} inactivity\n       */\n      'auth.inactive': function (inactivity) {\n        if (inactivity) {\n          this.showInactivityMessage();\n        }\n      },\n    },\n    created() {\n      const { email, pw } = this.$route.query;\n\n      if (email && pw) {\n        this.loginForm.email = email;\n        this.loginForm.password = pw;\n        this.loginForm.showPassword = true;\n\n        return;\n      }\n\n      // We want the email address to persist across all login/forgotPW/registration forms\n      this.loginForm.email = this.userInfo.email;\n      const savedEmail = window.localStorage.getItem('email');\n\n      if (savedEmail) {\n        this.loginForm.rememberMe = true;\n      }\n      // if we don't have an email already check if we \"remembered one\"\n      if (!this.loginForm.email && savedEmail) {\n        this.loginForm.email = savedEmail;\n      }\n    },\n    /**\n     * When the component is displayed in the DOM,\n     * check if a password was just reset.\n     * If the password was reset,\n     * show a success message and emit setTempPasswordStatus so it's not shown again.\n     */\n    mounted() {\n      if (this.tempPasswordSent) {\n        this.$emit('setTempPasswordStatus', false);\n        const h = this.$createElement;\n        this.passwordMessage = this.$message({\n          showClose: true,\n          message: h('p', { attrs: { class: 'paragraph-message' } }, [\n            h('span', null, 'If an account exists with the email you entered, you will receive a temporary password. '),\n            h('span', null, 'If you don\\'t have an existing account or didn\\'t receive the email, please contact '),\n            h('a', { attrs: { class: 'resend-email-link', href: 'mailto:support@threeflow.com' } }, 'support@threeflow.com'),\n            h('span', null, '.'),\n          ]),\n          customClass: 'large success forgot-pw-message',\n          type: 'success',\n          duration: 0,\n        });\n      }\n      if (this.auth.inactive) {\n        this.showInactivityMessage();\n      }\n    },\n    /**\n     * Remove the event listeners we manually added in the mounted method.\n     */\n    beforeDestroy() {\n      if (this.passwordMessage) {\n        this.passwordMessage.close();\n      }\n      if (this.formErrorMessage) {\n        this.formErrorMessage.close();\n      }\n      if (this.inactivityMessage) {\n        this.inactivityMessage.close();\n      }\n    },\n    methods: {\n      /**\n       * there is a chrome bug that doesn't fire a change event when a field is auto filled\n       * we can however check the animation change from being auto filled\n       * however we still can't access the value of the password field\n       * but since we know it was autofilled lets just enable the button\n       *\n       * @param {event} e\n       */\n      checkAnimation(e) {\n        if (e.animationName === 'onAutoFillStart') {\n          this.autofilledPassword = true;\n        }\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Clear out any displayed errors\n       */\n      clearError(rule, value, callback) {\n        callback();\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Method to validate the email address and see if this user was invited to the project\n       */\n      validateEmail(rule, value, callback) {\n        if (!this.loginForm.email || !this.checkInvited) {\n          callback();\n          return;\n        }\n\n        this.accountService\n          .checkInvitedToProject(this.loginForm.email, this.projectId)\n          .then(() => {\n            callback();\n          })\n          .catch(() => {\n            this.notInvited = true;\n            callback(new Error('This email is not invited. Ensure you’re using your company email and that it has been invited. Or contact support@threeflow.com.'));\n          });\n      },\n\n      /**\n       * Validate and call the accountService/authenticate method.\n       */\n      submitLogin() {\n        this.$refs.loginForm.validate((valid) => {\n          if (valid) {\n            this.accountService\n              .authenticate(\n                {\n                  email: this.loginForm.email,\n                  password: this.loginForm.password,\n                  project_id: this.projectId,\n                },\n                this.loginForm.rememberMe,\n              )\n              .then(() => {\n                const redirectURL = this.$route.query.redirect || this.linkRedirect;\n\n                this.$router.replace(redirectURL);\n              })\n              .catch((error) => {\n                if (this.formErrorMessage) {\n                  this.formErrorMessage.close();\n                }\n\n                this.formErrorMessage = this.$message({\n                  showClose: true,\n                  message: error.response.data.message,\n                  customClass: 'error',\n                  type: 'error',\n                  duration: 0,\n                });\n              });\n          }\n\n          return valid;\n        });\n      },\n      /**\n       * If the user was logged out due to inactivity we show a message at the top of the screen explaining why they were logged out\n       */\n      showInactivityMessage() {\n        const h = this.$createElement;\n        const message = h('p', { attrs: { class: 'paragraph-message' } }, [\n          h('span', null, 'You have been signed out due to inactivity,'),\n          h('br', null, null),\n          h('span', null, 'or because you\\'ve signed in on another device.'),\n          h('br', null, null),\n          h('span', null, 'All your changes are safe and sound.'),\n        ]);\n        this.inactivityMessage = this.$message({\n          showClose: true,\n          message,\n          customClass: 'large warning',\n          type: 'warning',\n          duration: 0,\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .auth-row {\n    display: flex;\n    margin: 33px 0 43px;\n    justify-content: space-between;\n  }\n\n  .checkbox-container {\n    display: flex;\n\n    .el-checkbox + .el-checkbox {\n      margin-left: 30px;\n    }\n  }\n\n  .terms-container {\n    max-width: 183px;\n    line-height: 18px;\n  }\n\n  .tf-button.sign-in-btn,\n  .wt-button.sign-in-btn {\n    margin-left: auto;\n  }\n\n  .links-container {\n    justify-content: center;\n\n    // If there are 2 linked, space them evenly.\n    &.justify-content-spaced {\n      justify-content: space-between;\n    }\n  }\n</style>\n\n<style>\n  .forgot-pw-message {\n    max-width: 690px;\n  }\n\n  :-webkit-autofill {\n    animation-name: onAutoFillStart;\n  }\n\n  :not(:-webkit-autofill) {\n    animation-name: onAutoFillCancel;\n  }\n\n  /* stylelint-disable block-no-empty  */\n  @keyframes onAutoFillStart {\n  }\n  @keyframes onAutoFillCancel {\n  }\n  /* stylelint-enable block-no-empty  */\n</style>\n",".auth-row {\n  display: flex;\n  margin: 33px 0 43px;\n  justify-content: space-between;\n}\n\n.checkbox-container {\n  display: flex;\n}\n.checkbox-container .el-checkbox + .el-checkbox {\n  margin-left: 30px;\n}\n\n.terms-container {\n  max-width: 183px;\n  line-height: 18px;\n}\n\n.tf-button.sign-in-btn,\n.wt-button.sign-in-btn {\n  margin-left: auto;\n}\n\n.links-container {\n  justify-content: center;\n}\n.links-container.justify-content-spaced {\n  justify-content: space-between;\n}\n\n/*# sourceMappingURL=AppLogin.vue.map */"]}, media: undefined })
,inject("data-v-d8f827ac_1", { source: "\n.forgot-pw-message {\n  max-width: 690px;\n}\n:-webkit-autofill {\n  animation-name: onAutoFillStart;\n}\n:not(:-webkit-autofill) {\n  animation-name: onAutoFillCancel;\n}\n\n/* stylelint-disable block-no-empty  */\n@keyframes onAutoFillStart {\n}\n@keyframes onAutoFillCancel {\n}\n/* stylelint-enable block-no-empty  */\n", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/AppLogin.vue"],"names":[],"mappings":";AA2bA;EACA,gBAAA;AACA;AAEA;EACA,+BAAA;AACA;AAEA;EACA,gCAAA;AACA;;AAEA,sCAAA;AACA;AACA;AACA;AACA;AACA,qCAAA","file":"AppLogin.vue","sourcesContent":["<template>\n  <tf-form\n    ref=\"loginForm\"\n    :model=\"loginForm\"\n    :rules=\"rules\"\n    name=\"auth-form\"\n    label-position=\"top\"\n    class=\"auth-form login\"\n    @submit.native.prevent=\"submitLogin\"\n  >\n    <auth-page-header title=\"Sign In to ThreeFlow\" />\n    <div class=\"inputs-container\">\n      <tf-form-item\n        :class=\"{'not-invited-error' : notInvited }\"\n        for=\"app-login-email\"\n        prop=\"email\"\n        class=\"email-container\"\n        label=\"Company email\"\n        size=\"medium\"\n      >\n        <!-- Changing `autofilledPassword` for both inputs is required for disabling the button -->\n        <tf-input\n          id=\"app-login-email\"\n          v-model=\"loginForm.email\"\n          data-test-input=\"login email\"\n          name=\"email-input\"\n          placeholder=\"Enter email\"\n          @keydown.native=\"autofilledPassword = false\"\n        />\n      </tf-form-item>\n      <tf-form-item\n        for=\"app-login-password\"\n        prop=\"password\"\n        class=\"password-container\"\n        label=\"Password\"\n        size=\"medium\"\n      >\n        <tf-input\n          id=\"app-login-password\"\n          v-model=\"loginForm.password\"\n          data-test-input=\"login password\"\n          :type=\"loginForm.showPassword ? 'text' : 'password'\"\n          name=\"password-input\"\n          placeholder=\"Enter password\"\n          @animationstart.native=\"checkAnimation($event)\"\n          @keydown.native=\"autofilledPassword = false\"\n        />\n      </tf-form-item>\n      <!-- Checkbox row -->\n      <div class=\"checkbox-container\">\n        <tf-checkbox\n          v-model=\"loginForm.showPassword\"\n          class=\"show-password-container\"\n          name=\"show-password\"\n          label=\"Show password\"\n        />\n        <tf-checkbox\n          v-model=\"loginForm.rememberMe\"\n          name=\"remember-user\"\n          label=\"Remember me\"\n        />\n      </div>\n      <!-- Submit Btn -->\n      <div class=\"auth-row\">\n        <span\n          v-if=\"linkTerms\"\n          class=\"terms-container\"\n        >\n          By signing in, you agree to\n          <router-link\n            :to=\"linkTerms\"\n            target=\"_blank\"\n            v-text=\"'Terms of use'\"\n          />.\n        </span>\n        <tf-button\n          data-test-button=\"login\"\n          class=\"sign-in-btn\"\n          :disabled=\"!validFields && !autofilledPassword\"\n          name=\"submit-button\"\n          type=\"primary\"\n          native-type=\"submit\"\n          v-text=\"'Sign in'\"\n        />\n      </div>\n      <!-- Extra links -->\n      <ul\n        v-if=\"linkForgot || linkRegister\"\n        :class=\"[\n          { 'justify-content-spaced' : linkForgot && linkRegister },\n          'links-container'\n        ]\"\n      >\n        <router-link\n          v-if=\"linkForgot\"\n          tag=\"li\"\n          :to=\"linkForgot\"\n        >\n          <tf-button\n            id=\"link-forgot-password\"\n            type=\"primary\"\n            size=\"text\"\n            v-text=\"'Forgot password?'\"\n          />\n        </router-link>\n        <router-link\n          v-if=\"linkRegister\"\n          tag=\"li\"\n          :to=\"linkRegister\"\n        >\n          <tf-button\n            id=\"link-register\"\n            type=\"primary\"\n            size=\"text\"\n            v-text=\"'Create an account'\"\n          />\n        </router-link>\n      </ul>\n    </div>\n    <auth-page-footer />\n  </tf-form>\n</template>\n\n<script>\n  export default {\n    name: 'AppLogin',\n    props: {\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n      auth: {\n        type: Object,\n        default: () => ({}),\n      },\n      checkInvited: {\n        type: Boolean,\n        default: false,\n      },\n      linkForgot: {\n        type: [String, Object],\n        default: '',\n      },\n      linkRedirect: {\n        type: [String, Object],\n        required: true,\n      },\n      linkRegister: {\n        type: [String, Object],\n        default: '',\n      },\n      linkTerms: {\n        type: [String, Object],\n        default: '',\n      },\n      projectId: {\n        type: [String, Number],\n        default: null,\n      },\n      tempPasswordSent: {\n        type: Boolean,\n        default: false,\n      },\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    data: (vm) => ({\n      autofilledPassword: false,\n      formErrorMessage: null,\n      inactivityMessage: null,\n      loginForm: {\n        email: '',\n        password: '',\n        rememberMe: false,\n        showPassword: false,\n      },\n      notInvited: false,\n      passwordMessage: null,\n      rules: {\n        email: [\n          {\n            required: true,\n            type: 'email',\n            message: 'Please enter your company email.',\n            trigger: 'blur',\n          },\n          {\n            validator: vm.clearError,\n            trigger: 'change',\n          },\n          {\n            validator: vm.validateEmail,\n            trigger: 'blur',\n          },\n        ],\n        password: [\n          {\n            required: true,\n            message: 'Please input your password.',\n            trigger: 'none',\n          },\n        ],\n      },\n    }),\n    computed: {\n      /**\n       * If the user has provided both their email and password\n       *\n       * @returns {boolean}\n       */\n      validFields() {\n        return Boolean(this.loginForm.email && this.loginForm.password);\n      },\n    },\n    watch: {\n      /**\n       * Watching the email field - emit with the new email\n       *\n       * @param {string} email\n       */\n      'loginForm.email': function (email) {\n        this.$emit('setUserEmail', email);\n        this.notInvited = false;\n      },\n      /**\n       * Watching to see if we need show the inactivity message\n       *\n       * @param {boolean} inactivity\n       */\n      'auth.inactive': function (inactivity) {\n        if (inactivity) {\n          this.showInactivityMessage();\n        }\n      },\n    },\n    created() {\n      const { email, pw } = this.$route.query;\n\n      if (email && pw) {\n        this.loginForm.email = email;\n        this.loginForm.password = pw;\n        this.loginForm.showPassword = true;\n\n        return;\n      }\n\n      // We want the email address to persist across all login/forgotPW/registration forms\n      this.loginForm.email = this.userInfo.email;\n      const savedEmail = window.localStorage.getItem('email');\n\n      if (savedEmail) {\n        this.loginForm.rememberMe = true;\n      }\n      // if we don't have an email already check if we \"remembered one\"\n      if (!this.loginForm.email && savedEmail) {\n        this.loginForm.email = savedEmail;\n      }\n    },\n    /**\n     * When the component is displayed in the DOM,\n     * check if a password was just reset.\n     * If the password was reset,\n     * show a success message and emit setTempPasswordStatus so it's not shown again.\n     */\n    mounted() {\n      if (this.tempPasswordSent) {\n        this.$emit('setTempPasswordStatus', false);\n        const h = this.$createElement;\n        this.passwordMessage = this.$message({\n          showClose: true,\n          message: h('p', { attrs: { class: 'paragraph-message' } }, [\n            h('span', null, 'If an account exists with the email you entered, you will receive a temporary password. '),\n            h('span', null, 'If you don\\'t have an existing account or didn\\'t receive the email, please contact '),\n            h('a', { attrs: { class: 'resend-email-link', href: 'mailto:support@threeflow.com' } }, 'support@threeflow.com'),\n            h('span', null, '.'),\n          ]),\n          customClass: 'large success forgot-pw-message',\n          type: 'success',\n          duration: 0,\n        });\n      }\n      if (this.auth.inactive) {\n        this.showInactivityMessage();\n      }\n    },\n    /**\n     * Remove the event listeners we manually added in the mounted method.\n     */\n    beforeDestroy() {\n      if (this.passwordMessage) {\n        this.passwordMessage.close();\n      }\n      if (this.formErrorMessage) {\n        this.formErrorMessage.close();\n      }\n      if (this.inactivityMessage) {\n        this.inactivityMessage.close();\n      }\n    },\n    methods: {\n      /**\n       * there is a chrome bug that doesn't fire a change event when a field is auto filled\n       * we can however check the animation change from being auto filled\n       * however we still can't access the value of the password field\n       * but since we know it was autofilled lets just enable the button\n       *\n       * @param {event} e\n       */\n      checkAnimation(e) {\n        if (e.animationName === 'onAutoFillStart') {\n          this.autofilledPassword = true;\n        }\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Clear out any displayed errors\n       */\n      clearError(rule, value, callback) {\n        callback();\n      },\n\n      /* eslint-disable-next-line jsdoc/require-param */\n      /**\n       * Method to validate the email address and see if this user was invited to the project\n       */\n      validateEmail(rule, value, callback) {\n        if (!this.loginForm.email || !this.checkInvited) {\n          callback();\n          return;\n        }\n\n        this.accountService\n          .checkInvitedToProject(this.loginForm.email, this.projectId)\n          .then(() => {\n            callback();\n          })\n          .catch(() => {\n            this.notInvited = true;\n            callback(new Error('This email is not invited. Ensure you’re using your company email and that it has been invited. Or contact support@threeflow.com.'));\n          });\n      },\n\n      /**\n       * Validate and call the accountService/authenticate method.\n       */\n      submitLogin() {\n        this.$refs.loginForm.validate((valid) => {\n          if (valid) {\n            this.accountService\n              .authenticate(\n                {\n                  email: this.loginForm.email,\n                  password: this.loginForm.password,\n                  project_id: this.projectId,\n                },\n                this.loginForm.rememberMe,\n              )\n              .then(() => {\n                const redirectURL = this.$route.query.redirect || this.linkRedirect;\n\n                this.$router.replace(redirectURL);\n              })\n              .catch((error) => {\n                if (this.formErrorMessage) {\n                  this.formErrorMessage.close();\n                }\n\n                this.formErrorMessage = this.$message({\n                  showClose: true,\n                  message: error.response.data.message,\n                  customClass: 'error',\n                  type: 'error',\n                  duration: 0,\n                });\n              });\n          }\n\n          return valid;\n        });\n      },\n      /**\n       * If the user was logged out due to inactivity we show a message at the top of the screen explaining why they were logged out\n       */\n      showInactivityMessage() {\n        const h = this.$createElement;\n        const message = h('p', { attrs: { class: 'paragraph-message' } }, [\n          h('span', null, 'You have been signed out due to inactivity,'),\n          h('br', null, null),\n          h('span', null, 'or because you\\'ve signed in on another device.'),\n          h('br', null, null),\n          h('span', null, 'All your changes are safe and sound.'),\n        ]);\n        this.inactivityMessage = this.$message({\n          showClose: true,\n          message,\n          customClass: 'large warning',\n          type: 'warning',\n          duration: 0,\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .auth-row {\n    display: flex;\n    margin: 33px 0 43px;\n    justify-content: space-between;\n  }\n\n  .checkbox-container {\n    display: flex;\n\n    .el-checkbox + .el-checkbox {\n      margin-left: 30px;\n    }\n  }\n\n  .terms-container {\n    max-width: 183px;\n    line-height: 18px;\n  }\n\n  .tf-button.sign-in-btn,\n  .wt-button.sign-in-btn {\n    margin-left: auto;\n  }\n\n  .links-container {\n    justify-content: center;\n\n    // If there are 2 linked, space them evenly.\n    &.justify-content-spaced {\n      justify-content: space-between;\n    }\n  }\n</style>\n\n<style>\n  .forgot-pw-message {\n    max-width: 690px;\n  }\n\n  :-webkit-autofill {\n    animation-name: onAutoFillStart;\n  }\n\n  :not(:-webkit-autofill) {\n    animation-name: onAutoFillCancel;\n  }\n\n  /* stylelint-disable block-no-empty  */\n  @keyframes onAutoFillStart {\n  }\n  @keyframes onAutoFillCancel {\n  }\n  /* stylelint-enable block-no-empty  */\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$5 = "data-v-d8f827ac";
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$6 = {
  name: 'AppRegisterConfirmation',
  props: {
    linkLogin: {
      type: [String, Object],
      default: ''
    },
    linkResend: {
      type: [String, Object],
      default: ''
    },
    linkRegister: {
      type: [String, Object],
      default: ''
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    // We want the email address to persist across all login/forgotPW/registration forms
    if (!this.userInfo.email) {
      // If we don't know your email address then you obviously don't know your info and will redirect to the login screen)
      var redirectURL = this.$route.query.redirect || this.linkLogin;
      this.$router.replace(redirectURL);
    }
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { staticClass: "auth-form" },
    [
      _c("auth-page-header", { attrs: { title: "Almost Done!" } }),
      _vm._v(" "),
      _c("p", [
        _vm._v("Please check "),
        _c("strong", [_vm._v(_vm._s(_vm.userInfo.email))]),
        _vm._v(" to confirm your account.")
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "links-container" },
        [
          _c(
            "router-link",
            { attrs: { tag: "li", to: _vm.linkResend } },
            [
              _c("tf-button", {
                attrs: { id: "link-register", type: "primary", size: "text" },
                domProps: { textContent: _vm._s("Didn’t receive the email?") }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("auth-page-footer")
    ],
    1
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = function (inject) {
    if (!inject) return
    inject("data-v-b46c6840_0", { source: ".auth-form[data-v-b46c6840] {\n  max-width: 500px;\n}\n.links-container[data-v-b46c6840] {\n  justify-content: space-around;\n  margin-top: 60px;\n}\n\n/*# sourceMappingURL=AppRegisterConfirmation.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/AppRegisterConfirmation.vue","AppRegisterConfirmation.vue"],"names":[],"mappings":"AAuDA;EACA,gBAAA;ACtDA;ADyDA;EACA,6BAAA;EACA,gBAAA;ACtDA;;AAEA,sDAAsD","file":"AppRegisterConfirmation.vue","sourcesContent":["<template>\n  <section class=\"auth-form\">\n    <auth-page-header title=\"Almost Done!\" />\n    <p>Please check <strong>{{ userInfo.email }}</strong> to confirm your account.</p>\n    <ul class=\"links-container\">\n      <router-link\n        tag=\"li\"\n        :to=\"linkResend\"\n      >\n        <tf-button\n          id=\"link-register\"\n          type=\"primary\"\n          size=\"text\"\n          v-text=\"'Didn’t receive the email?'\"\n        />\n      </router-link>\n    </ul>\n    <auth-page-footer />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppRegisterConfirmation',\n    props: {\n      linkLogin: {\n        type: [String, Object],\n        default: '',\n      },\n      linkResend: {\n        type: [String, Object],\n        default: '',\n      },\n      linkRegister: {\n        type: [String, Object],\n        default: '',\n      },\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    created() {\n      // We want the email address to persist across all login/forgotPW/registration forms\n      if (!this.userInfo.email) {\n        // If we don't know your email address then you obviously don't know your info and will redirect to the login screen)\n        const redirectURL = this.$route.query.redirect || this.linkLogin;\n\n        this.$router.replace(redirectURL);\n      }\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .auth-form {\n    max-width: 500px;\n  }\n\n  .links-container {\n    justify-content: space-around;\n    margin-top: 60px;\n  }\n</style>\n",".auth-form {\n  max-width: 500px;\n}\n\n.links-container {\n  justify-content: space-around;\n  margin-top: 60px;\n}\n\n/*# sourceMappingURL=AppRegisterConfirmation.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$6 = "data-v-b46c6840";
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    browser,
    undefined,
    undefined
  );

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

var _iterators = {};

var def = _objectDp.f;

var TAG$1 = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG$1)) def(it, TAG$1, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if ( typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ( (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

_addToUnscopables('keys');
_addToUnscopables('values');
_addToUnscopables('entries');

var ITERATOR$1 = _wks('iterator');
var TO_STRING_TAG = _wks('toStringTag');
var ArrayValues = _iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = _global[NAME];
  var proto$1 = Collection && Collection.prototype;
  var key$1;
  if (proto$1) {
    if (!proto$1[ITERATOR$1]) _hide(proto$1, ITERATOR$1, ArrayValues);
    if (!proto$1[TO_STRING_TAG]) _hide(proto$1, TO_STRING_TAG, NAME);
    _iterators[NAME] = ArrayValues;
    if (explicit) for (key$1 in es6_array_iterator) if (!proto$1[key$1]) _redefine(proto$1, key$1, es6_array_iterator[key$1], true);
  }
}

var isEnum = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = _toIobject(it);
    var keys = _objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!_descriptors || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries

var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var SPECIES$1 = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var _strictMethod = function (method, arg) {
  return !!method && _fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

var $some = _arrayMethods(3);

_export(_export.P + _export.F * !_strictMethod([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$7 = {
  name: 'AppRegisterForm',
  props: {
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    checkInvited: {
      type: Boolean,
      default: false
    },
    documentId: {
      type: String,
      default: null
    },
    employerName: {
      type: String,
      default: ''
    },
    invitedCarriers: {
      type: Number,
      default: 0
    },
    linkForgot: {
      type: [String, Object],
      required: true
    },
    linkLogin: {
      type: [String, Object],
      required: true
    },
    linkRegisterConfirmation: {
      type: [String, Object],
      required: true
    },
    projectId: {
      type: [String, Number],
      default: null
    },
    showProjectInfo: {
      type: Boolean,
      default: true
    },
    submittedCarriers: {
      type: Number,
      default: 0
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data(vm) {
    return {
      customError: null,
      // 'emailTaken' || 'notValid' || 'generic'
      formErrorMessage: null,
      notInvited: false,
      registrationForm: {
        firstName: vm.userInfo.firstName,
        lastName: vm.userInfo.lastName,
        role: vm.userInfo.role,
        email: '',
        password: ''
      },
      rules: {
        firstName: [{
          required: true,
          message: 'Please enter your first name.',
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          message: 'Please enter your last name.',
          trigger: 'blur'
        }],
        role: [{
          required: true,
          message: 'Please enter your role.',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Please enter your company email.',
          trigger: 'blur'
        }, {
          validator: vm.clearError,
          trigger: 'change'
        }, {
          validator: vm.validateEmail,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: 'Please choose a password.',
          trigger: 'blur'
        }, {
          min: 6,
          message: 'Your password must be at least 6 characters.',
          trigger: 'blur'
        }]
      },
      showPassword: false
    };
  },
  computed: {
    /**
     * Evaluate the registration form values to determine if the Create button is disabled.
     *
     * @returns {boolean}
     */
    btnCreateDisabled: function btnCreateDisabled() {
      return Object.values(this.registrationForm).some(function (value) {
        return !value;
      });
    }
  },
  watch: {
    /**
     * Watching the email field - and updating the vuex store with the new email
     *
     * @param {string} email
     */
    'registrationForm.email': function registrationFormEmail(email) {
      this.$emit('setUserEmail', email);
      this.notInvited = false;

      if (this.customError) {
        this.customError = null;
      }
    }
  },
  created: function created() {
    // We want the email address to persist across all login/forgotPW/registration forms
    this.registrationForm.email = this.$route.query.email || this.userInfo.email;
  },

  /* When the component is destroyed we need to remove the event listener we manually added for the error message */
  beforeDestroy: function beforeDestroy() {
    if (this.formErrorMessage) {
      this.formErrorMessage.close();
    }
  },
  methods: {
    /* eslint-disable-next-line jsdoc/require-param */

    /**
     * Clear out any displayed errors
     */
    clearError: function clearError(rule, value, callback) {
      callback();
    },

    /* eslint-disable-next-line jsdoc/require-param */

    /**
     * Method to validate the email address and see if this user was invited to the project
     */
    validateEmail: function validateEmail(rule, value, callback) {
      var _this = this;

      if (!this.registrationForm.email || !this.checkInvited) {
        callback();
        return;
      }

      this.accountService.checkInvitedToProject(this.registrationForm.email, this.projectId).then(function () {
        callback();
      }).catch(function () {
        _this.notInvited = true;
        callback(new Error('This email is not invited. Ensure you’re using your company email and that it has been invited. Or contact support@threeflow.com.'));
      });
    },

    /**
     * Validate the registrationForm and call the accountService/registerUser method.
     */
    submitRegistration: function submitRegistration() {
      var _this2 = this;

      this.$refs.registrationForm.validate(function (valid) {
        if (valid) {
          var data = {
            firstName: _this2.registrationForm.firstName,
            lastName: _this2.registrationForm.lastName,
            department: _this2.registrationForm.role,
            email: _this2.registrationForm.email,
            password: _this2.registrationForm.password,
            projectId: _this2.projectId
          };

          if (_this2.documentId) {
            data.documentId = _this2.documentId;
          }

          _this2.accountService.registerUser(data).then(function () {
            _this2.$router.push(_this2.linkRegisterConfirmation);
          }).catch(function (_ref) {
            var response = _ref.response;
            var _response$data = response.data,
                code = _response$data.code,
                message = _response$data.message;
            var customError = 'generic'; // 'emailTaken' || 'notValid' || 'generic'

            if (code === 'INVALID_PARAMS') {
              if (message === 'Email has already been taken') {
                customError = 'emailTaken';
              } else if (message === 'Email is invalid') {
                customError = 'notValid';
              }
            }

            _this2.customError = customError;
          });
        }

        return valid;
      });
    }
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-form",
    {
      ref: "registrationForm",
      staticClass: "auth-form register",
      attrs: {
        model: _vm.registrationForm,
        rules: _vm.rules,
        name: "register-form",
        "label-position": "top"
      },
      nativeOn: {
        submit: function($event) {
          $event.preventDefault();
          return _vm.submitRegistration($event)
        }
      }
    },
    [
      _c("auth-page-header", {
        attrs: { title: "Let’s get started by creating an account." }
      }),
      _vm._v(" "),
      _vm.showProjectInfo
        ? _c("p", [
            _c("span", { attrs: { id: "employer-info" } }, [
              _vm._v(
                "\n      When your " +
                  _vm._s(_vm.employerName) +
                  " proposal is underwritten, you’ll submit your quote here\n    "
              )
            ]),
            _c("br"),
            _vm._v(" "),
            _c("span", { attrs: { id: "carrier-info" } }, [
              _c("strong", [_vm._v("Heads up:")]),
              _vm._v(" "),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.submittedCarriers) +
                  " out of " +
                  _vm._s(_vm.invitedCarriers) +
                  " carriers invited have submitted their quotes.\n    "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inputs-container" },
        [
          _c(
            "tf-form-item",
            {
              staticClass: "first-name-container",
              attrs: {
                for: "first-name-input",
                prop: "firstName",
                label: "First name",
                size: "medium"
              }
            },
            [
              _c("tf-input", {
                attrs: {
                  name: "first-name-input",
                  placeholder: "Enter First Name"
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("setUserInfo", { first_name: $event })
                  }
                },
                model: {
                  value: _vm.registrationForm.firstName,
                  callback: function($$v) {
                    _vm.$set(_vm.registrationForm, "firstName", $$v);
                  },
                  expression: "registrationForm.firstName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "tf-form-item",
            {
              staticClass: "last-name-container",
              attrs: {
                for: "last-name-input",
                prop: "lastName",
                label: "Last name",
                size: "medium"
              }
            },
            [
              _c("tf-input", {
                attrs: {
                  name: "last-name-input",
                  placeholder: "Enter Last Name"
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("setUserInfo", { last_name: $event })
                  }
                },
                model: {
                  value: _vm.registrationForm.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.registrationForm, "lastName", $$v);
                  },
                  expression: "registrationForm.lastName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "tf-form-item",
            {
              staticClass: "role-container",
              attrs: { prop: "role", label: "Role" }
            },
            [
              _c(
                "tf-select",
                {
                  attrs: { placeholder: "Select a Role", name: "role-input" },
                  on: {
                    input: function($event) {
                      return _vm.$emit("setUserInfo", { role: $event })
                    }
                  },
                  model: {
                    value: _vm.registrationForm.role,
                    callback: function($$v) {
                      _vm.$set(_vm.registrationForm, "role", $$v);
                    },
                    expression: "registrationForm.role"
                  }
                },
                [
                  _c("tf-option", {
                    staticClass: "role-input-option",
                    attrs: { label: "Sales", value: "Sales" }
                  }),
                  _vm._v(" "),
                  _c("tf-option", {
                    staticClass: "role-input-option",
                    attrs: { label: "Sales Support", value: "Sales Support" }
                  }),
                  _vm._v(" "),
                  _c("tf-option", {
                    staticClass: "role-input-option",
                    attrs: {
                      label: "Account Manager",
                      value: "Account Manager"
                    }
                  }),
                  _vm._v(" "),
                  _c("tf-option", {
                    staticClass: "role-input-option",
                    attrs: { label: "Underwriter ", value: "Underwriter" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "tf-form-item",
            {
              staticClass: "email-container",
              class: { "is-error": _vm.customError },
              attrs: {
                for: "email-input",
                prop: "email",
                label: "Company email",
                size: "medium"
              }
            },
            [
              _c("tf-input", {
                attrs: { name: "email-input", placeholder: "Enter email" },
                model: {
                  value: _vm.registrationForm.email,
                  callback: function($$v) {
                    _vm.$set(_vm.registrationForm, "email", $$v);
                  },
                  expression: "registrationForm.email"
                }
              }),
              _vm._v(" "),
              _vm.customError
                ? _c(
                    "div",
                    { staticClass: "el-form-item__error" },
                    [
                      _vm.customError === "emailTaken"
                        ? [
                            _vm._v(
                              "\n          Email has already been taken.\n          "
                            ),
                            _c("router-link", {
                              attrs: { to: _vm.linkForgot },
                              domProps: {
                                textContent: _vm._s("Reset your password")
                              }
                            }),
                            _vm._v(".\n        ")
                          ]
                        : _vm.customError === "notValid"
                        ? [
                            _vm._v(
                              "\n          Your company domain isn’t in our system. Make sure you typed your email address correctly.\n        "
                            )
                          ]
                        : [
                            _vm._v(
                              "\n          There was a problem processing your request.\n        "
                            )
                          ]
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "tf-form-item",
            {
              staticClass: "password-container",
              attrs: {
                for: "password-input",
                prop: "password",
                label: "Create password (at least 6 characters)",
                size: "medium"
              }
            },
            [
              _c("tf-input", {
                attrs: {
                  type: _vm.showPassword ? "text" : "password",
                  placeholder: "Enter Password",
                  name: "password-input"
                },
                model: {
                  value: _vm.registrationForm.password,
                  callback: function($$v) {
                    _vm.$set(_vm.registrationForm, "password", $$v);
                  },
                  expression: "registrationForm.password"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("tf-checkbox", {
            staticClass: "show-password-container",
            attrs: { name: "show-password", label: "Show password" },
            model: {
              value: _vm.showPassword,
              callback: function($$v) {
                _vm.showPassword = $$v;
              },
              expression: "showPassword"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _c("tf-button", {
                attrs: {
                  disabled: _vm.btnCreateDisabled,
                  name: "submit-button",
                  type: "primary",
                  "native-type": "submit"
                },
                domProps: { textContent: _vm._s("Create account") }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "links-container" },
            [
              _c(
                "router-link",
                { attrs: { tag: "li", to: _vm.linkLogin } },
                [
                  _c("tf-button", {
                    attrs: {
                      id: "link-account",
                      type: "primary",
                      size: "text"
                    },
                    domProps: {
                      textContent: _vm._s("I already have an account.")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("auth-page-footer")
    ],
    1
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$8 = {
  name: 'AppResendConfirmation',
  props: {
    documentId: {
      type: String,
      default: null
    },
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    linkConfirmation: {
      type: [String, Object],
      required: true
    },
    linkLogin: {
      type: [String, Object],
      required: true
    },
    linkRegister: {
      type: [String, Object],
      required: true
    },
    projectId: {
      type: [String, Number],
      default: null
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  /**
   * If the email address isn't passed, redirect to the linkLogin.
   */
  created: function created() {
    if (!this.userInfo.email) {
      this.$router.replace(this.$route.query.redirect || this.linkLogin);
    }
  },
  methods: {
    /**
     * call the AccountService to send a new confirmation email
     */
    resendConfirmation: function resendConfirmation() {
      var _this = this;

      this.accountService.resendConfirmation({
        documentId: this.documentId,
        email: this.userInfo.email,
        projectId: this.projectId
      }).then(function () {
        var redirectURL = _this.$route.query.redirect || _this.linkConfirmation;

        _this.$router.replace(redirectURL);
      }).catch(function () {});
    }
  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    {
      staticClass: "auth-form",
      attrs: { id: "resend-confirmation-container" }
    },
    [
      _c("auth-page-header", {
        attrs: { title: "I didn’t receive the temporary password email." }
      }),
      _vm._v(" "),
      _c("ol", [
        _c(
          "li",
          [
            _vm._v(
              "\n      Is the " +
                _vm._s(_vm.userInfo.email) +
                " your correct email without typos? If not, you can\n      "
            ),
            _c("router-link", {
              attrs: { to: _vm.linkRegister },
              domProps: {
                textContent: _vm._s("restart the account creation process")
              }
            }),
            _vm._v(".\n    ")
          ],
          1
        ),
        _vm._v(" "),
        _c("li", [_vm._v("Check your spam folder")]),
        _vm._v(" "),
        _c("li", [_vm._v("Add email@threeflow.com to your contacts")])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.userInfo.email))]),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("tf-button", {
            domProps: { textContent: _vm._s("Resend confirmation email") },
            on: { click: _vm.resendConfirmation }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("auth-page-footer")
    ],
    1
  )
};
var __vue_staticRenderFns__$8 = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("p", [_c("strong", [_vm._v("Or we can try again:")])])
  }
];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = function (inject) {
    if (!inject) return
    inject("data-v-138dcaff_0", { source: ".auth-form[data-v-138dcaff] {\n  max-width: 570px;\n  text-align: left;\n}\nol[data-v-138dcaff] {\n  margin-bottom: 25px;\n  padding-left: 20px;\n  list-style: decimal;\n}\nli[data-v-138dcaff] {\n  font-size: 14px;\n  line-height: 1.86;\n}\np[data-v-138dcaff] {\n  margin: 0 0 15px;\n}\n\n/*# sourceMappingURL=AppResendConfirmation.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/AppResendConfirmation.vue","AppResendConfirmation.vue"],"names":[],"mappings":"AA8FA;EACA,gBAAA;EACA,gBAAA;AC7FA;ADgGA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AC7FA;ADgGA;EACA,eAAA;EACA,iBAAA;AC7FA;ADgGA;EACA,gBAAA;AC7FA;;AAEA,oDAAoD","file":"AppResendConfirmation.vue","sourcesContent":["<template>\n  <section\n    id=\"resend-confirmation-container\"\n    class=\"auth-form\"\n  >\n    <auth-page-header title=\"I didn’t receive the temporary password email.\" />\n    <ol>\n      <li>\n        Is the {{ userInfo.email }} your correct email without typos? If not, you can\n        <router-link\n          :to=\"linkRegister\"\n          v-text=\"'restart the account creation process'\"\n        />.\n      </li>\n      <li>Check your spam folder</li>\n      <li>Add email@threeflow.com to your contacts</li>\n    </ol>\n    <p><strong>Or we can try again:</strong></p>\n    <p>{{ userInfo.email }}</p>\n    <p>\n      <tf-button\n        @click=\"resendConfirmation\"\n        v-text=\"'Resend confirmation email'\"\n      />\n    </p>\n    <auth-page-footer />\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppResendConfirmation',\n    props: {\n      documentId: {\n        type: String,\n        default: null,\n      },\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n      linkConfirmation: {\n        type: [String, Object],\n        required: true,\n      },\n      linkLogin: {\n        type: [String, Object],\n        required: true,\n      },\n      linkRegister: {\n        type: [String, Object],\n        required: true,\n      },\n      projectId: {\n        type: [String, Number],\n        default: null,\n      },\n      userInfo: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    /**\n     * If the email address isn't passed, redirect to the linkLogin.\n     */\n    created() {\n      if (!this.userInfo.email) {\n        this.$router.replace(this.$route.query.redirect || this.linkLogin);\n      }\n    },\n    methods: {\n      /**\n       * call the AccountService to send a new confirmation email\n       */\n      resendConfirmation() {\n        this\n          .accountService\n          .resendConfirmation({\n            documentId: this.documentId,\n            email: this.userInfo.email,\n            projectId: this.projectId,\n          })\n          .then(() => {\n            const redirectURL = this.$route.query.redirect || this.linkConfirmation;\n\n            this.$router.replace(redirectURL);\n          })\n          .catch(() => {});\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  .auth-form {\n    max-width: 570px;\n    text-align: left;\n  }\n\n  ol {\n    margin-bottom: 25px;\n    padding-left: 20px;\n    list-style: decimal;\n  }\n\n  li {\n    font-size: 14px;\n    line-height: 1.86;\n  }\n\n  p {\n    margin: 0 0 15px;\n  }\n</style>\n",".auth-form {\n  max-width: 570px;\n  text-align: left;\n}\n\nol {\n  margin-bottom: 25px;\n  padding-left: 20px;\n  list-style: decimal;\n}\n\nli {\n  font-size: 14px;\n  line-height: 1.86;\n}\n\np {\n  margin: 0 0 15px;\n}\n\n/*# sourceMappingURL=AppResendConfirmation.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$8 = "data-v-138dcaff";
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$9 = {
  name: 'AppResetPasswordForm',
  props: {
    accountService: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      resetPasswordForm: {
        password: '',
        showPassword: false
      },
      rules: {
        password: [{
          required: true,
          message: 'Please choose a password.',
          trigger: 'none'
        }, {
          min: 6,
          message: 'Your password must be at least 6 characters.',
          trigger: 'none'
        }]
      },
      passwordType: 'password',
      submitting: false
    };
  },
  watch: {
    /**
     * Watching the show password checkbox and changing the type of the password input
     *
     * @param {boolean} show
     */
    'resetPasswordForm.showPassword': function resetPasswordFormShowPassword(show) {
      this.passwordType = show ? 'text' : 'password';
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.setTimeout(function () {
      _this.resetPasswordForm.password = '';
    }, 100);
  },
  methods: {
    /**
     * Validate the resetPasswordForm
     * Then call the accountService/changePassword method and emit an event if succesful
     */
    submitResetPassword: function submitResetPassword() {
      var _this2 = this;

      this.$refs.resetPasswordForm.validate(function (valid) {
        _this2.submitting = true;

        if (valid) {
          var data = {
            password: _this2.resetPasswordForm.password
          };

          _this2.accountService.changePassword(data).then(function () {
            _this2.submitting = false;

            _this2.$emit('passwordUpdated');
          });
        } else {
          _this2.submitting = false;
        }

        return valid;
      });
    }
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    { staticClass: "reset-password-container" },
    [
      _c("h4", [_vm._v("Please choose a new password for your account.")]),
      _vm._v(" "),
      _c(
        "tf-form",
        {
          ref: "resetPasswordForm",
          staticClass: "reset-password",
          attrs: {
            model: _vm.resetPasswordForm,
            rules: _vm.rules,
            "label-position": "top"
          },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault();
              return _vm.submitResetPassword($event)
            }
          }
        },
        [
          _c(
            "tf-form-item",
            {
              staticClass: "password-container",
              attrs: { for: "password-input", prop: "password", size: "medium" }
            },
            [
              _c("p", [_vm._v("New Password (at least six characters)")]),
              _vm._v(" "),
              _c("tf-input", {
                attrs: {
                  type: _vm.passwordType,
                  "auto-complete": "off",
                  name: "password-input"
                },
                model: {
                  value: _vm.resetPasswordForm.password,
                  callback: function($$v) {
                    _vm.$set(_vm.resetPasswordForm, "password", $$v);
                  },
                  expression: "resetPasswordForm.password"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "tf-checkbox",
            {
              staticClass: "show-password-container",
              attrs: { name: "show-password" },
              model: {
                value: _vm.resetPasswordForm.showPassword,
                callback: function($$v) {
                  _vm.$set(_vm.resetPasswordForm, "showPassword", $$v);
                },
                expression: "resetPasswordForm.showPassword"
              }
            },
            [_vm._v("\n      Show password\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _c("tf-button", {
                attrs: {
                  disabled: !_vm.resetPasswordForm.password || _vm.submitting,
                  type: "primary",
                  "native-type": "submit"
                },
                domProps: { textContent: _vm._s("Update Password") }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = function (inject) {
    if (!inject) return
    inject("data-v-7c93f8a6_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.el-form-item[data-v-7c93f8a6] {\n  margin-bottom: 5px;\n}\n.btn-group[data-v-7c93f8a6] {\n  display: flex;\n  margin-top: 25px;\n}\n.el-input[data-v-7c93f8a6] {\n  max-width: 300px;\n}\nh4[data-v-7c93f8a6] {\n  margin-bottom: 20px;\n  font-weight: 400;\n  font-size: 16px;\n}\np[data-v-7c93f8a6] {\n  margin-bottom: 5px;\n}\n\n/*# sourceMappingURL=AppResetPasswordForm.vue.map */", map: {"version":3,"sources":["AppResetPasswordForm.vue","/home/circleci/repo/src/components/AuthPages/AppResetPasswordForm.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC4GpC;EACA,kBAAA;AD1GA;AC6GA;EACA,aAAA;EACA,gBAAA;AD1GA;AC6GA;EACA,gBAAA;AD1GA;AC6GA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AD1GA;AC6GA;EACA,kBAAA;AD1GA;;AAEA,mDAAmD","file":"AppResetPasswordForm.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.el-form-item {\n  margin-bottom: 5px;\n}\n\n.btn-group {\n  display: flex;\n  margin-top: 25px;\n}\n\n.el-input {\n  max-width: 300px;\n}\n\nh4 {\n  margin-bottom: 20px;\n  font-weight: 400;\n  font-size: 16px;\n}\n\np {\n  margin-bottom: 5px;\n}\n\n/*# sourceMappingURL=AppResetPasswordForm.vue.map */","<template>\n  <section class=\"reset-password-container\">\n    <h4>Please choose a new password for your&nbsp;account.</h4>\n    <tf-form\n      ref=\"resetPasswordForm\"\n      :model=\"resetPasswordForm\"\n      :rules=\"rules\"\n      label-position=\"top\"\n      class=\"reset-password\"\n      @submit.native.prevent=\"submitResetPassword\"\n    >\n      <tf-form-item\n        for=\"password-input\"\n        prop=\"password\"\n        class=\"password-container\"\n        size=\"medium\"\n      >\n        <p>New Password (at least six characters)</p>\n        <tf-input\n          v-model=\"resetPasswordForm.password\"\n          :type=\"passwordType\"\n          auto-complete=\"off\"\n          name=\"password-input\"\n        />\n      </tf-form-item>\n      <tf-checkbox\n        v-model=\"resetPasswordForm.showPassword\"\n        class=\"show-password-container\"\n        name=\"show-password\"\n      >\n        Show password\n      </tf-checkbox>\n      <div class=\"btn-group\">\n        <tf-button\n          :disabled=\"!resetPasswordForm.password || submitting\"\n          type=\"primary\"\n          native-type=\"submit\"\n          v-text=\"'Update Password'\"\n        />\n      </div>\n    </tf-form>\n  </section>\n</template>\n\n<script>\n  export default {\n    name: 'AppResetPasswordForm',\n    props: {\n      accountService: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    data: () => ({\n      resetPasswordForm: {\n        password: '',\n        showPassword: false,\n      },\n      rules: {\n        password: [\n          { required: true, message: 'Please choose a password.', trigger: 'none' },\n          { min: 6, message: 'Your password must be at least 6 characters.', trigger: 'none' },\n        ],\n      },\n      passwordType: 'password',\n      submitting: false,\n    }),\n    watch: {\n      /**\n       * Watching the show password checkbox and changing the type of the password input\n       *\n       * @param {boolean} show\n       */\n      'resetPasswordForm.showPassword': function (show) {\n        this.passwordType = show ? 'text' : 'password';\n      },\n    },\n    mounted() {\n      window.setTimeout(() => {\n        this.resetPasswordForm.password = '';\n      }, 100);\n    },\n    methods: {\n      /**\n       * Validate the resetPasswordForm\n       * Then call the accountService/changePassword method and emit an event if succesful\n       */\n      submitResetPassword() {\n        this.$refs.resetPasswordForm.validate((valid) => {\n          this.submitting = true;\n\n          if (valid) {\n            const data = {\n              password: this.resetPasswordForm.password,\n            };\n            this.accountService.changePassword(data).then(() => {\n              this.submitting = false;\n              this.$emit('passwordUpdated');\n            });\n          } else {\n            this.submitting = false;\n          }\n\n          return valid;\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/mixins';\n\n  .el-form-item {\n    margin-bottom: 5px;\n  }\n\n  .btn-group {\n    display: flex;\n    margin-top: 25px;\n  }\n\n  .el-input {\n    max-width: 300px;\n  }\n\n  h4 {\n    margin-bottom: 20px;\n    font-weight: 400;\n    font-size: 16px;\n  }\n\n  p {\n    margin-bottom: 5px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$9 = "data-v-7c93f8a6";
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    browser,
    undefined,
    undefined
  );

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString$1 = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString$1.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString$1.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString$1.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString$1.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString$1.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString$1.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction$1(val) {
  return toString$1.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction$1(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim$1(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$1 = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$1,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim$1,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$1.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$1.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$1.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$1.forEach(val, function parseValue(v) {
        if (utils$1.isDate(v)) {
          v = v.toISOString();
        } else if (utils$1.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils$1.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils$1.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$1.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var cookies = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$1.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$1.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$1.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$1.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$1.trim(line.substr(0, i)).toLowerCase();
    val = utils$1.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils$1.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$1.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$1.isUndefined(headers) && utils$1.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils$1.isFormData(data) ||
      utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$1.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$1.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils$1.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$1.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$1.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge(target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$1.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$1.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$1.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$1.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$1.forEach(otherKeys, mergeDeepProperties);

  return config;
};

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils$1.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios_1;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = Cancel_1;
axios.CancelToken = CancelToken_1;
axios.isCancel = isCancel;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

var axios_1 = axios;

// Allow use of default import syntax in TypeScript
var default_1 = axios;
axios_1.default = default_1;

var axios$1 = axios_1;

//
/**
 * Terms of Use
 *
 * @vuedoc
 * @exports AppTermsOfUse
 * @category Components
 */

var script$a = {
  name: 'AppTermsOfUse',
  props: {
    termsId: {
      type: String,
      default: '11825817'
    }
  },
  data: function data() {
    return {
      hasError: false,
      isLoading: true,
      termsOfUseContent: ''
    };
  },
  // On create we hit the iubenda api and grab the terms from there.
  // We can pass in an id incase we need different calls for different sites.
  created: function created() {
    var _this = this;

    axios$1.get("https://www.iubenda.com/api/terms-and-conditions/".concat(this.termsId)).then(function (response) {
      _this.termsOfUseContent = response.data.content;
      _this.isLoading = false;
    }).catch(function () {
      _this.isLoading = false;
      _this.hasError = true;
    });
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticClass: "terms-container",
      class: { "has-error": _vm.hasError }
    },
    [
      _vm.hasError
        ? _c("el-alert", {
            attrs: {
              closable: false,
              title: "There was a problem retrieving the terms of use.",
              type: "error"
            }
          })
        : _c("span", { domProps: { innerHTML: _vm._s(_vm.termsOfUseContent) } })
    ],
    1
  )
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = function (inject) {
    if (!inject) return
    inject("data-v-e6795040_0", { source: ".terms-container[data-v-e6795040] {\n  width: 100%;\n  max-width: 725px;\n  padding: 30px 20px;\n}\n.terms-container.has-error[data-v-e6795040] {\n  max-width: none;\n}\n\n/*# sourceMappingURL=AppTermsOfUse.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/AppTermsOfUse.vue","AppTermsOfUse.vue"],"names":[],"mappings":"AA6DA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AC5DA;AD8DA;EACA,eAAA;AC5DA;;AAEA,4CAA4C","file":"AppTermsOfUse.vue","sourcesContent":["<template>\n  <section\n    v-loading=\"isLoading\"\n    class=\"terms-container\"\n    :class=\"{ 'has-error' : hasError }\"\n  >\n    <el-alert\n      v-if=\"hasError\"\n      :closable=\"false\"\n      title=\"There was a problem retrieving the terms of use.\"\n      type=\"error\"\n    />\n    <!-- eslint-disable vue/no-v-html -->\n    <span\n      v-else\n      v-html=\"termsOfUseContent\"\n    />\n    <!-- eslint-enable vue/no-v-html -->\n  </section>\n</template>\n\n<script>\n  import axios from 'axios';\n\n  /**\n   * Terms of Use\n   *\n   * @vuedoc\n   * @exports AppTermsOfUse\n   * @category Components\n   */\n  export default {\n    name: 'AppTermsOfUse',\n    props: {\n      termsId: {\n        type: String,\n        default: '11825817',\n      },\n    },\n    data: () => ({\n      hasError: false,\n      isLoading: true,\n      termsOfUseContent: '',\n    }),\n    // On create we hit the iubenda api and grab the terms from there.\n    // We can pass in an id incase we need different calls for different sites.\n    created() {\n      axios.get(`https://www.iubenda.com/api/terms-and-conditions/${this.termsId}`)\n        .then((response) => {\n          this.termsOfUseContent = response.data.content;\n          this.isLoading = false;\n        })\n        .catch(() => {\n          this.isLoading = false;\n          this.hasError = true;\n        });\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .terms-container {\n    width: 100%;\n    max-width: 725px;\n    padding: 30px 20px;\n\n    &.has-error {\n      max-width: none;\n    }\n  }\n</style>\n",".terms-container {\n  width: 100%;\n  max-width: 725px;\n  padding: 30px 20px;\n}\n.terms-container.has-error {\n  max-width: none;\n}\n\n/*# sourceMappingURL=AppTermsOfUse.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$a = "data-v-e6795040";
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Auth Flow Footer
 *
 * @vuedoc
 * @exports AuthenticationFooter
 * @category Components
 */
var script$b = {
  name: 'AuthenticationFooter'
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("footer", [
    _c(
      "p",
      [
        _vm._v("\n    Need help?\n    "),
        _c("tf-button", {
          attrs: {
            tag: "a",
            type: "primary",
            size: "text",
            target: "_blank",
            href: "mailto:support@threeflow.com"
          },
          domProps: { textContent: _vm._s("Contact support") }
        }),
        _vm._v(".\n  ")
      ],
      1
    )
  ])
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = function (inject) {
    if (!inject) return
    inject("data-v-65730a44_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nfooter[data-v-65730a44] {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  padding: 20px 0 40px;\n  text-align: center;\n  background: #fff;\n}\n.auth-form p[data-v-65730a44],\n.auth-form p .tf-button--text[data-v-65730a44],\n.auth-form p .wt-button--text[data-v-65730a44] {\n  font-size: 14px;\n}\n.auth-form p .tf-button--text[data-v-65730a44],\n.auth-form p .wt-button--text[data-v-65730a44] {\n  display: inline-block;\n}\n\n/*# sourceMappingURL=Footer.vue.map */", map: {"version":3,"sources":["Footer.vue","/home/circleci/repo/src/components/AuthPages/Footer.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AC0ClC;;oCAAA;AAZA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBALA;ADpBA;AC6BA;;;EAGA,eAAA;AD1BA;AC6BA;;EAEA,qBAAA;AD3BA;;AAEA,qCAAqC","file":"Footer.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nfooter {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  padding: 20px 0 40px;\n  text-align: center;\n  background: #fff;\n}\n\n.auth-form p,\n.auth-form p .tf-button--text,\n.auth-form p .wt-button--text {\n  font-size: 14px;\n}\n.auth-form p .tf-button--text,\n.auth-form p .wt-button--text {\n  display: inline-block;\n}\n\n/*# sourceMappingURL=Footer.vue.map */","<template>\n  <footer>\n    <p>\n      Need help?\n      <tf-button\n        tag=\"a\"\n        type=\"primary\"\n        size=\"text\"\n        target=\"_blank\"\n        href=\"mailto:support@threeflow.com\"\n        v-text=\"'Contact support'\"\n      />.\n    </p>\n  </footer>\n</template>\n\n<script>\n/**\n * WatchTower Auth Flow Footer\n *\n * @vuedoc\n * @exports AuthenticationFooter\n * @category Components\n */\n  export default {\n    name: 'AuthenticationFooter',\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  footer {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    padding: 20px 0 40px;\n    text-align: center;\n    background: $tf-white;\n  }\n\n  .auth-form p {\n    &,\n    .tf-button--text,\n    .wt-button--text {\n      font-size: 14px;\n    }\n\n    .tf-button--text,\n    .wt-button--text {\n      display: inline-block;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$b = "data-v-65730a44";
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Auth Flow Header
 *
 * @vuedoc
 * @exports AuthenticationHeader'
 * @category Components
 */
var script$c = {
  name: 'AuthenticationFooter',
  props: {
    title: {
      type: String,
      default: null
    }
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("header", [
    _c("div", { staticClass: "logo" }, [_c("threeflow-wordmark")], 1),
    _vm._v(" "),
    _vm.title
      ? _c("h2", { domProps: { textContent: _vm._s(_vm.title) } })
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = function (inject) {
    if (!inject) return
    inject("data-v-25b5c87e_0", { source: ".logo[data-v-25b5c87e] {\n  display: block;\n  margin: 0 auto 45px;\n}\n\n/*# sourceMappingURL=Header.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/AuthPages/Header.vue","Header.vue"],"names":[],"mappings":"AAiCA;EACA,cAAA;EACA,mBAAA;AChCA;;AAEA,qCAAqC","file":"Header.vue","sourcesContent":["<template>\n  <header>\n    <div class=\"logo\">\n      <threeflow-wordmark />\n    </div>\n    <h2\n      v-if=\"title\"\n      v-text=\"title\"\n    />\n  </header>\n</template>\n\n<script>\n/**\n * WatchTower Auth Flow Header\n *\n * @vuedoc\n * @exports AuthenticationHeader'\n * @category Components\n */\n\n  export default {\n    name: 'AuthenticationFooter',\n    props: {\n      title: {\n        type: String,\n        default: null,\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  .logo {\n    display: block;\n    margin: 0 auto 45px;\n  }\n</style>\n",".logo {\n  display: block;\n  margin: 0 auto 45px;\n}\n\n/*# sourceMappingURL=Header.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$c = "data-v-25b5c87e";
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    browser,
    undefined,
    undefined
  );

var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO || !_strictMethod($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = _toIobject(this);
    var length = _toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, _toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This is an input used when there are "readonly" and "edit" modes. The "readonly" will render out text that on hover (or parental hover) will look like an input. The "edit" mode by default will show an  input > cancel button > save button" design pattern is required. The parent should handle the readonly state along with the API's success/failure returns.
 *
 * @vuedoc
 * @exports TfForm/TfInlineFormField
 * @category Components
 */
var script$d = {
  name: 'TfInlineFormField',
  props: {
    deleteType: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isEditing: {
      type: Boolean,
      required: true
    },
    isHovering: {
      type: Boolean,
      default: false
    },
    isDeleting: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Enter value'
    },
    prop: {
      type: String,
      required: true
    },
    showBtnDelete: {
      type: Boolean,
      default: true
    },
    showBtnEdit: {
      type: Boolean,
      default: true
    },
    showBtnActions: {
      type: Boolean,
      default: true
    },
    showExtension: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data: function data(vm) {
    return {
      originalValue: vm.value
    };
  },
  computed: {
    /**
     * Evaluate different states to disable all the buttons in the template.
     *
     * @returns {boolean}
     */
    btnsDisabled: function btnsDisabled() {
      return this.isDeleting || this.isSaving || this.isDisabled;
    },

    /**
     * Evaluate different states to disable all the save in the template and prevent the form from submitting on enter.
     *
     * @returns {boolean}
     */
    btnSaveDisabled: function btnSaveDisabled() {
      return this.isRequired && !this.localValue;
    },

    /**
     * Evaluate the props to get the extension if necessessary.
     *
     * @returns {string}
     */
    extension: function extension() {
      return this.showExtension ? this.value.substr(this.value.lastIndexOf('.') + 1) : '';
    },

    /**
     * Get the local value for the input with/without the extension.
     * Emit the new value with/without the extension.
     *
     * @returns {string}
     */
    localValue: {
      get: function get() {
        return this.showExtension && this.isEditing ? this.value.replace(".".concat(this.extension), '') : this.value;
      },
      set: function set(value) {
        var newValue = this.extension ? "".concat(value, ".").concat(this.extension) : value;
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    /**
     * Emit "cancel" and "edit" correctly to reset the state in the parent.
     */
    onCancel: function onCancel() {
      this.$emit('cancel', this.originalValue);
      this.$emit('edit', false);
    },

    /**
     * Set btnsDisable to `true` and emit "delete" to the parent.
     */
    onDelete: function onDelete() {
      this.$emit('delete');
    },

    /**
     * Emit up to the parent and wait for the prop to change. If the default slot for the edit mode is being used, we focus on the input.
     */
    onEdit: function onEdit() {
      var _this = this;

      this.$emit('edit', true);
      this.$nextTick(function () {
        // need to test b/c of jest timing issues I can't pinpoint as well.
        if (_this.$slots.default || !_this.$refs.input) {
          return;
        }

        _this.$refs.input.$el.querySelector('input').focus();
      });
    },

    /**
     * Emit "save" with the correct value/extension only if any of the disabled states aren't true. We also want to update "originalValue" since this component is not destroyed.
     */
    onSave: function onSave() {
      if (this.btnsDisabled || this.btnSaveDisabled) {
        return;
      }

      var newValue = this.showExtension && this.isEditing ? "".concat(this.localValue, ".").concat(this.extension) : this.localValue;
      this.originalValue = newValue;
      this.$emit('save', newValue);
    }
  }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function() {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "tf-inline-form-field wt-inline-form-field" },
    [
      _vm.isEditing
        ? _c(
            "div",
            { staticClass: "container-editing" },
            [
              _c(
                "tf-form",
                {
                  attrs: {
                    model:
                      ((_obj = {}), (_obj[_vm.prop] = _vm.localValue), _obj)
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault();
                    }
                  }
                },
                [
                  _c(
                    "tf-form-item",
                    { attrs: { prop: _vm.prop, size: "medium" } },
                    [
                      _vm._t("default", [
                        _c(
                          "tf-input",
                          _vm._b(
                            {
                              ref: "input",
                              nativeOn: {
                                keyup: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onSave($event)
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "escape",
                                        undefined,
                                        $event.key,
                                        undefined
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.onCancel($event)
                                  }
                                ]
                              },
                              model: {
                                value: _vm.localValue,
                                callback: function($$v) {
                                  _vm.localValue = $$v;
                                },
                                expression: "localValue"
                              }
                            },
                            "tf-input",
                            {
                              disabled: _vm.btnsDisabled,
                              placeholder: _vm.placeholder
                            },
                            false
                          ),
                          [
                            _vm.showExtension
                              ? _c(
                                  "template",
                                  {
                                    attrs: { "data-test-extension": "" },
                                    slot: "append"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.extension) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.showBtnActions
                        ? _c(
                            "div",
                            { staticClass: "btn-group align-end" },
                            [
                              _c("tf-button", {
                                attrs: {
                                  disabled: _vm.btnsDisabled,
                                  icon: "times",
                                  size: "icon-no-fill",
                                  type: "decline",
                                  "no-border": ""
                                },
                                on: { click: _vm.onCancel }
                              }),
                              _vm._v(" "),
                              _c("tf-button", {
                                attrs: {
                                  disabled:
                                    _vm.btnsDisabled || _vm.btnSaveDisabled,
                                  loading: _vm.isSaving,
                                  icon: "check",
                                  size: "icon-no-fill",
                                  type: "affirm",
                                  "no-border": ""
                                },
                                on: { click: _vm.onSave }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-group align-start" },
                [
                  _vm.showBtnDelete
                    ? _c("tf-button", {
                        staticClass: "btn-delete",
                        attrs: {
                          disabled: _vm.btnsDisabled,
                          size: "text-small",
                          type: "decline"
                        },
                        domProps: {
                          textContent: _vm._s(
                            "Delete" +
                              (_vm.deleteType ? " " + _vm.deleteType : "")
                          )
                        },
                        on: { click: _vm.onDelete }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            {
              class: [{ "is-hovering": _vm.isHovering }, "container-readonly"]
            },
            [
              _c(
                "span",
                { staticClass: "faux-input", on: { click: _vm.onEdit } },
                [_c("span", [_vm._v(_vm._s(_vm.value))])]
              ),
              _vm._v(" "),
              _vm.showBtnEdit
                ? _c("tf-button", {
                    staticClass: "btn-edit",
                    attrs: {
                      type: "primary",
                      icon: "pencil-alt",
                      size: "icon-no-fill",
                      "no-border": ""
                    },
                    on: { click: _vm.onEdit }
                  })
                : _vm._e()
            ],
            1
          )
    ]
  )
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = function (inject) {
    if (!inject) return
    inject("data-v-40486366_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.el-form-item[data-v-40486366] {\n  margin: 0;\n}\n[data-v-40486366] .el-form-item__content {\n  display: flex;\n}\n[data-v-40486366] .el-input-group__append {\n  background-color: #fafafa;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n.btn-group.align-end[data-v-40486366] {\n  margin-left: 15px;\n}\n.btn-group.align-end .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill[data-v-40486366],\n.btn-group.align-end .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill[data-v-40486366] {\n  margin-left: 4px;\n}\nspan[data-v-40486366] {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  transition: all 0.5s;\n  min-height: 30px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  line-height: 26px;\n}\n.tf-button.btn-delete[data-v-40486366],\n.wt-button.btn-delete[data-v-40486366] {\n  margin-top: 3px;\n}\n.btn-edit[data-v-40486366] {\n  opacity: 0;\n  transition: all 0.5s;\n}\n.container-editing[data-v-40486366] {\n  display: flex;\n  flex-direction: column;\n}\n.container-readonly[data-v-40486366] {\n  display: flex;\n}\n.container-readonly:hover .btn-edit[data-v-40486366], .container-readonly.is-hovering .btn-edit[data-v-40486366] {\n  opacity: 1;\n}\n.container-readonly:hover .faux-input[data-v-40486366], .container-readonly.is-hovering .faux-input[data-v-40486366] {\n  padding: 0 15px;\n  border-color: #c1c1c1;\n  background: #fff;\n}\n.faux-input[data-v-40486366] {\n  border: 1px solid transparent;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.faux-input > span[data-v-40486366] {\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.tf-inline-form-field[data-v-40486366],\n.wt-inline-form-field[data-v-40486366] {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfInlineFormField.vue.map */", map: {"version":3,"sources":["TfInlineFormField.vue","/home/circleci/repo/src/components/TfForm/TfInlineFormField.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACuQpC;EACA,SAAA;ADrQA;ACyQA;EACA,aAAA;ADtQA;ACyQA;EACA,yBAAA;EAEA,4BAAA;EACA,+BAAA;ADxQA;AC6QA;EACA,iBAAA;AD1QA;AC6QA;;EAEA,gBAAA;AD3QA;AC+QA;EACA,sBAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;AD5QA;AC+QA;;EAEA,eAAA;AD5QA;AC+QA;EACA,UAAA;EACA,oBAAA;AD5QA;ACgRA;EACA,aAAA;EACA,sBAAA;AD7QA;ACgRA;EACA,aAAA;AD9QA;ACkRA;EACA,UAAA;ADhRA;ACmRA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;ADjRA;ACuRA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADpRA;ACsRA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ADpRA;ACwRA;;EAEA,WAAA;ADrRA;;AAEA,gDAAgD","file":"TfInlineFormField.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.el-form-item {\n  margin: 0;\n}\n\n::v-deep .el-form-item__content {\n  display: flex;\n}\n::v-deep .el-input-group__append {\n  background-color: #fafafa;\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n\n.btn-group.align-end {\n  margin-left: 15px;\n}\n.btn-group.align-end .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n.btn-group.align-end .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n  margin-left: 4px;\n}\n\nspan {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  transition: all 0.5s;\n  min-height: 30px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  line-height: 26px;\n}\n\n.tf-button.btn-delete,\n.wt-button.btn-delete {\n  margin-top: 3px;\n}\n\n.btn-edit {\n  opacity: 0;\n  transition: all 0.5s;\n}\n\n.container-editing {\n  display: flex;\n  flex-direction: column;\n}\n.container-readonly {\n  display: flex;\n}\n.container-readonly:hover .btn-edit, .container-readonly.is-hovering .btn-edit {\n  opacity: 1;\n}\n.container-readonly:hover .faux-input, .container-readonly.is-hovering .faux-input {\n  padding: 0 15px;\n  border-color: #c1c1c1;\n  background: #fff;\n}\n\n.faux-input {\n  border: 1px solid transparent;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.faux-input > span {\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.tf-inline-form-field,\n.wt-inline-form-field {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfInlineFormField.vue.map */","<template>\n  <div class=\"tf-inline-form-field wt-inline-form-field\">\n    <div\n      v-if=\"isEditing\"\n      class=\"container-editing\"\n    >\n      <tf-form\n        :model=\"{ [prop]: localValue }\"\n        @submit.native.prevent\n      >\n        <tf-form-item\n          :prop=\"prop\"\n          size=\"medium\"\n        >\n          <slot>\n            <tf-input\n              ref=\"input\"\n              v-bind=\"{\n                disabled: btnsDisabled,\n                placeholder\n              }\"\n              v-model=\"localValue\"\n              @keyup.native.enter=\"onSave\"\n              @keyup.native.escape=\"onCancel\"\n            >\n              <template\n                v-if=\"showExtension\"\n                slot=\"append\"\n                data-test-extension\n              >\n                {{ extension }}\n              </template>\n            </tf-input>\n          </slot>\n          <div\n            v-if=\"showBtnActions\"\n            class=\"btn-group align-end\"\n          >\n            <!-- btn: cancel edit -->\n            <tf-button\n              :disabled=\"btnsDisabled\"\n              icon=\"times\"\n              size=\"icon-no-fill\"\n              type=\"decline\"\n              no-border\n              @click=\"onCancel\"\n            />\n            <!-- btn: save product -->\n            <tf-button\n              :disabled=\"btnsDisabled || btnSaveDisabled\"\n              :loading=\"isSaving\"\n              icon=\"check\"\n              size=\"icon-no-fill\"\n              type=\"affirm\"\n              no-border\n              @click=\"onSave\"\n            />\n          </div>\n        </tf-form-item>\n      </tf-form>\n      <div class=\"btn-group align-start\">\n        <tf-button\n          v-if=\"showBtnDelete\"\n          class=\"btn-delete\"\n          :disabled=\"btnsDisabled\"\n          size=\"text-small\"\n          type=\"decline\"\n          @click=\"onDelete\"\n          v-text=\"`Delete${deleteType ? ` ${deleteType}` : ''}`\"\n        />\n      </div>\n    </div>\n    <div\n      v-else\n      :class=\"[\n        { 'is-hovering': isHovering },\n        'container-readonly'\n      ]\"\n    >\n      <span\n        class=\"faux-input\"\n        @click=\"onEdit\"\n      >\n        <span>{{ value }}</span>\n      </span>\n      <tf-button\n        v-if=\"showBtnEdit\"\n        class=\"btn-edit\"\n        type=\"primary\"\n        icon=\"pencil-alt\"\n        size=\"icon-no-fill\"\n        no-border\n        @click=\"onEdit\"\n      />\n    </div>\n  </div>\n</template>\n\n<script>\n  /**\n   * This is an input used when there are \"readonly\" and \"edit\" modes. The \"readonly\" will render out text that on hover (or parental hover) will look like an input. The \"edit\" mode by default will show an  input > cancel button > save button\" design pattern is required. The parent should handle the readonly state along with the API's success/failure returns.\n   *\n   * @vuedoc\n   * @exports TfForm/TfInlineFormField\n   * @category Components\n   */\n  export default {\n    name: 'TfInlineFormField',\n    props: {\n      deleteType: {\n        type: String,\n        default: '',\n      },\n      isDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      isEditing: {\n        type: Boolean,\n        required: true,\n      },\n      isHovering: {\n        type: Boolean,\n        default: false,\n      },\n      isDeleting: {\n        type: Boolean,\n        default: false,\n      },\n      isSaving: {\n        type: Boolean,\n        required: true,\n      },\n      isRequired: {\n        type: Boolean,\n        default: true,\n      },\n      placeholder: {\n        type: String,\n        default: 'Enter value',\n      },\n      prop: {\n        type: String,\n        required: true,\n      },\n      showBtnDelete: {\n        type: Boolean,\n        default: true,\n      },\n      showBtnEdit: {\n        type: Boolean,\n        default: true,\n      },\n      showBtnActions: {\n        type: Boolean,\n        default: true,\n      },\n      showExtension: {\n        type: Boolean,\n        default: true,\n      },\n      value: {\n        type: String,\n        required: true,\n      },\n    },\n    data: (vm) => ({\n      originalValue: vm.value,\n    }),\n    computed: {\n      /**\n       * Evaluate different states to disable all the buttons in the template.\n       *\n       * @returns {boolean}\n       */\n      btnsDisabled() {\n        return this.isDeleting || this.isSaving || this.isDisabled;\n      },\n      /**\n       * Evaluate different states to disable all the save in the template and prevent the form from submitting on enter.\n       *\n       * @returns {boolean}\n       */\n      btnSaveDisabled() {\n        return this.isRequired && !this.localValue;\n      },\n      /**\n       * Evaluate the props to get the extension if necessessary.\n       *\n       * @returns {string}\n       */\n      extension() {\n        return this.showExtension\n          ? this.value.substr(this.value.lastIndexOf('.') + 1)\n          : '';\n      },\n      /**\n       * Get the local value for the input with/without the extension.\n       * Emit the new value with/without the extension.\n       *\n       * @returns {string}\n       */\n      localValue: {\n        get() {\n          return this.showExtension && this.isEditing\n            ? this.value.replace(`.${this.extension}`, '')\n            : this.value;\n        },\n        set(value) {\n          const newValue = this.extension\n            ? `${value}.${this.extension}`\n            : value;\n\n          this.$emit('input', newValue);\n        },\n      },\n    },\n    methods: {\n      /**\n       * Emit \"cancel\" and \"edit\" correctly to reset the state in the parent.\n       */\n      onCancel() {\n        this.$emit('cancel', this.originalValue);\n        this.$emit('edit', false);\n      },\n      /**\n       * Set btnsDisable to `true` and emit \"delete\" to the parent.\n       */\n      onDelete() {\n        this.$emit('delete');\n      },\n      /**\n       * Emit up to the parent and wait for the prop to change. If the default slot for the edit mode is being used, we focus on the input.\n       */\n      onEdit() {\n        this.$emit('edit', true);\n\n        this.$nextTick(() => {\n          // need to test b/c of jest timing issues I can't pinpoint as well.\n          if (this.$slots.default || !this.$refs.input) {\n            return;\n          }\n\n          this.$refs.input.$el.querySelector('input').focus();\n        });\n      },\n      /**\n       * Emit \"save\" with the correct value/extension only if any of the disabled states aren't true. We also want to update \"originalValue\" since this component is not destroyed.\n       */\n      onSave() {\n        if (this.btnsDisabled || this.btnSaveDisabled) {\n          return;\n        }\n\n        const newValue = this.showExtension && this.isEditing\n          ? `${this.localValue}.${this.extension}`\n          : this.localValue;\n        this.originalValue = newValue;\n\n        this.$emit('save', newValue);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .el-form-item {\n    margin: 0;\n  }\n\n  ::v-deep {\n    .el-form-item__content {\n      display: flex;\n    }\n\n    .el-input-group__append {\n      background-color: $tf-extra-light-gray-2;\n      border: {\n        top-right-radius: 2px;\n        bottom-right-radius: 2px;\n      }\n    }\n  }\n\n  .btn-group.align-end {\n    margin-left: 15px;\n\n    // Long term, this should be replaced in the button component scoped styles.\n    .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n    .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n      margin-left: 4px;\n    }\n  }\n\n  span {\n    box-sizing: border-box;\n    display: flex;\n    flex: 1;\n    align-items: center;\n    transition: all .5s;\n    min-height: 30px;\n    border: 1px solid transparent;\n    border-radius: 2px;\n    line-height: 26px;\n  }\n\n  .tf-button.btn-delete,\n  .wt-button.btn-delete {\n    margin-top: 3px;\n  }\n\n  .btn-edit {\n    opacity: 0;\n    transition: all .5s;\n  }\n\n  .container {\n    &-editing {\n      display: flex;\n      flex-direction: column;\n    }\n\n    &-readonly {\n      display: flex;\n\n      &:hover,\n      &.is-hovering {\n        .btn-edit {\n          opacity: 1;\n        }\n\n        .faux-input {\n          padding: 0 15px;\n          border-color: $tf-light-gray;\n          background: $tf-white;\n        }\n      }\n    }\n  }\n\n  .faux-input {\n    border: 1px solid transparent;\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    > span {\n      display: block;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n\n  .tf-inline-form-field,\n  .wt-inline-form-field {\n    width: 100%;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$d = "data-v-40486366";
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    browser,
    undefined,
    undefined
  );

// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperties: _objectDps });

var f$4 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols



var Reflect = _global.Reflect;
var _ownKeys = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = _objectGopn.f(_anObject(it));
  var getSymbols = _objectGops.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// https://github.com/tc39/proposal-object-getownpropertydescriptors






_export(_export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = _toIobject(object);
    var getDesc = _objectGopd.f;
    var keys = _ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) _createProperty(result, key, desc);
    }
    return result;
  }
});

var $forEach = _arrayMethods(0);
var STRICT = _strictMethod([].forEach, true);

_export(_export.P + _export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

var $filter = _arrayMethods(2);

_export(_export.P + _export.F * !_strictMethod([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var _global$1 = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core$1 = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1$1 = _core$1.version;

var _aFunction$1 = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx$1 = function (fn, that, length) {
  _aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject$1 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject$1 = function (it) {
  if (!_isObject$1(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails$1 = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors$1 = !_fails$1(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$3 = _global$1.document;
// typeof document.createElement is 'object' in old IE
var is$1 = _isObject$1(document$3) && _isObject$1(document$3.createElement);
var _domCreate$1 = function (it) {
  return is$1 ? document$3.createElement(it) : {};
};

var _ie8DomDefine$1 = !_descriptors$1 && !_fails$1(function () {
  return Object.defineProperty(_domCreate$1('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive$1 = function (it, S) {
  if (!_isObject$1(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject$1(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP$2 = Object.defineProperty;

var f$5 = _descriptors$1 ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject$1(O);
  P = _toPrimitive$1(P, true);
  _anObject$1(Attributes);
  if (_ie8DomDefine$1) try {
    return dP$2(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp$1 = {
	f: f$5
};

var _propertyDesc$1 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide$1 = _descriptors$1 ? function (object, key, value) {
  return _objectDp$1.f(object, key, _propertyDesc$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;
var _has$1 = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE$2 = 'prototype';

var $export$1 = function (type, name, source) {
  var IS_FORCED = type & $export$1.F;
  var IS_GLOBAL = type & $export$1.G;
  var IS_STATIC = type & $export$1.S;
  var IS_PROTO = type & $export$1.P;
  var IS_BIND = type & $export$1.B;
  var IS_WRAP = type & $export$1.W;
  var exports = IS_GLOBAL ? _core$1 : _core$1[name] || (_core$1[name] = {});
  var expProto = exports[PROTOTYPE$2];
  var target = IS_GLOBAL ? _global$1 : IS_STATIC ? _global$1[name] : (_global$1[name] || {})[PROTOTYPE$2];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has$1(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx$1(out, _global$1)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE$2] = C[PROTOTYPE$2];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx$1(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export$1.R && expProto && !expProto[key]) _hide$1(expProto, key, out);
    }
  }
};
// type bitmap
$export$1.F = 1;   // forced
$export$1.G = 2;   // global
$export$1.S = 4;   // static
$export$1.P = 8;   // proto
$export$1.B = 16;  // bind
$export$1.W = 32;  // wrap
$export$1.U = 64;  // safe
$export$1.R = 128; // real proto method for `library`
var _export$1 = $export$1;

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export$1(_export$1.S + _export$1.F * !_descriptors$1, 'Object', { defineProperty: _objectDp$1.f });

var $Object = _core$1.Object;
var defineProperty$1 = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$2 = defineProperty$1;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    defineProperty$2(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfFormBuilder is a component that is fed a nested array of form items and an object model. The form items array should be arranged in a format of `{Array<Array<Object>>}`. Where each first level of the index is a row in the template and each object is a column in that row. The form items should also contain any rules that are validated on blur.
 *
 * @vuedoc
 * @exports TfForm/TfFormBuilder
 * @category components
 */
var script$e = {
  name: 'TfFormBuilder',
  props: {
    formItems: {
      type: Array,
      required: true
    },
    isLoaded: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Validate the field and emit $blur, which should include the prop and its validity.
     *
     * @param {string} prop
     */
    onBlur: function onBlur(prop) {
      var isValid = true;
      this.$refs.form.validateField(prop, function (error) {
        isValid = !error;
      });
      this.$emit('blur', {
        isValid: isValid,
        prop: prop
      });
    },

    /**
     * Clone the model, mutate the appropriate prop, $emit and clear any validation.
     *
     * @param {string} prop
     * @param {number | string} value
     */
    onInput: function onInput(prop, value) {
      var newValue = _objectSpread(_objectSpread({}, this.value), {}, _defineProperty({}, prop, value));

      this.$emit('input', newValue);
      this.$refs.form.clearValidate(prop);
    },

    /**
     * Validate the form and $emit 'submit' to the parent if passing when a user hits the ENTER key on an input. The parent component handles the logic for validating and submitting each of the detail sections holistically.
     */
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return;
        }

        _this.$emit('submit');
      });
    }
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-form",
    _vm._b(
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: !_vm.isLoaded,
            expression: "!isLoaded"
          }
        ],
        ref: "form",
        attrs: { "label-position": "top" }
      },
      "tf-form",
      { model: _vm.value },
      false
    ),
    _vm._l(_vm.formItems, function(formItemRow, index) {
      return _c(
        "div",
        { key: index, staticClass: "form-group" },
        _vm._l(formItemRow, function(formItem) {
          return _c(
            "tf-form-item",
            _vm._b(
              {
                key: formItem.props.prop,
                style: { width: formItem.width },
                attrs: { size: "medium" }
              },
              "tf-form-item",
              Object.assign({}, formItem.props, { rules: formItem.rules }),
              false
            ),
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _vm._t(
                    "label",
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(formItem.props.label) +
                          "\n        "
                      )
                    ],
                    null,
                    { prop: formItem.props.prop }
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm._t(
                "formElement",
                [
                  ["text", "number", "textarea"].includes(formItem.props.type)
                    ? _c(
                        "tf-input",
                        _vm._b(
                          {
                            on: {
                              blur: function($event) {
                                return _vm.onBlur(formItem.props.prop)
                              },
                              input: function($event) {
                                return _vm.onInput(formItem.props.prop, $event)
                              }
                            },
                            nativeOn: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onSubmit($event)
                              }
                            }
                          },
                          "tf-input",
                          Object.assign({}, formItem.props, {
                            disabled: _vm.isSaving || formItem.props.disabled,
                            value: _vm.value[formItem.props.prop]
                          }),
                          false
                        )
                      )
                    : formItem.props.type === "date"
                    ? _c(
                        "tf-datepicker",
                        _vm._b(
                          {
                            on: {
                              input: function($event) {
                                return _vm.onInput(formItem.props.prop, $event)
                              },
                              blur: function($event) {
                                return _vm.onBlur(formItem.props.prop)
                              }
                            }
                          },
                          "tf-datepicker",
                          Object.assign({}, formItem.props, {
                            disabled: _vm.isSaving || formItem.props.disabled,
                            value: _vm.value[formItem.props.prop]
                          }),
                          false
                        )
                      )
                    : formItem.props.type === "select"
                    ? _c(
                        "tf-input-with-options",
                        _vm._b(
                          {
                            on: {
                              blur: function($event) {
                                return _vm.onBlur(formItem.props.prop)
                              },
                              input: function($event) {
                                return _vm.onInput(formItem.props.prop, $event)
                              }
                            }
                          },
                          "tf-input-with-options",
                          Object.assign({}, formItem.props, {
                            disabled: _vm.isSaving || formItem.props.disabled,
                            value: _vm.value[formItem.props.prop]
                          }),
                          false
                        )
                      )
                    : formItem.props.type === "switch"
                    ? _c(
                        "el-switch",
                        _vm._b(
                          {
                            class: { "is-inline": formItem.isInline },
                            on: {
                              change: function($event) {
                                return _vm.$emit("switchChange", {
                                  prop: formItem.props.prop,
                                  value: $event
                                })
                              },
                              input: function($event) {
                                return _vm.onInput(formItem.props.prop, $event)
                              }
                            }
                          },
                          "el-switch",
                          Object.assign({}, formItem.props, {
                            disabled: _vm.isSaving || formItem.props.disabled,
                            value: _vm.value[formItem.props.prop]
                          }),
                          false
                        )
                      )
                    : _vm._e()
                ],
                null,
                { formItem: formItem }
              )
            ],
            2
          )
        }),
        1
      )
    }),
    0
  )
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = function (inject) {
    if (!inject) return
    inject("data-v-3890e8e0_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.form-group[data-v-3890e8e0] {\n  display: flex;\n  margin: 0 -12px;\n}\n[data-v-3890e8e0] .el-form,[data-v-3890e8e0] .el-form-item {\n  width: 100%;\n}\n[data-v-3890e8e0] .el-form-item {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n[data-v-3890e8e0] .el-form-item__error {\n  position: relative;\n}\n[data-v-3890e8e0] .el-form-item > .el-form-item__label {\n  line-height: 40px;\n}\n[data-v-3890e8e0] .el-select {\n  display: inline-block;\n}\n[data-v-3890e8e0] .el-switch.is-inline {\n  height: 40px;\n}\n[data-v-3890e8e0] .el-switch:not(.is-inline) {\n  width: 100%;\n}\n[data-v-3890e8e0] .el-textarea__inner {\n  resize: none;\n}\n[data-v-3890e8e0] .vdp-datepicker {\n  display: block;\n  z-index: 100;\n}\n[data-v-3890e8e0] .vdp-datepicker,[data-v-3890e8e0] .vdp-datepicker input {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfFormBuilder.vue.map */", map: {"version":3,"sources":["TfFormBuilder.vue","/home/circleci/repo/src/components/TfForm/TfFormBuilder.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC6JpC;EACA,aAAA;EACA,eAAA;AD3JA;ACgKA;EAEA,WAAA;AD9JA;ACiKA;EAEA,iBAAA;EACA,kBAAA;ADhKA;ACmKA;EACA,kBAAA;ADjKA;ACoKA;EACA,iBAAA;ADlKA;ACuKA;EACA,qBAAA;ADrKA;ACyKA;EACA,YAAA;ADvKA;AC0KA;EACA,WAAA;ADxKA;AC4KA;EACA,YAAA;AD1KA;AC6KA;EACA,cAAA;EACA,YAAA;AD3KA;AC6KA;EAEA,WAAA;AD3KA;;AAEA,4CAA4C","file":"TfFormBuilder.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.form-group {\n  display: flex;\n  margin: 0 -12px;\n}\n\n::v-deep .el-form, ::v-deep .el-form-item {\n  width: 100%;\n}\n::v-deep .el-form-item {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n::v-deep .el-form-item__error {\n  position: relative;\n}\n::v-deep .el-form-item > .el-form-item__label {\n  line-height: 40px;\n}\n::v-deep .el-select {\n  display: inline-block;\n}\n::v-deep .el-switch.is-inline {\n  height: 40px;\n}\n::v-deep .el-switch:not(.is-inline) {\n  width: 100%;\n}\n::v-deep .el-textarea__inner {\n  resize: none;\n}\n::v-deep .vdp-datepicker {\n  display: block;\n  z-index: 100;\n}\n::v-deep .vdp-datepicker,\n::v-deep .vdp-datepicker input {\n  width: 100%;\n}\n\n/*# sourceMappingURL=TfFormBuilder.vue.map */","<template>\n  <tf-form\n    ref=\"form\"\n    v-bind=\"{ model: value }\"\n    v-loading=\"!isLoaded\"\n    label-position=\"top\"\n  >\n    <div\n      v-for=\"(formItemRow, index) in formItems\"\n      :key=\"index\"\n      class=\"form-group\"\n    >\n      <tf-form-item\n        v-for=\"formItem in formItemRow\"\n        :key=\"formItem.props.prop\"\n        v-bind=\"{\n          ...formItem.props,\n          rules: formItem.rules,\n        }\"\n        :style=\"{ width: formItem.width }\"\n        size=\"medium\"\n      >\n        <template slot=\"label\">\n          <slot\n            name=\"label\"\n            v-bind=\"{ prop: formItem.props.prop }\"\n          >\n            {{ formItem.props.label }}\n          </slot>\n        </template>\n        <slot\n          name=\"formElement\"\n          v-bind=\"{ formItem }\"\n        >\n          <tf-input\n            v-if=\"[\n              'text',\n              'number',\n              'textarea',\n            ].includes(formItem.props.type)\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            @blur=\"onBlur(formItem.props.prop)\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n            @keydown.native.enter=\"onSubmit\"\n          />\n          <tf-datepicker\n            v-else-if=\"formItem.props.type === 'date'\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n            @blur=\"onBlur(formItem.props.prop)\"\n          />\n          <tf-input-with-options\n            v-else-if=\"formItem.props.type === 'select'\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            @blur=\"onBlur(formItem.props.prop)\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n          />\n          <el-switch\n            v-else-if=\"formItem.props.type === 'switch'\"\n            v-bind=\"{\n              ...formItem.props,\n              disabled: isSaving || formItem.props.disabled,\n              value: value[formItem.props.prop],\n            }\"\n            :class=\"{ 'is-inline': formItem.isInline }\"\n            @change=\"$emit('switchChange', { prop: formItem.props.prop, value: $event })\"\n            @input=\"onInput(formItem.props.prop, $event)\"\n          />\n        </slot>\n      </tf-form-item>\n    </div>\n  </tf-form>\n</template>\n\n<script>\n  /**\n   * TfFormBuilder is a component that is fed a nested array of form items and an object model. The form items array should be arranged in a format of `{Array<Array<Object>>}`. Where each first level of the index is a row in the template and each object is a column in that row. The form items should also contain any rules that are validated on blur.\n   *\n   * @vuedoc\n   * @exports TfForm/TfFormBuilder\n   * @category components\n   */\n  export default {\n    name: 'TfFormBuilder',\n    props: {\n      formItems: {\n        type: Array,\n        required: true,\n      },\n      isLoaded: {\n        type: Boolean,\n        default: false,\n      },\n      isSaving: {\n        type: Boolean,\n        default: false,\n      },\n      value: {\n        type: Object,\n        required: true,\n      },\n    },\n    methods: {\n      /**\n       * Validate the field and emit $blur, which should include the prop and its validity.\n       *\n       * @param {string} prop\n       */\n      onBlur(prop) {\n        let isValid = true;\n\n        this.$refs.form.validateField(prop, (error) => {\n          isValid = !error;\n        });\n\n        this.$emit('blur', { isValid, prop });\n      },\n      /**\n       * Clone the model, mutate the appropriate prop, $emit and clear any validation.\n       *\n       * @param {string} prop\n       * @param {number | string} value\n       */\n      onInput(prop, value) {\n        const newValue = {\n          ...this.value,\n          [prop]: value,\n        };\n        this.$emit('input', newValue);\n        this.$refs.form.clearValidate(prop);\n      },\n      /**\n       * Validate the form and $emit 'submit' to the parent if passing when a user hits the ENTER key on an input. The parent component handles the logic for validating and submitting each of the detail sections holistically.\n       */\n      onSubmit() {\n        this.$refs.form.validate((valid) => {\n          if (!valid) {\n            return;\n          }\n\n          this.$emit('submit');\n        });\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .form-group {\n    display: flex;\n    margin: 0 (-$tf-form-half-gutter);\n  }\n\n  ::v-deep {\n    .el-form {\n      &,\n      &-item {\n        width: 100%;\n      }\n\n      &-item {\n        margin: {\n          left: $tf-form-half-gutter;\n          right: $tf-form-half-gutter;\n        }\n\n        &__error {\n          position: relative;\n        }\n\n        > .el-form-item__label {\n          line-height: 40px;\n        }\n      }\n    }\n\n    .el-select {\n      display: inline-block;\n    }\n\n    .el-switch {\n      &.is-inline {\n        height: 40px;\n      }\n\n      &:not(.is-inline) {\n        width: 100%;\n      }\n    }\n\n    .el-textarea__inner {\n      resize: none;\n    }\n\n    .vdp-datepicker {\n      display: block;\n      z-index: 100;\n\n      &,\n      input {\n        width: 100%;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$e = "data-v-3890e8e0";
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    browser,
    undefined,
    undefined
  );

var toString$2 = {}.toString;

var _cof$1 = function (it) {
  return toString$2.call(it).slice(8, -1);
};

// 7.2.2 IsArray(argument)

var _isArray$1 = Array.isArray || function isArray(arg) {
  return _cof$1(arg) == 'Array';
};

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


_export$1(_export$1.S, 'Array', { isArray: _isArray$1 });

var isArray$1 = _core$1.Array.isArray;

var isArray$2 = isArray$1;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (isArray$2(arr)) return _arrayLikeToArray(arr);
}

var _redefine$1 = _hide$1;

var id$1 = 0;
var px$1 = Math.random();
var _uid$1 = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$1 + px$1).toString(36));
};

var _meta = createCommonjsModule(function (module) {
var META = _uid$1('meta');


var setDesc = _objectDp$1.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails$1(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has$1(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has$1(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has$1(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var _library$1 = true;

var _shared$1 = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global$1[SHARED] || (_global$1[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core$1.version,
  mode:  'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var _wks$1 = createCommonjsModule(function (module) {
var store = _shared$1('wks');

var Symbol = _global$1.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid$1)('Symbol.' + name));
};

$exports.store = store;
});

var def$1 = _objectDp$1.f;

var TAG$2 = _wks$1('toStringTag');

var _setToStringTag$1 = function (it, tag, stat) {
  if (it && !_has$1(it = stat ? it : it.prototype, TAG$2)) def$1(it, TAG$2, { configurable: true, value: tag });
};

var f$6 = _wks$1;

var _wksExt = {
	f: f$6
};

var defineProperty$3 = _objectDp$1.f;
var _wksDefine = function (name) {
  var $Symbol = _core$1.Symbol || (_core$1.Symbol =  {} );
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$3($Symbol, name, { value: _wksExt.f(name) });
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject$1 = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof$1(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined$1 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject$1 = function (it) {
  return _iobject$1(_defined$1(it));
};

// 7.1.4 ToInteger
var ceil$1 = Math.ceil;
var floor$2 = Math.floor;
var _toInteger$1 = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor$2 : ceil$1)(it);
};

// 7.1.15 ToLength

var min$3 = Math.min;
var _toLength$1 = function (it) {
  return it > 0 ? min$3(_toInteger$1(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max$2 = Math.max;
var min$4 = Math.min;
var _toAbsoluteIndex$1 = function (index, length) {
  index = _toInteger$1(index);
  return index < 0 ? max$2(index + length, 0) : min$4(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject$1($this);
    var length = _toLength$1(O.length);
    var index = _toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var shared$1 = _shared$1('keys');

var _sharedKey$1 = function (key) {
  return shared$1[key] || (shared$1[key] = _uid$1(key));
};

var arrayIndexOf$1 = _arrayIncludes$1(false);
var IE_PROTO$3 = _sharedKey$1('IE_PROTO');

var _objectKeysInternal$1 = function (object, names) {
  var O = _toIobject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$3) _has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has$1(O, key = names[i++])) {
    ~arrayIndexOf$1(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys$1 = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys$1 = Object.keys || function keys(O) {
  return _objectKeysInternal$1(O, _enumBugKeys$1);
};

var f$7 = Object.getOwnPropertySymbols;

var _objectGops$1 = {
	f: f$7
};

var f$8 = {}.propertyIsEnumerable;

var _objectPie$1 = {
	f: f$8
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys$1(it);
  var getSymbols = _objectGops$1.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie$1.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.1.13 ToObject(argument)

var _toObject$1 = function (it) {
  return Object(_defined$1(it));
};

var _objectDps$1 = _descriptors$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject$1(O);
  var keys = _objectKeys$1(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp$1.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$4 = _global$1.document;
var _html$1 = document$4 && document$4.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$4 = _sharedKey$1('IE_PROTO');
var Empty$1 = function () { /* empty */ };
var PROTOTYPE$3 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict$1 = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate$1('iframe');
  var i = _enumBugKeys$1.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html$1.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict$1 = iframeDocument.F;
  while (i--) delete createDict$1[PROTOTYPE$3][_enumBugKeys$1[i]];
  return createDict$1();
};

var _objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty$1[PROTOTYPE$3] = _anObject$1(O);
    result = new Empty$1();
    Empty$1[PROTOTYPE$3] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$4] = O;
  } else result = createDict$1();
  return Properties === undefined ? result : _objectDps$1(result, Properties);
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys$1 = _enumBugKeys$1.concat('length', 'prototype');

var f$9 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal$1(O, hiddenKeys$1);
};

var _objectGopn$1 = {
	f: f$9
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN$1 = _objectGopn$1.f;
var toString$3 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN$1(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$a = function getOwnPropertyNames(it) {
  return windowNames && toString$3.call(it) == '[object Window]' ? getWindowNames(it) : gOPN$1(_toIobject$1(it));
};

var _objectGopnExt = {
	f: f$a
};

var gOPD$2 = Object.getOwnPropertyDescriptor;

var f$b = _descriptors$1 ? gOPD$2 : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject$1(O);
  P = _toPrimitive$1(P, true);
  if (_ie8DomDefine$1) try {
    return gOPD$2(O, P);
  } catch (e) { /* empty */ }
  if (_has$1(O, P)) return _propertyDesc$1(!_objectPie$1.f.call(O, P), O[P]);
};

var _objectGopd$1 = {
	f: f$b
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;





















var gOPD$3 = _objectGopd$1.f;
var dP$3 = _objectDp$1.f;
var gOPN$2 = _objectGopnExt.f;
var $Symbol = _global$1.Symbol;
var $JSON = _global$1.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$4 = 'prototype';
var HIDDEN = _wks$1('_hidden');
var TO_PRIMITIVE = _wks$1('toPrimitive');
var isEnum$1 = {}.propertyIsEnumerable;
var SymbolRegistry = _shared$1('symbol-registry');
var AllSymbols = _shared$1('symbols');
var OPSymbols = _shared$1('op-symbols');
var ObjectProto$1 = Object[PROTOTYPE$4];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops$1.f;
var QObject = _global$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$4] || !QObject[PROTOTYPE$4].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors$1 && _fails$1(function () {
  return _objectCreate$1(dP$3({}, 'a', {
    get: function () { return dP$3(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$3(ObjectProto$1, key);
  if (protoDesc) delete ObjectProto$1[key];
  dP$3(it, key, D);
  if (protoDesc && it !== ObjectProto$1) dP$3(ObjectProto$1, key, protoDesc);
} : dP$3;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate$1($Symbol[PROTOTYPE$4]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
  _anObject$1(it);
  key = _toPrimitive$1(key, true);
  _anObject$1(D);
  if (_has$1(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has$1(it, HIDDEN)) dP$3(it, HIDDEN, _propertyDesc$1(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has$1(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate$1(D, { enumerable: _propertyDesc$1(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$3(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject$1(it);
  var keys = _enumKeys(P = _toIobject$1(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate$1(it) : $defineProperties(_objectCreate$1(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum$1.call(this, key = _toPrimitive$1(key, true));
  if (this === ObjectProto$1 && _has$1(AllSymbols, key) && !_has$1(OPSymbols, key)) return false;
  return E || !_has$1(this, key) || !_has$1(AllSymbols, key) || _has$1(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject$1(it);
  key = _toPrimitive$1(key, true);
  if (it === ObjectProto$1 && _has$1(AllSymbols, key) && !_has$1(OPSymbols, key)) return;
  var D = gOPD$3(it, key);
  if (D && _has$1(AllSymbols, key) && !(_has$1(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$2(_toIobject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has$1(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$1;
  var names = gOPN$2(IS_OP ? OPSymbols : _toIobject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has$1(AllSymbols, key = names[i++]) && (IS_OP ? _has$1(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid$1(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto$1) $set.call(OPSymbols, value);
      if (_has$1(this, HIDDEN) && _has$1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc$1(1, value));
    };
    if (_descriptors$1 && setter) setSymbolDesc(ObjectProto$1, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine$1($Symbol[PROTOTYPE$4], 'toString', function toString() {
    return this._k;
  });

  _objectGopd$1.f = $getOwnPropertyDescriptor;
  _objectDp$1.f = $defineProperty;
  _objectGopn$1.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie$1.f = $propertyIsEnumerable;
  _objectGops$1.f = $getOwnPropertySymbols;

  if (_descriptors$1 && !_library$1) {
    _redefine$1(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks$1(name));
  };
}

_export$1(_export$1.G + _export$1.W + _export$1.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j$1 = 0; es6Symbols.length > j$1;)_wks$1(es6Symbols[j$1++]);

for (var wellKnownSymbols = _objectKeys$1(_wks$1.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export$1(_export$1.S + _export$1.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has$1(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export$1(_export$1.S + _export$1.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = _fails$1(function () { _objectGops$1.f(1); });

_export$1(_export$1.S + _export$1.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops$1.f(_toObject$1(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export$1(_export$1.S + _export$1.F * (!USE_NATIVE || _fails$1(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject$1(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray$1(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$4][TO_PRIMITIVE] || _hide$1($Symbol[PROTOTYPE$4], TO_PRIMITIVE, $Symbol[PROTOTYPE$4].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag$1($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag$1(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag$1(_global$1.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core$1.Symbol;

var symbol$1 = symbol;

// true  -> String#at
// false -> String#codePointAt
var _stringAt$1 = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined$1(that));
    var i = _toInteger$1(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _iterators$1 = {};

var IteratorPrototype$1 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide$1(IteratorPrototype$1, _wks$1('iterator'), function () { return this; });

var _iterCreate$1 = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate$1(IteratorPrototype$1, { next: _propertyDesc$1(1, next) });
  _setToStringTag$1(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$5 = _sharedKey$1('IE_PROTO');
var ObjectProto$2 = Object.prototype;

var _objectGpo$1 = Object.getPrototypeOf || function (O) {
  O = _toObject$1(O);
  if (_has$1(O, IE_PROTO$5)) return O[IE_PROTO$5];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$2 : null;
};

var ITERATOR$2 = _wks$1('iterator');
var BUGGY$1 = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR$1 = '@@iterator';
var KEYS$1 = 'keys';
var VALUES$1 = 'values';

var returnThis$1 = function () { return this; };

var _iterDefine$1 = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate$1(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY$1 && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS$1: return function keys() { return new Constructor(this, kind); };
      case VALUES$1: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES$1;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR$2] || proto[FF_ITERATOR$1] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo$1($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag$1(IteratorPrototype, TAG, true);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES$1) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if (( FORCED) && (BUGGY$1 || VALUES_BUG || !proto[ITERATOR$2])) {
    _hide$1(proto, ITERATOR$2, $default);
  }
  // Plug for library
  _iterators$1[NAME] = $default;
  _iterators$1[TAG] = returnThis$1;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES$1),
      keys: IS_SET ? $default : getMethod(KEYS$1),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine$1(proto, key, methods[key]);
    } else _export$1(_export$1.P + _export$1.F * (BUGGY$1 || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt$1(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine$1(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep$1 = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator$1 = _iterDefine$1(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject$1(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep$1(1);
  }
  if (kind == 'keys') return _iterStep$1(0, index);
  if (kind == 'values') return _iterStep$1(0, O[index]);
  return _iterStep$1(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators$1.Arguments = _iterators$1.Array;

var TO_STRING_TAG$1 = _wks$1('toStringTag');

var DOMIterables$1 = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i$1 = 0; i$1 < DOMIterables$1.length; i$1++) {
  var NAME$1 = DOMIterables$1[i$1];
  var Collection$1 = _global$1[NAME$1];
  var proto$2 = Collection$1 && Collection$1.prototype;
  if (proto$2 && !proto$2[TO_STRING_TAG$1]) _hide$1(proto$2, TO_STRING_TAG$1, NAME$1);
  _iterators$1[NAME$1] = _iterators$1.Array;
}

var iterator = _wksExt.f('iterator');

var iterator$1 = iterator;

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject$1(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject$1(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$3 = _wks$1('iterator');
var ArrayProto$1 = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators$1.Array === it || ArrayProto$1[ITERATOR$3] === it);
};

var _createProperty$1 = function (object, index, value) {
  if (index in object) _objectDp$1.f(object, index, _propertyDesc$1(0, value));
  else object[index] = value;
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$3 = _wks$1('toStringTag');
// ES3 wrong here
var ARG$1 = _cof$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet$1 = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof$1 = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet$1(O = Object(it), TAG$3)) == 'string' ? T
    // builtinTag case
    : ARG$1 ? _cof$1(O)
    // ES3 arguments fallback
    : (B = _cof$1(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$4 = _wks$1('iterator');

var core_getIteratorMethod = _core$1.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$4]
    || it['@@iterator']
    || _iterators$1[_classof$1(it)];
};

var ITERATOR$5 = _wks$1('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$5]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$5]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$5] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export$1(_export$1.S + _export$1.F * !_iterDetect(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject$1(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx$1(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty$1(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength$1(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty$1(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var from_1 = _core$1.Array.from;

var from_1$1 = from_1;

function _iterableToArray(iter) {
  if (typeof symbol$1 !== "undefined" && iter[iterator$1] != null || iter["@@iterator"] != null) return from_1$1(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return from_1$1(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var _arrayReduce = function (that, callbackfn, aLen, memo, isRight) {
  _aFunction(callbackfn);
  var O = _toObject(that);
  var self = _iobject(O);
  var length = _toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

_export(_export.P + _export.F * !_strictMethod([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return _arrayReduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


_export(_export.S, 'Array', { isArray: _isArray });

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * A component made to build out a list of the TfInputWithOptions component. The options are required to be in a [{ label, value }] format and the model is a flat array of strings/numbers, both of which are provided as props from the parent.
 * This component will also validate the inputs based on the rules that are passed and clear validation on @input. If the on blur on TfInputWithOptions has a violation, $emit('blur') will not happen.
 *
 * @vuedoc
 * @exports TfForm/FormList
 * @category components
 */
var script$f = {
  name: 'TfFormList',
  props: {
    /**
     * Render the "Add another" CTA in the template.
     */
    allowAddAnother: {
      type: Boolean,
      default: true
    },

    /**
     * Allow all form items to be deleted even if it's the last one left
     */
    allowDeleteFirst: {
      type: Boolean,
      default: false
    },

    /**
     * Allow multiple options to be the value. ['option 1', 'option 1']
     */
    allowDuplicates: {
      type: Boolean,
      default: false
    },

    /**
     * If there is only one form item left, disable the delete button
     */
    disableDeleteFirst: {
      type: Boolean,
      default: false
    },

    /**
     * Pass "groupDisabled" as true to group any option that has `isDisabled: true` to a "disabledOptions" array.
     * This combined with `showUsedAsDisabled: true` will group any used values to a "disabledOptions" array.
     */
    groupDisabled: {
      type: Boolean,
      default: false
    },

    /**
     * "groupedDisabledOptionsTitle" will render a title above the list of disabled values in the tfInputWithOptions component.
     */
    groupedDisabledOptionsTitle: {
      type: String,
      default: 'Used values'
    },

    /**
     * An array of values that the Delete CTA should be hidden for
     */
    hideDeleteForValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Disable all interactions in the template.
     */
    isDisabled: {
      type: Boolean,
      default: false
    },

    /**
     * Render only the first label in the template.
     */
    isSingleLabel: {
      type: Boolean,
      default: true
    },

    /**
     * Render custom label string in the template.
     */
    label: {
      type: String,
      default: ''
    },

    /**
     * Render no branding colors template.
     */
    noBranding: {
      type: Boolean,
      default: false
    },

    /**
     * Render the options to choose from in the template.
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(options) {
        return options.every(function (_ref) {
          var label = _ref.label,
              value = _ref.value;
          return value && label;
        });
      }
    },

    /**
     * Render custom placeholder string in the template.
     */
    placeholder: {
      type: String,
      default: 'Select from list or start typing'
    },

    /**
     * An array of values that should not be editable
     */
    readonlyValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Form rules applied to the form items in the template.
     */
    rules: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },

    /**
     * Pass "showUsedAsDisabled" as true to render a list of the used values in the tfInputWithOptions component.
     */
    showUsedAsDisabled: {
      type: Boolean,
      default: false
    },

    /**
     * Model
     */
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      invalidIndexes: [],
      replacementArray: []
    };
  },
  computed: {
    /**
     * Evalutate the "groupDisabled", "showUsedAsDisabled", and "options" props to group any disabled options or any used values if "showUsedAsDisabled" is `true`.
     * By default ("groupDisabled" is `false`), this will return an empty array.
     *
     * @returns {Array}
     */
    groupedDisabledOptions: function groupedDisabledOptions() {
      var _this = this;

      if (!this.groupDisabled) {
        return [];
      } // Push the option if isDisabled or if the value is included && showUsedAsDisabled is true.


      return this.options.reduce(function (options, option) {
        return option.isDisabled || _this.showUsedAsDisabled && _this.value.includes(option.value) ? options.concat(option) : options;
      }, []);
    },

    /**
     * Evaluate the "allowDuplicates", "showUsedAsDisabled", and "groupDisabled" props to determine if the options should include all or filtered values based on different criteria.
     * "allowDuplicates" will return all options
     * "showUsedAsDisabled" will create a new options array that includes used values in a disabled state, unless "groupDisabled" is `true`, to which they are then excluded.
     * "groupDisabled" will create a new options array that excludes any options with `isDisabled: true` or any used values if "showUsedAsDisabled" is `true`.
     *
     * @returns {Array}
     */
    formListOptions: function formListOptions() {
      var _this2 = this;

      if (this.allowDuplicates) {
        return this.options;
      }

      if (this.showUsedAsDisabled || this.groupDisabled) {
        return this.options.reduce(function (options, option) {
          // Ignore any included or disabled if groupDisabled.
          if (_this2.groupDisabled && (_this2.value.includes(option.value) || option.isDisabled)) {
            return options;
          }

          return options.concat(_objectSpread$1(_objectSpread$1({}, option), {}, {
            isDisabled: _this2.value.includes(option.value) || option.isDisabled || false
          }));
        }, []);
      }

      return this.options.filter(function (_ref2) {
        var value = _ref2.value;
        return !_this2.value.includes(value);
      });
    }
  },
  watch: {
    /**
     * Watch for changes in "disabledOptions" to emit any synced data.
     *
     * @param {Array} newValue
     */
    disabledOptions: function disabledOptions(newValue) {
      this.$emit('update:disabledOptions', newValue);
    },

    /**
     * Watch for changes in "formListOptions" to emit any synced data.
     *
     * @param {Array} newValue
     */
    formListOptions: function formListOptions(newValue) {
      this.$emit('update:formListOptions', newValue);
    }
  },
  created: function created() {
    if (!this.value.length) {
      this.addFormItem();
      return;
    }

    this.$set(this, 'replacementArray', _toConsumableArray(this.value));
  },
  methods: {
    /**
     * Add an empty string to the value and emit to the parent.
     */
    addFormItem: function addFormItem() {
      this.$emit('input', [].concat(_toConsumableArray(this.value), ['']));
      this.replacementArray.push('');
    },

    /**
     * Clear any validation and $emit the new model along with what was deleted.
     *
     * @param {number} index
     */
    deleteInput: function deleteInput(index) {
      var deletedValue = this.value[index];

      var newValue = _toConsumableArray(this.value);

      this.$refs.form.clearValidate("listItems.".concat(index));
      newValue.splice(index, 1);
      this.$emit('deleted', {
        index: index,
        value: deletedValue
      });
      this.$emit('input', newValue);
    },

    /**
     * Validate the form input and $emit 'blur' with the appropriate data for the parent.
     *
     * @param {number} index
     */
    onBlur: function onBlur(index) {
      var isValid = true;
      this.$refs.form.validateField("listItems.".concat(index), function (error) {
        isValid = !error;
      });
      var value = this.value[index];
      var replacementValue = this.replacementArray[index];
      this.$set(this, 'replacementArray', this.value);
      this.$emit('blur', {
        index: index,
        isValid: isValid,
        replaced: replacementValue !== '' && replacementValue !== value ? replacementValue : null,
        value: value
      });
    },

    /**
     * Clone the value prop and $emit new value to parent.
     *
     * @param {number} index
     * @param {number} value
     */
    onInput: function onInput(index, value) {
      this.$refs.form.clearValidate("listItems.".concat(index));

      var newValue = _toConsumableArray(this.value);

      newValue[index] = value;
      this.$emit('input', newValue);
    }
  }
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "section",
    [
      _c(
        "tf-form",
        { ref: "form", attrs: { model: { listItems: _vm.value } } },
        [
          !_vm.value.length
            ? _c(
                "tf-form-item",
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _vm._t("label", [
                        _vm._v(
                          "\n          " + _vm._s(_vm.label) + "\n        "
                        )
                      ])
                    ],
                    2
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "transition-group",
            { attrs: { name: "slide-in-fade" } },
            _vm._l(_vm.value, function(formItem, index) {
              return _c(
                "div",
                {
                  key: "form-" + index,
                  class: [
                    { "is-hidden-label": _vm.isSingleLabel && index },
                    "form-list-item"
                  ]
                },
                [
                  _c(
                    "tf-form-item",
                    _vm._b(
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "error",
                              fn: function(ref) {
                                var error = ref.error;
                                return _c(
                                  "div",
                                  { staticClass: "el-form-item__error" },
                                  [
                                    _vm._t(
                                      "error",
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(error) +
                                            "\n            "
                                        )
                                      ],
                                      null,
                                      { error: error }
                                    )
                                  ],
                                  2
                                )
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      "tf-form-item",
                      {
                        prop: "listItems." + index,
                        rules: _vm.rules
                      },
                      false
                    ),
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._t(
                            "label",
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.label) +
                                  "\n            "
                              )
                            ],
                            null,
                            { index: index }
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._v(" "),
                      _c(
                        "tf-input-with-options",
                        _vm._b(
                          {
                            attrs: { "data-test-input-with-options": "" },
                            on: {
                              blur: function($event) {
                                return _vm.onBlur(index)
                              },
                              input: function($event) {
                                return _vm.onInput(index, $event)
                              }
                            }
                          },
                          "tf-input-with-options",
                          {
                            allowEnter: false,
                            disabled:
                              _vm.isDisabled ||
                              (_vm.readonlyValues.length > 0 &&
                                _vm.readonlyValues.includes(formItem)),
                            groupedDisabledOptions: _vm.groupedDisabledOptions,
                            groupedDisabledOptionsTitle:
                              _vm.groupedDisabledOptionsTitle,
                            optionKey: "value",
                            optionLabel: "label",
                            options: _vm.formListOptions,
                            placeholder: _vm.placeholder,
                            value: _vm.value[index]
                          },
                          false
                        )
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  (!_vm.hideDeleteForValues.length &&
                    (_vm.allowDeleteFirst || _vm.value.length > 1)) ||
                  (_vm.hideDeleteForValues.length &&
                    !_vm.hideDeleteForValues.includes(formItem))
                    ? _c(
                        "div",
                        { staticClass: "container-btn-group" },
                        [
                          _c(
                            "tf-button",
                            _vm._b(
                              {
                                attrs: {
                                  "data-test-btn-delete": "",
                                  icon: "trash-alt",
                                  size: "icon-no-fill",
                                  type: "decline",
                                  "no-border": ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteInput(index)
                                  }
                                }
                              },
                              "tf-button",
                              {
                                disabled:
                                  _vm.isDisabled ||
                                  (_vm.disableDeleteFirst &&
                                    _vm.value.length === 1),
                                noBranding: _vm.noBranding
                              },
                              false
                            )
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.allowAddAnother
        ? _c(
            "tf-button",
            _vm._b(
              {
                attrs: {
                  "data-test-btn-add": "",
                  type: "primary",
                  size: "text"
                },
                on: { click: _vm.addFormItem }
              },
              "tf-button",
              {
                disabled: _vm.isDisabled,
                noBranding: _vm.noBranding
              },
              false
            ),
            [_vm._t("addAnother", [_vm._v("\n      Add another\n    ")])],
            2
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = function (inject) {
    if (!inject) return
    inject("data-v-8f6fe652_0", { source: ".form-list-item[data-v-8f6fe652] {\n  display: flex;\n}\n.form-list-item[data-v-8f6fe652]  > .el-form-item {\n  flex: 1;\n}\n.form-list-item[data-v-8f6fe652]  .el-select {\n  width: 100%;\n}\n.form-list-item[data-v-8f6fe652]  .el-form-item__label:before {\n  display: none;\n}\n.form-list-item[data-v-8f6fe652]  .el-form-item__error {\n  position: relative;\n}\n.is-hidden-label[data-v-8f6fe652]  .el-form-item__label {\n  display: none;\n}\n.container-btn-group[data-v-8f6fe652] {\n  padding: 38px 0 0 3px;\n}\n.is-hidden-label .container-btn-group[data-v-8f6fe652] {\n  padding-top: 0;\n}\n.plan-design-dropdown-container[data-v-8f6fe652] {\n  width: 100%;\n}\n\n/*\n  I'm commenting this out for now b/c there is a timing issue when deleting a value.\n  There's a fix on https://vuejs.org/v2/guide/transitions.html#List-Move-Transitions,\n  but we don't have the time for that for now.\n*/\n\n/*# sourceMappingURL=TfFormList.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/TfForm/TfFormList.vue","TfFormList.vue"],"names":[],"mappings":"AAsYA;EACA,aAAA;ACrYA;ADwYA;EACA,OAAA;ACtYA;ADyYA;EACA,WAAA;ACvYA;AD2YA;EACA,aAAA;ACzYA;AD4YA;EACA,kBAAA;AC1YA;ADiZA;EACA,aAAA;AC9YA;ADkZA;EACA,qBAAA;AC/YA;ADiZA;EACA,cAAA;AC/YA;ADmZA;EACA,WAAA;AChZA;;ADmZA;;;;CAAA;;AC3YA,yCAAyC","file":"TfFormList.vue","sourcesContent":["<template>\n  <section>\n    <tf-form\n      ref=\"form\"\n      :model=\"{ listItems: value }\"\n    >\n      <!--Still display the label if all form items in the list have been deleted-->\n      <tf-form-item v-if=\"!value.length\">\n        <template slot=\"label\">\n          <slot name=\"label\">\n            {{ label }}\n          </slot>\n        </template>\n      </tf-form-item>\n      <!--Render form items normally if there are any present-->\n      <transition-group name=\"slide-in-fade\">\n        <div\n          v-for=\"(formItem, index) in value\"\n          :key=\"`form-${index}`\"\n          :class=\"[\n            { 'is-hidden-label': isSingleLabel && index },\n            'form-list-item'\n          ]\"\n        >\n          <tf-form-item\n            v-bind=\"{\n              prop: `listItems.${index}`,\n              rules,\n            }\"\n          >\n            <template slot=\"label\">\n              <slot\n                name=\"label\"\n                v-bind=\"{ index }\"\n              >\n                {{ label }}\n              </slot>\n            </template>\n            <!-- Class is required for element's styles -->\n            <div\n              slot=\"error\"\n              slot-scope=\"{ error }\"\n              class=\"el-form-item__error\"\n            >\n              <slot\n                name=\"error\"\n                v-bind=\"{ error }\"\n              >\n                {{ error }}\n              </slot>\n            </div>\n            <tf-input-with-options\n              v-bind=\"{\n                allowEnter: false,\n                disabled: isDisabled ||\n                  (readonlyValues.length > 0 && readonlyValues.includes(formItem)),\n                groupedDisabledOptions,\n                groupedDisabledOptionsTitle,\n                optionKey: 'value',\n                optionLabel: 'label',\n                options: formListOptions,\n                placeholder,\n                value: value[index],\n              }\"\n              data-test-input-with-options\n              @blur=\"onBlur(index)\"\n              @input=\"onInput(index, $event)\"\n            />\n          </tf-form-item>\n          <div\n            v-if=\"\n              !hideDeleteForValues.length && (allowDeleteFirst || value.length > 1)\n                || hideDeleteForValues.length && !hideDeleteForValues.includes(formItem)\"\n            class=\"container-btn-group\"\n          >\n            <tf-button\n              data-test-btn-delete\n              v-bind=\"{\n                disabled: isDisabled || (disableDeleteFirst && value.length === 1),\n                noBranding,\n              }\"\n              icon=\"trash-alt\"\n              size=\"icon-no-fill\"\n              type=\"decline\"\n              no-border\n              @click=\"deleteInput(index)\"\n            />\n          </div>\n        </div>\n      </transition-group>\n    </tf-form>\n    <tf-button\n      v-if=\"allowAddAnother\"\n      data-test-btn-add\n      v-bind=\"{\n        disabled: isDisabled,\n        noBranding,\n      }\"\n      type=\"primary\"\n      size=\"text\"\n      @click=\"addFormItem\"\n    >\n      <slot name=\"addAnother\">\n        Add another\n      </slot>\n    </tf-button>\n  </section>\n</template>\n<script>\n  /**\n   * A component made to build out a list of the TfInputWithOptions component. The options are required to be in a [{ label, value }] format and the model is a flat array of strings/numbers, both of which are provided as props from the parent.\n   * This component will also validate the inputs based on the rules that are passed and clear validation on @input. If the on blur on TfInputWithOptions has a violation, $emit('blur') will not happen.\n   *\n   * @vuedoc\n   * @exports TfForm/FormList\n   * @category components\n   */\n  export default {\n    name: 'TfFormList',\n    props: {\n      /**\n       * Render the \"Add another\" CTA in the template.\n       */\n      allowAddAnother: {\n        type: Boolean,\n        default: true,\n      },\n      /**\n       * Allow all form items to be deleted even if it's the last one left\n       */\n      allowDeleteFirst: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Allow multiple options to be the value. ['option 1', 'option 1']\n       */\n      allowDuplicates: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * If there is only one form item left, disable the delete button\n       */\n      disableDeleteFirst: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Pass \"groupDisabled\" as true to group any option that has `isDisabled: true` to a \"disabledOptions\" array.\n       * This combined with `showUsedAsDisabled: true` will group any used values to a \"disabledOptions\" array.\n       */\n      groupDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * \"groupedDisabledOptionsTitle\" will render a title above the list of disabled values in the tfInputWithOptions component.\n       */\n      groupedDisabledOptionsTitle: {\n        type: String,\n        default: 'Used values',\n      },\n      /**\n       * An array of values that the Delete CTA should be hidden for\n       */\n      hideDeleteForValues: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * Disable all interactions in the template.\n       */\n      isDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Render only the first label in the template.\n       */\n      isSingleLabel: {\n        type: Boolean,\n        default: true,\n      },\n      /**\n       * Render custom label string in the template.\n       */\n      label: {\n        type: String,\n        default: '',\n      },\n      /**\n       * Render no branding colors template.\n       */\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Render the options to choose from in the template.\n       */\n      options: {\n        type: Array,\n        default: () => [],\n        validator: (options) => options.every(({ label, value }) => value && label),\n      },\n      /**\n       * Render custom placeholder string in the template.\n       */\n      placeholder: {\n        type: String,\n        default: 'Select from list or start typing',\n      },\n      /**\n       * An array of values that should not be editable\n       */\n      readonlyValues: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * Form rules applied to the form items in the template.\n       */\n      rules: {\n        type: [Array, Object],\n        default: () => [],\n      },\n      /**\n       * Pass \"showUsedAsDisabled\" as true to render a list of the used values in the tfInputWithOptions component.\n       */\n      showUsedAsDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Model\n       */\n      value: {\n        type: Array,\n        required: true,\n      },\n    },\n    data: () => ({\n      invalidIndexes: [],\n      replacementArray: [],\n    }),\n    computed: {\n      /**\n       * Evalutate the \"groupDisabled\", \"showUsedAsDisabled\", and \"options\" props to group any disabled options or any used values if \"showUsedAsDisabled\" is `true`.\n       * By default (\"groupDisabled\" is `false`), this will return an empty array.\n       *\n       * @returns {Array}\n       */\n      groupedDisabledOptions() {\n        if (!this.groupDisabled) {\n          return [];\n        }\n\n        // Push the option if isDisabled or if the value is included && showUsedAsDisabled is true.\n        return this.options.reduce((options, option) => (\n          option.isDisabled || (this.showUsedAsDisabled && this.value.includes(option.value))\n            ? options.concat(option)\n            : options\n        ), []);\n      },\n      /**\n       * Evaluate the \"allowDuplicates\", \"showUsedAsDisabled\", and \"groupDisabled\" props to determine if the options should include all or filtered values based on different criteria.\n       * \"allowDuplicates\" will return all options\n       * \"showUsedAsDisabled\" will create a new options array that includes used values in a disabled state, unless \"groupDisabled\" is `true`, to which they are then excluded.\n       * \"groupDisabled\" will create a new options array that excludes any options with `isDisabled: true` or any used values if \"showUsedAsDisabled\" is `true`.\n       *\n       * @returns {Array}\n       */\n      formListOptions() {\n        if (this.allowDuplicates) {\n          return this.options;\n        }\n\n        if (this.showUsedAsDisabled || this.groupDisabled) {\n          return this.options.reduce((options, option) => {\n            // Ignore any included or disabled if groupDisabled.\n            if (this.groupDisabled && (this.value.includes(option.value) || option.isDisabled)) {\n              return options;\n            }\n\n            return options.concat({\n              ...option,\n              isDisabled: this.value.includes(option.value) || option.isDisabled || false,\n            });\n          }, []);\n        }\n\n        return this.options.filter(({ value }) => !this.value.includes(value));\n      },\n    },\n    watch: {\n      /**\n       * Watch for changes in \"disabledOptions\" to emit any synced data.\n       *\n       * @param {Array} newValue\n       */\n      disabledOptions(newValue) {\n        this.$emit('update:disabledOptions', newValue);\n      },\n      /**\n       * Watch for changes in \"formListOptions\" to emit any synced data.\n       *\n       * @param {Array} newValue\n       */\n      formListOptions(newValue) {\n        this.$emit('update:formListOptions', newValue);\n      },\n    },\n    created() {\n      if (!this.value.length) {\n        this.addFormItem();\n        return;\n      }\n\n      this.$set(this, 'replacementArray', [...this.value]);\n    },\n    methods: {\n      /**\n       * Add an empty string to the value and emit to the parent.\n       */\n      addFormItem() {\n        this.$emit('input', [...this.value, '']);\n        this.replacementArray.push('');\n      },\n      /**\n       * Clear any validation and $emit the new model along with what was deleted.\n       *\n       * @param {number} index\n       */\n      deleteInput(index) {\n        const deletedValue = this.value[index];\n        const newValue = [...this.value];\n\n        this.$refs.form.clearValidate(`listItems.${index}`);\n\n        newValue.splice(index, 1);\n\n        this.$emit('deleted', { index, value: deletedValue });\n        this.$emit('input', newValue);\n      },\n      /**\n       * Validate the form input and $emit 'blur' with the appropriate data for the parent.\n       *\n       * @param {number} index\n       */\n      onBlur(index) {\n        let isValid = true;\n\n        this.$refs.form.validateField(`listItems.${index}`, (error) => {\n          isValid = !error;\n        });\n\n        const value = this.value[index];\n        const replacementValue = this.replacementArray[index];\n\n        this.$set(this, 'replacementArray', this.value);\n        this.$emit('blur', {\n          index,\n          isValid,\n          replaced: replacementValue !== '' && (replacementValue !== value)\n            ? replacementValue\n            : null,\n          value,\n        });\n      },\n      /**\n       * Clone the value prop and $emit new value to parent.\n       *\n       * @param {number} index\n       * @param {number} value\n       */\n      onInput(index, value) {\n        this.$refs.form.clearValidate(`listItems.${index}`);\n\n        const newValue = [...this.value];\n\n        newValue[index] = value;\n\n        this.$emit('input', newValue);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  .form-list-item {\n    display: flex;\n\n    ::v-deep {\n      > .el-form-item {\n        flex: 1;\n      }\n\n      .el-select {\n        width: 100%;\n      }\n\n      .el-form-item {\n        &__label:before {\n          display: none;\n        }\n\n        &__error {\n          position: relative;\n        }\n      }\n    }\n  }\n\n  .is-hidden-label {\n    ::v-deep .el-form-item__label {\n      display: none;\n    }\n  }\n\n  .container-btn-group {\n    padding: 38px 0 0 3px;\n\n    .is-hidden-label & {\n      padding-top: 0;\n    }\n  }\n\n  .plan-design-dropdown-container {\n    width: 100%;\n  }\n\n  /*\n    I'm commenting this out for now b/c there is a timing issue when deleting a value.\n    There's a fix on https://vuejs.org/v2/guide/transitions.html#List-Move-Transitions,\n    but we don't have the time for that for now.\n  */\n\n  .slide-in-fade {\n    // &-enter-active,\n    // &-leave-active {\n    //   max-height: 0;\n    //   opacity: 0;\n    //   transition: all .25s ease-in;\n    // }\n\n    // &-enter-to,\n    // &-leave {\n    //   opacity: 1;\n    //   overflow: hidden;\n    //   max-height: 150px;\n    // }\n  }\n</style>\n",".form-list-item {\n  display: flex;\n}\n.form-list-item ::v-deep > .el-form-item {\n  flex: 1;\n}\n.form-list-item ::v-deep .el-select {\n  width: 100%;\n}\n.form-list-item ::v-deep .el-form-item__label:before {\n  display: none;\n}\n.form-list-item ::v-deep .el-form-item__error {\n  position: relative;\n}\n\n.is-hidden-label ::v-deep .el-form-item__label {\n  display: none;\n}\n\n.container-btn-group {\n  padding: 38px 0 0 3px;\n}\n.is-hidden-label .container-btn-group {\n  padding-top: 0;\n}\n\n.plan-design-dropdown-container {\n  width: 100%;\n}\n\n/*\n  I'm commenting this out for now b/c there is a timing issue when deleting a value.\n  There's a fix on https://vuejs.org/v2/guide/transitions.html#List-Move-Transitions,\n  but we don't have the time for that for now.\n*/\n\n/*# sourceMappingURL=TfFormList.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$f = "data-v-8f6fe652";
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    browser,
    undefined,
    undefined
  );

var script$g = {
  name: 'TfCheckbox',
  extends: Checkbox,
  inject: {
    $themeCheckboxColor: {
      default: function _default() {
        return null;
      }
    }
  },
  props: {
    noBranding: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Return color value as reactive value
     *
     * @returns {string | null}
     */
    themeCheckboxColor: function themeCheckboxColor() {
      return !this.noBranding && this.$themeCheckboxColor ? this.$themeCheckboxColor() : null;
    }
  },
  watch: {
    /**
     * when the user focus we need to emit up an event and possibly update our colors
     */
    focus: function focus() {
      this.$emit(this.focus ? 'focus' : 'blur');
      this.toggleColors();
    },

    /**
     * when the user checks the box we need to check if we need to update the colors
     */
    isChecked: function isChecked() {
      this.toggleColors();
    },

    /**
     * When we get the users branded colors we need to update the color of this checkbox
     */
    themeCheckboxColor: function themeCheckboxColor() {
      this.toggleColors();
    },

    /**
     * if the checkbox is disabled we might need to update the checkboxes colors
     */
    disabled: function disabled() {
      var _this = this;

      this.$nextTick(function () {
        _this.toggleColors();
      });
    }
  },
  mounted: function mounted() {
    if (this.themeCheckboxColor) {
      this.toggleColors();
    }
  },
  methods: {
    /**
     * Update all the colors, with inline styles if needed.
     */
    toggleColors: function toggleColors() {
      var innerEl = this.$el.querySelector('.el-checkbox__inner');
      var colorLabel = this.$el.querySelector('.color-label');

      if (this.disabled) {
        innerEl.removeAttribute('style');
        return;
      }

      if (this.isChecked) {
        innerEl.style.backgroundColor = this.themeCheckboxColor;

        if (colorLabel) {
          colorLabel.style.color = this.themeCheckboxColor;
        }
      } else {
        innerEl.removeAttribute('style');

        if (colorLabel) {
          colorLabel.removeAttribute('style');
        }
      }

      if (!this.focus) {
        innerEl.style.borderColor = this.themeCheckboxColor;
      } else {
        innerEl.style.removeProperty('border-color');
      }
    }
  }
};

/* script */
const __vue_script__$g = script$g;

/* template */

  /* style */
  const __vue_inject_styles__$g = undefined;
  /* scoped */
  const __vue_scope_id__$g = undefined;
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent_1(
    {},
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    undefined,
    undefined,
    undefined
  );

var script$h = {
  props: {
    allowEnter: {
      type: Boolean,
      default: true
    },
    appendValidationType: {
      type: Boolean,
      default: false
    },
    autoCollapse: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * "groupedDisabledOptions" provides a list of disabled options that appear below the options in the dropdown.
     */
    groupedDisabledOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * "groupedDisabledOptionsTitle" provides a title for the list of disabled options.
     */
    groupedDisabledOptionsTitle: {
      type: String,
      default: 'Used values'
    },
    optionKey: {
      type: String,
      default: 'normalized_value'
    },
    // Pass this if any objects in the options array has a label that doesn't match the value
    // Example: { normalized_value: '10%', normalized_label: 'Match in-force'}
    optionLabel: {
      type: String,
      default: 'normalized_label'
    },

    /* An array of objects. Each object contains a single option and may optionally contain an
    isDisabled prop that will determine if a specific dropdown item is disabled */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: 'Enter value'
    },
    prependValidationType: {
      type: Boolean,
      default: false
    },
    prop: {
      type: String,
      default: ''
    },
    saving: {
      type: Boolean,
      default: false
    },
    suffixClickable: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: null
    },
    validationType: {
      type: String,
      default: 'string'
    },
    value: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 'auto'
    }
  },
  data: function data(vm) {
    return {
      debounceChangeEvent: debounce$1(vm.sendChangeEvent, 500),
      selectedValue: '',
      showAutocomplete: false,
      showTooltip: false,
      initialValueSet: false,
      autoWidth: null,
      userEdited: false,
      hasFocus: false
    };
  },
  computed: {
    /**
     * get the correct width for the popover
     *
     * @returns {string}
     */
    popoverWidth: function popoverWidth() {
      return this.width === 'auto' ? this.autoWidth : this.width;
    },

    /**
     * get the correct text for the prepend/append divs
     *
     * @returns {string}
     */
    validationTypeText: function validationTypeText() {
      var text;

      if (this.validationType === 'dollar') {
        text = '$';
      } else if (this.validationType === 'percentage-whole-number') {
        text = '%';
      }

      return text;
    },

    /**
     * If the user has edited the value of the input,
     * filter options based on what was entered.
     * There is a potential edge case where `options` MIGHT
     * be passed as `null` so we're covering that just in case.
     *
     * @returns {Array}
     */
    filteredOptions: function filteredOptions() {
      var _this = this;

      var options = this.options || []; // user hasn't edited, there's no value—show all options, or user has hit "enter" w/o a value.

      if (!this.userEdited || !this.selectedValue) {
        return options;
      }

      return options.filter(function (option) {
        /*
          Not all objects in the options array need to have a label
          so we filter by optionLabel first and use the optionKeys as the backup testValue.
        */
        var testValue = option[_this.optionLabel] || option[_this.optionKey];
        return testValue.toLowerCase().includes(_this.selectedValue.toLowerCase());
      });
    }
  },
  watch: {
    /**
     * Everytime the value changes we need parse the value based on its validation type and update the selectedValue.
     */
    value: function value() {
      this.selectedValue = this.parseValue(this.value);
    },

    /**
     * Emit the change up when the selectedValue changes
     */
    selectedValue: function selectedValue() {
      this.$emit('input', this.selectedValue);

      if (this.initialValueSet) {
        this.debounceChangeEvent();
      }

      this.initialValueSet = true;
    },

    /**
     * Set the correct auto width for the popover when it is shown
     *
     * @param {boolean} showAutocomplete
     */
    showAutocomplete: function showAutocomplete(_showAutocomplete) {
      if (_showAutocomplete && this.width === 'auto') {
        this.autoWidth = this.$el.clientWidth;
      }
    },

    /**
     * Show/hide the autocomplete popover if there are options/no options and the user has edited the input
     * (overrides existing behavior only for the userEdited autocomplete behavior)
     *
     * @param {Array} newOptions
     */
    filteredOptions: function filteredOptions(newOptions) {
      if (this.userEdited && this.hasFocus) {
        this.showAutocomplete = !!newOptions.length;
      }
    }
  },
  created: function created() {
    if (this.value) {
      this.selectedValue = this.parseValue(this.value);
    } else {
      this.initialValueSet = true;
    }
  },
  methods: {
    /**
     * Fires When a user clicks on a list item in the popover we hide
     * We updated the 'selectedValue' as well as close the dropdown and focus on the textarea
     *
     * @param {string} value
     * @param {boolean} [isDisabled] - If the item is disabled, do nothing when it is clicked or the enter key is hit
     */
    autoCompleteClick: function autoCompleteClick(value, isDisabled) {
      var _this2 = this;

      if (isDisabled) {
        return;
      }

      this.selectedValue = this.parseValue(value);
      this.$nextTick(function () {
        _this2.$el.querySelector('textarea').focus();

        _this2.showAutocomplete = false;
      });
    },

    /**
     * Handle keydown events
     *
     * @param {object} event
     */
    onKeydown: function onKeydown(event) {
      var charCode = event.which ? event.which : event.keyCode; // Conditions

      var isNumpad = charCode >= 96 && charCode <= 105;
      var isTopNumbers = charCode >= 48 && charCode <= 57;
      var isNumericKey = isNumpad || isTopNumbers; // Allow for 'selecting all', 'copy', and 'paste'

      var isCopyPaste = event.metaKey && ['a', 'c', 'v'].includes(event.key);
      var isModifier = event.shiftKey;
      var isArrowKey = [37, 38, 39, 40].includes(charCode);

      if (!isArrowKey) {
        // at this point, we're saying that the user has edited the field, because they pushed a key
        this.userEdited = true;
      } // prevent keydown and emit to the parent if key is Enter and !allowEnter


      if (!this.allowEnter && charCode === 13) {
        event.preventDefault();
        this.$emit('keydownEnter');
      } // Allow if user is copy/pasting


      var numericValidationTypes = ['percentage-whole-number', 'whole-number'];

      if (!isCopyPaste) {
        if (numericValidationTypes.includes(this.validationType) && charCode > 31) {
          if (!isNumericKey || isModifier) {
            event.preventDefault();
          }
        }
      }
    },

    /**
     * When a user clicks in the text area we open the dropdown
     */
    onInputClick: function onInputClick() {
      this.showAutocomplete = true;
    },

    /**
     * When the text area gets focus we open the dropdown
     */
    onInputFocus: function onInputFocus() {
      this.$emit('focus'); // reset if the user left

      this.userEdited = false;

      if (this.options.length) {
        this.showAutocomplete = true;
      }

      this.hasFocus = true;

      if (this.tooltip) {
        this.showTooltip = true;
      }

      var self = this;
      window.setTimeout(function () {
        var autocomplete = self.$el.querySelector('.auto-complete-textarea');
        autocomplete.removeAttribute('tabindex');
      }, 100);
    },

    /**
     * When the text area loses we check if the focus is in the dropdown, if it's not we close the dropdown
     *
     * @param {object} event
     */
    onInputBlur: function onInputBlur(event) {
      if (!event) {
        return;
      }

      this.hasFocus = false;
      var relatedTarget = event.relatedTarget;
      var popover = this.$refs.popoverContainer;
      var isInPopover = this.isChildOf(relatedTarget, popover);

      if (!isInPopover) {
        if (this.tooltip) {
          this.showTooltip = false;
        }

        this.showAutocomplete = false;
        this.$emit('blur', event);
      }

      this.debounceChangeEvent.flush();
    },

    /**
     * If the user presses down while in the text area we focus on the first list item
     */
    handleTextAreaArrowDown: function handleTextAreaArrowDown() {
      if (this.filteredOptions.length) {
        this.$refs.popoverContainer.querySelector('li:first-child').focus();
      }
    },

    /**
     * If the user presses up on a list item we focus on the one above it (or on the text area)
     *
     * @param {object} event
     */
    handleListItemArrowUp: function handleListItemArrowUp(event) {
      event.preventDefault();
      var previousSibling = event.target.previousSibling;

      if (previousSibling) {
        previousSibling.focus();
      } else {
        this.$el.querySelector('textarea').focus();
      }
    },

    /**
     * If the user presses down on a list item we focus on the next item
     *
     * @param {object} event
     */
    handleListItemArrowDown: function handleListItemArrowDown(event) {
      event.preventDefault();
      var nextSibling = event.target.nextSibling;

      if (nextSibling) {
        nextSibling.focus();
      }
    },

    /**
     * If the user presses esc, we close the dropdown and focus on the textarea
     */
    handleEscKey: function handleEscKey() {
      this.showAutocomplete = false;
      this.$el.querySelector('textarea').focus();
    },

    /**
     * Parse the passed value based on what the validation type is.
     *
     * @param {string} value
     * @returns {string}
     */
    parseValue: function parseValue(value) {
      var parsedValue;

      switch (this.validationType) {
        case 'percentage-whole-number':
          parsedValue = value.replace('%', '');
          break;

        default:
          parsedValue = value;
      }

      return parsedValue;
    },

    /**
     * Let's emit a change event up when the value changes
     */
    sendChangeEvent: function sendChangeEvent() {
      var parsedValue;

      switch (this.validationType) {
        case 'percentage-whole-number':
          parsedValue = "".concat(this.selectedValue, "%");
          break;

        default:
          parsedValue = this.selectedValue;
      }

      this.$emit('change', parsedValue);
    },

    /**
     * Is the first element a child of the second
     * We use to decide to if the user is still in the dropdown
     *
     * @param {object} child
     * @param {object} parent
     * @returns {boolean}
     */
    isChildOf: function isChildOf(child, parent) {
      if (!child) {
        return false;
      }

      if (child.parentNode === parent) {
        return true;
      }

      if (child.parentNode === null) {
        return false;
      }

      return this.isChildOf(child.parentNode, parent);
    }
  }
};

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [
        { "with-suffix-icon": _vm.suffixClickable },
        { "with-text-addition": _vm.validationType !== "string" }
      ]
    },
    [
      _vm.tooltip
        ? _c(
            "tf-tooltip",
            {
              attrs: {
                options: {
                  placement: "top"
                },
                "force-show": _vm.showTooltip,
                trigger: "click"
              }
            },
            [
              _c("div", { attrs: { slot: "reference" }, slot: "reference" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "tooltip-inner",
                style: "width: " + (_vm.popoverWidth - 22) + "px",
                domProps: { textContent: _vm._s(_vm.tooltip) }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.prependValidationType
        ? _c("span", {
            staticClass: "prepend-input text-addition",
            domProps: { textContent: _vm._s(_vm.validationTypeText) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.options.length
        ? _c(
            "el-popover",
            _vm._b(
              {
                attrs: { placement: "bottom-start", trigger: "manual" },
                model: {
                  value: _vm.showAutocomplete,
                  callback: function($$v) {
                    _vm.showAutocomplete = $$v;
                  },
                  expression: "showAutocomplete"
                }
              },
              "el-popover",
              {
                disabled: _vm.disabled || _vm.saving,
                width: _vm.popoverWidth,
                popperOptions: {
                  boundariesElement: "body",
                  gpuAcceleration: true,
                  positionFixed: false,
                  preventOverflow: false
                },
                popperClass: "el-select-dropdown autocomplete"
              },
              false
            ),
            [
              _c(
                "div",
                {
                  ref: "popoverContainer",
                  staticClass:
                    "el-select-dropdown__wrap el-scrollbar__wrap el-scrollbar__wrap--hidden-default"
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "el-scrollbar__view el-select-dropdown__list"
                    },
                    [
                      _vm._l(_vm.filteredOptions, function(option, index) {
                        return _c("li", {
                          key: index,
                          staticClass: "el-select-dropdown__item",
                          class: { "is-disabled": option.isDisabled },
                          attrs: {
                            "data-test-input-with-options-option": "",
                            tabindex: "0"
                          },
                          domProps: {
                            textContent: _vm._s(
                              option[_vm.optionLabel] || option[_vm.optionKey]
                            )
                          },
                          on: {
                            click: function($event) {
                              return _vm.autoCompleteClick(
                                option[_vm.optionKey],
                                option.isDisabled
                              )
                            },
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault();
                                return _vm.autoCompleteClick(
                                  option[_vm.optionKey],
                                  option.isDisabled
                                )
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp"
                                  ])
                                ) {
                                  return null
                                }
                                return _vm.handleListItemArrowUp($event)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleListItemArrowDown($event)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "tab",
                                    9,
                                    $event.key,
                                    "Tab"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.autoCompleteClick(
                                  option[_vm.optionKey]
                                )
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleEscKey($event)
                              }
                            ]
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm.groupedDisabledOptions.length
                        ? [
                            _c("li", {
                              staticClass: "el-select-group__title",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.groupedDisabledOptionsTitle
                                )
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.groupedDisabledOptions, function(
                              option,
                              index
                            ) {
                              return _c("li", {
                                key: "disabled-" + index,
                                staticClass:
                                  "el-select-dropdown__item is-disabled",
                                domProps: {
                                  textContent: _vm._s(
                                    option[_vm.optionLabel] ||
                                      option[_vm.optionKey]
                                  )
                                }
                              })
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c("tf-input", {
                ref: "auto-complete-textarea",
                staticClass: "auto-complete-textarea",
                class: _vm.autoCollapse ? "auto-collapse" : "",
                attrs: {
                  slot: "reference",
                  "data-test-input-with-options-input": "",
                  disabled: _vm.disabled || _vm.saving,
                  placeholder: _vm.placeholder,
                  autosize: "",
                  size: "mini",
                  type: "textarea"
                },
                on: { focus: _vm.onInputFocus, blur: _vm.onInputBlur },
                nativeOn: {
                  keydown: [
                    function($event) {
                      return _vm.onKeydown($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown"
                        ])
                      ) {
                        return null
                      }
                      return _vm.handleTextAreaArrowDown($event)
                    }
                  ],
                  click: function($event) {
                    return _vm.onInputClick()
                  }
                },
                slot: "reference",
                model: {
                  value: _vm.selectedValue,
                  callback: function($$v) {
                    _vm.selectedValue = $$v;
                  },
                  expression: "selectedValue"
                }
              })
            ],
            1
          )
        : _c(
            "tf-input",
            _vm._b(
              {
                staticClass: "auto-complete-textarea",
                class: { "auto-collapse": _vm.autoCollapse },
                attrs: { autosize: "", size: "mini", type: "textarea" },
                on: { focus: _vm.onInputFocus, blur: _vm.onInputBlur },
                nativeOn: {
                  keydown: function($event) {
                    return _vm.onKeydown($event)
                  }
                },
                model: {
                  value: _vm.selectedValue,
                  callback: function($$v) {
                    _vm.selectedValue = $$v;
                  },
                  expression: "selectedValue"
                }
              },
              "tf-input",
              {
                disabled: _vm.disabled || _vm.saving,
                placeholder: _vm.placeholder,
                prop: _vm.prop
              },
              false
            )
          ),
      _vm._v(" "),
      _vm.appendValidationType
        ? _c("span", {
            staticClass: "append-input text-addition",
            domProps: { textContent: _vm._s(_vm.validationTypeText) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.suffixClickable
        ? _c("tf-button", {
            class: [{ "is-focused": _vm.showAutocomplete }, "button-suffix"],
            attrs: {
              disabled: _vm.disabled,
              icon: _vm.suffixClickable,
              loading: _vm.saving,
              type: "secondary",
              size: "icon-no-fill"
            },
            on: {
              click: function($event) {
                return _vm.$emit("suffixClick")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$h = function (inject) {
    if (!inject) return
    inject("data-v-7d680b79_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tooltip-inner[data-v-7d680b79] {\n  text-align: left;\n}\n.button-suffix.tf-button--icon-no-fill.has-icon[data-v-7d680b79],\n.button-suffix.wt-button--icon-no-fill.has-icon[data-v-7d680b79] {\n  position: absolute;\n  top: 0;\n  right: 5px;\n  bottom: 0;\n  padding: 0 5px;\n  color: #999;\n}\n.button-suffix.tf-button--icon-no-fill.has-icon svg[data-v-7d680b79],\n.button-suffix.wt-button--icon-no-fill.has-icon svg[data-v-7d680b79] {\n  fill: #c1c1c1;\n}\n.text-addition[data-v-7d680b79] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  color: #999;\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n}\n.text-addition.append-input[data-v-7d680b79] {\n  border-left: none;\n}\n.text-addition.prepend-input[data-v-7d680b79] {\n  border-right: none;\n}\n.with-suffix-icon[data-v-7d680b79] {\n  position: relative;\n}\n.with-suffix-icon .auto-complete-textarea .el-textarea__inner[data-v-7d680b79] {\n  padding-right: 30px;\n}\n.with-text-addition[data-v-7d680b79] {\n  display: flex;\n}\n.with-text-addition > span[data-v-7d680b79]:not(.text-addition) {\n  flex-grow: 1;\n}\n.el-select-dropdown.autocomplete li[data-v-7d680b79]:focus {\n  background-color: #efefef;\n  outline: 0;\n}\n.el-select-dropdown__item[data-v-7d680b79] {\n  overflow: inherit;\n  height: auto;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  text-overflow: inherit;\n  line-height: inherit;\n  white-space: inherit;\n}\n.el-select-dropdown__item.is-disabled[data-v-7d680b79] {\n  pointer-events: none;\n}\n.el-select-dropdown__list .is-disabled[data-v-7d680b79], .el-select-dropdown__list .is-disabled[data-v-7d680b79]:hover {\n  /* stylelint-disable declaration-no-important */\n  color: #999 !important;\n  background: #efefef !important;\n  /* stylelint-enable declaration-no-important */\n  font-style: italic;\n}\n\n/*# sourceMappingURL=TfInputWithOptions.vue.map */", map: {"version":3,"sources":["TfInputWithOptions.vue","/home/circleci/repo/src/components/TfForm/TfInputWithOptions.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACyjBpC;EACA,gBAAA;ADvjBA;AC0jBA;;EAEA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;ADvjBA;ACyjBA;;EACA,aAAA;ADtjBA;AC0jBA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;ADvjBA;ACyjBA;EACA,iBAAA;ADvjBA;AC0jBA;EACA,kBAAA;ADxjBA;AC4jBA;EACA,kBAAA;ADzjBA;AC2jBA;EACA,mBAAA;ADzjBA;AC6jBA;EACA,aAAA;AD1jBA;AC6jBA;EACA,YAAA;AD3jBA;ACgkBA;EACA,yBAAA;EACA,UAAA;AD7jBA;ACikBA;EACA,iBAAA;EACA,YAAA;EAEA,gBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,oBAAA;EACA,oBAAA;ADhkBA;ACkkBA;EACA,oBAAA;ADhkBA;ACskBA;EAGA,+CAAA;EACA,sBAAA;EACA,8BAAA;EACA,8CAAA;EACA,kBAAA;ADrkBA;;AAEA,iDAAiD","file":"TfInputWithOptions.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tooltip-inner {\n  text-align: left;\n}\n\n.button-suffix.tf-button--icon-no-fill.has-icon,\n.button-suffix.wt-button--icon-no-fill.has-icon {\n  position: absolute;\n  top: 0;\n  right: 5px;\n  bottom: 0;\n  padding: 0 5px;\n  color: #999;\n}\n.button-suffix.tf-button--icon-no-fill.has-icon svg,\n.button-suffix.wt-button--icon-no-fill.has-icon svg {\n  fill: #c1c1c1;\n}\n\n.text-addition {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  color: #999;\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n}\n.text-addition.append-input {\n  border-left: none;\n}\n.text-addition.prepend-input {\n  border-right: none;\n}\n\n.with-suffix-icon {\n  position: relative;\n}\n.with-suffix-icon .auto-complete-textarea .el-textarea__inner {\n  padding-right: 30px;\n}\n\n.with-text-addition {\n  display: flex;\n}\n.with-text-addition > span:not(.text-addition) {\n  flex-grow: 1;\n}\n\n.el-select-dropdown.autocomplete li:focus {\n  background-color: #efefef;\n  outline: 0;\n}\n\n.el-select-dropdown__item {\n  overflow: inherit;\n  height: auto;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  text-overflow: inherit;\n  line-height: inherit;\n  white-space: inherit;\n}\n.el-select-dropdown__item.is-disabled {\n  pointer-events: none;\n}\n\n.el-select-dropdown__list .is-disabled, .el-select-dropdown__list .is-disabled:hover {\n  /* stylelint-disable declaration-no-important */\n  color: #999 !important;\n  background: #efefef !important;\n  /* stylelint-enable declaration-no-important */\n  font-style: italic;\n}\n\n/*# sourceMappingURL=TfInputWithOptions.vue.map */","<template>\n  <div\n    :class=\"[\n      { 'with-suffix-icon' : suffixClickable },\n      { 'with-text-addition' : validationType !== 'string' },\n    ]\"\n  >\n    <tf-tooltip\n      v-if=\"tooltip\"\n      :options=\"{\n        placement: 'top',\n      }\"\n      :force-show=\"showTooltip\"\n      trigger=\"click\"\n    >\n      <!-- we need a blank element to act as a reference -->\n      <div slot=\"reference\" />\n      <div\n        class=\"tooltip-inner\"\n        :style=\"`width: ${popoverWidth - 22}px`\"\n        v-text=\"tooltip\"\n      />\n    </tf-tooltip>\n\n    <span\n      v-if=\"prependValidationType\"\n      class=\"prepend-input text-addition\"\n      v-text=\"validationTypeText\"\n    />\n    <!-- eslint-disable max-len -->\n    <!-- To do: We should replace this with the base <popper /> when we can.-->\n    <el-popover\n      v-if=\"options.length\"\n      v-model=\"showAutocomplete\"\n      v-bind=\"{\n        disabled: disabled || saving,\n        width: popoverWidth,\n        popperOptions: {\n          boundariesElement: 'body',\n          gpuAcceleration: true,\n          positionFixed: false,\n          preventOverflow: false\n        },\n        popperClass: 'el-select-dropdown autocomplete',\n      }\"\n      placement=\"bottom-start\"\n      trigger=\"manual\"\n    >\n      <div\n        ref=\"popoverContainer\"\n        class=\"el-select-dropdown__wrap el-scrollbar__wrap el-scrollbar__wrap--hidden-default\"\n      >\n        <ul class=\"el-scrollbar__view el-select-dropdown__list\">\n          <li\n            v-for=\"(option, index) in filteredOptions\"\n            :key=\"index\"\n            data-test-input-with-options-option\n            class=\"el-select-dropdown__item\"\n            :class=\"{ 'is-disabled': option.isDisabled }\"\n            tabindex=\"0\"\n            @click=\"autoCompleteClick(option[optionKey], option.isDisabled)\"\n            @keydown.enter.prevent=\"autoCompleteClick(option[optionKey], option.isDisabled)\"\n            @keydown.up=\"handleListItemArrowUp\"\n            @keydown.down=\"handleListItemArrowDown\"\n            @keydown.tab=\"autoCompleteClick(option[optionKey])\"\n            @keydown.esc=\"handleEscKey\"\n            v-text=\"option[optionLabel] || option[optionKey]\"\n          />\n          <template v-if=\"groupedDisabledOptions.length\">\n            <li\n              class=\"el-select-group__title\"\n              v-text=\"groupedDisabledOptionsTitle\"\n            />\n            <li\n              v-for=\"(option, index) in groupedDisabledOptions\"\n              :key=\"`disabled-${index}`\"\n              class=\"el-select-dropdown__item is-disabled\"\n              v-text=\"option[optionLabel] || option[optionKey]\"\n            />\n          </template>\n        </ul>\n      </div>\n      <tf-input\n        slot=\"reference\"\n        ref=\"auto-complete-textarea\"\n        v-model=\"selectedValue\"\n        data-test-input-with-options-input\n        :class=\"autoCollapse ? 'auto-collapse' : ''\"\n        :disabled=\"disabled || saving\"\n        :placeholder=\"placeholder\"\n        class=\"auto-complete-textarea\"\n        autosize\n        size=\"mini\"\n        type=\"textarea\"\n        @keydown.native=\"onKeydown\"\n        @keydown.native.down=\"handleTextAreaArrowDown\"\n        @click.native=\"onInputClick()\"\n        @focus=\"onInputFocus\"\n        @blur=\"onInputBlur\"\n      />\n    </el-popover>\n    <tf-input\n      v-else\n      v-model=\"selectedValue\"\n      v-bind=\"{\n        disabled: disabled || saving,\n        placeholder,\n        prop,\n      }\"\n      :class=\"{ 'auto-collapse' : autoCollapse }\"\n      class=\"auto-complete-textarea\"\n      autosize\n      size=\"mini\"\n      type=\"textarea\"\n      @keydown.native=\"onKeydown\"\n      @focus=\"onInputFocus\"\n      @blur=\"onInputBlur\"\n    />\n    <span\n      v-if=\"appendValidationType\"\n      class=\"append-input text-addition\"\n      v-text=\"validationTypeText\"\n    />\n    <tf-button\n      v-if=\"suffixClickable\"\n      :disabled=\"disabled\"\n      :icon=\"suffixClickable\"\n      :loading=\"saving\"\n      type=\"secondary\"\n      size=\"icon-no-fill\"\n      :class=\"[\n        { 'is-focused' : showAutocomplete, },\n        'button-suffix'\n      ]\"\n      @click=\"$emit('suffixClick')\"\n    />\n  </div>\n</template>\n\n<script>\n  import { debounce } from 'lodash';\n\n  export default {\n    props: {\n      allowEnter: {\n        type: Boolean,\n        default: true,\n      },\n      appendValidationType: {\n        type: Boolean,\n        default: false,\n      },\n      autoCollapse: {\n        type: Boolean,\n        default: true,\n      },\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * \"groupedDisabledOptions\" provides a list of disabled options that appear below the options in the dropdown.\n       */\n      groupedDisabledOptions: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * \"groupedDisabledOptionsTitle\" provides a title for the list of disabled options.\n       */\n      groupedDisabledOptionsTitle: {\n        type: String,\n        default: 'Used values',\n      },\n      optionKey: {\n        type: String,\n        default: 'normalized_value',\n      },\n      // Pass this if any objects in the options array has a label that doesn't match the value\n      // Example: { normalized_value: '10%', normalized_label: 'Match in-force'}\n      optionLabel: {\n        type: String,\n        default: 'normalized_label',\n      },\n      /* An array of objects. Each object contains a single option and may optionally contain an\n      isDisabled prop that will determine if a specific dropdown item is disabled */\n      options: {\n        type: Array,\n        default: () => [],\n      },\n      placeholder: {\n        type: String,\n        default: 'Enter value',\n      },\n      prependValidationType: {\n        type: Boolean,\n        default: false,\n      },\n      prop: {\n        type: String,\n        default: '',\n      },\n      saving: {\n        type: Boolean,\n        default: false,\n      },\n      suffixClickable: {\n        type: String,\n        default: '',\n      },\n      tooltip: {\n        type: String,\n        default: null,\n      },\n      validationType: {\n        type: String,\n        default: 'string',\n      },\n      value: {\n        type: String,\n        default: '',\n      },\n      width: {\n        type: [Number, String],\n        default: 'auto',\n      },\n    },\n    data: (vm) => ({\n      debounceChangeEvent: debounce(vm.sendChangeEvent, 500),\n      selectedValue: '',\n      showAutocomplete: false,\n      showTooltip: false,\n      initialValueSet: false,\n      autoWidth: null,\n      userEdited: false,\n      hasFocus: false,\n    }),\n    computed: {\n      /**\n       * get the correct width for the popover\n       *\n       * @returns {string}\n       */\n      popoverWidth() {\n        return this.width === 'auto'\n          ? this.autoWidth\n          : this.width;\n      },\n\n      /**\n       * get the correct text for the prepend/append divs\n       *\n       * @returns {string}\n       */\n      validationTypeText() {\n        let text;\n\n        if (this.validationType === 'dollar') {\n          text = '$';\n        } else if (this.validationType === 'percentage-whole-number') {\n          text = '%';\n        }\n\n        return text;\n      },\n\n      /**\n       * If the user has edited the value of the input,\n       * filter options based on what was entered.\n       * There is a potential edge case where `options` MIGHT\n       * be passed as `null` so we're covering that just in case.\n       *\n       * @returns {Array}\n       */\n      filteredOptions() {\n        const options = this.options || [];\n\n        // user hasn't edited, there's no value—show all options, or user has hit \"enter\" w/o a value.\n        if (!this.userEdited || !this.selectedValue) {\n          return options;\n        }\n\n        return options.filter((option) => {\n          /*\n            Not all objects in the options array need to have a label\n            so we filter by optionLabel first and use the optionKeys as the backup testValue.\n          */\n          const testValue = option[this.optionLabel] || option[this.optionKey];\n\n          return testValue.toLowerCase().includes(this.selectedValue.toLowerCase());\n        });\n      },\n    },\n    watch: {\n      /**\n       * Everytime the value changes we need parse the value based on its validation type and update the selectedValue.\n       */\n      value() {\n        this.selectedValue = this.parseValue(this.value);\n      },\n\n      /**\n       * Emit the change up when the selectedValue changes\n       */\n      selectedValue() {\n        this.$emit('input', this.selectedValue);\n\n        if (this.initialValueSet) {\n          this.debounceChangeEvent();\n        }\n\n        this.initialValueSet = true;\n      },\n\n      /**\n       * Set the correct auto width for the popover when it is shown\n       *\n       * @param {boolean} showAutocomplete\n       */\n      showAutocomplete(showAutocomplete) {\n        if (showAutocomplete && this.width === 'auto') {\n          this.autoWidth = this.$el.clientWidth;\n        }\n      },\n\n      /**\n       * Show/hide the autocomplete popover if there are options/no options and the user has edited the input\n       * (overrides existing behavior only for the userEdited autocomplete behavior)\n       *\n       * @param {Array} newOptions\n       */\n      filteredOptions(newOptions) {\n        if (this.userEdited && this.hasFocus) {\n          this.showAutocomplete = !!newOptions.length;\n        }\n      },\n    },\n\n    created() {\n      if (this.value) {\n        this.selectedValue = this.parseValue(this.value);\n      } else {\n        this.initialValueSet = true;\n      }\n    },\n\n    methods: {\n      /**\n       * Fires When a user clicks on a list item in the popover we hide\n       * We updated the 'selectedValue' as well as close the dropdown and focus on the textarea\n       *\n       * @param {string} value\n       * @param {boolean} [isDisabled] - If the item is disabled, do nothing when it is clicked or the enter key is hit\n       */\n      autoCompleteClick(value, isDisabled) {\n        if (isDisabled) {\n          return;\n        }\n\n        this.selectedValue = this.parseValue(value);\n\n        this.$nextTick(() => {\n          this.$el.querySelector('textarea').focus();\n          this.showAutocomplete = false;\n        });\n      },\n\n      /**\n       * Handle keydown events\n       *\n       * @param {object} event\n       */\n      onKeydown(event) {\n        const charCode = event.which ? event.which : event.keyCode;\n        // Conditions\n        const isNumpad = charCode >= 96 && charCode <= 105;\n        const isTopNumbers = charCode >= 48 && charCode <= 57;\n        const isNumericKey = isNumpad || isTopNumbers;\n\n        // Allow for 'selecting all', 'copy', and 'paste'\n        const isCopyPaste = event.metaKey\n          && ['a', 'c', 'v'].includes(event.key);\n        const isModifier = event.shiftKey;\n        const isArrowKey = [37, 38, 39, 40].includes(charCode);\n\n        if (!isArrowKey) {\n          // at this point, we're saying that the user has edited the field, because they pushed a key\n          this.userEdited = true;\n        }\n\n        // prevent keydown and emit to the parent if key is Enter and !allowEnter\n        if (!this.allowEnter && charCode === 13) {\n          event.preventDefault();\n          this.$emit('keydownEnter');\n        }\n\n        // Allow if user is copy/pasting\n        const numericValidationTypes = [\n          'percentage-whole-number',\n          'whole-number',\n        ];\n        if (!isCopyPaste) {\n          if (numericValidationTypes.includes(this.validationType) && charCode > 31) {\n            if (!isNumericKey || isModifier) {\n              event.preventDefault();\n            }\n          }\n        }\n      },\n\n      /**\n       * When a user clicks in the text area we open the dropdown\n       */\n      onInputClick() {\n        this.showAutocomplete = true;\n      },\n      /**\n       * When the text area gets focus we open the dropdown\n       */\n      onInputFocus() {\n        this.$emit('focus');\n        // reset if the user left\n        this.userEdited = false;\n\n        if (this.options.length) {\n          this.showAutocomplete = true;\n        }\n        this.hasFocus = true;\n        if (this.tooltip) {\n          this.showTooltip = true;\n        }\n        const self = this;\n        window.setTimeout(() => {\n          const autocomplete = self.$el.querySelector('.auto-complete-textarea');\n          autocomplete.removeAttribute('tabindex');\n        }, 100);\n      },\n      /**\n       * When the text area loses we check if the focus is in the dropdown, if it's not we close the dropdown\n       *\n       * @param {object} event\n       */\n      onInputBlur(event) {\n        if (!event) {\n          return;\n        }\n\n        this.hasFocus = false;\n\n        const { relatedTarget } = event;\n        const popover = this.$refs.popoverContainer;\n        const isInPopover = this.isChildOf(relatedTarget, popover);\n\n        if (!isInPopover) {\n          if (this.tooltip) {\n            this.showTooltip = false;\n          }\n\n          this.showAutocomplete = false;\n          this.$emit('blur', event);\n        }\n\n        this.debounceChangeEvent.flush();\n      },\n\n      /**\n       * If the user presses down while in the text area we focus on the first list item\n       */\n      handleTextAreaArrowDown() {\n        if (this.filteredOptions.length) {\n          this.$refs.popoverContainer.querySelector('li:first-child').focus();\n        }\n      },\n\n      /**\n       * If the user presses up on a list item we focus on the one above it (or on the text area)\n       *\n       * @param {object} event\n       */\n      handleListItemArrowUp(event) {\n        event.preventDefault();\n        const { previousSibling } = event.target;\n\n        if (previousSibling) {\n          previousSibling.focus();\n        } else {\n          this.$el.querySelector('textarea').focus();\n        }\n      },\n\n      /**\n       * If the user presses down on a list item we focus on the next item\n       *\n       * @param {object} event\n       */\n      handleListItemArrowDown(event) {\n        event.preventDefault();\n        const { nextSibling } = event.target;\n\n        if (nextSibling) {\n          nextSibling.focus();\n        }\n      },\n\n      /**\n       * If the user presses esc, we close the dropdown and focus on the textarea\n       */\n      handleEscKey() {\n        this.showAutocomplete = false;\n        this.$el.querySelector('textarea').focus();\n      },\n\n      /**\n       * Parse the passed value based on what the validation type is.\n       *\n       * @param {string} value\n       * @returns {string}\n       */\n      parseValue(value) {\n        let parsedValue;\n\n        switch (this.validationType) {\n        case 'percentage-whole-number':\n          parsedValue = value.replace('%', '');\n          break;\n        default:\n          parsedValue = value;\n        }\n        return parsedValue;\n      },\n\n      /**\n       * Let's emit a change event up when the value changes\n       */\n      sendChangeEvent() {\n        let parsedValue;\n\n        switch (this.validationType) {\n        case 'percentage-whole-number':\n          parsedValue = `${this.selectedValue}%`;\n          break;\n        default:\n          parsedValue = this.selectedValue;\n        }\n\n        this.$emit('change', parsedValue);\n      },\n\n      /**\n       * Is the first element a child of the second\n       * We use to decide to if the user is still in the dropdown\n       *\n       * @param {object} child\n       * @param {object} parent\n       * @returns {boolean}\n       */\n      isChildOf(child, parent) {\n        if (!child) {\n          return false;\n        }\n        if (child.parentNode === parent) {\n          return true;\n        } if (child.parentNode === null) {\n          return false;\n        }\n        return this.isChildOf(child.parentNode, parent);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tooltip-inner {\n    text-align: left;\n  }\n\n  .button-suffix.tf-button--icon-no-fill.has-icon,\n  .button-suffix.wt-button--icon-no-fill.has-icon {\n    position: absolute;\n    top: 0;\n    right: 5px;\n    bottom: 0;\n    padding: 0 5px;\n    color: $tf-medium-gray;\n\n    svg {\n      fill: $tf-light-gray;\n    }\n  }\n\n  .text-addition {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 8px;\n    color: $tf-medium-gray;\n    background: $tf-extra-light-gray-2;\n    border: 1px solid $tf-light-gray;\n\n    &.append-input {\n      border-left: none;\n    }\n\n    &.prepend-input {\n      border-right: none;\n    }\n  }\n\n  .with-suffix-icon {\n    position: relative;\n\n    .auto-complete-textarea .el-textarea__inner {\n      padding-right: 30px;\n    }\n  }\n\n  .with-text-addition {\n    display: flex;\n\n    > span {\n      &:not(.text-addition) {\n        flex-grow: 1;\n      }\n    }\n  }\n\n  .el-select-dropdown.autocomplete li:focus {\n    background-color: $tf-extra-light-gray-1;\n    outline: 0;\n  }\n\n  // Override the dropdown items to show full text.\n  .el-select-dropdown__item {\n    overflow: inherit;\n    height: auto;\n    padding: {\n      top: 5px;\n      bottom: 5px;\n    }\n    text-overflow: inherit;\n    line-height: inherit;\n    white-space: inherit;\n\n    &.is-disabled {\n      pointer-events: none;\n    }\n  }\n\n  .el-select-dropdown__list {\n    .is-disabled {\n      &,\n      &:hover {\n        // I'm having to use important to override Elements native styles ):\n        /* stylelint-disable declaration-no-important */\n        color: $tf-medium-gray !important;\n        background: $tf-extra-light-gray-1 !important;\n        /* stylelint-enable declaration-no-important */\n        font-style: italic;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$h = "data-v-7d680b79";
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    browser,
    undefined,
    undefined
  );

// 20.1.2.4 Number.isNaN(number)


_export(_export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

var $indexOf = _arrayIncludes(false);
var $native$1 = [].indexOf;
var NEGATIVE_ZERO$1 = !!$native$1 && 1 / [1].indexOf(1, -0) < 0;

_export(_export.P + _export.F * (NEGATIVE_ZERO$1 || !_strictMethod($native$1)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO$1
      // convert -0 to +0
      ? $native$1.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

var script$i = {
  props: {
    disableClick: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: 'value'
    },
    concatenateLabels: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    emptyText: {
      type: String,
      default: 'No Options Available'
    },
    forceDisableCheckboxClick: {
      type: Boolean,
      default: false
    },
    totalOptionsAvailable: {
      type: Number,
      default: 0
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    popperClass: {
      type: String,
      default: 'multi-select-popover'
    },
    popoverTrigger: {
      type: String,
      default: 'click'
    },
    searchableParent: {
      type: String,
      default: null
    },
    nextTabbableElement: {
      type: String,
      default: null
    },
    width: {
      type: [Number, String],
      default: 'auto'
    }
  },
  data: function data(vm) {
    return {
      checkAll: false,
      clonedValue: vm.value.slice(0),
      initialValues: null,
      showPopover: false,
      popoverVisible: false
    };
  },
  computed: {
    /**
     * If there is only one option we disabled the checkboxes
     *
     * @returns {boolean}
     */
    disabledCheckBoxes: function disabledCheckBoxes() {
      return this.totalOptionsAvailable.length === 1;
    },

    /**
     * What value we display when in the main multi select "label"
     *
     * @returns {string}
     */
    displayValue: function displayValue() {
      var _this = this;

      var labels = []; // populate labels array

      this.options.forEach(function (option) {
        if (_this.value.indexOf(option[_this.valueKey]) > -1) {
          labels.push(option[_this.label]);
        }
      }); // If all the options are selected

      if (this.options.length && Number(this.totalOptionsAvailable) === labels.length) {
        return 'All';
      }

      if (!labels.some(function (label) {
        return Number.isNaN(label);
      })) {
        // this is array of only numbers so lets roll them up
        return this.$TF.Formatting.getRanges(labels).join(', ');
      }

      if (this.concatenateLabels || labels.length === 1) {
        return labels.join(', ');
      }

      return '(Multi)';
    },

    /**
     * get the correct width for the popover
     *
     * @returns {string}
     */
    popoverWidth: function popoverWidth() {
      return this.popoverVisible && this.width === 'auto' ? this.$el.offsetWidth : this.width;
    }
  },
  watch: {
    /**
     * When the value changes we need to check if we should mark the 'checkall' checkbox
     *
     * @param {Array} currentValue
     * @param {Array} oldValue
     */
    value: function value(currentValue, oldValue) {
      this.clonedValue = this.value.slice(0);
      var checkedCount = this.value.length;
      this.checkAll = checkedCount === this.options.length;
      var containersEqual = isEqual(oldValue, this.value);

      if (containersEqual) {
        return;
      }

      this.$emit('input', this.value);
      this.$emit('change', {
        value: this.value,
        oldValue: oldValue
      });
    }
  },
  created: function created() {
    var checkedCount = this.value.length;
    this.checkAll = checkedCount === this.options.length;

    if (this.totalOptionsAvailable === 1) {
      this.handleCheckAllChange(true);
    }
  },
  methods: {
    /**
     * Change the popoverVisible to true and
     * set the initial values to the value prop.
     */
    onShow: function onShow() {
      this.popoverVisible = true;
      this.initialValues = this.value;
    },

    /**
     * We store the popoverVisible on show/hide
     * so we know if we have to close the select once the user tabs off.
     */
    onHide: function onHide() {
      this.popoverVisible = false;
      this.$emit('hide', {
        value: this.value,
        initialValues: this.initialValues
      });
      this.initialValues = null;
    },

    /**
     * If the popover trigger is manual,
     * we use the 'showPopover' variable to control it and we toggle it on focus.
     */
    focus: function focus() {
      this.showPopover = true;
    },

    /**
     * If the popover trigger is manual,
     * we use the 'showPopover' variable to control it and toggle it on blur.
     */
    blur: function blur() {
      this.showPopover = false;
    },

    /**
     * Click on the checkbox when a checkbox is in focus the user hits enter.
     *
     * @param {event} event
     */
    onCheckBoxEnter: function onCheckBoxEnter(event) {
      var checkbox = event.target;
      checkbox.click();
    },

    /**
     * Toggle popover if the user hits enter when on the main input.
     */
    onInputEnter: function onInputEnter() {
      if (this.popoverTrigger === 'manual') {
        this.showPopover = !this.showPopover;
      } else {
        this.$refs['multi-select-input'].$el.click();
      }
    },

    /**
     * If the user hits tab while focused on the main input,
     * we move the user to the next checkbox.
     * For some reason Element puts everything in a strange order.
     *
     * @param {event} event
     */
    handleInputTab: function handleInputTab(event) {
      if (!event.shiftKey && this.popoverVisible) {
        var checkall = this.$refs['check-all'];
        var inputs = this.$refs.checkbox;

        if (checkall) {
          window.setTimeout(function () {
            checkall.$el.querySelector('input').focus();
          }, 100);
        } else if (inputs.length) {
          window.setTimeout(function () {
            inputs[0].$el.querySelector('input').focus();
          }, 100);
        }
      }
    },

    /**
     * If the user hits tab while focused on checkbox
     * or if the user was on the last checkbox,
     * we hide the popover and focus on the next elment outside of it
     *
     * @param {event} event
     * @param {number} index
     */
    handleCheckboxTab: function handleCheckboxTab(event, index) {
      if (index === this.options.length - 1 && this.nextTabbableElement && this.searchableParent) {
        event.preventDefault();

        if (this.popoverTrigger === 'manual') {
          this.showPopover = !this.showPopover;
        } else {
          this.$refs['multi-select-input'].$el.click();
        }

        this.$el.closest(this.searchableParent).querySelector(this.nextTabbableElement).focus();
      }
    },

    /**
     * Manually toggle the popover
     */
    togglePopover: function togglePopover() {
      if (this.popoverTrigger === 'manual') {
        this.showPopover = !this.showPopover;
      }
    },

    /**
     * Handle the click of single checkbox
     *
     * @param {Array} value
     */
    handleMultiSelectChange: function handleMultiSelectChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.options.length;
      this.$emit('input', value);
    },

    /**
     * Handle the click of check all checkbox
     *
     * @param {boolean} checkAll
     */
    handleCheckAllChange: function handleCheckAllChange(checkAll) {
      var _this2 = this;

      if (checkAll) {
        var values = [];
        this.options.forEach(function (option) {
          values.push(option[_this2.valueKey]);
        });
        this.$emit('input', values);
        this.$emit('update');
      } else {
        this.$emit('input', []);
      }
    }
  }
};

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "el-popover",
    {
      attrs: {
        "append-to-body": _vm.appendToBody,
        disabled: _vm.disableClick,
        "popper-class": _vm.popperClass,
        trigger: _vm.popoverTrigger,
        value: _vm.showPopover,
        "visible-arrow": false,
        placement: "bottom",
        width: _vm.popoverWidth
      },
      on: { show: _vm.onShow, hide: _vm.onHide }
    },
    [
      _c("tf-input", {
        ref: "multi-select-input",
        staticClass: "multi-select-dropdown",
        attrs: {
          slot: "reference",
          disabled: _vm.disableClick,
          readonly: true,
          value: _vm.displayValue,
          size: "large",
          placeholder: "Select"
        },
        nativeOn: {
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onInputEnter($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
              ) {
                return null
              }
              return _vm.handleInputTab($event)
            }
          ],
          click: function($event) {
            return _vm.togglePopover($event)
          }
        },
        slot: "reference"
      }),
      _vm._v(" "),
      _vm.options.length === 0
        ? _c("label", { staticClass: "empty-text" }, [
            _vm._v(_vm._s(_vm.emptyText))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.options.length > 1
        ? _c(
            "tf-checkbox",
            {
              ref: "check-all",
              attrs: {
                indeterminate: false,
                disabled:
                  _vm.disabledCheckBoxes || _vm.forceDisableCheckboxClick
              },
              on: { change: _vm.handleCheckAllChange },
              nativeOn: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleCheckAllChange(!_vm.checkAll)
                }
              },
              model: {
                value: _vm.checkAll,
                callback: function($$v) {
                  _vm.checkAll = $$v;
                },
                expression: "checkAll"
              }
            },
            [_vm._v("\n    Select all\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "tf-checkbox-group",
        {
          on: { change: _vm.handleMultiSelectChange },
          model: {
            value: _vm.clonedValue,
            callback: function($$v) {
              _vm.clonedValue = $$v;
            },
            expression: "clonedValue"
          }
        },
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "tf-checkbox",
            {
              key: option.id,
              ref: "checkbox",
              refInFor: true,
              attrs: {
                disabled:
                  _vm.disabledCheckBoxes || _vm.forceDisableCheckboxClick,
                label: option[_vm.valueKey]
              },
              nativeOn: {
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onCheckBoxEnter($event)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    return _vm.handleCheckboxTab($event, index)
                  }
                ]
              }
            },
            [_vm._v("\n      " + _vm._s(option[_vm.label]) + "\n    ")]
          )
        }),
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  const __vue_inject_styles__$i = undefined;
  /* scoped */
  const __vue_scope_id__$i = undefined;
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfSelectText popover compononent
 *
 * @vuedoc
 * @exports TfPopover/TfSelectText
 * @category Components
 */
var script$j = {
  name: 'TfSelectText',
  props: {
    noMatchText: {
      type: String,
      default: 'Option not found'
    },
    options: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    optionText: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: 'n/a'
    },
    title: {
      type: String,
      required: true,
      default: 'Select option'
    },
    value: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      selected: null
    };
  },
  created: function created() {
    this.selected = this.value;
  }
};

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-select",
    {
      staticClass: "tf-select-text wt-select-text",
      attrs: {
        "no-match-text": _vm.noMatchText,
        placeholder: _vm.placeholder,
        filterable: ""
      },
      on: {
        change: function($event) {
          return _vm.$emit("change", $event)
        },
        input: function($event) {
          return _vm.$emit("input", $event)
        },
        blur: function($event) {
          return _vm.$emit("blur")
        },
        focus: function($event) {
          return _vm.$emit("focus")
        }
      },
      model: {
        value: _vm.selected,
        callback: function($$v) {
          _vm.selected = $$v;
        },
        expression: "selected"
      }
    },
    [
      _c(
        "el-option-group",
        { attrs: { label: _vm.title } },
        _vm._l(_vm.options, function(option) {
          return _c("el-option", {
            key: option[_vm.optionValue],
            attrs: {
              value: option[_vm.optionValue],
              label: option[_vm.optionText]
            }
          })
        }),
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

  /* style */
  const __vue_inject_styles__$j = function (inject) {
    if (!inject) return
    inject("data-v-2fdb675d_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.el-select[data-v-2fdb675d] {\n  width: 100%;\n}\n.el-select[data-v-2fdb675d] .el-input__inner {\n  border-color: transparent;\n}\n.el-select[data-v-2fdb675d] .el-input__inner, .el-select[data-v-2fdb675d] .el-input__inner::placeholder {\n  /* stylelint-disable-next-line declaration-no-important */\n  color: #1b266f !important;\n}\n.el-select[data-v-2fdb675d] .el-input__suffix {\n  display: none;\n}\n.el-select[data-v-2fdb675d]:hover .el-input:not(.is-focus) .el-input__inner {\n  border-color: #c1c1c1;\n}\n.el-select-group .el-select-dropdown__item[data-v-2fdb675d] {\n  padding-left: 10px;\n}\n[data-v-2fdb675d] .el-select-group__title {\n  padding-left: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #1b266f;\n  border-bottom: 1px solid #efefef;\n}\n\n/*# sourceMappingURL=TfSelectText.vue.map */", map: {"version":3,"sources":["TfSelectText.vue","/home/circleci/repo/src/components/TfForm/TfSelectText.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC6EpC;EACA,WAAA;AD3EA;AC8EA;EACA,yBAAA;AD5EA;AC8EA;EAEA,yDAAA;EACA,yBAAA;AD7EA;ACiFA;EACA,aAAA;AD/EA;ACqFA;EACA,qBAAA;ADnFA;ACyFA;EACA,kBAAA;ADtFA;ACyFA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,cAAA;EACA,gCAAA;ADxFA;;AAEA,2CAA2C","file":"TfSelectText.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.el-select {\n  width: 100%;\n}\n.el-select ::v-deep.el-input__inner {\n  border-color: transparent;\n}\n.el-select ::v-deep.el-input__inner, .el-select ::v-deep.el-input__inner::placeholder {\n  /* stylelint-disable-next-line declaration-no-important */\n  color: #1b266f !important;\n}\n.el-select ::v-deep.el-input__suffix {\n  display: none;\n}\n.el-select:hover ::v-deep.el-input:not(.is-focus) .el-input__inner {\n  border-color: #c1c1c1;\n}\n\n.el-select-group .el-select-dropdown__item {\n  padding-left: 10px;\n}\n\n::v-deep .el-select-group__title {\n  padding-left: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #1b266f;\n  border-bottom: 1px solid #efefef;\n}\n\n/*# sourceMappingURL=TfSelectText.vue.map */","<template>\n  <tf-select\n    v-model=\"selected\"\n    :no-match-text=\"noMatchText\"\n    :placeholder=\"placeholder\"\n    class=\"tf-select-text wt-select-text\"\n    filterable\n    @change=\"$emit('change', $event)\"\n    @input=\"$emit('input', $event)\"\n    @blur=\"$emit('blur')\"\n    @focus=\"$emit('focus')\"\n  >\n    <el-option-group\n      :label=\"title\"\n    >\n      <el-option\n        v-for=\"option in options\"\n        :key=\"option[optionValue]\"\n        :value=\"option[optionValue]\"\n        :label=\"option[optionText]\"\n      />\n    </el-option-group>\n  </tf-select>\n</template>\n\n<script>\n/**\n * TfSelectText popover compononent\n *\n * @vuedoc\n * @exports TfPopover/TfSelectText\n * @category Components\n */\n\n  export default {\n    name: 'TfSelectText',\n    props: {\n      noMatchText: {\n        type: String,\n        default: 'Option not found',\n      },\n      options: {\n        type: Array,\n        required: true,\n        default: () => [],\n      },\n      optionText: {\n        type: String,\n        default: 'name',\n      },\n      optionValue: {\n        type: String,\n        default: 'id',\n      },\n      placeholder: {\n        type: String,\n        default: 'n/a',\n      },\n      title: {\n        type: String,\n        required: true,\n        default: 'Select option',\n      },\n      value: {\n        type: [Number, String],\n        default: null,\n      },\n    },\n\n    data: () => ({\n      selected: null,\n    }),\n\n    created() {\n      this.selected = this.value;\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .el-select {\n    width: 100%;\n\n    ::v-deep.el-input {\n      &__inner {\n        border-color: transparent;\n\n        &,\n        &::placeholder {\n          /* stylelint-disable-next-line declaration-no-important */\n          color: $tf-dark-blue !important;\n        }\n      }\n\n      &__suffix {\n        display: none;\n      }\n    }\n\n    &:hover {\n      ::v-deep.el-input:not(.is-focus) {\n        .el-input__inner {\n          border-color: $tf-light-gray;\n        }\n      }\n    }\n  }\n\n  .el-select-group .el-select-dropdown__item {\n    padding-left: 10px;\n  }\n\n  ::v-deep .el-select-group__title {\n    padding-left: 10px;\n    font: {\n      size: 14px;\n      weight: 700;\n    }\n    color: $tf-dark-blue;\n    border-bottom: 1px solid $tf-extra-light-gray-1;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$j = "data-v-2fdb675d";
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Tag
 *
 * @vuedoc
 * @exports TfTag
 * @category Components
 */
var script$k = {
  name: 'TfTag',
  props: {
    text: {
      type: String,
      required: true
    },
    closable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * Emit a close event on click
     */
    onClose: function onClose() {
      this.$emit('close');
    }
  }
};

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    { class: ["tag", _vm.type] },
    [
      _c("span", {
        staticClass: "text",
        domProps: { textContent: _vm._s(_vm.text) }
      }),
      _vm._v(" "),
      _vm.closable
        ? _c("tf-button", {
            staticClass: "close-btn",
            attrs: { type: "secondary", icon: "times", size: "icon-no-fill" },
            on: { click: _vm.onClose }
          })
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

  /* style */
  const __vue_inject_styles__$k = function (inject) {
    if (!inject) return
    inject("data-v-8b00e8dc_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tag[data-v-8b00e8dc] {\n  display: flex;\n  min-width: 80px;\n  padding: 0 10px;\n  background: #efefef;\n  margin: 0 20px 20px 0;\n}\n.text[data-v-8b00e8dc] {\n  flex-grow: 1;\n  color: #000;\n  font-size: 14px;\n  line-height: 29px;\n}\n.wt-button--icon-no-fill.has-icon[data-v-8b00e8dc],\n.tf-button--icon-no-fill.has-icon[data-v-8b00e8dc] {\n  flex-grow: 0;\n}\n.wt-button--icon-no-fill.has-icon[data-v-8b00e8dc] svg,\n.tf-button--icon-no-fill.has-icon[data-v-8b00e8dc] svg {\n  fill: #42474c;\n}\n\n/*# sourceMappingURL=TfTag.vue.map */", map: {"version":3,"sources":["TfTag.vue","/home/circleci/repo/src/components/TfForm/TfTag.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC2DpC;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;ADzDA;AC4DA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;ADzDA;AC4DA;;EAEA,YAAA;ADzDA;AC2DA;;EACA,aAAA;ADxDA;;AAEA,oCAAoC","file":"TfTag.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tag {\n  display: flex;\n  min-width: 80px;\n  padding: 0 10px;\n  background: #efefef;\n  margin: 0 20px 20px 0;\n}\n\n.text {\n  flex-grow: 1;\n  color: #000;\n  font-size: 14px;\n  line-height: 29px;\n}\n\n.wt-button--icon-no-fill.has-icon::v-deep,\n.tf-button--icon-no-fill.has-icon::v-deep {\n  flex-grow: 0;\n}\n.wt-button--icon-no-fill.has-icon::v-deep svg,\n.tf-button--icon-no-fill.has-icon::v-deep svg {\n  fill: #42474c;\n}\n\n/*# sourceMappingURL=TfTag.vue.map */","<template>\n  <span\n    :class=\"[\n      'tag',\n      type\n    ]\"\n  >\n    <span\n      class=\"text\"\n      v-text=\"text\"\n    />\n\n    <tf-button\n      v-if=\"closable\"\n      class=\"close-btn\"\n      type=\"secondary\"\n      icon=\"times\"\n      size=\"icon-no-fill\"\n      @click=\"onClose\"\n    />\n  </span>\n</template>\n\n<script>\n/**\n * WatchTower Tag\n *\n * @vuedoc\n * @exports TfTag\n * @category Components\n */\n\n  export default {\n    name: 'TfTag',\n\n    props: {\n      text: {\n        type: String,\n        required: true,\n      },\n      closable: {\n        type: Boolean,\n        default: false,\n      },\n      type: {\n        type: String,\n        default: '',\n      },\n    },\n\n    methods: {\n      /**\n       * Emit a close event on click\n       */\n      onClose() {\n        this.$emit('close');\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tag {\n    display: flex;\n    min-width: 80px;\n    padding: 0 10px;\n    background: $tf-extra-light-gray-1;\n    margin: 0 20px 20px 0;\n  }\n\n  .text {\n    flex-grow: 1;\n    color: $tf-black;\n    font-size: 14px;\n    line-height: 29px;\n  }\n\n  .wt-button--icon-no-fill.has-icon::v-deep,\n  .tf-button--icon-no-fill.has-icon::v-deep {\n    flex-grow: 0;\n\n    svg {\n      fill: $tf-dark-gray;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$k = "data-v-8b00e8dc";
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * WatchTower Tag Field
 *
 * @vuedoc
 * @exports TfForm/TfTagField
 * @category Components
 */
var script$l = {
  name: 'TfTagField',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    /**
     * When a tag is close, remove it and emit an "input" event, per the v-model…model.
     *
     * @param {number} index
     */
    onClose: function onClose(index) {
      var value = _toConsumableArray(this.value);

      value.splice(index, 1);
      this.$emit('input', value);
    }
  }
};

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "tag-field" },
    [
      _vm._l(_vm.value, function(tag, tagIndex) {
        return _c("tf-tag", {
          key: tagIndex,
          attrs: { text: tag.text, closable: tag.closable || _vm.closable },
          on: {
            close: function($event) {
              return _vm.onClose(tagIndex)
            }
          }
        })
      }),
      _vm._v(" "),
      _vm.placeholder && !_vm.value.length
        ? _c("span", {
            staticClass: "placeholder",
            domProps: { textContent: _vm._s(_vm.placeholder) }
          })
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;

  /* style */
  const __vue_inject_styles__$l = function (inject) {
    if (!inject) return
    inject("data-v-55fa314f_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tag-field[data-v-55fa314f] {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px 0 0 20px;\n  border: 1px #c1c1c1 solid;\n  border-radius: 2px;\n  min-height: 49px;\n}\n.placeholder[data-v-55fa314f] {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 16px;\n  margin-bottom: 20px;\n  color: #999;\n}\n\n/*# sourceMappingURL=TfTagField.vue.map */", map: {"version":3,"sources":["TfTagField.vue","/home/circleci/repo/src/components/TfForm/TfTagField.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC8DpC;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AD5DA;AC+DA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AD5DA;;AAEA,yCAAyC","file":"TfTagField.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tag-field {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px 0 0 20px;\n  border: 1px #c1c1c1 solid;\n  border-radius: 2px;\n  min-height: 49px;\n}\n\n.placeholder {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 16px;\n  margin-bottom: 20px;\n  color: #999;\n}\n\n/*# sourceMappingURL=TfTagField.vue.map */","<template>\n  <div class=\"tag-field\">\n    <tf-tag\n      v-for=\"(tag, tagIndex) of value\"\n      :key=\"tagIndex\"\n      :text=\"tag.text\"\n      :closable=\"tag.closable || closable\"\n      @close=\"onClose(tagIndex)\"\n    />\n    <span\n      v-if=\"placeholder && !value.length\"\n      class=\"placeholder\"\n      v-text=\"placeholder\"\n    />\n  </div>\n</template>\n\n<script>\n/**\n * WatchTower Tag Field\n *\n * @vuedoc\n * @exports TfForm/TfTagField\n * @category Components\n */\n\n  export default {\n    name: 'TfTagField',\n\n    props: {\n      placeholder: {\n        type: String,\n        default: '',\n      },\n      type: {\n        type: String,\n        default: '',\n      },\n      closable: {\n        type: Boolean,\n        default: false,\n      },\n      value: {\n        type: Array,\n        default: () => [],\n      },\n    },\n    methods: {\n      /**\n       * When a tag is close, remove it and emit an \"input\" event, per the v-model…model.\n       *\n       * @param {number} index\n       */\n      onClose(index) {\n        const value = [...this.value];\n\n        value.splice(index, 1);\n\n        this.$emit('input', value);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tag-field {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 20px 0 0 20px;\n    border: 1px $tf-light-gray solid;\n    border-radius: 2px;\n    min-height: 49px;\n  }\n\n  .placeholder {\n    display: inline-block;\n    font-size: 14px;\n    line-height: 16px;\n    margin-bottom: 20px;\n    color: $tf-medium-gray;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$l = "data-v-55fa314f";
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Quote Edits Export Row
 *
 * @vuedoc
 * @exports components/TfPdfExport/QuoteEdits/Row
 * @category Components
 */
var script$m = {
  name: 'QuoteEditsExportRow',
  props: {
    leftEdit: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rightEdit: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "quote-edit-row pdf-export-block" }, [
    _c(
      "div",
      { staticClass: "left" },
      [
        _vm.leftEdit.created_at
          ? _c("history-item", { attrs: { item: _vm.leftEdit, tag: "div" } })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right" },
      [
        _vm.rightEdit.created_at
          ? _c("history-item", { attrs: { item: _vm.rightEdit, tag: "div" } })
          : _vm._e()
      ],
      1
    )
  ])
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;

  /* style */
  const __vue_inject_styles__$m = function (inject) {
    if (!inject) return
    inject("data-v-9d67839a_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.history-item[data-v-9d67839a] {\n  padding: 0;\n  text-align: left;\n  border: 0;\n}\n.history-item[data-v-9d67839a] p,\n.history-item[data-v-9d67839a] .time {\n  font-size: 12px;\n  line-height: 16px;\n  color: #000;\n}\n.quote-edit-row[data-v-9d67839a] {\n  display: flex;\n  width: 504px;\n}\n.quote-edit-row div[data-v-9d67839a] {\n  flex: 1 0;\n  width: 220px;\n  padding-right: 32px;\n  padding-bottom: 20px;\n}\n.quote-edit-row div[data-v-9d67839a]:nth-child(2) {\n  padding-left: 32px;\n  padding-right: 0;\n}\n\n/*# sourceMappingURL=Row.vue.map */", map: {"version":3,"sources":["Row.vue","/home/circleci/repo/src/components/TfPdfExport/QuoteEdits/Row.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACwCpC;EACA,UAAA;EACA,gBAAA;EACA,SAAA;ADtCA;ACwCA;;EAEA,eAAA;EACA,iBAAA;EACA,WAAA;ADtCA;AC0CA;EACA,aAAA;EACA,YAAA;ADvCA;ACyCA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;ADvCA;AC0CA;EACA,kBAAA;EACA,gBAAA;ADxCA;;AAEA,kCAAkC","file":"Row.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.history-item::v-deep {\n  padding: 0;\n  text-align: left;\n  border: 0;\n}\n.history-item::v-deep p,\n.history-item::v-deep .time {\n  font-size: 12px;\n  line-height: 16px;\n  color: #000;\n}\n\n.quote-edit-row {\n  display: flex;\n  width: 504px;\n}\n.quote-edit-row div {\n  flex: 1 0;\n  width: 220px;\n  padding-right: 32px;\n  padding-bottom: 20px;\n}\n.quote-edit-row div:nth-child(2) {\n  padding-left: 32px;\n  padding-right: 0;\n}\n\n/*# sourceMappingURL=Row.vue.map */","<template>\n  <div class=\"quote-edit-row pdf-export-block\">\n    <div class=\"left\">\n      <history-item\n        v-if=\"leftEdit.created_at\"\n        :item=\"leftEdit\"\n        tag=\"div\"\n      />\n    </div>\n    <div class=\"right\">\n      <history-item\n        v-if=\"rightEdit.created_at\"\n        :item=\"rightEdit\"\n        tag=\"div\"\n      />\n    </div>\n  </div>\n</template>\n\n<script>\n/**\n * Quote Edits Export Row\n *\n * @vuedoc\n * @exports components/TfPdfExport/QuoteEdits/Row\n * @category Components\n */\n  export default {\n    name: 'QuoteEditsExportRow',\n    props: {\n      leftEdit: {\n        type: Object,\n        default: () => ({}),\n      },\n      rightEdit: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .history-item::v-deep {\n    padding: 0;\n    text-align: left;\n    border: 0;\n\n    p,\n    .time {\n      font-size: 12px;\n      line-height: 16px;\n      color: $tf-black;\n    }\n  }\n\n  .quote-edit-row {\n    display: flex;\n    width: 504px;\n\n    div {\n      flex: 1 0;\n      width: 220px;\n      padding-right: 32px;\n      padding-bottom: 20px;\n    }\n\n    div:nth-child(2) {\n      padding-left: 32px;\n      padding-right: 0;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$m = "data-v-9d67839a";
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    browser,
    undefined,
    undefined
  );

var $map = _arrayMethods(1);

_export(_export.P + _export.F * !_strictMethod([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

/**
 * PdfExportHeader
 *
 * @vuedoc
 * @exports components/TfPdfExport/Header
 * @category Components
 */

var script$n = {
  name: 'TfPdfExportHeader',
  props: {
    employerName: {
      type: String,
      required: true,
      default: null
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    title: {
      type: String,
      required: true,
      default: null
    }
  },
  computed: {
    /**
     * Generates today's date for template.
     *
     * @returns {string}
     */
    today: function today() {
      return moment().format('MM/DD/YYYY');
    },

    /**
     * Converts the filter object to array of objects with { type, values }.
     *
     * @returns {Array}
     */
    renderedFilters: function renderedFilters() {
      var _this = this;

      return Object.keys(this.filters).map(function (type) {
        return {
          type: type,
          values: _this.filters[type]
        };
      });
    },

    /**
     * Looks for any of the filters in renderedFilters to see if they have length.
     *
     * @returns {boolean}
     */
    showFilters: function showFilters() {
      return this.renderedFilters.length && this.renderedFilters.some(function (filter) {
        return filter.values.length;
      });
    }
  }
};

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("header", { class: ["pdf-export-block", "pdf-export-header"] }, [
    _c("h1", [_vm._v(_vm._s(_vm.employerName))]),
    _vm._v(" "),
    _c("h2", [_vm._v(_vm._s(_vm.title) + " as of " + _vm._s(_vm.today))]),
    _vm._v(" "),
    _vm.showFilters
      ? _c(
          "div",
          { staticClass: "applied-filters" },
          [
            _vm._l(_vm.renderedFilters, function(filter) {
              return [
                filter.values.length
                  ? _c("p", { key: filter.type }, [
                      _c("strong", [_vm._v(_vm._s(filter.type))]),
                      _vm._v(
                        ": " + _vm._s(filter.values.join("; ")) + "\n      "
                      )
                    ])
                  : _vm._e()
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;

  /* style */
  const __vue_inject_styles__$n = function (inject) {
    if (!inject) return
    inject("data-v-fe71925c_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nheader[data-v-fe71925c] {\n  border-bottom: 2px tf-light-gray solid;\n  padding-bottom: 20px;\n  text-align: left;\n  width: calc(100% - 80px);\n}\nh1[data-v-fe71925c],\nh2[data-v-fe71925c] {\n  font-weight: bold;\n  color: #000;\n}\nh1[data-v-fe71925c] {\n  font-size: 20px;\n}\nh2[data-v-fe71925c] {\n  font-size: 16px;\n}\n.applied-filters[data-v-fe71925c] {\n  background: #efefef;\n  color: #000;\n  padding: 9px 12px;\n  font-size: 12px;\n  line-height: 18px;\n}\n.applied-filters strong[data-v-fe71925c] {\n  text-transform: capitalize;\n}\n\n/*# sourceMappingURL=Header.vue.map */", map: {"version":3,"sources":["Header.vue","/home/circleci/repo/src/components/TfPdfExport/Header.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACuFpC;EACA,sCAAA;EACA,oBAAA;EACA,gBAAA;EACA,wBAAA;ADrFA;ACwFA;;EAEA,iBAAA;EACA,WAAA;ADrFA;ACwFA;EACA,eAAA;ADrFA;ACwFA;EACA,eAAA;ADrFA;ACwFA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;ADrFA;ACuFA;EACA,0BAAA;ADrFA;;AAEA,qCAAqC","file":"Header.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nheader {\n  border-bottom: 2px tf-light-gray solid;\n  padding-bottom: 20px;\n  text-align: left;\n  width: calc(100% - 80px);\n}\n\nh1,\nh2 {\n  font-weight: bold;\n  color: #000;\n}\n\nh1 {\n  font-size: 20px;\n}\n\nh2 {\n  font-size: 16px;\n}\n\n.applied-filters {\n  background: #efefef;\n  color: #000;\n  padding: 9px 12px;\n  font-size: 12px;\n  line-height: 18px;\n}\n.applied-filters strong {\n  text-transform: capitalize;\n}\n\n/*# sourceMappingURL=Header.vue.map */","<template>\n  <header\n    :class=\"[\n      'pdf-export-block',\n      'pdf-export-header'\n    ]\"\n  >\n    <h1>{{ employerName }}</h1>\n    <h2>{{ title }} as of {{ today }}</h2>\n    <div\n      v-if=\"showFilters\"\n      class=\"applied-filters\"\n    >\n      <template v-for=\"filter in renderedFilters\">\n        <p\n          v-if=\"filter.values.length\"\n          :key=\"filter.type\"\n        >\n          <strong>{{ filter.type }}</strong>: {{ filter.values.join('; ') }}\n        </p>\n      </template>\n    </div>\n  </header>\n</template>\n\n<script>\n  import moment from 'moment';\n\n  /**\n   * PdfExportHeader\n   *\n   * @vuedoc\n   * @exports components/TfPdfExport/Header\n   * @category Components\n   */\n  export default {\n    name: 'TfPdfExportHeader',\n    props: {\n      employerName: {\n        type: String,\n        required: true,\n        default: null,\n      },\n      filters: {\n        type: Object,\n        default: () => ({}),\n      },\n      title: {\n        type: String,\n        required: true,\n        default: null,\n      },\n    },\n\n    computed: {\n      /**\n       * Generates today's date for template.\n       *\n       * @returns {string}\n       */\n      today() {\n        return moment().format('MM/DD/YYYY');\n      },\n\n      /**\n       * Converts the filter object to array of objects with { type, values }.\n       *\n       * @returns {Array}\n       */\n      renderedFilters() {\n        return Object.keys(this.filters).map((type) => ({\n          type,\n          values: this.filters[type],\n        }));\n      },\n\n      /**\n       * Looks for any of the filters in renderedFilters to see if they have length.\n       *\n       * @returns {boolean}\n       */\n      showFilters() {\n        return this.renderedFilters.length\n          && this.renderedFilters.some((filter) => filter.values.length);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/variables';\n\nheader {\n  border-bottom: 2px tf-light-gray solid;\n  padding-bottom: 20px;\n  text-align: left;\n  width: calc(100% - 80px);\n}\n\nh1,\nh2 {\n  font-weight: bold;\n  color: $tf-black;\n}\n\nh1 {\n  font-size: 20px;\n}\n\nh2 {\n  font-size: 16px;\n}\n\n.applied-filters {\n  background: $tf-extra-light-gray-1;\n  color: $tf-black;\n  padding: 9px 12px;\n  font-size: 12px;\n  line-height: 18px;\n\n  strong {\n    text-transform: capitalize;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$n = "data-v-fe71925c";
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    browser,
    undefined,
    undefined
  );

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Quote Edits Export
 *
 * @vuedoc
 * @exports components/TfPdfExport/QuoteEdits/index
 * @category Components
 */

var script$o = {
  name: 'TfQuoteEditsExport',
  components: {
    QuoteEditsExportRow: __vue_component__$m,
    ExportHeader: __vue_component__$n
  },
  props: {
    buttonSize: {
      type: String,
      default: 'text-icon'
    },
    buttonTitle: {
      type: String,
      default: 'export'
    },
    dates: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    employerName: {
      type: String,
      default: null
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  computed: {
    /**
     * Returns a version of the quote edits structure split across columns
     *
     * @returns {Array}
     */
    edits: function edits() {
      var columnEdits = {
        left: [],
        right: []
      };
      this.dates.reduce(function (edits, date) {
        return edits.concat(date);
      }, []).forEach(function (edit, index) {
        columnEdits[index % 2 ? 'right' : 'left'].push(_objectSpread$2(_objectSpread$2({}, edit), {}, {
          position: index
        }));
      });
      return columnEdits;
    }
  }
};

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    [
      _c(
        "tf-pdf-export",
        {
          attrs: {
            "button-size": _vm.buttonSize,
            "button-title": _vm.buttonTitle,
            "is-disabled": !_vm.dates.length,
            filename: "quote-edits_" + _vm.projectId + ".pdf"
          }
        },
        [
          _c("export-header", {
            attrs: {
              "employer-name": _vm.employerName,
              filters: _vm.filters,
              title: "Quote Edits History"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.edits.left, function(left, index) {
            return _c("quote-edits-export-row", {
              key: index,
              attrs: { "left-edit": left, "right-edit": _vm.edits.right[index] }
            })
          })
        ],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;

  /* style */
  const __vue_inject_styles__$o = undefined;
  /* scoped */
  const __vue_scope_id__$o = undefined;
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    undefined,
    undefined,
    undefined
  );

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * PDF Exporter for Comments
 *
 * @vuedoc
 * @exports TfPdfExport/Comments
 * @category Components
 */

var script$p = {
  name: 'TfCommentsExport',
  components: {
    ExportHeader: __vue_component__$n
  },
  props: {
    broker: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    buttonSize: {
      type: String,
      default: 'text-icon'
    },
    buttonTitle: {
      type: String,
      default: 'export'
    },
    comments: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    documents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    employerName: {
      type: String,
      default: null
    },
    filters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      default: null
    },
    userInfo: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          firstName: '',
          lastName: '',
          organization: '',
          type: 'broker'
        };
      }
    }
  },
  computed: {
    /**
     * Sorts the comment replies in descending order and adds `topComment` to the top comments.
     * Then we return a flattened array of all comments.
     *
     * @returns {Array}
     */
    sortedComments: function sortedComments() {
      var _this = this;

      return this.comments.reduce(function (comments, comment) {
        var newComment = _objectSpread$3(_objectSpread$3({}, comment), {}, {
          replies: [],
          topComment: true
        });

        var sortedReplies = comment.replies ? _this.$TF.Formatting.sortObjects(comment.replies, 'created_at', 'desc') : [];
        return comments.concat([newComment], sortedReplies);
      }, []);
    }
  }
};

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    [
      _c(
        "tf-pdf-export",
        {
          attrs: {
            "button-size": _vm.buttonSize,
            "button-title": _vm.buttonTitle,
            filename: "comments_" + _vm.projectId + ".pdf",
            "is-disabled": !_vm.sortedComments.length
          }
        },
        [
          _c("export-header", {
            attrs: {
              "employer-name": _vm.employerName,
              filters: _vm.filters,
              title: "Comment History"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.sortedComments, function(comment) {
            return _c("comment", {
              key: comment.id,
              attrs: {
                broker: _vm.broker,
                comment: comment,
                documents: _vm.documents,
                "project-id": _vm.projectId,
                "is-pdf-render": true,
                "is-reply": !comment.topComment,
                "user-info": _vm.userInfo,
                "application-namespace": "export"
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;

  /* style */
  const __vue_inject_styles__$p = undefined;
  /* scoped */
  const __vue_scope_id__$p = undefined;
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//

/**
 * PDF Export
 *
 * @vuedoc
 * @exports TfPdfExport
 * @category components
 */
var script$q = {
  name: 'TfPdfExport',
  props: {
    filename: {
      type: String,
      default: 'export.pdf'
    }
  },
  data: function data() {
    return {
      pages: []
    };
  },
  mounted: function mounted() {
    this.exportPdf();
  },
  methods: {
    /**
     * Get element height including margin and padding
     *
     * @param {object} element
     * @returns {number}
     */
    getHeight: function getHeight(element) {
      return ['height', 'margin-top', 'margin-bottom', 'padding-top', 'padding-bottom'].reduce(function (height, propertyName) {
        return height + Number(document.defaultView.getComputedStyle(element, '').getPropertyValue(propertyName).replace(/px$/, ''));
      }, 0);
    },

    /**
     * Create new DIV element
     *
     * @param {string} className
     * @returns {object}
     */
    generateDiv: function generateDiv(className) {
      var div = document.createElement('div');

      if (className) {
        div.className = className;
      }

      return div;
    },

    /**
     * Generate PDF via JsPDF
     *
     * @returns {object}
     */
    generatePdf: function generatePdf() {
      var _this = this;

      var pdfDocument = document.implementation.createHTMLDocument('pdf-export');
      pdfDocument.className = 'pdf-export-document'; // page 1

      var pdfPage = this.generateDiv('pdf-export-page');
      var pageHeight = 40; // design has 40px margin all around

      var blocksInDocument = 0;
      var lastBlockOnPage = 0;
      var blocks = [];
      this.$el.querySelectorAll('.pdf-export-block').forEach(function (block) {
        var cloneBlock = block; // this is the only point at which the height value reflects reality, so we need to store it

        cloneBlock.setAttribute('block-height', _this.getHeight(block));
        blocks.push(cloneBlock);
      });

      while (blocks.length > 0) {
        var block = blocks.splice(0, 1)[0];
        var blockHeight = Number(block.getAttribute('block-height'));

        if (pageHeight + blockHeight > 730) {
          // we need to add another page
          lastBlockOnPage = blocksInDocument;
          this.pages.push(pdfPage);
          pdfPage = this.generateDiv('pdf-export-page');
          pageHeight = 40;
        }

        block.style.position = 'absolute';
        block.style.left = '40px';
        block.style.top = "".concat(pageHeight, "px");
        pdfPage.appendChild(block);
        pageHeight += blockHeight;
        blocksInDocument += 1;
      }

      if (blocksInDocument > lastBlockOnPage + 1) {
        // one or more elements were added to a pdfPage but the page wasn't added to the pages array yet
        this.pages.push(pdfPage);
      } // insert pagination div


      this.pages.forEach(function (page, index) {
        var pagination = _this.generateDiv('pagination');

        pagination.innerHTML = "Page ".concat(index + 1, " of ").concat(_this.pages.length);
        page.appendChild(pagination);
        pdfDocument.body.appendChild(page);
      });
      return pdfDocument.body;
    },

    /**
     * Export PDF via JsPDF.
     * jest/mocha (well, node) can't deal with this version of jsPDF at this time so we're cheating here and using require.
     * TODO:
     * - conditionally load node version here; note that that library does not expose a save() method because Node is expected to handle it's own file saving
     * - if we want to test the result, we'd have to account for that some other way
     */
    exportPdf: function exportPdf() {
      var _this2 = this;

      var JsPDF = require('jspdf'); // eslint-disable-line


      var pdfFile = new JsPDF('p', 'pt', 'letter'); // needed for the .html() method on jsPDF (but is somehow not a requirement for jsPDF)

      if (!window.html2canvas) {
        var html2canvas = require('html2canvas'); // eslint-disable-line


        window.html2canvas = html2canvas;
      }

      pdfFile.html(this.generatePdf(), {
        callback: function callback() {
          // occasionally when window page height is larger or equal to 730px blank page(s) will be added
          // to end of pdf document. these need to be checked after generation and be will deleted before save
          var pdfPages = pdfFile.internal.getNumberOfPages();

          if (pdfPages > _this2.pages.length) {
            for (pdfPages; pdfPages > _this2.pages.length; pdfPages -= 1) {
              pdfFile.deletePage(pdfPages);
            }
          }

          pdfFile.save(_this2.filename);

          _this2.$emit('save');
        },
        html2canvas: {
          scale: 1,
          logging: false // this was spitting out console logs

        }
      });
    }
  }
};

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "pdf-export-markup" }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;

  /* style */
  const __vue_inject_styles__$q = function (inject) {
    if (!inject) return
    inject("data-v-54e0325e_0", { source: "/**\n* This file is intentially unscoped since there are divs being created in the methods.\n*/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.pdf-export-document {\n  width: 610px;\n}\n.pdf-export-markup {\n  position: fixed;\n  top: -1000em;\n  left: -1000em;\n  width: 630px;\n}\n.pdf-export-page {\n  position: relative;\n  width: 610px;\n  height: 792px;\n  padding: 0;\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n.pagination {\n  position: absolute;\n  bottom: 30px;\n  right: 40px;\n  font-size: 10px;\n  color: #42474c;\n}\n\n/*# sourceMappingURL=ExportFile.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/TfPdfExport/ExportFile.vue","ExportFile.vue"],"names":[],"mappings":"AAwKA;;CAAA;ACrKA;;kCAEkC;AAClC;;oCAEoC;ADqKpC;EACA,YAAA;ACnKA;ADsKA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;ACnKA;ADsKA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;ACnKA;ADsKA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;ACnKA;;AAEA,yCAAyC","file":"ExportFile.vue","sourcesContent":["<template>\n  <div class=\"pdf-export-markup\">\n    <slot />\n  </div>\n</template>\n\n<script>\n  /**\n   * PDF Export\n   *\n   * @vuedoc\n   * @exports TfPdfExport\n   * @category components\n   */\n  export default {\n    name: 'TfPdfExport',\n    props: {\n      filename: {\n        type: String,\n        default: 'export.pdf',\n      },\n    },\n    data() {\n      return { pages: [] };\n    },\n    mounted() {\n      this.exportPdf();\n    },\n    methods: {\n      /**\n       * Get element height including margin and padding\n       *\n       * @param {object} element\n       * @returns {number}\n       */\n      getHeight(element) {\n        return [\n          'height',\n          'margin-top',\n          'margin-bottom',\n          'padding-top',\n          'padding-bottom',\n        ].reduce(\n          (height, propertyName) => height + Number(\n            document\n              .defaultView\n              .getComputedStyle(element, '')\n              .getPropertyValue(propertyName)\n              .replace(/px$/, ''),\n          ),\n          0,\n        );\n      },\n      /**\n       * Create new DIV element\n       *\n       * @param {string} className\n       * @returns {object}\n       */\n      generateDiv(className) {\n        const div = document.createElement('div');\n        if (className) {\n          div.className = className;\n        }\n        return div;\n      },\n      /**\n       * Generate PDF via JsPDF\n       *\n       * @returns {object}\n       */\n      generatePdf() {\n        const pdfDocument = document.implementation.createHTMLDocument('pdf-export');\n        pdfDocument.className = 'pdf-export-document';\n\n        // page 1\n        let pdfPage = this.generateDiv('pdf-export-page');\n        let pageHeight = 40; // design has 40px margin all around\n        let blocksInDocument = 0;\n        let lastBlockOnPage = 0;\n        const blocks = [];\n\n        this.$el.querySelectorAll('.pdf-export-block').forEach((block) => {\n          const cloneBlock = block;\n          // this is the only point at which the height value reflects reality, so we need to store it\n          cloneBlock.setAttribute('block-height', this.getHeight(block));\n          blocks.push(cloneBlock);\n        });\n\n        while (blocks.length > 0) {\n          const block = blocks.splice(0, 1)[0];\n          const blockHeight = Number(block.getAttribute('block-height'));\n          if (pageHeight + blockHeight > 730) {\n            // we need to add another page\n            lastBlockOnPage = blocksInDocument;\n            this.pages.push(pdfPage);\n            pdfPage = this.generateDiv('pdf-export-page');\n            pageHeight = 40;\n          }\n\n          block.style.position = 'absolute';\n          block.style.left = '40px';\n          block.style.top = `${pageHeight}px`;\n          pdfPage.appendChild(block);\n          pageHeight += blockHeight;\n          blocksInDocument += 1;\n        }\n\n        if (blocksInDocument > lastBlockOnPage + 1) {\n          // one or more elements were added to a pdfPage but the page wasn't added to the pages array yet\n          this.pages.push(pdfPage);\n        }\n\n        // insert pagination div\n        this.pages.forEach((page, index) => {\n          const pagination = this.generateDiv('pagination');\n          pagination.innerHTML = `Page ${index + 1} of ${this.pages.length}`;\n          page.appendChild(pagination);\n          pdfDocument.body.appendChild(page);\n        });\n\n        return pdfDocument.body;\n      },\n      /**\n       * Export PDF via JsPDF.\n       * jest/mocha (well, node) can't deal with this version of jsPDF at this time so we're cheating here and using require.\n       * TODO:\n       * - conditionally load node version here; note that that library does not expose a save() method because Node is expected to handle it's own file saving\n       * - if we want to test the result, we'd have to account for that some other way\n       */\n      exportPdf() {\n        const JsPDF = require('jspdf'); // eslint-disable-line\n        const pdfFile = new JsPDF('p', 'pt', 'letter');\n\n        // needed for the .html() method on jsPDF (but is somehow not a requirement for jsPDF)\n        if (!window.html2canvas) {\n          const html2canvas = require('html2canvas'); // eslint-disable-line\n          window.html2canvas = html2canvas;\n        }\n\n        pdfFile.html(\n          this.generatePdf(),\n          {\n            callback: () => {\n              // occasionally when window page height is larger or equal to 730px blank page(s) will be added\n              // to end of pdf document. these need to be checked after generation and be will deleted before save\n              let pdfPages = pdfFile.internal.getNumberOfPages();\n\n              if (pdfPages > this.pages.length) {\n                for (pdfPages; pdfPages > this.pages.length; pdfPages -= 1) {\n                  pdfFile.deletePage(pdfPages);\n                }\n              }\n              pdfFile.save(this.filename);\n              this.$emit('save');\n            },\n            html2canvas: {\n              scale: 1,\n              logging: false, // this was spitting out console logs\n            },\n          },\n        );\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\">\n  /**\n  * This file is intentially unscoped since there are divs being created in the methods.\n  */\n  @import 'src/assets/styles/variables';\n\n  .pdf-export-document {\n    width: 610px;\n  }\n\n  .pdf-export-markup {\n    position: fixed;\n    top: -1000em;\n    left: -1000em;\n    width: 630px;\n  }\n\n  .pdf-export-page {\n    position: relative;\n    width: 610px;\n    height: 792px;\n    padding: 0;\n    margin: 0;\n    font-family: Arial, sans-serif;\n  }\n\n  .pagination {\n    position: absolute;\n    bottom: 30px;\n    right: 40px;\n    font-size: 10px;\n    color: $tf-dark-gray;\n  }\n</style>\n","/**\n* This file is intentially unscoped since there are divs being created in the methods.\n*/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.pdf-export-document {\n  width: 610px;\n}\n\n.pdf-export-markup {\n  position: fixed;\n  top: -1000em;\n  left: -1000em;\n  width: 630px;\n}\n\n.pdf-export-page {\n  position: relative;\n  width: 610px;\n  height: 792px;\n  padding: 0;\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.pagination {\n  position: absolute;\n  bottom: 30px;\n  right: 40px;\n  font-size: 10px;\n  color: #42474c;\n}\n\n/*# sourceMappingURL=ExportFile.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$q = undefined;
  /* module identifier */
  const __vue_module_identifier__$q = undefined;
  /* functional template */
  const __vue_is_functional_template__$q = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$q = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    browser,
    undefined,
    undefined
  );

//
/**
 * PDF Export
 *
 * @vuedoc
 * @exports TfPdfExport
 * @category components
 */

var script$r = {
  name: 'TfPdfExport',
  components: {
    ExportFile: __vue_component__$q
  },
  props: {
    buttonSize: {
      type: String,
      default: 'text-icon'
    },
    buttonTitle: {
      type: String,
      default: 'export'
    },
    filename: {
      type: String,
      default: 'export.pdf'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      render: false,
      renderingPdf: false
    };
  },
  methods: {
    /**
     * Starts the render process.
     */
    startRender: function startRender() {
      this.renderingPdf = true;
      this.render = true;
    },

    /**
     * Stops the render process.
     */
    stopRender: function stopRender() {
      this.render = false;
      this.renderingPdf = false;
    }
  }
};

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "pdf-export-generator" },
    [
      _c(
        "tf-button",
        {
          attrs: {
            disabled: _vm.isDisabled,
            loading: _vm.renderingPdf,
            size: _vm.buttonSize,
            type: "primary",
            icon: "file-download"
          },
          on: { click: _vm.startRender }
        },
        [_vm._v("\n    " + _vm._s(_vm.buttonTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.render
        ? _c(
            "export-file",
            { attrs: { filename: _vm.filename }, on: { save: _vm.stopRender } },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$q = [];
__vue_render__$q._withStripped = true;

  /* style */
  const __vue_inject_styles__$r = undefined;
  /* scoped */
  const __vue_scope_id__$r = undefined;
  /* module identifier */
  const __vue_module_identifier__$r = undefined;
  /* functional template */
  const __vue_is_functional_template__$r = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$r = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    undefined,
    undefined,
    undefined
  );

var $at$1 = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at$1(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _redefineAll = function (target, src, safe) {
  for (var key in src) _redefine(target, key, src[key], safe);
  return target;
};

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

// call something on iterator step with safe closing on error

var _iterCall$1 = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$6 = _wks('iterator');
var ArrayProto$2 = Array.prototype;

var _isArrayIter$1 = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto$2[ITERATOR$6] === it);
};

var ITERATOR$7 = _wks('iterator');

var core_getIteratorMethod$1 = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$7]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod$1(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter$1(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall$1(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

var SPECIES$2 = _wks('species');

var _setSpecies = function (KEY) {
  var C = _global[KEY];
  if (_descriptors && C && !C[SPECIES$2]) _objectDp.f(C, SPECIES$2, {
    configurable: true,
    get: function () { return this; }
  });
};

var _meta$1 = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1$1 = _meta$1.KEY;
var _meta_2$1 = _meta$1.NEED;
var _meta_3$1 = _meta$1.fastKey;
var _meta_4$1 = _meta$1.getWeak;
var _meta_5$1 = _meta$1.onFreeze;

var _validateCollection = function (it, TYPE) {
  if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

var dP$4 = _objectDp.f;









var fastKey = _meta$1.fastKey;

var SIZE = _descriptors ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

var _collectionStrong = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = _objectCreate(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });
    _redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = _validateCollection(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        _validateCollection(this, NAME);
        var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(_validateCollection(this, NAME), key);
      }
    });
    if (_descriptors) dP$4(C.prototype, 'size', {
      get: function () {
        return _validateCollection(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    _iterDefine(C, NAME, function (iterated, kind) {
      this._t = _validateCollection(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return _iterStep(1);
      }
      // return step by kind
      if (kind == 'keys') return _iterStep(0, entry.k);
      if (kind == 'values') return _iterStep(0, entry.v);
      return _iterStep(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    _setSpecies(NAME);
  }
};

var ITERATOR$8 = _wks('iterator');
var SAFE_CLOSING$1 = false;

try {
  var riter$1 = [7][ITERATOR$8]();
  riter$1['return'] = function () { SAFE_CLOSING$1 = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter$1, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect$1 = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING$1) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$8]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$8] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = _global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    _redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !_isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    _redefineAll(C.prototype, methods);
    _meta$1.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = _fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = _iterDetect$1(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && _fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        _anInstance(target, C, NAME);
        var that = _inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  _setToStringTag(C, NAME);

  O[NAME] = C;
  _export(_export.G + _export.W + _export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

var SET = 'Set';

// 23.2 Set Objects
var es6_set = _collection(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
  }
}, _collectionStrong);

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $find = _arrayMethods(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY);

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $find$1 = _arrayMethods(6);
var KEY$1 = 'findIndex';
var forced$1 = true;
// Shouldn't skip holes
if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY$1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The "Product Options" for the Project Product Product selector.
 *
 * @vuedoc
 * @exports ProductSelector/ProductOption
 * @category Components
 */
var script$s = {
  name: 'TfProductOption',
  inject: ['TfProductSelector', 'productType'],
  props: {
    isParentLevel: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      hover: false
    };
  },
  computed: {
    /**
     * Determines if the product options is selected.
     *
     * @returns {boolean}
     */
    isActive: function isActive() {
      return this.TfProductSelector.value.includes(this.product.id);
    },

    /**
     * If productSelector is themed, set corresponding CSS colors
     *
     * @returns {object }
     */
    inlineStyle: function inlineStyle() {
      var style = {};

      if (this.TfProductSelector.themePrimaryColor) {
        if (this.isActive) {
          style.backgroundColor = this.TfProductSelector.themePrimaryColor;
        }
      }

      if (this.TfProductSelector.themeHoverColor && !this.isActive && this.hover) {
        style.backgroundColor = this.TfProductSelector.themeHoverColor;
        style.color = this.TfProductSelector.themePrimaryColor;
      }

      return style;
    },

    /**
     * Determines if the product options is disabled.
     *
     * @returns {boolean}
     */
    isDisabled: function isDisabled() {
      return this.TfProductSelector.disabledProducts.includes(this.product.id);
    }
  },
  methods: {
    /**
     * Emits the appropriate inject/emit types and payload.
     *
     * @param {string} type
     * @param {string} emit
     * @param {object} payload
     */
    emitPayload: function emitPayload(type, emit, payload) {
      this[type].$emit(emit, payload);
    },

    /**
     * Adds or removed the product ID and emits from the root TfProductSelector component.
     *
     */
    onClick: function onClick() {
      var _this = this;

      if (this.isDisabled) {
        return;
      }

      if (!this.TfProductSelector.allowMultiple && this.isActive) {
        this.emitPayload('productType', 'hidePopover');
        return;
      }

      var oldValue = _toConsumableArray(this.TfProductSelector.value);

      var productId = this.product.id;
      var action;
      var selectedProductIds = this.TfProductSelector.allowMultiple ? this.TfProductSelector.value : [];

      if (selectedProductIds.includes(productId)) {
        this.$delete(selectedProductIds, selectedProductIds.findIndex(function (id) {
          return id === productId;
        }));
        action = 'deleted';
      } else {
        action = this.TfProductSelector.allowMultiple ? 'added' : 'changed';
        selectedProductIds.push(productId);
      }

      selectedProductIds = this.$TF.Formatting.sortObjects(selectedProductIds.map(function (id) {
        return _this.TfProductSelector.products.find(function (product) {
          return product.id === id;
        });
      }), 'position').map(function (product) {
        return product.id;
      }); // Emits for all the changes

      this.emitPayload('TfProductSelector', 'input', selectedProductIds);
      this.emitPayload('TfProductSelector', 'change', {
        oldValue: oldValue,
        value: selectedProductIds
      });
      this.emitPayload('TfProductSelector', 'selectProductOption', {
        action: action,
        productId: productId,
        selectedProductIds: selectedProductIds
      });

      if (!this.TfProductSelector.allowMultiple) {
        this.emitPayload('productType', 'hidePopover');
      }
    }
  }
};

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      class: [
        { "is-multiple": _vm.TfProductSelector.allowMultiple },
        { "is-active": _vm.isActive },
        { "is-disabled": _vm.isDisabled },
        { "is-parent-level": _vm.isParentLevel },
        "btn-product-option"
      ],
      style: _vm.inlineStyle,
      on: {
        mouseover: function($event) {
          _vm.hover = true;
        },
        mouseout: function($event) {
          _vm.hover = false;
        },
        click: _vm.onClick
      }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.product.label) + "\n  "),
      _vm._t("productOptionAppend", null, { product: _vm.product })
    ],
    2
  )
};
var __vue_staticRenderFns__$r = [];
__vue_render__$r._withStripped = true;

  /* style */
  const __vue_inject_styles__$s = function (inject) {
    if (!inject) return
    inject("data-v-b01c8f24_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.btn-product-option[data-v-b01c8f24] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 15px 10px 30px;\n  font-size: 14px;\n  border: none;\n  border-bottom: 1px solid #efefef;\n  background: #fafafa;\n  cursor: pointer;\n}\n.btn-product-option.is-active[data-v-b01c8f24] {\n  color: #fff;\n  background: #2638a6;\n}\n.btn-product-option.is-active[data-v-b01c8f24], .btn-product-option.is-active[data-v-b01c8f24]:not(.is-disabled) {\n  cursor: default;\n}\n.btn-product-option.is-active.is-multiple[data-v-b01c8f24] {\n  cursor: pointer;\n}\n.btn-product-option.is-disabled[data-v-b01c8f24] {\n  color: #c1c1c1;\n  cursor: not-allowed;\n}\n.btn-product-option[data-v-b01c8f24]:not(.is-parent-level) {\n  padding-left: 30px;\n}\n\n/*# sourceMappingURL=ProductOption.vue.map */", map: {"version":3,"sources":["ProductOption.vue","/home/circleci/repo/src/components/TfProductSelector/ProductOption.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC2KpC;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;ADzKA;AC2KA;EACA,WAAA;EACA,mBAAA;ADzKA;AC2KA;EAEA,eAAA;AD1KA;AC6KA;EACA,eAAA;AD3KA;AC+KA;EACA,cAAA;EACA,mBAAA;AD7KA;ACgLA;EACA,kBAAA;AD9KA;;AAEA,4CAA4C","file":"ProductOption.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.btn-product-option {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 15px 10px 30px;\n  font-size: 14px;\n  border: none;\n  border-bottom: 1px solid #efefef;\n  background: #fafafa;\n  cursor: pointer;\n}\n.btn-product-option.is-active {\n  color: #fff;\n  background: #2638a6;\n}\n.btn-product-option.is-active, .btn-product-option.is-active:not(.is-disabled) {\n  cursor: default;\n}\n.btn-product-option.is-active.is-multiple {\n  cursor: pointer;\n}\n.btn-product-option.is-disabled {\n  color: #c1c1c1;\n  cursor: not-allowed;\n}\n.btn-product-option:not(.is-parent-level) {\n  padding-left: 30px;\n}\n\n/*# sourceMappingURL=ProductOption.vue.map */","<template>\n  <button\n    :class=\"[\n      { 'is-multiple': TfProductSelector.allowMultiple },\n      { 'is-active': isActive },\n      { 'is-disabled': isDisabled },\n      { 'is-parent-level': isParentLevel },\n      'btn-product-option'\n    ]\"\n    :style=\"inlineStyle\"\n    @mouseover=\"hover = true\"\n    @mouseout=\"hover = false\"\n    @click=\"onClick\"\n  >\n    {{ product.label }}\n    <slot\n      name=\"productOptionAppend\"\n      :product=\"product\"\n    />\n  </button>\n</template>\n\n<script>\n/**\n * The \"Product Options\" for the Project Product Product selector.\n *\n * @vuedoc\n * @exports ProductSelector/ProductOption\n * @category Components\n */\n  export default {\n    name: 'TfProductOption',\n    inject: [\n      'TfProductSelector',\n      'productType',\n    ],\n    props: {\n      isParentLevel: {\n        type: Boolean,\n        default: true,\n      },\n      product: {\n        type: Object,\n        required: true,\n        default: () => ({}),\n      },\n    },\n    data: () => ({\n      hover: false,\n    }),\n    computed: {\n      /**\n       * Determines if the product options is selected.\n       *\n       * @returns {boolean}\n       */\n      isActive() {\n        return this.TfProductSelector.value.includes(this.product.id);\n      },\n      /**\n       * If productSelector is themed, set corresponding CSS colors\n       *\n       * @returns {object }\n       */\n      inlineStyle() {\n        const style = {};\n\n        if (this.TfProductSelector.themePrimaryColor) {\n          if (this.isActive) {\n            style.backgroundColor = this.TfProductSelector.themePrimaryColor;\n          }\n        }\n\n        if (this.TfProductSelector.themeHoverColor && !this.isActive && this.hover) {\n          style.backgroundColor = this.TfProductSelector.themeHoverColor;\n          style.color = this.TfProductSelector.themePrimaryColor;\n        }\n\n        return style;\n      },\n      /**\n       * Determines if the product options is disabled.\n       *\n       * @returns {boolean}\n       */\n      isDisabled() {\n        return this.TfProductSelector.disabledProducts.includes(this.product.id);\n      },\n    },\n    methods: {\n      /**\n       * Emits the appropriate inject/emit types and payload.\n       *\n       * @param {string} type\n       * @param {string} emit\n       * @param {object} payload\n       */\n      emitPayload(type, emit, payload) {\n        this[type].$emit(emit, payload);\n      },\n      /**\n       * Adds or removed the product ID and emits from the root TfProductSelector component.\n       *\n       */\n      onClick() {\n        if (this.isDisabled) {\n          return;\n        }\n\n        if (!this.TfProductSelector.allowMultiple && this.isActive) {\n          this.emitPayload('productType', 'hidePopover');\n          return;\n        }\n\n        const oldValue = [...this.TfProductSelector.value];\n        const productId = this.product.id;\n        let action;\n        let selectedProductIds = this.TfProductSelector.allowMultiple\n          ? this.TfProductSelector.value\n          : [];\n\n        if (selectedProductIds.includes(productId)) {\n          this.$delete(\n            selectedProductIds,\n            selectedProductIds.findIndex((id) => id === productId),\n          );\n          action = 'deleted';\n        } else {\n          action = this.TfProductSelector.allowMultiple ? 'added' : 'changed';\n          selectedProductIds.push(productId);\n        }\n\n        selectedProductIds = this.$TF.Formatting\n          .sortObjects(\n            selectedProductIds.map(\n              (id) => this.TfProductSelector.products.find((product) => product.id === id),\n            ),\n            'position',\n          )\n          .map((product) => product.id);\n\n        // Emits for all the changes\n        this.emitPayload(\n          'TfProductSelector',\n          'input',\n          selectedProductIds,\n        );\n        this.emitPayload(\n          'TfProductSelector',\n          'change',\n          {\n            oldValue,\n            value: selectedProductIds,\n          },\n        );\n        this.emitPayload(\n          'TfProductSelector',\n          'selectProductOption',\n          {\n            action,\n            productId,\n            selectedProductIds,\n          },\n        );\n\n        if (!this.TfProductSelector.allowMultiple) {\n          this.emitPayload('productType', 'hidePopover');\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .btn-product-option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 10px 15px 10px 30px;\n    font-size: 14px;\n    border: none;\n    border-bottom: 1px solid $tf-extra-light-gray-1;\n    background: $tf-extra-light-gray-2;\n    cursor: pointer;\n\n    &.is-active {\n      color: $tf-white;\n      background: $tf-blue;\n\n      &,\n      &:not(.is-disabled) {\n        cursor: default;\n      }\n\n      &.is-multiple {\n        cursor: pointer;\n      }\n    }\n\n    &.is-disabled {\n      color: $tf-light-gray;\n      cursor: not-allowed;\n    }\n\n    &:not(.is-parent-level) {\n      padding-left: 30px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$s = "data-v-b01c8f24";
  /* module identifier */
  const __vue_module_identifier__$s = undefined;
  /* functional template */
  const __vue_is_functional_template__$s = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$s = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    browser,
    undefined,
    undefined
  );

/**
 * The "Product Types" for the Project Product Product selector.
 *
 * @vuedoc
 * @exports ProductSelector/TfProductType
 * @category Components
 */

var script$t = {
  name: 'TfProductType',
  components: {
    ProductOption: __vue_component__$s
  },
  inject: ['TfProductSelector'],
  provide: function provide() {
    return {
      productType: this
    };
  },
  props: {
    productType: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          id: 0,
          name: null,
          products: []
        };
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data(vm) {
    return {
      hover: false,
      openProductTypeIds: vm.value
    };
  },
  computed: {
    /**
     * Determines if the product type is expanded.
     *
     * @returns {boolean}
     */
    isActive: function isActive() {
      return this.openProductTypeIds.includes(this.productType.id);
    },

    /**
     * Determine if the product should be in a child of a product type
     * based on the product label and product count.
     *
     * @returns {boolean}
     */
    isParentLevel: function isParentLevel() {
      var firstProduct = this.productType.products[0];
      return this.productType.products.length === 1 && firstProduct.label === firstProduct.product_type_name;
    }
  },
  methods: {
    /**
     * Emits the updated model and emits "toggleProductType" from the TfProductSelector component.
     *
     */
    toggleProductType: function toggleProductType() {
      this.$emit('input', this.openProductTypeIds);
      this.TfProductSelector.$emit('toggleProductType', {
        action: this.openProductTypeIds.includes(this.productType.id) ? 'expand' : 'collapse',
        productTypeId: this.productType.id,
        openProductTypeIds: this.openProductTypeIds
      });
    }
  }
};

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "el-collapse",
    {
      on: { change: _vm.toggleProductType },
      model: {
        value: _vm.openProductTypeIds,
        callback: function($$v) {
          _vm.openProductTypeIds = $$v;
        },
        expression: "openProductTypeIds"
      }
    },
    [
      !_vm.isParentLevel
        ? _c(
            "el-collapse-item",
            {
              staticClass: "product-type-container",
              attrs: { name: _vm.productType.id }
            },
            [
              _c(
                "span",
                {
                  staticClass: "product-type-title-container",
                  style: {
                    backgroundColor:
                      _vm.TfProductSelector.themeHoverColor && _vm.hover
                        ? _vm.TfProductSelector.themeHoverColor
                        : null
                  },
                  attrs: { slot: "title" },
                  on: {
                    mouseover: function($event) {
                      _vm.hover = true;
                    },
                    mouseout: function($event) {
                      _vm.hover = false;
                    }
                  },
                  slot: "title"
                },
                [
                  _c(
                    "span",
                    { staticClass: "product-type-title" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.productType.name) +
                          "\n        "
                      ),
                      _vm._t("productTypeAppend", null, {
                        productType: _vm.productType
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("icon", {
                    class: [
                      { "is-active": _vm.isActive },
                      "product-type-toggle"
                    ],
                    style: {
                      fill:
                        _vm.isActive && _vm.TfProductSelector.themePrimaryColor
                          ? _vm.TfProductSelector.themePrimaryColor
                          : null
                    },
                    attrs: { name: "chevron-down" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.productType.products, function(productObj, index) {
                return _c("product-option", {
                  key: "product-" + productObj.label,
                  attrs: {
                    product: productObj,
                    "is-disabled": index
                      ? _vm.productType.products[0].state !== "complete"
                      : false,
                    "is-parent-level": false
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "productOptionAppend",
                        fn: function(optionAppendProps) {
                          return [
                            _vm._t(
                              "productOptionAppend",
                              null,
                              null,
                              optionAppendProps
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              })
            ],
            2
          )
        : _c("product-option", {
            attrs: {
              product: _vm.productType.products[0],
              "is-parent-level": true
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "productOptionAppend",
                  fn: function(optionAppendProps) {
                    return [
                      _vm._t(
                        "productOptionAppend",
                        null,
                        null,
                        optionAppendProps
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
    ],
    1
  )
};
var __vue_staticRenderFns__$s = [];
__vue_render__$s._withStripped = true;

  /* style */
  const __vue_inject_styles__$t = function (inject) {
    if (!inject) return
    inject("data-v-7880c74f_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.product-type-title[data-v-7880c74f] {\n  display: flex;\n  font-weight: 600;\n}\n.product-type-title-container[data-v-7880c74f] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 8px 15px;\n  font-size: 16px;\n  border-bottom: 1px solid #efefef;\n  cursor: pointer;\n}\n.product-type-title-container[data-v-7880c74f]:hover {\n  background: #f4f5ff;\n}\n.product-type-toggle[data-v-7880c74f] {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.product-type-toggle.is-active[data-v-7880c74f] {\n  fill: #2638a6;\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ProductType.vue.map */", map: {"version":3,"sources":["ProductType.vue","/home/circleci/repo/src/components/TfProductSelector/ProductType.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACgKpC;EACA,aAAA;EACA,gBAAA;AD9JA;ACiKA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;AD/JA;ACiKA;EACA,mBAAA;AD/JA;ACmKA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,qBAAA;ADjKA;ACmKA;EACA,aAAA;EACA,0BAAA;ADjKA;;AAEA,0CAA0C","file":"ProductType.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.product-type-title {\n  display: flex;\n  font-weight: 600;\n}\n.product-type-title-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 8px 15px;\n  font-size: 16px;\n  border-bottom: 1px solid #efefef;\n  cursor: pointer;\n}\n.product-type-title-container:hover {\n  background: #f4f5ff;\n}\n.product-type-toggle {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.product-type-toggle.is-active {\n  fill: #2638a6;\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ProductType.vue.map */","<template>\n  <el-collapse\n    v-model=\"openProductTypeIds\"\n    @change=\"toggleProductType\"\n  >\n    <el-collapse-item\n      v-if=\"!isParentLevel\"\n      class=\"product-type-container\"\n      :name=\"productType.id\"\n    >\n      <span\n        slot=\"title\"\n        class=\"product-type-title-container\"\n        :style=\"{\n          backgroundColor: TfProductSelector.themeHoverColor\n            && hover\n            ? TfProductSelector.themeHoverColor\n            : null\n        }\"\n        @mouseover=\"hover = true\"\n        @mouseout=\"hover = false\"\n      >\n        <span class=\"product-type-title\">\n          {{ productType.name }}\n          <slot\n            name=\"productTypeAppend\"\n            :product-type=\"productType\"\n          />\n        </span>\n        <icon\n          :class=\"[\n            { 'is-active': isActive },\n            'product-type-toggle'\n          ]\"\n          :style=\"{\n            fill: isActive && TfProductSelector.themePrimaryColor\n              ? TfProductSelector.themePrimaryColor\n              : null\n          }\"\n          name=\"chevron-down\"\n        />\n      </span>\n      <product-option\n        v-for=\"(productObj, index) in productType.products\"\n        :key=\"`product-${productObj.label}`\"\n        :product=\"productObj\"\n        :is-disabled=\"index ? productType.products[0].state !== 'complete' : false\"\n        :is-parent-level=\"false\"\n      >\n        <!-- Used to control appended icons in component using <product-selector /> -->\n        <template\n          slot=\"productOptionAppend\"\n          slot-scope=\"optionAppendProps\"\n        >\n          <slot\n            name=\"productOptionAppend\"\n            v-bind=\"optionAppendProps\"\n          />\n        </template>\n      </product-option>\n    </el-collapse-item>\n    <product-option\n      v-else\n      :product=\"productType.products[0]\"\n      :is-parent-level=\"true\"\n    >\n      <!-- Used to control appended icons in component using <product-selector /> -->\n      <template\n        slot=\"productOptionAppend\"\n        slot-scope=\"optionAppendProps\"\n      >\n        <slot\n          name=\"productOptionAppend\"\n          v-bind=\"optionAppendProps\"\n        />\n      </template>\n    </product-option>\n  </el-collapse>\n</template>\n\n<script>\n  import ProductOption from './ProductOption';\n\n  /**\n   * The \"Product Types\" for the Project Product Product selector.\n   *\n   * @vuedoc\n   * @exports ProductSelector/TfProductType\n   * @category Components\n   */\n  export default {\n    name: 'TfProductType',\n    components: { ProductOption },\n    inject: [\n      'TfProductSelector',\n    ],\n    provide() {\n      return {\n        productType: this,\n      };\n    },\n    props: {\n      productType: {\n        type: Object,\n        required: true,\n        default: () => ({\n          id: 0,\n          name: null,\n          products: [],\n        }),\n      },\n      value: {\n        type: Array,\n        default: () => ([]),\n      },\n    },\n    data: (vm) => ({\n      hover: false,\n      openProductTypeIds: vm.value,\n    }),\n    computed: {\n      /**\n       * Determines if the product type is expanded.\n       *\n       * @returns {boolean}\n       */\n      isActive() {\n        return this.openProductTypeIds.includes(this.productType.id);\n      },\n      /**\n       * Determine if the product should be in a child of a product type\n       * based on the product label and product count.\n       *\n       * @returns {boolean}\n       */\n      isParentLevel() {\n        const firstProduct = this.productType.products[0];\n\n        return this.productType.products.length === 1\n          && firstProduct.label === firstProduct.product_type_name;\n      },\n    },\n    methods: {\n      /**\n       * Emits the updated model and emits \"toggleProductType\" from the TfProductSelector component.\n       *\n       */\n      toggleProductType() {\n        this.$emit('input', this.openProductTypeIds);\n        this.TfProductSelector.$emit('toggleProductType', {\n          action: this.openProductTypeIds.includes(this.productType.id)\n            ? 'expand'\n            : 'collapse',\n          productTypeId: this.productType.id,\n          openProductTypeIds: this.openProductTypeIds,\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .product-type {\n    &-title {\n      display: flex;\n      font-weight: 600;\n    }\n\n    &-title-container {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      padding: 8px 15px;\n      font-size: 16px;\n      border-bottom: 1px solid $tf-extra-light-gray-1;\n      cursor: pointer;\n\n      &:hover {\n        background: $tf-light-blue;\n      }\n    }\n\n    &-toggle {\n      height: 18px;\n      width: 16px;\n      margin-top: 3px;\n      fill: $tf-dark-gray;\n      transition: transform .3s;\n      transform: rotateZ(0);\n\n      &.is-active {\n        fill: $tf-blue;\n        transform: rotateZ(180deg);\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$t = "data-v-7880c74f";
  /* module identifier */
  const __vue_module_identifier__$t = undefined;
  /* functional template */
  const __vue_is_functional_template__$t = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$t = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    browser,
    undefined,
    undefined
  );

/**
 * The Project Product Product selector for passed products.
 *
 * @vuedoc
 * @exports ProductSelector/index
 * @category Components
 */

var script$u = {
  name: 'TfProductSelector',
  components: {
    ProductType: __vue_component__$t
  },
  provide: function provide() {
    return {
      TfProductSelector: this
    };
  },
  props: {
    allowMultiple: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    collapsedCategories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    collapsedProductTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabledProducts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fixedToggle: {
      type: Boolean,
      default: true
    },
    inputBorderColor: {
      type: String,
      default: null
    },
    keepOpen: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    showCategoryTitles: {
      type: Boolean,
      default: true
    },
    showSelectedCount: {
      type: Boolean,
      default: false
    },
    themePrimaryColor: {
      type: String,
      default: null
    },
    themeHoverColor: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    width: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      hoverIndex: null,
      isActive: false,
      openCategoryIds: [],
      openProductTypeIds: [],
      popperWidth: null
    };
  },
  computed: {
    /**
     * Creates an array of all the product labels or "placeholder" if nothing is selected.
     *
     * @returns {Array}
     */
    label: function label() {
      var _this = this;

      return this.value.length && this.products.length ? this.value.map(function (productId) {
        var selectedProduct = _this.products.find(function (product) {
          return product.id === productId;
        });

        if (!selectedProduct) {
          return ['No product found'];
        }

        var typeIsNotLabel = selectedProduct.product_type_name !== selectedProduct.label;
        return selectedProduct.alternative || typeIsNotLabel ? "".concat(selectedProduct.product_type_name, ", ").concat(selectedProduct.label) : selectedProduct.label;
      }) : ['Select a Product'];
    },

    /**
     * Creates an object of all the products types with their products as children.
     *
     * @returns {object}
     */
    productsByTypeTree: function productsByTypeTree() {
      var productTypes = {};
      var productTypeId = 'product_type_id';
      this.products.forEach(function (product) {
        if (!productTypes[product[productTypeId]]) {
          productTypes[product[productTypeId]] = {
            id: product[productTypeId],
            name: product.product_type_name,
            products: []
          };
        }

        productTypes[product[productTypeId]].products.push(product);
      });
      return productTypes;
    },

    /**
     * Creates an array of categories if no category is provided.
     *
     * @returns {Array}
     */
    productTypesByCategory: function productTypesByCategory() {
      return this.categories.length ? this.categories : [{
        id: 1,
        label: 'All Products',
        productTypeIds: _toConsumableArray(new Set(this.products.map(function (product) {
          return product.product_type_id;
        }).reduce(function (array, value) {
          return array.concat(value);
        }, [])))
      }];
    }
  },
  watch: {
    /**
     * Watch changes on productsByTypeTree and call expandAll
     */
    productsByTypeTree: function productsByTypeTree() {
      this.expandAll();
    }
  },
  mounted: function mounted() {
    this.popperWidth = (this.width || this.$refs.productSelectorContainer.clientWidth) - 2;
    this.expandAll();
  },
  methods: {
    /**
     * Go through all of the product types by category and the child product type IDs.
     * Push to the respective "openCategoryIds" and "openProductTypeIds" arrays
     * depending if the are included in
     * the "collapsedCategories" and "collapsedProductTypes" props .
     */
    expandAll: function expandAll() {
      var _this2 = this;

      this.productTypesByCategory.forEach(function (category, index) {
        if (!_this2.collapsedCategories.includes(index)) {
          _this2.openCategoryIds.push(index);
        }

        category.productTypeIds.forEach(function (productTypeId) {
          if (!_this2.collapsedProductTypes.includes(productTypeId)) {
            _this2.openProductTypeIds.push(productTypeId);
          }
        });
      });
    },

    /**
     * Hiding the popover when clicking outside <tf-popover>
     */
    hidePopover: function hidePopover() {
      if (this.keepOpen) {
        return;
      }

      this.isActive = false;
    },

    /**
     * Emits the category ID and the openCategoryIds array.
     *
     * @param {number} categoryIndex
     */
    toggleCategory: function toggleCategory(categoryIndex) {
      this.$emit('toggleCategory', {
        action: this.openCategoryIds.includes(categoryIndex) ? 'expand' : 'collapse',
        categoryIndex: categoryIndex,
        openCategoryIds: this.openCategoryIds
      });
    }
  }
};

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "productSelectorContainer" },
    [
      _c(
        "tf-popover",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.hidePopover,
              expression: "hidePopover"
            }
          ],
          attrs: {
            width: _vm.popperWidth,
            "visible-arrow": false,
            "border-color": _vm.themePrimaryColor || null,
            "popper-class": "product-select-popover",
            placement: "bottom-start",
            trigger: "manual"
          },
          model: {
            value: _vm.isActive,
            callback: function($$v) {
              _vm.isActive = $$v;
            },
            expression: "isActive"
          }
        },
        [
          _c(
            "span",
            {
              class: [{ "is-active": _vm.isActive }, "product-selector-input"],
              style: { borderColor: _vm.inputBorderColor || null },
              attrs: { slot: "reference" },
              on: {
                click: function($event) {
                  _vm.isActive = !_vm.isActive;
                }
              },
              slot: "reference"
            },
            [
              _c("span", {
                staticClass: "product-selector-label",
                domProps: { textContent: _vm._s(_vm.label.join("; ")) }
              }),
              _vm._v(" "),
              _vm.showSelectedCount
                ? _c("span", {
                    staticClass: "product-selector-counter",
                    domProps: {
                      textContent: _vm._s("(" + _vm.value.length + ")")
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: [
                    { "is-fixed": _vm.fixedToggle },
                    "product-selector-toggle"
                  ]
                },
                [
                  _c("icon", {
                    class: { "is-active": _vm.isActive },
                    style: {
                      fill: _vm.isActive ? _vm.themePrimaryColor : null
                    },
                    attrs: { name: "caret-down" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.productTypesByCategory, function(category, index) {
            return _c(
              "el-collapse",
              {
                key: "category-" + index,
                on: {
                  change: function($event) {
                    return _vm.toggleCategory(index)
                  }
                },
                model: {
                  value: _vm.openCategoryIds,
                  callback: function($$v) {
                    _vm.openCategoryIds = $$v;
                  },
                  expression: "openCategoryIds"
                }
              },
              [
                _c(
                  "el-collapse-item",
                  { staticClass: "container-category", attrs: { name: index } },
                  [
                    _vm.showCategoryTitles
                      ? _c(
                          "span",
                          {
                            staticClass: "title-category",
                            style: {
                              color:
                                _vm.openCategoryIds.includes(index) &&
                                _vm.themePrimaryColor
                                  ? _vm.themePrimaryColor
                                  : null,
                              backgroundColor:
                                _vm.hoverIndex === index && _vm.themeHoverColor
                                  ? _vm.themeHoverColor
                                  : null
                            },
                            attrs: { slot: "title" },
                            on: {
                              mouseover: function($event) {
                                _vm.hoverIndex = index;
                              },
                              mouseout: function($event) {
                                _vm.hoverIndex = null;
                              }
                            },
                            slot: "title"
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(category.label) +
                                "\n          "
                            ),
                            _c("icon", {
                              class: [
                                {
                                  "is-active": _vm.openCategoryIds.includes(
                                    index
                                  )
                                },
                                "category-toggle"
                              ],
                              style: {
                                fill:
                                  _vm.openCategoryIds.includes(index) &&
                                  _vm.themePrimaryColor
                                    ? _vm.themePrimaryColor
                                    : null
                              },
                              attrs: { name: "chevron-down" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(category.productTypeIds, function(productTypeId) {
                      return _c("product-type", {
                        key: "product-type-" + productTypeId,
                        attrs: {
                          "product-type": _vm.productsByTypeTree[productTypeId]
                        },
                        on: { hidePopover: _vm.hidePopover },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "productOptionAppend",
                              fn: function(product) {
                                return [
                                  _vm._t("productOptionAppend", null, {
                                    product: product.product
                                  })
                                ]
                              }
                            },
                            {
                              key: "productTypeAppend",
                              fn: function(productTypeData) {
                                return [
                                  _vm._t("productTypeAppend", null, {
                                    productType: productTypeData.productType
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.openProductTypeIds,
                          callback: function($$v) {
                            _vm.openProductTypeIds = $$v;
                          },
                          expression: "openProductTypeIds"
                        }
                      })
                    })
                  ],
                  2
                )
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$t = [];
__vue_render__$t._withStripped = true;

  /* style */
  const __vue_inject_styles__$u = function (inject) {
    if (!inject) return
    inject("data-v-56557204_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.category-toggle[data-v-56557204] {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.category-toggle.is-active[data-v-56557204] {\n  fill: #2638a6;\n  transform: rotateZ(180deg);\n}\n.el-collapse-item__header.is-active .title-category[data-v-56557204] {\n  color: #2638a6;\n}\n.title-category[data-v-56557204] {\n  display: flex;\n  justify-content: space-between;\n  padding: 9px 15px;\n  border-bottom: 1px solid #efefef;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.title-category svg[data-v-56557204] {\n  transform: rotateZ(0);\n}\n.container-category.is-active .title-category svg[data-v-56557204] {\n  transition: transform 0.3s;\n  transform: rotateZ(180deg);\n}\n.product-selector-counter[data-v-56557204] {\n  margin: 0 5px;\n}\n.product-selector-toggle[data-v-56557204] {\n  display: flex;\n  flex-basis: 18px;\n  flex-shrink: 0;\n  justify-content: flex-end;\n}\n.product-selector-toggle svg[data-v-56557204] {\n  fill: #999;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n  height: 20px;\n  width: 12px;\n}\n.product-selector-toggle svg.is-active[data-v-56557204] {\n  fill: #2638a6;\n  transform: rotateZ(180deg);\n}\n.product-selector-toggle.is-fixed[data-v-56557204] {\n  margin-left: auto;\n}\n.product-selector-input[data-v-56557204] {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 5px 10px;\n  font-size: 14px;\n  border: 1px solid #c1c1c1;\n  border-radius: 4px;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n.product-selector-input.is-active[data-v-56557204] {\n  border-color: #2638a6;\n}\n.product-selector-input[data-v-56557204]:focus {\n  outline: none;\n}\n.product-selector-label[data-v-56557204] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.el-collapse-item__wrap[data-v-56557204] {\n  padding-left: 15px;\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/circleci/repo/src/components/TfProductSelector/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACkUpC;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,qBAAA;ADhUA;ACkUA;EACA,aAAA;EACA,0BAAA;ADhUA;ACqUA;EACA,cAAA;ADlUA;ACsUA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EAGA,eAAA;EACA,gBAAA;EAGA,eAAA;ADvUA;ACyUA;EAMA,qBAAA;AD5UA;ACuUA;EACA,0BAAA;EACA,0BAAA;ADrUA;AC6UA;EACA,aAAA;AD1UA;AC6UA;EACA,aAAA;EAEA,gBAAA;EACA,cAAA;EAEA,yBAAA;AD7UA;AC+UA;EACA,UAAA;EACA,0BAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AD7UA;AC+UA;EACA,aAAA;EACA,0BAAA;AD7UA;ACiVA;EACA,iBAAA;AD/UA;ACmVA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;ADjVA;ACmVA;EACA,qBAAA;ADjVA;ACoVA;EACA,aAAA;ADlVA;ACsVA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADpVA;ACwVA;EACA,kBAAA;ADrVA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.category-toggle {\n  height: 18px;\n  width: 16px;\n  margin-top: 3px;\n  fill: #42474c;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n}\n.category-toggle.is-active {\n  fill: #2638a6;\n  transform: rotateZ(180deg);\n}\n\n.el-collapse-item__header.is-active .title-category {\n  color: #2638a6;\n}\n\n.title-category {\n  display: flex;\n  justify-content: space-between;\n  padding: 9px 15px;\n  border-bottom: 1px solid #efefef;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.title-category svg {\n  transform: rotateZ(0);\n}\n.container-category.is-active .title-category svg {\n  transition: transform 0.3s;\n  transform: rotateZ(180deg);\n}\n\n.product-selector-counter {\n  margin: 0 5px;\n}\n.product-selector-toggle {\n  display: flex;\n  flex-basis: 18px;\n  flex-shrink: 0;\n  justify-content: flex-end;\n}\n.product-selector-toggle svg {\n  fill: #999;\n  transition: transform 0.3s;\n  transform: rotateZ(0);\n  height: 20px;\n  width: 12px;\n}\n.product-selector-toggle svg.is-active {\n  fill: #2638a6;\n  transform: rotateZ(180deg);\n}\n.product-selector-toggle.is-fixed {\n  margin-left: auto;\n}\n.product-selector-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 5px 10px;\n  font-size: 14px;\n  border: 1px solid #c1c1c1;\n  border-radius: 4px;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n.product-selector-input.is-active {\n  border-color: #2638a6;\n}\n.product-selector-input:focus {\n  outline: none;\n}\n.product-selector-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.el-collapse-item__wrap {\n  padding-left: 15px;\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div ref=\"productSelectorContainer\">\n    <tf-popover\n      v-model=\"isActive\"\n      v-click-outside=\"hidePopover\"\n      :width=\"popperWidth\"\n      :visible-arrow=\"false\"\n      :border-color=\"themePrimaryColor || null\"\n      popper-class=\"product-select-popover\"\n      placement=\"bottom-start\"\n      trigger=\"manual\"\n    >\n      <span\n        slot=\"reference\"\n        :class=\"[{ 'is-active': isActive }, 'product-selector-input']\"\n        :style=\"{ borderColor: inputBorderColor || null }\"\n        @click=\"isActive = !isActive\"\n      >\n        <span\n          class=\"product-selector-label\"\n          v-text=\"label.join('; ')\"\n        />\n        <span\n          v-if=\"showSelectedCount\"\n          class=\"product-selector-counter\"\n          v-text=\"`(${value.length})`\"\n        />\n        <span\n          :class=\"[\n            { 'is-fixed': fixedToggle },\n            'product-selector-toggle'\n          ]\"\n        >\n          <icon\n            :class=\"{ 'is-active': isActive }\"\n            :style=\"{ fill: isActive ? themePrimaryColor : null }\"\n            name=\"caret-down\"\n          />\n        </span>\n      </span>\n      <el-collapse\n        v-for=\"(category, index) in productTypesByCategory\"\n        :key=\"`category-${index}`\"\n        v-model=\"openCategoryIds\"\n        @change=\"toggleCategory(index)\"\n      >\n        <el-collapse-item\n          class=\"container-category\"\n          :name=\"index\"\n        >\n          <span\n            v-if=\"showCategoryTitles\"\n            slot=\"title\"\n            class=\"title-category\"\n            :style=\"{\n              color: openCategoryIds.includes(index) && themePrimaryColor\n                ? themePrimaryColor\n                : null,\n              backgroundColor: hoverIndex === index && themeHoverColor\n                ? themeHoverColor\n                : null\n            }\"\n            @mouseover=\"hoverIndex = index\"\n            @mouseout=\"hoverIndex = null\"\n          >\n            {{ category.label }}\n            <icon\n              :style=\"{\n                fill: openCategoryIds.includes(index) && themePrimaryColor\n                  ? themePrimaryColor\n                  : null\n              }\"\n              :class=\"[\n                { 'is-active': openCategoryIds.includes(index) },\n                'category-toggle'\n              ]\"\n              name=\"chevron-down\"\n            />\n          </span>\n          <product-type\n            v-for=\"productTypeId in category.productTypeIds\"\n            :key=\"`product-type-${productTypeId}`\"\n            v-model=\"openProductTypeIds\"\n            :product-type=\"productsByTypeTree[productTypeId]\"\n            @hidePopover=\"hidePopover\"\n          >\n            <!-- Used to control appended icons in component using <product-selector /> -->\n            <template\n              slot=\"productOptionAppend\"\n              slot-scope=\"product\"\n            >\n              <slot\n                name=\"productOptionAppend\"\n                :product=\"product.product\"\n              />\n            </template>\n            <template\n              slot=\"productTypeAppend\"\n              slot-scope=\"productTypeData\"\n            >\n              <slot\n                name=\"productTypeAppend\"\n                :product-type=\"productTypeData.productType\"\n              />\n            </template>\n          </product-type>\n        </el-collapse-item>\n      </el-collapse>\n    </tf-popover>\n  </div>\n</template>\n\n<script>\n  import ProductType from './ProductType';\n  /**\n   * The Project Product Product selector for passed products.\n   *\n   * @vuedoc\n   * @exports ProductSelector/index\n   * @category Components\n   */\n  export default {\n    name: 'TfProductSelector',\n    components: { ProductType },\n    provide() {\n      return {\n        TfProductSelector: this,\n      };\n    },\n    props: {\n      allowMultiple: {\n        type: Boolean,\n        default: false,\n      },\n      categories: {\n        type: Array,\n        default: () => ([]),\n      },\n      collapsedCategories: {\n        type: Array,\n        default: () => ([]),\n      },\n      collapsedProductTypes: {\n        type: Array,\n        default: () => ([]),\n      },\n      disabledProducts: {\n        type: Array,\n        default: () => ([]),\n      },\n      fixedToggle: {\n        type: Boolean,\n        default: true,\n      },\n      inputBorderColor: {\n        type: String,\n        default: null,\n      },\n      keepOpen: {\n        type: Boolean,\n        default: false,\n      },\n      products: {\n        type: Array,\n        required: true,\n        default: () => ([]),\n      },\n      showCategoryTitles: {\n        type: Boolean,\n        default: true,\n      },\n      showSelectedCount: {\n        type: Boolean,\n        default: false,\n      },\n      themePrimaryColor: {\n        type: String,\n        default: null,\n      },\n      themeHoverColor: {\n        type: String,\n        default: null,\n      },\n      value: {\n        type: Array,\n        required: true,\n        default: () => ([]),\n      },\n      width: {\n        type: Number,\n        default: null,\n      },\n    },\n    data: () => ({\n      hoverIndex: null,\n      isActive: false,\n      openCategoryIds: [],\n      openProductTypeIds: [],\n      popperWidth: null,\n    }),\n    computed: {\n      /**\n       * Creates an array of all the product labels or \"placeholder\" if nothing is selected.\n       *\n       * @returns {Array}\n       */\n      label() {\n        return this.value.length && this.products.length\n          ? this.value.map((productId) => {\n            const selectedProduct = this.products.find((product) => product.id === productId);\n\n            if (!selectedProduct) {\n              return ['No product found'];\n            }\n\n            const typeIsNotLabel = selectedProduct.product_type_name !== selectedProduct.label;\n\n            return selectedProduct.alternative || typeIsNotLabel\n              ? `${selectedProduct.product_type_name}, ${selectedProduct.label}`\n              : selectedProduct.label;\n          })\n          : ['Select a Product'];\n      },\n      /**\n       * Creates an object of all the products types with their products as children.\n       *\n       * @returns {object}\n       */\n      productsByTypeTree() {\n        const productTypes = {};\n        const productTypeId = 'product_type_id';\n\n        this.products.forEach((product) => {\n          if (!productTypes[product[productTypeId]]) {\n            productTypes[product[productTypeId]] = {\n              id: product[productTypeId],\n              name: product.product_type_name,\n              products: [],\n            };\n          }\n\n          productTypes[product[productTypeId]].products.push(product);\n        });\n\n        return productTypes;\n      },\n      /**\n       * Creates an array of categories if no category is provided.\n       *\n       * @returns {Array}\n       */\n      productTypesByCategory() {\n        return this.categories.length\n          ? this.categories\n          : [{\n            id: 1,\n            label: 'All Products',\n            productTypeIds: [...new Set(this.products\n              .map((product) => product.product_type_id)\n              .reduce((array, value) => array.concat(value), []))],\n          }];\n      },\n    },\n    watch: {\n      /**\n       * Watch changes on productsByTypeTree and call expandAll\n       */\n      productsByTypeTree() {\n        this.expandAll();\n      },\n    },\n    mounted() {\n      this.popperWidth = (this.width || this.$refs.productSelectorContainer.clientWidth) - 2;\n\n      this.expandAll();\n    },\n    methods: {\n      /**\n       * Go through all of the product types by category and the child product type IDs.\n       * Push to the respective \"openCategoryIds\" and \"openProductTypeIds\" arrays\n       * depending if the are included in\n       * the \"collapsedCategories\" and \"collapsedProductTypes\" props .\n       */\n      expandAll() {\n        this.productTypesByCategory.forEach((category, index) => {\n          if (!this.collapsedCategories.includes(index)) {\n            this.openCategoryIds.push(index);\n          }\n\n          category.productTypeIds.forEach((productTypeId) => {\n            if (!this.collapsedProductTypes.includes(productTypeId)) {\n              this.openProductTypeIds.push(productTypeId);\n            }\n          });\n        });\n      },\n      /**\n       * Hiding the popover when clicking outside <tf-popover>\n       */\n      hidePopover() {\n        if (this.keepOpen) {\n          return;\n        }\n\n        this.isActive = false;\n      },\n      /**\n       * Emits the category ID and the openCategoryIds array.\n       *\n       * @param {number} categoryIndex\n       */\n      toggleCategory(categoryIndex) {\n        this.$emit('toggleCategory', {\n          action: this.openCategoryIds.includes(categoryIndex)\n            ? 'expand'\n            : 'collapse',\n          categoryIndex,\n          openCategoryIds: this.openCategoryIds,\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .category-toggle {\n    height: 18px;\n    width: 16px;\n    margin-top: 3px;\n    fill: $tf-dark-gray;\n    transition: transform .3s;\n    transform: rotateZ(0);\n\n    &.is-active {\n      fill: $tf-blue;\n      transform: rotateZ(180deg);\n    }\n  }\n\n  .el-collapse-item__header.is-active {\n    .title-category {\n      color: $tf-blue;\n    }\n  }\n\n  .title-category {\n    display: flex;\n    justify-content: space-between;\n    padding: 9px 15px;\n    border-bottom: 1px solid $tf-extra-light-gray-1;\n\n    font: {\n      size: 16px;\n      weight: 700;\n    }\n\n    cursor: pointer;\n\n    svg {\n      .container-category.is-active & {\n        transition: transform .3s;\n        transform: rotateZ(180deg);\n      }\n\n      transform: rotateZ(0);\n    }\n  }\n\n  .product-selector {\n    &-counter {\n      margin: 0 5px;\n    }\n\n    &-toggle {\n      display: flex;\n      flex: {\n        basis: 18px;\n        shrink: 0;\n      }\n      justify-content: flex-end;\n\n      svg {\n        fill: $tf-medium-gray;\n        transition: transform .3s;\n        transform: rotateZ(0);\n        height: 20px;\n        width: 12px;\n\n        &.is-active {\n          fill: $tf-blue;\n          transform: rotateZ(180deg);\n        }\n      }\n\n      &.is-fixed {\n        margin-left: auto;\n      }\n    }\n\n    &-input {\n      position: relative;\n      display: flex;\n      align-items: center;\n      width: 100%;\n      padding: 5px 10px;\n      font-size: 14px;\n      border: 1px solid $tf-light-gray;\n      border-radius: 4px;\n      box-sizing: border-box;\n      cursor: pointer;\n\n      &.is-active {\n        border-color: $tf-blue;\n      }\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    &-label {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .el-collapse-item__wrap {\n    padding-left: 15px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$u = "data-v-56557204";
  /* module identifier */
  const __vue_module_identifier__$u = undefined;
  /* functional template */
  const __vue_is_functional_template__$u = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$u = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The Progress icon based on progressState prop.
 *
 * @vuedoc
 * @exports ProjectProductSelector/TfProgressIcon
 * @category Components
 */
var script$v = {
  name: 'TfProgressIcon',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    progressState: {
      type: String,
      default: null
    }
  }
};

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.progressState === "full"
    ? _c("icon", {
        class: [{ "is-active": _vm.isActive }, _vm.progressState],
        attrs: { name: "check-circle" }
      })
    : _c("span", {
        class: [
          { "is-active": _vm.isActive },
          _vm.progressState,
          "progress-icon"
        ]
      })
};
var __vue_staticRenderFns__$u = [];
__vue_render__$u._withStripped = true;

  /* style */
  const __vue_inject_styles__$v = function (inject) {
    if (!inject) return
    inject("data-v-cb5758d8_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nsvg[data-v-cb5758d8] {\n  width: 16px;\n  height: 16px;\n}\nsvg.full[data-v-cb5758d8] {\n  fill: #00b980;\n}\nsvg.active[data-v-cb5758d8] {\n  fill: #2638a6;\n}\nsvg.is-active[data-v-cb5758d8] {\n  fill: #fff;\n}\n.progress-icon[data-v-cb5758d8] {\n  display: block;\n  width: 16px;\n  height: 16px;\n  overflow: hidden;\n  border: 2px solid #c1c1c1;\n  border-radius: 100%;\n  box-sizing: border-box;\n}\n.progress-icon.is-active[data-v-cb5758d8] {\n  border-color: #fff;\n}\n.progress-icon.half[data-v-cb5758d8]:after {\n  display: block;\n  margin-left: 6px;\n  background: #f7912a;\n  width: 14px;\n  height: 14px;\n  content: \"\";\n}\n.progress-icon.half.is-active[data-v-cb5758d8]:after {\n  background-color: #fff;\n}\n\n/*# sourceMappingURL=TfProgressIcon.vue.map */", map: {"version":3,"sources":["TfProgressIcon.vue","/home/circleci/repo/src/components/TfProductSelector/TfProgressIcon.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACwCpC;EACA,WAAA;EACA,YAAA;ADtCA;ACwCA;EACA,aAAA;ADtCA;ACyCA;EACA,aAAA;ADvCA;AC0CA;EACA,UAAA;ADxCA;AC4CA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;ADzCA;AC2CA;EACA,kBAAA;ADzCA;AC6CA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AD3CA;AC8CA;EACA,sBAAA;AD5CA;;AAEA,6CAA6C","file":"TfProgressIcon.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nsvg {\n  width: 16px;\n  height: 16px;\n}\nsvg.full {\n  fill: #00b980;\n}\nsvg.active {\n  fill: #2638a6;\n}\nsvg.is-active {\n  fill: #fff;\n}\n\n.progress-icon {\n  display: block;\n  width: 16px;\n  height: 16px;\n  overflow: hidden;\n  border: 2px solid #c1c1c1;\n  border-radius: 100%;\n  box-sizing: border-box;\n}\n.progress-icon.is-active {\n  border-color: #fff;\n}\n.progress-icon.half:after {\n  display: block;\n  margin-left: 6px;\n  background: #f7912a;\n  width: 14px;\n  height: 14px;\n  content: \"\";\n}\n.progress-icon.half.is-active:after {\n  background-color: #fff;\n}\n\n/*# sourceMappingURL=TfProgressIcon.vue.map */","<template>\n  <icon\n    v-if=\"progressState === 'full'\"\n    :class=\"[\n      { 'is-active' : isActive, },\n      progressState,\n    ]\"\n    name=\"check-circle\"\n  />\n  <span\n    v-else\n    :class=\"[\n      { 'is-active': isActive, },\n      progressState,\n      'progress-icon',\n    ]\"\n  />\n</template>\n\n<script>\n/**\n * The Progress icon based on progressState prop.\n *\n * @vuedoc\n * @exports ProjectProductSelector/TfProgressIcon\n * @category Components\n */\n  export default {\n    name: 'TfProgressIcon',\n    props: {\n      isActive: {\n        type: Boolean,\n        default: false,\n      },\n      progressState: {\n        type: String,\n        default: null,\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  svg {\n    width: 16px;\n    height: 16px;\n\n    &.full {\n      fill: $tf-green;\n    }\n\n    &.active {\n      fill: $tf-blue;\n    }\n\n    &.is-active {\n      fill: $tf-white;\n    }\n  }\n\n  .progress-icon {\n    display: block;\n    width: 16px;\n    height: 16px;\n    overflow: hidden;\n    border: 2px solid $tf-light-gray;\n    border-radius: 100%;\n    box-sizing: border-box;\n\n    &.is-active {\n      border-color: $tf-white;\n    }\n\n    &.half {\n      &:after {\n        display: block;\n        margin-left: 6px;\n        background: $tf-orange;\n        width: 14px;\n        height: 14px;\n        content: '';\n      }\n\n      &.is-active:after {\n        background-color: $tf-white;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$v = "data-v-cb5758d8";
  /* module identifier */
  const __vue_module_identifier__$v = undefined;
  /* functional template */
  const __vue_is_functional_template__$v = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$v = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    browser,
    undefined,
    undefined
  );

var dP$5 = _objectDp.f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME$2 = 'name';

// 19.2.4.2 name
NAME$2 in FProto || _descriptors && dP$5(FProto, NAME$2, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$3 = _wks('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES$3]) == undefined ? D : _aFunction(S);
};

var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX$1 = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !_fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
_fixReWks('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!_isRegexp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = _regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX$1];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX$1] === match.index) separatorCopy[LAST_INDEX$1]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = _anObject(regexp);
      var S = String(this);
      var C = _speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return _regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = _regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(_toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = _advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The Comments component that includes the readonly and edit state of a comment.
 *
 * @vuedoc
 * @exports Comments/index
 * @category Components
 */
var script$w = {
  name: 'Comment',
  props: {
    applicationNamespace: {
      type: String,
      required: true,
      default: ''
    },
    broker: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    comment: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    documents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inlineSuccess: {
      type: Boolean,
      default: true
    },
    isReply: {
      type: Boolean,
      default: false
    },
    isPdfRender: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: Number,
      default: null
    },
    projectId: {
      type: [Number, String],
      default: '',
      required: true
    },
    proposalDocumentId: {
      type: Number,
      default: null
    },
    showNewBadge: {
      type: Boolean,
      default: true
    },
    showReplyButton: {
      type: Boolean,
      default: true
    },
    userInfo: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          firstName: '',
          lastName: '',
          organization: '',
          type: 'broker'
        };
      }
    }
  },
  data: function data() {
    return {
      autoSaveTimestamp: '',
      commentText: '',
      showSuccessMessage: false,
      showCommentBox: false
    };
  },
  computed: {
    /**
     * Splits the comment content by `\n\n` into an array to use in the template.
     *
     * @returns {Array}
     */
    commentParagraphs: function commentParagraphs() {
      return this.comment.content.split('\n\n').map(function (p) {
        return p.split('\n');
      });
    },

    /**
     * If this is a top level comment, we should reply to this comment.
     * If this is a reply, we should take the parentId prop
     *
     * @returns {string}
     */
    commentParentId: function commentParentId() {
      return this.isReply ? this.parentId : this.comment.id;
    },

    /**
     * Evaluates recipient, userInfo and broker data to decide what to return in this.fullName.
     *
     * @returns {string}
     */
    commentRecipient: function commentRecipient() {
      var _this = this;

      var recipient = this.documents.find(function (document) {
        return document.id === _this.comment.commentable_id;
      });
      var commentRecipient = null;

      if (recipient) {
        commentRecipient = this.broker.name; // IF: this.comment originated from a broker we know it's to the carrier of a document => the recipient's (carrier's) name
        // ELSE IF: this comment came from a carrier => assign broker name from this.userInfo.organization

        if (this.comment.user.broker.name) {
          commentRecipient = recipient.carrier.name;
        } else if (this.isBrokerUser) {
          commentRecipient = this.userInfo.organization;
        }
      }

      return commentRecipient;
    },

    /**
     * Determines if the user is a broker based on this.userInfo type.
     *
     * @returns {boolean}
     */
    isBrokerUser: function isBrokerUser() {
      return this.userInfo.type === 'broker';
    },

    /**
     * Determines if the user is a carrier based on this.userInfo type.
     *
     * @returns {boolean}
     */
    isCarrierUser: function isCarrierUser() {
      return this.userInfo.type === 'carrier';
    },

    /**
     * Evaluates broker and carrier data to decide what to return in this.fullName.
     *
     * @returns {boolean}
     */
    isSameOrganization: function isSameOrganization() {
      var isBroker = this.isBrokerUser && this.userInfo.organization === this.comment.user.broker.name;
      var isCarrier = this.isCarrierUser && this.userInfo.organization === this.comment.user.carrier.name;
      return isCarrier || isBroker;
    },

    /**
     * Return organization name, if set, regardless of user type
     *
     * @returns {string}
     */
    organizationName: function organizationName() {
      var isBroker = this.comment.user.broker && this.comment.user.broker.name;
      var isCarrier = this.comment.user.carrier && this.comment.user.carrier.name;
      var organizationName = null;

      if (isCarrier) {
        organizationName = this.comment.user.carrier.name;
      }

      if (isBroker) {
        organizationName = this.comment.user.broker.name;
      }

      return organizationName;
    },

    /**
     * Return organization name, if set, regardless of user type
     *
     * @returns {Array}
     */
    orderedReplies: function orderedReplies() {
      return this.comment.replies // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      ? this.$TF.Formatting.sortObjects(this.comment.replies, 'created_at', 'desc') : [];
    },

    /**
     * Evaluates the comment and showNewBadge prop to decide to show the "new" badge.
     *
     * @returns {boolean}
     */
    showLocalNewBadge: function showLocalNewBadge() {
      return this.comment.is_new && this.showNewBadge;
    },

    /**
     * Returns the success message based on user type.
     *
     * @returns {string}
     */
    successMessage: function successMessage() {
      return this.isBrokerUser ? 'Your comment has been sent to the carrier(s)' : 'Your comment has been sent to your broker.';
    },

    /**
     * Return organization name, if set, regardless of user type
     *
     * @returns {string}
     */
    userName: function userName() {
      var user = this.comment.user;
      var userName = "".concat(user.first_name, " ").concat(user.last_name);

      if (!this.isSameOrganization) {
        userName = "".concat(userName, " at ").concat(this.organizationName);
      }

      return userName;
    }
  },

  /*
  }
  * Check if we saved a comment in session storage that wasn't submitted and also sort any replies.
  * If this is a newly added comment, show the alert for 5 seconds.
  */
  created: function created() {
    var _this2 = this;

    var savedComment = window.sessionStorage.getItem("comment-".concat(this.comment.id));

    if (savedComment) {
      var commentObject = JSON.parse(savedComment);
      this.autoSaveTimestamp = commentObject.timestamp;
      this.commentText = commentObject.message;
      this.showCommentBox = true;
    }

    if (this.comment.showSuccess) {
      this.showSuccessMessage = true;
      this.interval = setInterval(function () {
        _this2.showSuccessMessage = false;
      }, 5000);
    }
  },
  methods: {
    /**
     * Clear out the comment
     */
    clearData: function clearData() {
      this.autoSaveTimestamp = '';
      this.commentText = '';
    },

    /**
     * Toggle the reply box for this comment
     */
    onCancel: function onCancel() {
      this.showCommentBox = false;
      this.clearData();
    },

    /**
     * Toggle the reply box for this comment and emit the reply to the parent
     *
     * @param {event} $event
     */
    onCommentAdded: function onCommentAdded($event) {
      this.$emit('commentAdded', $event);
      this.showCommentBox = false;
      this.clearData();
    }
  }
};

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [
        { "pdf-export-container": _vm.isPdfRender },
        { "is-reply": _vm.isReply },
        "tf-comment-container",
        "wt-comment-container"
      ]
    },
    [
      _vm.showSuccessMessage
        ? _c("el-alert", {
            attrs: {
              "show-icon": "",
              closable: false,
              title: _vm.successMessage,
              type: "success"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLocalNewBadge
        ? _c("tf-badge", {
            class: { indent: _vm.isReply },
            attrs: { size: "small", status: "success", value: "new" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          class: [
            "sender-recipient",
            {
              "pdf-export-block": _vm.isPdfRender,
              indent: _vm.isReply
            }
          ]
        },
        [
          _c("strong", [_vm._v(_vm._s(_vm.userName))]),
          _vm._v(" "),
          _vm.commentRecipient
            ? [
                _vm._v("\n      to "),
                _c("strong", [_vm._v(_vm._s(_vm.commentRecipient))])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("p", {
        class: [
          "date",
          {
            "pdf-export-block": _vm.isPdfRender,
            indent: _vm.isReply
          }
        ],
        domProps: {
          textContent: _vm._s(
            _vm.$TF.DatesUtils.formatDateAndTime(_vm.comment.created_at)
          )
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "comment" },
        [
          _vm._l(_vm.commentParagraphs, function(paragraphs, index) {
            return _vm._l(paragraphs, function(p, pIndex) {
              return _c("p", {
                key: index + "-" + pIndex,
                class: {
                  "no-break":
                    paragraphs.length > 1 && pIndex !== paragraphs.length - 1,
                  "pdf-export-block": _vm.isPdfRender,
                  indent: _vm.isReply,
                  "is-last":
                    index === _vm.commentParagraphs.length - 1 &&
                    pIndex === paragraphs.length - 1
                },
                domProps: { textContent: _vm._s(p.trim()) }
              })
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "tf-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showCommentBox && _vm.showReplyButton,
              expression: "!showCommentBox && showReplyButton"
            }
          ],
          class: { indent: _vm.isReply },
          attrs: { type: "primary", icon: "reply", size: "text-icon" },
          on: {
            click: function($event) {
              _vm.showCommentBox = true;
            }
          }
        },
        [_vm._v("\n    Reply\n  ")]
      ),
      _vm._v(" "),
      _c("comment-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCommentBox && !_vm.isPdfRender,
            expression: "showCommentBox && !isPdfRender"
          }
        ],
        attrs: {
          "application-namespace": _vm.applicationNamespace,
          "auto-save-timestamp": _vm.autoSaveTimestamp,
          comment: _vm.comment,
          "inline-success": _vm.inlineSuccess,
          "parent-id": _vm.commentParentId,
          "project-id": _vm.projectId,
          "proposal-document-id": _vm.proposalDocumentId,
          "user-info": _vm.userInfo
        },
        on: { cancel: _vm.onCancel, commentAdded: _vm.onCommentAdded },
        model: {
          value: _vm.commentText,
          callback: function($$v) {
            _vm.commentText = $$v;
          },
          expression: "commentText"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.orderedReplies.length,
              expression: "orderedReplies.length"
            }
          ]
        },
        _vm._l(_vm.orderedReplies, function(commentReply, index) {
          return _c("comment", {
            key: commentReply.id,
            attrs: {
              "application-namespace": _vm.applicationNamespace,
              broker: _vm.broker,
              comment: commentReply,
              documents: _vm.documents,
              "is-reply": true,
              "is-pdf-render": _vm.isPdfRender,
              "parent-id": _vm.commentParentId,
              "proposal-document-id": _vm.proposalDocumentId,
              "project-id": _vm.projectId,
              "show-reply-button": !index,
              "user-info": _vm.userInfo
            },
            on: { commentAdded: _vm.onCommentAdded }
          })
        }),
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$v = [];
__vue_render__$v._withStripped = true;

  /* style */
  const __vue_inject_styles__$w = function (inject) {
    if (!inject) return
    inject("data-v-002bcb29_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.pdf-export-container .tf-button.icon-reply[data-v-002bcb29],\n.pdf-export-container .wt-button.icon-reply[data-v-002bcb29], .pdf-export-container .alert-new.alert-simple[data-v-002bcb29], .pdf-export-container .el-alert[data-v-002bcb29] {\n  display: none;\n}\n.tf-comment-container[data-v-002bcb29],\n.wt-comment-container[data-v-002bcb29] {\n  padding: 15px 15px 15px 0;\n  font-size: 14px;\n  line-height: 20px;\n  border-top: solid 1px #efefef;\n}\n.tf-comment-container[data-v-002bcb29]:first-child,\n.wt-comment-container[data-v-002bcb29]:first-child {\n  border-top: 0;\n}\n.tf-comment-container.is-reply:first-child .el-alert + .name[data-v-002bcb29],\n.wt-comment-container.is-reply:first-child .el-alert + .name[data-v-002bcb29] {\n  padding-top: 14px;\n}\n.tf-comment-container > .tf-badge[data-v-002bcb29],\n.wt-comment-container > .tf-badge[data-v-002bcb29] {\n  margin-bottom: 10px;\n}\n.date[data-v-002bcb29] {\n  color: #999;\n  font-style: italic;\n}\n.el-alert[data-v-002bcb29] {\n  margin: 0 0 15px;\n}\n.alert-new.alert-simple[data-v-002bcb29] {\n  margin: 0;\n  padding: 5px 10px;\n}\n.tf-button.icon-reply[data-v-002bcb29],\n.wt-button.icon-reply[data-v-002bcb29] {\n  margin-top: 12px;\n}\n.indent[data-v-002bcb29],\n.alert-new.alert-simple.indent[data-v-002bcb29],\n.tf-button.indent[data-v-002bcb29],\n.wt-button.indent[data-v-002bcb29] {\n  margin-left: 35px;\n}\np[data-v-002bcb29] {\n  margin: 0;\n  line-height: 20px;\n}\n.comment p[data-v-002bcb29] {\n  margin-bottom: 20px;\n}\n.comment p.no-break[data-v-002bcb29] {\n  margin-bottom: 0;\n}\n.comment p[data-v-002bcb29]:last-child {\n  margin-bottom: 0;\n}\np.pdf-export-block[data-v-002bcb29] {\n  width: 530px;\n  font-size: 12px;\n  line-height: 16px;\n}\np.pdf-export-block.indent[data-v-002bcb29] {\n  width: 495px;\n}\np.pdf-export-block.is-last[data-v-002bcb29] {\n  margin-bottom: 16px;\n}\np.pdf-export-block.sender-recipient[data-v-002bcb29] {\n  padding-top: 16px;\n  border-top: 1px solid #c1c1c1;\n}\n.pdf-export-header + p.pdf-export-block.sender-recipient[data-v-002bcb29] {\n  padding-top: 0;\n  border-top: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/circleci/repo/src/components/Comment/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC2YpC;;EACA,aAAA;ADxYA;AC4YA;;EAEA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;ADzYA;AC2YA;;EACA,aAAA;ADxYA;AC4YA;;EACA,iBAAA;ADzYA;AC6YA;;EACA,mBAAA;AD1YA;AC8YA;EACA,WAAA;EACA,kBAAA;AD3YA;AC8YA;EACA,gBAAA;AD3YA;ACgZA;EACA,SAAA;EACA,iBAAA;AD7YA;ACkZA;;EAEA,gBAAA;AD/YA;ACqZA;;;;EAIA,iBAAA;ADlZA;ACqZA;EACA,SAAA;EACA,iBAAA;ADlZA;ACoZA;EACA,mBAAA;ADlZA;ACoZA;EACA,gBAAA;ADlZA;ACqZA;EACA,gBAAA;ADnZA;ACuZA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;ADrZA;ACuZA;EACA,YAAA;ADrZA;ACwZA;EACA,mBAAA;ADtZA;ACyZA;EACA,iBAAA;EAGA,6BAAA;ADzZA;AC2ZA;EACA,cAAA;EACA,aAAA;ADzZA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.pdf-export-container .tf-button.icon-reply,\n.pdf-export-container .wt-button.icon-reply, .pdf-export-container .alert-new.alert-simple, .pdf-export-container .el-alert {\n  display: none;\n}\n\n.tf-comment-container,\n.wt-comment-container {\n  padding: 15px 15px 15px 0;\n  font-size: 14px;\n  line-height: 20px;\n  border-top: solid 1px #efefef;\n}\n.tf-comment-container:first-child,\n.wt-comment-container:first-child {\n  border-top: 0;\n}\n.tf-comment-container.is-reply:first-child .el-alert + .name,\n.wt-comment-container.is-reply:first-child .el-alert + .name {\n  padding-top: 14px;\n}\n.tf-comment-container > .tf-badge,\n.wt-comment-container > .tf-badge {\n  margin-bottom: 10px;\n}\n\n.date {\n  color: #999;\n  font-style: italic;\n}\n\n.el-alert {\n  margin: 0 0 15px;\n}\n\n.alert-new.alert-simple {\n  margin: 0;\n  padding: 5px 10px;\n}\n\n.tf-button.icon-reply,\n.wt-button.icon-reply {\n  margin-top: 12px;\n}\n\n.indent,\n.alert-new.alert-simple.indent,\n.tf-button.indent,\n.wt-button.indent {\n  margin-left: 35px;\n}\n\np {\n  margin: 0;\n  line-height: 20px;\n}\n.comment p {\n  margin-bottom: 20px;\n}\n.comment p.no-break {\n  margin-bottom: 0;\n}\n.comment p:last-child {\n  margin-bottom: 0;\n}\np.pdf-export-block {\n  width: 530px;\n  font-size: 12px;\n  line-height: 16px;\n}\np.pdf-export-block.indent {\n  width: 495px;\n}\np.pdf-export-block.is-last {\n  margin-bottom: 16px;\n}\np.pdf-export-block.sender-recipient {\n  padding-top: 16px;\n  border-top: 1px solid #c1c1c1;\n}\n.pdf-export-header + p.pdf-export-block.sender-recipient {\n  padding-top: 0;\n  border-top: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div\n    :class=\"[\n      { 'pdf-export-container': isPdfRender },\n      { 'is-reply': isReply },\n      'tf-comment-container',\n      'wt-comment-container'\n    ]\"\n  >\n    <el-alert\n      v-if=\"showSuccessMessage\"\n      show-icon\n      :closable=\"false\"\n      :title=\"successMessage\"\n      type=\"success\"\n    />\n    <tf-badge\n      v-if=\"showLocalNewBadge\"\n      :class=\"{ 'indent': isReply }\"\n      size=\"small\"\n      status=\"success\"\n      value=\"new\"\n    />\n    <p\n      :class=\"[\n        'sender-recipient',\n        {\n          'pdf-export-block': isPdfRender,\n          'indent': isReply,\n        }\n      ]\"\n    >\n      <strong>{{ userName }}</strong>\n      <template v-if=\"commentRecipient\">\n        to <strong>{{ commentRecipient }}</strong>\n      </template>\n    </p>\n    <p\n      :class=\"[\n        'date',\n        {\n          'pdf-export-block': isPdfRender,\n          'indent': isReply\n        }\n      ]\"\n      v-text=\"$TF.DatesUtils.formatDateAndTime(comment.created_at)\"\n    />\n    <div class=\"comment\">\n      <template v-for=\"(paragraphs, index) in commentParagraphs\">\n        <p\n          v-for=\"(p, pIndex) in paragraphs\"\n          :key=\"`${index}-${pIndex}`\"\n          :class=\"{\n            'no-break': paragraphs.length > 1 && pIndex !== paragraphs.length -1,\n            'pdf-export-block': isPdfRender,\n            'indent': isReply,\n            'is-last': index === commentParagraphs.length -1 && pIndex === paragraphs.length -1\n          }\"\n          v-text=\"p.trim()\"\n        />\n      </template>\n    </div>\n    <tf-button\n      v-show=\"!showCommentBox && showReplyButton\"\n      type=\"primary\"\n      icon=\"reply\"\n      size=\"text-icon\"\n      :class=\"{'indent': isReply}\"\n      @click=\"showCommentBox = true\"\n    >\n      Reply\n    </tf-button>\n    <comment-input\n      v-show=\"showCommentBox && !isPdfRender\"\n      v-model=\"commentText\"\n      :application-namespace=\"applicationNamespace\"\n      :auto-save-timestamp=\"autoSaveTimestamp\"\n      :comment=\"comment\"\n      :inline-success=\"inlineSuccess\"\n      :parent-id=\"commentParentId\"\n      :project-id=\"projectId\"\n      :proposal-document-id=\"proposalDocumentId\"\n      :user-info=\"userInfo\"\n      @cancel=\"onCancel\"\n      @commentAdded=\"onCommentAdded\"\n    />\n    <div v-show=\"orderedReplies.length\">\n      <comment\n        v-for=\"(commentReply, index) in orderedReplies\"\n        :key=\"commentReply.id\"\n        :application-namespace=\"applicationNamespace\"\n        :broker=\"broker\"\n        :comment=\"commentReply\"\n        :documents=\"documents\"\n        :is-reply=\"true\"\n        :is-pdf-render=\"isPdfRender\"\n        :parent-id=\"commentParentId\"\n        :proposal-document-id=\"proposalDocumentId\"\n        :project-id=\"projectId\"\n        :show-reply-button=\"!index\"\n        :user-info=\"userInfo\"\n        @commentAdded=\"onCommentAdded\"\n      />\n    </div>\n  </div>\n</template>\n\n<script>\n/**\n * The Comments component that includes the readonly and edit state of a comment.\n *\n * @vuedoc\n * @exports Comments/index\n * @category Components\n */\n  export default {\n    name: 'Comment',\n    props: {\n      applicationNamespace: {\n        type: String,\n        required: true,\n        default: '',\n      },\n      broker: {\n        type: Object,\n        required: true,\n        default: () => ({}),\n      },\n      comment: {\n        type: Object,\n        default: () => ({}),\n      },\n      documents: {\n        type: Array,\n        default: () => [],\n      },\n      inlineSuccess: {\n        type: Boolean,\n        default: true,\n      },\n      isReply: {\n        type: Boolean,\n        default: false,\n      },\n      isPdfRender: {\n        type: Boolean,\n        default: false,\n      },\n      parentId: {\n        type: Number,\n        default: null,\n      },\n      projectId: {\n        type: [Number, String],\n        default: '',\n        required: true,\n      },\n      proposalDocumentId: {\n        type: Number,\n        default: null,\n      },\n      showNewBadge: {\n        type: Boolean,\n        default: true,\n      },\n      showReplyButton: {\n        type: Boolean,\n        default: true,\n      },\n      userInfo: {\n        type: Object,\n        required: true,\n        default: () => ({\n          firstName: '',\n          lastName: '',\n          organization: '',\n          type: 'broker',\n        }),\n      },\n    },\n\n    data: () => ({\n      autoSaveTimestamp: '',\n      commentText: '',\n      showSuccessMessage: false,\n      showCommentBox: false,\n    }),\n\n    computed: {\n      /**\n       * Splits the comment content by `\\n\\n` into an array to use in the template.\n       *\n       * @returns {Array}\n       */\n      commentParagraphs() {\n        return this.comment.content\n          .split('\\n\\n')\n          .map((p) => p.split('\\n'));\n      },\n\n      /**\n       * If this is a top level comment, we should reply to this comment.\n       * If this is a reply, we should take the parentId prop\n       *\n       * @returns {string}\n       */\n      commentParentId() {\n        return this.isReply ? this.parentId : this.comment.id;\n      },\n\n      /**\n       * Evaluates recipient, userInfo and broker data to decide what to return in this.fullName.\n       *\n       * @returns {string}\n       */\n      commentRecipient() {\n        const recipient = this.documents.find(\n          (document) => document.id === this.comment.commentable_id,\n        );\n        let commentRecipient = null;\n\n        if (recipient) {\n          commentRecipient = this.broker.name;\n\n          // IF: this.comment originated from a broker we know it's to the carrier of a document => the recipient's (carrier's) name\n          // ELSE IF: this comment came from a carrier => assign broker name from this.userInfo.organization\n          if (this.comment.user.broker.name) {\n            commentRecipient = recipient.carrier.name;\n          } else if (this.isBrokerUser) {\n            commentRecipient = this.userInfo.organization;\n          }\n        }\n\n        return commentRecipient;\n      },\n\n      /**\n       * Determines if the user is a broker based on this.userInfo type.\n       *\n       * @returns {boolean}\n       */\n      isBrokerUser() {\n        return this.userInfo.type === 'broker';\n      },\n\n      /**\n       * Determines if the user is a carrier based on this.userInfo type.\n       *\n       * @returns {boolean}\n       */\n      isCarrierUser() {\n        return this.userInfo.type === 'carrier';\n      },\n\n      /**\n       * Evaluates broker and carrier data to decide what to return in this.fullName.\n       *\n       * @returns {boolean}\n       */\n      isSameOrganization() {\n        const isBroker = this.isBrokerUser\n          && this.userInfo.organization === this.comment.user.broker.name;\n        const isCarrier = this.isCarrierUser\n          && this.userInfo.organization === this.comment.user.carrier.name;\n\n        return isCarrier || isBroker;\n      },\n\n      /**\n       * Return organization name, if set, regardless of user type\n       *\n       * @returns {string}\n       */\n      organizationName() {\n        const isBroker = this.comment.user.broker\n          && this.comment.user.broker.name;\n        const isCarrier = this.comment.user.carrier\n          && this.comment.user.carrier.name;\n        let organizationName = null;\n\n        if (isCarrier) {\n          organizationName = this.comment.user.carrier.name;\n        }\n\n        if (isBroker) {\n          organizationName = this.comment.user.broker.name;\n        }\n\n        return organizationName;\n      },\n      /**\n       * Return organization name, if set, regardless of user type\n       *\n       * @returns {Array}\n       */\n      orderedReplies() {\n        return this.comment.replies\n          // eslint-disable-next-line vue/no-side-effects-in-computed-properties\n          ? this.$TF.Formatting.sortObjects(\n            this.comment.replies,\n            'created_at',\n            'desc',\n          )\n          : [];\n      },\n      /**\n       * Evaluates the comment and showNewBadge prop to decide to show the \"new\" badge.\n       *\n       * @returns {boolean}\n       */\n      showLocalNewBadge() {\n        return this.comment.is_new && this.showNewBadge;\n      },\n\n      /**\n       * Returns the success message based on user type.\n       *\n       * @returns {string}\n       */\n      successMessage() {\n        return this.isBrokerUser\n          ? 'Your comment has been sent to the carrier(s)'\n          : 'Your comment has been sent to your broker.';\n      },\n\n      /**\n       * Return organization name, if set, regardless of user type\n       *\n       * @returns {string}\n       */\n      userName() {\n        const { user } = this.comment;\n        let userName = `${user.first_name} ${user.last_name}`;\n\n        if (!this.isSameOrganization) {\n          userName = `${userName} at ${this.organizationName}`;\n        }\n\n        return userName;\n      },\n    },\n\n    /*\n  }\n  * Check if we saved a comment in session storage that wasn't submitted and also sort any replies.\n  * If this is a newly added comment, show the alert for 5 seconds.\n  */\n    created() {\n      const savedComment = window.sessionStorage.getItem(`comment-${this.comment.id}`);\n\n      if (savedComment) {\n        const commentObject = JSON.parse(savedComment);\n        this.autoSaveTimestamp = commentObject.timestamp;\n        this.commentText = commentObject.message;\n        this.showCommentBox = true;\n      }\n\n      if (this.comment.showSuccess) {\n        this.showSuccessMessage = true;\n        this.interval = setInterval(() => {\n          this.showSuccessMessage = false;\n        }, 5000);\n      }\n    },\n\n    methods: {\n      /**\n       * Clear out the comment\n       */\n      clearData() {\n        this.autoSaveTimestamp = '';\n        this.commentText = '';\n      },\n\n      /**\n       * Toggle the reply box for this comment\n       */\n      onCancel() {\n        this.showCommentBox = false;\n        this.clearData();\n      },\n\n      /**\n       * Toggle the reply box for this comment and emit the reply to the parent\n       *\n       * @param {event} $event\n       */\n      onCommentAdded($event) {\n        this.$emit('commentAdded', $event);\n        this.showCommentBox = false;\n        this.clearData();\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  %hideOnPdf {\n    .pdf-export-container & {\n      display: none;\n    }\n  }\n\n  .tf-comment-container,\n  .wt-comment-container {\n    padding: 15px 15px 15px 0;\n    font-size: 14px;\n    line-height: 20px;\n    border-top: solid 1px $tf-extra-light-gray-1;\n\n    &:first-child {\n      border-top: 0;\n    }\n\n    &.is-reply:first-child {\n      .el-alert + .name {\n        padding-top: 14px;\n      }\n    }\n\n    > .tf-badge {\n      margin-bottom: 10px;\n    }\n  }\n\n  .date {\n    color: $tf-medium-gray;\n    font-style: italic;\n  }\n\n  .el-alert {\n    margin: 0 0 15px;\n\n    @extend %hideOnPdf;\n  }\n\n  .alert-new.alert-simple {\n    margin: 0;\n    padding: 5px 10px;\n\n    @extend %hideOnPdf;\n  }\n\n  .tf-button.icon-reply,\n  .wt-button.icon-reply {\n    margin-top: 12px;\n\n    @extend %hideOnPdf;\n  }\n\n  // frustrating amount of specifity needed for these\n  .indent,\n  .alert-new.alert-simple.indent,\n  .tf-button.indent,\n  .wt-button.indent {\n    margin-left: 35px;\n  }\n\n  p {\n    margin: 0;\n    line-height: 20px;\n\n    .comment & {\n      margin-bottom: 20px;\n\n      &.no-break {\n        margin-bottom: 0;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    &.pdf-export-block {\n      width: 530px;\n      font-size: 12px;\n      line-height: 16px;\n\n      &.indent {\n        width: 495px;\n      }\n\n      &.is-last {\n        margin-bottom: 16px;\n      }\n\n      &.sender-recipient {\n        padding-top: 16px;\n        // Dashed lines currently break the UI (https://watchtower.atlassian.net/browse/BA-1563)\n        // border-top: 2px $tf-light-gray dashed;\n        border-top: 1px solid $tf-light-gray;\n\n        .pdf-export-header + & {\n          padding-top: 0;\n          border-top: 0;\n        }\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$w = "data-v-002bcb29";
  /* module identifier */
  const __vue_module_identifier__$w = undefined;
  /* functional template */
  const __vue_is_functional_template__$w = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$w = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    browser,
    undefined,
    undefined
  );

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
var _dateToIsoString = (_fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !_fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()



// PhantomJS / old WebKit has a broken implementations
_export(_export.P + _export.F * (Date.prototype.toISOString !== _dateToIsoString), 'Date', {
  toISOString: _dateToIsoString
});

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The Comments input component.
 *
 * @vuedoc
 * @exports Comments/Input
 * @category Components
 */
var script$x = {
  name: 'CommentInput',
  props: {
    applicationNamespace: {
      type: String,
      default: '',
      required: true
    },
    autoSaveTimestamp: {
      type: String,
      default: null
    },
    comment: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    commentableIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    customSessionName: {
      type: String,
      default: null
    },
    disableSubmit: {
      type: Boolean,
      default: false
    },
    inlineSuccess: {
      type: Boolean,
      default: true
    },
    parentId: {
      type: Number,
      default: null
    },
    projectId: {
      type: [Number, String],
      default: '',
      required: true
    },
    proposalDocumentId: {
      type: Number,
      default: null
    },
    saveSession: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    userInfo: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          firstName: '',
          lastName: '',
          organization: '',
          type: 'broker'
        };
      }
    },
    value: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: function data() {
    return {
      errorOnSubmit: null,
      timestamp: '',
      isSaving: false,
      timer: 0
    };
  },
  computed: {
    /**
     * get(): returns the v-model from the parent
     * set(): emits to the parent new model.
     *
     * @returns {string}
     */
    commentValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);

        if (this.saveSession) {
          this.updateSession(value);
        }
      }
    },

    /**
     * Formats this.autoSaveTimestamp to use in the template.
     *
     * @returns {string}
     */
    formattedTimestamp: function formattedTimestamp() {
      return this.$TF.DatesUtils.formatDateAndTime(this.timestamp);
    },

    /**
     * Formats a default label based on user info.
     *
     * @returns {string}
     */
    label: function label() {
      var _this$userInfo = this.userInfo,
          firstName = _this$userInfo.firstName,
          lastName = _this$userInfo.lastName,
          organization = _this$userInfo.organization;
      return "".concat(firstName, " ").concat(lastName, " at ").concat(organization);
    },

    /**
     * Formats this.autoSaveTimestamp to use in the template.
     *
     * @returns {string}
     */
    sessionName: function sessionName() {
      return this.customSessionName || "comment-".concat(this.comment.id);
    }
  },

  /**
   * The parent controls if there is an inital timestamp from session
   * so we should pass it as a prop there and set it on create here.
   */
  created: function created() {
    if (this.autoSaveTimestamp) {
      this.timestamp = this.autoSaveTimestamp;
    }
  },
  methods: {
    /**
     * Debounce on value change and update the session storage every 3 second unless the user is typing.
     *
     * @param {string} message
     */
    updateSession: function updateSession(message) {
      var _this = this;

      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        if (_this.isSaving) {
          return;
        }

        _this.timestamp = new Date(new Date().getTime()).toISOString();
        var commentObject = JSON.stringify({
          message: message,
          projectId: _this.projectId,
          timestamp: _this.timestamp
        });
        window.sessionStorage.setItem(_this.sessionName, commentObject);
      }, 3000);
    },

    /**
     * Removes the session and emits 'cancel' to the parent.
     */
    onClickCancel: function onClickCancel() {
      if (this.saveSession) {
        window.sessionStorage.removeItem(this.sessionName);
        clearTimeout(this.timer);
      }

      this.$emit('cancel');
    },

    /**
     * Submits the comment and emits 'commentAdded' to the parent.
     */
    onClickSubmit: function onClickSubmit() {
      var _this2 = this;

      var commentableIds = this.proposalDocumentId || this.comment.commentable_id;
      this.isSaving = true;
      this.errorOnSubmit = null;

      if (this.commentableIds.length) {
        commentableIds = this.commentableIds;
      }

      this.$TF.CommentService.postComment({
        applicationNamespace: this.applicationNamespace,
        content: this.commentValue,
        commentableIds: commentableIds,
        parentId: this.parentId
      }).then(function (data) {
        var newComments = Array.isArray(data.comments) ? data.comments : [data.comment];
        var orderedComments = newComments.map(function (comment) {
          return _objectSpread$4(_objectSpread$4({}, comment), {}, {
            showSuccess: _this2.inlineSuccess
          });
        });

        if (!_this2.inlineSuccess) {
          _this2.$message({
            showClose: true,
            message: 'Your comment has been sent to your broker.',
            type: 'success',
            duration: 5000
          });
        }

        orderedComments.forEach(function () {
          window.sessionStorage.removeItem(_this2.sessionName);
        });

        _this2.$emit('commentAdded', orderedComments);
      }).catch(function () {
        _this2.errorOnSubmit = 'There was an error submitting the comment.';
      }).finally(function () {
        _this2.isSaving = false;
        _this2.errorOnSubmit = null;

        if (_this2.saveSession) {
          clearTimeout(_this2.timer);
        }
      });
    }
  },
  destroy: function destroy() {
    if (this.saveSession) {
      clearTimeout(this.timer);
    }
  }
};

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: [{ "has-label": _vm.showLabel }, "comment-input-container"] },
    [
      _vm.showLabel
        ? _c("p", [_c("strong", [_vm._v(_vm._s(_vm.label))])])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "autosave-fade" } }, [
        _vm.timestamp
          ? _c("p", {
              staticClass: "timestamp",
              domProps: {
                textContent: _vm._s("Autosaved at " + _vm.formattedTimestamp)
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("el-form", [
        _c("div", { staticClass: "el-textarea" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.commentValue,
                expression: "commentValue"
              }
            ],
            staticClass: "el-textarea__inner",
            attrs: {
              disabled: _vm.isSaving,
              placeholder: "Enter your comment",
              rows: "6"
            },
            domProps: { value: _vm.commentValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.commentValue = $event.target.value;
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-group align-end" },
        [
          _c(
            "tf-button",
            {
              attrs: { type: "secondary", size: "medium" },
              on: { click: _vm.onClickCancel }
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "tf-button",
            {
              attrs: {
                disabled: !_vm.commentValue || _vm.disableSubmit,
                loading: _vm.isSaving,
                type: "primary",
                size: "medium"
              },
              on: { click: _vm.onClickSubmit }
            },
            [_vm._v("\n      Send\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.errorOnSubmit
        ? _c("p", {
            staticClass: "text-error",
            domProps: { textContent: _vm._s(_vm.errorOnSubmit) }
          })
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$w = [];
__vue_render__$w._withStripped = true;

  /* style */
  const __vue_inject_styles__$x = function (inject) {
    if (!inject) return
    inject("data-v-30315e22_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\np[data-v-30315e22] {\n  margin-bottom: 0;\n}\n.autosave-fade-enter-active[data-v-30315e22], .autosave-fade-leave-active[data-v-30315e22] {\n  transition: all 0.75s;\n  max-height: 50px;\n}\n.autosave-fade-enter[data-v-30315e22], .autosave-fade-leave-to[data-v-30315e22] {\n  opacity: 0;\n  max-height: 0;\n}\n.timestamp[data-v-30315e22] {\n  color: #999;\n  text-align: right;\n}\n.comment-input-container.has-label[data-v-30315e22] {\n  margin-top: 12px;\n}\n.el-textarea[data-v-30315e22] {\n  margin: 10px 0 15px;\n}\n.text-error[data-v-30315e22] {\n  text-align: right;\n}\n\n/*# sourceMappingURL=Input.vue.map */", map: {"version":3,"sources":["Input.vue","/home/circleci/repo/src/components/Comment/Input.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AACpC;;kCAEkC;AAClC;;oCAEoC;ACmSpC;EACA,gBAAA;ADjSA;ACqSA;EAEA,qBAAA;EACA,gBAAA;ADnSA;ACsSA;EAEA,UAAA;EACA,aAAA;ADrSA;ACySA;EACA,WAAA;EACA,iBAAA;ADtSA;ACySA;EACA,gBAAA;ADtSA;ACySA;EACA,mBAAA;ADtSA;ACySA;EACA,iBAAA;ADtSA;;AAEA,oCAAoC","file":"Input.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\np {\n  margin-bottom: 0;\n}\n\n.autosave-fade-enter-active, .autosave-fade-leave-active {\n  transition: all 0.75s;\n  max-height: 50px;\n}\n.autosave-fade-enter, .autosave-fade-leave-to {\n  opacity: 0;\n  max-height: 0;\n}\n\n.timestamp {\n  color: #999;\n  text-align: right;\n}\n\n.comment-input-container.has-label {\n  margin-top: 12px;\n}\n\n.el-textarea {\n  margin: 10px 0 15px;\n}\n\n.text-error {\n  text-align: right;\n}\n\n/*# sourceMappingURL=Input.vue.map */","<template>\n  <div :class=\"[{ 'has-label': showLabel }, 'comment-input-container']\">\n    <p v-if=\"showLabel\">\n      <strong>{{ label }}</strong>\n    </p>\n    <transition name=\"autosave-fade\">\n      <p\n        v-if=\"timestamp\"\n        class=\"timestamp\"\n        v-text=\"`Autosaved at ${formattedTimestamp}`\"\n      />\n    </transition>\n    <el-form>\n      <div class=\"el-textarea\">\n        <!--\n          We're using a textarea here to \"solve\" https://watchtower.atlassian.net/browse/SUP-166\n        -->\n        <textarea\n          v-model=\"commentValue\"\n          :disabled=\"isSaving\"\n          class=\"el-textarea__inner\"\n          placeholder=\"Enter your comment\"\n          rows=\"6\"\n        />\n      </div>\n    </el-form>\n    <div class=\"btn-group align-end\">\n      <tf-button\n        type=\"secondary\"\n        size=\"medium\"\n        @click=\"onClickCancel\"\n      >\n        Cancel\n      </tf-button>\n      <tf-button\n        :disabled=\"!commentValue || disableSubmit\"\n        :loading=\"isSaving\"\n        type=\"primary\"\n        size=\"medium\"\n        @click=\"onClickSubmit\"\n      >\n        Send\n      </tf-button>\n    </div>\n    <p\n      v-if=\"errorOnSubmit\"\n      class=\"text-error\"\n      v-text=\"errorOnSubmit\"\n    />\n  </div>\n</template>\n<script>\n/**\n * The Comments input component.\n *\n * @vuedoc\n * @exports Comments/Input\n * @category Components\n */\n\n  export default {\n    name: 'CommentInput',\n    props: {\n      applicationNamespace: {\n        type: String,\n        default: '',\n        required: true,\n      },\n      autoSaveTimestamp: {\n        type: String,\n        default: null,\n      },\n      comment: {\n        type: Object,\n        default: () => ({}),\n      },\n      commentableIds: {\n        type: Array,\n        default: () => [],\n      },\n      customSessionName: {\n        type: String,\n        default: null,\n      },\n      disableSubmit: {\n        type: Boolean,\n        default: false,\n      },\n      inlineSuccess: {\n        type: Boolean,\n        default: true,\n      },\n      parentId: {\n        type: Number,\n        default: null,\n      },\n      projectId: {\n        type: [Number, String],\n        default: '',\n        required: true,\n      },\n      proposalDocumentId: {\n        type: Number,\n        default: null,\n      },\n      saveSession: {\n        type: Boolean,\n        default: true,\n      },\n      showLabel: {\n        type: Boolean,\n        default: true,\n      },\n      userInfo: {\n        type: Object,\n        required: true,\n        default: () => ({\n          firstName: '',\n          lastName: '',\n          organization: '',\n          type: 'broker',\n        }),\n      },\n      value: {\n        type: String,\n        required: true,\n        default: '',\n      },\n    },\n\n    data: () => ({\n      errorOnSubmit: null,\n      timestamp: '',\n      isSaving: false,\n      timer: 0,\n    }),\n\n    computed: {\n      /**\n       * get(): returns the v-model from the parent\n       * set(): emits to the parent new model.\n       *\n       * @returns {string}\n       */\n      commentValue: {\n        get() {\n          return this.value;\n        },\n        set(value) {\n          this.$emit('input', value);\n\n          if (this.saveSession) {\n            this.updateSession(value);\n          }\n        },\n      },\n\n      /**\n       * Formats this.autoSaveTimestamp to use in the template.\n       *\n       * @returns {string}\n       */\n      formattedTimestamp() {\n        return this.$TF.DatesUtils.formatDateAndTime(this.timestamp);\n      },\n\n      /**\n       * Formats a default label based on user info.\n       *\n       * @returns {string}\n       */\n      label() {\n        const { firstName, lastName, organization } = this.userInfo;\n\n        return `${firstName} ${lastName} at ${organization}`;\n      },\n\n      /**\n       * Formats this.autoSaveTimestamp to use in the template.\n       *\n       * @returns {string}\n       */\n      sessionName() {\n        return this.customSessionName || `comment-${this.comment.id}`;\n      },\n    },\n\n    /**\n     * The parent controls if there is an inital timestamp from session\n     * so we should pass it as a prop there and set it on create here.\n     */\n    created() {\n      if (this.autoSaveTimestamp) {\n        this.timestamp = this.autoSaveTimestamp;\n      }\n    },\n\n    methods: {\n      /**\n       * Debounce on value change and update the session storage every 3 second unless the user is typing.\n       *\n       * @param {string} message\n       */\n      updateSession(message) {\n        clearTimeout(this.timer);\n\n        this.timer = setTimeout(() => {\n          if (this.isSaving) {\n            return;\n          }\n\n          this.timestamp = new Date(new Date().getTime()).toISOString();\n\n          const commentObject = JSON.stringify({\n            message,\n            projectId: this.projectId,\n            timestamp: this.timestamp,\n          });\n\n          window.sessionStorage.setItem(this.sessionName, commentObject);\n        }, 3000);\n      },\n\n      /**\n       * Removes the session and emits 'cancel' to the parent.\n       */\n      onClickCancel() {\n        if (this.saveSession) {\n          window.sessionStorage.removeItem(this.sessionName);\n          clearTimeout(this.timer);\n        }\n\n        this.$emit('cancel');\n      },\n\n      /**\n       * Submits the comment and emits 'commentAdded' to the parent.\n       */\n      onClickSubmit() {\n        let commentableIds = this.proposalDocumentId || this.comment.commentable_id;\n\n        this.isSaving = true;\n        this.errorOnSubmit = null;\n\n        if (this.commentableIds.length) {\n          commentableIds = this.commentableIds;\n        }\n\n        this.$TF.CommentService\n          .postComment({\n            applicationNamespace: this.applicationNamespace,\n            content: this.commentValue,\n            commentableIds,\n            parentId: this.parentId,\n          })\n          .then((data) => {\n            const newComments = Array.isArray(data.comments)\n              ? data.comments\n              : [data.comment];\n            const orderedComments = newComments.map((comment) => ({\n              ...comment,\n              showSuccess: this.inlineSuccess,\n            }));\n            if (!this.inlineSuccess) {\n              this.$message({\n                showClose: true,\n                message: 'Your comment has been sent to your broker.',\n                type: 'success',\n                duration: 5000,\n              });\n            }\n            orderedComments.forEach(() => {\n              window.sessionStorage.removeItem(this.sessionName);\n            });\n            this.$emit('commentAdded', orderedComments);\n          })\n          .catch(() => {\n            this.errorOnSubmit = 'There was an error submitting the comment.';\n          })\n          .finally(() => {\n            this.isSaving = false;\n            this.errorOnSubmit = null;\n\n            if (this.saveSession) {\n              clearTimeout(this.timer);\n            }\n          });\n      },\n    },\n\n    destroy() {\n      if (this.saveSession) {\n        clearTimeout(this.timer);\n      }\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  p {\n    margin-bottom: 0;\n  }\n\n  .autosave-fade {\n    &-enter-active,\n    &-leave-active {\n      transition: all .75s;\n      max-height: 50px;\n    }\n\n    &-enter,\n    &-leave-to /* .fade-leave-active below version 2.1.8 */ {\n      opacity: 0;\n      max-height: 0;\n    }\n  }\n\n  .timestamp {\n    color: $tf-medium-gray;\n    text-align: right;\n  }\n\n  .comment-input-container.has-label {\n    margin-top: 12px;\n  }\n\n  .el-textarea {\n    margin: 10px 0 15px;\n  }\n\n  .text-error {\n    text-align: right;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$x = "data-v-30315e22";
  /* module identifier */
  const __vue_module_identifier__$x = undefined;
  /* functional template */
  const __vue_is_functional_template__$x = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$x = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$y = {
  name: 'CopyLinkContainer',
  props: {
    text: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    },
    linkType: {
      type: String,
      default: 'secondary'
    }
  },
  data: function data() {
    return {
      tooltipOpacity: 0
    };
  },
  methods: {
    /**
     * Copy the "Share Link" to the users clipboard
     */
    copyLink: function copyLink() {
      var _this = this;

      this.tooltipOpacity = 1;
      this.$refs.shareLink.select();
      document.execCommand('copy');
      clearTimeout(this.timeout);
      this.timeout = window.setTimeout(function () {
        _this.tooltipOpacity = 0;
      }, 3000);
    }
  }
};

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "copy-link-container" }, [
    _c("div", { staticClass: "copy-link-body" }, [
      _vm._v("\n    " + _vm._s(_vm.text) + "\n    "),
      _c("input", {
        ref: "shareLink",
        attrs: { readonly: "" },
        domProps: { value: _vm.link }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-container" },
      [
        _c(
          "tf-button",
          {
            attrs: { type: "secondary", size: "medium" },
            on: { click: _vm.copyLink }
          },
          [_vm._v("\n      Copy Link\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tooltip__popper is-dark copied-popper",
            style: "opacity: " + _vm.tooltipOpacity,
            attrs: { "x-placement": "top" }
          },
          [
            _vm._v("\n      Copied!\n      "),
            _c("div", {
              staticClass: "popper__arrow",
              attrs: { "x-arrow": "" }
            })
          ]
        )
      ],
      1
    )
  ])
};
var __vue_staticRenderFns__$x = [];
__vue_render__$x._withStripped = true;

  /* style */
  const __vue_inject_styles__$y = function (inject) {
    if (!inject) return
    inject("data-v-5df5919e_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.copy-link-container[data-v-5df5919e] {\n  background: #fff;\n  border: 1px #efefef solid;\n  box-sizing: border-box;\n  padding: 25px 20px 25px 15px;\n  position: relative;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n}\n.copy-link-container .el-tooltip__popper[data-v-5df5919e] {\n  width: auto;\n  color: #fff;\n  position: absolute;\n  right: 39px;\n  top: -15px;\n  transition: opacity 300ms;\n}\n.copy-link-container .el-tooltip__popper.copied-popper .popper__arrow[data-v-5df5919e] {\n  left: 24.5px;\n}\n.copy-link-body[data-v-5df5919e] {\n  font-size: 14px;\n  display: inline-block;\n  color: #42474c;\n  flex-grow: 1;\n  margin-right: 15px;\n}\n.copy-link-body input[data-v-5df5919e] {\n  color: #2638a6;\n  font-weight: bold;\n  background: transparent;\n  border: 0;\n  display: block;\n  width: 100%;\n  height: 15px;\n  margin-top: 2px;\n  text-overflow: ellipsis;\n}\n.button-container[data-v-5df5919e] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/*# sourceMappingURL=CopyLinkContainer.vue.map */", map: {"version":3,"sources":["CopyLinkContainer.vue","/home/circleci/repo/src/components/CopyLinkContainer.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AACpC;;kCAEkC;AAClC;;oCAEoC;AC+DpC;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AD7DA;AC+DA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;AD7DA;ACgEA;EACA,YAAA;AD9DA;ACkEA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AD/DA;ACiEA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AD/DA;ACmEA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ADhEA;;AAEA,gDAAgD","file":"CopyLinkContainer.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.copy-link-container {\n  background: #fff;\n  border: 1px #efefef solid;\n  box-sizing: border-box;\n  padding: 25px 20px 25px 15px;\n  position: relative;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n}\n.copy-link-container .el-tooltip__popper {\n  width: auto;\n  color: #fff;\n  position: absolute;\n  right: 39px;\n  top: -15px;\n  transition: opacity 300ms;\n}\n.copy-link-container .el-tooltip__popper.copied-popper .popper__arrow {\n  left: 24.5px;\n}\n\n.copy-link-body {\n  font-size: 14px;\n  display: inline-block;\n  color: #42474c;\n  flex-grow: 1;\n  margin-right: 15px;\n}\n.copy-link-body input {\n  color: #2638a6;\n  font-weight: bold;\n  background: transparent;\n  border: 0;\n  display: block;\n  width: 100%;\n  height: 15px;\n  margin-top: 2px;\n  text-overflow: ellipsis;\n}\n\n.button-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/*# sourceMappingURL=CopyLinkContainer.vue.map */","<template>\n  <div class=\"copy-link-container\">\n    <div class=\"copy-link-body\">\n      {{ text }}\n      <input\n        ref=\"shareLink\"\n        :value=\"link\"\n        readonly\n      >\n    </div>\n    <div class=\"button-container\">\n      <tf-button\n        type=\"secondary\"\n        size=\"medium\"\n        @click=\"copyLink\"\n      >\n        Copy Link\n      </tf-button>\n      <div\n        :style=\"`opacity: ${tooltipOpacity}`\"\n        class=\"el-tooltip__popper is-dark copied-popper\"\n        x-placement=\"top\"\n      >\n        Copied!\n        <div\n          x-arrow=\"\"\n          class=\"popper__arrow\"\n        />\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'CopyLinkContainer',\n    props: {\n      text: {\n        type: String,\n        default: null,\n      },\n      link: {\n        type: String,\n        default: null,\n      },\n      linkType: {\n        type: String,\n        default: 'secondary',\n      },\n    },\n    data: () => ({\n      tooltipOpacity: 0,\n    }),\n    methods: {\n      /**\n       * Copy the \"Share Link\" to the users clipboard\n       */\n      copyLink() {\n        this.tooltipOpacity = 1;\n        this.$refs.shareLink.select();\n        document.execCommand('copy');\n        clearTimeout(this.timeout);\n        this.timeout = window.setTimeout(() => {\n          this.tooltipOpacity = 0;\n        }, 3000);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  .copy-link-container {\n    background: $tf-white;\n    border: 1px $tf-extra-light-gray-1 solid;\n    box-sizing: border-box;\n    padding: 25px 20px 25px 15px;\n    position: relative;\n    text-align: left;\n    display: flex;\n    justify-content: space-between;\n\n    .el-tooltip__popper {\n      width: auto;\n      color: $tf-white;\n      position: absolute;\n      right: 39px;\n      top: -15px;\n      transition: opacity 300ms;\n    }\n\n    .el-tooltip__popper.copied-popper .popper__arrow {\n      left: 24.5px;\n    }\n  }\n\n  .copy-link-body {\n    font-size: 14px;\n    display: inline-block;\n    color: $tf-dark-gray;\n    flex-grow: 1;\n    margin-right: 15px;\n\n    input {\n      color: $tf-blue;\n      font-weight: bold;\n      background: transparent;\n      border: 0;\n      display: block;\n      width: 100%;\n      height: 15px;\n      margin-top: 2px;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .button-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$y = "data-v-5df5919e";
  /* module identifier */
  const __vue_module_identifier__$y = undefined;
  /* functional template */
  const __vue_is_functional_template__$y = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$y = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var apiUrl = process.env.VUE_APP_API_URL;
var authKey = 'X-API-AUTHTOKEN';
var cookieNameSpace = process.env.VUE_APP_COOKIE_NAMESPACE;
/**
 * Document Manager Category
 *
 * @vuedoc
 * @exports DocumentManagerCategory
 * @category Views
 */

var script$z = {
  name: 'DocumentManagerCategory',
  props: {
    applicationNamespace: {
      type: String,
      default: 'broker_portal'
    },
    documentId: {
      type: Number,
      default: null
    },
    documentLoaded: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: ''
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default: null
    }
  },
  data: function data(vm) {
    return {
      apiUrl: apiUrl,
      acceptableFileTypes: vm.$TF.ReusableData.getAcceptableUploadFileTypes(),
      acceptableFileExtensions: vm.$TF.ReusableData.getAcceptableUploadFileExtensions(),
      headers: _defineProperty({}, authKey, null)
    };
  },
  computed: {
    /**
     * Generate a unique class name based on the type of document category we're rendering
     *
     * @returns {string}
     */
    typeClass: function typeClass() {
      return this.type.replace(/::/g, '-').replace(/_/g, '-').toLowerCase();
    }
  },
  created: function created() {
    this.headers[authKey] = this.$TF.Cookies.getCookie("".concat(cookieNameSpace, "-auth-token"));
  },
  methods: {
    /**
     * Upload another file (by clicking the upload button)
     */
    onUploadMore: function onUploadMore() {
      this.$refs["".concat(this.typeClass, "-button")].$el.click();
    },

    /**
     * Relay source removal and update tooltip
     *
     * @param {object} source
     */
    onSourceRemoved: function onSourceRemoved(source) {
      this.$emit('sourceRemoved', source);
    },

    /**
     * Relay source addition and update tooltip
     *
     * @param {object} response
     */
    onSuccess: function onSuccess(response) {
      this.$emit('sourceAdded', response.successfully_uploaded_sources);
    },

    /**
     * Before you can upload a file we need to validate some stuff
     *
     * @param {object} file
     * @returns {boolean}
     */
    onBeforeUpload: function onBeforeUpload(file) {
      if (this.headers[authKey] !== this.$TF.Cookies.getCookie("".concat(cookieNameSpace, "-auth-token"))) {
        this.$emit('notAuthorized');
        return false;
      }

      var valid = true;
      var uploadError = 'Sorry, this file type isn’t accepted.';
      var extensionArray = file.name.split('.');
      var extension = extensionArray[extensionArray.length - 1];

      if (file.size > 26214400) {
        valid = false;
        uploadError = 'This file exceeds the 25mb limit. Not uploaded.';
      } else if (file.raw && file.raw.type) {
        valid = this.acceptableFileTypes.includes(file.raw.type);
      } else {
        valid = this.acceptableFileExtensions.includes(".".concat(extension.toLowerCase()));
      }

      this.$emit('error', {
        uploadError: valid ? '' : uploadError,
        uploadErrorDescription: ''
      });
      return valid;
    },

    /**
     * If there is an error in the upload process we need to show an error message (that we populate with this data)
     *
     * @param {event} error
     */
    onUploadError: function onUploadError(error) {
      // TODO Have Patti destroy this copy with something better
      this.$emit('error', {
        status: error.status,
        uploadError: 'Sorry, we messed something up',
        uploadErrorDescription: 'Give it another go. If this annoyance continues, give us a shout and we’ll fix it.'
      });
    }
  }
};

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    { staticClass: "document-category", class: _vm.typeClass },
    [
      _c("h3", [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]),
      _vm._v(" "),
      !_vm.fileList.length && _vm.emptyText
        ? _c("p", [_vm._v("\n    " + _vm._s(_vm.emptyText) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.default
        ? _c("div", { staticClass: "details" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "file-list" },
        _vm._l(_vm.fileList, function(file) {
          return _c("document-manager-item", {
            key: file.id,
            attrs: {
              "application-namespace": _vm.applicationNamespace,
              file: file,
              "show-delete-button": _vm.userInfo.id === file.user_id,
              "show-button-label": true,
              "is-broker": true
            },
            on: { sourceRemoved: _vm.onSourceRemoved }
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.documentLoaded
        ? _c(
            "el-upload",
            {
              staticClass: "upload",
              attrs: {
                action:
                  _vm.apiUrl +
                  "/v1/" +
                  _vm.applicationNamespace +
                  "/documents/" +
                  _vm.documentId +
                  "/upload_sources",
                headers: _vm.headers,
                data: { type: _vm.type },
                "on-success": _vm.onSuccess,
                "before-upload": _vm.onBeforeUpload,
                "on-error": _vm.onUploadError,
                accept: _vm.acceptableFileExtensions.join(","),
                "auto-upload": true,
                name: "files[]",
                multiple: ""
              }
            },
            [
              _c(
                "tf-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.fileList.length,
                      expression: "!fileList.length"
                    }
                  ],
                  ref: _vm.typeClass + "-button",
                  staticClass: "button-upload-files",
                  attrs: {
                    type: "secondary",
                    size: "medium",
                    icon: "file-upload"
                  }
                },
                [_vm._v("\n      Upload Files\n    ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fileList.length
        ? _c(
            "tf-button",
            {
              staticClass: "button-upload-more",
              attrs: {
                type: "primary",
                icon: "file-upload",
                size: "text-icon-small"
              },
              on: { click: _vm.onUploadMore }
            },
            [_vm._v("\n    Upload More Files\n  ")]
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$y = [];
__vue_render__$y._withStripped = true;

  /* style */
  const __vue_inject_styles__$z = function (inject) {
    if (!inject) return
    inject("data-v-74934753_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.document-category[data-v-74934753] {\n  padding: 19px 0;\n}\nh3[data-v-74934753] {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n.upload[data-v-74934753] .el-upload-list__item.is-success {\n  display: none;\n}\n.upload[data-v-74934753] .el-upload-list__item.is-uploading {\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  border-top: 1px dashed #efefef;\n}\n.upload[data-v-74934753] .el-upload-list__item.is-uploading .el-icon-close {\n  top: 10px;\n}\n.upload[data-v-74934753] .el-upload-list__item.is-uploading .el-upload-list__item-name {\n  padding-top: 15px;\n  font-weight: normal;\n  color: #1b266f;\n}\n.upload[data-v-74934753] .el-upload-list__item.is-uploading .el-progress {\n  top: 35px;\n}\n.upload[data-v-74934753] .el-upload-list__item.is-uploading:hover {\n  background: transparent;\n}\n.details[data-v-74934753] {\n  padding-bottom: 18px;\n}\n.details[data-v-74934753] li, .details[data-v-74934753] p {\n  font-size: 14px;\n}\n.details[data-v-74934753] ul {\n  margin: 0 0 10px;\n  list-style: disc inside none;\n}\n.details[data-v-74934753] li {\n  color: #1b266f;\n}\n\n/*# sourceMappingURL=DocumentManagerCategory.vue.map */", map: {"version":3,"sources":["DocumentManagerCategory.vue","/home/circleci/repo/src/components/DocumentManagerCategory.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACoNpC;EACA,eAAA;ADlNA;ACqNA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;ADlNA;ACsNA;EACA,aAAA;ADnNA;ACsNA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;ADpNA;ACsNA;EACA,SAAA;ADpNA;ACuNA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;ADrNA;ACwNA;EACA,SAAA;ADtNA;ACyNA;EACA,uBAAA;ADvNA;AC4NA;EACA,oBAAA;ADzNA;AC2NA;EACA,eAAA;ADzNA;AC4NA;EACA,gBAAA;EACA,4BAAA;AD1NA;AC6NA;EACA,cAAA;AD3NA;;AAEA,sDAAsD","file":"DocumentManagerCategory.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.document-category {\n  padding: 19px 0;\n}\n\nh3 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.upload::v-deep .el-upload-list__item.is-success {\n  display: none;\n}\n.upload::v-deep .el-upload-list__item.is-uploading {\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  border-top: 1px dashed #efefef;\n}\n.upload::v-deep .el-upload-list__item.is-uploading .el-icon-close {\n  top: 10px;\n}\n.upload::v-deep .el-upload-list__item.is-uploading .el-upload-list__item-name {\n  padding-top: 15px;\n  font-weight: normal;\n  color: #1b266f;\n}\n.upload::v-deep .el-upload-list__item.is-uploading .el-progress {\n  top: 35px;\n}\n.upload::v-deep .el-upload-list__item.is-uploading:hover {\n  background: transparent;\n}\n\n.details::v-deep {\n  padding-bottom: 18px;\n}\n.details::v-deep li, .details::v-deep p {\n  font-size: 14px;\n}\n.details::v-deep ul {\n  margin: 0 0 10px;\n  list-style: disc inside none;\n}\n.details::v-deep li {\n  color: #1b266f;\n}\n\n/*# sourceMappingURL=DocumentManagerCategory.vue.map */","<template>\n  <li\n    class=\"document-category\"\n    :class=\"typeClass\"\n  >\n    <h3>\n      {{ title }}\n    </h3>\n    <p v-if=\"!fileList.length && emptyText\">\n      {{ emptyText }}\n    </p>\n    <div\n      v-if=\"$slots.default\"\n      class=\"details\"\n    >\n      <slot />\n    </div>\n    <ul class=\"file-list\">\n      <document-manager-item\n        v-for=\"file in fileList\"\n        :key=\"file.id\"\n        :application-namespace=\"applicationNamespace\"\n        :file=\"file\"\n        :show-delete-button=\"userInfo.id === file.user_id\"\n        :show-button-label=\"true\"\n        :is-broker=\"true\"\n        @sourceRemoved=\"onSourceRemoved\"\n      />\n    </ul>\n\n    <el-upload\n      v-if=\"documentLoaded\"\n      :action=\"`${apiUrl}/v1/${applicationNamespace}/documents/${documentId}/upload_sources`\"\n      :headers=\"headers\"\n      :data=\"{ type: type }\"\n      :on-success=\"onSuccess\"\n      :before-upload=\"onBeforeUpload\"\n      :on-error=\"onUploadError\"\n      :accept=\"acceptableFileExtensions.join(',')\"\n      :auto-upload=\"true\"\n      name=\"files[]\"\n      class=\"upload\"\n      multiple\n    >\n      <tf-button\n        v-show=\"!fileList.length\"\n        :ref=\"`${typeClass}-button`\"\n        class=\"button-upload-files\"\n        type=\"secondary\"\n        size=\"medium\"\n        icon=\"file-upload\"\n      >\n        Upload Files\n      </tf-button>\n    </el-upload>\n    <tf-button\n      v-if=\"fileList.length\"\n      class=\"button-upload-more\"\n      type=\"primary\"\n      icon=\"file-upload\"\n      size=\"text-icon-small\"\n      @click=\"onUploadMore\"\n    >\n      Upload More Files\n    </tf-button>\n  </li>\n</template>\n\n<script>\n  const apiUrl = process.env.VUE_APP_API_URL;\n  const authKey = 'X-API-AUTHTOKEN';\n  const cookieNameSpace = process.env.VUE_APP_COOKIE_NAMESPACE;\n\n  /**\n   * Document Manager Category\n   *\n   * @vuedoc\n   * @exports DocumentManagerCategory\n   * @category Views\n   */\n  export default {\n    name: 'DocumentManagerCategory',\n    props: {\n      applicationNamespace: {\n        type: String,\n        default: 'broker_portal',\n      },\n      documentId: {\n        type: Number,\n        default: null,\n      },\n      documentLoaded: {\n        type: Boolean,\n        default: false,\n      },\n      emptyText: {\n        type: String,\n        default: '',\n      },\n      fileList: {\n        type: Array,\n        default: () => ([]),\n      },\n      title: {\n        type: String,\n        default: '',\n      },\n      type: {\n        type: String,\n        default: '',\n      },\n      userInfo: {\n        type: Object,\n        default: null,\n      },\n    },\n    data: (vm) => ({\n      apiUrl,\n      acceptableFileTypes: vm.$TF.ReusableData.getAcceptableUploadFileTypes(),\n      acceptableFileExtensions: vm.$TF.ReusableData.getAcceptableUploadFileExtensions(),\n      headers: {\n        [authKey]: null,\n      },\n    }),\n    computed: {\n      /**\n       * Generate a unique class name based on the type of document category we're rendering\n       *\n       * @returns {string}\n       */\n      typeClass() {\n        return this.type.replace(/::/g, '-').replace(/_/g, '-').toLowerCase();\n      },\n    },\n\n    created() {\n      this.headers[authKey] = this.$TF.Cookies.getCookie(`${cookieNameSpace}-auth-token`);\n    },\n\n    methods: {\n      /**\n       * Upload another file (by clicking the upload button)\n       */\n      onUploadMore() {\n        this.$refs[`${this.typeClass}-button`].$el.click();\n      },\n\n      /**\n       * Relay source removal and update tooltip\n       *\n       * @param {object} source\n       */\n      onSourceRemoved(source) {\n        this.$emit('sourceRemoved', source);\n      },\n\n      /**\n       * Relay source addition and update tooltip\n       *\n       * @param {object} response\n       */\n      onSuccess(response) {\n        this.$emit('sourceAdded', response.successfully_uploaded_sources);\n      },\n\n      /**\n       * Before you can upload a file we need to validate some stuff\n       *\n       * @param {object} file\n       * @returns {boolean}\n       */\n      onBeforeUpload(file) {\n        if (this.headers[authKey] !== this.$TF.Cookies.getCookie(`${cookieNameSpace}-auth-token`)) {\n          this.$emit('notAuthorized');\n          return false;\n        }\n\n        let valid = true;\n        let uploadError = 'Sorry, this file type isn’t accepted.';\n        const extensionArray = file.name.split('.');\n        const extension = extensionArray[extensionArray.length - 1];\n\n        if (file.size > 26214400) {\n          valid = false;\n          uploadError = 'This file exceeds the 25mb limit. Not uploaded.';\n        } else if (file.raw && file.raw.type) {\n          valid = this.acceptableFileTypes.includes(file.raw.type);\n        } else {\n          valid = this.acceptableFileExtensions.includes(`.${extension.toLowerCase()}`);\n        }\n        this.$emit('error', {\n          uploadError: valid ? '' : uploadError,\n          uploadErrorDescription: '',\n        });\n        return valid;\n      },\n\n      /**\n       * If there is an error in the upload process we need to show an error message (that we populate with this data)\n       *\n       * @param {event} error\n       */\n      onUploadError(error) {\n        // TODO Have Patti destroy this copy with something better\n        this.$emit('error', {\n          status: error.status,\n          uploadError: 'Sorry, we messed something up',\n          uploadErrorDescription: 'Give it another go. If this annoyance continues, give us a shout and we’ll fix it.',\n        });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/variables';\n\n.document-category {\n  padding: 19px 0;\n}\n\nh3 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.upload {\n  &::v-deep .el-upload-list__item.is-success {\n    display: none;\n  }\n\n  &::v-deep .el-upload-list__item.is-uploading {\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n    border-top: 1px dashed $tf-extra-light-gray-1;\n\n    .el-icon-close {\n      top: 10px;\n    }\n\n    .el-upload-list__item-name {\n      padding-top: 15px;\n      font-weight: normal;\n      color: $tf-dark-blue;\n    }\n\n    .el-progress {\n      top: 35px;\n    }\n\n    &:hover {\n      background: transparent;\n    }\n  }\n}\n\n.details::v-deep {\n  padding-bottom: 18px;\n\n  li, p {\n    font-size: 14px;\n  }\n\n  ul {\n    margin: 0 0 10px;\n    list-style: disc inside none;\n  }\n\n  li {\n    color: $tf-dark-blue;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$z = "data-v-74934753";
  /* module identifier */
  const __vue_module_identifier__$z = undefined;
  /* functional template */
  const __vue_is_functional_template__$z = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$z = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    browser,
    undefined,
    undefined
  );

var TYPED = _uid('typed_array');
var VIEW = _uid('view');
var ABV = !!(_global.ArrayBuffer && _global.DataView);
var CONSTR = ABV;
var i$2 = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i$2 < l) {
  if (Typed = _global[TypedArrayConstructors[i$2++]]) {
    _hide(Typed.prototype, TYPED, true);
    _hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

var _typed = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

// https://tc39.github.io/ecma262/#sec-toindex


var _toIndex = function (it) {
  if (it === undefined) return 0;
  var number = _toInteger(it);
  var length = _toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

var _arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = _toObject(this);
  var length = _toLength(O.length);
  var aLen = arguments.length;
  var index = _toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : _toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var _typedBuffer = createCommonjsModule(function (module, exports) {











var gOPN = _objectGopn.f;
var dP = _objectDp.f;


var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = _global[ARRAY_BUFFER];
var $DataView = _global[DATA_VIEW];
var Math = _global.Math;
var RangeError = _global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = _global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = _descriptors ? '_b' : BUFFER;
var $LENGTH = _descriptors ? '_l' : BYTE_LENGTH;
var $OFFSET = _descriptors ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = _toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = _toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!_typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    _anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = _toIndex(length);
    this._b = _arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    _anInstance(this, $DataView, DATA_VIEW);
    _anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = _toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : _toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (_descriptors) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  _redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!_fails(function () {
    $ArrayBuffer(1);
  }) || !_fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || _fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      _anInstance(this, $ArrayBuffer);
      return new BaseBuffer(_toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) _hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) _redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
_setToStringTag($ArrayBuffer, ARRAY_BUFFER);
_setToStringTag($DataView, DATA_VIEW);
_hide($DataView[PROTOTYPE], _typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;
});

var _arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = _toObject(this);
  var len = _toLength(O.length);
  var to = _toAbsoluteIndex(target, len);
  var from = _toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : _toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

var _typedArray = createCommonjsModule(function (module) {
if (_descriptors) {
  var LIBRARY = _library;
  var global = _global;
  var fails = _fails;
  var $export = _export;
  var $typed = _typed;
  var $buffer = _typedBuffer;
  var ctx = _ctx;
  var anInstance = _anInstance;
  var propertyDesc = _propertyDesc;
  var hide = _hide;
  var redefineAll = _redefineAll;
  var toInteger = _toInteger;
  var toLength = _toLength;
  var toIndex = _toIndex;
  var toAbsoluteIndex = _toAbsoluteIndex;
  var toPrimitive = _toPrimitive;
  var has = _has;
  var classof = _classof;
  var isObject = _isObject;
  var toObject = _toObject;
  var isArrayIter = _isArrayIter$1;
  var create = _objectCreate;
  var getPrototypeOf = _objectGpo;
  var gOPN = _objectGopn.f;
  var getIterFn = core_getIteratorMethod$1;
  var uid = _uid;
  var wks = _wks;
  var createArrayMethod = _arrayMethods;
  var createArrayIncludes = _arrayIncludes;
  var speciesConstructor = _speciesConstructor;
  var ArrayIterators = es6_array_iterator;
  var Iterators = _iterators;
  var $iterDetect = _iterDetect$1;
  var setSpecies = _setSpecies;
  var arrayFill = _arrayFill;
  var arrayCopyWithin = _arrayCopyWithin;
  var $DP = _objectDp;
  var $GOPD = _objectGopd;
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };
});

_typedArray('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$A = {
  name: 'DocumentManagerItem',
  props: {
    applicationNamespace: {
      type: String,
      default: '',
      required: true
    },
    file: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showButtonLabel: {
      type: Boolean,
      default: false
    },
    showDownloadButton: {
      type: Boolean,
      default: true
    },
    showDeleteButton: {
      type: Boolean,
      default: false
    },
    isBroker: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDownloadError: false,
      currentlyDownloading: false,
      disableDelete: false
    };
  },
  methods: {
    /**
     * If the user confirms they want to delete a file we call the source service to delete the file
     * We then emit that it was removed to the parent compponent
     */
    deleteSource: function deleteSource() {
      var _this = this;

      this.showDownloadError = false;
      this.disableDelete = true;
      this.$TF.SourceService.deleteSource(this.file.id, this.applicationNamespace).then(function () {
        _this.$emit('sourceRemoved', _this.file);
      });
    },

    /**
     * On click of the download button we call the getSource call from the source service
     */
    downloadSource: function downloadSource() {
      var _this2 = this;

      this.currentlyDownloading = true;
      this.showDownloadError = false;
      this.$TF.SourceService.getSource(this.file.id, this.applicationNamespace).then(function (response) {
        // call the api to get the data for this file
        var base64String = response.data.source.content.replace(/\s/g, '');
        var byteCharacters = window.atob(base64String);
        var byteNumbers = new Array(byteCharacters.length);

        for (var i = 0; i < byteCharacters.length; i += 1) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        var blob = new window.Blob([byteArray], {
          type: 'application/octet-stream'
        });
        _this2.currentlyDownloading = false;

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.data.source.file_file_name);
        } else {
          var downloadLink = document.createElement('a');
          downloadLink.value = 'Download';
          downloadLink.target = '_blank';
          downloadLink.download = response.data.source.file_file_name;
          var blobURL = '';
          blobURL = window.URL.createObjectURL(blob);
          downloadLink.href = blobURL;

          _this2.$el.appendChild(downloadLink); // fire a click event on the anchor


          downloadLink.click();
          downloadLink.remove();

          _this2.$emit('downloaded');
        }
      }).catch(function () {
        _this2.currentlyDownloading = false;
        _this2.showDownloadError = true;
      });
    }
  }
};

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("li", { staticClass: "document-manager-item" }, [
    _c("div", { staticClass: "file-list-container" }, [
      _c("div", { staticClass: "file-list-info" }, [
        _c("span", { staticClass: "name" }, [
          _vm._v("\n        " + _vm._s(_vm.file.name) + "\n      ")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "upload-info" }, [
          _vm._v("\n        Uploaded\n        "),
          _c("span", {
            staticClass: "upload-time",
            domProps: {
              textContent: _vm._s(
                _vm.$TF.DatesUtils.formatDateAndTime(_vm.file.created_at)
              )
            }
          }),
          _vm._v(" "),
          _vm.file.user
            ? _c("span", [
                _vm._v(
                  "by " +
                    _vm._s(_vm.file.user.first_name) +
                    " " +
                    _vm._s(_vm.file.user.last_name)
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons" },
        [
          _vm.showDownloadButton
            ? _c(
                "tf-button",
                {
                  staticClass: "btn-download",
                  attrs: {
                    loading: _vm.currentlyDownloading,
                    type: "primary",
                    size: "text-small"
                  },
                  on: { click: _vm.downloadSource }
                },
                [_vm._v("\n        Download File\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showDeleteButton
            ? _c(
                "tf-button",
                {
                  staticClass: "btn-delete",
                  attrs: {
                    disabled: _vm.disableDelete,
                    type: "primary",
                    size: "text-small"
                  },
                  on: { click: _vm.deleteSource }
                },
                [_vm._v("\n        Delete File\n      ")]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.showDownloadError
      ? _c("p", { staticClass: "download-error" }, [
          _vm._v("\n    There was a problem downloading the file.\n  ")
        ])
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$z = [];
__vue_render__$z._withStripped = true;

  /* style */
  const __vue_inject_styles__$A = function (inject) {
    if (!inject) return
    inject("data-v-16508137_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.file-list-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n.file-list-container .file-list-info {\n  flex: 1;\n  padding-right: 20px;\n}\n.file-list-container svg {\n  fill: #2638a6;\n  height: 12px;\n}\n.file-list-container svg.delete-image {\n  width: 95px;\n  height: 92px;\n}\n.file-list-container .is-disabled svg {\n  fill: #c1c1c1;\n}\n.file-list-container .name {\n  font-size: 14px;\n  display: inline-block;\n  color: #1b266f;\n  word-break: break-all;\n  margin-bottom: 5px;\n}\n.file-list-container .buttons {\n  min-width: 100px;\n  padding-top: 5px;\n}\n.file-list-container .tf-button + .tf-button.btn-delete,\n.file-list-container .wt-button + .wt-button.btn-delete {\n  margin-top: 11px;\n  margin-left: 0;\n}\n.file-list-container .btn-download {\n  margin-left: 0;\n}\n.file-list-container button.label-button {\n  width: auto;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n.file-list-container button.label-button .label {\n  font-size: 12px;\n  font-weight: bold;\n  color: #2638a6;\n}\n.file-list-container button.label-button svg {\n  position: relative;\n  top: 2px;\n  margin-right: 4px;\n}\n.file-list-container button + button {\n  padding: 0;\n}\n.file-list-container .upload-info {\n  font-size: 12px;\n  display: block;\n  line-height: 1.33;\n  color: #999;\n}\n.file-list-container .el-alert {\n  margin-top: 10px;\n  font-size: 0;\n}\n.file-list-container .el-alert .el-alert__title.is-bold {\n  font-weight: 600;\n  line-height: 22px;\n}\n.file-list-container .el-alert .el-button.is-loading {\n  float: left;\n  border: 0;\n  background: transparent;\n  position: relative;\n  top: -2px;\n  /* stylelint-disable selector-max-compound-selectors */\n}\n.file-list-container .el-alert .el-button.is-loading:before {\n  background: transparent;\n}\n.file-list-container .el-alert .el-button.is-loading .el-icon-loading:before {\n  color: #999;\n}\n.document-manager-item {\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  border-bottom: 1px dashed #efefef;\n}\n.document-manager-item:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.document-manager-item .download-error {\n  margin-top: 0;\n  color: #f92f37;\n  font-size: 12px;\n  text-align: right;\n}\n\n/*# sourceMappingURL=DocumentManagerItem.vue.map */", map: {"version":3,"sources":["DocumentManagerItem.vue","/home/circleci/repo/src/components/DocumentManagerItem.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AACpC;;kCAEkC;AAClC;;oCAEoC;ACyIpC;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ADvIA;ACyIA;EACA,OAAA;EACA,mBAAA;ADvIA;AC0IA;EACA,aAAA;EACA,YAAA;ADxIA;AC0IA;EACA,WAAA;EACA,YAAA;ADxIA;AC4IA;EACA,aAAA;AD1IA;AC6IA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AD3IA;AC8IA;EACA,gBAAA;EACA,gBAAA;AD5IA;AC+IA;;EAEA,gBAAA;EACA,cAAA;AD7IA;ACgJA;EACA,cAAA;AD9IA;ACiJA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AD/IA;ACiJA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AD/IA;ACkJA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;ADhJA;ACoJA;EACA,UAAA;ADlJA;ACqJA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;ADnJA;ACsJA;EACA,gBAAA;EACA,YAAA;ADpJA;ACsJA;EACA,gBAAA;EACA,iBAAA;ADpJA;ACuJA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EAKA,sDAAA;ADzJA;ACsJA;EACA,uBAAA;ADpJA;ACuJA;EACA,WAAA;ADrJA;AC2JA;EACA,oBAAA;EACA,mBAAA;EACA,iCAAA;ADxJA;AC0JA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;ADxJA;AC2JA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;ADzJA;;AAEA,kDAAkD","file":"DocumentManagerItem.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.file-list-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n.file-list-container .file-list-info {\n  flex: 1;\n  padding-right: 20px;\n}\n.file-list-container svg {\n  fill: #2638a6;\n  height: 12px;\n}\n.file-list-container svg.delete-image {\n  width: 95px;\n  height: 92px;\n}\n.file-list-container .is-disabled svg {\n  fill: #c1c1c1;\n}\n.file-list-container .name {\n  font-size: 14px;\n  display: inline-block;\n  color: #1b266f;\n  word-break: break-all;\n  margin-bottom: 5px;\n}\n.file-list-container .buttons {\n  min-width: 100px;\n  padding-top: 5px;\n}\n.file-list-container .tf-button + .tf-button.btn-delete,\n.file-list-container .wt-button + .wt-button.btn-delete {\n  margin-top: 11px;\n  margin-left: 0;\n}\n.file-list-container .btn-download {\n  margin-left: 0;\n}\n.file-list-container button.label-button {\n  width: auto;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n.file-list-container button.label-button .label {\n  font-size: 12px;\n  font-weight: bold;\n  color: #2638a6;\n}\n.file-list-container button.label-button svg {\n  position: relative;\n  top: 2px;\n  margin-right: 4px;\n}\n.file-list-container button + button {\n  padding: 0;\n}\n.file-list-container .upload-info {\n  font-size: 12px;\n  display: block;\n  line-height: 1.33;\n  color: #999;\n}\n.file-list-container .el-alert {\n  margin-top: 10px;\n  font-size: 0;\n}\n.file-list-container .el-alert .el-alert__title.is-bold {\n  font-weight: 600;\n  line-height: 22px;\n}\n.file-list-container .el-alert .el-button.is-loading {\n  float: left;\n  border: 0;\n  background: transparent;\n  position: relative;\n  top: -2px;\n  /* stylelint-disable selector-max-compound-selectors */\n}\n.file-list-container .el-alert .el-button.is-loading:before {\n  background: transparent;\n}\n.file-list-container .el-alert .el-button.is-loading .el-icon-loading:before {\n  color: #999;\n}\n\n.document-manager-item {\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  border-bottom: 1px dashed #efefef;\n}\n.document-manager-item:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n.document-manager-item .download-error {\n  margin-top: 0;\n  color: #f92f37;\n  font-size: 12px;\n  text-align: right;\n}\n\n/*# sourceMappingURL=DocumentManagerItem.vue.map */","<template>\n  <li class=\"document-manager-item\">\n    <div class=\"file-list-container\">\n      <div class=\"file-list-info\">\n        <span class=\"name\">\n          {{ file.name }}\n        </span>\n        <span class=\"upload-info\">\n          Uploaded\n          <span\n            class=\"upload-time\"\n            v-text=\"$TF.DatesUtils.formatDateAndTime(file.created_at)\"\n          />\n          <span v-if=\"file.user\">by {{ file.user.first_name }} {{ file.user.last_name }}</span>\n        </span>\n      </div>\n      <div class=\"buttons\">\n        <tf-button\n          v-if=\"showDownloadButton\"\n          :loading=\"currentlyDownloading\"\n          type=\"primary\"\n          size=\"text-small\"\n          class=\"btn-download\"\n          @click=\"downloadSource\"\n        >\n          Download File\n        </tf-button>\n        <tf-button\n          v-if=\"showDeleteButton\"\n          :disabled=\"disableDelete\"\n          type=\"primary\"\n          size=\"text-small\"\n          class=\"btn-delete\"\n          @click=\"deleteSource\"\n        >\n          Delete File\n        </tf-button>\n      </div>\n    </div>\n    <p\n      v-if=\"showDownloadError\"\n      class=\"download-error\"\n    >\n      There was a problem downloading the file.\n    </p>\n  </li>\n</template>\n\n<script>\n  export default {\n    name: 'DocumentManagerItem',\n    props: {\n      applicationNamespace: {\n        type: String,\n        default: '',\n        required: true,\n      },\n      file: {\n        type: Object,\n        default: () => ({}),\n      },\n      showButtonLabel: {\n        type: Boolean,\n        default: false,\n      },\n      showDownloadButton: {\n        type: Boolean,\n        default: true,\n      },\n      showDeleteButton: {\n        type: Boolean,\n        default: false,\n      },\n      isBroker: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => ({\n      showDownloadError: false,\n      currentlyDownloading: false,\n      disableDelete: false,\n    }),\n    methods: {\n      /**\n       * If the user confirms they want to delete a file we call the source service to delete the file\n       * We then emit that it was removed to the parent compponent\n       */\n      deleteSource() {\n        this.showDownloadError = false;\n        this.disableDelete = true;\n        this.$TF.SourceService.deleteSource(this.file.id, this.applicationNamespace).then(() => {\n          this.$emit('sourceRemoved', this.file);\n        });\n      },\n      /**\n       * On click of the download button we call the getSource call from the source service\n       */\n      downloadSource() {\n        this.currentlyDownloading = true;\n        this.showDownloadError = false;\n        this.$TF.SourceService\n          .getSource(this.file.id, this.applicationNamespace)\n          .then((response) => {\n            // call the api to get the data for this file\n\n            const base64String = response.data.source.content.replace(/\\s/g, '');\n            const byteCharacters = window.atob(base64String);\n            const byteNumbers = new Array(byteCharacters.length);\n\n            for (let i = 0; i < byteCharacters.length; i += 1) {\n              byteNumbers[i] = byteCharacters.charCodeAt(i);\n            }\n\n            const byteArray = new Uint8Array(byteNumbers);\n            const blob = new window.Blob([byteArray], { type: 'application/octet-stream' });\n\n            this.currentlyDownloading = false;\n            if (window.navigator && window.navigator.msSaveOrOpenBlob) {\n              window.navigator.msSaveOrOpenBlob(blob, response.data.source.file_file_name);\n            } else {\n              const downloadLink = document.createElement('a');\n              downloadLink.value = 'Download';\n              downloadLink.target = '_blank';\n              downloadLink.download = response.data.source.file_file_name;\n              let blobURL = '';\n              blobURL = window.URL.createObjectURL(blob);\n              downloadLink.href = blobURL;\n              this.$el.appendChild(downloadLink);\n              // fire a click event on the anchor\n              downloadLink.click();\n              downloadLink.remove();\n              this.$emit('downloaded');\n            }\n          })\n          .catch(() => {\n            this.currentlyDownloading = false;\n            this.showDownloadError = true;\n          });\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\">\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  .file-list-container {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 15px;\n\n    .file-list-info {\n      flex: 1;\n      padding-right: 20px;\n    }\n\n    svg {\n      fill: $tf-blue;\n      height: 12px;\n\n      &.delete-image {\n        width: 95px;\n        height: 92px;\n      }\n    }\n\n    .is-disabled svg {\n      fill: $tf-light-gray;\n    }\n\n    .name {\n      font-size: 14px;\n      display: inline-block;\n      color: $tf-dark-blue;\n      word-break: break-all;\n      margin-bottom: 5px;\n    }\n\n    .buttons {\n      min-width: 100px;\n      padding-top: 5px;\n    }\n\n    .tf-button + .tf-button.btn-delete,\n    .wt-button + .wt-button.btn-delete {\n      margin-top: 11px;\n      margin-left: 0;\n    }\n\n    .btn-download {\n      margin-left: 0;\n    }\n\n    button.label-button {\n      width: auto;\n      border: 0;\n      padding: 0;\n      margin: 0;\n\n      .label {\n        font-size: 12px;\n        font-weight: bold;\n        color: $tf-blue;\n      }\n\n      svg {\n        position: relative;\n        top: 2px;\n        margin-right: 4px;\n      }\n    }\n\n    button + button {\n      padding: 0;\n    }\n\n    .upload-info {\n      font-size: 12px;\n      display: block;\n      line-height: 1.33;\n      color: $tf-medium-gray;\n    }\n\n    .el-alert {\n      margin-top: 10px;\n      font-size: 0;\n\n      .el-alert__title.is-bold {\n        font-weight: 600;\n        line-height: 22px;\n      }\n\n      .el-button.is-loading {\n        float: left;\n        border: 0;\n        background: transparent;\n        position: relative;\n        top: -2px;\n\n        &:before {\n          background: transparent;\n        }\n        /* stylelint-disable selector-max-compound-selectors */\n        .el-icon-loading:before {\n          color: $tf-medium-gray;\n        }\n      }\n    }\n  }\n\n  .document-manager-item {\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n    border-bottom: 1px dashed $tf-extra-light-gray-1;\n\n    &:last-child {\n      margin-bottom: 0;\n      padding-bottom: 0;\n      border-bottom: none;\n    }\n\n    .download-error {\n      margin-top: 0;\n      color: $tf-danger;\n      font-size: 12px;\n      text-align: right;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$A = undefined;
  /* module identifier */
  const __vue_module_identifier__$A = undefined;
  /* functional template */
  const __vue_is_functional_template__$A = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$A = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$B = {
  name: 'HistoryItem',
  props: {
    /**
     * what element this should appear as
     */
    tag: {
      type: String,
      default: 'li'
    },

    /**
     * overrides if we should show new badge or not
     */
    showNewBadge: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },

    /**
     * the history item to display
     */
    item: {
      type: Object,
      required: true
    },

    /**
     * route string to the page where the change was made
     */
    attributeLink: {
      type: String,
      default: ''
    }
  },
  computed: {
    /**
     * Display correctly formatted username
     *
     * @returns {string}
     */
    userName: function userName() {
      var userName = "".concat(this.user.first_name, " ").concat(this.user.last_name);

      if (this.user.carrier.name) {
        userName = "".concat(this.user.carrier.name, ", ").concat(userName);
      }

      return userName;
    },

    /**
     * Display product type if there's a label
     *
     * @returns {string}
     */
    productTypeName: function productTypeName() {
      return this.item.product_type_name !== this.item.project_product_label ? "".concat(this.item.product_type_name, ", ").concat(this.item.project_product_label) : this.item.product_type_name;
    },

    /**
     * Display the attribute info including what product it belonged to
     * as well as container/value/subtype info.
     *
     * @returns {string}
     */
    attributeInfo: function attributeInfo() {
      var details = this.item.history_details;
      var attributeInfo = details.attribute_name;

      if (details.tier_subtype_name) {
        attributeInfo += ", ".concat(details.tier_subtype_name);
      }

      if (this.item.attributable_id !== 77) {
        attributeInfo += ', ';

        if (details.container_type.toLowerCase() === 'class') {
          attributeInfo += 'Class ';
        }

        attributeInfo += "".concat(details.container_name);
      }

      if (this.item.label && this.item.label !== 'composite') {
        attributeInfo += ", ".concat(this.item.label);
      }

      return attributeInfo;
    },

    /**
     * The text to be displayed for what the item was changed from
     * If this is a Rate Attribute: Float to 3 decimal points and add $
     *
     * @returns {string}
     */
    fromValue: function fromValue() {
      var valueText = this.item.before_value || 'n/a';
      return this.isRateAttribute && this.item.before_value ? "$".concat(parseFloat(valueText).toFixed(3)) : valueText;
    },

    /**
     * Test to see if this is a attribute type of 'Rate Attribute'
     *
     * @returns {boolean}
     */
    isRateAttribute: function isRateAttribute() {
      return this.item.attributable_type.toLowerCase() === 'rateattribute';
    },

    /**
     * Display the formatted time when the edit happened
     * Every item will have a `last_created_at` this shows the user when the update occurred.
     *
     * @returns {string}
     */
    itemTime: function itemTime() {
      return this.$TF.DatesUtils.formatDateAndTime(this.item.last_created_at);
    },

    /**
     * The text to be displayed for what the item was changed to
     * If this is a Rate Attribute: Float to 3 decimal points and add $
     *
     * @returns {string}
     */
    toValue: function toValue() {
      var valueText = this.item.after_value || 'n/a';
      return this.isRateAttribute && this.item.after_value ? "$".concat(parseFloat(valueText).toFixed(3)) : valueText;
    },

    /**
     * Grab the info for the author of this edit
     *
     * @returns {object}
     */
    user: function user() {
      return this.item.history_details.responsible_user;
    }
  }
};

/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tag,
    { tag: "component", staticClass: "history-item" },
    [
      _vm.showNewBadge && _vm.item.is_new
        ? _c("tf-badge", { attrs: { value: "New", status: "success" } })
        : _vm._e(),
      _vm._v(" "),
      _c("p", { attrs: { "data-test-username": "" } }, [
        _c("strong", [_vm._v(_vm._s(_vm.userName))])
      ]),
      _vm._v(" "),
      _c("p", { attrs: { "data-test-product-type-name": "" } }, [
        _vm._v("\n    " + _vm._s(_vm.productTypeName) + "\n  ")
      ]),
      _vm._v(" "),
      _c("p", { attrs: { "data-test-attribute-info": "" } }, [
        _vm._v("\n    " + _vm._s(_vm.attributeInfo) + "\n  ")
      ]),
      _vm._v(" "),
      _c("p", { attrs: { "data-test-from-value": "" } }, [
        _vm._v("\n    From: " + _vm._s(_vm.fromValue) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.attributeLink
        ? [
            _c(
              "p",
              [
                _c("router-link", {
                  attrs: { to: _vm.attributeLink },
                  domProps: { textContent: _vm._s("To: " + _vm.toValue) }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("router-link", {
                  staticClass: "view-change-link",
                  attrs: { to: _vm.attributeLink },
                  domProps: { textContent: _vm._s("View Change") }
                })
              ],
              1
            )
          ]
        : _c("p", [
            _c(
              "strong",
              { attrs: { "data-test-without-attribute-link": "" } },
              [_vm._v("To: " + _vm._s(_vm.toValue))]
            )
          ]),
      _vm._v(" "),
      _c("p", [
        _c("span", {
          staticClass: "time",
          domProps: { textContent: _vm._s(_vm.itemTime) }
        })
      ])
    ],
    2
  )
};
var __vue_staticRenderFns__$A = [];
__vue_render__$A._withStripped = true;

  /* style */
  const __vue_inject_styles__$B = function (inject) {
    if (!inject) return
    inject("data-v-7b4a7188_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.history-item[data-v-7b4a7188] {\n  font-size: 14px;\n  padding: 25px 16px;\n  border-bottom: solid 1px #efefef;\n}\n.time[data-v-7b4a7188] {\n  color: #999;\n}\n.view-change-link[data-v-7b4a7188] {\n  font-weight: normal;\n}\np[data-v-7b4a7188] {\n  margin: 0;\n  padding: 2px 0;\n}\n\n/*# sourceMappingURL=HistoryItem.vue.map */", map: {"version":3,"sources":["HistoryItem.vue","/home/circleci/repo/src/components/HistoryItem.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC8LpC;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;AD5LA;AC+LA;EACA,WAAA;AD5LA;AC+LA;EACA,mBAAA;AD5LA;AC+LA;EACA,SAAA;EACA,cAAA;AD5LA;;AAEA,0CAA0C","file":"HistoryItem.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.history-item {\n  font-size: 14px;\n  padding: 25px 16px;\n  border-bottom: solid 1px #efefef;\n}\n\n.time {\n  color: #999;\n}\n\n.view-change-link {\n  font-weight: normal;\n}\n\np {\n  margin: 0;\n  padding: 2px 0;\n}\n\n/*# sourceMappingURL=HistoryItem.vue.map */","<template>\n  <component\n    :is=\"tag\"\n    class=\"history-item\"\n  >\n    <tf-badge\n      v-if=\"showNewBadge && item.is_new\"\n      value=\"New\"\n      status=\"success\"\n    />\n    <p data-test-username>\n      <strong>{{ userName }}</strong>\n    </p>\n    <p data-test-product-type-name>\n      {{ productTypeName }}\n    </p>\n    <p data-test-attribute-info>\n      {{ attributeInfo }}\n    </p>\n    <p data-test-from-value>\n      From: {{ fromValue }}\n    </p>\n    <template v-if=\"attributeLink\">\n      <p>\n        <router-link\n          :to=\"attributeLink\"\n          v-text=\"`To: ${toValue}`\"\n        />\n      </p>\n      <p>\n        <router-link\n          :to=\"attributeLink\"\n          class=\"view-change-link\"\n          v-text=\"'View Change'\"\n        />\n      </p>\n    </template>\n    <p v-else>\n      <strong data-test-without-attribute-link>To: {{ toValue }}</strong>\n    </p>\n    <p>\n      <span\n        class=\"time\"\n        v-text=\"itemTime\"\n      />\n    </p>\n  </component>\n</template>\n\n<script>\n  export default {\n    name: 'HistoryItem',\n    props: {\n      /**\n       * what element this should appear as\n       */\n      tag: {\n        type: String,\n        default: 'li',\n      },\n      /**\n       * overrides if we should show new badge or not\n       */\n      showNewBadge: {\n        type: Boolean,\n        default: () => true,\n      },\n      /**\n       * the history item to display\n       */\n      item: {\n        type: Object,\n        required: true,\n      },\n      /**\n       * route string to the page where the change was made\n       */\n      attributeLink: {\n        type: String,\n        default: '',\n      },\n    },\n    computed: {\n      /**\n       * Display correctly formatted username\n       *\n       * @returns {string}\n       */\n      userName() {\n        let userName = `${this.user.first_name} ${this.user.last_name}`;\n        if (this.user.carrier.name) {\n          userName = `${this.user.carrier.name}, ${userName}`;\n        }\n        return userName;\n      },\n\n      /**\n       * Display product type if there's a label\n       *\n       * @returns {string}\n       */\n      productTypeName() {\n        return this.item.product_type_name !== this.item.project_product_label\n          ? `${this.item.product_type_name}, ${this.item.project_product_label}`\n          : this.item.product_type_name;\n      },\n\n      /**\n       * Display the attribute info including what product it belonged to\n       * as well as container/value/subtype info.\n       *\n       * @returns {string}\n       */\n      attributeInfo() {\n        const details = this.item.history_details;\n        let attributeInfo = details.attribute_name;\n\n        if (details.tier_subtype_name) {\n          attributeInfo += `, ${details.tier_subtype_name}`;\n        }\n\n        if (this.item.attributable_id !== 77) {\n          attributeInfo += ', ';\n\n          if (details.container_type.toLowerCase() === 'class') {\n            attributeInfo += 'Class ';\n          }\n\n          attributeInfo += `${details.container_name}`;\n        }\n\n        if (this.item.label && this.item.label !== 'composite') {\n          attributeInfo += `, ${this.item.label}`;\n        }\n\n        return attributeInfo;\n      },\n      /**\n       * The text to be displayed for what the item was changed from\n       * If this is a Rate Attribute: Float to 3 decimal points and add $\n       *\n       * @returns {string}\n       */\n      fromValue() {\n        const valueText = this.item.before_value || 'n/a';\n\n        return this.isRateAttribute && this.item.before_value\n          ? `$${parseFloat(valueText).toFixed(3)}`\n          : valueText;\n      },\n      /**\n       * Test to see if this is a attribute type of 'Rate Attribute'\n       *\n       * @returns {boolean}\n       */\n      isRateAttribute() {\n        return this.item.attributable_type.toLowerCase() === 'rateattribute';\n      },\n      /**\n       * Display the formatted time when the edit happened\n       * Every item will have a `last_created_at` this shows the user when the update occurred.\n       *\n       * @returns {string}\n       */\n      itemTime() {\n        return this.$TF.DatesUtils.formatDateAndTime(this.item.last_created_at);\n      },\n      /**\n       * The text to be displayed for what the item was changed to\n       * If this is a Rate Attribute: Float to 3 decimal points and add $\n       *\n       * @returns {string}\n       */\n      toValue() {\n        const valueText = this.item.after_value || 'n/a';\n\n        return this.isRateAttribute && this.item.after_value\n          ? `$${parseFloat(valueText).toFixed(3)}`\n          : valueText;\n      },\n      /**\n       * Grab the info for the author of this edit\n       *\n       * @returns {object}\n       */\n      user() {\n        return this.item.history_details.responsible_user;\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/variables';\n\n.history-item {\n  font-size: 14px;\n  padding: 25px 16px;\n  border-bottom: solid 1px $tf-extra-light-gray-1;\n}\n\n.time {\n  color: $tf-medium-gray;\n}\n\n.view-change-link {\n  font-weight: normal;\n}\n\np {\n  margin: 0;\n  padding: 2px 0;\n}\n\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$B = "data-v-7b4a7188";
  /* module identifier */
  const __vue_module_identifier__$B = undefined;
  /* functional template */
  const __vue_is_functional_template__$B = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$B = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    browser,
    undefined,
    undefined
  );

// @@match logic
_fixReWks('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = _anObject(regexp);
      var S = String(this);
      if (!rx.global) return _regexpExecAbstract(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = _regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Component used for displaying the meta data information regarding an RFP throughout our applications.
 *
 * @vuedoc
 * @exports RfpTable
 * @category components
 */
var script$C = {
  name: 'RfpTable',
  props: {
    documentManagerLink: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editLink: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasStopLoss: {
      type: Boolean,
      default: false
    },
    labelCellWidth: {
      type: Number,
      default: 172
    },
    projectType: {
      type: String,
      required: true
    },
    showDocuments: {
      type: Boolean,
      default: false
    }
  },
  data: function data(vm) {
    return {
      noValueText: 'Not provided',
      tableData: [{
        type: 'employer_name',
        text: 'Employer'
      }, {
        type: 'employer_location',
        text: 'Employer location'
      }, {
        type: 'employer_website',
        text: 'Employer website'
      }, {
        type: 'employer_total_lives',
        text: 'Lives'
      }, {
        type: 'employer_sic',
        text: 'SIC'
      }, {
        type: 'products',
        text: 'Products & broker commissions'
      }, {
        type: 'incumbent_carriers',
        text: 'Incumbents'
      }, {
        type: 'broker_of_record_label',
        text: 'Broker of record'
      }, {
        type: 'broker_contacts',
        // Backwards compatible fix. Until Broker team features are
        // added to Core API, this row should remain "Primary contacts"
        // can see "Broker team contacts" on Features 2 until then
        // TODO: [SHARED-156] remove Primary in favor for Broker team after feature is merged to staging -kc
        text: vm.info.event_contacts ? 'Broker team contacts' : 'Primary contacts'
      }, {
        type: 'event_contacts',
        text: 'Placement event contacts'
      }, {
        type: 'stop_loss_tpa_company',
        text: 'Medical claim administrator'
      }, {
        type: 'stop_loss_rx_vendor',
        text: 'Prescription drug administrator'
      }, {
        type: 'stop_loss_transplant_carrier',
        text: 'Fully insured transplant carrier'
      }, {
        type: 'reason_for_rfp',
        text: 'Reason for marketing'
      }, {
        type: 'benefit_administrator',
        text: 'Benefit admin'
      }, {
        type: 'open_enrollment_this_year',
        text: 'Open enrollment'
      }, {
        type: 'hdhp',
        text: 'High deductible health plan'
      }, {
        type: 'market_activity',
        text: 'Market activity'
      }, {
        type: 'effective_date',
        text: 'Coverage effective date'
      }, {
        type: 'project_due_date',
        text: 'Due date'
      }, {
        type: 'rfp_cover_memo',
        text: 'Cover memo'
      }]
    };
  },
  computed: {
    /**
     * If this project has a Stop Loss Product, we filter out certain rows if there was no data when the RFP was created.
     *
     * @returns {Array}
     */
    ignoreRows: function ignoreRows() {
      var _this = this;

      var generalData = ['rfp_cover_memo'];
      var stopLossData = ['stop_loss_tpa_company', 'stop_loss_rx_vendor', 'stop_loss_transplant_carrier'];

      if (this.hasStopLoss) {
        generalData.push.apply(generalData, stopLossData);
      }

      var rowsToIgnore = generalData.filter(function (type) {
        return _this.info[type] && _this.info[type].match(/not provided/i);
      }); // if project is Initial Employer Build, we don't want to show broker_contacts row at all.

      /**
       * the second condition is meant to make event_contacts backwards compatible with the current core_api as
       * it does not have this particular property in rfp_info yet. so we hide it regardless of project type.
       * We can remove the second condition at any time after the work in features 2 for the new broker team
       * feature is added to staging. -kc
       * TODO: remove second condition once broker team feature is merged into staging -kc
       */

      if (this.projectType === this.$TF.ReusableData.projectTypes.initialBuild || !this.info.event_contacts) {
        rowsToIgnore.push('event_contacts');
      }

      return rowsToIgnore;
    },

    /**
     * Identify if this project is in Open Enrollment and surround Enrollment Strategy in parenthesis if it exists
     *
     * @returns {object}
     */
    formatOpenEnrollment: function formatOpenEnrollment() {
      return {
        // Ensure that the open enrollment year is 'yes' and not empty as an extra check to accomodate Cover Memo e2e test
        thisYear: this.info.open_enrollment_this_year && this.info.open_enrollment_this_year.toLowerCase() === 'yes',
        enrollmentStrategy: this.info.open_enrollment_strategy ? "(".concat(this.info.open_enrollment_strategy, ")") : ''
      };
    }
  }
};

/* script */
const __vue_script__$C = script$C;

/* template */
var __vue_render__$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "table",
    { staticClass: "rfp-table" },
    [
      _vm._l(_vm.tableData, function(dataInfo) {
        return [
          !_vm.ignoreRows.includes(dataInfo.type)
            ? _c("tr", { key: dataInfo.text }, [
                _c("td", {
                  style: { width: _vm.labelCellWidth + "px" },
                  domProps: { textContent: _vm._s(dataInfo.text) }
                }),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    dataInfo.type === "project_due_date"
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.info[dataInfo.type] !==
                                  "Due Date Not Specified"
                                  ? _vm.$TF.DatesUtils.formatSimpleDate(
                                      _vm.info.project_due_date
                                    )
                                  : _vm.noValueText
                              ) +
                              "\n          "
                          ),
                          _vm.editLink.name
                            ? _c("router-link", {
                                staticClass: "link-edit",
                                attrs: { to: _vm.editLink },
                                domProps: { textContent: _vm._s("Edit") }
                              })
                            : _vm._e()
                        ]
                      : dataInfo.type === "rfp_cover_memo" &&
                        _vm.info.rfp_cover_memo
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.info.rfp_cover_memo.replace(
                                /(?:\r\n|\r|\n)/g,
                                "<br>"
                              )
                            )
                          }
                        })
                      : dataInfo.type === "employer_website" &&
                        _vm.info.employer_website
                      ? _c("a", {
                          attrs: {
                            target: "_blank",
                            href: _vm.info.employer_website
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.info.employer_website
                                .replace(/^https?:\/\//, "")
                                .replace(/\/+$/, "")
                            )
                          }
                        })
                      : dataInfo.type === "effective_date" &&
                        _vm.info.effective_date
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$TF.DatesUtils.formatSimpleDate(
                                  _vm.info.effective_date
                                )
                              ) +
                              "\n        "
                          )
                        ]
                      : dataInfo.type === "open_enrollment_this_year" &&
                        _vm.formatOpenEnrollment.thisYear
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.info.open_enrollment_this_year) +
                              "\n          " +
                              _vm._s(
                                _vm.formatOpenEnrollment.enrollmentStrategy
                              ) +
                              "\n        "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.info[dataInfo.type] || _vm.noValueText
                              ) +
                              "\n        "
                          )
                        ]
                  ],
                  2
                )
              ])
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _vm.showDocuments
        ? _c("tr", [
            _c("td", [_vm._v("Documents")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.info.inforce_sources_message) +
                  "\n      "
              ),
              _vm.documentManagerLink.name
                ? _c(
                    "p",
                    [
                      _c("router-link", {
                        attrs: { to: _vm.documentManagerLink },
                        domProps: { textContent: _vm._s("Document Manager") }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__$B = [];
__vue_render__$B._withStripped = true;

  /* style */
  const __vue_inject_styles__$C = function (inject) {
    if (!inject) return
    inject("data-v-7103d4be_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.rfp-table[data-v-7103d4be] {\n  width: 100%;\n  margin-bottom: 28px;\n}\ntd[data-v-7103d4be] {\n  padding: 13px;\n  border: 1px #c1c1c1 solid;\n  background: #fff;\n  vertical-align: top;\n}\n.link-edit[data-v-7103d4be] {\n  margin-left: 15px;\n}\n\n/*# sourceMappingURL=RfpTable.vue.map */", map: {"version":3,"sources":["RfpTable.vue","/home/circleci/repo/src/components/RfpTable.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AACpC;;kCAEkC;AAClC;;oCAEoC;ACuMpC;EACA,WAAA;EACA,mBAAA;ADrMA;ACwMA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;ADrMA;ACwMA;EACA,iBAAA;ADrMA;;AAEA,uCAAuC","file":"RfpTable.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.rfp-table {\n  width: 100%;\n  margin-bottom: 28px;\n}\n\ntd {\n  padding: 13px;\n  border: 1px #c1c1c1 solid;\n  background: #fff;\n  vertical-align: top;\n}\n\n.link-edit {\n  margin-left: 15px;\n}\n\n/*# sourceMappingURL=RfpTable.vue.map */","<template>\n  <table class=\"rfp-table\">\n    <template v-for=\"dataInfo in tableData\">\n      <tr\n        v-if=\"!ignoreRows.includes(dataInfo.type)\"\n        :key=\"dataInfo.text\"\n      >\n        <td\n          :style=\"{ width: `${labelCellWidth}px` }\"\n          v-text=\"dataInfo.text\"\n        />\n        <td>\n          <!-- Format Due date && Edit link -->\n          <template v-if=\"dataInfo.type === 'project_due_date'\">\n            {{ info[dataInfo.type] !== 'Due Date Not Specified'\n              ? $TF.DatesUtils.formatSimpleDate(info.project_due_date)\n              : noValueText\n            }}\n            <router-link\n              v-if=\"editLink.name\"\n              :to=\"editLink\"\n              class=\"link-edit\"\n              v-text=\"'Edit'\"\n            />\n          </template>\n          <!--\n            Formatted Cover Memo\n            Disable no-html since these are paragraphs\n          -->\n          <!-- eslint-disable vue/no-v-html -->\n          <span\n            v-else-if=\"dataInfo.type === 'rfp_cover_memo' && info.rfp_cover_memo\"\n            v-html=\"info.rfp_cover_memo.replace(/(?:\\r\\n|\\r|\\n)/g, '<br>')\"\n          />\n          <!-- eslint-enable vue/no-v-html -->\n          <!-- Employer Website -->\n          <a\n            v-else-if=\"dataInfo.type === 'employer_website' && info.employer_website\"\n            target=\"_blank\"\n            :href=\"info.employer_website\"\n            v-text=\"info.employer_website.replace(/^https?:\\/\\//, '').replace(/\\/+$/, '')\"\n          />\n          <!-- Formatted Effective Date -->\n          <template v-else-if=\"dataInfo.type === 'effective_date' && info.effective_date\">\n            {{ $TF.DatesUtils.formatSimpleDate(info.effective_date) }}\n          </template>\n          <!-- Also display Open Enrollment Strategy if Open Enrollment is Yes -->\n          <template\n            v-else-if=\"dataInfo.type === 'open_enrollment_this_year'\n              && formatOpenEnrollment.thisYear\n            \"\n          >\n            {{ info.open_enrollment_this_year }}\n            {{ formatOpenEnrollment.enrollmentStrategy }}\n          </template>\n          <!-- Show the value of row or noValueText  -->\n          <template v-else>\n            {{ info[dataInfo.type] || noValueText }}\n          </template>\n        </td>\n      </tr>\n    </template>\n    <tr v-if=\"showDocuments\">\n      <td>Documents</td>\n      <td>\n        {{ info.inforce_sources_message }}\n        <p v-if=\"documentManagerLink.name\">\n          <router-link\n            :to=\"documentManagerLink\"\n            v-text=\"'Document Manager'\"\n          />\n        </p>\n      </td>\n    </tr>\n  </table>\n</template>\n\n<script>\n  /**\n   * Component used for displaying the meta data information regarding an RFP throughout our applications.\n   *\n   * @vuedoc\n   * @exports RfpTable\n   * @category components\n   */\n  export default {\n    name: 'RfpTable',\n    props: {\n      documentManagerLink: {\n        type: Object,\n        default: () => ({}),\n      },\n      editLink: {\n        type: Object,\n        default: () => ({}),\n      },\n      info: {\n        type: Object,\n        default: () => ({}),\n      },\n      hasStopLoss: {\n        type: Boolean,\n        default: false,\n      },\n      labelCellWidth: {\n        type: Number,\n        default: 172,\n      },\n      projectType: {\n        type: String,\n        required: true,\n      },\n      showDocuments: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: (vm) => ({\n      noValueText: 'Not provided',\n      tableData: [\n        { type: 'employer_name', text: 'Employer' },\n        { type: 'employer_location', text: 'Employer location' },\n        { type: 'employer_website', text: 'Employer website' },\n        { type: 'employer_total_lives', text: 'Lives' },\n        { type: 'employer_sic', text: 'SIC' },\n        { type: 'products', text: 'Products & broker commissions' },\n        { type: 'incumbent_carriers', text: 'Incumbents' },\n        { type: 'broker_of_record_label', text: 'Broker of record' },\n        {\n          type: 'broker_contacts',\n          // Backwards compatible fix. Until Broker team features are\n          // added to Core API, this row should remain \"Primary contacts\"\n          // can see \"Broker team contacts\" on Features 2 until then\n          // TODO: [SHARED-156] remove Primary in favor for Broker team after feature is merged to staging -kc\n          text: vm.info.event_contacts\n            ? 'Broker team contacts'\n            : 'Primary contacts',\n        },\n        { type: 'event_contacts', text: 'Placement event contacts' },\n        { type: 'stop_loss_tpa_company', text: 'Medical claim administrator' },\n        { type: 'stop_loss_rx_vendor', text: 'Prescription drug administrator' },\n        { type: 'stop_loss_transplant_carrier', text: 'Fully insured transplant carrier' },\n        { type: 'reason_for_rfp', text: 'Reason for marketing' },\n        { type: 'benefit_administrator', text: 'Benefit admin' },\n        { type: 'open_enrollment_this_year', text: 'Open enrollment' },\n        { type: 'hdhp', text: 'High deductible health plan' },\n        { type: 'market_activity', text: 'Market activity' },\n        { type: 'effective_date', text: 'Coverage effective date' },\n        { type: 'project_due_date', text: 'Due date' },\n        { type: 'rfp_cover_memo', text: 'Cover memo' },\n      ],\n    }),\n    computed: {\n      /**\n       * If this project has a Stop Loss Product, we filter out certain rows if there was no data when the RFP was created.\n       *\n       * @returns {Array}\n       */\n      ignoreRows() {\n        const generalData = ['rfp_cover_memo'];\n        const stopLossData = ['stop_loss_tpa_company', 'stop_loss_rx_vendor', 'stop_loss_transplant_carrier'];\n\n        if (this.hasStopLoss) {\n          generalData.push(...stopLossData);\n        }\n\n        const rowsToIgnore = generalData.filter((type) => (\n          this.info[type] && this.info[type].match(/not provided/i)\n        ));\n\n        // if project is Initial Employer Build, we don't want to show broker_contacts row at all.\n        /**\n         * the second condition is meant to make event_contacts backwards compatible with the current core_api as\n         * it does not have this particular property in rfp_info yet. so we hide it regardless of project type.\n         * We can remove the second condition at any time after the work in features 2 for the new broker team\n         * feature is added to staging. -kc\n         * TODO: remove second condition once broker team feature is merged into staging -kc\n         */\n        if (\n          this.projectType === this.$TF.ReusableData.projectTypes.initialBuild\n          || !this.info.event_contacts\n        ) {\n          rowsToIgnore.push('event_contacts');\n        }\n\n        return rowsToIgnore;\n      },\n      /**\n       * Identify if this project is in Open Enrollment and surround Enrollment Strategy in parenthesis if it exists\n       *\n       * @returns {object}\n       */\n      formatOpenEnrollment() {\n        return {\n          // Ensure that the open enrollment year is 'yes' and not empty as an extra check to accomodate Cover Memo e2e test\n          thisYear: this.info.open_enrollment_this_year\n            && this.info.open_enrollment_this_year.toLowerCase() === 'yes',\n          enrollmentStrategy: this.info.open_enrollment_strategy\n            ? `(${this.info.open_enrollment_strategy})` : '',\n        };\n      },\n\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  .rfp-table {\n    width: 100%;\n    margin-bottom: 28px;\n  }\n\n  td {\n    padding: 13px;\n    border: 1px $tf-light-gray solid;\n    background: $tf-white;\n    vertical-align: top;\n  }\n\n  .link-edit {\n    margin-left: 15px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$C = "data-v-7103d4be";
  /* module identifier */
  const __vue_module_identifier__$C = undefined;
  /* functional template */
  const __vue_is_functional_template__$C = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$C = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfPagination is a component used to render a button for each of the pages of the totalPages that is passed down.
 * It uses the v-model/:value from the parent and $emits the model changes to the parent.
 *
 * @vuedoc
 * @exports TfPagination
 * @category Components
 */
var script$D = {
  name: 'TfPagination',
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    totalPages: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    /**
     * Returns an array or page numbers based on the total pages.
     *
     * @returns {Array}
     */
    pages: function pages() {
      return _toConsumableArray(Array(this.totalPages).keys()).map(function (i) {
        return i + 1;
      });
    }
  }
};

/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [
        { "is-disabled": _vm.isDisabled },
        "pagination-container btn-group"
      ]
    },
    [
      _c("tf-button", {
        attrs: {
          disabled: _vm.value === 1 || _vm.isDisabled,
          type: "secondary",
          size: "text-icon",
          icon: "angle-left"
        },
        on: {
          mousedown: function($event) {
            return $event.preventDefault()
          },
          click: function($event) {
            return _vm.$emit("input", _vm.value - 1)
          }
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.pages, function(page) {
        return _c("tf-button", {
          key: page,
          class: { active: page === _vm.value },
          attrs: {
            disabled: page === _vm.value || _vm.isDisabled,
            size: "text",
            type: "secondary"
          },
          domProps: { textContent: _vm._s(page) },
          on: {
            mousedown: function($event) {
              return $event.preventDefault()
            },
            click: function($event) {
              return _vm.$emit("input", page)
            }
          }
        })
      }),
      _vm._v(" "),
      _c("tf-button", {
        attrs: {
          disabled: _vm.value === _vm.totalPages || _vm.isDisabled,
          type: "secondary",
          size: "text-icon",
          icon: "angle-right"
        },
        on: {
          mousedown: function($event) {
            return $event.preventDefault()
          },
          click: function($event) {
            return _vm.$emit("input", _vm.value + 1)
          }
        }
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$C = [];
__vue_render__$C._withStripped = true;

  /* style */
  const __vue_inject_styles__$D = function (inject) {
    if (!inject) return
    inject("data-v-d42e0c7a_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tf-button.tf-button--secondary[data-v-d42e0c7a],\n.wt-button.wt-button--secondary[data-v-d42e0c7a] {\n  padding: 6px 10px;\n  line-height: 14px;\n  border-radius: 2px;\n}\n.tf-button.tf-button--secondary[data-v-d42e0c7a]:not(.is-disabled),\n.wt-button.wt-button--secondary[data-v-d42e0c7a]:not(.is-disabled) {\n  color: #1b266f;\n}\n.tf-button.tf-button--secondary.active[data-v-d42e0c7a],\n.wt-button.wt-button--secondary.active[data-v-d42e0c7a] {\n  cursor: default;\n}\n.pagination-container:not(.is-disabled) .tf-button.tf-button--secondary.active[data-v-d42e0c7a],\n.pagination-container:not(.is-disabled) .wt-button.wt-button--secondary.active[data-v-d42e0c7a] {\n  color: #2638a6;\n  background: #f4f5ff;\n}\n.tf-button.tf-button--secondary[data-v-d42e0c7a]:focus,\n.wt-button.wt-button--secondary[data-v-d42e0c7a]:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n.tf-button.tf-button--secondary + .tf-button[data-v-d42e0c7a],\n.tf-button.tf-button--secondary + .wt-button[data-v-d42e0c7a],\n.wt-button.wt-button--secondary + .tf-button[data-v-d42e0c7a],\n.wt-button.wt-button--secondary + .wt-button[data-v-d42e0c7a] {\n  margin-left: 4px;\n}\n\n/*# sourceMappingURL=TfPagination.vue.map */", map: {"version":3,"sources":["TfPagination.vue","/home/circleci/repo/src/components/TfPagination.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACwEpC;;EAEA,iBAAA;EACA,iBAAA;EACA,kBAAA;ADtEA;ACwEA;;EACA,cAAA;ADrEA;ACwEA;;EACA,eAAA;ADrEA;ACuEA;;EACA,cAAA;EACA,mBAAA;ADpEA;ACwEA;;EACA,0CAAA;ADrEA;ACwEA;;;;EAEA,gBAAA;ADpEA;;AAEA,2CAA2C","file":"TfPagination.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tf-button.tf-button--secondary,\n.wt-button.wt-button--secondary {\n  padding: 6px 10px;\n  line-height: 14px;\n  border-radius: 2px;\n}\n.tf-button.tf-button--secondary:not(.is-disabled),\n.wt-button.wt-button--secondary:not(.is-disabled) {\n  color: #1b266f;\n}\n.tf-button.tf-button--secondary.active,\n.wt-button.wt-button--secondary.active {\n  cursor: default;\n}\n.pagination-container:not(.is-disabled) .tf-button.tf-button--secondary.active,\n.pagination-container:not(.is-disabled) .wt-button.wt-button--secondary.active {\n  color: #2638a6;\n  background: #f4f5ff;\n}\n.tf-button.tf-button--secondary:focus,\n.wt-button.wt-button--secondary:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n.tf-button.tf-button--secondary + .tf-button,\n.tf-button.tf-button--secondary + .wt-button,\n.wt-button.wt-button--secondary + .tf-button,\n.wt-button.wt-button--secondary + .wt-button {\n  margin-left: 4px;\n}\n\n/*# sourceMappingURL=TfPagination.vue.map */","<template>\n  <div\n    :class=\"[\n      { 'is-disabled': isDisabled },\n      'pagination-container btn-group'\n    ]\"\n  >\n    <tf-button\n      :disabled=\"value === 1 || isDisabled\"\n      type=\"secondary\"\n      size=\"text-icon\"\n      icon=\"angle-left\"\n      @mousedown=\"$event.preventDefault()\"\n      @click=\"$emit('input', value - 1)\"\n    />\n    <tf-button\n      v-for=\"page in pages\"\n      :key=\"page\"\n      :class=\"{ active: page === value }\"\n      :disabled=\"page === value || isDisabled\"\n      size=\"text\"\n      type=\"secondary\"\n      @mousedown=\"$event.preventDefault()\"\n      @click=\"$emit('input', page)\"\n      v-text=\"page\"\n    />\n    <tf-button\n      :disabled=\"value === totalPages || isDisabled\"\n      type=\"secondary\"\n      size=\"text-icon\"\n      icon=\"angle-right\"\n      @mousedown=\"$event.preventDefault()\"\n      @click=\"$emit('input', value + 1)\"\n    />\n  </div>\n</template>\n<script>\n  /**\n   * TfPagination is a component used to render a button for each of the pages of the totalPages that is passed down.\n   * It uses the v-model/:value from the parent and $emits the model changes to the parent.\n   *\n   * @vuedoc\n   * @exports TfPagination\n   * @category Components\n   */\n  export default {\n    name: 'TfPagination',\n    props: {\n      isDisabled: {\n        type: Boolean,\n        default: false,\n      },\n      totalPages: {\n        type: Number,\n        required: true,\n      },\n      value: {\n        type: Number,\n        required: true,\n      },\n    },\n    computed: {\n      /**\n       * Returns an array or page numbers based on the total pages.\n       *\n       * @returns {Array}\n       */\n      pages() {\n        return [...Array(this.totalPages).keys()].map((i) => i + 1);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .tf-button.tf-button--secondary,\n  .wt-button.wt-button--secondary {\n    padding: 6px 10px;\n    line-height: 14px;\n    border-radius: 2px;\n\n    &:not(.is-disabled) {\n      color: $tf-dark-blue;\n    }\n\n    &.active {\n      cursor: default;\n\n      .pagination-container:not(.is-disabled) & {\n        color: $tf-blue;\n        background: $tf-light-blue;\n      }\n    }\n\n    &:focus {\n      outline: -webkit-focus-ring-color auto 1px;\n    }\n\n    + .tf-button,\n    + .wt-button {\n      margin-left: 4px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$D = "data-v-d42e0c7a";
  /* module identifier */
  const __vue_module_identifier__$D = undefined;
  /* functional template */
  const __vue_is_functional_template__$D = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$D = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$E = {
  name: 'ThreeflowWordmark',
  props: {
    fillColor: {
      type: String,
      default: '#00b980'
    }
  }
};

/* script */
const __vue_script__$E = script$E;

/* template */
var __vue_render__$D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        height: "69",
        viewBox: "0 0 306 69",
        width: "306",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("title", [_vm._v("Threeflow")]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "m295.168 17.898v-1.153h4.468v1.153h-1.624v4.474h-1.354v-4.474zm6.635-1.153 1.218 3.729 1.287-3.729h1.354l.338 5.627h-1.219l-.135-3.525-1.083 3.118h-.948l-1.083-3.05-.27 3.457h-1.22l.339-5.627zm-27.553 17.017c-2.235 0-2.709 2.44-2.709 5.898-.068 4.067.813 8.135 2.573 11.864 1.895-3.39 2.775-7.797 2.775-12 0-3.05-.338-5.762-2.64-5.762zm-70.612-19.322c0-2.78 1.557-5.017 4.197-5.017 1.964 0 3.114 1.22 3.114 2.916 0 2.372-1.827 3.66-5.01 3.66h-5.28l-2.979-.067h-32.563v51.117h10.9v-19.39h13.066v-9.965h-13.066v-12.204h20.783l2.234-.068h5.28c8.87 0 16.316-3.864 16.316-12.678 0-7.254-5.01-12.135-12.862-12.135-9.207 0-14.894 7.119-14.894 15.796v50.575h10.832l-.068-52.54zm92.68 12.474c2.708 6.034 4.062 12.542 4.13 19.118 0 12.61-5.145 21.762-16.519 21.762-3.588 0-7.04-1.084-9.952-3.254-2.978 2.17-6.566 3.322-10.222 3.254-11.238 0-15.774-8.745-15.774-21.558 0-6.576 1.354-12.678 4.13-19.322h10.696c-2.64 6.915-4.197 11.864-4.197 18.712 0 6.847 1.489 12.406 6.837 12.406.88 0 1.693-.136 2.505-.407-2.843-5.288-4.333-11.254-4.265-17.287 0-9.627 3.52-14.44 10.561-14.44 7.515 0 10.493 5.626 10.493 14.372.068 6.101-1.557 12.135-4.603 17.423.812.203 1.625.339 2.437.339 5.484 0 7.244-5.695 7.244-12.949 0-6.372-1.49-11.186-4.197-18.169zm-70.272 8.678c-4.806 0-7.176 3.729-7.176 11.118 0 7.39 2.37 10.983 7.109 10.983s7.176-3.729 7.176-11.118c0-7.39-2.37-10.983-7.109-10.983zm-.067 32.135c-11.915 0-18.008-7.661-18.008-20.542 0-13.152 5.754-21.49 18.21-21.49 11.848 0 17.873 7.863 17.873 20.54-.067 12.814-5.619 21.492-18.075 21.492zm-87.738-19.525c.609 6.508 3.52 9.83 10.087 9.83 4.468 0 8.733-1.56 12.186-4.339v10.101c-3.588 2.577-9.14 3.933-13.879 3.933-12.389 0-19.362-7.526-19.362-20.813 0-12.136 5.822-21.152 17.196-21.152 10.696 0 16.18 7.864 16.18 19.931 0 1.153-.068 2.644-.203 4.407h-23.153v-7.864h12.863c-.271-4.407-1.828-7.458-5.62-7.458-3.79 0-5.89 2.848-6.295 8.882zm-37.1 0c.61 6.508 3.52 9.83 10.088 9.83 4.468 0 8.733-1.56 12.185-4.339v10.101c-3.588 2.577-9.139 3.933-13.878 3.933-12.389 0-19.362-7.526-19.362-20.813 0-12.136 5.822-21.22 17.196-21.22 10.696 0 16.18 7.864 16.18 19.932 0 1.152-.068 2.644-.203 4.406h-23.153v-7.796h12.863c-.271-4.407-1.828-7.458-5.62-7.458-3.79 0-5.89 2.848-6.296 8.882zm-12.118-11.05c-3.52.135-6.837.542-9.816 2.1v27.798l-10.832.067v-40.203h10.629v5.763c2.37-3.39 5.957-5.763 10.02-6.508v10.981zm-77.582-12.272v42.168h10.967v-42.168h14.894l2.099-.068h2.91c8.87 0 16.316-3.865 16.316-12.678-.067-7.253-5.077-12.134-12.93-12.134-9.207 0-14.894 7.118-14.894 15.796l-.068 51.253h10.832v-27.525c1.557-1.898 3.86-3.05 6.364-3.118 3.52 0 4.604 2.033 4.604 5.355v25.289h10.831v-27.255c0-7.932-4.062-13.084-11.17-13.084-4.13 0-8.327 1.898-10.629 4.474l.068-17.49c0-2.78 1.557-5.017 4.197-5.017 1.964 0 3.114 1.22 3.114 2.915 0 2.373-1.827 3.66-5.01 3.66h-5.009l-1.49-.067h-37.437v9.627h11.441v.068z",
          fill: _vm.fillColor
        }
      })
    ]
  )
};
var __vue_staticRenderFns__$D = [];
__vue_render__$D._withStripped = true;

  /* style */
  const __vue_inject_styles__$E = undefined;
  /* scoped */
  const __vue_scope_id__$E = undefined;
  /* module identifier */
  const __vue_module_identifier__$E = undefined;
  /* functional template */
  const __vue_is_functional_template__$E = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$E = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
    __vue_inject_styles__$E,
    __vue_script__$E,
    __vue_scope_id__$E,
    __vue_is_functional_template__$E,
    __vue_module_identifier__$E,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * "TfBadge" is a component used for displaying a variety of badges throughout our applications.
 *
 * @vuedoc
 * @exports TfBadge
 * @category components
 */
var script$F = {
  name: 'TfBadge',
  props: {
    /**
     * Boolean used to determine if the badge should be used as a counter, which is a unique style when showing notifications.
     */
    isCounter: {
      type: Boolean,
      default: false
    },

    /**
     * Boolean used to determine if the badge should be pill shaped with completely rounded corners.
     */
    isPill: {
      type: Boolean,
      default: false
    },

    /**
     * Boolean used to determine if the badge should have a background color identical to its border.
     */
    isSolid: {
      type: Boolean,
      default: false
    },

    /**
     * String used to determine the various padding and font styles.
     */
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      }
    },

    /**
     * String used to determine the status of the badge.
     */
    status: {
      type: String,
      default: 'notify',
      validator: function validator(value) {
        return ['error', 'notify', 'success', 'warn'].includes(value);
      }
    },

    /**
     * String or number used as text for the badge.
     */
    value: {
      type: [String, Number],
      required: true
    }
  }
};

/* script */
const __vue_script__$F = script$F;

/* template */
var __vue_render__$E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", {
    staticClass: "tf-badge",
    class: [
      { "is-solid": _vm.isSolid },
      { "is-pill": _vm.isPill },
      { "is-counter": _vm.isCounter },
      "is-" + _vm.size + " is-" + _vm.status
    ],
    domProps: { textContent: _vm._s(_vm.value) }
  })
};
var __vue_staticRenderFns__$E = [];
__vue_render__$E._withStripped = true;

  /* style */
  const __vue_inject_styles__$F = function (inject) {
    if (!inject) return
    inject("data-v-13715cdb_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nspan[data-v-13715cdb] {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border: 1px solid;\n  border-radius: 5px;\n}\nspan.is-small[data-v-13715cdb] {\n  padding: 2px 5px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12px;\n  letter-spacing: inherit;\n}\nspan.is-small.is-pill[data-v-13715cdb]:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-medium[data-v-13715cdb] {\n  padding: 3px 5px;\n}\nspan.is-medium.is-pill[data-v-13715cdb]:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-large[data-v-13715cdb] {\n  padding: 3px 16px;\n}\nspan.is-error[data-v-13715cdb] {\n  color: #f92f37;\n  background: #ffece9;\n  border-color: #f92f37;\n}\nspan.is-error.is-solid[data-v-13715cdb], span.is-error.is-counter[data-v-13715cdb] {\n  background: #f92f37;\n}\nspan.is-notify[data-v-13715cdb] {\n  color: #42474c;\n  border-color: #42474c;\n}\nspan.is-notify.is-solid[data-v-13715cdb], span.is-notify.is-counter[data-v-13715cdb] {\n  background: #42474c;\n}\nspan.is-success[data-v-13715cdb] {\n  color: #00b980;\n  background: #f2fffa;\n  border-color: #00b980;\n}\nspan.is-success.is-solid[data-v-13715cdb], span.is-success.is-counter[data-v-13715cdb] {\n  background: #00b980;\n}\nspan.is-warn[data-v-13715cdb] {\n  color: #f7912a;\n  background: #fff4ea;\n  border-color: #f7912a;\n}\nspan.is-warn.is-solid[data-v-13715cdb], span.is-warn.is-counter[data-v-13715cdb] {\n  background: #f7912a;\n}\nspan.is-counter[data-v-13715cdb] {\n  box-sizing: border-box;\n  height: 20px;\n  min-width: 20px;\n  padding: 2px 5px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: inherit;\n  line-height: 12px;\n  color: #fff;\n}\nspan.is-pill[data-v-13715cdb] {\n  border-radius: 100px;\n}\nspan.is-solid[data-v-13715cdb] {\n  color: #fff;\n}\n\n/*# sourceMappingURL=TfBadge.vue.map */", map: {"version":3,"sources":["TfBadge.vue","/home/circleci/repo/src/components/TfBadge.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACsEpC;EACA,qBAAA;EAEA,eAAA;EACA,gBAAA;EAGA,kBAAA;EACA,yBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,kBAAA;ADxEA;AC4EA;EACA,gBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,iBAAA;EACA,uBAAA;AD5EA;AC8EA;EAEA,kBAAA;EACA,iBAAA;AD7EA;ACkFA;EACA,gBAAA;ADhFA;ACkFA;EAEA,kBAAA;EACA,iBAAA;ADjFA;ACsFA;EACA,iBAAA;ADpFA;ACwFA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;ADtFA;ACwFA;EAEA,mBAAA;ADvFA;AC2FA;EACA,cAAA;EACA,qBAAA;ADzFA;AC2FA;EAEA,mBAAA;AD1FA;AC8FA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AD5FA;AC8FA;EAEA,mBAAA;AD7FA;ACiGA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AD/FA;ACiGA;EAEA,mBAAA;ADhGA;ACqGA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,uBAAA;EACA,iBAAA;EACA,WAAA;ADrGA;ACwGA;EACA,oBAAA;ADtGA;ACyGA;EACA,WAAA;ADvGA;;AAEA,sCAAsC","file":"TfBadge.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nspan {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border: 1px solid;\n  border-radius: 5px;\n}\nspan.is-small {\n  padding: 2px 5px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 12px;\n  letter-spacing: inherit;\n}\nspan.is-small.is-pill:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-medium {\n  padding: 3px 5px;\n}\nspan.is-medium.is-pill:not(.is-counter) {\n  padding-right: 8px;\n  padding-left: 8px;\n}\nspan.is-large {\n  padding: 3px 16px;\n}\nspan.is-error {\n  color: #f92f37;\n  background: #ffece9;\n  border-color: #f92f37;\n}\nspan.is-error.is-solid, span.is-error.is-counter {\n  background: #f92f37;\n}\nspan.is-notify {\n  color: #42474c;\n  border-color: #42474c;\n}\nspan.is-notify.is-solid, span.is-notify.is-counter {\n  background: #42474c;\n}\nspan.is-success {\n  color: #00b980;\n  background: #f2fffa;\n  border-color: #00b980;\n}\nspan.is-success.is-solid, span.is-success.is-counter {\n  background: #00b980;\n}\nspan.is-warn {\n  color: #f7912a;\n  background: #fff4ea;\n  border-color: #f7912a;\n}\nspan.is-warn.is-solid, span.is-warn.is-counter {\n  background: #f7912a;\n}\nspan.is-counter {\n  box-sizing: border-box;\n  height: 20px;\n  min-width: 20px;\n  padding: 2px 5px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: inherit;\n  line-height: 12px;\n  color: #fff;\n}\nspan.is-pill {\n  border-radius: 100px;\n}\nspan.is-solid {\n  color: #fff;\n}\n\n/*# sourceMappingURL=TfBadge.vue.map */","<template>\n  <span\n    class=\"tf-badge\"\n    :class=\"[\n      { 'is-solid': isSolid },\n      { 'is-pill': isPill },\n      { 'is-counter': isCounter },\n      `is-${size} is-${status}`,\n    ]\"\n    v-text=\"value\"\n  />\n</template>\n\n<script>\n  /**\n   * \"TfBadge\" is a component used for displaying a variety of badges throughout our applications.\n   *\n   * @vuedoc\n   * @exports TfBadge\n   * @category components\n   */\n  export default {\n    name: 'TfBadge',\n    props: {\n      /**\n       * Boolean used to determine if the badge should be used as a counter, which is a unique style when showing notifications.\n       */\n      isCounter: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Boolean used to determine if the badge should be pill shaped with completely rounded corners.\n       */\n      isPill: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * Boolean used to determine if the badge should have a background color identical to its border.\n       */\n      isSolid: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * String used to determine the various padding and font styles.\n       */\n      size: {\n        type: String,\n        default: 'medium',\n        validator: (value) => ['small', 'medium', 'large'].includes(value),\n      },\n      /**\n       * String used to determine the status of the badge.\n       */\n      status: {\n        type: String,\n        default: 'notify',\n        validator: (value) => ['error', 'notify', 'success', 'warn'].includes(value),\n      },\n      /**\n       * String or number used as text for the badge.\n       */\n      value: {\n        type: [String, Number],\n        required: true,\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  span {\n    display: inline-block;\n    font: {\n      size: 12px;\n      weight: 700;\n    }\n    text: {\n      align: center;\n      transform: uppercase;\n    }\n    letter-spacing: 1px;\n    border: 1px solid;\n    border-radius: 5px;\n\n    &.is {\n      // Sizes\n      &-small {\n        padding: 2px 5px;\n        font: {\n          size: 10px;\n          weight: 600;\n        }\n        line-height: 12px;\n        letter-spacing: inherit;\n\n        &.is-pill:not(.is-counter) {\n          padding: {\n            right: 8px;\n            left: 8px;\n          }\n        }\n      }\n\n      &-medium {\n        padding: 3px 5px;\n\n        &.is-pill:not(.is-counter) {\n          padding: {\n            right: 8px;\n            left: 8px;\n          }\n        }\n      }\n\n      &-large {\n        padding: 3px 16px;\n      }\n\n      // Statuses\n      &-error {\n        color: $tf-danger;\n        background: $tf-danger-light;\n        border-color: $tf-danger;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-danger;\n        }\n      }\n\n      &-notify {\n        color: $tf-dark-gray;\n        border-color: $tf-dark-gray;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-dark-gray;\n        }\n      }\n\n      &-success {\n        color: $tf-success;\n        background: $tf-success-light;\n        border-color: $tf-success;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-success;\n        }\n      }\n\n      &-warn {\n        color: $tf-warning;\n        background: $tf-warning-light;\n        border-color: $tf-warning;\n\n        &.is-solid,\n        &.is-counter {\n          background: $tf-warning;\n        }\n      }\n\n      // Misc styles\n      &-counter {\n        box-sizing: border-box;\n        height: 20px;\n        min-width: 20px;\n        padding: 2px 5px;\n        border: 1px solid $tf-white;\n        border-radius: 10px;\n        font: {\n          size: 12px;\n          weight: 700;\n        }\n        letter-spacing: inherit;\n        line-height: 12px;\n        color: $tf-white;\n      }\n\n      &-pill {\n        border-radius: 100px;\n      }\n\n      &-solid {\n        color: $tf-white;\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$F = "data-v-13715cdb";
  /* module identifier */
  const __vue_module_identifier__$F = undefined;
  /* functional template */
  const __vue_is_functional_template__$F = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$F = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
    __vue_inject_styles__$F,
    __vue_script__$F,
    __vue_scope_id__$F,
    __vue_is_functional_template__$F,
    __vue_module_identifier__$F,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$G = {
  name: 'TfButton',
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    },
    $themePrimaryButtonColor: {
      default: function _default() {
        return null;
      }
    },
    $themeSecondaryButtonColor: {
      default: function _default() {
        return null;
      }
    }
  },
  props: {
    tag: {
      type: String,
      default: 'button'
    },
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    noBranding: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'asc'
    },
    svgHeight: {
      type: Number,
      default: function _default() {
        return 15;
      }
    },
    svgWidth: {
      type: Number,
      default: function _default() {
        return 12;
      }
    },
    prepend: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hover: false
    };
  },
  computed: {
    /**
     * Return color value as reactive value
     *
     * @returns {string}
     */
    themePrimaryButtonColor: function themePrimaryButtonColor() {
      return this.$themePrimaryButtonColor ? this.$themePrimaryButtonColor() : null;
    },

    /**
     * Return color value as reactive value
     *
     * @returns {string}
     */
    themeSecondaryButtonColor: function themeSecondaryButtonColor() {
      return this.$themeSecondaryButtonColor ? this.$themeSecondaryButtonColor() : null;
    },

    /**
     * inline styles to match primaryColor
     *
     * @returns {object}
     */
    colorStyle: function colorStyle() {
      var style = {};

      if (this.buttonDisabled || this.noBranding) {
        return style;
      }

      if (this.themePrimaryButtonColor) {
        if (this.type === 'primary') {
          if (['text-icon', 'text-icon-small', 'text', 'text-small', 'icon-no-fill'].includes(this.size)) {
            // all text button styles and default icon style (no-fill)
            style.color = this.themePrimaryButtonColor;

            if (!this.noBorder && !this.noPadding && this.size === 'icon-no-fill' && this.hover) {
              style.borderColor = this.themePrimaryButtonColor;
            }
          } else {
            // default primary button (large, medium, icon)
            style.backgroundColor = this.themePrimaryButtonColor;
            style.borderColor = this.themePrimaryButtonColor;
          }
        }
      }

      if (this.themeSecondaryButtonColor) {
        if (this.type === 'secondary') {
          style.color = this.themeSecondaryButtonColor;
          style.borderColor = this.themeSecondaryButtonColor;
        }
      }

      return style;
    },

    /**
     * get formItemSize (from Element)
     *
     * @returns {string}
     */
    elFormItemSize: function elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },

    /**
     * get button size and if size is the deprecated 'icon-small', convert to new 'icon-no-fill'
     *
     * @returns {string}
     */
    buttonSize: function buttonSize() {
      var updatedSize = this.size === 'icon-small' ? 'icon-no-fill' : this.size;
      return updatedSize || this.elFormItemSize || (this.$ELEMENT || {}).size;
    },

    /**
     * Is button disabled
     *
     * @returns {boolean}
     */
    buttonDisabled: function buttonDisabled() {
      var disabledForm = (this.elForm || {}).disabled;
      return this.disabled || disabledForm || this.loading;
    }
  },
  methods: {
    /**
     * Emit click
     *
     * @param {event} evt
     */
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};

/* script */
const __vue_script__$G = script$G;

/* template */
var __vue_render__$F = function() {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "tf-button wt-button",
      class: [
        _vm.type ? "tf-button--" + _vm.type + " wt-button--" + _vm.type : "",
        _vm.buttonSize
          ? "tf-button--" + _vm.buttonSize + " wt-button--" + _vm.buttonSize
          : "",
        {
          "is-disabled": _vm.buttonDisabled
        },
        _vm.icon ? "has-icon icon-" + _vm.icon : "",
        ((_obj = {}), (_obj["has-icon icon-spinner"] = _vm.loading), _obj),
        { "no-padding": _vm.noPadding },
        { "no-border": _vm.noBorder }
      ],
      style: _vm.colorStyle,
      attrs: {
        disabled: _vm.buttonDisabled,
        autofocus: _vm.autofocus,
        type: _vm.nativeType,
        href: _vm.href,
        target: _vm.target
      },
      on: {
        mousedown: function($event) {
          return _vm.$emit("mousedown", $event)
        },
        mouseover: function($event) {
          _vm.hover = true;
        },
        mouseout: function($event) {
          _vm.hover = false;
        },
        click: _vm.handleClick
      }
    },
    [
      _vm.icon && _vm.prepend
        ? [
            _c("icon", {
              class: { "is-rotating": _vm.loading },
              attrs: { name: !_vm.loading ? _vm.icon : "spinner" }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.default
        ? _c("span", { staticClass: "button-text" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm._v(" "),
      !_vm.icon && _vm.loading
        ? _c("icon", {
            staticClass: "icon-loading is-rotating",
            attrs: { name: "spinner" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.icon && !_vm.prepend
        ? [
            _c("icon", {
              class: { "is-rotating": _vm.loading },
              attrs: { name: !_vm.loading ? _vm.icon : "spinner" }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "table-sort"
        ? _c(
            "div",
            {
              class:
                "table-sort table-sort-" +
                _vm.direction +
                " " +
                (_vm.selected ? "table-sort-selected" : "")
            },
            [
              _c("icon", { attrs: { name: "angle-up" } }),
              _vm._v(" "),
              _c("icon", { attrs: { name: "angle-up" } })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__$F = [];
__vue_render__$F._withStripped = true;

  /* style */
  const __vue_inject_styles__$G = function (inject) {
    if (!inject) return
    inject("data-v-5bceaf54_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tf-button[data-v-5bceaf54],\n.wt-button[data-v-5bceaf54] {\n  white-space: nowrap;\n  -webkit-appearance: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  text-align: center;\n  box-sizing: border-box;\n  outline: 0;\n  margin: 0;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  background-color: #2638a6;\n  border-color: #2638a6;\n  color: #fff;\n  font-size: 16px;\n  padding: 7px 14px;\n  border-radius: 0;\n  text-transform: none;\n  border: 2px #2638a6 solid;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n}\n.tf-button[data-v-5bceaf54]:not(.is-disabled),\n.wt-button[data-v-5bceaf54]:not(.is-disabled) {\n  cursor: pointer;\n}\n.tf-button .button-text[data-v-5bceaf54],\n.tf-button svg[data-v-5bceaf54],\n.wt-button .button-text[data-v-5bceaf54],\n.wt-button svg[data-v-5bceaf54] {\n  transform: translate(0, 0);\n}\n.tf-button + .tf-button[data-v-5bceaf54],\n.wt-button + .wt-button[data-v-5bceaf54] {\n  margin-left: 14px;\n}\n.tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill[data-v-5bceaf54],\n.wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill[data-v-5bceaf54] {\n  margin-left: 10px;\n}\n.tf-button--large[data-v-5bceaf54],\n.wt-button--large[data-v-5bceaf54] {\n  font-size: 18px;\n  padding: 12px 18px;\n  border-radius: 25px;\n}\n.tf-button--medium[data-v-5bceaf54],\n.tf-button--small[data-v-5bceaf54],\n.wt-button--medium[data-v-5bceaf54],\n.wt-button--small[data-v-5bceaf54] {\n  border-radius: 3px;\n}\n.tf-button--medium[data-v-5bceaf54],\n.wt-button--medium[data-v-5bceaf54] {\n  font-size: 16px;\n  padding: 7px 18px;\n}\n.tf-button--small[data-v-5bceaf54],\n.wt-button--small[data-v-5bceaf54] {\n  font-size: 14px;\n  padding: 5px 13px;\n}\n.tf-button--large.has-icon svg[data-v-5bceaf54],\n.tf-button--medium.has-icon svg[data-v-5bceaf54],\n.wt-button--large.has-icon svg[data-v-5bceaf54],\n.wt-button--medium.has-icon svg[data-v-5bceaf54] {\n  height: 15px;\n}\n.tf-button--small.has-icon svg[data-v-5bceaf54],\n.wt-button--small.has-icon svg[data-v-5bceaf54] {\n  height: 13px;\n}\n.tf-button--icon[data-v-5bceaf54],\n.tf-button--icon-no-fill[data-v-5bceaf54],\n.wt-button--icon[data-v-5bceaf54],\n.wt-button--icon-no-fill[data-v-5bceaf54] {\n  padding: 5px 4px;\n}\n.tf-button--icon span[data-v-5bceaf54],\n.tf-button--icon-no-fill span[data-v-5bceaf54],\n.wt-button--icon span[data-v-5bceaf54],\n.wt-button--icon-no-fill span[data-v-5bceaf54] {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n}\n.tf-button--icon span + svg[data-v-5bceaf54],\n.tf-button--icon-no-fill span + svg[data-v-5bceaf54],\n.wt-button--icon span + svg[data-v-5bceaf54],\n.wt-button--icon-no-fill span + svg[data-v-5bceaf54] {\n  margin-left: 0;\n}\n.tf-button--icon.has-icon svg[data-v-5bceaf54],\n.tf-button--icon-no-fill.has-icon svg[data-v-5bceaf54],\n.wt-button--icon.has-icon svg[data-v-5bceaf54],\n.wt-button--icon-no-fill.has-icon svg[data-v-5bceaf54] {\n  width: 14px;\n  height: 14px;\n}\n.tf-button--primary[data-v-5bceaf54],\n.wt-button--primary[data-v-5bceaf54] {\n  background-color: #2638a6;\n  border-color: #2638a6;\n  color: #fff;\n}\n.tf-button--secondary[data-v-5bceaf54],\n.wt-button--secondary[data-v-5bceaf54] {\n  background-color: transparent;\n  border-color: #2638a6;\n  color: #2638a6;\n}\n.tf-button--affirm[data-v-5bceaf54],\n.wt-button--affirm[data-v-5bceaf54] {\n  color: #fff;\n  background: #00b980;\n  border-color: #00b980;\n}\n.tf-button--decline[data-v-5bceaf54],\n.wt-button--decline[data-v-5bceaf54] {\n  color: #fff;\n  background: #f92f37;\n  border-color: #f92f37;\n}\n.tf-button.is-disabled[data-v-5bceaf54],\n.wt-button.is-disabled[data-v-5bceaf54] {\n  background: #efefef;\n  color: #c1c1c1;\n}\n.tf-button.is-disabled[data-v-5bceaf54]:not(.tf-button--icon-no-fill), .tf-button.is-disabled[data-v-5bceaf54]:not(.wt-button--icon-no-fill),\n.wt-button.is-disabled[data-v-5bceaf54]:not(.tf-button--icon-no-fill),\n.wt-button.is-disabled[data-v-5bceaf54]:not(.wt-button--icon-no-fill) {\n  border-color: #efefef;\n}\n.tf-button--no-fill[data-v-5bceaf54],\n.wt-button--no-fill[data-v-5bceaf54] {\n  background-color: transparent;\n  border-color: transparent;\n  color: #2638a6;\n}\n.tf-button--text[data-v-5bceaf54],\n.tf-button--text-small[data-v-5bceaf54],\n.tf-button--text-icon.has-icon[data-v-5bceaf54],\n.tf-button--text-icon-small.has-icon[data-v-5bceaf54],\n.tf-button--icon-no-fill.has-icon[data-v-5bceaf54],\n.wt-button--text[data-v-5bceaf54],\n.wt-button--text-small[data-v-5bceaf54],\n.wt-button--text-icon.has-icon[data-v-5bceaf54],\n.wt-button--text-icon-small.has-icon[data-v-5bceaf54],\n.wt-button--icon-no-fill.has-icon[data-v-5bceaf54] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  text-transform: none;\n  font-size: 14px;\n}\n.tf-button--text svg[data-v-5bceaf54],\n.tf-button--text-small svg[data-v-5bceaf54],\n.tf-button--text-icon.has-icon svg[data-v-5bceaf54],\n.tf-button--text-icon-small.has-icon svg[data-v-5bceaf54],\n.tf-button--icon-no-fill.has-icon svg[data-v-5bceaf54],\n.wt-button--text svg[data-v-5bceaf54],\n.wt-button--text-small svg[data-v-5bceaf54],\n.wt-button--text-icon.has-icon svg[data-v-5bceaf54],\n.wt-button--text-icon-small.has-icon svg[data-v-5bceaf54],\n.wt-button--icon-no-fill.has-icon svg[data-v-5bceaf54] {\n  flex-grow: 0;\n  position: static;\n}\n.tf-button--text[data-v-5bceaf54],\n.tf-button--text-small[data-v-5bceaf54],\n.tf-button--text-icon.has-icon[data-v-5bceaf54],\n.tf-button--text-icon-small.has-icon[data-v-5bceaf54],\n.wt-button--text[data-v-5bceaf54],\n.wt-button--text-small[data-v-5bceaf54],\n.wt-button--text-icon.has-icon[data-v-5bceaf54],\n.wt-button--text-icon-small.has-icon[data-v-5bceaf54] {\n  border: 0;\n  padding: 0;\n}\n.tf-button--icon-no-fill[data-v-5bceaf54],\n.wt-button--icon-no-fill[data-v-5bceaf54] {\n  padding: 6px;\n  border: 2px transparent solid;\n  border-radius: 3px;\n}\n.tf-button--icon-no-fill.no-padding[data-v-5bceaf54],\n.wt-button--icon-no-fill.no-padding[data-v-5bceaf54] {\n  padding: 0;\n}\n.tf-button--icon-no-fill span[data-v-5bceaf54],\n.wt-button--icon-no-fill span[data-v-5bceaf54] {\n  position: absolute;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary[data-v-5bceaf54], .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary[data-v-5bceaf54] {\n  border: 2px #2638a6 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm[data-v-5bceaf54], .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm[data-v-5bceaf54] {\n  border: 2px #00b980 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline[data-v-5bceaf54], .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline[data-v-5bceaf54] {\n  border: 2px #f92f37 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).no-border[data-v-5bceaf54], .tf-button--icon-no-fill:hover:not(.is-disabled).no-padding[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-border[data-v-5bceaf54],\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-padding[data-v-5bceaf54] {\n  border: 2px transparent solid;\n}\n.tf-button--text-icon-small.has-icon[data-v-5bceaf54],\n.tf-button--text-small[data-v-5bceaf54],\n.wt-button--text-icon-small.has-icon[data-v-5bceaf54],\n.wt-button--text-small[data-v-5bceaf54] {\n  font-size: 12px;\n  font-weight: 400;\n}\n.tf-button--text-icon-small.has-icon .button-text[data-v-5bceaf54],\n.tf-button--text-small .button-text[data-v-5bceaf54],\n.wt-button--text-icon-small.has-icon .button-text[data-v-5bceaf54],\n.wt-button--text-small .button-text[data-v-5bceaf54] {\n  line-height: 21px;\n}\n.tf-button--text-icon.has-icon svg[data-v-5bceaf54],\n.tf-button--icon-no-fill.has-icon svg[data-v-5bceaf54],\n.wt-button--text-icon.has-icon svg[data-v-5bceaf54],\n.wt-button--icon-no-fill.has-icon svg[data-v-5bceaf54] {\n  width: 15px;\n  height: 15px;\n}\n.tf-button--text-icon-small.has-icon svg[data-v-5bceaf54],\n.wt-button--text-icon-small.has-icon svg[data-v-5bceaf54] {\n  width: 11px;\n  height: 11px;\n}\n.tf-button--text.tf-button--primary[data-v-5bceaf54],\n.tf-button--text-small.tf-button--primary[data-v-5bceaf54],\n.tf-button--text-icon.tf-button--primary[data-v-5bceaf54],\n.tf-button--text-icon-small.tf-button--primary[data-v-5bceaf54],\n.tf-button--icon-no-fill.tf-button--primary[data-v-5bceaf54],\n.wt-button--text.wt-button--primary[data-v-5bceaf54],\n.wt-button--text-small.wt-button--primary[data-v-5bceaf54],\n.wt-button--text-icon.wt-button--primary[data-v-5bceaf54],\n.wt-button--text-icon-small.wt-button--primary[data-v-5bceaf54],\n.wt-button--icon-no-fill.wt-button--primary[data-v-5bceaf54] {\n  color: #2638a6;\n}\n.tf-button--text.tf-button--affirm[data-v-5bceaf54],\n.tf-button--text-small.tf-button--affirm[data-v-5bceaf54],\n.tf-button--text-icon.tf-button--affirm[data-v-5bceaf54],\n.tf-button--text-icon-small.tf-button--affirm[data-v-5bceaf54],\n.tf-button--icon-no-fill.tf-button--affirm[data-v-5bceaf54],\n.wt-button--text.wt-button--affirm[data-v-5bceaf54],\n.wt-button--text-small.wt-button--affirm[data-v-5bceaf54],\n.wt-button--text-icon.wt-button--affirm[data-v-5bceaf54],\n.wt-button--text-icon-small.wt-button--affirm[data-v-5bceaf54],\n.wt-button--icon-no-fill.wt-button--affirm[data-v-5bceaf54] {\n  color: #00b980;\n}\n.tf-button--text.tf-button--decline[data-v-5bceaf54],\n.tf-button--text-small.tf-button--decline[data-v-5bceaf54],\n.tf-button--text-icon.tf-button--decline[data-v-5bceaf54],\n.tf-button--text-icon-small.tf-button--decline[data-v-5bceaf54],\n.tf-button--icon-no-fill.tf-button--decline[data-v-5bceaf54],\n.wt-button--text.wt-button--decline[data-v-5bceaf54],\n.wt-button--text-small.wt-button--decline[data-v-5bceaf54],\n.wt-button--text-icon.wt-button--decline[data-v-5bceaf54],\n.wt-button--text-icon-small.wt-button--decline[data-v-5bceaf54],\n.wt-button--icon-no-fill.wt-button--decline[data-v-5bceaf54] {\n  color: #f92f37;\n}\n.tf-button--text[disabled][data-v-5bceaf54],\n.tf-button--text-small[disabled][data-v-5bceaf54],\n.tf-button--text-icon[disabled][data-v-5bceaf54],\n.tf-button--text-icon-small[disabled][data-v-5bceaf54],\n.tf-button--icon-no-fill[disabled][data-v-5bceaf54],\n.wt-button--text[disabled][data-v-5bceaf54],\n.wt-button--text-small[disabled][data-v-5bceaf54],\n.wt-button--text-icon[disabled][data-v-5bceaf54],\n.wt-button--text-icon-small[disabled][data-v-5bceaf54],\n.wt-button--icon-no-fill[disabled][data-v-5bceaf54] {\n  background: transparent;\n  color: #c1c1c1;\n}\n\n/* table buttons */\n.tf-button--table-sort[data-v-5bceaf54],\n.wt-button--table-sort[data-v-5bceaf54] {\n  position: relative;\n  background: transparent;\n  border: 0;\n  text-transform: none;\n  padding: 0;\n  color: #42474c;\n  padding-right: 16px;\n  top: -2px;\n}\n.table-sort[data-v-5bceaf54] {\n  position: absolute;\n  right: 0;\n  top: -4px;\n  width: 8px;\n}\n.table-sort svg[data-v-5bceaf54] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 8px;\n  fill: #42474c;\n}\n.table-sort svg + svg[data-v-5bceaf54] {\n  top: 9px;\n  transform: rotateZ(180deg);\n}\n.table-sort.table-sort-selected.table-sort-asc svg[data-v-5bceaf54]:first-of-type {\n  fill: #00b980;\n}\n.table-sort.table-sort-selected.table-sort-desc svg + svg[data-v-5bceaf54] {\n  fill: #00b980;\n}\nsvg + .button-text[data-v-5bceaf54],\n.button-text + svg[data-v-5bceaf54] {\n  margin-left: 6px;\n}\n\n/*# sourceMappingURL=TfButton.vue.map */", map: {"version":3,"sources":["TfButton.vue","/home/circleci/repo/src/components/TfButton.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AACpC;;kCAEkC;AAClC;;oCAEoC;AC6PpC;;EAEA,mBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AD3PA;AC6PA;;EACA,eAAA;AD1PA;AC8PA;;;;EAEA,0BAAA;AD1PA;AC8PA;;EAEA,iBAAA;AD3PA;AC8PA;;EAEA,iBAAA;AD3PA;AC8PA;;EAEA,eAAA;EACA,kBAAA;EACA,mBAAA;AD3PA;AC8PA;;;;EAIA,kBAAA;AD3PA;AC8PA;;EAEA,eAAA;EACA,iBAAA;AD3PA;AC8PA;;EAEA,eAAA;EACA,iBAAA;AD3PA;ACkQA;;;;EACA,YAAA;AD5PA;ACkQA;;EACA,YAAA;AD9PA;ACkQA;;;;EAIA,gBAAA;AD/PA;ACiQA;;;;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AD5PA;AC8PA;;;;EACA,cAAA;ADzPA;ACkQA;;;;EACA,WAAA;EACA,YAAA;AD5PA;ACgQA;;EAEA,yBAAA;EACA,qBAAA;EACA,WAAA;AD7PA;ACgQA;;EAEA,6BAAA;EACA,qBAAA;EACA,cAAA;AD7PA;ACgQA;;EAEA,WAAA;EACA,mBAAA;EACA,qBAAA;AD7PA;ACgQA;;EAEA,WAAA;EACA,mBAAA;EACA,qBAAA;AD7PA;ACgQA;;EAEA,mBAAA;EACA,cAAA;AD7PA;AC+PA;;;EAEA,qBAAA;AD5PA;ACgQA;;EAEA,6BAAA;EACA,yBAAA;EACA,cAAA;AD7PA;ACgQA;;;;;;;;;;EAUA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;AD7PA;AC+PA;;;;;;;;;;EACA,YAAA;EACA,gBAAA;ADpPA;ACwPA;;;;;;;;EAQA,SAAA;EACA,UAAA;ADrPA;ACwPA;;EAEA,YAAA;EACA,6BAAA;EACA,kBAAA;ADrPA;ACuPA;;EACA,UAAA;ADpPA;ACuPA;;EACA,kBAAA;ADpPA;ACwPA;;;EAEA,yBAAA;ADrPA;ACwPA;;;EAEA,yBAAA;ADrPA;ACwPA;;;EAEA,yBAAA;ADrPA;ACwPA;;;EACA,6BAAA;ADpPA;ACyPA;;;;EAKA,eAAA;EACA,gBAAA;ADvPA;AC0PA;;;;EACA,iBAAA;ADrPA;AC6PA;;;;EACA,WAAA;EACA,YAAA;ADvPA;AC2PA;;EAEA,WAAA;EACA,YAAA;ADxPA;AC2PA;;;;;;;;;;EAUA,cAAA;ADxPA;AC2PA;;;;;;;;;;EAUA,cAAA;ADxPA;AC2PA;;;;;;;;;;EAUA,cAAA;ADxPA;AC2PA;;;;;;;;;;EAUA,uBAAA;EACA,cAAA;ADxPA;;AC2PA,kBAAA;AACA;;EAEA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;ADxPA;AC2PA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ADxPA;AC0PA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;ADxPA;AC2PA;EACA,QAAA;EACA,0BAAA;ADzPA;AC6PA;EACA,aAAA;AD3PA;ACgQA;EACA,aAAA;AD9PA;ACoQA;;EAEA,gBAAA;ADjQA;;AAEA,uCAAuC","file":"TfButton.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tf-button,\n.wt-button {\n  white-space: nowrap;\n  -webkit-appearance: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  text-align: center;\n  box-sizing: border-box;\n  outline: 0;\n  margin: 0;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  background-color: #2638a6;\n  border-color: #2638a6;\n  color: #fff;\n  font-size: 16px;\n  padding: 7px 14px;\n  border-radius: 0;\n  text-transform: none;\n  border: 2px #2638a6 solid;\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n}\n.tf-button:not(.is-disabled),\n.wt-button:not(.is-disabled) {\n  cursor: pointer;\n}\n.tf-button .button-text,\n.tf-button svg,\n.wt-button .button-text,\n.wt-button svg {\n  transform: translate(0, 0);\n}\n\n.tf-button + .tf-button,\n.wt-button + .wt-button {\n  margin-left: 14px;\n}\n\n.tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n.wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n  margin-left: 10px;\n}\n\n.tf-button--large,\n.wt-button--large {\n  font-size: 18px;\n  padding: 12px 18px;\n  border-radius: 25px;\n}\n\n.tf-button--medium,\n.tf-button--small,\n.wt-button--medium,\n.wt-button--small {\n  border-radius: 3px;\n}\n\n.tf-button--medium,\n.wt-button--medium {\n  font-size: 16px;\n  padding: 7px 18px;\n}\n\n.tf-button--small,\n.wt-button--small {\n  font-size: 14px;\n  padding: 5px 13px;\n}\n\n.tf-button--large.has-icon svg,\n.tf-button--medium.has-icon svg,\n.wt-button--large.has-icon svg,\n.wt-button--medium.has-icon svg {\n  height: 15px;\n}\n\n.tf-button--small.has-icon svg,\n.wt-button--small.has-icon svg {\n  height: 13px;\n}\n\n.tf-button--icon,\n.tf-button--icon-no-fill,\n.wt-button--icon,\n.wt-button--icon-no-fill {\n  padding: 5px 4px;\n}\n.tf-button--icon span,\n.tf-button--icon-no-fill span,\n.wt-button--icon span,\n.wt-button--icon-no-fill span {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n}\n.tf-button--icon span + svg,\n.tf-button--icon-no-fill span + svg,\n.wt-button--icon span + svg,\n.wt-button--icon-no-fill span + svg {\n  margin-left: 0;\n}\n\n.tf-button--icon.has-icon svg,\n.tf-button--icon-no-fill.has-icon svg,\n.wt-button--icon.has-icon svg,\n.wt-button--icon-no-fill.has-icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.tf-button--primary,\n.wt-button--primary {\n  background-color: #2638a6;\n  border-color: #2638a6;\n  color: #fff;\n}\n\n.tf-button--secondary,\n.wt-button--secondary {\n  background-color: transparent;\n  border-color: #2638a6;\n  color: #2638a6;\n}\n\n.tf-button--affirm,\n.wt-button--affirm {\n  color: #fff;\n  background: #00b980;\n  border-color: #00b980;\n}\n\n.tf-button--decline,\n.wt-button--decline {\n  color: #fff;\n  background: #f92f37;\n  border-color: #f92f37;\n}\n\n.tf-button.is-disabled,\n.wt-button.is-disabled {\n  background: #efefef;\n  color: #c1c1c1;\n}\n.tf-button.is-disabled:not(.tf-button--icon-no-fill), .tf-button.is-disabled:not(.wt-button--icon-no-fill),\n.wt-button.is-disabled:not(.tf-button--icon-no-fill),\n.wt-button.is-disabled:not(.wt-button--icon-no-fill) {\n  border-color: #efefef;\n}\n\n.tf-button--no-fill,\n.wt-button--no-fill {\n  background-color: transparent;\n  border-color: transparent;\n  color: #2638a6;\n}\n\n.tf-button--text,\n.tf-button--text-small,\n.tf-button--text-icon.has-icon,\n.tf-button--text-icon-small.has-icon,\n.tf-button--icon-no-fill.has-icon,\n.wt-button--text,\n.wt-button--text-small,\n.wt-button--text-icon.has-icon,\n.wt-button--text-icon-small.has-icon,\n.wt-button--icon-no-fill.has-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  text-transform: none;\n  font-size: 14px;\n}\n.tf-button--text svg,\n.tf-button--text-small svg,\n.tf-button--text-icon.has-icon svg,\n.tf-button--text-icon-small.has-icon svg,\n.tf-button--icon-no-fill.has-icon svg,\n.wt-button--text svg,\n.wt-button--text-small svg,\n.wt-button--text-icon.has-icon svg,\n.wt-button--text-icon-small.has-icon svg,\n.wt-button--icon-no-fill.has-icon svg {\n  flex-grow: 0;\n  position: static;\n}\n\n.tf-button--text,\n.tf-button--text-small,\n.tf-button--text-icon.has-icon,\n.tf-button--text-icon-small.has-icon,\n.wt-button--text,\n.wt-button--text-small,\n.wt-button--text-icon.has-icon,\n.wt-button--text-icon-small.has-icon {\n  border: 0;\n  padding: 0;\n}\n\n.tf-button--icon-no-fill,\n.wt-button--icon-no-fill {\n  padding: 6px;\n  border: 2px transparent solid;\n  border-radius: 3px;\n}\n.tf-button--icon-no-fill.no-padding,\n.wt-button--icon-no-fill.no-padding {\n  padding: 0;\n}\n.tf-button--icon-no-fill span,\n.wt-button--icon-no-fill span {\n  position: absolute;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary, .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary,\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--primary,\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--primary {\n  border: 2px #2638a6 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm, .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm,\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--affirm,\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--affirm {\n  border: 2px #00b980 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline, .tf-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline,\n.wt-button--icon-no-fill:hover:not(.is-disabled).tf-button--decline,\n.wt-button--icon-no-fill:hover:not(.is-disabled).wt-button--decline {\n  border: 2px #f92f37 solid;\n}\n.tf-button--icon-no-fill:hover:not(.is-disabled).no-border, .tf-button--icon-no-fill:hover:not(.is-disabled).no-padding,\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-border,\n.wt-button--icon-no-fill:hover:not(.is-disabled).no-padding {\n  border: 2px transparent solid;\n}\n\n.tf-button--text-icon-small.has-icon,\n.tf-button--text-small,\n.wt-button--text-icon-small.has-icon,\n.wt-button--text-small {\n  font-size: 12px;\n  font-weight: 400;\n}\n.tf-button--text-icon-small.has-icon .button-text,\n.tf-button--text-small .button-text,\n.wt-button--text-icon-small.has-icon .button-text,\n.wt-button--text-small .button-text {\n  line-height: 21px;\n}\n\n.tf-button--text-icon.has-icon svg,\n.tf-button--icon-no-fill.has-icon svg,\n.wt-button--text-icon.has-icon svg,\n.wt-button--icon-no-fill.has-icon svg {\n  width: 15px;\n  height: 15px;\n}\n\n.tf-button--text-icon-small.has-icon svg,\n.wt-button--text-icon-small.has-icon svg {\n  width: 11px;\n  height: 11px;\n}\n\n.tf-button--text.tf-button--primary,\n.tf-button--text-small.tf-button--primary,\n.tf-button--text-icon.tf-button--primary,\n.tf-button--text-icon-small.tf-button--primary,\n.tf-button--icon-no-fill.tf-button--primary,\n.wt-button--text.wt-button--primary,\n.wt-button--text-small.wt-button--primary,\n.wt-button--text-icon.wt-button--primary,\n.wt-button--text-icon-small.wt-button--primary,\n.wt-button--icon-no-fill.wt-button--primary {\n  color: #2638a6;\n}\n\n.tf-button--text.tf-button--affirm,\n.tf-button--text-small.tf-button--affirm,\n.tf-button--text-icon.tf-button--affirm,\n.tf-button--text-icon-small.tf-button--affirm,\n.tf-button--icon-no-fill.tf-button--affirm,\n.wt-button--text.wt-button--affirm,\n.wt-button--text-small.wt-button--affirm,\n.wt-button--text-icon.wt-button--affirm,\n.wt-button--text-icon-small.wt-button--affirm,\n.wt-button--icon-no-fill.wt-button--affirm {\n  color: #00b980;\n}\n\n.tf-button--text.tf-button--decline,\n.tf-button--text-small.tf-button--decline,\n.tf-button--text-icon.tf-button--decline,\n.tf-button--text-icon-small.tf-button--decline,\n.tf-button--icon-no-fill.tf-button--decline,\n.wt-button--text.wt-button--decline,\n.wt-button--text-small.wt-button--decline,\n.wt-button--text-icon.wt-button--decline,\n.wt-button--text-icon-small.wt-button--decline,\n.wt-button--icon-no-fill.wt-button--decline {\n  color: #f92f37;\n}\n\n.tf-button--text[disabled],\n.tf-button--text-small[disabled],\n.tf-button--text-icon[disabled],\n.tf-button--text-icon-small[disabled],\n.tf-button--icon-no-fill[disabled],\n.wt-button--text[disabled],\n.wt-button--text-small[disabled],\n.wt-button--text-icon[disabled],\n.wt-button--text-icon-small[disabled],\n.wt-button--icon-no-fill[disabled] {\n  background: transparent;\n  color: #c1c1c1;\n}\n\n/* table buttons */\n.tf-button--table-sort,\n.wt-button--table-sort {\n  position: relative;\n  background: transparent;\n  border: 0;\n  text-transform: none;\n  padding: 0;\n  color: #42474c;\n  padding-right: 16px;\n  top: -2px;\n}\n\n.table-sort {\n  position: absolute;\n  right: 0;\n  top: -4px;\n  width: 8px;\n}\n.table-sort svg {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 8px;\n  fill: #42474c;\n}\n.table-sort svg + svg {\n  top: 9px;\n  transform: rotateZ(180deg);\n}\n.table-sort.table-sort-selected.table-sort-asc svg:first-of-type {\n  fill: #00b980;\n}\n.table-sort.table-sort-selected.table-sort-desc svg + svg {\n  fill: #00b980;\n}\n\nsvg + .button-text,\n.button-text + svg {\n  margin-left: 6px;\n}\n\n/*# sourceMappingURL=TfButton.vue.map */","<template>\n  <component\n    :is=\"tag\"\n    :disabled=\"buttonDisabled\"\n    :autofocus=\"autofocus\"\n    :type=\"nativeType\"\n    :href=\"href\"\n    :target=\"target\"\n    :class=\"[\n      type ? `tf-button--${type} wt-button--${type}` : '',\n      buttonSize ? `tf-button--${buttonSize} wt-button--${buttonSize}` : '',\n      {\n        'is-disabled': buttonDisabled\n      },\n      icon ? `has-icon icon-${icon}` : '',\n      { [`has-icon icon-spinner`] : loading },\n      { 'no-padding': noPadding },\n      { 'no-border': noBorder }\n    ]\"\n    :style=\"colorStyle\"\n    class=\"tf-button wt-button\"\n    @mousedown=\"$emit('mousedown', $event)\"\n    @mouseover=\"hover = true\"\n    @mouseout=\"hover = false\"\n    @click=\"handleClick\"\n  >\n    <!-- Prepend icons to text -->\n    <template v-if=\"icon && prepend\">\n      <icon\n        :class=\"{ 'is-rotating': loading }\"\n        :name=\"!loading ? icon : 'spinner'\"\n      />\n    </template>\n    <span\n      v-if=\"$slots.default\"\n      class=\"button-text\"\n    >\n      <slot />\n    </span>\n    <!-- Add loading icon when there is no prefixed/affixed icon -->\n    <icon\n      v-if=\"!icon && loading\"\n      class=\"icon-loading is-rotating\"\n      name=\"spinner\"\n    />\n    <!-- Append icons to text -->\n    <template v-if=\"icon && !prepend\">\n      <icon\n        :class=\"{ 'is-rotating': loading }\"\n        :name=\"!loading ? icon : 'spinner'\"\n      />\n    </template>\n    <div\n      v-if=\"type === 'table-sort'\"\n      :class=\"`table-sort table-sort-${direction} ${selected ? 'table-sort-selected' : ''}`\"\n    >\n      <icon name=\"angle-up\" />\n      <icon name=\"angle-up\" />\n    </div>\n  </component>\n</template>\n<script>\n  export default {\n    name: 'TfButton',\n    inject: {\n      elForm: {\n        default: '',\n      },\n      elFormItem: {\n        default: '',\n      },\n      $themePrimaryButtonColor: { default: () => null },\n      $themeSecondaryButtonColor: { default: () => null },\n    },\n    props: {\n      tag: {\n        type: String,\n        default: 'button',\n      },\n      href: {\n        type: String,\n        default: null,\n      },\n      target: {\n        type: String,\n        default: null,\n      },\n      type: {\n        type: String,\n        default: 'default',\n      },\n      size: {\n        type: String,\n        default: null,\n      },\n      icon: {\n        type: String,\n        default: '',\n      },\n      nativeType: {\n        type: String,\n        default: 'button',\n      },\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n      loading: {\n        type: Boolean,\n        default: false,\n      },\n      noPadding: {\n        type: Boolean,\n        default: false,\n      },\n      noBorder: {\n        type: Boolean,\n        default: false,\n      },\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      autofocus: {\n        type: Boolean,\n        default: false,\n      },\n      selected: {\n        type: Boolean,\n        default: false,\n      },\n      direction: {\n        type: String,\n        default: 'asc',\n      },\n      svgHeight: {\n        type: Number,\n        default: () => 15,\n      },\n      svgWidth: {\n        type: Number,\n        default: () => 12,\n      },\n      prepend: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => ({\n      hover: false,\n    }),\n    computed: {\n      /**\n       * Return color value as reactive value\n       *\n       * @returns {string}\n       */\n      themePrimaryButtonColor() {\n        return this.$themePrimaryButtonColor ? this.$themePrimaryButtonColor() : null;\n      },\n      /**\n       * Return color value as reactive value\n       *\n       * @returns {string}\n       */\n      themeSecondaryButtonColor() {\n        return this.$themeSecondaryButtonColor ? this.$themeSecondaryButtonColor() : null;\n      },\n      /**\n       * inline styles to match primaryColor\n       *\n       * @returns {object}\n       */\n      colorStyle() {\n        const style = {};\n\n        if (this.buttonDisabled || this.noBranding) {\n          return style;\n        }\n\n        if (this.themePrimaryButtonColor) {\n          if (this.type === 'primary') {\n            if ([\n              'text-icon',\n              'text-icon-small',\n              'text',\n              'text-small',\n              'icon-no-fill',\n            ].includes(this.size)) {\n              // all text button styles and default icon style (no-fill)\n              style.color = this.themePrimaryButtonColor;\n\n              if (\n                !this.noBorder\n                && !this.noPadding\n                && this.size === 'icon-no-fill'\n                && this.hover\n              ) {\n                style.borderColor = this.themePrimaryButtonColor;\n              }\n            } else {\n              // default primary button (large, medium, icon)\n              style.backgroundColor = this.themePrimaryButtonColor;\n              style.borderColor = this.themePrimaryButtonColor;\n            }\n          }\n        }\n\n        if (this.themeSecondaryButtonColor) {\n          if (this.type === 'secondary') {\n            style.color = this.themeSecondaryButtonColor;\n            style.borderColor = this.themeSecondaryButtonColor;\n          }\n        }\n\n        return style;\n      },\n      /**\n       * get formItemSize (from Element)\n       *\n       * @returns {string}\n       */\n      elFormItemSize() {\n        return (this.elFormItem || {}).elFormItemSize;\n      },\n      /**\n       * get button size and if size is the deprecated 'icon-small', convert to new 'icon-no-fill'\n       *\n       * @returns {string}\n       */\n      buttonSize() {\n        const updatedSize = this.size === 'icon-small' ? 'icon-no-fill' : this.size;\n        return updatedSize\n          || this.elFormItemSize\n          || (this.$ELEMENT || {}).size;\n      },\n      /**\n       * Is button disabled\n       *\n       * @returns {boolean}\n       */\n      buttonDisabled() {\n        const disabledForm = (this.elForm || {}).disabled;\n\n        return this.disabled || disabledForm || this.loading;\n      },\n    },\n    methods: {\n      /**\n       * Emit click\n       *\n       * @param {event} evt\n       */\n      handleClick(evt) {\n        this.$emit('click', evt);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  .tf-button,\n  .wt-button {\n    white-space: nowrap;\n    -webkit-appearance: none;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n    text-align: center;\n    box-sizing: border-box;\n    outline: 0;\n    margin: 0;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    background-color: $tf-blue;\n    border-color: $tf-blue;\n    color: $tf-white;\n    font-size: 16px;\n    padding: 7px 14px;\n    border-radius: 0;\n    text-transform: none;\n    border: 2px $tf-blue solid;\n    display: inline-flex;\n    align-items: center;\n    font-weight: 600;\n    line-height: 1;\n\n    &:not(.is-disabled) {\n      cursor: pointer;\n    }\n\n    // 2-12-21 RLH - styles added to span to stop button text/icon from jumping when clicked in IE\n    .button-text,\n    svg {\n      transform: translate(0, 0);\n    }\n  }\n\n  .tf-button + .tf-button,\n  .wt-button + .wt-button {\n    margin-left: 14px;\n  }\n\n  .tf-button.tf-button--icon-no-fill + .tf-button.tf-button--icon-no-fill,\n  .wt-button.wt-button--icon-no-fill + .wt-button.wt-button--icon-no-fill {\n    margin-left: 10px;\n  }\n\n  .tf-button--large,\n  .wt-button--large {\n    font-size: 18px;\n    padding: 12px 18px;\n    border-radius: 25px;\n  }\n\n  .tf-button--medium,\n  .tf-button--small,\n  .wt-button--medium,\n  .wt-button--small {\n    border-radius: 3px;\n  }\n\n  .tf-button--medium,\n  .wt-button--medium {\n    font-size: 16px;\n    padding: 7px 18px;\n  }\n\n  .tf-button--small,\n  .wt-button--small {\n    font-size: 14px;\n    padding: 5px 13px;\n  }\n\n  .tf-button--large.has-icon,\n  .tf-button--medium.has-icon,\n  .wt-button--large.has-icon,\n  .wt-button--medium.has-icon {\n    svg {\n      height: 15px;\n    }\n  }\n\n  .tf-button--small.has-icon,\n  .wt-button--small.has-icon {\n    svg {\n      height: 13px;\n    }\n  }\n\n  .tf-button--icon,\n  .tf-button--icon-no-fill,\n  .wt-button--icon,\n  .wt-button--icon-no-fill {\n    padding: 5px 4px;\n\n    span {\n      display: inline-block;\n      width: 0;\n      height: 0;\n      overflow: hidden;\n\n      + svg {\n        margin-left: 0;\n      }\n    }\n  }\n\n  .tf-button--icon.has-icon,\n  .tf-button--icon-no-fill.has-icon,\n  .wt-button--icon.has-icon,\n  .wt-button--icon-no-fill.has-icon {\n    svg {\n      width: 14px;\n      height: 14px;\n    }\n  }\n\n  .tf-button--primary,\n  .wt-button--primary {\n    background-color: $tf-blue;\n    border-color: $tf-blue;\n    color: $tf-white;\n  }\n\n  .tf-button--secondary,\n  .wt-button--secondary {\n    background-color: transparent;\n    border-color: $tf-blue;\n    color: $tf-blue;\n  }\n\n  .tf-button--affirm,\n  .wt-button--affirm {\n    color: $tf-white;\n    background: $tf-green;\n    border-color: $tf-green;\n  }\n\n  .tf-button--decline,\n  .wt-button--decline {\n    color: $tf-white;\n    background: $tf-red;\n    border-color: $tf-red;\n  }\n\n  .tf-button.is-disabled,\n  .wt-button.is-disabled {\n    background: $tf-extra-light-gray-1;\n    color: $tf-light-gray;\n\n    &:not(.tf-button--icon-no-fill),\n    &:not(.wt-button--icon-no-fill) {\n      border-color: $tf-extra-light-gray-1;\n    }\n  }\n\n  .tf-button--no-fill,\n  .wt-button--no-fill {\n    background-color: transparent;\n    border-color: transparent;\n    color: $tf-blue;\n  }\n\n  .tf-button--text,\n  .tf-button--text-small,\n  .tf-button--text-icon.has-icon,\n  .tf-button--text-icon-small.has-icon,\n  .tf-button--icon-no-fill.has-icon,\n  .wt-button--text,\n  .wt-button--text-small,\n  .wt-button--text-icon.has-icon,\n  .wt-button--text-icon-small.has-icon,\n  .wt-button--icon-no-fill.has-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    text-transform: none;\n    font-size: 14px;\n\n    svg {\n      flex-grow: 0;\n      position: static;\n    }\n  }\n\n  .tf-button--text,\n  .tf-button--text-small,\n  .tf-button--text-icon.has-icon,\n  .tf-button--text-icon-small.has-icon,\n  .wt-button--text,\n  .wt-button--text-small,\n  .wt-button--text-icon.has-icon,\n  .wt-button--text-icon-small.has-icon {\n    border: 0;\n    padding: 0;\n  }\n\n  .tf-button--icon-no-fill,\n  .wt-button--icon-no-fill {\n    padding: 6px;\n    border: 2px transparent solid;\n    border-radius: 3px;\n\n    &.no-padding {\n      padding: 0;\n    }\n\n    span {\n      position: absolute;\n    }\n\n    &:hover:not(.is-disabled) {\n      &.tf-button--primary,\n      &.wt-button--primary {\n        border: 2px $tf-blue solid;\n      }\n\n      &.tf-button--affirm,\n      &.wt-button--affirm {\n        border: 2px $tf-green solid;\n      }\n\n      &.tf-button--decline,\n      &.wt-button--decline {\n        border: 2px $tf-red solid;\n      }\n\n      &.no-border, &.no-padding {\n        border: 2px transparent solid;\n      }\n    }\n  }\n\n  .tf-button--text-icon-small.has-icon,\n  .tf-button--text-small,\n  .wt-button--text-icon-small.has-icon,\n  .wt-button--text-small {\n    font: {\n      size: 12px;\n      weight: 400;\n    }\n\n    .button-text {\n      line-height: 21px;\n    }\n  }\n\n  .tf-button--text-icon.has-icon,\n  .tf-button--icon-no-fill.has-icon,\n  .wt-button--text-icon.has-icon,\n  .wt-button--icon-no-fill.has-icon {\n    svg {\n      width: 15px;\n      height: 15px;\n    }\n  }\n\n  .tf-button--text-icon-small.has-icon svg,\n  .wt-button--text-icon-small.has-icon svg {\n    width: 11px;\n    height: 11px;\n  }\n\n  .tf-button--text.tf-button--primary,\n  .tf-button--text-small.tf-button--primary,\n  .tf-button--text-icon.tf-button--primary,\n  .tf-button--text-icon-small.tf-button--primary,\n  .tf-button--icon-no-fill.tf-button--primary,\n  .wt-button--text.wt-button--primary,\n  .wt-button--text-small.wt-button--primary,\n  .wt-button--text-icon.wt-button--primary,\n  .wt-button--text-icon-small.wt-button--primary,\n  .wt-button--icon-no-fill.wt-button--primary {\n    color: $tf-blue;\n  }\n\n  .tf-button--text.tf-button--affirm,\n  .tf-button--text-small.tf-button--affirm,\n  .tf-button--text-icon.tf-button--affirm,\n  .tf-button--text-icon-small.tf-button--affirm,\n  .tf-button--icon-no-fill.tf-button--affirm,\n  .wt-button--text.wt-button--affirm,\n  .wt-button--text-small.wt-button--affirm,\n  .wt-button--text-icon.wt-button--affirm,\n  .wt-button--text-icon-small.wt-button--affirm,\n  .wt-button--icon-no-fill.wt-button--affirm {\n    color: $tf-green;\n  }\n\n  .tf-button--text.tf-button--decline,\n  .tf-button--text-small.tf-button--decline,\n  .tf-button--text-icon.tf-button--decline,\n  .tf-button--text-icon-small.tf-button--decline,\n  .tf-button--icon-no-fill.tf-button--decline,\n  .wt-button--text.wt-button--decline,\n  .wt-button--text-small.wt-button--decline,\n  .wt-button--text-icon.wt-button--decline,\n  .wt-button--text-icon-small.wt-button--decline,\n  .wt-button--icon-no-fill.wt-button--decline {\n    color: $tf-red;\n  }\n\n  .tf-button--text[disabled],\n  .tf-button--text-small[disabled],\n  .tf-button--text-icon[disabled],\n  .tf-button--text-icon-small[disabled],\n  .tf-button--icon-no-fill[disabled],\n  .wt-button--text[disabled],\n  .wt-button--text-small[disabled],\n  .wt-button--text-icon[disabled],\n  .wt-button--text-icon-small[disabled],\n  .wt-button--icon-no-fill[disabled] {\n    background: transparent;\n    color: $tf-light-gray;\n  }\n\n  /* table buttons */\n  .tf-button--table-sort,\n  .wt-button--table-sort {\n    position: relative;\n    background: transparent;\n    border: 0;\n    text-transform: none;\n    padding: 0;\n    color: $tf-dark-gray;\n    padding-right: 16px;\n    top: -2px;\n  }\n\n  .table-sort {\n    position: absolute;\n    right: 0;\n    top: -4px;\n    width: 8px;\n\n    svg {\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 8px;\n      fill: $tf-dark-gray;\n    }\n\n    svg + svg {\n      top: 9px;\n      transform: rotateZ(180deg);\n    }\n\n    &.table-sort-selected.table-sort-asc {\n      svg:first-of-type {\n        fill: $tf-green;\n      }\n    }\n\n    &.table-sort-selected.table-sort-desc {\n      svg + svg {\n        fill: $tf-green;\n      }\n    }\n  }\n\n  // Add margin to span for appended icons\n  svg + .button-text,\n  .button-text + svg {\n    margin-left: 6px;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$G = "data-v-5bceaf54";
  /* module identifier */
  const __vue_module_identifier__$G = undefined;
  /* functional template */
  const __vue_is_functional_template__$G = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$G = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
    __vue_inject_styles__$G,
    __vue_script__$G,
    __vue_scope_id__$G,
    __vue_is_functional_template__$G,
    __vue_module_identifier__$G,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * "CtaEmailSupport" is a simple call-to-action component used for opening a user's email client (if set) with the appropriate support email address.
 *
 * @vuedoc
 * @exports TfCtaEmailSupport
 * @category components
 */
var script$H = {
  name: 'TfCtaEmailSupport',
  props: {
    /**
     * Boolean used to tell the TfButton component to bypass branding styles.
     */
    noBranding: {
      type: Boolean,
      default: false
    },

    /**
     * String used to tell the TfButton component what button type/color to display.
     */
    type: {
      type: String,
      default: 'primary'
    }
  }
};

/* script */
const __vue_script__$H = script$H;

/* template */
var __vue_render__$G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-button",
    {
      staticClass: "cta-email-support",
      attrs: {
        href: "mailto:support@threeflow.com",
        size: "text",
        tag: "a",
        target: "_blank",
        type: _vm.type,
        "no-branding": _vm.noBranding
      }
    },
    [_vm._t("default", [_vm._v("\n    contact support\n  ")])],
    2
  )
};
var __vue_staticRenderFns__$G = [];
__vue_render__$G._withStripped = true;

  /* style */
  const __vue_inject_styles__$H = function (inject) {
    if (!inject) return
    inject("data-v-f93ecfd2_0", { source: "\n.cta-email-support[data-v-f93ecfd2] {\n  display: inline-block;\n  font-size: inherit;\n}\n", map: {"version":3,"sources":["/home/circleci/repo/src/components/TfCtaEmailSupport.vue"],"names":[],"mappings":";AA6CA;EACA,qBAAA;EACA,kBAAA;AACA","file":"TfCtaEmailSupport.vue","sourcesContent":["<template>\n  <tf-button\n    class=\"cta-email-support\"\n    href=\"mailto:support@threeflow.com\"\n    size=\"text\"\n    tag=\"a\"\n    target=\"_blank\"\n    :type=\"type\"\n    :no-branding=\"noBranding\"\n  >\n    <slot>\n      contact support\n    </slot>\n  </tf-button>\n</template>\n<script>\n  /**\n   * \"CtaEmailSupport\" is a simple call-to-action component used for opening a user's email client (if set) with the appropriate support email address.\n   *\n   * @vuedoc\n   * @exports TfCtaEmailSupport\n   * @category components\n   */\n  export default {\n    name: 'TfCtaEmailSupport',\n    props: {\n      /**\n       * Boolean used to tell the TfButton component to bypass branding styles.\n       */\n      noBranding: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * String used to tell the TfButton component what button type/color to display.\n       */\n      type: {\n        type: String,\n        default: 'primary',\n      },\n    },\n  };\n</script>\n\n<style scoped>\n  .cta-email-support {\n    display: inline-block;\n    font-size: inherit;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$H = "data-v-f93ecfd2";
  /* module identifier */
  const __vue_module_identifier__$H = undefined;
  /* functional template */
  const __vue_is_functional_template__$H = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$H = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
    __vue_inject_styles__$H,
    __vue_script__$H,
    __vue_scope_id__$H,
    __vue_is_functional_template__$H,
    __vue_module_identifier__$H,
    false,
    browser,
    undefined,
    undefined
  );

var Datepicker$1 = createCommonjsModule(function (module, exports) {
/*
* @sum.cumo/vue-datepicker v3.2.3
* (c) 2018-2021 sum.cumo GmbH
* Released under the Apache-2.0 License.
*/
(function (global, factory) {
	 module.exports = factory() ;
}(commonjsGlobal, (function () {
	var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

	var check = function (it) {
	  return it && it.Math == Math && it;
	}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


	var global$d = // eslint-disable-next-line es/no-global-this -- safe
	check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
	check(typeof self == 'object' && self) || check(typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1) || // eslint-disable-next-line no-new-func -- fallback
	function () {
	  return this;
	}() || Function('return this')();

	var objectGetOwnPropertyDescriptor = {};

	var fails$c = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	var fails$b = fails$c; // Detect IE8's incomplete defineProperty implementation

	var descriptors = !fails$b(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, {
	    get: function () {
	      return 7;
	    }
	  })[1] != 7;
	});

	var objectPropertyIsEnumerable = {};

	var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

	var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

	var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({
	  1: 2
	}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

	objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$2(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;

	var createPropertyDescriptor$3 = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var toString$1 = {}.toString;

	var classofRaw$1 = function (it) {
	  return toString$1.call(it).slice(8, -1);
	};

	var fails$a = fails$c;
	var classof$6 = classofRaw$1;
	var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

	var indexedObject = fails$a(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof$6(it) == 'String' ? split.call(it, '') : Object(it);
	} : Object;

	// https://tc39.es/ecma262/#sec-requireobjectcoercible

	var requireObjectCoercible$7 = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on " + it);
	  return it;
	};

	var IndexedObject$2 = indexedObject;
	var requireObjectCoercible$6 = requireObjectCoercible$7;

	var toIndexedObject$5 = function (it) {
	  return IndexedObject$2(requireObjectCoercible$6(it));
	};

	var isObject$a = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var isObject$9 = isObject$a; // `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string

	var toPrimitive$4 = function (input, PREFERRED_STRING) {
	  if (!isObject$9(input)) return input;
	  var fn, val;
	  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$9(val = fn.call(input))) return val;
	  if (typeof (fn = input.valueOf) == 'function' && !isObject$9(val = fn.call(input))) return val;
	  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$9(val = fn.call(input))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

	var requireObjectCoercible$5 = requireObjectCoercible$7; // `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject

	var toObject$5 = function (argument) {
	  return Object(requireObjectCoercible$5(argument));
	};

	var toObject$4 = toObject$5;
	var hasOwnProperty = {}.hasOwnProperty;

	var has$7 = function hasOwn(it, key) {
	  return hasOwnProperty.call(toObject$4(it), key);
	};

	var global$c = global$d;
	var isObject$8 = isObject$a;
	var document$1 = global$c.document; // typeof document.createElement is 'object' in old IE

	var EXISTS = isObject$8(document$1) && isObject$8(document$1.createElement);

	var documentCreateElement$1 = function (it) {
	  return EXISTS ? document$1.createElement(it) : {};
	};

	var DESCRIPTORS$5 = descriptors;
	var fails$9 = fails$c;
	var createElement = documentCreateElement$1; // Thank's IE8 for his funny defineProperty

	var ie8DomDefine = !DESCRIPTORS$5 && !fails$9(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a != 7;
	});

	var DESCRIPTORS$4 = descriptors;
	var propertyIsEnumerableModule = objectPropertyIsEnumerable;
	var createPropertyDescriptor$2 = createPropertyDescriptor$3;
	var toIndexedObject$4 = toIndexedObject$5;
	var toPrimitive$3 = toPrimitive$4;
	var has$6 = has$7;
	var IE8_DOM_DEFINE$1 = ie8DomDefine; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

	objectGetOwnPropertyDescriptor.f = DESCRIPTORS$4 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject$4(O);
	  P = toPrimitive$3(P, true);
	  if (IE8_DOM_DEFINE$1) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) {
	    /* empty */
	  }
	  if (has$6(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule.f.call(O, P), O[P]);
	};

	var objectDefineProperty = {};

	var isObject$7 = isObject$a;

	var anObject$a = function (it) {
	  if (!isObject$7(it)) {
	    throw TypeError(String(it) + ' is not an object');
	  }

	  return it;
	};

	var DESCRIPTORS$3 = descriptors;
	var IE8_DOM_DEFINE = ie8DomDefine;
	var anObject$9 = anObject$a;
	var toPrimitive$2 = toPrimitive$4; // eslint-disable-next-line es/no-object-defineproperty -- safe

	var $defineProperty = Object.defineProperty; // `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty

	objectDefineProperty.f = DESCRIPTORS$3 ? $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject$9(O);
	  P = toPrimitive$2(P, true);
	  anObject$9(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) {
	    /* empty */
	  }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var DESCRIPTORS$2 = descriptors;
	var definePropertyModule$4 = objectDefineProperty;
	var createPropertyDescriptor$1 = createPropertyDescriptor$3;
	var createNonEnumerableProperty$5 = DESCRIPTORS$2 ? function (object, key, value) {
	  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var redefine$4 = {exports: {}};

	var global$b = global$d;
	var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;

	var setGlobal$3 = function (key, value) {
	  try {
	    createNonEnumerableProperty$4(global$b, key, value);
	  } catch (error) {
	    global$b[key] = value;
	  }

	  return value;
	};

	var global$a = global$d;
	var setGlobal$2 = setGlobal$3;
	var SHARED = '__core-js_shared__';
	var store$3 = global$a[SHARED] || setGlobal$2(SHARED, {});
	var sharedStore = store$3;

	var store$2 = sharedStore;
	var functionToString = Function.toString; // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper

	if (typeof store$2.inspectSource != 'function') {
	  store$2.inspectSource = function (it) {
	    return functionToString.call(it);
	  };
	}

	var inspectSource$2 = store$2.inspectSource;

	var global$9 = global$d;
	var inspectSource$1 = inspectSource$2;
	var WeakMap$1 = global$9.WeakMap;
	var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$1(WeakMap$1));

	var shared$4 = {exports: {}};

	var store$1 = sharedStore;
	(shared$4.exports = function (key, value) {
	  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.12.1',
	  mode: 'global',
	  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
	});

	var id = 0;
	var postfix = Math.random();

	var uid$2 = function (key) {
	  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
	};

	var shared$3 = shared$4.exports;
	var uid$1 = uid$2;
	var keys$1 = shared$3('keys');

	var sharedKey$2 = function (key) {
	  return keys$1[key] || (keys$1[key] = uid$1(key));
	};

	var hiddenKeys$4 = {};

	var NATIVE_WEAK_MAP = nativeWeakMap;
	var global$8 = global$d;
	var isObject$6 = isObject$a;
	var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
	var objectHas = has$7;
	var shared$2 = sharedStore;
	var sharedKey$1 = sharedKey$2;
	var hiddenKeys$3 = hiddenKeys$4;
	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var WeakMap = global$8.WeakMap;
	var set, get, has$5;

	var enforce = function (it) {
	  return has$5(it) ? get(it) : set(it, {});
	};

	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;

	    if (!isObject$6(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    }

	    return state;
	  };
	};

	if (NATIVE_WEAK_MAP || shared$2.state) {
	  var store = shared$2.state || (shared$2.state = new WeakMap());
	  var wmget = store.get;
	  var wmhas = store.has;
	  var wmset = store.set;

	  set = function (it, metadata) {
	    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    wmset.call(store, it, metadata);
	    return metadata;
	  };

	  get = function (it) {
	    return wmget.call(store, it) || {};
	  };

	  has$5 = function (it) {
	    return wmhas.call(store, it);
	  };
	} else {
	  var STATE = sharedKey$1('state');
	  hiddenKeys$3[STATE] = true;

	  set = function (it, metadata) {
	    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty$3(it, STATE, metadata);
	    return metadata;
	  };

	  get = function (it) {
	    return objectHas(it, STATE) ? it[STATE] : {};
	  };

	  has$5 = function (it) {
	    return objectHas(it, STATE);
	  };
	}

	var internalState = {
	  set: set,
	  get: get,
	  has: has$5,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var global$7 = global$d;
	var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
	var has$4 = has$7;
	var setGlobal$1 = setGlobal$3;
	var inspectSource = inspectSource$2;
	var InternalStateModule = internalState;
	var getInternalState = InternalStateModule.get;
	var enforceInternalState = InternalStateModule.enforce;
	var TEMPLATE = String(String).split('String');
	(redefine$4.exports = function (O, key, value, options) {
	  var unsafe = options ? !!options.unsafe : false;
	  var simple = options ? !!options.enumerable : false;
	  var noTargetGet = options ? !!options.noTargetGet : false;
	  var state;

	  if (typeof value == 'function') {
	    if (typeof key == 'string' && !has$4(value, 'name')) {
	      createNonEnumerableProperty$2(value, 'name', key);
	    }

	    state = enforceInternalState(value);

	    if (!state.source) {
	      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
	    }
	  }

	  if (O === global$7) {
	    if (simple) O[key] = value;else setGlobal$1(key, value);
	    return;
	  } else if (!unsafe) {
	    delete O[key];
	  } else if (!noTargetGet && O[key]) {
	    simple = true;
	  }

	  if (simple) O[key] = value;else createNonEnumerableProperty$2(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, 'toString', function toString() {
	  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
	});

	var global$6 = global$d;
	var path$1 = global$6;

	var path = path$1;
	var global$5 = global$d;

	var aFunction$3 = function (variable) {
	  return typeof variable == 'function' ? variable : undefined;
	};

	var getBuiltIn$3 = function (namespace, method) {
	  return arguments.length < 2 ? aFunction$3(path[namespace]) || aFunction$3(global$5[namespace]) : path[namespace] && path[namespace][method] || global$5[namespace] && global$5[namespace][method];
	};

	var objectGetOwnPropertyNames = {};

	var ceil = Math.ceil;
	var floor$1 = Math.floor; // `ToInteger` abstract operation
	// https://tc39.es/ecma262/#sec-tointeger

	var toInteger$4 = function (argument) {
	  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil)(argument);
	};

	var toInteger$3 = toInteger$4;
	var min$3 = Math.min; // `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength

	var toLength$7 = function (argument) {
	  return argument > 0 ? min$3(toInteger$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	var toInteger$2 = toInteger$4;
	var max$2 = Math.max;
	var min$2 = Math.min; // Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

	var toAbsoluteIndex$2 = function (index, length) {
	  var integer = toInteger$2(index);
	  return integer < 0 ? max$2(integer + length, 0) : min$2(integer, length);
	};

	var toIndexedObject$3 = toIndexedObject$5;
	var toLength$6 = toLength$7;
	var toAbsoluteIndex$1 = toAbsoluteIndex$2; // `Array.prototype.{ indexOf, includes }` methods implementation

	var createMethod$3 = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject$3($this);
	    var length = toLength$6(O.length);
	    var index = toAbsoluteIndex$1(fromIndex, length);
	    var value; // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check

	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

	      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};

	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod$3(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod$3(false)
	};

	var has$3 = has$7;
	var toIndexedObject$2 = toIndexedObject$5;
	var indexOf = arrayIncludes.indexOf;
	var hiddenKeys$2 = hiddenKeys$4;

	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject$2(object);
	  var i = 0;
	  var result = [];
	  var key;

	  for (key in O) !has$3(hiddenKeys$2, key) && has$3(O, key) && result.push(key); // Don't enum bug & hidden keys


	  while (names.length > i) if (has$3(O, key = names[i++])) {
	    ~indexOf(result, key) || result.push(key);
	  }

	  return result;
	};

	var enumBugKeys$3 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

	var internalObjectKeys$1 = objectKeysInternal;
	var enumBugKeys$2 = enumBugKeys$3;
	var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe

	objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys$1(O, hiddenKeys$1);
	};

	var objectGetOwnPropertySymbols = {};

	objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

	var getBuiltIn$2 = getBuiltIn$3;
	var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
	var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
	var anObject$8 = anObject$a; // all object keys, includes non-enumerable and symbols

	var ownKeys$2 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject$8(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
	};

	var has$2 = has$7;
	var ownKeys$1 = ownKeys$2;
	var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
	var definePropertyModule$3 = objectDefineProperty;

	var copyConstructorProperties$1 = function (target, source) {
	  var keys = ownKeys$1(source);
	  var defineProperty = definePropertyModule$3.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;

	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!has$2(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	  }
	};

	var fails$8 = fails$c;
	var replacement = /#|\.prototype\./;

	var isForced$2 = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails$8(detection) : !!detection;
	};

	var normalize = isForced$2.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};

	var data = isForced$2.data = {};
	var NATIVE = isForced$2.NATIVE = 'N';
	var POLYFILL = isForced$2.POLYFILL = 'P';
	var isForced_1 = isForced$2;

	var global$4 = global$d;
	var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
	var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
	var redefine$3 = redefine$4.exports;
	var setGlobal = setGlobal$3;
	var copyConstructorProperties = copyConstructorProperties$1;
	var isForced$1 = isForced_1;
	/*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/

	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

	  if (GLOBAL) {
	    target = global$4;
	  } else if (STATIC) {
	    target = global$4[TARGET] || setGlobal(TARGET, {});
	  } else {
	    target = (global$4[TARGET] || {}).prototype;
	  }

	  if (target) for (key in source) {
	    sourceProperty = source[key];

	    if (options.noTargetGet) {
	      descriptor = getOwnPropertyDescriptor$1(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];

	    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty === typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    } // add a flag to not completely full polyfills


	    if (options.sham || targetProperty && targetProperty.sham) {
	      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
	    } // extend global


	    redefine$3(target, key, sourceProperty, options);
	  }
	};

	var getBuiltIn$1 = getBuiltIn$3;
	var engineUserAgent = getBuiltIn$1('navigator', 'userAgent') || '';

	var global$3 = global$d;
	var userAgent = engineUserAgent;
	var process = global$3.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8;
	var match, version;

	if (v8) {
	  match = v8.split('.');
	  version = match[0] < 4 ? 1 : match[0] + match[1];
	} else if (userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);

	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = match[1];
	  }
	}

	var engineV8Version = version && +version;

	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION$2 = engineV8Version;
	var fails$7 = fails$c; // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing

	var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$7(function () {
	  return !String(Symbol()) || // Chrome 38 Symbol has incorrect toString conversion
	  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	  !Symbol.sham && V8_VERSION$2 && V8_VERSION$2 < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL$1 = nativeSymbol;
	var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';

	var global$2 = global$d;
	var shared$1 = shared$4.exports;
	var has$1 = has$7;
	var uid = uid$2;
	var NATIVE_SYMBOL = nativeSymbol;
	var USE_SYMBOL_AS_UID = useSymbolAsUid;
	var WellKnownSymbolsStore = shared$1('wks');
	var Symbol$1 = global$2.Symbol;
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

	var wellKnownSymbol$a = function (name) {
	  if (!has$1(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
	    if (NATIVE_SYMBOL && has$1(Symbol$1, name)) {
	      WellKnownSymbolsStore[name] = Symbol$1[name];
	    } else {
	      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
	    }
	  }

	  return WellKnownSymbolsStore[name];
	};

	var internalObjectKeys = objectKeysInternal;
	var enumBugKeys$1 = enumBugKeys$3; // `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe

	var objectKeys$1 = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys$1);
	};

	var DESCRIPTORS$1 = descriptors;
	var definePropertyModule$2 = objectDefineProperty;
	var anObject$7 = anObject$a;
	var objectKeys = objectKeys$1; // `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe

	var objectDefineProperties = DESCRIPTORS$1 ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject$7(O);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;

	  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);

	  return O;
	};

	var getBuiltIn = getBuiltIn$3;
	var html$1 = getBuiltIn('document', 'documentElement');

	var anObject$6 = anObject$a;
	var defineProperties = objectDefineProperties;
	var enumBugKeys = enumBugKeys$3;
	var hiddenKeys = hiddenKeys$4;
	var html = html$1;
	var documentCreateElement = documentCreateElement$1;
	var sharedKey = sharedKey$2;
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');

	var EmptyConstructor = function () {
	  /* empty */
	};

	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak

	  return temp;
	}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	}; // Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug


	var activeXDocument;

	var NullProtoObject = function () {
	  try {
	    /* global ActiveXObject -- old IE */
	    activeXDocument = document.domain && new ActiveXObject('htmlfile');
	  } catch (error) {
	    /* ignore */
	  }

	  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
	  var length = enumBugKeys.length;

	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];

	  return NullProtoObject();
	};

	hiddenKeys[IE_PROTO] = true; // `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create

	var objectCreate = Object.create || function create(O, Properties) {
	  var result;

	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject$6(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();

	  return Properties === undefined ? result : defineProperties(result, Properties);
	};

	var wellKnownSymbol$9 = wellKnownSymbol$a;
	var create$1 = objectCreate;
	var definePropertyModule$1 = objectDefineProperty;
	var UNSCOPABLES = wellKnownSymbol$9('unscopables');
	var ArrayPrototype = Array.prototype; // Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	if (ArrayPrototype[UNSCOPABLES] == undefined) {
	  definePropertyModule$1.f(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create$1(null)
	  });
	} // add a key to Array.prototype[@@unscopables]


	var addToUnscopables$2 = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};

	var $$8 = _export;
	var $includes = arrayIncludes.includes;
	var addToUnscopables$1 = addToUnscopables$2; // `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes

	$$8({
	  target: 'Array',
	  proto: true
	}, {
	  includes: function includes(el
	  /* , fromIndex = 0 */
	  ) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	addToUnscopables$1('includes');

	var isObject$5 = isObject$a;

	var aPossiblePrototype$1 = function (it) {
	  if (!isObject$5(it) && it !== null) {
	    throw TypeError("Can't set " + String(it) + ' as a prototype');
	  }

	  return it;
	};

	/* eslint-disable no-proto -- safe */
	var anObject$5 = anObject$a;
	var aPossiblePrototype = aPossiblePrototype$1; // `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe

	var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;

	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
	    setter.call(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) {
	    /* empty */
	  }

	  return function setPrototypeOf(O, proto) {
	    anObject$5(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);

	var isObject$4 = isObject$a;
	var setPrototypeOf = objectSetPrototypeOf; // makes subclassing work correct for wrapped built-ins

	var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if ( // it can work only with native `setPrototypeOf`
	  setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	  typeof (NewTarget = dummy.constructor) == 'function' && NewTarget !== Wrapper && isObject$4(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};

	var whitespaces$1 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var requireObjectCoercible$4 = requireObjectCoercible$7;
	var whitespaces = whitespaces$1;
	var whitespace = '[' + whitespaces + ']';
	var ltrim = RegExp('^' + whitespace + whitespace + '*');
	var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

	var createMethod$2 = function (TYPE) {
	  return function ($this) {
	    var string = String(requireObjectCoercible$4($this));
	    if (TYPE & 1) string = string.replace(ltrim, '');
	    if (TYPE & 2) string = string.replace(rtrim, '');
	    return string;
	  };
	};

	var stringTrim = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod$2(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod$2(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod$2(3)
	};

	var DESCRIPTORS = descriptors;
	var global$1 = global$d;
	var isForced = isForced_1;
	var redefine$2 = redefine$4.exports;
	var has = has$7;
	var classof$5 = classofRaw$1;
	var inheritIfRequired = inheritIfRequired$1;
	var toPrimitive$1 = toPrimitive$4;
	var fails$6 = fails$c;
	var create = objectCreate;
	var getOwnPropertyNames = objectGetOwnPropertyNames.f;
	var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
	var defineProperty = objectDefineProperty.f;
	var trim = stringTrim.trim;
	var NUMBER = 'Number';
	var NativeNumber = global$1[NUMBER];
	var NumberPrototype = NativeNumber.prototype; // Opera ~12 has broken Object#toString

	var BROKEN_CLASSOF = classof$5(create(NumberPrototype)) == NUMBER; // `ToNumber` abstract operation
	// https://tc39.es/ecma262/#sec-tonumber

	var toNumber = function (argument) {
	  var it = toPrimitive$1(argument, false);
	  var first, third, radix, maxCode, digits, length, index, code;

	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = it.charCodeAt(0);

	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66:
	        case 98:
	          radix = 2;
	          maxCode = 49;
	          break;
	        // fast equal of /^0b[01]+$/i

	        case 79:
	        case 111:
	          radix = 8;
	          maxCode = 55;
	          break;
	        // fast equal of /^0o[0-7]+$/i

	        default:
	          return +it;
	      }

	      digits = it.slice(2);
	      length = digits.length;

	      for (index = 0; index < length; index++) {
	        code = digits.charCodeAt(index); // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols

	        if (code < 48 || code > maxCode) return NaN;
	      }

	      return parseInt(digits, radix);
	    }
	  }

	  return +it;
	}; // `Number` constructor
	// https://tc39.es/ecma262/#sec-number-constructor


	if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
	  var NumberWrapper = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var dummy = this;
	    return dummy instanceof NumberWrapper // check on 1..constructor(foo) case
	    && (BROKEN_CLASSOF ? fails$6(function () {
	      NumberPrototype.valueOf.call(dummy);
	    }) : classof$5(dummy) != NUMBER) ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
	  };

	  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : ( // ES3:
	  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
	  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' + // ESNext
	  'fromString,range').split(','), j = 0, key; keys.length > j; j++) {
	    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
	      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
	    }
	  }

	  NumberWrapper.prototype = NumberPrototype;
	  NumberPrototype.constructor = NumberWrapper;
	  redefine$2(global$1, NUMBER, NumberWrapper);
	}

	var aFunction$2 = function (it) {
	  if (typeof it != 'function') {
	    throw TypeError(String(it) + ' is not a function');
	  }

	  return it;
	};

	var aFunction$1 = aFunction$2; // optional / simple context binding

	var functionBindContext = function (fn, that, length) {
	  aFunction$1(fn);
	  if (that === undefined) return fn;

	  switch (length) {
	    case 0:
	      return function () {
	        return fn.call(that);
	      };

	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };

	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };

	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }

	  return function ()
	  /* ...args */
	  {
	    return fn.apply(that, arguments);
	  };
	};

	var classof$4 = classofRaw$1; // `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe

	var isArray$3 = Array.isArray || function isArray(arg) {
	  return classof$4(arg) == 'Array';
	};

	var isObject$3 = isObject$a;
	var isArray$2 = isArray$3;
	var wellKnownSymbol$8 = wellKnownSymbol$a;
	var SPECIES$4 = wellKnownSymbol$8('species'); // `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate

	var arraySpeciesCreate$2 = function (originalArray, length) {
	  var C;

	  if (isArray$2(originalArray)) {
	    C = originalArray.constructor; // cross-realm fallback

	    if (typeof C == 'function' && (C === Array || isArray$2(C.prototype))) C = undefined;else if (isObject$3(C)) {
	      C = C[SPECIES$4];
	      if (C === null) C = undefined;
	    }
	  }

	  return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
	};

	var bind = functionBindContext;
	var IndexedObject$1 = indexedObject;
	var toObject$3 = toObject$5;
	var toLength$5 = toLength$7;
	var arraySpeciesCreate$1 = arraySpeciesCreate$2;
	var push = [].push; // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation

	var createMethod$1 = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_OUT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject$3($this);
	    var self = IndexedObject$1(O);
	    var boundFunction = bind(callbackfn, that, 3);
	    var length = toLength$5(self.length);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate$1;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
	    var value, result;

	    for (; length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);

	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	            case 3:
	              return true;
	            // some

	            case 5:
	              return value;
	            // find

	            case 6:
	              return index;
	            // findIndex

	            case 2:
	              push.call(target, value);
	            // filter
	          } else switch (TYPE) {
	            case 4:
	              return false;
	            // every

	            case 7:
	              push.call(target, value);
	            // filterOut
	          }
	      }
	    }

	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	var arrayIteration = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod$1(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod$1(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod$1(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod$1(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod$1(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod$1(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod$1(6),
	  // `Array.prototype.filterOut` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterOut: createMethod$1(7)
	};

	var fails$5 = fails$c;
	var wellKnownSymbol$7 = wellKnownSymbol$a;
	var V8_VERSION$1 = engineV8Version;
	var SPECIES$3 = wellKnownSymbol$7('species');

	var arrayMethodHasSpeciesSupport$3 = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION$1 >= 51 || !fails$5(function () {
	    var array = [];
	    var constructor = array.constructor = {};

	    constructor[SPECIES$3] = function () {
	      return {
	        foo: 1
	      };
	    };

	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};

	var $$7 = _export;
	var $filter = arrayIteration.filter;
	var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$3;
	var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$2('filter'); // `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species

	$$7({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT$1
	}, {
	  filter: function filter(callbackfn
	  /* , thisArg */
	  ) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var $$6 = _export;
	var $findIndex = arrayIteration.findIndex;
	var addToUnscopables = addToUnscopables$2;
	var FIND_INDEX = 'findIndex';
	var SKIPS_HOLES = true; // Shouldn't skip holes

	if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () {
	  SKIPS_HOLES = false;
	}); // `Array.prototype.findIndex` method
	// https://tc39.es/ecma262/#sec-array.prototype.findindex

	$$6({
	  target: 'Array',
	  proto: true,
	  forced: SKIPS_HOLES
	}, {
	  findIndex: function findIndex(callbackfn
	  /* , that = undefined */
	  ) {
	    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	addToUnscopables(FIND_INDEX);

	var $$5 = _export; // `Number.isNaN` method
	// https://tc39.es/ecma262/#sec-number.isnan

	$$5({
	  target: 'Number',
	  stat: true
	}, {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare -- NaN check
	    return number != number;
	  }
	});

	var toPrimitive = toPrimitive$4;
	var definePropertyModule = objectDefineProperty;
	var createPropertyDescriptor = createPropertyDescriptor$3;

	var createProperty$2 = function (object, key, value) {
	  var propertyKey = toPrimitive(key);
	  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
	};

	var $$4 = _export;
	var fails$4 = fails$c;
	var isArray$1 = isArray$3;
	var isObject$2 = isObject$a;
	var toObject$2 = toObject$5;
	var toLength$4 = toLength$7;
	var createProperty$1 = createProperty$2;
	var arraySpeciesCreate = arraySpeciesCreate$2;
	var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$3;
	var wellKnownSymbol$6 = wellKnownSymbol$a;
	var V8_VERSION = engineV8Version;
	var IS_CONCAT_SPREADABLE = wellKnownSymbol$6('isConcatSpreadable');
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
	var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'; // We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679

	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$4(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$1('concat');

	var isConcatSpreadable = function (O) {
	  if (!isObject$2(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray$1(O);
	};

	var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species

	$$4({
	  target: 'Array',
	  proto: true,
	  forced: FORCED
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject$2(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;

	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];

	      if (isConcatSpreadable(E)) {
	        len = toLength$4(E.length);
	        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

	        for (k = 0; k < len; k++, n++) if (k in E) createProperty$1(A, n, E[k]);
	      } else {
	        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
	        createProperty$1(A, n++, E);
	      }
	    }

	    A.length = n;
	    return A;
	  }
	});

	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);

	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }

	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var $$3 = _export;
	var isObject$1 = isObject$a;
	var isArray = isArray$3;
	var toAbsoluteIndex = toAbsoluteIndex$2;
	var toLength$3 = toLength$7;
	var toIndexedObject$1 = toIndexedObject$5;
	var createProperty = createProperty$2;
	var wellKnownSymbol$5 = wellKnownSymbol$a;
	var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$3;
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
	var SPECIES$2 = wellKnownSymbol$5('species');
	var nativeSlice = [].slice;
	var max$1 = Math.max; // `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects

	$$3({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT
	}, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject$1(this);
	    var length = toLength$3(O.length);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

	    var Constructor, result, n;

	    if (isArray(O)) {
	      Constructor = O.constructor; // cross-realm fallback

	      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject$1(Constructor)) {
	        Constructor = Constructor[SPECIES$2];
	        if (Constructor === null) Constructor = undefined;
	      }

	      if (Constructor === Array || Constructor === undefined) {
	        return nativeSlice.call(O, k, fin);
	      }
	    }

	    result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));

	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);

	    result.length = n;
	    return result;
	  }
	});

	var Language = /*#__PURE__*/function () {
	  // eslint-disable-next-line max-params
	  function Language(language, months, monthsAbbr, days) {
	    var rtl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    var ymd = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	    var yearSuffix = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';

	    _classCallCheck(this, Language);

	    this.language = language;
	    this.months = months;
	    this.monthsAbbr = monthsAbbr;
	    this.days = days;
	    this.rtl = rtl;
	    this.ymd = ymd;
	    this.yearSuffix = yearSuffix;
	  }
	  /* eslint-disable no-underscore-dangle */


	  _createClass(Language, [{
	    key: "language",
	    get: function get() {
	      return this._language;
	    },
	    set: function set(language) {
	      if (typeof language !== 'string') {
	        throw new TypeError('Language must be a string');
	      }

	      this._language = language;
	    }
	  }, {
	    key: "months",
	    get: function get() {
	      return this._months;
	    },
	    set: function set(months) {
	      if (months.length !== 12) {
	        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
	      }

	      this._months = months;
	    }
	  }, {
	    key: "monthsAbbr",
	    get: function get() {
	      return this._monthsAbbr;
	    },
	    set: function set(monthsAbbr) {
	      if (monthsAbbr.length !== 12) {
	        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
	      }

	      this._monthsAbbr = monthsAbbr;
	    }
	  }, {
	    key: "days",
	    get: function get() {
	      return this._days;
	    },
	    set: function set(days) {
	      if (days.length !== 7) {
	        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
	      }

	      this._days = days;
	    }
	  }, {
	    key: "getDaysStartingOn",
	    value: function getDaysStartingOn(firstDayOfWeek) {
	      var firstDays = this._days.slice(firstDayOfWeek);

	      var lastDays = this._days.slice(0, firstDayOfWeek);

	      return firstDays.concat(lastDays);
	    }
	  }, {
	    key: "getMonthByAbbrName",
	    value: function getMonthByAbbrName(name) {
	      var monthValue = this._monthsAbbr.findIndex(function (month) {
	        return month === name;
	      }) + 1;
	      return monthValue < 10 ? "0".concat(monthValue) : "".concat(monthValue);
	    }
	  }, {
	    key: "getMonthByName",
	    value: function getMonthByName(name) {
	      var monthValue = this._months.findIndex(function (month) {
	        return month === name;
	      }) + 1;
	      return monthValue < 10 ? "0".concat(monthValue) : "".concat(monthValue);
	    }
	  }]);

	  return Language;
	}();

	var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']);

	var calendarSlots = ['beforeCalendarHeaderDay', 'calendarFooterDay', 'beforeCalendarHeaderMonth', 'calendarFooterMonth', 'beforeCalendarHeaderYear', 'calendarFooterYear', 'nextIntervalBtn', 'prevIntervalBtn'];

	var fails$3 = fails$c;

	var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails$3(function () {
	    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
	    method.call(null, argument || function () {
	      throw 1;
	    }, 1);
	  });
	};

	var $$2 = _export;
	var IndexedObject = indexedObject;
	var toIndexedObject = toIndexedObject$5;
	var arrayMethodIsStrict = arrayMethodIsStrict$1;
	var nativeJoin = [].join;
	var ES3_STRINGS = IndexedObject != Object;
	var STRICT_METHOD = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
	// https://tc39.es/ecma262/#sec-array.prototype.join

	$$2({
	  target: 'Array',
	  proto: true,
	  forced: ES3_STRINGS || !STRICT_METHOD
	}, {
	  join: function join(separator) {
	    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
	  }
	});

	var anObject$4 = anObject$a; // `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags

	var regexpFlags$1 = function () {
	  var that = anObject$4(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};

	var regexpStickyHelpers = {};

	var fails$2 = fails$c; // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
	// so we use an intermediate function.

	function RE(s, f) {
	  return RegExp(s, f);
	}

	regexpStickyHelpers.UNSUPPORTED_Y = fails$2(function () {
	  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	  var re = RE('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') != null;
	});
	regexpStickyHelpers.BROKEN_CARET = fails$2(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = RE('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') != null;
	});

	/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */

	/* eslint-disable regexp/no-useless-quantifier -- testing */


	var regexpFlags = regexpFlags$1;
	var stickyHelpers$1 = regexpStickyHelpers;
	var shared = shared$4.exports;
	var nativeExec = RegExp.prototype.exec;
	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var patchedExec = nativeExec;

	var UPDATES_LAST_INDEX_WRONG = function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	}();

	var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y || stickyHelpers$1.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1;

	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	    var sticky = UNSUPPORTED_Y$1 && re.sticky;
	    var flags = regexpFlags.call(re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;

	    if (sticky) {
	      flags = flags.replace('y', '');

	      if (flags.indexOf('g') === -1) {
	        flags += 'g';
	      }

	      strCopy = String(str).slice(re.lastIndex); // Support anchored sticky behavior.

	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      } // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.


	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }

	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
	    match = nativeExec.call(sticky ? reCopy : re, strCopy);

	    if (sticky) {
	      if (match) {
	        match.input = match.input.slice(charsAdded);
	        match[0] = match[0].slice(charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }

	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    return match;
	  };
	}

	var regexpExec$3 = patchedExec;

	var $$1 = _export;
	var exec = regexpExec$3; // `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec

	$$1({
	  target: 'RegExp',
	  proto: true,
	  forced: /./.exec !== exec
	}, {
	  exec: exec
	});

	var redefine$1 = redefine$4.exports;
	var regexpExec$2 = regexpExec$3;
	var fails$1 = fails$c;
	var wellKnownSymbol$4 = wellKnownSymbol$a;
	var createNonEnumerableProperty = createNonEnumerableProperty$5;
	var SPECIES$1 = wellKnownSymbol$4('species');
	var RegExpPrototype = RegExp.prototype;
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$1(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;

	  re.exec = function () {
	    var result = [];
	    result.groups = {
	      a: '7'
	    };
	    return result;
	  };

	  return ''.replace(re, '$<a>') !== '7';
	}); // IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0

	var REPLACE_KEEPS_$0 = function () {
	  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
	  return 'a'.replace(/./, '$0') === '$0';
	}();

	var REPLACE = wellKnownSymbol$4('replace'); // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string

	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }

	  return false;
	}(); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper


	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$1(function () {
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  var re = /(?:)/;
	  var originalExec = re.exec;

	  re.exec = function () {
	    return originalExec.apply(this, arguments);
	  };

	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	});

	var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
	  var SYMBOL = wellKnownSymbol$4(KEY);
	  var DELEGATES_TO_SYMBOL = !fails$1(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};

	    O[SYMBOL] = function () {
	      return 7;
	    };

	    return ''[KEY](O) != 7;
	  });
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;

	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.

	      re.constructor = {};

	      re.constructor[SPECIES$1] = function () {
	        return re;
	      };

	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }

	    re.exec = function () {
	      execCalled = true;
	      return null;
	    };

	    re[SYMBOL]('');
	    return !execCalled;
	  });

	  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !(REPLACE_SUPPORTS_NAMED_GROUPS && REPLACE_KEEPS_$0 && !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE) || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var $exec = regexp.exec;

	      if ($exec === regexpExec$2 || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return {
	            done: true,
	            value: nativeRegExpMethod.call(regexp, str, arg2)
	          };
	        }

	        return {
	          done: true,
	          value: nativeMethod.call(str, regexp, arg2)
	        };
	      }

	      return {
	        done: false
	      };
	    }, {
	      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
	      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
	    });
	    var stringMethod = methods[0];
	    var regexMethod = methods[1];
	    redefine$1(String.prototype, KEY, stringMethod);
	    redefine$1(RegExpPrototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	    ? function (string, arg) {
	      return regexMethod.call(string, this, arg);
	    } // 21.2.5.6 RegExp.prototype[@@match](string)
	    // 21.2.5.9 RegExp.prototype[@@search](string)
	    : function (string) {
	      return regexMethod.call(string, this);
	    });
	  }

	  if (sham) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
	};

	var toInteger$1 = toInteger$4;
	var requireObjectCoercible$3 = requireObjectCoercible$7; // `String.prototype.{ codePointAt, at }` methods implementation

	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = String(requireObjectCoercible$3($this));
	    var position = toInteger$1(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = S.charCodeAt(position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	var stringMultibyte = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};

	var charAt = stringMultibyte.charAt; // `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex

	var advanceStringIndex$3 = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};

	var classof$3 = classofRaw$1;
	var regexpExec$1 = regexpExec$3; // `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec

	var regexpExecAbstract = function (R, S) {
	  var exec = R.exec;

	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);

	    if (typeof result !== 'object') {
	      throw TypeError('RegExp exec method returned something other than an Object or null');
	    }

	    return result;
	  }

	  if (classof$3(R) !== 'RegExp') {
	    throw TypeError('RegExp#exec called on incompatible receiver');
	  }

	  return regexpExec$1.call(R, S);
	};

	var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
	var anObject$3 = anObject$a;
	var toLength$2 = toLength$7;
	var requireObjectCoercible$2 = requireObjectCoercible$7;
	var advanceStringIndex$2 = advanceStringIndex$3;
	var regExpExec$1 = regexpExecAbstract; // @@match logic

	fixRegExpWellKnownSymbolLogic$2('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
	  return [// `String.prototype.match` method
	  // https://tc39.es/ecma262/#sec-string.prototype.match
	  function match(regexp) {
	    var O = requireObjectCoercible$2(this);
	    var matcher = regexp == undefined ? undefined : regexp[MATCH];
	    return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, // `RegExp.prototype[@@match]` method
	  // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
	  function (regexp) {
	    var res = maybeCallNative(nativeMatch, regexp, this);
	    if (res.done) return res.value;
	    var rx = anObject$3(regexp);
	    var S = String(this);
	    if (!rx.global) return regExpExec$1(rx, S);
	    var fullUnicode = rx.unicode;
	    rx.lastIndex = 0;
	    var A = [];
	    var n = 0;
	    var result;

	    while ((result = regExpExec$1(rx, S)) !== null) {
	      var matchStr = String(result[0]);
	      A[n] = matchStr;
	      if (matchStr === '') rx.lastIndex = advanceStringIndex$2(S, toLength$2(rx.lastIndex), fullUnicode);
	      n++;
	    }

	    return n === 0 ? null : A;
	  }];
	});

	var isObject = isObject$a;
	var classof$2 = classofRaw$1;
	var wellKnownSymbol$3 = wellKnownSymbol$a;
	var MATCH = wellKnownSymbol$3('match'); // `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp

	var isRegexp = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
	};

	var anObject$2 = anObject$a;
	var aFunction = aFunction$2;
	var wellKnownSymbol$2 = wellKnownSymbol$a;
	var SPECIES = wellKnownSymbol$2('species'); // `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor

	var speciesConstructor$1 = function (O, defaultConstructor) {
	  var C = anObject$2(O).constructor;
	  var S;
	  return C === undefined || (S = anObject$2(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
	};

	var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
	var isRegExp = isRegexp;
	var anObject$1 = anObject$a;
	var requireObjectCoercible$1 = requireObjectCoercible$7;
	var speciesConstructor = speciesConstructor$1;
	var advanceStringIndex$1 = advanceStringIndex$3;
	var toLength$1 = toLength$7;
	var callRegExpExec = regexpExecAbstract;
	var regexpExec = regexpExec$3;
	var stickyHelpers = regexpStickyHelpers;
	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	var arrayPush = [].push;
	var min$1 = Math.min;
	var MAX_UINT32 = 0xFFFFFFFF; // @@split logic

	fixRegExpWellKnownSymbolLogic$1('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit;

	  if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
	  '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(requireObjectCoercible$1(this));
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

	      if (!isRegExp(separator)) {
	        return nativeSplit.call(string, separator, lim);
	      }

	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;

	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy.lastIndex;

	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
	          lastLength = match[0].length;
	          lastLastIndex = lastIndex;
	          if (output.length >= lim) break;
	        }

	        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
	      }

	      if (lastLastIndex === string.length) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));

	      return output.length > lim ? output.slice(0, lim) : output;
	    }; // Chakra, V8

	  } else if ('0'.split(undefined, 0).length) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
	    };
	  } else internalSplit = nativeSplit;

	  return [// `String.prototype.split` method
	  // https://tc39.es/ecma262/#sec-string.prototype.split
	  function split(separator, limit) {
	    var O = requireObjectCoercible$1(this);
	    var splitter = separator == undefined ? undefined : separator[SPLIT];
	    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
	  }, // `RegExp.prototype[@@split]` method
	  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	  //
	  // NOTE: This cannot be properly polyfilled in engines that don't support
	  // the 'y' flag.
	  function (regexp, limit) {
	    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
	    if (res.done) return res.value;
	    var rx = anObject$1(regexp);
	    var S = String(this);
	    var C = speciesConstructor(rx, RegExp);
	    var unicodeMatching = rx.unicode;
	    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y'); // ^(? + rx + ) is needed, in combination with some S slicing, to
	    // simulate the 'y' flag.

	    var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
	    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	    if (lim === 0) return [];
	    if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	    var p = 0;
	    var q = 0;
	    var A = [];

	    while (q < S.length) {
	      splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
	      var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
	      var e;

	      if (z === null || (e = min$1(toLength$1(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
	        q = advanceStringIndex$1(S, q, unicodeMatching);
	      } else {
	        A.push(S.slice(p, q));
	        if (A.length === lim) return A;

	        for (var i = 1; i <= z.length - 1; i++) {
	          A.push(z[i]);
	          if (A.length === lim) return A;
	        }

	        q = p = e;
	      }
	    }

	    A.push(S.slice(p));
	    return A;
	  }];
	}, UNSUPPORTED_Y);

	var toObject$1 = toObject$5;
	var floor = Math.floor;
	var replace = ''.replace;
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g; // https://tc39.es/ecma262/#sec-getsubstitution

	var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject$1(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }

	  return replace.call(replacement, symbols, function (match, ch) {
	    var capture;

	    switch (ch.charAt(0)) {
	      case '$':
	        return '$';

	      case '&':
	        return matched;

	      case '`':
	        return str.slice(0, position);

	      case "'":
	        return str.slice(tailPos);

	      case '<':
	        capture = namedCaptures[ch.slice(1, -1)];
	        break;

	      default:
	        // \d\d?
	        var n = +ch;
	        if (n === 0) return match;

	        if (n > m) {
	          var f = floor(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	          return match;
	        }

	        capture = captures[n - 1];
	    }

	    return capture === undefined ? '' : capture;
	  });
	};

	var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
	var anObject = anObject$a;
	var toLength = toLength$7;
	var toInteger = toInteger$4;
	var requireObjectCoercible = requireObjectCoercible$7;
	var advanceStringIndex = advanceStringIndex$3;
	var getSubstitution = getSubstitution$1;
	var regExpExec = regexpExecAbstract;
	var max = Math.max;
	var min = Math.min;

	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	}; // @@replace logic


	fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
	  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
	  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
	  return [// `String.prototype.replace` method
	  // https://tc39.es/ecma262/#sec-string.prototype.replace
	  function replace(searchValue, replaceValue) {
	    var O = requireObjectCoercible(this);
	    var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return replacer !== undefined ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
	  }, // `RegExp.prototype[@@replace]` method
	  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	  function (regexp, replaceValue) {
	    if (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0 || typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1) {
	      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	    }

	    var rx = anObject(regexp);
	    var S = String(this);
	    var functionalReplace = typeof replaceValue === 'function';
	    if (!functionalReplace) replaceValue = String(replaceValue);
	    var global = rx.global;

	    if (global) {
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	    }

	    var results = [];

	    while (true) {
	      var result = regExpExec(rx, S);
	      if (result === null) break;
	      results.push(result);
	      if (!global) break;
	      var matchStr = String(result[0]);
	      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	    }

	    var accumulatedResult = '';
	    var nextSourcePosition = 0;

	    for (var i = 0; i < results.length; i++) {
	      result = results[i];
	      var matched = String(result[0]);
	      var position = max(min(toInteger(result.index), S.length), 0);
	      var captures = []; // NOTE: This is equivalent to
	      //   captures = result.slice(1).map(maybeToString)
	      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

	      for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));

	      var namedCaptures = result.groups;

	      if (functionalReplace) {
	        var replacerArgs = [matched].concat(captures, position, S);
	        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	        var replacement = String(replaceValue.apply(undefined, replacerArgs));
	      } else {
	        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	      }

	      if (position >= nextSourcePosition) {
	        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	        nextSourcePosition = position + matched.length;
	      }
	    }

	    return accumulatedResult + S.slice(nextSourcePosition);
	  }];
	});

	var wellKnownSymbol$1 = wellKnownSymbol$a;
	var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
	var test = {};
	test[TO_STRING_TAG$1] = 'z';
	var toStringTagSupport = String(test) === '[object z]';

	var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
	var classofRaw = classofRaw$1;
	var wellKnownSymbol = wellKnownSymbol$a;
	var TO_STRING_TAG = wellKnownSymbol('toStringTag'); // ES3 wrong here

	var CORRECT_ARGUMENTS = classofRaw(function () {
	  return arguments;
	}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) {
	    /* empty */
	  }
	}; // getting tag from ES6+ `Object.prototype.toString`


	var classof$1 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
	  : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag // builtinTag case
	  : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
	  : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
	};

	var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
	var classof = classof$1; // `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring

	var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};

	var TO_STRING_TAG_SUPPORT = toStringTagSupport;
	var redefine = redefine$4.exports;
	var toString = objectToString; // `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring

	if (!TO_STRING_TAG_SUPPORT) {
	  redefine(Object.prototype, 'toString', toString, {
	    unsafe: true
	  });
	}

	var getParsedDate = function getParsedDate(_ref) {
	  var formatStr = _ref.formatStr,
	      dateStr = _ref.dateStr,
	      translation = _ref.translation;
	  var splitter = formatStr.match(/-|\/|\s|\./) || ['-'];
	  var df = formatStr.split(splitter[0]);
	  var ds = dateStr.split(splitter[0]);
	  var ymd = [new Date().getFullYear(), '01', '01'];

	  for (var i = 0; i < df.length; i += 1) {
	    if (/yyyy/i.test(df[i])) {
	      ymd[0] = ds[i];
	    } else if (/mmmm/i.test(df[i])) {
	      ymd[1] = translation.getMonthByName(ds[i]);
	    } else if (/mmm/i.test(df[i])) {
	      ymd[1] = translation.getMonthByAbbrName(ds[i]);
	    } else if (/mm/i.test(df[i])) {
	      ymd[1] = ds[i];
	    } else if (/m/i.test(df[i])) {
	      ymd[1] = ds[i];
	    } else if (/dd/i.test(df[i])) {
	      ymd[2] = ds[i];
	    } else if (/d/i.test(df[i])) {
	      var tmp = ds[i].replace(/st|rd|nd|th/g, '');
	      ymd[2] = tmp < 10 ? "0".concat(tmp) : "".concat(tmp);
	    }
	  }

	  return ymd;
	};

	var utils = {
	  /**
	   * @type {Boolean}
	   */
	  useUtc: false,

	  /**
	   * Returns the full year, using UTC or not
	   * @param {Date} date
	   */
	  getFullYear: function getFullYear(date) {
	    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
	  },

	  /**
	   * Returns the month, using UTC or not
	   * @param {Date} date
	   */
	  getMonth: function getMonth(date) {
	    return this.useUtc ? date.getUTCMonth() : date.getMonth();
	  },

	  /**
	   * Returns the number of days in the month, using UTC or not
	   * @param {Date} date
	   */
	  getDaysInMonth: function getDaysInMonth(date) {
	    return this.daysInMonth(this.getFullYear(date), this.getMonth(date));
	  },

	  /**
	   * Returns the date, using UTC or not
	   * @param {Date} date
	   */
	  getDate: function getDate(date) {
	    return this.useUtc ? date.getUTCDate() : date.getDate();
	  },

	  /**
	   * Returns the day, using UTC or not
	   * @param {Date} date
	   */
	  getDay: function getDay(date) {
	    return this.useUtc ? date.getUTCDay() : date.getDay();
	  },

	  /**
	   * Returns the hours, using UTC or not
	   * @param {Date} date
	   */
	  getHours: function getHours(date) {
	    return this.useUtc ? date.getUTCHours() : date.getHours();
	  },

	  /**
	   * Returns the minutes, using UTC or not
	   * @param {Date} date
	   */
	  getMinutes: function getMinutes(date) {
	    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
	  },

	  /**
	   * Sets the full year, using UTC or not
	   * @param {Date} date
	   * @param {String, Number} value
	   */
	  setFullYear: function setFullYear(date, value) {
	    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
	  },

	  /**
	   * Sets the month, using UTC or not
	   * @param {Date} date
	   * @param {String, Number} value
	   */
	  setMonth: function setMonth(date, value) {
	    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
	  },

	  /**
	   * Sets the date, using UTC or not
	   * @param {Date} date
	   * @param {String, Number} value
	   */
	  setDate: function setDate(date, value) {
	    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
	  },

	  /**
	   * Check if date1 is equivalent to date2, without comparing the time
	   * @see https://stackoverflow.com/a/6202196/4455925
	   * @param {Date} date1
	   * @param {Date} date2
	   */
	  compareDates: function compareDates(date1, date2) {
	    var d1 = new Date(date1.valueOf());
	    var d2 = new Date(date2.valueOf());
	    this.resetDateTime(d1);
	    this.resetDateTime(d2);
	    return d1.valueOf() === d2.valueOf();
	  },

	  /**
	   * Validates a date object
	   * @param {Date} date - an object instantiated with the new Date constructor
	   * @return {Boolean}
	   */
	  isValidDate: function isValidDate(date) {
	    if (Object.prototype.toString.call(date) !== '[object Date]') {
	      return false;
	    }

	    return !Number.isNaN(date.valueOf());
	  },

	  /**
	   * Return abbreviated week day name
	   * @param {Date} date
	   * @param {Array} days
	   * @return {String}
	   */
	  getDayNameAbbr: function getDayNameAbbr(date, days) {
	    if (_typeof(date) !== 'object') {
	      throw TypeError('Invalid Type');
	    }

	    return days[this.getDay(date)];
	  },

	  /**
	   * Return day number from abbreviated week day name
	   * @param {String} abbr
	   * @return {Number}
	   */
	  getDayFromAbbr: function getDayFromAbbr(abbr) {
	    for (var i = 0; i < en.days.length; i += 1) {
	      if (abbr.toLowerCase() === en.days[i].toLowerCase()) {
	        return i;
	      }
	    }

	    throw TypeError('Invalid week day');
	  },

	  /**
	   * Return name of the month
	   * @param {Number|Date} month
	   * @param {Array} months
	   * @return {String}
	   */
	  getMonthName: function getMonthName(month, months) {
	    if (!months) {
	      throw Error('missing 2nd parameter Months array');
	    }

	    if (_typeof(month) === 'object') {
	      return months[this.getMonth(month)];
	    }

	    if (typeof month === 'number') {
	      return months[month];
	    }

	    throw TypeError('Invalid type');
	  },

	  /**
	   * Return an abbreviated version of the month
	   * @param {Number|Date} month
	   * @param {Array} monthsAbbr
	   * @return {String}
	   */
	  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
	    if (!monthsAbbr) {
	      throw Error('missing 2nd paramter Months array');
	    }

	    if (_typeof(month) === 'object') {
	      return monthsAbbr[this.getMonth(month)];
	    }

	    if (typeof month === 'number') {
	      return monthsAbbr[month];
	    }

	    throw TypeError('Invalid type');
	  },

	  /**
	   * Alternative get total number of days in month
	   * @param {Number} year
	   * @param {Number} month
	   * @return {Number}
	   */
	  // eslint-disable-next-line complexity
	  daysInMonth: function daysInMonth(year, month) {
	    if (/8|3|5|10/.test(month)) {
	      return 30;
	    }

	    if (month === 1) {
	      return !(year % 4) && year % 100 || !(year % 400) ? 29 : 28;
	    }

	    return 31;
	  },

	  /**
	   * Get nth suffix for date
	   * @param {Number} day
	   * @return {String}
	   */
	  // eslint-disable-next-line complexity
	  getNthSuffix: function getNthSuffix(day) {
	    switch (day) {
	      case 1:
	      case 21:
	      case 31:
	        return 'st';

	      case 2:
	      case 22:
	        return 'nd';

	      case 3:
	      case 23:
	        return 'rd';

	      default:
	        return 'th';
	    }
	  },

	  /**
	   * Formats date object
	   * @param {Date} date
	   * @param {String} formatStr
	   * @param {Object} translation
	   * @return {String}
	   */
	  formatDate: function formatDate(date, formatStr) {
	    var translation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : en;
	    var year = this.getFullYear(date);
	    var month = this.getMonth(date) + 1;
	    var day = this.getDate(date);
	    var matches = {
	      dd: "0".concat(day).slice(-2),
	      d: day,
	      yyyy: year,
	      yy: String(year).slice(2),
	      MMMM: this.getMonthName(this.getMonth(date), translation.months),
	      MMM: this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr),
	      MM: "0".concat(month).slice(-2),
	      M: month,
	      o: this.getNthSuffix(this.getDate(date)),
	      E: this.getDayNameAbbr(date, translation.days)
	    };
	    var REGEX_FORMAT = /y{4}|y{2}|M{1,4}(?![aäe])|d{1,2}|o{1}|E{1}(?![eéi])/g;
	    return formatStr.replace(REGEX_FORMAT, function (match) {
	      return matches[match] || match;
	    });
	  },

	  /**
	   * makes date parseable
	   * to use with international dates
	   * @param {String} dateStr
	   * @param {String|Function} formatStr
	   * @param {Object} translation
	   * @param {Function} parser
	   * @return {Date | String}
	   */
	  // eslint-disable-next-line max-params,complexity,max-statements
	  parseDate: function parseDate(dateStr, formatStr) {
	    var translation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : en;
	    var parser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	    if (!(dateStr && formatStr)) {
	      return dateStr;
	    }

	    if (typeof formatStr === 'function') {
	      if (!parser || typeof parser !== 'function') {
	        throw new Error('Parser need to be a function if you are using a custom formatter');
	      }

	      return parser(dateStr);
	    }

	    var ymd = getParsedDate({
	      formatStr: formatStr,
	      dateStr: dateStr,
	      translation: translation
	    });
	    var dat = "".concat(ymd.join('-')).concat(this.getTime());

	    if (Number.isNaN(Date.parse(dat))) {
	      return dateStr;
	    }

	    return dat;
	  },
	  getTime: function getTime() {
	    var time = 'T00:00:00';

	    if (this.useUtc) {
	      return "".concat(time, "Z");
	    }

	    return time;
	  },

	  /**
	   * Creates an array of dates for each day in between two dates.
	   * @param {Date} start
	   * @param {Date} end
	   * @return {Array}
	   */
	  createDateArray: function createDateArray(start, end) {
	    var dates = [];
	    var startTemp = start;

	    while (startTemp <= end) {
	      dates.push(new Date(startTemp));
	      startTemp = this.setDate(new Date(startTemp), this.getDate(new Date(startTemp)) + 1);
	    }

	    return dates;
	  },

	  /**
	   * Remove hours/minutes/seconds/milliseconds from a date object
	   * @param {Date} date
	   * @return {Date}
	   */
	  resetDateTime: function resetDateTime(date) {
	    return new Date(this.useUtc ? date.setUTCHours(0, 0, 0, 0) : date.setHours(0, 0, 0, 0));
	  },

	  /**
	   * Return a new date object with hours/minutes/seconds/milliseconds removed
	   * @return {Date}
	   */
	  getNewDateObject: function getNewDateObject(date) {
	    return date ? this.resetDateTime(new Date(date)) : this.resetDateTime(new Date());
	  }
	};
	var makeDateUtils = (function (useUtc) {
	  return _objectSpread2(_objectSpread2({}, utils), {}, {
	    useUtc: useUtc
	  });
	});

	var script$8 = {
	  props: {
	    autofocus: {
	      type: Boolean,
	      default: false
	    },
	    bootstrapStyling: {
	      type: Boolean,
	      default: false
	    },
	    clearButton: {
	      type: Boolean,
	      default: false
	    },
	    clearButtonIcon: {
	      type: String,
	      default: ''
	    },
	    calendarButton: {
	      type: Boolean,
	      default: false
	    },
	    calendarButtonIcon: {
	      type: String,
	      default: ''
	    },
	    calendarButtonIconContent: {
	      type: String,
	      default: ''
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: [String, Function],
	      default: 'dd MMM yyyy'
	    },
	    id: {
	      type: String,
	      default: null
	    },
	    inline: {
	      type: Boolean,
	      default: false
	    },
	    inputClass: {
	      type: [String, Object, Array],
	      default: null
	    },
	    maxlength: {
	      type: [Number, String],
	      default: null
	    },
	    name: {
	      type: String,
	      default: null
	    },
	    openDate: {
	      type: [String, Date, Number],
	      default: null,
	      validator: function validator(val) {
	        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
	      }
	    },
	    parser: {
	      type: Function,
	      default: null
	    },
	    pattern: {
	      type: String,
	      default: null
	    },
	    placeholder: {
	      type: String,
	      default: null
	    },
	    refName: {
	      type: String,
	      default: ''
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    showCalendarOnButtonClick: {
	      type: Boolean,
	      default: false
	    },
	    showCalendarOnFocus: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: {
	      type: [Number, String],
	      default: null
	    },
	    typeable: {
	      type: Boolean,
	      default: false
	    },
	    useUtc: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

	function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
	    if (typeof shadowMode !== 'boolean') {
	        createInjectorSSR = createInjector;
	        createInjector = shadowMode;
	        shadowMode = false;
	    }
	    // Vue.extend constructor export interop.
	    const options = typeof script === 'function' ? script.options : script;
	    // render functions
	    if (template && template.render) {
	        options.render = template.render;
	        options.staticRenderFns = template.staticRenderFns;
	        options._compiled = true;
	        // functional template
	        if (isFunctionalTemplate) {
	            options.functional = true;
	        }
	    }
	    // scopedId
	    if (scopeId) {
	        options._scopeId = scopeId;
	    }
	    let hook;
	    if (moduleIdentifier) {
	        // server build
	        hook = function (context) {
	            // 2.3 injection
	            context =
	                context || // cached call
	                    (this.$vnode && this.$vnode.ssrContext) || // stateful
	                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
	            // 2.2 with runInNewContext: true
	            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	                context = __VUE_SSR_CONTEXT__;
	            }
	            // inject component styles
	            if (style) {
	                style.call(this, createInjectorSSR(context));
	            }
	            // register component module identifier for async chunk inference
	            if (context && context._registeredComponents) {
	                context._registeredComponents.add(moduleIdentifier);
	            }
	        };
	        // used by ssr in case component is cached and beforeCreate
	        // never gets called
	        options._ssrRegister = hook;
	    }
	    else if (style) {
	        hook = shadowMode
	            ? function (context) {
	                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
	            }
	            : function (context) {
	                style.call(this, createInjector(context));
	            };
	    }
	    if (hook) {
	        if (options.functional) {
	            // register for functional component in vue file
	            const originalRender = options.render;
	            options.render = function renderWithStyleInjection(h, context) {
	                hook.call(context);
	                return originalRender(h, context);
	            };
	        }
	        else {
	            // inject component registration as beforeCreate hook
	            const existing = options.beforeCreate;
	            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
	        }
	    }
	    return script;
	}

	/* script */
	const __vue_script__$8 = script$8;

	/* template */

	  /* style */
	  const __vue_inject_styles__$8 = undefined;
	  /* scoped */
	  const __vue_scope_id__$8 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$8 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$8 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$8,
	    __vue_script__$8,
	    __vue_scope_id__$8,
	    __vue_is_functional_template__$8,
	    __vue_module_identifier__$8,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$7 = {
	  name: 'DateInput',
	  mixins: [__vue_component__$8],
	  props: {
	    isOpen: {
	      type: Boolean,
	      default: false
	    },
	    resetTypedDate: {
	      type: [Date],
	      default: null
	    },
	    selectedDate: {
	      type: Date,
	      default: null
	    },
	    translation: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      input: null,
	      isFocusedUsed: false,
	      isBlurred: false,
	      typedDate: '',
	      utils: makeDateUtils(this.useUtc)
	    };
	  },
	  computed: {
	    computedInputClass: function computedInputClass() {
	      if (this.bootstrapStyling) {
	        if (typeof this.inputClass === 'string') {
	          return [this.inputClass, 'form-control'].join(' ');
	        }

	        return _objectSpread2({
	          'form-control': true
	        }, this.inputClass);
	      }

	      return this.inputClass;
	    },
	    formattedDate: function formattedDate() {
	      return typeof this.format === 'function' ? this.format(new Date(this.selectedDate)) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
	    },
	    formattedValue: function formattedValue() {
	      if (!this.selectedDate) {
	        return null;
	      }

	      if (this.typedDate.length) {
	        return this.typedDate;
	      }

	      return this.formattedDate;
	    }
	  },
	  watch: {
	    resetTypedDate: function resetTypedDate() {
	      this.typedDate = '';
	    }
	  },
	  mounted: function mounted() {
	    this.input = this.$el.querySelector('input');
	  },
	  methods: {
	    /**
	     * emit a clearDate event
	     */
	    clearDate: function clearDate() {
	      this.$emit('clear-date');
	    },

	    /**
	     * submit typedDate and emit a blur event
	     */
	    handleInputBlur: function handleInputBlur() {
	      this.isBlurred = this.isOpen;

	      if (this.typeable) {
	        this.submitTypedDate();
	      }

	      this.$emit('blur');
	      this.$emit('close');
	      this.isFocusedUsed = false;
	    },
	    handleInputClick: function handleInputClick() {
	      var isFocusedUsed = this.showCalendarOnFocus && !this.isFocusedUsed;

	      if (!this.showCalendarOnButtonClick && !isFocusedUsed) {
	        this.toggle();
	      }

	      if (this.showCalendarOnFocus) {
	        this.isFocusedUsed = true;
	      }
	    },
	    handleInputFocus: function handleInputFocus() {
	      if (this.showCalendarOnFocus) {
	        this.$emit('open');
	      }

	      this.isBlurred = false;
	      this.$emit('focus');
	    },
	    handleKeydownEnter: function handleKeydownEnter() {
	      if (this.typeable) {
	        this.submitTypedDate();
	      }

	      this.$emit('close');
	    },
	    parseDate: function parseDate(value) {
	      return this.utils.parseDate(value, this.format, this.translation, this.parser);
	    },

	    /**
	     * Attempt to parse a typed date
	     */
	    parseTypedDate: function parseTypedDate() {
	      if (this.typeable) {
	        var parsableDate = this.parseDate(this.input.value);
	        var parsedDate = Date.parse(parsableDate);

	        if (!Number.isNaN(parsedDate)) {
	          this.typedDate = this.input.value;
	          this.$emit('typed-date', new Date(parsedDate));
	        }
	      }
	    },

	    /**
	     * Submits a typed date if it's valid
	     */
	    submitTypedDate: function submitTypedDate() {
	      var parsableDate = this.parseDate(this.input.value);
	      var parsedDate = Date.parse(parsableDate);

	      if (Number.isNaN(parsedDate)) {
	        this.clearDate();
	      } else {
	        this.input.value = this.formattedDate;
	        this.typedDate = '';
	        this.$emit('typed-date', parsedDate);
	      }
	    },
	    toggle: function toggle() {
	      if (!this.isOpen && this.isBlurred) {
	        this.isBlurred = false;
	        return;
	      }

	      this.$emit(this.isOpen ? 'close' : 'open');
	    }
	  }
	};

	/* script */
	const __vue_script__$7 = script$7;

	/* template */
	var __vue_render__$5 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { class: { "input-group": _vm.bootstrapStyling } },
	    [
	      _vm._t("beforeDateInput"),
	      _vm._v(" "),
	      _vm.calendarButton
	        ? _c(
	            "span",
	            {
	              staticClass: "vdp-datepicker__calendar-button",
	              class: {
	                "input-group-prepend": _vm.bootstrapStyling,
	                "calendar-btn-disabled": _vm.disabled
	              },
	              on: { click: _vm.toggle }
	            },
	            [
	              _c(
	                "span",
	                { class: { "input-group-text": _vm.bootstrapStyling } },
	                [
	                  _vm._t("calendarBtn", [
	                    _c("i", { class: _vm.calendarButtonIcon }, [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.calendarButtonIconContent) +
	                          "\n          "
	                      ),
	                      !_vm.calendarButtonIcon
	                        ? _c("span", [_vm._v("…")])
	                        : _vm._e()
	                    ])
	                  ])
	                ],
	                2
	              )
	            ]
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c("input", {
	        ref: _vm.refName,
	        class: _vm.computedInputClass,
	        attrs: {
	          id: _vm.id,
	          autocomplete: "off",
	          autofocus: _vm.autofocus,
	          "clear-button": _vm.clearButton,
	          disabled: _vm.disabled,
	          maxlength: _vm.maxlength,
	          name: _vm.name,
	          pattern: _vm.pattern,
	          placeholder: _vm.placeholder,
	          readonly: !_vm.typeable,
	          required: _vm.required,
	          tabindex: _vm.tabindex,
	          type: _vm.inline ? "hidden" : null
	        },
	        domProps: { value: _vm.formattedValue },
	        on: {
	          blur: _vm.handleInputBlur,
	          click: _vm.handleInputClick,
	          focus: _vm.handleInputFocus,
	          keydown: [
	            function($event) {
	              if (
	                !$event.type.indexOf("key") &&
	                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	              ) {
	                return null
	              }
	              $event.preventDefault();
	              return _vm.handleKeydownEnter($event)
	            },
	            function($event) {
	              if (
	                !$event.type.indexOf("key") &&
	                _vm._k(
	                  $event.keyCode,
	                  "escape",
	                  undefined,
	                  $event.key,
	                  undefined
	                )
	              ) {
	                return null
	              }
	              $event.preventDefault();
	              return _vm.$emit("close")
	            }
	          ],
	          keyup: _vm.parseTypedDate
	        }
	      }),
	      _vm._v(" "),
	      _vm.clearButton && _vm.selectedDate
	        ? _c(
	            "span",
	            {
	              staticClass: "vdp-datepicker__clear-button",
	              class: { "input-group-append": _vm.bootstrapStyling },
	              on: {
	                click: function($event) {
	                  return _vm.clearDate()
	                }
	              }
	            },
	            [
	              _c(
	                "span",
	                { class: { "input-group-text": _vm.bootstrapStyling } },
	                [
	                  _vm._t("clearBtn", [
	                    _c("i", { class: _vm.clearButtonIcon }, [
	                      !_vm.clearButtonIcon
	                        ? _c("span", [_vm._v("×")])
	                        : _vm._e()
	                    ])
	                  ])
	                ],
	                2
	              )
	            ]
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _vm._t("afterDateInput")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$5 = [];
	__vue_render__$5._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$7 = undefined;
	  /* scoped */
	  const __vue_scope_id__$7 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$7 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$7 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
	    __vue_inject_styles__$7,
	    __vue_script__$7,
	    __vue_scope_id__$7,
	    __vue_is_functional_template__$7,
	    __vue_module_identifier__$7,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var $ = _export;
	var toObject = toObject$5;
	var nativeKeys = objectKeys$1;
	var fails = fails$c;
	var FAILS_ON_PRIMITIVES = fails(function () {
	  nativeKeys(1);
	}); // `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys

	$({
	  target: 'Object',
	  stat: true,
	  forced: FAILS_ON_PRIMITIVES
	}, {
	  keys: function keys(it) {
	    return nativeKeys(toObject(it));
	  }
	});

	var cellUtils = {
	  configExists: function configExists(obj) {
	    return typeof obj !== 'undefined' && Object.keys(obj).length > 0;
	  },
	  isDefined: function isDefined(obj, prop) {
	    return this.configExists(obj) && typeof obj[prop] !== 'undefined';
	  },
	  hasArray: function hasArray(obj, prop) {
	    return this.isDefined(obj, prop) && obj[prop].length > 0;
	  },
	  hasDate: function hasDate(obj, prop) {
	    return this.isDefined(obj, prop) && this.utils.isValidDate(obj[prop]);
	  },
	  dayMonthYear: function dayMonthYear(obj, prop) {
	    var utils = this.utils;
	    var hasDate = this.hasDate(obj, prop);

	    if (!hasDate) {
	      return {
	        day: undefined,
	        month: undefined,
	        year: undefined
	      };
	    }

	    var d = obj[prop];
	    return {
	      day: utils.getDate(d),
	      month: utils.getMonth(d),
	      year: utils.getFullYear(d)
	    };
	  }
	};
	var makeCellUtils = (function (utils) {
	  return _objectSpread2(_objectSpread2({}, cellUtils), {}, {
	    utils: utils
	  });
	});

	var DisabledDate = /*#__PURE__*/function () {
	  function DisabledDate(utils, disabledDates) {
	    _classCallCheck(this, DisabledDate);

	    this._utils = utils;
	    this._disabledDates = disabledDates;
	  }

	  _createClass(DisabledDate, [{
	    key: "config",
	    get: function get() {
	      var disabledDates = this._disabledDates;
	      var utils = makeCellUtils(this._utils);
	      return {
	        exists: utils.configExists(disabledDates),
	        to: utils.dayMonthYear(disabledDates, 'to'),
	        from: utils.dayMonthYear(disabledDates, 'from'),
	        has: {
	          customPredictor: utils.isDefined(disabledDates, 'customPredictor'),
	          daysOfMonth: utils.hasArray(disabledDates, 'daysOfMonth'),
	          daysOfWeek: utils.hasArray(disabledDates, 'days'),
	          from: utils.hasDate(disabledDates, 'from'),
	          ranges: utils.hasArray(disabledDates, 'ranges'),
	          specificDates: utils.hasArray(disabledDates, 'dates'),
	          to: utils.hasDate(disabledDates, 'to')
	        }
	      };
	    }
	  }, {
	    key: "daysInMonth",
	    value: function daysInMonth(date) {
	      var utils = this._utils;
	      var month = utils.getMonth(date);
	      var year = utils.getFullYear(date);
	      return utils.daysInMonth(year, month);
	    }
	  }, {
	    key: "isDateDisabledVia",
	    value: function isDateDisabledVia(date) {
	      var _this = this;

	      var disabledDates = this._disabledDates;
	      var has = this.config.has;
	      return {
	        to: function to() {
	          return has.to && date < disabledDates.to;
	        },
	        from: function from() {
	          return has.from && date > disabledDates.from;
	        },
	        range: function range() {
	          if (!has.ranges) return false;
	          var ranges = disabledDates.ranges;
	          var u = makeCellUtils(_this._utils);
	          return ranges.some(function (thisRange) {
	            var hasFrom = u.isDefined(thisRange, 'from');
	            var hasTo = u.isDefined(thisRange, 'to');
	            return hasFrom && hasTo && date < thisRange.to && date > thisRange.from;
	          });
	        },
	        customPredictor: function customPredictor() {
	          return has.customPredictor && disabledDates.customPredictor(date);
	        },
	        specificDate: function specificDate() {
	          if (!has.specificDates) return false;
	          return disabledDates.dates.some(function (d) {
	            return _this._utils.compareDates(date, d);
	          });
	        },
	        daysOfWeek: function daysOfWeek() {
	          if (!has.daysOfWeek) return false;
	          return disabledDates.days.indexOf(_this._utils.getDay(date)) !== -1;
	        },
	        daysOfMonth: function daysOfMonth() {
	          if (!has.daysOfMonth) return false;
	          return disabledDates.daysOfMonth.indexOf(_this._utils.getDate(date)) !== -1;
	        }
	      };
	    }
	  }, {
	    key: "isMonthDisabledVia",
	    value: function isMonthDisabledVia(date) {
	      var _this$config = this.config,
	          _from = _this$config.from,
	          has = _this$config.has,
	          _to = _this$config.to;

	      var month = this._utils.getMonth(date);

	      var year = this._utils.getFullYear(date);

	      return {
	        to: function to() {
	          var isYearInPast = has.to && year < _to.year;

	          if (isYearInPast) {
	            return true;
	          }

	          return has.to && month < _to.month && year <= _to.year;
	        },
	        from: function from() {
	          var isYearInFuture = has.from && year > _from.year;

	          if (isYearInFuture) {
	            return true;
	          }

	          return has.from && month > _from.month && year >= _from.year;
	        }
	      };
	    }
	  }, {
	    key: "isYearDisabledVia",
	    value: function isYearDisabledVia(date) {
	      var _this$config2 = this.config,
	          _from2 = _this$config2.from,
	          has = _this$config2.has,
	          _to2 = _this$config2.to;

	      var year = this._utils.getFullYear(date);

	      return {
	        to: function to() {
	          return has.to && year < _to2.year;
	        },
	        from: function from() {
	          return has.from && year > _from2.year;
	        }
	      };
	    }
	    /**
	     * Checks if the given date should be disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isDateDisabled",
	    value: function isDateDisabled(date) {
	      if (!this.config.exists) return false;
	      var isDisabledVia = this.isDateDisabledVia(date);
	      return isDisabledVia.to() || isDisabledVia.from() || isDisabledVia.range() || isDisabledVia.specificDate() || isDisabledVia.daysOfWeek() || isDisabledVia.daysOfMonth() || isDisabledVia.customPredictor();
	    }
	    /**
	     * Checks if the given month should be disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isMonthDisabled",
	    value: function isMonthDisabled(date) {
	      var config = this.config;
	      var isDisabledVia = this.isMonthDisabledVia(date);

	      if (!config.exists) {
	        return false;
	      }

	      if (isDisabledVia.to() || isDisabledVia.from()) {
	        return true;
	      } // now we have to check each day of the month


	      for (var i = 1; i <= this.daysInMonth(date); i += 1) {
	        var dayDate = new Date(date);
	        dayDate.setDate(i); // if at least one day of this month is NOT disabled,
	        // we can conclude that this month SHOULD be selectable

	        if (!this.isDateDisabled(dayDate)) {
	          return false;
	        }
	      }

	      return true;
	    }
	    /**
	     * Checks if the given year should be disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isYearDisabled",
	    value: function isYearDisabled(date) {
	      var config = this.config;
	      var isDisabledVia = this.isYearDisabledVia(date);

	      if (!config.exists) {
	        return false;
	      }

	      if (isDisabledVia.to() || isDisabledVia.from()) {
	        return true;
	      } // now we have to check each month of the year


	      for (var i = 0; i < 12; i += 1) {
	        var monthDate = new Date(date);
	        monthDate.setMonth(i); // if at least one month of this year is NOT disabled,
	        // we can conclude that this year SHOULD be selectable

	        if (!this.isMonthDisabled(monthDate)) {
	          return false;
	        }
	      }

	      return true;
	    }
	  }]);

	  return DisabledDate;
	}();

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	var script$6 = {
	  name: 'PickerHeader',
	  props: {
	    isNextDisabled: {
	      type: Boolean,
	      required: true
	    },
	    isPreviousDisabled: {
	      type: Boolean,
	      required: true
	    },
	    isRtl: {
	      type: Boolean,
	      required: true
	    }
	  },
	  computed: {
	    /**
	     * Is the left hand navigation button disabled?
	     * @return {Boolean}
	     */
	    isLeftNavDisabled: function isLeftNavDisabled() {
	      return this.isRtl ? this.isNextDisabled : this.isPreviousDisabled;
	    },

	    /**
	     * Is the right hand navigation button disabled?
	     * @return {Boolean}
	     */
	    isRightNavDisabled: function isRightNavDisabled() {
	      return this.isRtl ? this.isPreviousDisabled : this.isNextDisabled;
	    }
	  }
	};

	/* script */
	const __vue_script__$6 = script$6;

	/* template */
	var __vue_render__$4 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "header",
	    [
	      _c(
	        "span",
	        {
	          staticClass: "prev",
	          class: { disabled: _vm.isLeftNavDisabled },
	          on: {
	            click: function($event) {
	              return _vm.$emit(_vm.isRtl ? "next" : "previous")
	            }
	          }
	        },
	        [
	          _vm._t("prevIntervalBtn", [
	            _c("span", { staticClass: "default" }, [_vm._v("<")])
	          ])
	        ],
	        2
	      ),
	      _vm._v(" "),
	      _vm._t("default"),
	      _vm._v(" "),
	      _c(
	        "span",
	        {
	          staticClass: "next",
	          class: { disabled: _vm.isRightNavDisabled },
	          on: {
	            click: function($event) {
	              return _vm.$emit(_vm.isRtl ? "previous" : "next")
	            }
	          }
	        },
	        [
	          _vm._t("nextIntervalBtn", [
	            _c("span", { staticClass: "default" }, [_vm._v(">")])
	          ])
	        ],
	        2
	      )
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$4 = [];
	__vue_render__$4._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$6 = undefined;
	  /* scoped */
	  const __vue_scope_id__$6 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$6 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$6 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
	    __vue_inject_styles__$6,
	    __vue_script__$6,
	    __vue_scope_id__$6,
	    __vue_is_functional_template__$6,
	    __vue_module_identifier__$6,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$5 = {
	  components: {
	    PickerHeader: __vue_component__$6
	  },
	  inheritAttrs: false,
	  props: {
	    disabledDates: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    isRtl: {
	      type: Boolean,
	      default: false
	    },
	    isUpDisabled: {
	      type: Boolean,
	      default: false
	    },
	    pageDate: {
	      type: Date,
	      default: null
	    },
	    selectedDate: {
	      type: Date,
	      default: null
	    },
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	    translation: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    useUtc: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      utils: makeDateUtils(this.useUtc)
	    };
	  },
	  computed: {
	    /**
	     * A look-up object created from 'disabledDates' prop
	     * @return {Object}
	     */
	    disabledConfig: function disabledConfig() {
	      return new DisabledDate(this.utils, this.disabledDates).config;
	    },

	    /**
	     * Returns the current page's full year as an integer.
	     * @return {Number}
	     */
	    pageYear: function pageYear() {
	      return this.utils.getFullYear(this.pageDate);
	    }
	  },
	  methods: {
	    /**
	     * Changes the page up or down
	     * @param {Number} incrementBy
	     */
	    changePage: function changePage(incrementBy) {
	      var date = this.pageDate;
	      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
	      this.$emit('page-change', date);
	    },

	    /**
	     * Emits a 'select' or 'select-disabled' event
	     * @param {Object} cell
	     */
	    select: function select(cell) {
	      if (cell.isDisabled) {
	        this.$emit('select-disabled', cell);
	      } else {
	        this.$emit('select', cell);
	      }
	    },

	    /**
	     * Increment the current page
	     */
	    nextPage: function nextPage() {
	      if (!this.isNextDisabled) {
	        this.changePage(+1);
	      }
	    },

	    /**
	     * Decrement the page
	     */
	    previousPage: function previousPage() {
	      if (!this.isPreviousDisabled) {
	        this.changePage(-1);
	      }
	    }
	  }
	};

	/* script */
	const __vue_script__$5 = script$5;

	/* template */

	  /* style */
	  const __vue_inject_styles__$5 = undefined;
	  /* scoped */
	  const __vue_scope_id__$5 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$5 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$5 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$5,
	    __vue_script__$5,
	    __vue_scope_id__$5,
	    __vue_is_functional_template__$5,
	    __vue_module_identifier__$5,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var HighlightedDate = /*#__PURE__*/function () {
	  function HighlightedDate(utils, disabledDates, highlighted) {
	    _classCallCheck(this, HighlightedDate);

	    this._utils = utils;
	    this._disabledDates = disabledDates;
	    this._highlighted = highlighted;
	  }

	  _createClass(HighlightedDate, [{
	    key: "config",
	    get: function get() {
	      var highlightedDates = this._highlighted;
	      var utils = makeCellUtils(this._utils);
	      return {
	        exists: utils.configExists(highlightedDates),
	        to: utils.dayMonthYear(highlightedDates, 'to'),
	        from: utils.dayMonthYear(highlightedDates, 'from'),
	        has: {
	          customPredictor: utils.isDefined(highlightedDates, 'customPredictor'),
	          daysOfMonth: utils.hasArray(highlightedDates, 'daysOfMonth'),
	          daysOfWeek: utils.hasArray(highlightedDates, 'days'),
	          from: utils.hasDate(highlightedDates, 'from'),
	          specificDates: utils.hasArray(highlightedDates, 'dates'),
	          to: utils.hasDate(highlightedDates, 'to'),
	          includeDisabled: utils.isDefined(highlightedDates, 'includeDisabled') && highlightedDates.includeDisabled
	        }
	      };
	    }
	  }, {
	    key: "isDateDisabled",
	    value: function isDateDisabled(date) {
	      var utils = this._utils;
	      var disabledDates = this._disabledDates;
	      return new DisabledDate(utils, disabledDates).isDateDisabled(date);
	    }
	  }, {
	    key: "isHighlightingNotPossible",
	    value: function isHighlightingNotPossible(date) {
	      var config = this.config;
	      if (!config.exists) return false;
	      return !config.has.includeDisabled && this.isDateDisabled(date);
	    }
	  }, {
	    key: "isDateHighlightedVia",
	    value: function isDateHighlightedVia(date) {
	      var _this = this;

	      var highlightedDates = this._highlighted;
	      var has = this.config.has;
	      return {
	        to: function to() {
	          return has.to && date <= highlightedDates.to;
	        },
	        from: function from() {
	          return has.from && date >= highlightedDates.from;
	        },
	        customPredictor: function customPredictor() {
	          return has.customPredictor && highlightedDates.customPredictor(date);
	        },
	        specificDate: function specificDate() {
	          if (!has.specificDates) return false;
	          return highlightedDates.dates.some(function (d) {
	            return _this._utils.compareDates(date, d);
	          });
	        },
	        daysOfWeek: function daysOfWeek() {
	          if (!has.daysOfWeek) return false;
	          return highlightedDates.days.indexOf(_this._utils.getDay(date)) !== -1;
	        },
	        daysOfMonth: function daysOfMonth() {
	          if (!has.daysOfMonth) return false;
	          return highlightedDates.daysOfMonth.indexOf(_this._utils.getDate(date)) !== -1;
	        }
	      };
	    } // eslint-disable-next-line complexity,max-statements

	  }, {
	    key: "isDateHighlighted",
	    value: function isDateHighlighted(date) {
	      if (this.isHighlightingNotPossible(date)) return false;
	      var isHighlightedVia = this.isDateHighlightedVia(date);
	      return isHighlightedVia.to() && isHighlightedVia.from() || isHighlightedVia.specificDate() || isHighlightedVia.daysOfWeek() || isHighlightedVia.daysOfMonth() || isHighlightedVia.customPredictor();
	    }
	  }]);

	  return HighlightedDate;
	}();

	var script$4 = {
	  name: 'PickerDay',
	  mixins: [__vue_component__$5],
	  props: {
	    dayCellContent: {
	      type: Function,
	      default: function _default(day) {
	        return day.date;
	      }
	    },
	    highlighted: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    firstDayOfWeek: {
	      type: String,
	      default: 'sun'
	    },
	    showFullMonthName: {
	      type: Boolean,
	      default: false
	    },
	    showEdgeDates: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    /**
	     * Sets an array with all days to show this month
	     * @return {Array}
	     */
	    cells: function cells() {
	      var days = [];
	      var daysInCalendar = this.daysFromPrevMonth + this.daysInMonth + this.daysFromNextMonth;
	      var dObj = this.firstCellDate();

	      for (var i = 0; i < daysInCalendar; i += 1) {
	        days.push(this.makeDay(i, dObj));
	        this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
	      }

	      return days;
	    },

	    /**
	     * Gets the name of the month the current page is on
	     * @return {String}
	     */
	    currMonthName: function currMonthName() {
	      var monthName = this.showFullMonthName ? this.translation.months : this.translation.monthsAbbr;
	      return this.utils.getMonthNameAbbr(this.pageMonth, monthName);
	    },

	    /**
	     * Gets the name of the year that current page is on
	     * @return {String}
	     */
	    currYearName: function currYearName() {
	      var yearSuffix = this.translation.yearSuffix;
	      return "".concat(this.pageYear).concat(yearSuffix);
	    },

	    /**
	     * Returns an array of day names
	     * @return {String[]}
	     */
	    daysOfWeek: function daysOfWeek() {
	      return this.translation.getDaysStartingOn(this.firstDayOfWeekNumber);
	    },

	    /**
	     * Returns the number of days in this month
	     * @return {String[]}
	     */
	    daysInMonth: function daysInMonth() {
	      return this.utils.getDaysInMonth(this.pageDate);
	    },

	    /**
	     * Calculates how many days to show from the previous month
	     * @return {number}
	     */
	    daysFromPrevMonth: function daysFromPrevMonth() {
	      var firstOfMonthDayNumber = this.utils.getDay(this.pageDate);
	      return (7 - this.firstDayOfWeekNumber + firstOfMonthDayNumber) % 7;
	    },

	    /**
	     * Calculates how many days to show from the next month
	     * @return {number}
	     */
	    daysFromNextMonth: function daysFromNextMonth() {
	      var daysThisAndPrevMonth = this.daysFromPrevMonth + this.daysInMonth;
	      return Math.ceil(daysThisAndPrevMonth / 7) * 7 - daysThisAndPrevMonth;
	    },

	    /**
	     * Returns first-day-of-week as a number (Sunday is 0)
	     * @return {Number}
	     */
	    firstDayOfWeekNumber: function firstDayOfWeekNumber() {
	      return this.utils.getDayFromAbbr(this.firstDayOfWeek);
	    },

	    /**
	     * A look-up object created from 'highlighted' prop
	     * @return {Object}
	     */
	    highlightedConfig: function highlightedConfig() {
	      return new HighlightedDate(this.utils, this.disabledDates, this.highlighted).config;
	    },

	    /**
	     * Is the next month disabled?
	     * @return {Boolean}
	     */
	    isNextDisabled: function isNextDisabled() {
	      if (!this.disabledConfig.has.from) {
	        return false;
	      }

	      return this.disabledConfig.from.month <= this.pageMonth && this.disabledConfig.from.year <= this.pageYear;
	    },

	    /**
	     * Is the previous month disabled?
	     * @return {Boolean}
	     */
	    isPreviousDisabled: function isPreviousDisabled() {
	      if (!this.disabledConfig.has.to) {
	        return false;
	      }

	      return this.disabledConfig.to.month >= this.pageMonth && this.disabledConfig.to.year >= this.pageYear;
	    },

	    /**
	     * Returns the current page's month as an integer.
	     * @return {Number}
	     */
	    pageMonth: function pageMonth() {
	      return this.utils.getMonth(this.pageDate);
	    },

	    /**
	     * Display the current page's month & year as the title.
	     * @return {String}
	     */
	    pageTitleDay: function pageTitleDay() {
	      return this.translation.ymd ? "".concat(this.currYearName, " ").concat(this.currMonthName) : "".concat(this.currMonthName, " ").concat(this.currYearName);
	    },

	    /**
	     * The first day of the next page's month.
	     * @return {Date}
	     */
	    firstOfNextMonth: function firstOfNextMonth() {
	      var d = new Date(this.pageDate);
	      return new Date(this.utils.setMonth(d, this.utils.getMonth(d) + 1));
	    }
	  },
	  methods: {
	    /**
	     * Changes the page up or down (overrides changePage in pickerMixin)
	     * @param {Number} incrementBy
	     */
	    changePage: function changePage(incrementBy) {
	      var date = this.pageDate;
	      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
	      this.$emit('page-change', date);
	    },

	    /**
	     * Set the class for a specific day
	     * @param {Object} day
	     * @return {Object}
	     */
	    dayClasses: function dayClasses(day) {
	      return {
	        'selected': day.isSelected,
	        'disabled': day.isDisabled,
	        'highlighted': day.isHighlighted,
	        'muted': day.isPreviousMonth || day.isNextMonth,
	        'today': day.isToday,
	        'weekend': day.isWeekend,
	        'sat': day.isSaturday,
	        'sun': day.isSunday,
	        'highlight-start': day.isHighlightStart,
	        'highlight-end': day.isHighlightEnd
	      };
	    },

	    /**
	     * Whether a day is disabled
	     * @param {Date} date to check if disabled
	     * @return {Boolean}
	     */
	    isDisabledDate: function isDisabledDate(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isDateDisabled(date);
	    },

	    /**
	     * Whether a day is highlighted
	     * (only if it is not disabled already except when highlighted.includeDisabled is true)
	     * @param {Date} date to check if highlighted
	     * @return {Boolean}
	     */
	    isHighlightedDate: function isHighlightedDate(date) {
	      var dateWithoutTime = this.utils.resetDateTime(date);
	      return new HighlightedDate(this.utils, this.disabledDates, this.highlighted).isDateHighlighted(dateWithoutTime);
	    },

	    /**
	     * Whether a day is highlighted and it is the last date
	     * in the highlighted range of dates
	     * @param {Date} date end highlight
	     * @return {Boolean}
	     */
	    isHighlightEnd: function isHighlightEnd(date) {
	      var config = this.highlightedConfig;
	      return this.isHighlightedDate(date) && config.to.year === this.utils.getFullYear(date) && config.to.month === this.utils.getMonth(date) && config.to.day === this.utils.getDate(date);
	    },

	    /**
	     * Whether a day is highlighted and it is the first date
	     * in the highlighted range of dates
	     * @param {Date} date start highlight
	     * @return {Boolean}
	     */
	    isHighlightStart: function isHighlightStart(date) {
	      var config = this.highlightedConfig;
	      return this.isHighlightedDate(date) && config.from.year === this.utils.getFullYear(date) && config.from.month === this.utils.getMonth(date) && config.from.day === this.utils.getDate(date);
	    },

	    /**
	     * Whether a day is selected
	     * @param {Date} dObj to check if selected
	     * @return {Boolean}
	     */
	    isSelectedDate: function isSelectedDate(dObj) {
	      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
	    },

	    /**
	     * Defines the objects within the days array
	     * @param  {id}  id
	     * @param  {Date}  dObj
	     * @return {Object}
	     */
	    // eslint-disable-next-line complexity
	    makeDay: function makeDay(id, dObj) {
	      var isNextMonth = dObj >= this.firstOfNextMonth;
	      var isPreviousMonth = dObj < this.pageDate;
	      var isSaturday = this.utils.getDay(dObj) === 6;
	      var isSunday = this.utils.getDay(dObj) === 0;
	      var showDate = this.showEdgeDates || !(isPreviousMonth || isNextMonth);
	      return {
	        date: showDate ? this.utils.getDate(dObj) : '',
	        timestamp: dObj.valueOf(),
	        isSelected: this.isSelectedDate(dObj),
	        isDisabled: showDate ? this.isDisabledDate(dObj) : true,
	        isHighlighted: this.isHighlightedDate(dObj),
	        isHighlightStart: this.isHighlightStart(dObj),
	        isHighlightEnd: this.isHighlightEnd(dObj),
	        isToday: this.utils.compareDates(dObj, new Date()),
	        isWeekend: isSaturday || isSunday,
	        isSaturday: isSaturday,
	        isSunday: isSunday,
	        isPreviousMonth: isPreviousMonth,
	        isNextMonth: isNextMonth
	      };
	    },

	    /**
	     * Set up a new date object to the first day of the current 'page'
	     * @return Date
	     */
	    firstCellDate: function firstCellDate() {
	      var d = this.pageDate;
	      var firstOfMonth = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
	      return new Date(firstOfMonth.setDate(firstOfMonth.getDate() - this.daysFromPrevMonth));
	    }
	  }
	};

	/* script */
	const __vue_script__$4 = script$4;

	/* template */
	var __vue_render__$3 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "picker-view" },
	    [
	      _vm._t("beforeCalendarHeaderDay"),
	      _vm._v(" "),
	      _vm.showHeader
	        ? _c(
	            "PickerHeader",
	            {
	              attrs: {
	                "is-next-disabled": _vm.isNextDisabled,
	                "is-previous-disabled": _vm.isPreviousDisabled,
	                "is-rtl": _vm.isRtl
	              },
	              on: { next: _vm.nextPage, previous: _vm.previousPage }
	            },
	            [
	              _c(
	                "span",
	                {
	                  staticClass: "day__month_btn",
	                  class: { up: !_vm.isUpDisabled },
	                  on: {
	                    click: function($event) {
	                      return _vm.$emit("set-view", "month")
	                    }
	                  }
	                },
	                [_vm._v("\n      " + _vm._s(_vm.pageTitleDay) + "\n    ")]
	              ),
	              _vm._v(" "),
	              _vm._t("nextIntervalBtn", null, { slot: "nextIntervalBtn" }),
	              _vm._v(" "),
	              _vm._t("prevIntervalBtn", null, { slot: "prevIntervalBtn" })
	            ],
	            2
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c(
	        "div",
	        { class: { "flex-rtl": _vm.isRtl } },
	        [
	          _vm._l(_vm.daysOfWeek, function(day) {
	            return _c("span", { key: day, staticClass: "day-header" }, [
	              _vm._v("\n      " + _vm._s(day) + "\n    ")
	            ])
	          }),
	          _vm._v(" "),
	          _c(
	            "div",
	            { ref: "cells" },
	            _vm._l(_vm.cells, function(cell) {
	              return _c(
	                "span",
	                {
	                  key: cell.timestamp,
	                  staticClass: "cell day",
	                  class: _vm.dayClasses(cell),
	                  on: {
	                    click: function($event) {
	                      return _vm.select(cell)
	                    }
	                  }
	                },
	                [
	                  _vm._t(
	                    "dayCellContent",
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.dayCellContent(cell)) +
	                          "\n        "
	                      )
	                    ],
	                    { cell: cell }
	                  )
	                ],
	                2
	              )
	            }),
	            0
	          )
	        ],
	        2
	      ),
	      _vm._v(" "),
	      _vm._t("calendarFooterDay")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$3 = [];
	__vue_render__$3._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$4 = undefined;
	  /* scoped */
	  const __vue_scope_id__$4 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$4 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$4 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
	    __vue_inject_styles__$4,
	    __vue_script__$4,
	    __vue_scope_id__$4,
	    __vue_is_functional_template__$4,
	    __vue_module_identifier__$4,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$3 = {
	  name: 'PickerMonth',
	  mixins: [__vue_component__$5],
	  computed: {
	    /**
	     * Sets an array with all months to show this year
	     * @return {Array}
	     */
	    cells: function cells() {
	      var d = this.pageDate;
	      var months = []; // set up a new date object to the beginning of the current 'page'

	      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

	      for (var i = 0; i < 12; i += 1) {
	        months.push({
	          month: this.utils.getMonthName(i, this.translation.months),
	          timestamp: dObj.valueOf(),
	          isSelected: this.isSelectedMonth(dObj),
	          isDisabled: this.isDisabledMonth(dObj)
	        });
	        this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
	      }

	      return months;
	    },

	    /**
	     * Is the next year disabled?
	     * @return {Boolean}
	     */
	    isNextDisabled: function isNextDisabled() {
	      if (!this.disabledConfig.has.from) {
	        return false;
	      }

	      return this.disabledConfig.from.year <= this.pageYear;
	    },

	    /**
	     * Is the previous year disabled?
	     * @return {Boolean}
	     */
	    isPreviousDisabled: function isPreviousDisabled() {
	      if (!this.disabledConfig.has.to) {
	        return false;
	      }

	      return this.disabledConfig.to.year >= this.pageYear;
	    },

	    /**
	     * Display the current page's year as the title.
	     * @return {String}
	     */
	    pageTitleMonth: function pageTitleMonth() {
	      var yearSuffix = this.translation.yearSuffix;
	      return "".concat(this.pageYear).concat(yearSuffix);
	    }
	  },
	  methods: {
	    /**
	     * Whether a month is disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isDisabledMonth: function isDisabledMonth(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isMonthDisabled(date);
	    },

	    /**
	     * Whether the selected date is in this month
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isSelectedMonth: function isSelectedMonth(date) {
	      var month = this.utils.getMonth(date);
	      var year = this.utils.getFullYear(date);
	      return this.selectedDate && year === this.utils.getFullYear(this.selectedDate) && month === this.utils.getMonth(this.selectedDate);
	    }
	  }
	};

	/* script */
	const __vue_script__$3 = script$3;

	/* template */
	var __vue_render__$2 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "picker-view" },
	    [
	      _vm._t("beforeCalendarHeaderMonth"),
	      _vm._v(" "),
	      _vm.showHeader
	        ? _c(
	            "PickerHeader",
	            {
	              attrs: {
	                "is-next-disabled": _vm.isNextDisabled,
	                "is-previous-disabled": _vm.isPreviousDisabled,
	                "is-rtl": _vm.isRtl
	              },
	              on: { next: _vm.nextPage, previous: _vm.previousPage }
	            },
	            [
	              _c(
	                "span",
	                {
	                  staticClass: "month__year_btn",
	                  class: { up: !_vm.isUpDisabled },
	                  on: {
	                    click: function($event) {
	                      return _vm.$emit("set-view", "year")
	                    }
	                  }
	                },
	                [_vm._v("\n      " + _vm._s(_vm.pageTitleMonth) + "\n    ")]
	              ),
	              _vm._v(" "),
	              _vm._t("nextIntervalBtn", null, { slot: "nextIntervalBtn" }),
	              _vm._v(" "),
	              _vm._t("prevIntervalBtn", null, { slot: "prevIntervalBtn" })
	            ],
	            2
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c(
	        "div",
	        { ref: "cells" },
	        _vm._l(_vm.cells, function(cell) {
	          return _c(
	            "span",
	            {
	              key: cell.timestamp,
	              staticClass: "cell month",
	              class: { selected: cell.isSelected, disabled: cell.isDisabled },
	              on: {
	                click: function($event) {
	                  return _vm.select(cell)
	                }
	              }
	            },
	            [_vm._v("\n      " + _vm._s(cell.month) + "\n    ")]
	          )
	        }),
	        0
	      ),
	      _vm._v(" "),
	      _vm._t("calendarFooterMonth")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$2 = [];
	__vue_render__$2._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$3 = undefined;
	  /* scoped */
	  const __vue_scope_id__$3 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$3 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$3 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
	    __vue_inject_styles__$3,
	    __vue_script__$3,
	    __vue_scope_id__$3,
	    __vue_is_functional_template__$3,
	    __vue_module_identifier__$3,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$2 = {
	  name: 'PickerYear',
	  mixins: [__vue_component__$5],
	  props: {
	    yearRange: {
	      type: Number,
	      default: 10
	    }
	  },
	  computed: {
	    /**
	     * Sets an array with all years to show this decade (or yearRange)
	     * @return {Array}
	     */
	    cells: function cells() {
	      var d = this.pageDate;
	      var years = [];
	      var year = this.useUtc ? Math.floor(d.getUTCFullYear() / this.yearRange) * this.yearRange : Math.floor(d.getFullYear() / this.yearRange) * this.yearRange; // set up a new date object to the beginning of the current 'page'7

	      var dObj = this.useUtc ? new Date(Date.UTC(year, d.getUTCMonth(), d.getUTCDate())) : new Date(year, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

	      for (var i = 0; i < this.yearRange; i += 1) {
	        years.push({
	          year: this.utils.getFullYear(dObj),
	          timestamp: dObj.valueOf(),
	          isSelected: this.isSelectedYear(dObj),
	          isDisabled: this.isDisabledYear(dObj)
	        });
	        this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
	      }

	      return years;
	    },

	    /**
	     * Is the next decade disabled?
	     * @return {Boolean}
	     */
	    isNextDisabled: function isNextDisabled() {
	      if (!this.disabledConfig.has.from) {
	        return false;
	      }

	      return this.disabledConfig.from.year <= this.pageDecadeEnd;
	    },

	    /**
	     * Is the previous decade disabled?
	     * @return {Boolean}
	     */
	    isPreviousDisabled: function isPreviousDisabled() {
	      if (!this.disabledConfig.has.to) {
	        return false;
	      }

	      return this.disabledConfig.to.year >= this.pageDecadeStart;
	    },

	    /**
	     * The year at which the current yearRange starts
	     * @return {Number}
	     */
	    pageDecadeStart: function pageDecadeStart() {
	      return Math.floor(this.pageYear / this.yearRange) * this.yearRange;
	    },

	    /**
	     * The year at which the current yearRange ends
	     * @return {Number}
	     */
	    pageDecadeEnd: function pageDecadeEnd() {
	      return this.pageDecadeStart + this.yearRange - 1;
	    },

	    /**
	     * Display the current page's decade (or year range) as the title.
	     * @return {String}
	     */
	    pageTitleYear: function pageTitleYear() {
	      var yearSuffix = this.translation.yearSuffix;
	      return "".concat(this.pageDecadeStart, " - ").concat(this.pageDecadeEnd).concat(yearSuffix);
	    }
	  },
	  methods: {
	    /**
	     * Whether a year is disabled
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isDisabledYear: function isDisabledYear(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isYearDisabled(date);
	    },

	    /**
	     * Whether the selected date is in this year
	     * @param {Date} date
	     * @return {Boolean}
	     */
	    isSelectedYear: function isSelectedYear(date) {
	      var year = this.utils.getFullYear(date);
	      return this.selectedDate && year === this.utils.getFullYear(this.selectedDate);
	    },

	    /**
	     * Increments the page (overrides nextPage in pickerMixin)
	     */
	    nextPage: function nextPage() {
	      if (!this.isNextDisabled) {
	        this.changePage(this.yearRange);
	      }
	    },

	    /**
	     * Decrements the page (overrides previousPage in pickerMixin)
	     */
	    previousPage: function previousPage() {
	      if (!this.isPreviousDisabled) {
	        this.changePage(-this.yearRange);
	      }
	    }
	  }
	};

	/* script */
	const __vue_script__$2 = script$2;

	/* template */
	var __vue_render__$1 = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "picker-view" },
	    [
	      _vm._t("beforeCalendarHeaderYear"),
	      _vm._v(" "),
	      _vm.showHeader
	        ? _c(
	            "PickerHeader",
	            {
	              attrs: {
	                "is-next-disabled": _vm.isNextDisabled,
	                "is-previous-disabled": _vm.isPreviousDisabled,
	                "is-rtl": _vm.isRtl
	              },
	              on: { next: _vm.nextPage, previous: _vm.previousPage }
	            },
	            [
	              _c("span", [
	                _vm._v("\n      " + _vm._s(_vm.pageTitleYear) + "\n    ")
	              ]),
	              _vm._v(" "),
	              _vm._t("nextIntervalBtn", null, { slot: "nextIntervalBtn" }),
	              _vm._v(" "),
	              _vm._t("prevIntervalBtn", null, { slot: "prevIntervalBtn" })
	            ],
	            2
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _c(
	        "div",
	        { ref: "cells" },
	        _vm._l(_vm.cells, function(cell) {
	          return _c(
	            "span",
	            {
	              key: cell.timestamp,
	              staticClass: "cell year",
	              class: { selected: cell.isSelected, disabled: cell.isDisabled },
	              on: {
	                click: function($event) {
	                  return _vm.select(cell)
	                }
	              }
	            },
	            [_vm._v("\n      " + _vm._s(cell.year) + "\n    ")]
	          )
	        }),
	        0
	      ),
	      _vm._v(" "),
	      _vm._t("calendarFooterYear")
	    ],
	    2
	  )
	};
	var __vue_staticRenderFns__$1 = [];
	__vue_render__$1._withStripped = true;

	  /* style */
	  const __vue_inject_styles__$2 = undefined;
	  /* scoped */
	  const __vue_scope_id__$2 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$2 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$2 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
	    __vue_inject_styles__$2,
	    __vue_script__$2,
	    __vue_scope_id__$2,
	    __vue_is_functional_template__$2,
	    __vue_module_identifier__$2,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/* eslint no-param-reassign: 0 */

	/**
	 * get the hidden element width, height
	 * @param {HTMLElement} element dom
	 */
	function getPopupElementSize(element) {
	  var originalDisplay = element.style.display;
	  var originalVisibility = element.style.visibility;
	  element.style.display = 'block';
	  element.style.visibility = 'hidden';
	  var styles = window.getComputedStyle(element);
	  var width = element.offsetWidth + parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
	  var height = element.offsetHeight + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
	  element.style.display = originalDisplay;
	  element.style.visibility = originalVisibility;
	  return {
	    width: width,
	    height: height
	  };
	}
	/**
	 * get the popup position
	 * @param {Element} el element
	 * @param {Element} elRelative relative element
	 * @param {Number} targetWidth target element's width
	 * @param {Number} targetHeight target element's height
	 * @param {Boolean} appendToBody
	 * @param {String} fixedPosition
	 * @param {Boolean} rtl
	 */
	// eslint-disable-next-line complexity,max-statements

	function getRelativePosition(_ref) {
	  var el = _ref.el,
	      elRelative = _ref.elRelative,
	      targetWidth = _ref.targetWidth,
	      targetHeight = _ref.targetHeight,
	      appendToBody = _ref.appendToBody,
	      fixedPosition = _ref.fixedPosition,
	      rtl = _ref.rtl;
	  var left = 0;
	  var top = 0;
	  var offsetX = 0;
	  var offsetY = 0;
	  var relativeRect = elRelative.getBoundingClientRect();
	  var documentWidth = document.documentElement.clientWidth;
	  var documentHeight = document.documentElement.clientHeight;

	  if (appendToBody) {
	    offsetX = window.pageXOffset + relativeRect.left;
	    offsetY = window.pageYOffset + relativeRect.top;
	  }

	  var calendarBounding = el.getBoundingClientRect();
	  var outOfBoundsRight = calendarBounding.right > window.innerWidth;
	  var outOfBoundsBottom = calendarBounding.bottom > window.innerHeight;
	  var fixedPositionRight = fixedPosition && fixedPosition.indexOf('right') !== -1;
	  var fixedPositionTop = fixedPosition && fixedPosition.indexOf('top') !== -1;

	  var setLeft = function setLeft() {
	    left = offsetX;
	  };

	  var setRight = function setRight() {
	    left = offsetX + relativeRect.width - targetWidth;
	  };

	  var setBottom = function setBottom() {
	    top = offsetY + relativeRect.height;
	  };

	  var setTop = function setTop() {
	    top = offsetY - targetHeight;
	  };

	  if (fixedPosition === '') {
	    if (outOfBoundsRight || rtl) {
	      setRight();
	    } else {
	      setLeft();
	    }

	    if (outOfBoundsBottom) {
	      setTop();
	    } else {
	      setBottom();
	    }

	    var hasRelativWidth = documentWidth - relativeRect.left < targetWidth && relativeRect.right < targetWidth;
	    var hasRelativHeight = relativeRect.top <= targetHeight && documentHeight - relativeRect.bottom <= targetHeight;

	    if (hasRelativWidth) {
	      left = offsetX - relativeRect.left + 1;
	    }

	    if (hasRelativHeight) {
	      top = offsetY + documentHeight - relativeRect.top - targetHeight;
	    }
	  } else {
	    if (fixedPositionRight) {
	      setRight();
	    } else {
	      setLeft();
	    }

	    if (fixedPositionTop) {
	      setTop();
	    } else {
	      setBottom();
	    }
	  }

	  return {
	    left: "".concat(left, "px"),
	    top: "".concat(top, "px")
	  };
	}

	var script$1 = {
	  name: 'Popup',
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    fixedPosition: {
	      type: String,
	      default: ''
	    },
	    inline: {
	      type: Boolean,
	      default: false
	    },
	    rtl: {
	      type: Boolean,
	      default: false
	    },
	    visible: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      popupRect: null
	    };
	  },
	  watch: {
	    visible: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this = this;

	        this.$nextTick(function () {
	          if (val) {
	            _this.displayPopup();
	          }
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.inline) {
	      return;
	    }

	    if (this.appendToBody) {
	      document.body.appendChild(this.$el);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.inline) {
	      return;
	    }

	    if (this.appendToBody && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  },
	  methods: {
	    setTopStyle: function setTopStyle() {
	      if (this.appendToBody) {
	        var relativeRect = this.$parent.$el.getBoundingClientRect();
	        this.$el.style.top = "".concat(relativeRect.bottom + window.scrollY, "px");
	      }
	    },
	    displayPopup: function displayPopup() {
	      if (this.inline || !this.visible) return;
	      this.setTopStyle();
	      var popup = this.$el;
	      var relativeElement = this.$parent.$el;

	      if (!this.popupRect) {
	        this.popupRect = getPopupElementSize(popup);
	      }

	      var _this$popupRect = this.popupRect,
	          width = _this$popupRect.width,
	          height = _this$popupRect.height;

	      var _getRelativePosition = getRelativePosition({
	        el: popup,
	        elRelative: relativeElement,
	        targetWidth: width,
	        targetHeight: height,
	        appendToBody: this.appendToBody,
	        fixedPosition: this.fixedPosition,
	        rtl: this.rtl
	      }),
	          left = _getRelativePosition.left,
	          top = _getRelativePosition.top;

	      this.$el.style.left = left;
	      this.$el.style.top = top;
	    }
	  },
	  render: function render() {
	    return this.$slots.default;
	  }
	};

	/* script */
	const __vue_script__$1 = script$1;

	/* template */

	  /* style */
	  const __vue_inject_styles__$1 = undefined;
	  /* scoped */
	  const __vue_scope_id__$1 = undefined;
	  /* module identifier */
	  const __vue_module_identifier__$1 = undefined;
	  /* functional template */
	  const __vue_is_functional_template__$1 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$1,
	    __vue_script__$1,
	    __vue_scope_id__$1,
	    __vue_is_functional_template__$1,
	    __vue_module_identifier__$1,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script = {
	  name: 'Datepicker',
	  components: {
	    DateInput: __vue_component__$7,
	    PickerDay: __vue_component__$4,
	    PickerMonth: __vue_component__$3,
	    PickerYear: __vue_component__$2,
	    Popup: __vue_component__$1
	  },
	  mixins: [__vue_component__$8],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    calendarClass: {
	      type: [String, Object, Array],
	      default: ''
	    },
	    dayCellContent: {
	      type: Function,
	      default: function _default(day) {
	        return day.date;
	      }
	    },
	    disabledDates: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    firstDayOfWeek: {
	      type: String,
	      default: 'sun'
	    },
	    fixedPosition: {
	      type: String,
	      default: '',
	      validator: function validator(val) {
	        var possibleValues = ['', 'bottom', 'bottom-left', 'bottom-right', 'top', 'top-left', 'top-right'];
	        return possibleValues.includes(val);
	      }
	    },
	    fullMonthName: {
	      type: Boolean,
	      default: false
	    },
	    highlighted: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    initialView: {
	      type: String,
	      default: ''
	    },
	    language: {
	      type: Object,
	      default: function _default() {
	        return en;
	      }
	    },
	    maximumView: {
	      type: String,
	      default: 'year'
	    },
	    minimumView: {
	      type: String,
	      default: 'day'
	    },
	    showEdgeDates: {
	      type: Boolean,
	      default: true
	    },
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	    value: {
	      type: [String, Date, Number],
	      default: '',
	      validator: function validator(val) {
	        return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
	      }
	    },
	    wrapperClass: {
	      type: [String, Object, Array],
	      default: ''
	    },
	    yearPickerRange: {
	      type: Number,
	      default: 10
	    }
	  },
	  data: function data() {
	    var utils = makeDateUtils(this.useUtc);
	    var startDate = utils.getNewDateObject(this.openDate || null);
	    var pageTimestamp = utils.setDate(startDate, 1);
	    return {
	      calendarHeight: 0,
	      calendarSlots: calendarSlots,

	      /*
	       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
	       * This represents the first day of the current viewing month
	       * {Number}
	       */
	      pageTimestamp: pageTimestamp,
	      resetTypedDate: utils.getNewDateObject(),

	      /*
	       * Selected Date
	       * {Date}
	       */
	      selectedDate: null,
	      utils: utils,
	      view: ''
	    };
	  },
	  computed: {
	    allowedViews: function allowedViews() {
	      var _this = this;

	      var views = ['day', 'month', 'year'];
	      return views.filter(function (view) {
	        return _this.allowedToShowView(view);
	      });
	    },
	    computedInitialView: function computedInitialView() {
	      return this.initialView || this.minimumView;
	    },
	    isInline: function isInline() {
	      return !!this.inline;
	    },
	    isOpen: function isOpen() {
	      return this.view !== '';
	    },
	    isRtl: function isRtl() {
	      return this.translation.rtl;
	    },
	    isUpDisabled: function isUpDisabled() {
	      return !this.allowedToShowView(this.nextView.up);
	    },
	    nextView: function nextView() {
	      var _this2 = this;

	      var isCurrentView = function isCurrentView(view) {
	        return view === _this2.view;
	      };

	      var viewIndex = this.allowedViews.findIndex(isCurrentView);

	      var nextViewDown = function nextViewDown(index) {
	        return index <= 0 ? undefined : _this2.allowedViews[index - 1];
	      };

	      var nextViewUp = function nextViewUp(index) {
	        if (index < 0) {
	          return undefined;
	        }

	        if (index === _this2.allowedViews.length - 1) {
	          return 'decade';
	        }

	        return _this2.allowedViews[index + 1];
	      };

	      return {
	        up: nextViewUp(viewIndex),
	        down: nextViewDown(viewIndex)
	      };
	    },
	    pageDate: function pageDate() {
	      return new Date(this.pageTimestamp);
	    },
	    picker: function picker() {
	      var view = this.view || this.computedInitialView;
	      return "Picker".concat(this.ucFirst(view));
	    },
	    pickerClasses: function pickerClasses() {
	      return [this.calendarClass, this.isInline && 'inline', this.isRtl && this.appendToBody && 'rtl'];
	    },
	    translation: function translation() {
	      return this.language;
	    }
	  },
	  watch: {
	    initialView: function initialView() {
	      this.setInitialView();
	    },
	    openDate: function openDate() {
	      this.setPageDate();
	    },
	    value: function value(_value) {
	      var parsedValue = this.parseValue(_value);
	      this.setValue(parsedValue);
	    }
	  },
	  mounted: function mounted() {
	    this.init();
	  },
	  methods: {
	    /**
	     * Are we allowed to show a specific picker view?
	     * @param {String} view
	     * @return {Boolean}
	     */
	    allowedToShowView: function allowedToShowView(view) {
	      var views = ['day', 'month', 'year'];
	      var minimumViewIndex = views.indexOf(this.minimumView);
	      var maximumViewIndex = views.indexOf(this.maximumView);
	      var viewIndex = views.indexOf(view);
	      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
	    },

	    /**
	     * Clear the selected date
	     */
	    clearDate: function clearDate() {
	      this.selectedDate = null;
	      this.setPageDate();
	      this.$emit('selected', null);
	      this.$emit('input', null);
	      this.$emit('cleared');
	    },

	    /**
	     * Close the calendar views
	     */
	    close: function close() {
	      if (!this.isInline) {
	        this.view = '';
	        this.$emit('closed');
	      }
	    },

	    /**
	     * Set the new pageDate and emit `changed-<view>` event
	     */
	    handlePageChange: function handlePageChange(pageDate) {
	      this.setPageDate(pageDate);
	      this.$emit("changed-".concat(this.nextView.up), pageDate);
	    },

	    /**
	     * Emits a 'blur' event
	     */
	    handleInputBlur: function handleInputBlur() {
	      this.$emit('blur');
	    },

	    /**
	     * Emits a 'focus' event
	     */
	    handleInputFocus: function handleInputFocus() {
	      this.$emit('focus');
	    },

	    /**
	     * Set the date, or go to the next view down
	     */
	    handleSelect: function handleSelect(cell) {
	      if (this.allowedToShowView(this.nextView.down)) {
	        this.setPageDate(new Date(cell.timestamp));
	        this.$emit("changed-".concat(this.view), cell);
	        this.setView(this.nextView.down);
	        return;
	      }

	      this.resetTypedDate = this.utils.getNewDateObject();
	      this.selectDate(cell.timestamp);
	      this.close();
	    },

	    /**
	     * Emit a 'selected-disabled' event
	     */
	    handleSelectDisabled: function handleSelectDisabled(cell) {
	      this.$emit('selected-disabled', cell);
	    },

	    /**
	     * Set the date from a 'typed-date' event
	     */
	    handleTypedDate: function handleTypedDate(date) {
	      this.selectDate(date.valueOf());
	    },

	    /**
	     * Initiate the component
	     */
	    init: function init() {
	      if (this.value) {
	        var parsedValue = this.parseValue(this.value);
	        var isDateDisabled = parsedValue && this.isDateDisabled(parsedValue);

	        if (isDateDisabled) {
	          parsedValue = null;
	          this.$emit('input', parsedValue);
	        }

	        this.setValue(parsedValue);
	      }

	      if (this.isInline) {
	        this.setInitialView();
	      }
	    },

	    /**
	     * Returns true if a date is disabled
	     * @param {Date} date
	     */
	    isDateDisabled: function isDateDisabled(date) {
	      return new DisabledDate(this.utils, this.disabledDates).isDateDisabled(date);
	    },

	    /**
	     * Opens the calendar with the relevant view: 'day', 'month', or 'year'
	     */
	    open: function open() {
	      if (this.disabled || this.isInline) {
	        return;
	      }

	      this.setInitialView();
	      this.$emit('opened');
	    },

	    /**
	     * Parse a datepicker value from string/number to date
	     * @param {Date|String|Number|null} date
	     */
	    parseValue: function parseValue(date) {
	      var dateTemp = date;

	      if (typeof dateTemp === 'string' || typeof dateTemp === 'number') {
	        var parsed = new Date(dateTemp);
	        dateTemp = Number.isNaN(parsed.valueOf()) ? null : parsed;
	      }

	      return dateTemp;
	    },

	    /**
	     * Called in the event that the user navigates to date pages and
	     * closes the picker without selecting a date.
	     */
	    resetDefaultPageDate: function resetDefaultPageDate() {
	      if (this.selectedDate === null) {
	        this.setPageDate();
	        return;
	      }

	      this.setPageDate(this.selectedDate);
	    },

	    /**
	     * Select the date
	     * @param {Number} timestamp
	     */
	    selectDate: function selectDate(timestamp) {
	      var date = new Date(timestamp);
	      this.selectedDate = date;
	      this.setPageDate(date);
	      this.$emit('selected', date);
	      this.$emit('input', date);
	    },

	    /**
	     * Sets the initial picker page view: day, month or year
	     */
	    setInitialView: function setInitialView() {
	      var initialView = this.computedInitialView;

	      if (!this.allowedToShowView(initialView)) {
	        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
	      }

	      this.setView(initialView);
	    },

	    /**
	     * Sets the date that the calendar should open on
	     */
	    setPageDate: function setPageDate(date) {
	      var dateTemp = date;

	      if (!dateTemp) {
	        if (this.openDate) {
	          dateTemp = new Date(this.openDate);
	        } else {
	          dateTemp = new Date();
	        }

	        dateTemp = this.utils.resetDateTime(dateTemp);
	      }

	      this.pageTimestamp = this.utils.setDate(new Date(dateTemp), 1);
	    },

	    /**
	     * Set the datepicker value
	     * @param {Date|String|Number|null} date
	     */
	    setValue: function setValue(date) {
	      if (!date) {
	        this.setPageDate();
	        this.selectedDate = null;
	        return;
	      }

	      this.selectedDate = date;
	      this.setPageDate(date);
	    },

	    /**
	     * Set the picker view
	     */
	    setView: function setView(view) {
	      if (this.allowedToShowView(view)) {
	        this.view = view;
	      }
	    },

	    /**
	     * Capitalizes the first letter
	     */
	    ucFirst: function ucFirst(str) {
	      return str[0].toUpperCase() + str.substring(1);
	    }
	  }
	};

	/* script */
	const __vue_script__ = script;
	/* template */
	var __vue_render__ = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    {
	      staticClass: "vdp-datepicker",
	      class: [_vm.wrapperClass, { rtl: _vm.isRtl }]
	    },
	    [
	      _c(
	        "DateInput",
	        {
	          attrs: {
	            id: _vm.id,
	            autofocus: _vm.autofocus,
	            "bootstrap-styling": _vm.bootstrapStyling,
	            "calendar-button": _vm.calendarButton,
	            "calendar-button-icon": _vm.calendarButtonIcon,
	            "calendar-button-icon-content": _vm.calendarButtonIconContent,
	            "clear-button": _vm.clearButton,
	            "clear-button-icon": _vm.clearButtonIcon,
	            disabled: _vm.disabled,
	            format: _vm.format,
	            inline: _vm.inline,
	            "is-open": _vm.isOpen,
	            "input-class": _vm.inputClass,
	            maxlength: _vm.maxlength,
	            name: _vm.name,
	            parser: _vm.parser,
	            pattern: _vm.pattern,
	            placeholder: _vm.placeholder,
	            "ref-name": _vm.refName,
	            required: _vm.required,
	            "reset-typed-date": _vm.resetTypedDate,
	            "selected-date": _vm.selectedDate,
	            "show-calendar-on-button-click": _vm.showCalendarOnButtonClick,
	            "show-calendar-on-focus": _vm.showCalendarOnFocus,
	            tabindex: _vm.tabindex,
	            translation: _vm.translation,
	            typeable: _vm.typeable,
	            "use-utc": _vm.useUtc
	          },
	          on: {
	            blur: _vm.handleInputBlur,
	            "clear-date": _vm.clearDate,
	            close: _vm.close,
	            focus: _vm.handleInputFocus,
	            open: _vm.open,
	            "typed-date": _vm.handleTypedDate
	          }
	        },
	        [
	          _vm._t("beforeDateInput", null, { slot: "beforeDateInput" }),
	          _vm._v(" "),
	          _vm._t("afterDateInput", null, { slot: "afterDateInput" }),
	          _vm._v(" "),
	          _vm._t("clearBtn", null, { slot: "clearBtn" }),
	          _vm._v(" "),
	          _vm._t("calendarBtn", null, { slot: "calendarBtn" })
	        ],
	        2
	      ),
	      _vm._v(" "),
	      _c(
	        "Popup",
	        {
	          ref: "popup",
	          attrs: {
	            "append-to-body": _vm.appendToBody,
	            "fixed-position": _vm.fixedPosition,
	            inline: _vm.inline,
	            rtl: _vm.isRtl,
	            visible: _vm.isOpen
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.isOpen,
	                  expression: "isOpen"
	                }
	              ],
	              ref: "datepicker",
	              staticClass: "vdp-datepicker__calendar",
	              class: _vm.pickerClasses,
	              on: {
	                mousedown: function($event) {
	                  $event.preventDefault();
	                }
	              }
	            },
	            [
	              _vm._t("beforeCalendarHeader"),
	              _vm._v(" "),
	              _c(
	                _vm.picker,
	                {
	                  tag: "Component",
	                  attrs: {
	                    "day-cell-content": _vm.dayCellContent,
	                    "disabled-dates": _vm.disabledDates,
	                    "first-day-of-week": _vm.firstDayOfWeek,
	                    highlighted: _vm.highlighted,
	                    "is-rtl": _vm.isRtl,
	                    "is-up-disabled": _vm.isUpDisabled,
	                    "page-date": _vm.pageDate,
	                    "selected-date": _vm.selectedDate,
	                    "show-edge-dates": _vm.showEdgeDates,
	                    "show-full-month-name": _vm.fullMonthName,
	                    "show-header": _vm.showHeader,
	                    translation: _vm.translation,
	                    "use-utc": _vm.useUtc,
	                    "year-range": _vm.yearPickerRange
	                  },
	                  on: {
	                    "page-change": _vm.handlePageChange,
	                    select: _vm.handleSelect,
	                    "select-disabled": _vm.handleSelectDisabled,
	                    "set-view": _vm.setView
	                  },
	                  scopedSlots: _vm._u(
	                    [
	                      {
	                        key: "dayCellContent",
	                        fn: function(ref) {
	                          var cell = ref.cell;
	                          return [
	                            cell
	                              ? _vm._t("dayCellContent", null, { cell: cell })
	                              : _vm._e()
	                          ]
	                        }
	                      }
	                    ],
	                    null,
	                    true
	                  )
	                },
	                [
	                  _vm._l(_vm.calendarSlots, function(slotKey) {
	                    return [_vm._t(slotKey, null, { slot: slotKey })]
	                  })
	                ],
	                2
	              ),
	              _vm._v(" "),
	              _vm._t("calendarFooter")
	            ],
	            2
	          )
	        ]
	      )
	    ],
	    1
	  )
	};
	var __vue_staticRenderFns__ = [];
	__vue_render__._withStripped = true;

	  /* style */
	  const __vue_inject_styles__ = undefined;
	  /* scoped */
	  const __vue_scope_id__ = undefined;
	  /* module identifier */
	  const __vue_module_identifier__ = undefined;
	  /* functional template */
	  const __vue_is_functional_template__ = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  const __vue_component__ = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
	    __vue_inject_styles__,
	    __vue_script__,
	    __vue_scope_id__,
	    __vue_is_functional_template__,
	    __vue_module_identifier__,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	return __vue_component__;

})));

});

var script$I = {
  name: 'TfDatepicker',
  components: {
    Datepicker: Datepicker$1
  },
  inheritAttrs: false,
  props: {
    format: {
      type: String,
      default: 'MM/dd/yy'
    },
    value: {
      type: [String, Date],
      default: ''
    },
    viewType: {
      type: String,
      default: 'day',
      validator: function validator(value) {
        return ['day', 'month'].includes(value);
      }
    }
  },
  computed: {
    /**
     * Set individual class names for styling purposes.
     *
     * @returns {object}
     */
    wrapperClass: function wrapperClass() {
      return {
        'tf-datepicker': true,
        'is-month-only': this.viewType === 'month',
        'is-day-only': this.viewType === 'day'
      };
    }
  }
};

/* script */
const __vue_script__$I = script$I;

/* template */
var __vue_render__$H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "datepicker",
    _vm._g(
      _vm._b(
        {
          attrs: { "calendar-class": "tf-datepicker-container" },
          scopedSlots: _vm._u([
            {
              key: "dayCellContent",
              fn: function(ref) {
                var cell = ref.cell;
                return _c("span", {
                  staticClass: "custom-day",
                  domProps: { textContent: _vm._s(cell.date || "") }
                })
              }
            }
          ])
        },
        "datepicker",
        Object.assign({}, _vm.$attrs, _vm.$props, {
          minimumView: _vm.viewType,
          maximumView: _vm.viewType,
          wrapperClass: _vm.wrapperClass
        }),
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._v(" "),
      _c("tf-button", {
        attrs: {
          slot: "prevIntervalBtn",
          type: "primary",
          icon: "angle-left",
          size: "icon-no-fill",
          "no-border": ""
        },
        slot: "prevIntervalBtn"
      }),
      _vm._v(" "),
      _c("tf-button", {
        attrs: {
          slot: "nextIntervalBtn",
          type: "primary",
          icon: "angle-right",
          size: "icon-no-fill",
          "no-border": ""
        },
        slot: "nextIntervalBtn"
      })
    ],
    1
  )
};
var __vue_staticRenderFns__$H = [];
__vue_render__$H._withStripped = true;

  /* style */
  const __vue_inject_styles__$I = function (inject) {
    if (!inject) return
    inject("data-v-97163d22_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n[data-v-97163d22] input {\n  height: 30px;\n  border: 1px solid #c1c1c1;\n  border-radius: 2px;\n  color: #42474c;\n  padding: 0 10px;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */", map: {"version":3,"sources":["TfDatepicker.vue","/home/circleci/repo/src/components/TfDatepicker.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACwEpC;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;ADtEA;;AAEA,2CAA2C","file":"TfDatepicker.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n::v-deep input {\n  height: 30px;\n  border: 1px solid #c1c1c1;\n  border-radius: 2px;\n  color: #42474c;\n  padding: 0 10px;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */","<template>\n  <datepicker\n    v-bind=\"{\n      ...$attrs,\n      ...$props,\n      minimumView: viewType,\n      maximumView: viewType,\n      wrapperClass,\n    }\"\n    calendar-class=\"tf-datepicker-container\"\n    v-on=\"$listeners\"\n  >\n    <span\n      slot=\"dayCellContent\"\n      slot-scope=\"{ cell }\"\n      class=\"custom-day\"\n      v-text=\"cell.date || ''\"\n    />\n    <tf-button\n      slot=\"prevIntervalBtn\"\n      type=\"primary\"\n      icon=\"angle-left\"\n      size=\"icon-no-fill\"\n      no-border\n    />\n    <tf-button\n      slot=\"nextIntervalBtn\"\n      type=\"primary\"\n      icon=\"angle-right\"\n      size=\"icon-no-fill\"\n      no-border\n    />\n  </datepicker>\n</template>\n<script>\n  import Datepicker from '@sum.cumo/vue-datepicker/dist/Datepicker';\n\n  export default {\n    name: 'TfDatepicker',\n    components: { Datepicker },\n    inheritAttrs: false,\n    props: {\n      format: {\n        type: String,\n        default: 'MM/dd/yy',\n      },\n      value: {\n        type: [String, Date],\n        default: '',\n      },\n      viewType: {\n        type: String,\n        default: 'day',\n        validator: (value) => ['day', 'month'].includes(value),\n      },\n    },\n    computed: {\n      /**\n       * Set individual class names for styling purposes.\n       *\n       * @returns {object}\n       */\n      wrapperClass() {\n        return {\n          'tf-datepicker': true,\n          'is-month-only': this.viewType === 'month',\n          'is-day-only': this.viewType === 'day',\n        };\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  ::v-deep {\n    input {\n      height: 30px;\n      border: 1px solid $tf-light-gray;\n      border-radius: 2px;\n      color: $tf-dark-gray;\n      padding: 0 10px;\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  // This is an unscoped style block to account for appendToBody:true for <tf-datepicker />\n  @import 'src/assets/styles/variables';\n\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  .tf-datepicker-container.vdp-datepicker__calendar {\n    flex-direction: row;\n    justify-content: center;\n    box-shadow: none;\n    border-color: $tf-light-gray;\n    z-index: 2001;\n\n    .custom-day {\n      position: relative;\n      z-index: 2;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 31px;\n      height: 31px;\n      border: 1px solid transparent;\n      border-radius: 100%;\n\n      &:hover {\n        border-color: $tf-blue;\n        background: $tf-white;\n      }\n    }\n\n    div {\n      // Override all the cell data styles\n      .cell {\n        position: relative;\n        font-size: 12px;\n\n        &.day-header {\n          color: $tf-light-gray;\n        }\n\n        &.disabled {\n          color: $tf-light-gray;\n\n          >.custom-day:hover {\n            border: transparent;\n          }\n        }\n\n        &.selected,\n        &.selected:hover,\n        &.selected.highlighted,\n        &.highlight-start,\n        &.highlight-end {\n          background-color: transparent;\n\n          &.month,\n          .custom-day {\n            /* stylelint-disable declaration-no-important */\n            background-color: $tf-blue !important;\n            color: $tf-white !important;\n            /* stylelint-enable declaration-no-important */\n          }\n        }\n\n        &.highlighted {\n          background-color: transparent;\n\n          &:after {\n            position: absolute;\n            height: 27px;\n            top: calc(50% - 18px);\n            left: -1px;\n            right: -1px;\n            background-color: $tf-light-blue;\n            content: '';\n          }\n\n          &.highlight-end:after {\n            right: 50%;\n          }\n\n          &.highlight-start:after {\n            left: 50%;\n          }\n        }\n\n        &.month {\n          display: flex;\n          align-content: center;\n          justify-content: center;\n          width: 166px;\n          height: inherit;\n          margin: 6px 10px;\n          padding: 4px 0;\n\n          font: {\n            size: 14px;\n            weight: 700;\n          }\n\n          color: $tf-blue;\n          line-height: inherit;\n          border-color: $tf-blue;\n        }\n\n        &.muted:not(.disabled):hover {\n          border-color: transparent;\n        }\n      }\n\n      .day:not(.muted):not(.disabled):hover {\n        border-color: transparent;\n      }\n\n      &:not(.muted):not(.disabled) {\n        .month:hover,\n        .year:hover {\n          /* stylelint-disable declaration-no-important  */\n          border-color: $tf-dark-blue !important;\n          /* stylelint-enable declaration-no-important  */\n        }\n      }\n    }\n\n    .picker-view {\n      > div {\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        width: 100%;\n      }\n\n      header {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding: 10px 0;\n        line-height: 1;\n        color: $tf-dark-blue;\n\n        span {\n          display: flex;\n          float: none;\n          width: auto;\n        }\n\n        .is-month-only &,\n        .month__year_btn {\n          justify-content: center;\n        }\n\n        .day__month_btn {\n          flex: 2;\n          margin: auto;\n          justify-content: center;\n          font-weight: 700;\n          color: $tf-blue;\n        }\n\n        .is-day-only & {\n          justify-content: space-between;\n        }\n\n        .month__year_btn {\n          margin: 0 10px;\n        }\n\n        .next,\n        .prev {\n          &:not(.disabled):hover {\n            background: transparent;\n          }\n\n          &:after {\n            display: none;\n          }\n        }\n\n        .next .tf-button {\n          margin-left: auto;\n        }\n\n        .prev .tf-button {\n          margin-right: auto;\n        }\n      }\n    }\n\n    .is-month-only & {\n      width: 380px;\n    }\n\n    &,\n    header {\n      display: flex;\n    }\n\n    span.today {\n      background: transparent;\n      font-weight: 700;\n    }\n  }\n</style>\n"]}, media: undefined })
,inject("data-v-97163d22_1", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/* stylelint-disable selector-max-compound-selectors */\n/* stylelint-disable max-nesting-depth  */\n.tf-datepicker-container.vdp-datepicker__calendar {\n  flex-direction: row;\n  justify-content: center;\n  box-shadow: none;\n  border-color: #c1c1c1;\n  z-index: 2001;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  border: 1px solid transparent;\n  border-radius: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day:hover {\n  border-color: #2638a6;\n  background: #fff;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell {\n  position: relative;\n  font-size: 12px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.day-header {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled > .custom-day:hover {\n  border: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end .custom-day {\n  /* stylelint-disable declaration-no-important */\n  background-color: #2638a6 !important;\n  color: #fff !important;\n  /* stylelint-enable declaration-no-important */\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted:after {\n  position: absolute;\n  height: 27px;\n  top: calc(50% - 18px);\n  left: -1px;\n  right: -1px;\n  background-color: #f4f5ff;\n  content: \"\";\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-end:after {\n  right: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-start:after {\n  left: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.month {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  width: 166px;\n  height: inherit;\n  margin: 6px 10px;\n  padding: 4px 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #2638a6;\n  line-height: inherit;\n  border-color: #2638a6;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.muted:not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .day:not(.muted):not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .month:hover,\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .year:hover {\n  /* stylelint-disable declaration-no-important  */\n  border-color: #1b266f !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view > div {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 0;\n  line-height: 1;\n  color: #1b266f;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header span {\n  display: flex;\n  float: none;\n  width: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  justify-content: center;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .day__month_btn {\n  flex: 2;\n  margin: auto;\n  justify-content: center;\n  font-weight: 700;\n  color: #2638a6;\n}\n.is-day-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  justify-content: space-between;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  margin: 0 10px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:not(.disabled):hover,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:not(.disabled):hover {\n  background: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:after,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:after {\n  display: none;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next .tf-button {\n  margin-left: auto;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev .tf-button {\n  margin-right: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar {\n  width: 380px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar,\n.tf-datepicker-container.vdp-datepicker__calendar header {\n  display: flex;\n}\n.tf-datepicker-container.vdp-datepicker__calendar span.today {\n  background: transparent;\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */", map: {"version":3,"sources":["TfDatepicker.vue","/home/circleci/repo/src/components/TfDatepicker.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACsFpC,sDAAA;AACA,yCAAA;AACA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;ADpFA;ACsFA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;ADpFA;ACsFA;EACA,qBAAA;EACA,gBAAA;ADpFA;AC0FA;EACA,kBAAA;EACA,eAAA;ADxFA;AC0FA;EACA,cAAA;ADxFA;AC2FA;EACA,cAAA;ADzFA;AC2FA;EACA,mBAAA;ADzFA;AC6FA;EAKA,6BAAA;AD/FA;ACiGA;;;;;;EAEA,+CAAA;EACA,oCAAA;EACA,sBAAA;EACA,8CAAA;AD3FA;AC+FA;EACA,6BAAA;AD7FA;AC+FA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;AD7FA;ACgGA;EACA,UAAA;AD9FA;ACiGA;EACA,SAAA;AD/FA;ACmGA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAGA,eAAA;EACA,gBAAA;EAGA,cAAA;EACA,oBAAA;EACA,qBAAA;ADrGA;ACwGA;EACA,yBAAA;ADtGA;AC0GA;EACA,yBAAA;ADxGA;AC4GA;;EAEA,gDAAA;EACA,gCAAA;EACA,+CAAA;AD1GA;ACgHA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AD9GA;ACiHA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AD/GA;ACiHA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AD/GA;ACkHA;;EAEA,uBAAA;ADhHA;ACmHA;EACA,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;ADjHA;ACoHA;EACA,8BAAA;ADlHA;ACqHA;EACA,cAAA;ADnHA;ACwHA;;EACA,uBAAA;ADrHA;ACwHA;;EACA,aAAA;ADrHA;ACyHA;EACA,iBAAA;ADvHA;AC0HA;EACA,kBAAA;ADxHA;AC6HA;EACA,YAAA;AD3HA;AC8HA;;EAEA,aAAA;AD5HA;AC+HA;EACA,uBAAA;EACA,gBAAA;AD7HA;;AAEA,2CAA2C","file":"TfDatepicker.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/* stylelint-disable selector-max-compound-selectors */\n/* stylelint-disable max-nesting-depth  */\n.tf-datepicker-container.vdp-datepicker__calendar {\n  flex-direction: row;\n  justify-content: center;\n  box-shadow: none;\n  border-color: #c1c1c1;\n  z-index: 2001;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  border: 1px solid transparent;\n  border-radius: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .custom-day:hover {\n  border-color: #2638a6;\n  background: #fff;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell {\n  position: relative;\n  font-size: 12px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.day-header {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled {\n  color: #c1c1c1;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.disabled > .custom-day:hover {\n  border: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected:hover .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.selected.highlighted .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-start .custom-day, .tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end.month,\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlight-end .custom-day {\n  /* stylelint-disable declaration-no-important */\n  background-color: #2638a6 !important;\n  color: #fff !important;\n  /* stylelint-enable declaration-no-important */\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted {\n  background-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted:after {\n  position: absolute;\n  height: 27px;\n  top: calc(50% - 18px);\n  left: -1px;\n  right: -1px;\n  background-color: #f4f5ff;\n  content: \"\";\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-end:after {\n  right: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.highlighted.highlight-start:after {\n  left: 50%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.month {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  width: 166px;\n  height: inherit;\n  margin: 6px 10px;\n  padding: 4px 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #2638a6;\n  line-height: inherit;\n  border-color: #2638a6;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .cell.muted:not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div .day:not(.muted):not(.disabled):hover {\n  border-color: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .month:hover,\n.tf-datepicker-container.vdp-datepicker__calendar div:not(.muted):not(.disabled) .year:hover {\n  /* stylelint-disable declaration-no-important  */\n  border-color: #1b266f !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view > div {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 0;\n  line-height: 1;\n  color: #1b266f;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header span {\n  display: flex;\n  float: none;\n  width: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  justify-content: center;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .day__month_btn {\n  flex: 2;\n  margin: auto;\n  justify-content: center;\n  font-weight: 700;\n  color: #2638a6;\n}\n.is-day-only .tf-datepicker-container.vdp-datepicker__calendar .picker-view header {\n  justify-content: space-between;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .month__year_btn {\n  margin: 0 10px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:not(.disabled):hover,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:not(.disabled):hover {\n  background: transparent;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next:after,\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev:after {\n  display: none;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .next .tf-button {\n  margin-left: auto;\n}\n.tf-datepicker-container.vdp-datepicker__calendar .picker-view header .prev .tf-button {\n  margin-right: auto;\n}\n.is-month-only .tf-datepicker-container.vdp-datepicker__calendar {\n  width: 380px;\n}\n.tf-datepicker-container.vdp-datepicker__calendar,\n.tf-datepicker-container.vdp-datepicker__calendar header {\n  display: flex;\n}\n.tf-datepicker-container.vdp-datepicker__calendar span.today {\n  background: transparent;\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=TfDatepicker.vue.map */","<template>\n  <datepicker\n    v-bind=\"{\n      ...$attrs,\n      ...$props,\n      minimumView: viewType,\n      maximumView: viewType,\n      wrapperClass,\n    }\"\n    calendar-class=\"tf-datepicker-container\"\n    v-on=\"$listeners\"\n  >\n    <span\n      slot=\"dayCellContent\"\n      slot-scope=\"{ cell }\"\n      class=\"custom-day\"\n      v-text=\"cell.date || ''\"\n    />\n    <tf-button\n      slot=\"prevIntervalBtn\"\n      type=\"primary\"\n      icon=\"angle-left\"\n      size=\"icon-no-fill\"\n      no-border\n    />\n    <tf-button\n      slot=\"nextIntervalBtn\"\n      type=\"primary\"\n      icon=\"angle-right\"\n      size=\"icon-no-fill\"\n      no-border\n    />\n  </datepicker>\n</template>\n<script>\n  import Datepicker from '@sum.cumo/vue-datepicker/dist/Datepicker';\n\n  export default {\n    name: 'TfDatepicker',\n    components: { Datepicker },\n    inheritAttrs: false,\n    props: {\n      format: {\n        type: String,\n        default: 'MM/dd/yy',\n      },\n      value: {\n        type: [String, Date],\n        default: '',\n      },\n      viewType: {\n        type: String,\n        default: 'day',\n        validator: (value) => ['day', 'month'].includes(value),\n      },\n    },\n    computed: {\n      /**\n       * Set individual class names for styling purposes.\n       *\n       * @returns {object}\n       */\n      wrapperClass() {\n        return {\n          'tf-datepicker': true,\n          'is-month-only': this.viewType === 'month',\n          'is-day-only': this.viewType === 'day',\n        };\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  ::v-deep {\n    input {\n      height: 30px;\n      border: 1px solid $tf-light-gray;\n      border-radius: 2px;\n      color: $tf-dark-gray;\n      padding: 0 10px;\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  // This is an unscoped style block to account for appendToBody:true for <tf-datepicker />\n  @import 'src/assets/styles/variables';\n\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  .tf-datepicker-container.vdp-datepicker__calendar {\n    flex-direction: row;\n    justify-content: center;\n    box-shadow: none;\n    border-color: $tf-light-gray;\n    z-index: 2001;\n\n    .custom-day {\n      position: relative;\n      z-index: 2;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 31px;\n      height: 31px;\n      border: 1px solid transparent;\n      border-radius: 100%;\n\n      &:hover {\n        border-color: $tf-blue;\n        background: $tf-white;\n      }\n    }\n\n    div {\n      // Override all the cell data styles\n      .cell {\n        position: relative;\n        font-size: 12px;\n\n        &.day-header {\n          color: $tf-light-gray;\n        }\n\n        &.disabled {\n          color: $tf-light-gray;\n\n          >.custom-day:hover {\n            border: transparent;\n          }\n        }\n\n        &.selected,\n        &.selected:hover,\n        &.selected.highlighted,\n        &.highlight-start,\n        &.highlight-end {\n          background-color: transparent;\n\n          &.month,\n          .custom-day {\n            /* stylelint-disable declaration-no-important */\n            background-color: $tf-blue !important;\n            color: $tf-white !important;\n            /* stylelint-enable declaration-no-important */\n          }\n        }\n\n        &.highlighted {\n          background-color: transparent;\n\n          &:after {\n            position: absolute;\n            height: 27px;\n            top: calc(50% - 18px);\n            left: -1px;\n            right: -1px;\n            background-color: $tf-light-blue;\n            content: '';\n          }\n\n          &.highlight-end:after {\n            right: 50%;\n          }\n\n          &.highlight-start:after {\n            left: 50%;\n          }\n        }\n\n        &.month {\n          display: flex;\n          align-content: center;\n          justify-content: center;\n          width: 166px;\n          height: inherit;\n          margin: 6px 10px;\n          padding: 4px 0;\n\n          font: {\n            size: 14px;\n            weight: 700;\n          }\n\n          color: $tf-blue;\n          line-height: inherit;\n          border-color: $tf-blue;\n        }\n\n        &.muted:not(.disabled):hover {\n          border-color: transparent;\n        }\n      }\n\n      .day:not(.muted):not(.disabled):hover {\n        border-color: transparent;\n      }\n\n      &:not(.muted):not(.disabled) {\n        .month:hover,\n        .year:hover {\n          /* stylelint-disable declaration-no-important  */\n          border-color: $tf-dark-blue !important;\n          /* stylelint-enable declaration-no-important  */\n        }\n      }\n    }\n\n    .picker-view {\n      > div {\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        width: 100%;\n      }\n\n      header {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding: 10px 0;\n        line-height: 1;\n        color: $tf-dark-blue;\n\n        span {\n          display: flex;\n          float: none;\n          width: auto;\n        }\n\n        .is-month-only &,\n        .month__year_btn {\n          justify-content: center;\n        }\n\n        .day__month_btn {\n          flex: 2;\n          margin: auto;\n          justify-content: center;\n          font-weight: 700;\n          color: $tf-blue;\n        }\n\n        .is-day-only & {\n          justify-content: space-between;\n        }\n\n        .month__year_btn {\n          margin: 0 10px;\n        }\n\n        .next,\n        .prev {\n          &:not(.disabled):hover {\n            background: transparent;\n          }\n\n          &:after {\n            display: none;\n          }\n        }\n\n        .next .tf-button {\n          margin-left: auto;\n        }\n\n        .prev .tf-button {\n          margin-right: auto;\n        }\n      }\n    }\n\n    .is-month-only & {\n      width: 380px;\n    }\n\n    &,\n    header {\n      display: flex;\n    }\n\n    span.today {\n      background: transparent;\n      font-weight: 700;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$I = "data-v-97163d22";
  /* module identifier */
  const __vue_module_identifier__$I = undefined;
  /* functional template */
  const __vue_is_functional_template__$I = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$I = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
    __vue_inject_styles__$I,
    __vue_script__$I,
    __vue_scope_id__$I,
    __vue_is_functional_template__$I,
    __vue_module_identifier__$I,
    false,
    browser,
    undefined,
    undefined
  );

function _arrayWithHoles(arr) {
  if (isArray$2(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof symbol$1 !== "undefined" && arr[iterator$1] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var script$J = {
  name: 'TfFilterDateRange',
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      datepickerOptions: {
        inline: true,
        maximumView: 'day',
        minimumView: 'day'
      },
      localSelectedDate: {
        end: '',
        start: ''
      },
      openDate: null,
      selectedValueType: 'from'
    };
  },
  computed: {
    /**
     * Create an object with 'from' and 'to' based on the model value.
     * 'from' and 'to' should be dates or empty strings.
     *
     * @returns {object}
     */
    highlighted: function highlighted() {
      var _ref = this.value || ['', ''],
          _ref2 = _slicedToArray(_ref, 2),
          from = _ref2[0],
          to = _ref2[1];

      var resetTime = function resetTime(value) {
        return new Date(value.setHours(0, 0, 0, 0));
      };

      return {
        from: from ? resetTime(from) : '',
        to: to ? resetTime(to) : ''
      };
    },

    /**
     * Format 'from' and 'to' from this.highlighted into date strings for the input values.
     * 'from' and 'to' should be formatted strings or empty strings.
     *
     * @returns {object}
     */
    inputValues: function inputValues() {
      var _this = this;

      var _this$highlighted = this.highlighted,
          from = _this$highlighted.from,
          to = _this$highlighted.to;

      var format = function format(value) {
        return _this.$TF.DatesUtils.formatSimpleDate(value, 'MM/DD/YY');
      };

      return {
        from: from ? format(from) : '',
        to: to ? format(to) : ''
      };
    },

    /**
     * Add one month to this.openDate and format it to a string.
     *
     * @returns {string}
     */
    openToDate: function openToDate() {
      return new Date(moment(this.openDate).add(1, 'months'));
    }
  },
  created: function created() {
    var openDate = this.highlighted.from ? new Date(this.highlighted.from) : new Date();
    this.openDate = openDate;
  },
  methods: {
    /**
     * Subtract or add 2 months to this.openDate based on the passed param.
     *
     * @param {string} calendarType
     */
    changeMonth: function changeMonth(calendarType) {
      var openDate = moment(this.openDate);

      if (calendarType === 'start') {
        openDate = openDate.subtract(2, 'months');
      } else if (calendarType === 'end') {
        openDate = openDate.add(2, 'months');
      }

      this.openDate = new Date(openDate);
    },

    /**
     * Changes the open date and to today's date, sets the 'from' value to today's date, and focuses on the 'to' input.
     */
    changeToToday: function changeToToday() {
      var openDate = new Date();
      this.openDate = openDate;
      this.selectedValueType = 'to';
      this.localSelectedDate.start = openDate;
      this.localSelectedDate.end = '';
      this.$emit('input', [openDate, '']);
    },

    /**
     * Focus on the first checkbox.
     *
     * @param {string} value
     */
    focusInput: function focusInput(value) {
      this.selectedValueType = value;
      this.$refs["input-".concat(value)][0].$el.querySelector('input').blur();
    },

    /**
     * $emit 'input' with new "from" and "to" dates.
     * Update this.selectedValueType based on different scenarios.
     * Clear the localSelectedDate start and end values as well,
     * followed by setting the selected value for that calendar appropriately.
     * This is to hack some of the logic for the datepicker component.
     *
     * @param {object} value
     * @param {string} calendarType
     */
    selectDate: function selectDate(value, calendarType) {
      var _this$highlighted2 = this.highlighted,
          from = _this$highlighted2.from,
          to = _this$highlighted2.to;
      var selectedValueType;
      this.localSelectedDate.start = '';
      this.localSelectedDate.end = '';

      if (this.selectedValueType === 'from') {
        from = value;
        selectedValueType = 'to';

        if (to && moment(value).isSameOrAfter(to)) {
          to = value;
        }
      } else if (this.selectedValueType === 'to') {
        selectedValueType = 'from';
        to = value;

        if (from && moment(value).isSameOrBefore(from)) {
          from = value;
          selectedValueType = 'to';
        }
      }

      this.localSelectedDate[calendarType] = value;
      this.$emit('input', [from, to]);
      this.selectedValueType = selectedValueType;
    }
  }
};

/* script */
const __vue_script__$J = script$J;

/* template */
var __vue_render__$I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "filter-date-range-container" },
    [
      _c(
        "tf-form",
        { attrs: { "label-position": "top" } },
        _vm._l(["from", "to"], function(input) {
          return _c(
            "tf-form-item",
            { key: input, attrs: { for: input, label: input } },
            [
              _c(
                "tf-input",
                {
                  ref: "input-" + input,
                  refInFor: true,
                  class: { "is-active": _vm.selectedValueType === input },
                  attrs: {
                    value: _vm.inputValues[input],
                    readonly: "",
                    placeholder: "Select Date"
                  },
                  on: {
                    focus: function($event) {
                      return _vm.focusInput(input)
                    }
                  }
                },
                [
                  _c("icon", {
                    attrs: { slot: "prefix", name: "regular/calendar-alt" },
                    slot: "prefix"
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm._l(["start", "end"], function(calendarType) {
        return _c(
          "div",
          { key: calendarType, class: "calendar-" + calendarType },
          [
            _c(
              "tf-datepicker",
              _vm._b(
                {
                  on: {
                    "changed-decade": function($event) {
                      return _vm.changeMonth(calendarType)
                    },
                    "changed-month": function($event) {
                      return _vm.changeMonth(calendarType)
                    },
                    selected: function($event) {
                      return _vm.selectDate($event, calendarType)
                    }
                  }
                },
                "tf-datepicker",
                Object.assign({}, _vm.datepickerOptions, {
                  highlighted: _vm.highlighted,
                  openDate:
                    calendarType === "start" ? _vm.openDate : _vm.openToDate,
                  value: _vm.localSelectedDate[calendarType],
                  showEdgeDates: false
                }),
                false
              )
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("tf-button", {
        staticClass: "btn-to-current",
        attrs: { type: "primary", size: "text-small" },
        domProps: { textContent: _vm._s("Back to Today") },
        on: { click: _vm.changeToToday }
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$I = [];
__vue_render__$I._withStripped = true;

  /* style */
  const __vue_inject_styles__$J = function (inject) {
    if (!inject) return
    inject("data-v-781e0333_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.btn-to-current[data-v-781e0333] {\n  margin: 10px 0 20px;\n}\n\n/* stylelint-disable selector-max-compound-selectors */\n.calendar-start[data-v-781e0333] {\n  margin-right: 75px;\n}\n.calendar-start[data-v-781e0333]  header .next {\n  display: none !important;\n}\n.calendar-start[data-v-781e0333]  header .prev {\n  flex: 1;\n}\n.calendar-start[data-v-781e0333]  header:after {\n  flex: 1;\n  content: \"\";\n}\n.calendar-end[data-v-781e0333]  header .next {\n  flex: 1;\n}\n.calendar-end[data-v-781e0333]  header .prev {\n  display: none !important;\n}\n.calendar-end[data-v-781e0333]  header:before {\n  flex: 1;\n  content: \"\";\n}\n\n/* stylelint-enable selector-max-compound-selectors */\nform[data-v-781e0333],\n.el-input[data-v-781e0333] {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n.el-form-item[data-v-781e0333] {\n  margin-bottom: 10px;\n}\n[data-v-781e0333] .el-form-item__label {\n  text-transform: capitalize;\n  font-weight: 600;\n  line-height: inherit;\n}\n.filter-date-range-container[data-v-781e0333] {\n  display: flex;\n  flex-flow: wrap;\n  width: 675px;\n  padding: 10px 20px;\n}\n[data-v-781e0333] .el-input {\n  width: 120px;\n  margin-right: 20px;\n}\n[data-v-781e0333] .el-input__prefix {\n  top: 6px;\n}\n[data-v-781e0333] .el-input__inner:focus {\n  border-color: inherit;\n}\n\n/*# sourceMappingURL=DateRange.vue.map */", map: {"version":3,"sources":["DateRange.vue","/home/circleci/repo/src/components/TfFilter/DateRange.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACwMpC;EACA,mBAAA;ADtMA;;ACyMA,sDAAA;AACA;EACA,kBAAA;ADtMA;ACyMA;EACA,wBAAA;ADvMA;AC0MA;EACA,OAAA;ADxMA;AC2MA;EACA,OAAA;EACA,WAAA;ADzMA;ACgNA;EACA,OAAA;AD7MA;ACgNA;EACA,wBAAA;AD9MA;ACiNA;EACA,OAAA;EACA,WAAA;AD/MA;;ACmNA,qDAAA;AACA;;EAEA,aAAA;EACA,mBAAA;EACA,WAAA;ADhNA;ACmNA;EACA,mBAAA;ADhNA;ACkNA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;ADhNA;ACoNA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;ADjNA;ACoNA;EACA,YAAA;EACA,kBAAA;ADjNA;ACmNA;EACA,QAAA;ADjNA;ACoNA;EACA,qBAAA;ADlNA;;AAEA,wCAAwC","file":"DateRange.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.btn-to-current {\n  margin: 10px 0 20px;\n}\n\n/* stylelint-disable selector-max-compound-selectors */\n.calendar-start {\n  margin-right: 75px;\n}\n.calendar-start ::v-deep header .next {\n  display: none !important;\n}\n.calendar-start ::v-deep header .prev {\n  flex: 1;\n}\n.calendar-start ::v-deep header:after {\n  flex: 1;\n  content: \"\";\n}\n\n.calendar-end ::v-deep header .next {\n  flex: 1;\n}\n.calendar-end ::v-deep header .prev {\n  display: none !important;\n}\n.calendar-end ::v-deep header:before {\n  flex: 1;\n  content: \"\";\n}\n\n/* stylelint-enable selector-max-compound-selectors */\nform,\n.el-input {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.el-form-item {\n  margin-bottom: 10px;\n}\n::v-deep .el-form-item__label {\n  text-transform: capitalize;\n  font-weight: 600;\n  line-height: inherit;\n}\n\n.filter-date-range-container {\n  display: flex;\n  flex-flow: wrap;\n  width: 675px;\n  padding: 10px 20px;\n}\n\n::v-deep .el-input {\n  width: 120px;\n  margin-right: 20px;\n}\n::v-deep .el-input__prefix {\n  top: 6px;\n}\n::v-deep .el-input__inner:focus {\n  border-color: inherit;\n}\n\n/*# sourceMappingURL=DateRange.vue.map */","<template>\n  <div class=\"filter-date-range-container\">\n    <tf-form label-position=\"top\">\n      <tf-form-item\n        v-for=\"input in [ 'from', 'to' ]\"\n        :key=\"input\"\n        :for=\"input\"\n        :label=\"input\"\n      >\n        <tf-input\n          :ref=\"`input-${input}`\"\n          :class=\"{ 'is-active': selectedValueType === input }\"\n          :value=\"inputValues[input]\"\n          readonly\n          placeholder=\"Select Date\"\n          @focus=\"focusInput(input)\"\n        >\n          <icon\n            slot=\"prefix\"\n            name=\"regular/calendar-alt\"\n          />\n        </tf-input>\n      </tf-form-item>\n    </tf-form>\n    <div\n      v-for=\"calendarType in [ 'start', 'end' ]\"\n      :key=\"calendarType\"\n      :class=\"`calendar-${calendarType}`\"\n    >\n      <!-- Temporarily watching the @changed-decade event because of a Datepicker bug -->\n      <!-- Follow bug at: https://github.com/sumcumo/vue-datepicker/issues/121 -->\n      <tf-datepicker\n        v-bind=\"{\n          ...datepickerOptions,\n          highlighted,\n          openDate: calendarType === 'start' ? openDate : openToDate,\n          value: localSelectedDate[calendarType],\n          showEdgeDates: false,\n        }\"\n        @changed-decade=\"changeMonth(calendarType)\"\n        @changed-month=\"changeMonth(calendarType)\"\n        @selected=\"selectDate($event, calendarType)\"\n      />\n    </div>\n    <tf-button\n      class=\"btn-to-current\"\n      type=\"primary\"\n      size=\"text-small\"\n      @click=\"changeToToday\"\n      v-text=\"'Back to Today'\"\n    />\n  </div>\n</template>\n<script>\n  import moment from 'moment';\n\n  export default {\n    name: 'TfFilterDateRange',\n    props: {\n      value: {\n        type: Array,\n        required: true,\n      },\n    },\n    data: () => ({\n      datepickerOptions: {\n        inline: true,\n        maximumView: 'day',\n        minimumView: 'day',\n      },\n      localSelectedDate: {\n        end: '',\n        start: '',\n      },\n      openDate: null,\n      selectedValueType: 'from',\n    }),\n    computed: {\n      /**\n       * Create an object with 'from' and 'to' based on the model value.\n       * 'from' and 'to' should be dates or empty strings.\n       *\n       * @returns {object}\n       */\n      highlighted() {\n        const [from, to] = this.value || ['', ''];\n        const resetTime = (value) => new Date(value.setHours(0, 0, 0, 0));\n\n        return {\n          from: from ? resetTime(from) : '',\n          to: to ? resetTime(to) : '',\n        };\n      },\n      /**\n       * Format 'from' and 'to' from this.highlighted into date strings for the input values.\n       * 'from' and 'to' should be formatted strings or empty strings.\n       *\n       * @returns {object}\n       */\n      inputValues() {\n        const { from, to } = this.highlighted;\n        const format = (value) => this.$TF.DatesUtils.formatSimpleDate(value, 'MM/DD/YY');\n\n        return {\n          from: from ? format(from) : '',\n          to: to ? format(to) : '',\n        };\n      },\n      /**\n       * Add one month to this.openDate and format it to a string.\n       *\n       * @returns {string}\n       */\n      openToDate() {\n        return new Date(moment(this.openDate).add(1, 'months'));\n      },\n    },\n    created() {\n      const openDate = this.highlighted.from ? new Date(this.highlighted.from) : new Date();\n\n      this.openDate = openDate;\n    },\n    methods: {\n      /**\n       * Subtract or add 2 months to this.openDate based on the passed param.\n       *\n       * @param {string} calendarType\n       */\n      changeMonth(calendarType) {\n        let openDate = moment(this.openDate);\n\n        if (calendarType === 'start') {\n          openDate = openDate.subtract(2, 'months');\n        } else if (calendarType === 'end') {\n          openDate = openDate.add(2, 'months');\n        }\n\n        this.openDate = new Date(openDate);\n      },\n      /**\n       * Changes the open date and to today's date, sets the 'from' value to today's date, and focuses on the 'to' input.\n       */\n      changeToToday() {\n        const openDate = new Date();\n\n        this.openDate = openDate;\n        this.selectedValueType = 'to';\n        this.localSelectedDate.start = openDate;\n        this.localSelectedDate.end = '';\n        this.$emit('input', [openDate, '']);\n      },\n      /**\n       * Focus on the first checkbox.\n       *\n       * @param {string} value\n       */\n      focusInput(value) {\n        this.selectedValueType = value;\n        this.$refs[`input-${value}`][0].$el.querySelector('input').blur();\n      },\n      /**\n       * $emit 'input' with new \"from\" and \"to\" dates.\n       * Update this.selectedValueType based on different scenarios.\n       * Clear the localSelectedDate start and end values as well,\n       * followed by setting the selected value for that calendar appropriately.\n       * This is to hack some of the logic for the datepicker component.\n       *\n       * @param {object} value\n       * @param {string} calendarType\n       */\n      selectDate(value, calendarType) {\n        let { from, to } = this.highlighted;\n        let selectedValueType;\n\n        this.localSelectedDate.start = '';\n        this.localSelectedDate.end = '';\n\n        if (this.selectedValueType === 'from') {\n          from = value;\n          selectedValueType = 'to';\n\n          if (to && moment(value).isSameOrAfter(to)) {\n            to = value;\n          }\n        } else if (this.selectedValueType === 'to') {\n          selectedValueType = 'from';\n          to = value;\n\n          if (from && moment(value).isSameOrBefore(from)) {\n            from = value;\n            selectedValueType = 'to';\n          }\n        }\n\n        this.localSelectedDate[calendarType] = value;\n        this.$emit('input', [from, to]);\n        this.selectedValueType = selectedValueType;\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .btn-to-current {\n    margin: 10px 0 20px;\n  }\n\n  /* stylelint-disable selector-max-compound-selectors */\n  .calendar-start {\n    margin-right: 75px;\n\n    ::v-deep header {\n      .next {\n        display: none !important; // stylelint-disable-line\n      }\n\n      .prev {\n        flex: 1;\n      }\n\n      &:after {\n        flex: 1;\n        content: '';\n      }\n    }\n  }\n\n  .calendar-end {\n    ::v-deep header {\n      .next {\n        flex: 1;\n      }\n\n      .prev {\n        display: none !important; // stylelint-disable-line\n      }\n\n      &:before {\n        flex: 1;\n        content: '';\n      }\n    }\n  }\n  /* stylelint-enable selector-max-compound-selectors */\n  form,\n  .el-input {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n  }\n\n  .el-form-item {\n    margin-bottom: 10px;\n\n    ::v-deep &__label {\n      text-transform: capitalize;\n      font-weight: 600;\n      line-height: inherit;\n    }\n  }\n\n  .filter-date-range-container {\n    display: flex;\n    flex-flow: wrap;\n    width: 675px;\n    padding: 10px 20px;\n  }\n\n  ::v-deep .el-input {\n    width: 120px;\n    margin-right: 20px;\n\n    &__prefix {\n      top: 6px;\n    }\n\n    &__inner:focus {\n      border-color: inherit;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$J = "data-v-781e0333";
  /* module identifier */
  const __vue_module_identifier__$J = undefined;
  /* functional template */
  const __vue_is_functional_template__$J = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$J = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
    __vue_inject_styles__$J,
    __vue_script__$J,
    __vue_scope_id__$J,
    __vue_is_functional_template__$J,
    __vue_module_identifier__$J,
    false,
    browser,
    undefined,
    undefined
  );

//
var script$K = {
  name: 'TfFilterDate',
  components: {
    TfFilterDateRange: __vue_component__$J
  },
  props: {
    dateType: {
      type: String,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      dateOptions: [{
        text: 'Month',
        value: 'month'
      }, {
        text: 'Choose Range',
        value: 'date-range'
      }],
      openDate: new Date()
    };
  },
  computed: {
    /**
     * get: The first value of the model array if the dateType is month,
     * otherwise get the first array in the model or an empty array.
     * set: $emit the value wrapped in an array.
     */
    localValue: {
      get: function get() {
        return this.dateType === 'month' ? this.value[0] : this.value[0] || [];
      },
      set: function set(value) {
        this.$emit('input', [value]);
      }
    }
  },
  methods: {
    /**
     * Sets the open Date to today's date and emits "input" with that same value.
     */
    changeToCurrentMonth: function changeToCurrentMonth() {
      this.openDate = new Date();
      this.$emit('input', [this.openDate]);
    }
  }
};

/* script */
const __vue_script__$K = script$K;

/* template */
var __vue_render__$J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm.filter.type === "month-and-date-range"
        ? _c(
            "header",
            [
              _c(
                "div",
                { staticClass: "btn-group" },
                _vm._l(_vm.dateOptions, function(option) {
                  return _c("tf-button", {
                    key: option.value,
                    staticClass: "btn-type-selector",
                    attrs: {
                      disabled: _vm.dateType === option.value,
                      type: "primary",
                      size: "text-small"
                    },
                    domProps: { textContent: _vm._s(option.text) },
                    on: {
                      click: function($event) {
                        return _vm.$emit("changeDateFilterType", option.value)
                      }
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("tf-button", {
                attrs: {
                  type: "secondary",
                  icon: "times",
                  size: "icon-no-fill"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("closePopover", true)
                  }
                }
              })
            ],
            1
          )
        : _c("tf-button", {
            class: [
              "btn-close-popover",
              { "btn-close-month": _vm.filter.type === "month" }
            ],
            attrs: { type: "secondary", icon: "times", size: "icon-no-fill" },
            on: {
              click: function($event) {
                return _vm.$emit("closePopover", true)
              }
            }
          }),
      _vm._v(" "),
      _vm.dateType === "month"
        ? [
            _c(
              "tf-datepicker",
              _vm._b(
                {
                  model: {
                    value: _vm.localValue,
                    callback: function($$v) {
                      _vm.localValue = $$v;
                    },
                    expression: "localValue"
                  }
                },
                "tf-datepicker",
                {
                  inline: true,
                  viewType: "month",
                  openDate: _vm.openDate
                },
                false
              )
            ),
            _vm._v(" "),
            _c("tf-button", {
              staticClass: "btn-to-current",
              attrs: { type: "primary", size: "text-small" },
              domProps: { textContent: _vm._s("Back to Current Month") },
              on: { click: _vm.changeToCurrentMonth }
            })
          ]
        : _vm.dateType === "date-range"
        ? _c("tf-filter-date-range", {
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v;
              },
              expression: "localValue"
            }
          })
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__$J = [];
__vue_render__$J._withStripped = true;

  /* style */
  const __vue_inject_styles__$K = function (inject) {
    if (!inject) return
    inject("data-v-4fbbbe2e_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n[data-v-4fbbbe2e] .vdp-datepicker__calendar {\n  position: relative;\n}\nheader[data-v-4fbbbe2e] {\n  display: flex;\n  height: 42px;\n  padding: 0 20px;\n  border-bottom: 1px solid #999;\n}\nheader .tf-button--icon-no-fill[data-v-4fbbbe2e],\nheader .wt-button--icon-no-fill[data-v-4fbbbe2e] {\n  margin-left: auto;\n}\n.btn-close-popover[data-v-4fbbbe2e] {\n  position: absolute;\n  z-index: 101;\n  top: 15px;\n  right: 15px;\n}\n.btn-close-popover.btn-close-month[data-v-4fbbbe2e] {\n  z-index: 10001;\n  top: 10px;\n  right: 10px;\n}\n.btn-type-selector[data-v-4fbbbe2e] {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.btn-type-selector.is-disabled[data-v-4fbbbe2e] {\n  font-weight: 600;\n}\n.btn-to-current[data-v-4fbbbe2e] {\n  margin: 15px 0 30px 18px;\n}\n\n/*# sourceMappingURL=Date.vue.map */", map: {"version":3,"sources":["Date.vue","/home/circleci/repo/src/components/TfFilter/Date.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC+GpC;EACA,kBAAA;AD7GA;ACgHA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AD7GA;AC+GA;;EAEA,iBAAA;AD7GA;ACkHA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AD/GA;ACiHA;EACA,cAAA;EACA,SAAA;EACA,WAAA;AD/GA;ACmHA;EACA,gBAAA;EACA,yBAAA;ADjHA;ACmHA;EACA,gBAAA;ADjHA;ACqHA;EACA,wBAAA;ADnHA;;AAEA,mCAAmC","file":"Date.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n::v-deep .vdp-datepicker__calendar {\n  position: relative;\n}\n\nheader {\n  display: flex;\n  height: 42px;\n  padding: 0 20px;\n  border-bottom: 1px solid #999;\n}\nheader .tf-button--icon-no-fill,\nheader .wt-button--icon-no-fill {\n  margin-left: auto;\n}\n\n.btn-close-popover {\n  position: absolute;\n  z-index: 101;\n  top: 15px;\n  right: 15px;\n}\n.btn-close-popover.btn-close-month {\n  z-index: 10001;\n  top: 10px;\n  right: 10px;\n}\n.btn-type-selector {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.btn-type-selector.is-disabled {\n  font-weight: 600;\n}\n.btn-to-current {\n  margin: 15px 0 30px 18px;\n}\n\n/*# sourceMappingURL=Date.vue.map */","<template>\n  <div>\n    <header v-if=\"filter.type === 'month-and-date-range'\">\n      <div class=\"btn-group\">\n        <tf-button\n          v-for=\"option in dateOptions\"\n          :key=\"option.value\"\n          :disabled=\"dateType === option.value\"\n          type=\"primary\"\n          class=\"btn-type-selector\"\n          size=\"text-small\"\n          @click=\"$emit('changeDateFilterType', option.value)\"\n          v-text=\"option.text\"\n        />\n      </div>\n      <tf-button\n        type=\"secondary\"\n        icon=\"times\"\n        size=\"icon-no-fill\"\n        @click=\"$emit('closePopover', true)\"\n      />\n    </header>\n    <tf-button\n      v-else\n      :class=\"[\n        'btn-close-popover',\n        { 'btn-close-month': filter.type === 'month' }\n      ]\"\n      type=\"secondary\"\n      icon=\"times\"\n      size=\"icon-no-fill\"\n      @click=\"$emit('closePopover', true)\"\n    />\n    <template v-if=\"dateType === 'month'\">\n      <tf-datepicker\n        v-model=\"localValue\"\n        v-bind=\"{\n          inline: true,\n          viewType: 'month',\n          openDate\n        }\"\n      />\n      <tf-button\n        class=\"btn-to-current\"\n        type=\"primary\"\n        size=\"text-small\"\n        @click=\"changeToCurrentMonth\"\n        v-text=\"'Back to Current Month'\"\n      />\n    </template>\n    <tf-filter-date-range\n      v-else-if=\"dateType === 'date-range'\"\n      v-model=\"localValue\"\n    />\n  </div>\n</template>\n<script>\n  import TfFilterDateRange from './DateRange';\n\n  export default {\n    name: 'TfFilterDate',\n    components: { TfFilterDateRange },\n    props: {\n      dateType: {\n        type: String,\n        required: true,\n      },\n      filter: {\n        type: Object,\n        required: true,\n      },\n      value: {\n        type: Array,\n        required: true,\n      },\n    },\n    data: () => ({\n      dateOptions: [\n        { text: 'Month', value: 'month' },\n        { text: 'Choose Range', value: 'date-range' },\n      ],\n      openDate: new Date(),\n    }),\n    computed: {\n      /**\n       * get: The first value of the model array if the dateType is month,\n       * otherwise get the first array in the model or an empty array.\n       * set: $emit the value wrapped in an array.\n       */\n      localValue: {\n        get() {\n          return this.dateType === 'month'\n            ? this.value[0]\n            : this.value[0] || [];\n        },\n        set(value) {\n          this.$emit('input', [value]);\n        },\n      },\n    },\n    methods: {\n      /**\n       * Sets the open Date to today's date and emits \"input\" with that same value.\n       */\n      changeToCurrentMonth() {\n        this.openDate = new Date();\n        this.$emit('input', [this.openDate]);\n      },\n    },\n  };\n\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  ::v-deep .vdp-datepicker__calendar {\n    position: relative;\n  }\n\n  header {\n    display: flex;\n    height: 42px;\n    padding: 0 20px;\n    border-bottom: 1px solid $tf-medium-gray;\n\n    .tf-button--icon-no-fill,\n    .wt-button--icon-no-fill {\n      margin-left: auto;\n    }\n  }\n\n  .btn {\n    &-close-popover {\n      position: absolute;\n      z-index: 101;\n      top: 15px;\n      right: 15px;\n\n      &.btn-close-month {\n        z-index: 10001; // .vdp-datepicker__calendar has a z-index:10000\n        top: 10px;\n        right: 10px;\n      }\n    }\n\n    &-type-selector {\n      font-weight: 700;\n      text-transform: uppercase;\n\n      &.is-disabled {\n        font-weight: 600;\n      }\n    }\n\n    &-to-current {\n      margin: 15px 0 30px 18px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$K = "data-v-4fbbbe2e";
  /* module identifier */
  const __vue_module_identifier__$K = undefined;
  /* functional template */
  const __vue_is_functional_template__$K = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$K = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
    __vue_inject_styles__$K,
    __vue_script__$K,
    __vue_scope_id__$K,
    __vue_is_functional_template__$K,
    __vue_module_identifier__$K,
    false,
    browser,
    undefined,
    undefined
  );

var script$L = {
  components: {
    TfFilterDate: __vue_component__$K
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      required: true
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    valueKey: {
      type: String,
      default: 'value'
    }
  },
  data: function data(vm) {
    return {
      dateType: null,
      localValue: _toConsumableArray(vm.value),
      randomId: null,
      searchValue: '',
      showPopover: false
    };
  },
  computed: {
    /**
     * If the filter is a 'date-range' or 'month' dateType, then test for all values.
     *
     * @returns {Array}
     */
    disableBtns: function disableBtns() {
      var disableBtns = false;

      if (this.dateType === 'date-range') {
        disableBtns = this.localValue[0] ? this.localValue[0].includes('') : true;
      } else if (this.dateType === 'month') {
        disableBtns = !this.localValue[0];
      }

      return disableBtns;
    },

    /**
     * Map this.value to either the value or the appropriate label.
     * For filter types that are a range, we want to create this list
     * from this.filter.options since that has the appropriate order.
     *
     * @returns {Array}
     */
    displayOptions: function displayOptions() {
      var _this = this;

      var values = this.value.map(function (id) {
        var formatDate = function formatDate(dateValue) {
          var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD/YY';
          return _this.$TF.DatesUtils.formatSimpleDate(dateValue, format);
        };

        var text;

        if (_this.filter.type === 'range') {
          var _this$filter$options$ = _this.filter.options.find(function (_ref) {
            var localValue = _ref[_this.valueKey];
            return localValue === id;
          });

          text = _this$filter$options$[_this.labelKey];
        } else if (_this.filter.type === 'string') {
          text = id;
        } else if (_this.filter.dateType === 'month') {
          text = formatDate(id, 'MMMM YYYY');
        } else if (_this.filter.dateType === 'date-range') {
          var _id = _slicedToArray(id, 2),
              from = _id[0],
              to = _id[1];

          text = "".concat(formatDate(from), "-").concat(formatDate(to));
        }

        return {
          id: id,
          text: text
        };
      });
      var displayOptions;

      if (this.filter.type === 'range') {
        displayOptions = [];
        this.filter.options.forEach(function (option) {
          if (_this.value.includes(option[_this.valueKey])) {
            displayOptions.push({
              id: option[_this.valueKey],
              text: option[_this.labelKey]
            });
          }
        });
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        displayOptions = this.$TF.Formatting.sortObjects(values, 'text');
      }

      return displayOptions;
    },

    /**
     * Filter this.filter.options by this.searchValue if applicable.
     *
     * @returns {Array}
     */
    localOptions: function localOptions() {
      var _this2 = this;

      return this.searchValue ? this.filter.options.filter(function (_ref2) {
        var label = _ref2[_this2.labelKey];
        return label.toLowerCase().includes(_this2.searchValue.toLowerCase());
      }) : this.filter.options;
    },

    /**
     * Cache a string based on the filter's prop to be used throughout the template.
     *
     * @returns {string}
     */
    filterPropName: function filterPropName() {
      return "filter-".concat(this.filter.prop);
    }
  },
  watch: {
    /**
     * The reset button is controlled in the parent so we want to watch
     * for when the model is emptied from the parent to reset the local filter values.
     */
    value: function value() {
      if (!this.value.length) {
        this.resetFilters();
      }
    }
  },
  created: function created() {
    this.createRandomId();
    this.changeDateType();
  },
  methods: {
    /**
     * Close the popover and if there is a change in filter values,
     * $emit the localValue to the parent.
     */
    applyFilter: function applyFilter() {
      var _this3 = this;

      if (this.value.length === this.localValue.length && this.localValue.every(function (value) {
        return _this3.value.includes(value);
      })) {
        this.closePopover();
        return;
      }

      if (this.dateType) {
        this.$emit('changeDateFilterType', this.dateType);
      }

      this.$emit('input', this.localValue);
      this.closePopover();
    },

    /**
     * Clear or reset the localValue based on the passed param.
     * $emit the localValue to the parent.
     *
     * @param {string} dateFilterType
     */
    changeDateFilterType: function changeDateFilterType(dateFilterType) {
      var newLocalValue = this.filter.dateType === dateFilterType ? this.value : [];
      this.dateType = dateFilterType;
      this.$set(this, 'localValue', newLocalValue);
      /* Changing the filter type will change the content of the
       * popover but not inform the underlying Popover component
       * that it has been updated. Calling updatePopper explicitly
       * on tf-tooltip will schedule a re-render / repositioning */

      if (this.$refs['tf-tooltip'].updatePopper) {
        this.$refs['tf-tooltip'].updatePopper();
      }
    },

    /**
     * Clear or reset the localValue based on the passed param.
     * $emit the localValue to the parent.
     */
    changeDateType: function changeDateType() {
      if (!this.filter.dateType) {
        return;
      }

      var dateType = this.filter.dateType || this.filter.type;

      if (this.filter.type === 'month-and-date-range') {
        dateType = this.value[0] && Array.isArray(this.value[0]) ? 'date-range' : 'month';
      }

      this.dateType = dateType;
    },

    /**
     * Clear the search value, closes the popover.
     * Clear the localValue if desired.
     *
     * @param {boolean} resetValue
     */
    closePopover: function closePopover() {
      var resetValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.showPopover) {
        return;
      }

      this.showPopover = false;
      this.searchValue = '';

      if (resetValue) {
        this.$set(this, 'localValue', _toConsumableArray(this.value));
        this.changeDateType();
      } // I'm wrapping this due a test failure that
      // I'm not sure of a way around right now.
      // TypeError: this.$refs.tf-tooltip.doClose is not a function


      if (this.$refs['tf-tooltip'].doClose) {
        this.$refs['tf-tooltip'].doClose();
      }
    },

    /**
     * Create a random ID to use as a key for the calendars so changing an ID will redraw the component.
     */
    createRandomId: function createRandomId() {
      this.randomId = Math.floor(Math.random() * Math.floor(9999));
    },

    /**
     * If the user hits tab while focused on the main input,
     * we move the user to the next checkbox. Element does something odd
     * so this needs to be done on nextTick().
     *
     * @param {object} $event
     * @param {string} $event.shiftKey
     */
    focusOnCheckbox: function focusOnCheckbox(_ref3) {
      var _this4 = this;

      var shiftKey = _ref3.shiftKey;

      if (!shiftKey) {
        this.$nextTick(function () {
          _this4.$refs.checkbox[0].$el.querySelector('input').focus();
        });
      }
    },

    /**
     * Evaluate the the clicked element's name to close the popover and reset the values.
     *
     * @param {object} event
     */
    onClickOutside: function onClickOutside(event) {
      if ((event.target.name || event.target.getAttribute('data-prop-name')) === "".concat(this.filterPropName)) {
        return;
      }

      this.closePopover(true);
    },

    /**
     * Close popover with caret
     *
     */
    toggleIcon: function toggleIcon() {
      var _this5 = this;

      if (this.showPopover) {
        // delay close of popover as multiple popovers may exist and conflict with onClickOutside
        this.$forceNextTick(function () {
          _this5.closePopover(true);
        });
      }
    },

    /**
     * Remove the value from the localValue and $emit to the parent.
     *
     * @param {string | Array} value
     */
    removeValue: function removeValue(value) {
      var index = this.localValue.findIndex(function (localValue) {
        return localValue === value;
      });
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
    },

    /**
     * Reset the localValue and create a random ID for the calendars.
     */
    resetFilters: function resetFilters() {
      this.$set(this, 'localValue', []);
      this.createRandomId();
    }
  }
};

/* script */
const __vue_script__$L = script$L;

/* template */
var __vue_render__$K = function() {
  var _obj, _obj$1;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "popper",
        _vm._b(
          {
            ref: "tf-tooltip",
            attrs: { trigger: "clickToToggle" },
            on: {
              show: function($event) {
                _vm.showPopover = true;
              }
            }
          },
          "popper",
          {
            appendToBody: true,
            disabled: _vm.disabled,
            forceShow: _vm.showPopover,
            options: {
              placement: "bottom-start",
              modifiers: {
                flip: {
                  // disabling to force popper to stay below
                  // input regardless of viewport height
                  enabled: false
                }
              }
            },
            visibleArrow: false
          },
          false
        ),
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.onClickOutside,
                  expression: "onClickOutside"
                }
              ],
              class: [
                "tf-popper tf-filter-type-" +
                  _vm.filter.type +
                  " wt-popper wt-filter-type-" +
                  _vm.filter.type,
                ((_obj = {}),
                (_obj["tf-filter-type-" + _vm.dateType] = _vm.dateType),
                _obj),
                ((_obj$1 = {}),
                (_obj$1["wt-filter-type-" + _vm.dateType] = _vm.dateType),
                _obj$1)
              ],
              style: {
                width: _vm.filter.popoverWidth,
                minWidth: _vm.filter.width
              }
            },
            [
              _vm.showPopover
                ? [
                    ["string", "range"].includes(_vm.filter.type)
                      ? _c(
                          "tf-checkbox-group",
                          {
                            model: {
                              value: _vm.localValue,
                              callback: function($$v) {
                                _vm.localValue = $$v;
                              },
                              expression: "localValue"
                            }
                          },
                          _vm._l(_vm.localOptions, function(option) {
                            return _c(
                              "tf-checkbox",
                              {
                                key: option[_vm.valueKey],
                                ref: "checkbox",
                                refInFor: true,
                                attrs: {
                                  disabled: option.disabled,
                                  label: option[_vm.valueKey]
                                },
                                nativeOn: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return $event.target.click()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    option[_vm.labelKey]
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(option[_vm.labelKey]) +
                                              "\n              "
                                          )
                                        ]
                                      : _vm._t("noValue", [
                                          _vm._v(
                                            "\n                —\n              "
                                          )
                                        ])
                                  ],
                                  2
                                )
                              ]
                            )
                          }),
                          1
                        )
                      : _c("tf-filter-date", {
                          key: _vm.randomId,
                          attrs: {
                            "date-type": _vm.dateType,
                            filter: _vm.filter
                          },
                          on: {
                            changeDateFilterType: _vm.changeDateFilterType,
                            closePopover: _vm.closePopover
                          },
                          model: {
                            value: _vm.localValue,
                            callback: function($$v) {
                              _vm.localValue = $$v;
                            },
                            expression: "localValue"
                          }
                        }),
                    _vm._v(" "),
                    _c("footer", [
                      _c(
                        "div",
                        { staticClass: "btn-group" },
                        [
                          _c("tf-button", {
                            attrs: {
                              disabled: _vm.disableBtns,
                              "data-test-btn-reset": "",
                              size: "medium",
                              type: "secondary"
                            },
                            domProps: { textContent: _vm._s("Reset") },
                            on: { click: _vm.resetFilters }
                          }),
                          _vm._v(" "),
                          _c("tf-button", {
                            attrs: {
                              disabled: _vm.disableBtns,
                              "data-test-btn-done": "",
                              size: "medium"
                            },
                            domProps: { textContent: _vm._s("Done") },
                            on: { click: _vm.applyFilter }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "tf-input",
            _vm._b(
              {
                attrs: { slot: "reference" },
                nativeOn: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    ) {
                      return null
                    }
                    return _vm.focusOnCheckbox($event)
                  }
                },
                slot: "reference",
                model: {
                  value: _vm.searchValue,
                  callback: function($$v) {
                    _vm.searchValue = $$v;
                  },
                  expression: "searchValue"
                }
              },
              "tf-input",
              {
                class: [
                  { "is-active": _vm.showPopover && !_vm.disabled },
                  "input-filter"
                ],
                disabled: _vm.disabled,
                name: _vm.filterPropName,
                placeholder: _vm.filter.label,
                readonly: !["string", "range"].includes(_vm.filter.type)
              },
              false
            ),
            [
              _c("icon", {
                attrs: {
                  slot: "suffix",
                  name: "caret-down",
                  "data-prop-name": _vm.filterPropName
                },
                on: { click: _vm.toggleIcon },
                slot: "suffix"
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.value.length
        ? _c(
            "div",
            {
              staticClass:
                "tf-filter-values-container wt-filter-values-container"
            },
            _vm._l(_vm.displayOptions, function(option) {
              return _c(
                "span",
                {
                  key: option.text,
                  staticClass: "tf-filter-value wt-filter-value"
                },
                [
                  option.text
                    ? [_vm._v("\n        " + _vm._s(option.text) + "\n      ")]
                    : _vm._t("noValue", [_vm._v("\n        —\n      ")]),
                  _vm._v(" "),
                  _c("tf-button", {
                    staticClass: "btn-remove-filter-value",
                    attrs: {
                      "no-padding": "",
                      type: "primary",
                      icon: "times",
                      size: "icon-no-fill"
                    },
                    on: {
                      click: function($event) {
                        return _vm.removeValue(option.id)
                      }
                    }
                  })
                ],
                2
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$K = [];
__vue_render__$K._withStripped = true;

  /* style */
  const __vue_inject_styles__$L = function (inject) {
    if (!inject) return
    inject("data-v-74fb3934_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nfooter[data-v-74fb3934] {\n  padding: 10px 0;\n  border-top: 1px solid #999;\n}\n.tf-button.btn-remove-filter-value[data-v-74fb3934],\n.wt-button.btn-remove-filter-value[data-v-74fb3934] {\n  margin-top: 2px;\n}\n.tf-button.tf-button--secondary[data-v-74fb3934], .tf-button.wt-button--secondary[data-v-74fb3934],\n.wt-button.tf-button--secondary[data-v-74fb3934],\n.wt-button.wt-button--secondary[data-v-74fb3934] {\n  border-color: #fff;\n}\n.tf-popper[data-v-74fb3934],\n.wt-popper[data-v-74fb3934] {\n  padding: 0;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid #2638a6;\n  border-radius: 2px;\n  text-align: left;\n}\n.tf-filter-value[data-v-74fb3934],\n.wt-filter-value[data-v-74fb3934] {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 5px 7px 5px 15px;\n  font-size: 14px;\n}\n.tf-filter-value > span[data-v-74fb3934],\n.wt-filter-value > span[data-v-74fb3934] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.tf-filter-values-container[data-v-74fb3934],\n.wt-filter-values-container[data-v-74fb3934] {\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n  border-radius: 0 0 2px 2px;\n}\n[data-v-74fb3934] .el {\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable selector-max-compound-selectors */\n  /* stylelint-enable max-nesting-depth  */\n}\n[data-v-74fb3934] .el-checkbox {\n  display: flex;\n  padding: 12px 10px;\n  cursor: pointer;\n}\n[data-v-74fb3934] .el-checkbox:not(:last-child) {\n  border-bottom: 1px #efefef solid;\n}\n[data-v-74fb3934] .el-checkbox-group {\n  box-sizing: border-box;\n  max-height: 300px;\n  width: auto;\n  min-width: 200px;\n  overflow-y: auto;\n  position: relative;\n}\n[data-v-74fb3934] .el-checkbox__inner {\n  margin-top: 2px;\n}\n[data-v-74fb3934] .el-checkbox__label {\n  line-height: 20px;\n}\n[data-v-74fb3934] .el-checkbox + .el-checkbox {\n  margin-left: 0;\n}\n[data-v-74fb3934] .el-checkbox:hover {\n  background: #f4f5ff;\n  color: #2638a6;\n}\n[data-v-74fb3934] .el-input__suffix {\n  display: flex;\n  align-items: center;\n  margin-right: 6px;\n  cursor: pointer;\n}\n[data-v-74fb3934] .el-input__suffix svg {\n  height: 22px;\n  width: 14px;\n}\n[data-v-74fb3934] .el-input__suffix svg path {\n  pointer-events: none;\n}\n[data-v-74fb3934] .el-input__suffix-inner {\n  padding-top: 3px;\n}\n[data-v-74fb3934] .el-input.input-filter.is-active svg {\n  fill: #2638a6;\n  transform: rotate(180deg);\n}\n[data-v-74fb3934] .el-input input {\n  height: 30px;\n  line-height: 30px;\n}\n[data-v-74fb3934] .el-input input::placeholder {\n  opacity: 1;\n  color: #999;\n}\n[data-v-74fb3934] .el-input svg {\n  transition: transform 0.2s ease-out;\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/circleci/repo/src/components/TfFilter/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC6bpC;EACA,eAAA;EACA,0BAAA;AD3bA;ACgcA;;EACA,eAAA;AD5bA;AC+bA;;;EAEA,kBAAA;AD5bA;ACgcA;;EAEA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AD7bA;ACkcA;;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AD9bA;ACgcA;;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AD7bA;ACicA;;EACA,mBAAA;EACA,yBAAA;EAEA,aAAA;EACA,0BAAA;AD/bA;ACocA;EAqCA,sDAAA;EACA,yCAAA;EA6CA,qDAAA;EACA,wCAAA;ADjhBA;AC8bA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AD5bA;AC8bA;EACA,gCAAA;AD5bA;AC+bA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AD7bA;ACgcA;EACA,eAAA;AD9bA;ACicA;EACA,iBAAA;AD/bA;ACkcA;EACA,cAAA;ADhcA;ACmcA;EACA,mBAAA;EACA,cAAA;ADjcA;ACwcA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;ADtcA;ACwcA;EACA,YAAA;EACA,WAAA;ADtcA;ACwcA;EACA,oBAAA;ADtcA;AC2cA;EACA,gBAAA;ADzcA;AC6cA;EACA,aAAA;EACA,yBAAA;AD3cA;AC+cA;EACA,YAAA;EACA,iBAAA;AD7cA;AC+cA;EACA,UAAA;EACA,WAAA;AD7cA;ACidA;EACA,mCAAA;EACA,wBAAA;EACA,uBAAA;AD/cA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nfooter {\n  padding: 10px 0;\n  border-top: 1px solid #999;\n}\n\n.tf-button.btn-remove-filter-value,\n.wt-button.btn-remove-filter-value {\n  margin-top: 2px;\n}\n.tf-button.tf-button--secondary, .tf-button.wt-button--secondary,\n.wt-button.tf-button--secondary,\n.wt-button.wt-button--secondary {\n  border-color: #fff;\n}\n\n.tf-popper,\n.wt-popper {\n  padding: 0;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid #2638a6;\n  border-radius: 2px;\n  text-align: left;\n}\n\n.tf-filter-value,\n.wt-filter-value {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 5px 7px 5px 15px;\n  font-size: 14px;\n}\n.tf-filter-value > span,\n.wt-filter-value > span {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.tf-filter-values-container,\n.wt-filter-values-container {\n  background: #fafafa;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n  border-radius: 0 0 2px 2px;\n}\n\n::v-deep .el {\n  /* stylelint-disable selector-max-compound-selectors */\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable selector-max-compound-selectors */\n  /* stylelint-enable max-nesting-depth  */\n}\n::v-deep .el-checkbox {\n  display: flex;\n  padding: 12px 10px;\n  cursor: pointer;\n}\n::v-deep .el-checkbox:not(:last-child) {\n  border-bottom: 1px #efefef solid;\n}\n::v-deep .el-checkbox-group {\n  box-sizing: border-box;\n  max-height: 300px;\n  width: auto;\n  min-width: 200px;\n  overflow-y: auto;\n  position: relative;\n}\n::v-deep .el-checkbox__inner {\n  margin-top: 2px;\n}\n::v-deep .el-checkbox__label {\n  line-height: 20px;\n}\n::v-deep .el-checkbox + .el-checkbox {\n  margin-left: 0;\n}\n::v-deep .el-checkbox:hover {\n  background: #f4f5ff;\n  color: #2638a6;\n}\n::v-deep .el-input__suffix {\n  display: flex;\n  align-items: center;\n  margin-right: 6px;\n  cursor: pointer;\n}\n::v-deep .el-input__suffix svg {\n  height: 22px;\n  width: 14px;\n}\n::v-deep .el-input__suffix svg path {\n  pointer-events: none;\n}\n::v-deep .el-input__suffix-inner {\n  padding-top: 3px;\n}\n::v-deep .el-input.input-filter.is-active svg {\n  fill: #2638a6;\n  transform: rotate(180deg);\n}\n::v-deep .el-input input {\n  height: 30px;\n  line-height: 30px;\n}\n::v-deep .el-input input::placeholder {\n  opacity: 1;\n  color: #999;\n}\n::v-deep .el-input svg {\n  transition: transform 0.2s ease-out;\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div>\n    <popper\n      ref=\"tf-tooltip\"\n      v-bind=\"{\n        appendToBody: true,\n        disabled,\n        forceShow: showPopover,\n        options: {\n          placement: 'bottom-start',\n          modifiers: {\n            flip: {\n              // disabling to force popper to stay below\n              // input regardless of viewport height\n              enabled: false,\n            },\n          },\n        },\n        visibleArrow: false\n      }\"\n      trigger=\"clickToToggle\"\n      @show=\"showPopover = true\"\n    >\n      <!--\n        Due to a bug in vue-popper, the content should be the first element:\n        https://github.com/RobinCK/vue-popper/issues/71\n      -->\n      <div\n        v-click-outside=\"onClickOutside\"\n        :class=\"[\n          `tf-popper tf-filter-type-${filter.type} wt-popper wt-filter-type-${filter.type}`,\n          { [`tf-filter-type-${dateType}`]: dateType },\n          { [`wt-filter-type-${dateType}`]: dateType }\n        ]\"\n        :style=\"{ width: filter.popoverWidth, minWidth: filter.width }\"\n      >\n        <!-- Wrap the content in v-if to prevent contents from loading. -->\n        <template v-if=\"showPopover\">\n          <tf-checkbox-group\n            v-if=\"['string', 'range'].includes(filter.type)\"\n            v-model=\"localValue\"\n          >\n            <tf-checkbox\n              v-for=\"option in localOptions\"\n              ref=\"checkbox\"\n              :key=\"option[valueKey]\"\n              :disabled=\"option.disabled\"\n              :label=\"option[valueKey]\"\n              @keydown.native.enter=\"$event.target.click()\"\n            >\n              <span>\n                <template v-if=\"option[labelKey]\">\n                  {{ option[labelKey] }}\n                </template>\n                <slot\n                  v-else\n                  name=\"noValue\"\n                >\n                  &mdash;\n                </slot>\n              </span>\n            </tf-checkbox>\n          </tf-checkbox-group>\n          <tf-filter-date\n            v-else\n            :key=\"randomId\"\n            v-model=\"localValue\"\n            :date-type=\"dateType\"\n            :filter=\"filter\"\n            @changeDateFilterType=\"changeDateFilterType\"\n            @closePopover=\"closePopover\"\n          />\n          <footer>\n            <div class=\"btn-group\">\n              <tf-button\n                :disabled=\"disableBtns\"\n                data-test-btn-reset\n                size=\"medium\"\n                type=\"secondary\"\n                @click=\"resetFilters\"\n                v-text=\"'Reset'\"\n              />\n              <tf-button\n                :disabled=\"disableBtns\"\n                data-test-btn-done\n                size=\"medium\"\n                @click=\"applyFilter\"\n                v-text=\"'Done'\"\n              />\n            </div>\n          </footer>\n        </template>\n      </div>\n      <tf-input\n        slot=\"reference\"\n        v-bind=\"{\n          class: [{ 'is-active': showPopover && !disabled }, 'input-filter'],\n          disabled,\n          name: filterPropName,\n          placeholder: filter.label,\n          readonly: !['string', 'range'].includes(filter.type),\n        }\"\n        v-model=\"searchValue\"\n        @keydown.native.tab=\"focusOnCheckbox\"\n      >\n        <icon\n          slot=\"suffix\"\n          name=\"caret-down\"\n          :data-prop-name=\"filterPropName\"\n          @click=\"toggleIcon\"\n        />\n      </tf-input>\n    undefined>\n    <div\n      v-if=\"value.length\"\n      class=\"tf-filter-values-container wt-filter-values-container\"\n    >\n      <span\n        v-for=\"option in displayOptions\"\n        :key=\"option.text\"\n        class=\"tf-filter-value wt-filter-value\"\n      >\n        <template v-if=\"option.text\">\n          {{ option.text }}\n        </template>\n        <slot\n          v-else\n          name=\"noValue\"\n        >\n          &mdash;\n        </slot>\n        <tf-button\n          no-padding\n          class=\"btn-remove-filter-value\"\n          type=\"primary\"\n          icon=\"times\"\n          size=\"icon-no-fill\"\n          @click=\"removeValue(option.id)\"\n        />\n      </span>\n    </div>\n  </div>\n</template>\n\n<script>\n  import TfFilterDate from './Date';\n\n  export default {\n    components: { TfFilterDate },\n    props: {\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n      filter: {\n        type: Object,\n        required: true,\n      },\n      labelKey: {\n        type: String,\n        default: 'label',\n      },\n      value: {\n        type: Array,\n        default: () => [],\n      },\n      valueKey: {\n        type: String,\n        default: 'value',\n      },\n    },\n    data: (vm) => ({\n      dateType: null,\n      localValue: [...vm.value],\n      randomId: null,\n      searchValue: '',\n      showPopover: false,\n    }),\n    computed: {\n      /**\n       * If the filter is a 'date-range' or 'month' dateType, then test for all values.\n       *\n       * @returns {Array}\n       */\n      disableBtns() {\n        let disableBtns = false;\n\n        if (this.dateType === 'date-range') {\n          disableBtns = this.localValue[0]\n            ? this.localValue[0].includes('')\n            : true;\n        } else if (this.dateType === 'month') {\n          disableBtns = !this.localValue[0];\n        }\n\n        return disableBtns;\n      },\n      /**\n       * Map this.value to either the value or the appropriate label.\n       * For filter types that are a range, we want to create this list\n       * from this.filter.options since that has the appropriate order.\n       *\n       * @returns {Array}\n       */\n      displayOptions() {\n        const values = this.value.map((id) => {\n          const formatDate = (dateValue, format = 'MM/DD/YY') => this.$TF.DatesUtils.formatSimpleDate(dateValue, format);\n          let text;\n\n          if (this.filter.type === 'range') {\n            ({ [this.labelKey]: text } = this.filter.options.find(\n              ({ [this.valueKey]: localValue }) => localValue === id,\n            ));\n          } else if (this.filter.type === 'string') {\n            text = id;\n          } else if (this.filter.dateType === 'month') {\n            text = formatDate(id, 'MMMM YYYY');\n          } else if (this.filter.dateType === 'date-range') {\n            const [from, to] = id;\n\n            text = `${formatDate(from)}-${formatDate(to)}`;\n          }\n\n          return { id, text };\n        });\n        let displayOptions;\n\n        if (this.filter.type === 'range') {\n          displayOptions = [];\n\n          this.filter.options.forEach((option) => {\n            if (this.value.includes(option[this.valueKey])) {\n              displayOptions.push({\n                id: option[this.valueKey],\n                text: option[this.labelKey],\n              });\n            }\n          });\n        } else {\n          // eslint-disable-next-line vue/no-side-effects-in-computed-properties\n          displayOptions = this.$TF.Formatting.sortObjects(values, 'text');\n        }\n\n        return displayOptions;\n      },\n\n      /**\n       * Filter this.filter.options by this.searchValue if applicable.\n       *\n       * @returns {Array}\n       */\n      localOptions() {\n        return this.searchValue\n          ? this.filter.options.filter(({ [this.labelKey]: label }) => (\n            label\n              .toLowerCase()\n              .includes(this.searchValue.toLowerCase())))\n          : this.filter.options;\n      },\n\n      /**\n       * Cache a string based on the filter's prop to be used throughout the template.\n       *\n       * @returns {string}\n       */\n      filterPropName() {\n        return `filter-${this.filter.prop}`;\n      },\n    },\n    watch: {\n      /**\n       * The reset button is controlled in the parent so we want to watch\n       * for when the model is emptied from the parent to reset the local filter values.\n       */\n      value() {\n        if (!this.value.length) {\n          this.resetFilters();\n        }\n      },\n    },\n    created() {\n      this.createRandomId();\n      this.changeDateType();\n    },\n    methods: {\n      /**\n       * Close the popover and if there is a change in filter values,\n       * $emit the localValue to the parent.\n       */\n      applyFilter() {\n        if (\n          this.value.length === this.localValue.length\n          && this.localValue.every((value) => this.value.includes(value))\n        ) {\n          this.closePopover();\n          return;\n        }\n\n        if (this.dateType) {\n          this.$emit('changeDateFilterType', this.dateType);\n        }\n\n        this.$emit('input', this.localValue);\n        this.closePopover();\n      },\n\n      /**\n       * Clear or reset the localValue based on the passed param.\n       * $emit the localValue to the parent.\n       *\n       * @param {string} dateFilterType\n       */\n      changeDateFilterType(dateFilterType) {\n        const newLocalValue = this.filter.dateType === dateFilterType\n          ? this.value\n          : [];\n\n        this.dateType = dateFilterType;\n        this.$set(this, 'localValue', newLocalValue);\n\n        /* Changing the filter type will change the content of the\n         * popover but not inform the underlying Popover component\n         * that it has been updated. Calling updatePopper explicitly\n         * on tf-tooltip will schedule a re-render / repositioning */\n        if (this.$refs['tf-tooltip'].updatePopper) {\n          this.$refs['tf-tooltip'].updatePopper();\n        }\n      },\n\n      /**\n       * Clear or reset the localValue based on the passed param.\n       * $emit the localValue to the parent.\n       */\n      changeDateType() {\n        if (!this.filter.dateType) {\n          return;\n        }\n\n        let dateType = this.filter.dateType || this.filter.type;\n\n        if (this.filter.type === 'month-and-date-range') {\n          dateType = this.value[0] && Array.isArray(this.value[0])\n            ? 'date-range'\n            : 'month';\n        }\n\n        this.dateType = dateType;\n      },\n\n      /**\n       * Clear the search value, closes the popover.\n       * Clear the localValue if desired.\n       *\n       * @param {boolean} resetValue\n       */\n      closePopover(resetValue = false) {\n        if (!this.showPopover) {\n          return;\n        }\n        this.showPopover = false;\n        this.searchValue = '';\n\n        if (resetValue) {\n          this.$set(this, 'localValue', [...this.value]);\n          this.changeDateType();\n        }\n\n        // I'm wrapping this due a test failure that\n        // I'm not sure of a way around right now.\n        // TypeError: this.$refs.tf-tooltip.doClose is not a function\n        if (this.$refs['tf-tooltip'].doClose) {\n          this.$refs['tf-tooltip'].doClose();\n        }\n      },\n\n      /**\n       * Create a random ID to use as a key for the calendars so changing an ID will redraw the component.\n       */\n      createRandomId() {\n        this.randomId = Math.floor(Math.random() * Math.floor(9999));\n      },\n\n      /**\n       * If the user hits tab while focused on the main input,\n       * we move the user to the next checkbox. Element does something odd\n       * so this needs to be done on nextTick().\n       *\n       * @param {object} $event\n       * @param {string} $event.shiftKey\n       */\n      focusOnCheckbox({ shiftKey }) {\n        if (!shiftKey) {\n          this.$nextTick(() => {\n            this.$refs.checkbox[0].$el.querySelector('input').focus();\n          });\n        }\n      },\n\n      /**\n       * Evaluate the the clicked element's name to close the popover and reset the values.\n       *\n       * @param {object} event\n       */\n      onClickOutside(event) {\n        if ((event.target.name\n          || event.target.getAttribute('data-prop-name'))\n          === `${this.filterPropName}`) {\n          return;\n        }\n        this.closePopover(true);\n      },\n\n      /**\n       * Close popover with caret\n       *\n       */\n      toggleIcon() {\n        if (this.showPopover) {\n          // delay close of popover as multiple popovers may exist and conflict with onClickOutside\n          this.$forceNextTick(() => {\n            this.closePopover(true);\n          });\n        }\n      },\n\n      /**\n       * Remove the value from the localValue and $emit to the parent.\n       *\n       * @param {string | Array} value\n       */\n      removeValue(value) {\n        const index = this.localValue.findIndex((localValue) => localValue === value);\n\n        this.localValue.splice(index, 1);\n        this.$emit('input', this.localValue);\n      },\n      /**\n       * Reset the localValue and create a random ID for the calendars.\n       */\n      resetFilters() {\n        this.$set(this, 'localValue', []);\n        this.createRandomId();\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  footer {\n    padding: 10px 0;\n    border-top: 1px solid $tf-medium-gray;\n  }\n\n  .tf-button,\n  .wt-button {\n    &.btn-remove-filter-value {\n      margin-top: 2px;\n    }\n\n    &.tf-button--secondary,\n    &.wt-button--secondary {\n      border-color: $tf-white;\n    }\n  }\n\n  .tf-popper,\n  .wt-popper {\n    padding: 0;\n    box-sizing: border-box;\n    background: $tf-white;\n    border: 1px solid $tf-blue;\n    border-radius: 2px;\n    text-align: left;\n  }\n\n  .tf-filter,\n  .wt-filter {\n    &-value {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      padding: 5px 7px 5px 15px;\n      font-size: 14px;\n\n      > span {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n      }\n    }\n\n    &-values-container {\n      background: $tf-extra-light-gray-2;\n      border: 1px solid $tf-light-gray;\n      border: {\n        top: 0;\n        radius: 0 0 2px 2px;\n      }\n    }\n  }\n\n  ::v-deep .el {\n    &-checkbox {\n      display: flex;\n      padding: 12px 10px;\n      cursor: pointer;\n\n      &:not(:last-child) {\n        border-bottom: 1px $tf-extra-light-gray-1 solid;\n      }\n\n      &-group {\n        box-sizing: border-box;\n        max-height: 300px;\n        width: auto;\n        min-width: 200px;\n        overflow-y: auto;\n        position: relative;\n      }\n\n      &__inner {\n        margin-top: 2px;\n      }\n\n      &__label {\n        line-height: 20px;\n      }\n\n      + .el-checkbox {\n        margin-left: 0;\n      }\n\n      &:hover {\n        background: $tf-light-blue;\n        color: $tf-blue;\n      }\n    }\n\n    /* stylelint-disable selector-max-compound-selectors */\n    /* stylelint-disable max-nesting-depth  */\n    &-input {\n      &__suffix {\n        display: flex;\n        align-items: center;\n        margin-right: 6px;\n        cursor: pointer;\n\n        svg {\n          height: 22px;\n          width: 14px;\n\n          path {\n            pointer-events: none;\n          }\n        }\n      }\n\n      &__suffix-inner {\n        padding-top: 3px;\n      }\n\n      &.input-filter.is-active {\n        svg {\n          fill: $tf-blue;\n          transform: rotate(180deg);\n        }\n      }\n\n      input {\n        height: 30px;\n        line-height: 30px;\n\n        &::placeholder {\n          opacity: 1;\n          color: $tf-medium-gray;\n        }\n      }\n\n      svg {\n        transition: transform .2s ease-out;\n        transform-origin: center;\n        transform: rotate(0deg);\n      }\n    }\n    /* stylelint-enable selector-max-compound-selectors */\n    /* stylelint-enable max-nesting-depth  */\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$L = "data-v-74fb3934";
  /* module identifier */
  const __vue_module_identifier__$L = undefined;
  /* functional template */
  const __vue_is_functional_template__$L = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$L = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
    __vue_inject_styles__$L,
    __vue_script__$L,
    __vue_scope_id__$L,
    __vue_is_functional_template__$L,
    __vue_module_identifier__$L,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$M = {
  name: 'TfHamburgerMenu',
  props: {
    badgeCount: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: 'carrier'
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Adding key listeners to the hamburger menu and menu items so that we can tab to them and hit enter
    this.$refs['hamburger-menu'].$el.addEventListener('keydown', this.checkHamburgerKeyEvent); // TODO RI 2021-02-03 can we do this with a nexttick?

    window.setTimeout(function () {
      var menuItems = _this.$el.querySelectorAll('.tf-hamburger-popper .el-menu-item');

      if (menuItems.length) {
        for (var i = 0; i < menuItems.length; i += 1) {
          menuItems[i].addEventListener('keydown', _this.clickMenuItem);
        }
      }
    }, 500);
  },
  beforeDestroy: function beforeDestroy() {
    // Removing previously added key listeners
    this.$refs['hamburger-menu'].$el.removeEventListener('keydown', this.checkHamburgerKeyEvent);
    var menuItems = this.$el.querySelectorAll('.el-menu-item');

    if (menuItems.length) {
      for (var i = 0; i < menuItems.length; i += 1) {
        menuItems[i].removeEventListener('keydown', this.clickMenuItem);
      }
    }
  },
  methods: {
    /**
     * Click the hamburger menu if a user hits enter while focused on it
     */
    hideSubmenu: function hideSubmenu() {
      this.$emit('hide');
    },

    /**
     * Click the hamburger menu if a user hits enter while focused on it
     *
     * @param {event} e
     */
    checkHamburgerKeyEvent: function checkHamburgerKeyEvent(e) {
      var key = e.which || e.keyCode;

      if (key === 13) {
        // 13 is enter
        this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();
      }
    },

    /**
     * Click the menu item if a user hits enter while focused on it
     *
     * @param {event} e
     */
    clickMenuItem: function clickMenuItem(e) {
      var key = e.which || e.keyCode;

      if (key === 13) {
        // 13 is enter
        e.target.click();
      } else if (key === 27) {
        // if they hit escape close the menu
        this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();
      }
    }
  }
};

/* script */
const __vue_script__$M = script$M;

/* template */
var __vue_render__$L = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tf-submenu",
    {
      ref: "hamburger-menu",
      class: ["tf-hamburger wt-hamburger", _vm.mode],
      attrs: {
        "popper-append-to-body": false,
        "close-on-outside-click": true,
        index: "1",
        "popper-class": "tf-hamburger-popper"
      },
      on: { hide: _vm.hideSubmenu }
    },
    [
      _c(
        "template",
        { slot: "title" },
        [
          _c("span", [_vm._v("Menu")]),
          _vm._v(" "),
          _vm.badgeCount > 0
            ? _c("tf-badge", {
                attrs: {
                  value: _vm.badgeCount,
                  status: "error",
                  "is-counter": ""
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
};
var __vue_staticRenderFns__$L = [];
__vue_render__$L._withStripped = true;

  /* style */
  const __vue_inject_styles__$M = function (inject) {
    if (!inject) return
    inject("data-v-1811f7c6_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/* stylelint-disable selector-max-compound-selectors  */\n.el-menu--horizontal > .el-submenu.tf-hamburger,\n.el-menu--horizontal > .el-submenu.wt-hamburger {\n  float: right;\n  width: fit-content;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px transparent solid !important;\n  /* stylelint-enable declaration-no-important  */\n  height: 53px;\n  line-height: 53px;\n  width: 73px;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  background-color: #fff;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%232638a6' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n  background-size: 25px 18px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title:hover {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px #2638a6 solid !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title span:not(.tf-badge),\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title span:not(.tf-badge) {\n  position: absolute;\n  left: -100px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title .tf-badge,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title .tf-badge {\n  position: absolute;\n  right: 37px;\n  top: 5px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger i,\n.el-menu--horizontal > .el-submenu.wt-hamburger i {\n  display: none;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title {\n  background-color: #2638a6;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy {\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable max-nesting-depth  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title {\n  background-color: #2638a6;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title:hover {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23c1c1c1' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title {\n  background-color: #1b266f;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n\n/* stylelint-enable selector-max-compound-selectors  */\n.el-menu--horizontal.tf-hamburger-popper,\n.el-menu--horizontal.wt-hamburger-popper {\n  /* stylelint-disable declaration-no-important  */\n  top: 55px !important;\n  left: auto !important;\n  /* stylelint-enable declaration-no-important  */\n  border-radius: 3px;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup-bottom-start,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup-bottom-start {\n  margin-top: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup {\n  border-radius: 3px;\n  border: 1px #2638a6 solid;\n  padding: 0;\n  left: auto;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item {\n  font-size: 16px;\n  font-weight: 600;\n  color: #42474c;\n  height: 39px;\n  line-height: 39px;\n  border-top: 1px #c1c1c1 solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:focus,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:focus {\n  color: #2638a6;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:first-of-type, .el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:first-of-type,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  border-top: 1px #fff solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  font-weight: normal;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:hover,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:hover {\n  background: rgba(38, 56, 166, 0.1);\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.is-active,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.is-active {\n  color: #2638a6;\n  background: rgba(38, 56, 166, 0.2);\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/circleci/repo/src/components/HamburgerMenu/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AACpC;;kCAEkC;AAClC;;oCAEoC;ACwFpC,uDAAA;AAEA;;EAEA,YAAA;EACA,kBAAA;ADvFA;ACyFA;;EAEA,gDAAA;EACA,wCAAA;EACA,+CAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EDvFE,8TAA8T;ECyFhU,0BAAA;ADvFA;ACyFA;;EACA,gDAAA;EACA,oCAAA;EACA,+CAAA;ADtFA;ACyFA;;EACA,kBAAA;EACA,YAAA;ADtFA;ACyFA;;EACA,kBAAA;EACA,WAAA;EACA,QAAA;ADtFA;AC0FA;;EACA,aAAA;ADvFA;AC2FA;;;;EAEA,yBAAA;EDvFE,2TAA2T;AAC7T;AC2FA;;EACA,yCAAA;EAiBA,wCAAA;ADxGA;ACwFA;;EACA,yBAAA;EDrFE,2TAA2T;AAC7T;ACuFA;;EDpFE,8TAA8T;AAChU;ACyFA;;;;EAEA,yBAAA;EDrFE,2TAA2T;AAC7T;;AC6FA,sDAAA;AACA;;EAEA,gDAAA;EACA,oBAAA;EACA,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,QAAA;AD1FA;AC4FA;;EACA,aAAA;ADzFA;AC4FA;;EACA,kBAAA;EACA,yBAAA;EAEA,UAAA;EACA,UAAA;EACA,QAAA;AD1FA;AC4FA;;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;ADzFA;AC2FA;;EACA,cAAA;ADxFA;AC2FA;;;EAEA,0BAAA;ADxFA;AC4FA;;EACA,mBAAA;ADzFA;AC4FA;;EACA,kCAAA;ADzFA;AC4FA;;EACA,cAAA;EACA,kCAAA;ADzFA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/* stylelint-disable selector-max-compound-selectors  */\n.el-menu--horizontal > .el-submenu.tf-hamburger,\n.el-menu--horizontal > .el-submenu.wt-hamburger {\n  float: right;\n  width: fit-content;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px transparent solid !important;\n  /* stylelint-enable declaration-no-important  */\n  height: 53px;\n  line-height: 53px;\n  width: 73px;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  background-color: #fff;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%232638a6' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n  background-size: 25px 18px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title:hover {\n  /* stylelint-disable declaration-no-important  */\n  border: 1px #2638a6 solid !important;\n  /* stylelint-enable declaration-no-important  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title span:not(.tf-badge),\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title span:not(.tf-badge) {\n  position: absolute;\n  left: -100px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger .el-submenu__title .tf-badge,\n.el-menu--horizontal > .el-submenu.wt-hamburger .el-submenu__title .tf-badge {\n  position: absolute;\n  right: 37px;\n  top: 5px;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger i,\n.el-menu--horizontal > .el-submenu.wt-hamburger i {\n  display: none;\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.is-opened .el-submenu__title {\n  background-color: #2638a6;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy {\n  /* stylelint-disable max-nesting-depth  */\n  /* stylelint-enable max-nesting-depth  */\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title {\n  background-color: #2638a6;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy .el-submenu__title:hover {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23c1c1c1' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.tf-hamburger.legacy.is-opened .el-submenu__title,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title:hover,\n.el-menu--horizontal > .el-submenu.wt-hamburger.legacy.is-opened .el-submenu__title {\n  background-color: #1b266f;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='18' viewBox='0 0 25 18'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='M2 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zm0 7h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4zM2 0h21a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4z'%3E%3C/path%3E%3C/svg%3E\");\n}\n\n/* stylelint-enable selector-max-compound-selectors  */\n.el-menu--horizontal.tf-hamburger-popper,\n.el-menu--horizontal.wt-hamburger-popper {\n  /* stylelint-disable declaration-no-important  */\n  top: 55px !important;\n  left: auto !important;\n  /* stylelint-enable declaration-no-important  */\n  border-radius: 3px;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup-bottom-start,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup-bottom-start {\n  margin-top: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup {\n  border-radius: 3px;\n  border: 1px #2638a6 solid;\n  padding: 0;\n  left: auto;\n  right: 0;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item {\n  font-size: 16px;\n  font-weight: 600;\n  color: #42474c;\n  height: 39px;\n  line-height: 39px;\n  border-top: 1px #c1c1c1 solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:focus,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:focus {\n  color: #2638a6;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:first-of-type, .el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:first-of-type,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  border-top: 1px #fff solid;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.sub-page,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.sub-page {\n  font-weight: normal;\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item:hover,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item:hover {\n  background: rgba(38, 56, 166, 0.1);\n}\n.el-menu--horizontal.tf-hamburger-popper .el-menu--popup .el-menu-item.is-active,\n.el-menu--horizontal.wt-hamburger-popper .el-menu--popup .el-menu-item.is-active {\n  color: #2638a6;\n  background: rgba(38, 56, 166, 0.2);\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <tf-submenu\n    ref=\"hamburger-menu\"\n    :popper-append-to-body=\"false\"\n    :close-on-outside-click=\"true\"\n    index=\"1\"\n    popper-class=\"tf-hamburger-popper\"\n    :class=\"['tf-hamburger wt-hamburger', mode]\"\n    @hide=\"hideSubmenu\"\n  >\n    <template slot=\"title\">\n      <span>Menu</span>\n      <tf-badge\n        v-if=\"badgeCount > 0\"\n        :value=\"badgeCount\"\n        status=\"error\"\n        is-counter\n      />\n    </template>\n    <slot />\n  </tf-submenu>\n</template>\n<script>\n  export default {\n    name: 'TfHamburgerMenu',\n    props: {\n      badgeCount: {\n        type: Number,\n        default: 0,\n      },\n      mode: {\n        type: String,\n        default: 'carrier',\n      },\n    },\n    mounted() {\n      // Adding key listeners to the hamburger menu and menu items so that we can tab to them and hit enter\n      this.$refs['hamburger-menu'].$el.addEventListener('keydown', this.checkHamburgerKeyEvent);\n\n      // TODO RI 2021-02-03 can we do this with a nexttick?\n      window.setTimeout(() => {\n        const menuItems = this.$el.querySelectorAll('.tf-hamburger-popper .el-menu-item');\n        if (menuItems.length) {\n          for (let i = 0; i < menuItems.length; i += 1) {\n            menuItems[i].addEventListener('keydown', this.clickMenuItem);\n          }\n        }\n      }, 500);\n    },\n    beforeDestroy() {\n      // Removing previously added key listeners\n      this.$refs['hamburger-menu'].$el.removeEventListener('keydown', this.checkHamburgerKeyEvent);\n\n      const menuItems = this.$el.querySelectorAll('.el-menu-item');\n      if (menuItems.length) {\n        for (let i = 0; i < menuItems.length; i += 1) {\n          menuItems[i].removeEventListener('keydown', this.clickMenuItem);\n        }\n      }\n    },\n    methods: {\n      /**\n       * Click the hamburger menu if a user hits enter while focused on it\n       */\n      hideSubmenu() {\n        this.$emit('hide');\n      },\n      /**\n       * Click the hamburger menu if a user hits enter while focused on it\n       *\n       * @param {event} e\n       */\n      checkHamburgerKeyEvent(e) {\n        const key = e.which || e.keyCode;\n        if (key === 13) { // 13 is enter\n          this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();\n        }\n      },\n      /**\n       * Click the menu item if a user hits enter while focused on it\n       *\n       * @param {event} e\n       */\n      clickMenuItem(e) {\n        const key = e.which || e.keyCode;\n        if (key === 13) { // 13 is enter\n          e.target.click();\n        } else if (key === 27) { // if they hit escape close the menu\n          this.$refs['hamburger-menu'].$el.querySelector('.el-submenu__title').click();\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\">\n  @import 'src/assets/styles/variables';\n  @import 'src/assets/styles/mixins';\n\n  /* stylelint-disable selector-max-compound-selectors  */\n  .el-menu--horizontal {\n    > .el-submenu.tf-hamburger,\n    > .el-submenu.wt-hamburger {\n      float: right;\n      width: fit-content; // fix for safari, will not affect other browser (i.e. IE)\n\n      .el-submenu__title {\n        // neccessary because of scoped styles in element overriding these\n        /* stylelint-disable declaration-no-important  */\n        border: 1px transparent solid !important;\n        /* stylelint-enable declaration-no-important  */\n        height: 53px;\n        line-height: 53px;\n        width: 73px;\n        padding: 0;\n        position: relative;\n        overflow: hidden;\n        background-color: $tf-white;\n        background-position: center center;\n        background-repeat: no-repeat;\n        @include hamburger-image($tf-blue);\n        background-size: 25px 18px;\n\n        &:hover {\n          /* stylelint-disable declaration-no-important  */\n          border: 1px $tf-blue solid !important;\n          /* stylelint-enable declaration-no-important  */\n        }\n\n        span:not(.tf-badge) {\n          position: absolute;\n          left: -100px;\n        }\n\n        .tf-badge {\n          position: absolute;\n          right: 37px;\n          top: 5px;\n        }\n      }\n\n      i {\n        display: none;\n      }\n\n      &.is-opened {\n        .el-submenu__title:hover,\n        .el-submenu__title {\n          background-color: $tf-blue;\n          @include hamburger-image($tf-white);\n        }\n      }\n\n      &.legacy {\n        /* stylelint-disable max-nesting-depth  */\n        .el-submenu__title {\n          background-color: $tf-blue;\n          @include hamburger-image($tf-white);\n\n          &:hover {\n            @include hamburger-image($tf-light-gray);\n          }\n        }\n\n        &.is-opened {\n          .el-submenu__title:hover,\n          .el-submenu__title {\n            background-color: $tf-dark-blue;\n            @include hamburger-image($tf-white);\n          }\n        }\n        /* stylelint-enable max-nesting-depth  */\n      }\n    }\n  }\n\n  /* stylelint-enable selector-max-compound-selectors  */\n  .el-menu--horizontal.tf-hamburger-popper,\n  .el-menu--horizontal.wt-hamburger-popper {\n    /* stylelint-disable declaration-no-important  */\n    top: 55px !important;\n    left: auto !important;\n    /* stylelint-enable declaration-no-important  */\n    border-radius: 3px;\n    right: 0;\n\n    .el-menu--popup-bottom-start {\n      margin-top: 0;\n    }\n\n    .el-menu--popup {\n      border-radius: 3px;\n      border: 1px $tf-blue solid;\n\n      padding: 0;\n      left: auto;\n      right: 0;\n\n      .el-menu-item {\n        font-size: 16px;\n        font-weight: 600;\n        color: $tf-dark-gray;\n        height: 39px;\n        line-height: 39px;\n        border-top: 1px $tf-light-gray solid;\n\n        &:focus {\n          color: $tf-blue;\n        }\n\n        &:first-of-type,\n        &.sub-page {\n          border-top: 1px $tf-white solid;\n        }\n      }\n\n      .el-menu-item.sub-page {\n        font-weight: normal;\n      }\n\n      .el-menu-item:hover {\n        background: rgba($tf-blue, .1);\n      }\n\n      .el-menu-item.is-active {\n        color: $tf-blue;\n        background: rgba($tf-blue, .2);\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$M = undefined;
  /* module identifier */
  const __vue_module_identifier__$M = undefined;
  /* functional template */
  const __vue_is_functional_template__$M = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$M = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
    __vue_inject_styles__$M,
    __vue_script__$M,
    __vue_scope_id__$M,
    __vue_is_functional_template__$M,
    __vue_module_identifier__$M,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Hamburger Menu Toggle
 *
 * @vuedoc
 * @exports MenuToggle
 * @category Components
 */
var script$N = {
  name: 'MenuBarItem',
  inject: {
    menu: {
      default: {
        /**
         * Dummy method in case nothing is provided
         */
        closeHamburgerMenu: function closeHamburgerMenu() {}
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'grandchild'
    },
    to: {
      type: [Object, String],
      default: function _default() {
        return {};
      }
    },
    isToggle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    badgeCount: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      localIsOpen: false,
      activeNames: [],
      hover: false
    };
  },
  created: function created() {
    this.localIsOpen = this.isOpen;

    if (this.isOpen) {
      this.$set(this, 'activeNames', ['item']);
    }
  },
  methods: {
    /**
     * Track open/closed state locally to show correct toggle chevron
     */
    onToggle: function onToggle() {
      this.localIsOpen = !this.localIsOpen;
    },

    /**
     * Close the parent menu and then route to the required path as defined in the to object that was passed as a prop.
     */
    closeHamburgerMenu: function closeHamburgerMenu() {
      if (this.disabled) {
        return;
      }

      this.menu.closeHamburgerMenu();
      this.$router.push(this.to);
    }
  }
};

/* script */
const __vue_script__$N = script$N;

/* template */
var __vue_render__$M = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "menu-item" },
    [
      _vm.isToggle
        ? _c(
            "el-collapse",
            {
              on: { change: _vm.onToggle },
              model: {
                value: _vm.activeNames,
                callback: function($$v) {
                  _vm.activeNames = $$v;
                },
                expression: "activeNames"
              }
            },
            [
              _c("el-collapse-item", { attrs: { name: "item" } }, [
                _c(
                  "div",
                  {
                    class: [
                      "inner",
                      _vm.type,
                      { "is-toggle": _vm.isToggle },
                      { disabled: _vm.disabled }
                    ],
                    attrs: { slot: "title" },
                    on: {
                      mouseover: function($event) {
                        _vm.hover = true;
                      },
                      mouseleave: function($event) {
                        _vm.hover = false;
                      }
                    },
                    slot: "title"
                  },
                  [
                    _c("div", {
                      staticClass: "title",
                      domProps: { textContent: _vm._s(_vm.title) }
                    }),
                    _vm._v(" "),
                    _c("icon", {
                      class: ["chevron-down", { open: _vm.localIsOpen }],
                      attrs: { name: "chevron-down" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "contents" }, [_vm._t("default")], 2)
              ])
            ],
            1
          )
        : _c(
            "router-link",
            _vm._b(
              {
                attrs: { "data-test-menu-link": "" },
                nativeOn: {
                  click: function($event) {
                    return _vm.closeHamburgerMenu($event)
                  }
                }
              },
              "router-link",
              {
                class: [
                  "inner",
                  _vm.type,
                  { link: !_vm.disabled },
                  { "is-toggle": _vm.isToggle },
                  { disabled: _vm.disabled },
                  { hover: _vm.hover }
                ],
                disabled: _vm.disabled,
                event: "", // disabling this to move logic to closeHamburgerMenu
                to: _vm.to
              },
              false
            ),
            [
              _c("div", {
                staticClass: "title",
                domProps: { textContent: _vm._s(_vm.title) }
              }),
              _vm._v(" "),
              _vm.icon
                ? _c("icon", { class: _vm.icon, attrs: { name: _vm.icon } })
                : _vm._e(),
              _vm._v(" "),
              _vm.badgeCount
                ? _c("tf-badge", {
                    attrs: {
                      value: _vm.badgeCount,
                      status: "error",
                      "is-counter": ""
                    }
                  })
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
};
var __vue_staticRenderFns__$M = [];
__vue_render__$M._withStripped = true;

  /* style */
  const __vue_inject_styles__$N = function (inject) {
    if (!inject) return
    inject("data-v-661ea622_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.inner[data-v-661ea622] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 40px;\n  padding: 0 15px 0 30px;\n  line-height: 40px;\n  font-size: 14px;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n.inner.link[data-v-661ea622] {\n  color: #42474c;\n  font-weight: 400;\n}\n.inner.parent[data-v-661ea622] {\n  padding-left: 15px;\n  font-size: 16px;\n  font-weight: 700;\n}\n.inner.child[data-v-661ea622] {\n  padding-left: 20px;\n  font-weight: 600;\n}\n.inner.grandchild[data-v-661ea622] {\n  padding-left: 30px;\n  background: #fafafa;\n}\n.inner.parent[data-v-661ea622]:focus, .inner.parent.router-link-exact-active[data-v-661ea622]:not(.disabled), .inner.child[data-v-661ea622]:focus, .inner.child.router-link-exact-active[data-v-661ea622]:not(.disabled), .inner.grandchild[data-v-661ea622]:focus, .inner.grandchild.router-link-exact-active[data-v-661ea622]:not(.disabled) {\n  background: #2638a6;\n  color: #fff;\n}\n.inner.parent:focus svg[data-v-661ea622], .inner.parent.router-link-exact-active:not(.disabled) svg[data-v-661ea622], .inner.child:focus svg[data-v-661ea622], .inner.child.router-link-exact-active:not(.disabled) svg[data-v-661ea622], .inner.grandchild:focus svg[data-v-661ea622], .inner.grandchild.router-link-exact-active:not(.disabled) svg[data-v-661ea622] {\n  fill: #fff;\n}\n.inner.is-toggle[data-v-661ea622] {\n  cursor: pointer;\n}\n.inner.disabled[data-v-661ea622] {\n  color: #999;\n  cursor: not-allowed;\n}\n.inner.disabled.grandchild[data-v-661ea622] {\n  background-color: #fafafa;\n}\n.inner.disabled[data-v-661ea622]:hover, .inner.disabled[data-v-661ea622]:active, .inner.disabled[data-v-661ea622]:focus {\n  background-color: #fff;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  color: #999;\n}\n.inner.disabled:hover.grandchild[data-v-661ea622], .inner.disabled:active.grandchild[data-v-661ea622], .inner.disabled:focus.grandchild[data-v-661ea622] {\n  background-color: #fafafa;\n}\n.inner .title[data-v-661ea622] {\n  flex-grow: 1;\n}\n.inner .fa-icon[data-v-661ea622] {\n  fill: #42474c;\n}\n.inner .exclamation-triangle[data-v-661ea622] {\n  fill: #f7912a;\n}\n.inner .chevron-down[data-v-661ea622] {\n  transition: transform 0.5s, color 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n.inner .chevron-down.open[data-v-661ea622] {\n  transform: rotate(180deg);\n}\n.el-collapse[data-v-661ea622] {\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n.el-collapse-item__header.is-active:not(:focus) > .parent[data-v-661ea622],\n.el-collapse-item__header.is-active:not(:focus) > .child[data-v-661ea622] {\n  color: #2638a6;\n}\n.el-collapse-item__header.is-active:not(:focus) .chevron-down[data-v-661ea622] {\n  fill: #2638a6;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */", map: {"version":3,"sources":["MenuItem.vue","/home/circleci/repo/src/components/HamburgerMenu/MenuItem.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACgLpC;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,oCAAA;AD9KA;ACgLA;EACA,cAAA;EACA,gBAAA;AD9KA;ACiLA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AD/KA;ACkLA;EACA,kBAAA;EACA,gBAAA;ADhLA;ACmLA;EACA,kBAAA;EACA,mBAAA;ADjLA;ACuLA;EACA,mBAAA;EACA,WAAA;ADrLA;ACuLA;EACA,UAAA;ADrLA;AC0LA;EACA,eAAA;ADxLA;AC2LA;EACA,WAAA;EACA,mBAAA;ADzLA;AC2LA;EACA,yBAAA;ADzLA;AC4LA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;AD1LA;AC4LA;EACA,yBAAA;AD1LA;AC+LA;EACA,YAAA;AD7LA;ACgMA;EACA,aAAA;AD9LA;ACiMA;EACA,aAAA;AD/LA;ACkMA;EACA,2EAAA;EACA,wBAAA;EACA,uBAAA;ADhMA;ACkMA;EACA,yBAAA;ADhMA;ACqMA;EACA,oCAAA;ADlMA;ACuMA;;EAEA,cAAA;ADpMA;ACuMA;EACA,aAAA;ADrMA;;AAEA,uCAAuC","file":"MenuItem.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 40px;\n  padding: 0 15px 0 30px;\n  line-height: 40px;\n  font-size: 14px;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n.inner.link {\n  color: #42474c;\n  font-weight: 400;\n}\n.inner.parent {\n  padding-left: 15px;\n  font-size: 16px;\n  font-weight: 700;\n}\n.inner.child {\n  padding-left: 20px;\n  font-weight: 600;\n}\n.inner.grandchild {\n  padding-left: 30px;\n  background: #fafafa;\n}\n.inner.parent:focus, .inner.parent.router-link-exact-active:not(.disabled), .inner.child:focus, .inner.child.router-link-exact-active:not(.disabled), .inner.grandchild:focus, .inner.grandchild.router-link-exact-active:not(.disabled) {\n  background: #2638a6;\n  color: #fff;\n}\n.inner.parent:focus svg, .inner.parent.router-link-exact-active:not(.disabled) svg, .inner.child:focus svg, .inner.child.router-link-exact-active:not(.disabled) svg, .inner.grandchild:focus svg, .inner.grandchild.router-link-exact-active:not(.disabled) svg {\n  fill: #fff;\n}\n.inner.is-toggle {\n  cursor: pointer;\n}\n.inner.disabled {\n  color: #999;\n  cursor: not-allowed;\n}\n.inner.disabled.grandchild {\n  background-color: #fafafa;\n}\n.inner.disabled:hover, .inner.disabled:active, .inner.disabled:focus {\n  background-color: #fff;\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  color: #999;\n}\n.inner.disabled:hover.grandchild, .inner.disabled:active.grandchild, .inner.disabled:focus.grandchild {\n  background-color: #fafafa;\n}\n.inner .title {\n  flex-grow: 1;\n}\n.inner .fa-icon {\n  fill: #42474c;\n}\n.inner .exclamation-triangle {\n  fill: #f7912a;\n}\n.inner .chevron-down {\n  transition: transform 0.5s, color 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transform-origin: center;\n  transform: rotate(0deg);\n}\n.inner .chevron-down.open {\n  transform: rotate(180deg);\n}\n\n.el-collapse {\n  box-shadow: inset 0 -1px 0 0 #efefef;\n}\n\n.el-collapse-item__header.is-active:not(:focus) > .parent,\n.el-collapse-item__header.is-active:not(:focus) > .child {\n  color: #2638a6;\n}\n.el-collapse-item__header.is-active:not(:focus) .chevron-down {\n  fill: #2638a6;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */","<template>\n  <div class=\"menu-item\">\n    <el-collapse\n      v-if=\"isToggle\"\n      v-model=\"activeNames\"\n      @change=\"onToggle\"\n    >\n      <el-collapse-item\n        name=\"item\"\n      >\n        <div\n          slot=\"title\"\n          :class=\"[\n            'inner',\n            type,\n            { 'is-toggle' : isToggle },\n            { 'disabled' : disabled }\n          ]\"\n          @mouseover=\"hover = true\"\n          @mouseleave=\"hover = false\"\n        >\n          <div\n            class=\"title\"\n            v-text=\"title\"\n          />\n\n          <icon\n            name=\"chevron-down\"\n            :class=\"[\n              'chevron-down',\n              { 'open': localIsOpen }\n            ]\"\n          />\n        </div>\n        <div class=\"contents\">\n          <slot />\n        </div>\n      </el-collapse-item>\n    </el-collapse>\n\n    <router-link\n      v-else\n      data-test-menu-link\n      v-bind=\"{\n        class: [\n          'inner',\n          type,\n          { 'link': !disabled },\n          { 'is-toggle': isToggle },\n          { 'disabled': disabled },\n          { 'hover': hover },\n        ],\n        disabled,\n        event: '', // disabling this to move logic to closeHamburgerMenu\n        to,\n      }\"\n      @click.native=\"closeHamburgerMenu\"\n    >\n      <div\n        class=\"title\"\n        v-text=\"title\"\n      />\n\n      <icon\n        v-if=\"icon\"\n        :name=\"icon\"\n        :class=\"icon\"\n      />\n\n      <tf-badge\n        v-if=\"badgeCount\"\n        :value=\"badgeCount\"\n        status=\"error\"\n        is-counter\n      />\n    </router-link>\n  </div>\n</template>\n\n<script>\n  /**\n   * Hamburger Menu Toggle\n   *\n   * @vuedoc\n   * @exports MenuToggle\n   * @category Components\n   */\n  export default {\n    name: 'MenuBarItem',\n\n    inject: {\n      menu: {\n        default: {\n          /**\n           * Dummy method in case nothing is provided\n           */\n          closeHamburgerMenu() { },\n        },\n      },\n    },\n\n    props: {\n      title: {\n        type: String,\n        required: true,\n      },\n\n      type: {\n        type: String,\n        default: 'grandchild',\n      },\n\n      to: {\n        type: [Object, String],\n        default: () => ({}),\n      },\n\n      isToggle: {\n        type: Boolean,\n        default: false,\n      },\n\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n\n      isOpen: {\n        type: Boolean,\n        default: false,\n      },\n\n      badgeCount: {\n        type: Number,\n        default: 0,\n      },\n      icon: {\n        type: String,\n        default: '',\n      },\n    },\n\n    data: () => ({\n      localIsOpen: false,\n      activeNames: [],\n      hover: false,\n    }),\n\n    created() {\n      this.localIsOpen = this.isOpen;\n\n      if (this.isOpen) {\n        this.$set(this, 'activeNames', ['item']);\n      }\n    },\n\n    methods: {\n      /**\n       * Track open/closed state locally to show correct toggle chevron\n       */\n      onToggle() {\n        this.localIsOpen = !this.localIsOpen;\n      },\n\n      /**\n       * Close the parent menu and then route to the required path as defined in the to object that was passed as a prop.\n       */\n      closeHamburgerMenu() {\n        if (this.disabled) {\n          return;\n        }\n        this.menu.closeHamburgerMenu();\n        this.$router.push(this.to);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .inner {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 40px;\n    padding: 0 15px 0 30px;\n    line-height: 40px;\n    font-size: 14px;\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n\n    &.link {\n      color: $tf-dark-gray;\n      font-weight: 400;\n    }\n\n    &.parent {\n      padding-left: 15px;\n      font-size: 16px;\n      font-weight: 700;\n    }\n\n    &.child {\n      padding-left: 20px;\n      font-weight: 600;\n    }\n\n    &.grandchild {\n      padding-left: 30px;\n      background: $tf-extra-light-gray-2;\n    }\n\n    &.parent,\n    &.child,\n    &.grandchild {\n      &:focus, &.router-link-exact-active:not(.disabled) {\n        background: $tf-blue;\n        color: $tf-white;\n\n        svg {\n          fill: $tf-white;\n        }\n      }\n    }\n\n    &.is-toggle {\n      cursor: pointer;\n    }\n\n    &.disabled {\n      color: $tf-medium-gray;\n      cursor: not-allowed;\n\n      &.grandchild {\n        background-color: $tf-extra-light-gray-2;\n      }\n\n      &:hover, &:active, &:focus {\n        background-color: $tf-white;\n        box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n        color: $tf-medium-gray;\n\n        &.grandchild {\n          background-color: $tf-extra-light-gray-2;\n        }\n      }\n    }\n\n    .title {\n      flex-grow: 1;\n    }\n\n    .fa-icon {\n      fill: $tf-dark-gray;\n    }\n\n    .exclamation-triangle {\n      fill: $tf-orange;\n    }\n\n    .chevron-down {\n      transition: transform .5s, color .5s cubic-bezier(.645, .045, .355, 1);\n      transform-origin: center;\n      transform: rotate(0deg);\n\n      &.open {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .el-collapse {\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n  }\n\n  .el-collapse-item__header {\n    &.is-active:not(:focus) {\n      > .parent,\n      > .child {\n        color: $tf-blue;\n      }\n\n      .chevron-down {\n        fill: $tf-blue;\n      }\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .menu-item .el-collapse-item__header:focus,\n  .menu-item .link:focus {\n    outline: none;\n    box-shadow: inset 0 -1px 0 0 $tf-blue, inset 0 1px 0 0 $tf-blue;\n    background: $tf-blue;\n    color: $tf-white;\n\n    svg {\n      fill: $tf-white;\n    }\n  }\n\n  .menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n  .menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n    background: $tf-light-blue;\n  }\n</style>\n"]}, media: undefined })
,inject("data-v-661ea622_1", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.menu-item .el-collapse-item__header:focus,\n.menu-item .link:focus {\n  outline: none;\n  box-shadow: inset 0 -1px 0 0 #2638a6, inset 0 1px 0 0 #2638a6;\n  background: #2638a6;\n  color: #fff;\n}\n.menu-item .el-collapse-item__header:focus svg,\n.menu-item .link:focus svg {\n  fill: #fff;\n}\n.menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n.menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n  background: #f4f5ff;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */", map: {"version":3,"sources":["MenuItem.vue","/home/circleci/repo/src/components/HamburgerMenu/MenuItem.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC+RpC;;EAEA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,WAAA;AD7RA;AC+RA;;EACA,UAAA;AD5RA;ACgSA;;EAEA,mBAAA;AD7RA;;AAEA,uCAAuC","file":"MenuItem.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.menu-item .el-collapse-item__header:focus,\n.menu-item .link:focus {\n  outline: none;\n  box-shadow: inset 0 -1px 0 0 #2638a6, inset 0 1px 0 0 #2638a6;\n  background: #2638a6;\n  color: #fff;\n}\n.menu-item .el-collapse-item__header:focus svg,\n.menu-item .link:focus svg {\n  fill: #fff;\n}\n\n.menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n.menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n  background: #f4f5ff;\n}\n\n/*# sourceMappingURL=MenuItem.vue.map */","<template>\n  <div class=\"menu-item\">\n    <el-collapse\n      v-if=\"isToggle\"\n      v-model=\"activeNames\"\n      @change=\"onToggle\"\n    >\n      <el-collapse-item\n        name=\"item\"\n      >\n        <div\n          slot=\"title\"\n          :class=\"[\n            'inner',\n            type,\n            { 'is-toggle' : isToggle },\n            { 'disabled' : disabled }\n          ]\"\n          @mouseover=\"hover = true\"\n          @mouseleave=\"hover = false\"\n        >\n          <div\n            class=\"title\"\n            v-text=\"title\"\n          />\n\n          <icon\n            name=\"chevron-down\"\n            :class=\"[\n              'chevron-down',\n              { 'open': localIsOpen }\n            ]\"\n          />\n        </div>\n        <div class=\"contents\">\n          <slot />\n        </div>\n      </el-collapse-item>\n    </el-collapse>\n\n    <router-link\n      v-else\n      data-test-menu-link\n      v-bind=\"{\n        class: [\n          'inner',\n          type,\n          { 'link': !disabled },\n          { 'is-toggle': isToggle },\n          { 'disabled': disabled },\n          { 'hover': hover },\n        ],\n        disabled,\n        event: '', // disabling this to move logic to closeHamburgerMenu\n        to,\n      }\"\n      @click.native=\"closeHamburgerMenu\"\n    >\n      <div\n        class=\"title\"\n        v-text=\"title\"\n      />\n\n      <icon\n        v-if=\"icon\"\n        :name=\"icon\"\n        :class=\"icon\"\n      />\n\n      <tf-badge\n        v-if=\"badgeCount\"\n        :value=\"badgeCount\"\n        status=\"error\"\n        is-counter\n      />\n    </router-link>\n  </div>\n</template>\n\n<script>\n  /**\n   * Hamburger Menu Toggle\n   *\n   * @vuedoc\n   * @exports MenuToggle\n   * @category Components\n   */\n  export default {\n    name: 'MenuBarItem',\n\n    inject: {\n      menu: {\n        default: {\n          /**\n           * Dummy method in case nothing is provided\n           */\n          closeHamburgerMenu() { },\n        },\n      },\n    },\n\n    props: {\n      title: {\n        type: String,\n        required: true,\n      },\n\n      type: {\n        type: String,\n        default: 'grandchild',\n      },\n\n      to: {\n        type: [Object, String],\n        default: () => ({}),\n      },\n\n      isToggle: {\n        type: Boolean,\n        default: false,\n      },\n\n      disabled: {\n        type: Boolean,\n        default: false,\n      },\n\n      isOpen: {\n        type: Boolean,\n        default: false,\n      },\n\n      badgeCount: {\n        type: Number,\n        default: 0,\n      },\n      icon: {\n        type: String,\n        default: '',\n      },\n    },\n\n    data: () => ({\n      localIsOpen: false,\n      activeNames: [],\n      hover: false,\n    }),\n\n    created() {\n      this.localIsOpen = this.isOpen;\n\n      if (this.isOpen) {\n        this.$set(this, 'activeNames', ['item']);\n      }\n    },\n\n    methods: {\n      /**\n       * Track open/closed state locally to show correct toggle chevron\n       */\n      onToggle() {\n        this.localIsOpen = !this.localIsOpen;\n      },\n\n      /**\n       * Close the parent menu and then route to the required path as defined in the to object that was passed as a prop.\n       */\n      closeHamburgerMenu() {\n        if (this.disabled) {\n          return;\n        }\n        this.menu.closeHamburgerMenu();\n        this.$router.push(this.to);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .inner {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 40px;\n    padding: 0 15px 0 30px;\n    line-height: 40px;\n    font-size: 14px;\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n\n    &.link {\n      color: $tf-dark-gray;\n      font-weight: 400;\n    }\n\n    &.parent {\n      padding-left: 15px;\n      font-size: 16px;\n      font-weight: 700;\n    }\n\n    &.child {\n      padding-left: 20px;\n      font-weight: 600;\n    }\n\n    &.grandchild {\n      padding-left: 30px;\n      background: $tf-extra-light-gray-2;\n    }\n\n    &.parent,\n    &.child,\n    &.grandchild {\n      &:focus, &.router-link-exact-active:not(.disabled) {\n        background: $tf-blue;\n        color: $tf-white;\n\n        svg {\n          fill: $tf-white;\n        }\n      }\n    }\n\n    &.is-toggle {\n      cursor: pointer;\n    }\n\n    &.disabled {\n      color: $tf-medium-gray;\n      cursor: not-allowed;\n\n      &.grandchild {\n        background-color: $tf-extra-light-gray-2;\n      }\n\n      &:hover, &:active, &:focus {\n        background-color: $tf-white;\n        box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n        color: $tf-medium-gray;\n\n        &.grandchild {\n          background-color: $tf-extra-light-gray-2;\n        }\n      }\n    }\n\n    .title {\n      flex-grow: 1;\n    }\n\n    .fa-icon {\n      fill: $tf-dark-gray;\n    }\n\n    .exclamation-triangle {\n      fill: $tf-orange;\n    }\n\n    .chevron-down {\n      transition: transform .5s, color .5s cubic-bezier(.645, .045, .355, 1);\n      transform-origin: center;\n      transform: rotate(0deg);\n\n      &.open {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .el-collapse {\n    box-shadow: inset 0 -1px 0 0 $tf-extra-light-gray-1;\n  }\n\n  .el-collapse-item__header {\n    &.is-active:not(:focus) {\n      > .parent,\n      > .child {\n        color: $tf-blue;\n      }\n\n      .chevron-down {\n        fill: $tf-blue;\n      }\n    }\n  }\n</style>\n\n<style lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .menu-item .el-collapse-item__header:focus,\n  .menu-item .link:focus {\n    outline: none;\n    box-shadow: inset 0 -1px 0 0 $tf-blue, inset 0 1px 0 0 $tf-blue;\n    background: $tf-blue;\n    color: $tf-white;\n\n    svg {\n      fill: $tf-white;\n    }\n  }\n\n  .menu-item .el-collapse-item__header:hover:not(:focus):not(.router-link-exact-active),\n  .menu-item .link:hover:not(:focus):not(.router-link-exact-active) {\n    background: $tf-light-blue;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$N = "data-v-661ea622";
  /* module identifier */
  const __vue_module_identifier__$N = undefined;
  /* functional template */
  const __vue_is_functional_template__$N = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$N = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
    __vue_inject_styles__$N,
    __vue_script__$N,
    __vue_scope_id__$N,
    __vue_is_functional_template__$N,
    __vue_module_identifier__$N,
    false,
    browser,
    undefined,
    undefined
  );

// 21.2.5.3 get RegExp.prototype.flags()
if (_descriptors && /./g.flags != 'g') _objectDp.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: _flags
});

var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  _redefine(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (_fails(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = _anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING$1 = 'toString';
var $toString$1 = DateProto[TO_STRING$1];
var getTime$1 = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  _redefine(DateProto, TO_STRING$1, function toString() {
    var value = getTime$1.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString$1.call(this) : INVALID_DATE;
  });
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$O = {
  name: 'TfPanel',
  props: {
    backUrl: {
      type: String,
      // this is the url that we look for to trigger this panel
      default: null
    },
    open: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: null
    }
  },
  created: function created() {
    document.addEventListener('keyup', this.escapeKeyListener);
    document.addEventListener('click', this.outsidePanelListener);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keyup', this.escapeKeyListener);
    document.removeEventListener('click', this.outsidePanelListener);
  },
  methods: {
    /**
     * Close the panel if the user hits the esc key.
     *
     * @param {event} event
     * @param {number} event.keyCode
     */
    escapeKeyListener: function escapeKeyListener(_ref) {
      var keyCode = _ref.keyCode;

      if (keyCode === 27) {
        this.closePanel();
      }
    },

    /**
     * Close the panel when when someone clicks outside the panel.
     *
     * @param {event} event
     * @param {object} event.target
     */
    outsidePanelListener: function outsidePanelListener(_ref2) {
      var target = _ref2.target;
      var panel = this.$el;
      var isInPanel = panel === target || panel.contains(target);
      var dontClosePanel = this.shouldNotClosePanel(target);
      var hasTextSelection = getSelection() && getSelection().toString().length > 0;

      if (!isInPanel && !dontClosePanel && !hasTextSelection && this.open) {
        this.closePanel();
      }
    },

    /**
     * Close the panel.
     * Replacing the route would throw an error since it's a duplicate identical route
     * If this happens, we are probably opening the panel via a dispatch
     * and should close it the same way.
     */
    closePanel: function closePanel() {
      if (this.backUrl === this.$route.path) {
        this.$store.dispatch(this.action, false);
      } else {
        this.$router.replace(this.backUrl);
      }
    },

    /**
     * Check if the user clicked on something that should not close the panel.
     * This include even if it's outside the panel.
     *
     * @param {object} element
     * @returns {boolean}
     */
    shouldNotClosePanel: function shouldNotClosePanel(element) {
      if (element.hasAttribute && (element.hasAttribute('data-dont-close-panel') || element.hasAttribute('data-do-not-close-panel'))) {
        return true;
      }

      return element.parentNode && this.shouldNotClosePanel(element.parentNode);
    }
  }
};

/* script */
const __vue_script__$O = script$O;

/* template */
var __vue_render__$N = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: ["panel", { open: _vm.open }] },
    [
      _c(
        "tf-button",
        {
          staticClass: "close-btn",
          attrs: {
            type: "primary",
            icon: "times",
            size: "icon-no-fill",
            "no-border": ""
          },
          on: { click: _vm.closePanel }
        },
        [_vm._v("\n    Close Panel\n  ")]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
};
var __vue_staticRenderFns__$N = [];
__vue_render__$N._withStripped = true;

  /* style */
  const __vue_inject_styles__$O = function (inject) {
    if (!inject) return
    inject("data-v-eea69ebe_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.panel[data-v-eea69ebe] {\n  position: fixed;\n  right: 0;\n  z-index: 100;\n  height: 100%;\n  width: 0;\n  transition: width 0.5s;\n  max-width: 557px;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #efefef;\n  color: #000;\n  text-align: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.open[data-v-eea69ebe] {\n  width: 100%;\n}\n.panel .close-btn[data-v-eea69ebe] {\n  position: absolute;\n  right: 9px;\n  top: 9px;\n}\n\n/*# sourceMappingURL=TfPanel1.vue.map */", map: {"version":3,"sources":["TfPanel1.vue","/home/circleci/repo/src/components/TfPanel1.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACyGpC;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0EAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;ADvGA;ACyGA;EACA,WAAA;ADvGA;AC0GA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;ADxGA;;AAEA,uCAAuC","file":"TfPanel1.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.panel {\n  position: fixed;\n  right: 0;\n  z-index: 100;\n  height: 100%;\n  width: 0;\n  transition: width 0.5s;\n  max-width: 557px;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #efefef;\n  color: #000;\n  text-align: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.open {\n  width: 100%;\n}\n.panel .close-btn {\n  position: absolute;\n  right: 9px;\n  top: 9px;\n}\n\n/*# sourceMappingURL=TfPanel1.vue.map */","<template>\n  <div :class=\"['panel', { open: open }]\">\n    <tf-button\n      class=\"close-btn\"\n      type=\"primary\"\n      icon=\"times\"\n      size=\"icon-no-fill\"\n      no-border\n      @click=\"closePanel\"\n    >\n      Close Panel\n    </tf-button>\n    <slot />\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'TfPanel',\n    props: {\n      backUrl: {\n        type: String, // this is the url that we look for to trigger this panel\n        default: null,\n      },\n      open: {\n        type: Boolean,\n        default: false,\n      },\n      action: {\n        type: String,\n        default: null,\n      },\n    },\n    created() {\n      document.addEventListener('keyup', this.escapeKeyListener);\n      document.addEventListener('click', this.outsidePanelListener);\n    },\n    destroyed() {\n      document.removeEventListener('keyup', this.escapeKeyListener);\n      document.removeEventListener('click', this.outsidePanelListener);\n    },\n    methods: {\n      /**\n       * Close the panel if the user hits the esc key.\n       *\n       * @param {event} event\n       * @param {number} event.keyCode\n       */\n      escapeKeyListener({ keyCode }) {\n        if (keyCode === 27) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Close the panel when when someone clicks outside the panel.\n       *\n       * @param {event} event\n       * @param {object} event.target\n       */\n      outsidePanelListener({ target }) {\n        const panel = this.$el;\n        const isInPanel = panel === target || panel.contains(target);\n        const dontClosePanel = this.shouldNotClosePanel(target);\n        const hasTextSelection = getSelection() && getSelection().toString().length > 0;\n\n        if (!isInPanel && !dontClosePanel && !hasTextSelection && this.open) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Close the panel.\n       * Replacing the route would throw an error since it's a duplicate identical route\n       * If this happens, we are probably opening the panel via a dispatch\n       * and should close it the same way.\n       */\n      closePanel() {\n        if (this.backUrl === this.$route.path) {\n          this.$store.dispatch(this.action, false);\n        } else {\n          this.$router.replace(this.backUrl);\n        }\n      },\n\n      /**\n       * Check if the user clicked on something that should not close the panel.\n       * This include even if it's outside the panel.\n       *\n       * @param {object} element\n       * @returns {boolean}\n       */\n      shouldNotClosePanel(element) {\n        if (\n          element.hasAttribute\n          && (\n            element.hasAttribute('data-dont-close-panel')\n            || element.hasAttribute('data-do-not-close-panel')\n          )\n        ) {\n          return true;\n        }\n        return element.parentNode && this.shouldNotClosePanel(element.parentNode);\n      },\n    },\n  };\n</script>\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/mixins';\n\n.panel {\n  position: fixed;\n  right: 0;\n  z-index: 100;\n  height: 100%;\n  width: 0;\n  transition: width .5s;\n  max-width: 557px;\n  box-sizing: border-box;\n  background: $tf-white;\n  box-shadow: 0 0 6px 0 rgba($tf-black, .04), 0 2px 4px 0 rgba($tf-black, .12);\n  border: solid 1px $tf-extra-light-gray-1;\n  color: $tf-black;\n  text-align: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  &.open {\n    width: 100%;\n  }\n\n  .close-btn {\n    position: absolute;\n    right: 9px;\n    top: 9px;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$O = "data-v-eea69ebe";
  /* module identifier */
  const __vue_module_identifier__$O = undefined;
  /* functional template */
  const __vue_is_functional_template__$O = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$O = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
    __vue_inject_styles__$O,
    __vue_script__$O,
    __vue_scope_id__$O,
    __vue_is_functional_template__$O,
    __vue_module_identifier__$O,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$P = {
  name: 'TfPanel2',
  props: {
    title: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    handle: {
      type: Boolean,
      default: false
    },
    // handle alias; TODO deprecate/remove at shared 3.0
    statusBar: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: true
    },
    trigger: {
      type: String,
      default: null
    },
    closeOnEscape: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'right'
    },
    fixedPosition: {
      type: Boolean,
      default: true
    },
    top: {
      type: [String, Number],
      default: '0px'
    },
    maxWidth: {
      type: String,
      default: '557px'
    },
    minWidth: {
      type: String,
      default: '0px'
    }
  },
  data: function data() {
    return {
      handleLeftPosition: null,
      handleRightPosition: null
    };
  },
  computed: {
    /**
     * Normalize top position to a string with `px` if needed
     * (Let's standardize on strings with units,
     * since the width props are strings,
     * but still backwards support number positions)
     *
     * @returns {string}
     */
    normalizedTop: function normalizedTop() {
      return typeof this.top === 'number' ? "".concat(this.top, "px") : this.top;
    },

    /**
     * Get the classes for the panel
     *
     * @returns {Array}
     */
    panelClass: function panelClass() {
      return ['panel', this.position, {
        open: this.open,
        animate: this.animate,
        'has-handle': this.handle,
        fixed: this.fixedPosition
      }];
    },

    /**
     * Get the inline styles for the panel
     *
     * @returns {object}
     */
    panelStyle: function panelStyle() {
      return {
        width: this.maxWidth,
        minWidth: this.open ? this.minWidth : 0,
        top: this.normalizedTop,
        height: "calc(100% - ".concat(this.normalizedTop, ")")
      };
    },

    /**
     * Get the inline styles for the handle
     *
     * @returns {object}
     */
    handleStyle: function handleStyle() {
      return {
        left: this.handleLeftPosition,
        right: this.handleRightPosition,
        height: "calc(100% - ".concat(this.top, "px)")
      };
    },

    /**
     * Get right direction for carets
     *
     * @returns {string}
     */
    statusIconDirection: function statusIconDirection() {
      if (!this.open && this.position === 'left' || this.open && this.position === 'right') {
        return 'caret-down';
      }

      return 'caret-up';
    },

    /**
     * Get handle boolean (backwards compatibility with old "status bar" boolean)
     *
     * @returns {boolean}
     */
    localHandle: function localHandle() {
      return this.statusBar || this.handle;
    }
  },
  watch: {
    /**
     * When the panel is opened we need to set the position of the 'handle'
     */
    open: function open() {
      this.setHandlePosition();
    }
  },
  created: function created() {
    if (this.closable) {
      if (this.closeOnEscape) {
        document.addEventListener('keyup', this.escapeKeyListener);
      }

      if (this.closeOnOutsideClick) {
        document.addEventListener('click', this.outsidePanelListener);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.localHandle) {
      window.addEventListener('resize', function () {
        _this.setHandlePosition();
      });
      this.setHandlePosition();
    }
  },
  destroyed: function destroyed() {
    var _this2 = this;

    if (this.closable) {
      if (this.closeOnEscape) {
        document.removeEventListener('keyup', this.escapeKeyListener);
      }

      if (this.closeOnOutsideClick) {
        document.removeEventListener('click', this.outsidePanelListener);
      }
    }

    if (this.localHandle) {
      window.removeEventListener('resize', function () {
        _this2.setHandlePosition();
      });
    }
  },
  methods: {
    /**
     * set the position of the handle
     */
    setHandlePosition: function setHandlePosition() {
      var windowWidth = window.innerWidth;
      var maxWidthHasPercentage = this.maxWidth.indexOf('%') > -1;
      var minWidth = this.minWidth.replace('px', '');
      var maxPixelWidth;

      if (maxWidthHasPercentage) {
        maxPixelWidth = this.maxWidth.replace('%', '') / 100 * windowWidth;
      } else {
        maxPixelWidth = this.maxWidth.replace('px', '');
      }

      if (this.position === 'right') {
        if (this.open) {
          this.handleLeftPosition = 'auto';

          if (minWidth && maxPixelWidth < minWidth) {
            this.handleRightPosition = this.minWidth;
          } else {
            this.handleRightPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? "".concat(windowWidth - 10, "px") : this.maxWidth;
          }
        } else {
          this.handleLeftPosition = 'auto';
          this.handleRightPosition = '0px';
        }
      } else if (this.open) {
        if (minWidth && maxPixelWidth < minWidth) {
          this.handleLeftPosition = this.minWidth;
        } else {
          this.handleLeftPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? "".concat(windowWidth - 10, "px") : this.maxWidth;
        }

        this.handleRightPosition = 'auto';
      } else {
        this.handleLeftPosition = '0px';
        this.handleRightPosition = 'auto';
      }
    },

    /**
     * Close the panel
     */
    closePanel: function closePanel() {
      this.$emit('togglePanel', false);
    },

    /**
     * Toggle the panel
     */
    togglePanel: function togglePanel() {
      this.$emit('togglePanel', !this.open);
    },

    /**
     * Close panel on escape key
     *
     * @param {object} event
     */
    escapeKeyListener: function escapeKeyListener(event) {
      if (event.keyCode === 27) {
        this.closePanel();
      }
    },

    /**
     * Return color value as reactive value
     *
     * @param {object} event
     */
    outsidePanelListener: function outsidePanelListener(event) {
      var target = event.target;
      var panel = this.$el;
      var isInPanel = this.isChildOf(target, panel);

      if (!isInPanel && this.closable) {
        this.closePanel();
      }
    },

    /**
     * Check if element is child of another element
     *
     * @param {object} child
     * @param {object} parent
     * @returns {boolean}
     */
    isChildOf: function isChildOf(child, parent) {
      if (child.parentNode === parent) {
        return true;
      }

      if (child.parentNode === null) {
        return false;
      }

      return this.isChildOf(child.parentNode, parent);
    }
  }
};

/* script */
const __vue_script__$P = script$P;

/* template */
var __vue_render__$O = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "panel", class: _vm.panelClass, style: _vm.panelStyle },
    [
      _vm.localHandle
        ? _c(
            "button",
            {
              staticClass: "handle",
              style: _vm.handleStyle,
              on: {
                click: function($event) {
                  return _vm.togglePanel()
                }
              }
            },
            [
              _c(
                "span",
                [
                  _c("icon", { attrs: { name: _vm.statusIconDirection } }),
                  _vm._v(" "),
                  _c("icon", { attrs: { name: _vm.statusIconDirection } }),
                  _vm._v(" "),
                  _c("icon", { attrs: { name: _vm.statusIconDirection } })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.title || _vm.closable
        ? _c(
            "header",
            [
              _vm.title
                ? _c("h3", { domProps: { textContent: _vm._s(_vm.title) } })
                : _vm._e(),
              _vm._v(" "),
              _vm.closable
                ? _c("tf-button", {
                    staticClass: "close",
                    attrs: {
                      type: "primary",
                      icon: "times",
                      size: "icon-no-fill",
                      "no-border": ""
                    },
                    on: { click: _vm.closePanel }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("main", { staticClass: "panel-content" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("footer", { attrs: { slot: "footer" }, slot: "footer" })
    ]
  )
};
var __vue_staticRenderFns__$O = [];
__vue_render__$O._withStripped = true;

  /* style */
  const __vue_inject_styles__$P = function (inject) {
    if (!inject) return
    inject("data-v-a88f5388_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.panel[data-v-a88f5388] {\n  display: flex;\n  flex-direction: column;\n  right: 0;\n  z-index: 100;\n  max-width: 0;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #c1c1c1;\n  color: #000;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.fixed[data-v-a88f5388] {\n  position: fixed;\n}\n.panel:not(.fixed).has-handle[data-v-a88f5388] {\n  margin-left: 8px;\n}\n.panel.animate[data-v-a88f5388] {\n  transition: width 0.5s;\n}\n.panel.left[data-v-a88f5388] {\n  right: auto;\n  left: 0;\n}\n.panel.open[data-v-a88f5388] {\n  max-width: 100%;\n  overflow-y: auto;\n}\n.panel-content[data-v-a88f5388] {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n}\n.handle[data-v-a88f5388] {\n  background: #f4f5ff;\n  border: 0;\n  border-left: 1px solid #c1c1c1;\n  border-right: 1px solid #c1c1c1;\n  overflow: hidden;\n  cursor: pointer;\n  height: calc(100% + 1px);\n  margin-top: -1px;\n  position: fixed;\n  z-index: 10;\n  width: 14px;\n  padding: 0;\n}\n.handle[data-v-a88f5388]:focus {\n  border-color: #999;\n  outline: none;\n}\n.handle span[data-v-a88f5388] {\n  position: relative;\n  left: -4px;\n}\n.handle svg[data-v-a88f5388] {\n  color: #c1c1c1;\n  transform: rotate(-90deg);\n  transform-origin: left top 0;\n}\n.left .handle[data-v-a88f5388] {\n  box-shadow: 4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\n.right .handle[data-v-a88f5388] {\n  box-shadow: -4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\nheader[data-v-a88f5388] {\n  margin: 0;\n  padding: 4px 4px 4px 12px;\n  background: #fafafa;\n  border-bottom: 1px solid #c1c1c1;\n  display: flex;\n  align-items: flex-start;\n}\nh3[data-v-a88f5388] {\n  margin: 0;\n  padding: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  text-align: left;\n  flex-grow: 1;\n}\n\n/*# sourceMappingURL=TfPanel2.vue.map */", map: {"version":3,"sources":["TfPanel2.vue","/home/circleci/repo/src/components/TfPanel2.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AACpC;;kCAEkC;AAClC;;oCAEoC;AC4VpC;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,0EAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;AD1VA;AC4VA;EACA,eAAA;AD1VA;AC6VA;EACA,gBAAA;AD3VA;AC8VA;EACA,sBAAA;AD5VA;AC+VA;EACA,WAAA;EACA,OAAA;AD7VA;ACgWA;EACA,eAAA;EACA,gBAAA;AD9VA;ACkWA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,gBAAA;AD/VA;ACkWA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AD/VA;ACiWA;EACA,kBAAA;EACA,aAAA;AD/VA;ACkWA;EACA,kBAAA;EACA,UAAA;ADhWA;ACmWA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;ADjWA;ACoWA;EACA,2CAAA;ADlWA;ACqWA;EACA,4CAAA;ADnWA;ACuWA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;ADpWA;ACuWA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;ADpWA;;AAEA,uCAAuC","file":"TfPanel2.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.panel {\n  display: flex;\n  flex-direction: column;\n  right: 0;\n  z-index: 100;\n  max-width: 0;\n  box-sizing: border-box;\n  background: #fff;\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  border: solid 1px #c1c1c1;\n  color: #000;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.panel.fixed {\n  position: fixed;\n}\n.panel:not(.fixed).has-handle {\n  margin-left: 8px;\n}\n.panel.animate {\n  transition: width 0.5s;\n}\n.panel.left {\n  right: auto;\n  left: 0;\n}\n.panel.open {\n  max-width: 100%;\n  overflow-y: auto;\n}\n\n.panel-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.handle {\n  background: #f4f5ff;\n  border: 0;\n  border-left: 1px solid #c1c1c1;\n  border-right: 1px solid #c1c1c1;\n  overflow: hidden;\n  cursor: pointer;\n  height: calc(100% + 1px);\n  margin-top: -1px;\n  position: fixed;\n  z-index: 10;\n  width: 14px;\n  padding: 0;\n}\n.handle:focus {\n  border-color: #999;\n  outline: none;\n}\n.handle span {\n  position: relative;\n  left: -4px;\n}\n.handle svg {\n  color: #c1c1c1;\n  transform: rotate(-90deg);\n  transform-origin: left top 0;\n}\n.left .handle {\n  box-shadow: 4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\n.right .handle {\n  box-shadow: -4px 0 5px 0 rgba(0, 0, 0, 0.25);\n}\n\nheader {\n  margin: 0;\n  padding: 4px 4px 4px 12px;\n  background: #fafafa;\n  border-bottom: 1px solid #c1c1c1;\n  display: flex;\n  align-items: flex-start;\n}\n\nh3 {\n  margin: 0;\n  padding: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  text-align: left;\n  flex-grow: 1;\n}\n\n/*# sourceMappingURL=TfPanel2.vue.map */","<template>\n  <div\n    ref=\"panel\"\n    :class=\"panelClass\"\n    :style=\"panelStyle\"\n  >\n    <button\n      v-if=\"localHandle\"\n      :style=\"handleStyle\"\n      class=\"handle\"\n      @click=\"togglePanel()\"\n    >\n      <span>\n        <icon :name=\"statusIconDirection\" />\n        <icon :name=\"statusIconDirection\" />\n        <icon :name=\"statusIconDirection\" />\n      </span>\n    </button>\n\n    <header\n      v-if=\"title || closable\"\n    >\n      <h3\n        v-if=\"title\"\n        v-text=\"title\"\n      />\n\n      <tf-button\n        v-if=\"closable\"\n        class=\"close\"\n        type=\"primary\"\n        icon=\"times\"\n        size=\"icon-no-fill\"\n        no-border\n        @click=\"closePanel\"\n      />\n    </header>\n\n    <main\n      class=\"panel-content\"\n    >\n      <slot />\n    </main>\n\n    <footer\n      slot=\"footer\"\n    />\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'TfPanel2',\n\n    props: {\n      title: {\n        type: String,\n        default: '',\n      },\n\n      open: {\n        type: Boolean,\n        default: false,\n      },\n\n      closable: {\n        type: Boolean,\n        default: true,\n      },\n\n      handle: {\n        type: Boolean,\n        default: false,\n      },\n\n      // handle alias; TODO deprecate/remove at shared 3.0\n      statusBar: {\n        type: Boolean,\n        default: false,\n      },\n\n      animate: {\n        type: Boolean,\n        default: true,\n      },\n\n      trigger: {\n        type: String,\n        default: null,\n      },\n\n      closeOnEscape: {\n        type: Boolean,\n        default: false,\n      },\n\n      position: {\n        type: String,\n        default: 'right',\n      },\n\n      fixedPosition: {\n        type: Boolean,\n        default: true,\n      },\n\n      top: {\n        type: [String, Number],\n        default: '0px',\n      },\n\n      maxWidth: {\n        type: String,\n        default: '557px',\n      },\n\n      minWidth: {\n        type: String,\n        default: '0px',\n      },\n    },\n    data: () => ({\n      handleLeftPosition: null,\n      handleRightPosition: null,\n    }),\n\n    computed: {\n      /**\n       * Normalize top position to a string with `px` if needed\n       * (Let's standardize on strings with units,\n       * since the width props are strings,\n       * but still backwards support number positions)\n       *\n       * @returns {string}\n       */\n      normalizedTop() {\n        return typeof this.top === 'number'\n          ? `${this.top}px`\n          : this.top;\n      },\n\n      /**\n       * Get the classes for the panel\n       *\n       * @returns {Array}\n       */\n      panelClass() {\n        return [\n          'panel',\n          this.position,\n          {\n            open: this.open,\n            animate: this.animate,\n            'has-handle': this.handle,\n            fixed: this.fixedPosition,\n          },\n        ];\n      },\n\n      /**\n       * Get the inline styles for the panel\n       *\n       * @returns {object}\n       */\n      panelStyle() {\n        return {\n          width: this.maxWidth,\n          minWidth: this.open ? this.minWidth : 0,\n          top: this.normalizedTop,\n          height: `calc(100% - ${this.normalizedTop})`,\n        };\n      },\n\n      /**\n       * Get the inline styles for the handle\n       *\n       * @returns {object}\n       */\n      handleStyle() {\n        return {\n          left: this.handleLeftPosition,\n          right: this.handleRightPosition,\n          height: `calc(100% - ${this.top}px)`,\n        };\n      },\n\n      /**\n       * Get right direction for carets\n       *\n       * @returns {string}\n       */\n      statusIconDirection() {\n        if (\n          (!this.open && this.position === 'left')\n          || (this.open && this.position === 'right')\n        ) {\n          return 'caret-down';\n        }\n        return 'caret-up';\n      },\n\n      /**\n       * Get handle boolean (backwards compatibility with old \"status bar\" boolean)\n       *\n       * @returns {boolean}\n       */\n      localHandle() {\n        return this.statusBar || this.handle;\n      },\n    },\n\n    watch: {\n      /**\n       * When the panel is opened we need to set the position of the 'handle'\n       */\n      open() {\n        this.setHandlePosition();\n      },\n    },\n\n    created() {\n      if (this.closable) {\n        if (this.closeOnEscape) {\n          document.addEventListener('keyup', this.escapeKeyListener);\n        }\n        if (this.closeOnOutsideClick) {\n          document.addEventListener('click', this.outsidePanelListener);\n        }\n      }\n    },\n\n    mounted() {\n      if (this.localHandle) {\n        window.addEventListener('resize', () => {\n          this.setHandlePosition();\n        });\n        this.setHandlePosition();\n      }\n    },\n\n    destroyed() {\n      if (this.closable) {\n        if (this.closeOnEscape) {\n          document.removeEventListener('keyup', this.escapeKeyListener);\n        }\n        if (this.closeOnOutsideClick) {\n          document.removeEventListener('click', this.outsidePanelListener);\n        }\n      }\n      if (this.localHandle) {\n        window.removeEventListener('resize', () => {\n          this.setHandlePosition();\n        });\n      }\n    },\n\n    methods: {\n      /**\n       * set the position of the handle\n       */\n      setHandlePosition() {\n        const windowWidth = window.innerWidth;\n        const maxWidthHasPercentage = this.maxWidth.indexOf('%') > -1;\n        const minWidth = this.minWidth.replace('px', '');\n        let maxPixelWidth;\n\n        if (maxWidthHasPercentage) {\n          maxPixelWidth = (this.maxWidth.replace('%', '') / 100) * windowWidth;\n        } else {\n          maxPixelWidth = this.maxWidth.replace('px', '');\n        }\n\n        if (this.position === 'right') {\n          if (this.open) {\n            this.handleLeftPosition = 'auto';\n\n            if (minWidth && maxPixelWidth < minWidth) {\n              this.handleRightPosition = this.minWidth;\n            } else {\n              this.handleRightPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? `${windowWidth - 10}px` : this.maxWidth;\n            }\n          } else {\n            this.handleLeftPosition = 'auto';\n            this.handleRightPosition = '0px';\n          }\n        } else if (this.open) {\n          if (minWidth && maxPixelWidth < minWidth) {\n            this.handleLeftPosition = this.minWidth;\n          } else {\n            this.handleLeftPosition = windowWidth - 10 < this.maxWidth.replace('px', '') ? `${windowWidth - 10}px` : this.maxWidth;\n          }\n          this.handleRightPosition = 'auto';\n        } else {\n          this.handleLeftPosition = '0px';\n          this.handleRightPosition = 'auto';\n        }\n      },\n\n      /**\n       * Close the panel\n       */\n      closePanel() {\n        this.$emit('togglePanel', false);\n      },\n\n      /**\n       * Toggle the panel\n       */\n      togglePanel() {\n        this.$emit('togglePanel', !this.open);\n      },\n\n      /**\n       * Close panel on escape key\n       *\n       * @param {object} event\n       */\n      escapeKeyListener(event) {\n        if (event.keyCode === 27) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Return color value as reactive value\n       *\n       * @param {object} event\n       */\n      outsidePanelListener(event) {\n        const { target } = event;\n        const panel = this.$el;\n        const isInPanel = this.isChildOf(target, panel);\n        if (!isInPanel && this.closable) {\n          this.closePanel();\n        }\n      },\n\n      /**\n       * Check if element is child of another element\n       *\n       * @param {object} child\n       * @param {object} parent\n       * @returns {boolean}\n       */\n      isChildOf(child, parent) {\n        if (child.parentNode === parent) {\n          return true;\n        } if (child.parentNode === null) {\n          return false;\n        }\n        return this.isChildOf(child.parentNode, parent);\n      },\n    },\n  };\n</script>\n<style lang=\"scss\" scoped>\n@import 'src/assets/styles/mixins';\n@import 'src/assets/styles/variables';\n\n.panel {\n  display: flex;\n  flex-direction: column;\n  right: 0;\n  z-index: 100;\n  max-width: 0;\n  box-sizing: border-box;\n  background: $tf-white;\n  box-shadow: 0 0 6px 0 rgba($tf-black, .04), 0 2px 4px 0 rgba($tf-black, .12);\n  border: solid 1px $tf-light-gray;\n  color: $tf-black;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  &.fixed {\n    position: fixed;\n  }\n\n  &:not(.fixed).has-handle {\n    margin-left: 8px;\n  }\n\n  &.animate {\n    transition: width .5s;\n  }\n\n  &.left {\n    right: auto;\n    left: 0;\n  }\n\n  &.open {\n    max-width: 100%;\n    overflow-y: auto;\n  }\n}\n\n.panel-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.handle {\n  background: $tf-light-blue;\n  border: 0;\n  border-left: 1px solid $tf-light-gray;\n  border-right: 1px solid $tf-light-gray;\n  overflow: hidden;\n  cursor: pointer;\n  height: calc(100% + 1px);\n  margin-top: -1px;\n  position: fixed;\n  z-index: 10;\n  width: 14px;\n  padding: 0;\n\n  &:focus {\n    border-color: $tf-medium-gray;\n    outline: none;\n  }\n\n  span {\n    position: relative;\n    left: -4px;\n  }\n\n  svg {\n    color: $tf-light-gray;\n    transform: rotate(-90deg);\n    transform-origin: left top 0;\n  }\n\n  .left & {\n    box-shadow: 4px 0 5px 0 rgba($tf-black, .25);\n  }\n\n  .right & {\n    box-shadow: -4px 0 5px 0 rgba($tf-black, .25);\n  }\n}\n\nheader {\n  margin: 0;\n  padding: 4px 4px 4px 12px;\n  background: $tf-extra-light-gray-2;\n  border-bottom: 1px solid $tf-light-gray;\n  display: flex;\n  align-items: flex-start;\n}\n\nh3 {\n  margin: 0;\n  padding: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  text-align: left;\n  flex-grow: 1;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$P = "data-v-a88f5388";
  /* module identifier */
  const __vue_module_identifier__$P = undefined;
  /* functional template */
  const __vue_is_functional_template__$P = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$P = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$O, staticRenderFns: __vue_staticRenderFns__$O },
    __vue_inject_styles__$P,
    __vue_script__$P,
    __vue_scope_id__$P,
    __vue_is_functional_template__$P,
    __vue_module_identifier__$P,
    false,
    browser,
    undefined,
    undefined
  );

var script$Q = {
  name: 'TfPopover',
  extends: Popover,
  props: {
    borderColor: {
      type: String,
      default: null
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      element: null
    };
  },
  watch: {
    /**
     * Add/remove event listeners depending on the state of the popper
     *
     * @param {boolean} newVal
     * @param {boolean} oldVal
     */
    showPopper: function showPopper(newVal, oldVal) {
      var _this = this;

      // store popper DOM element reference
      if (!this.element) {
        this.element = this.$refs.popper;
      }

      if (this.closeOnOutsideClick) {
        if (newVal) {
          document.addEventListener('click', this.outsideClickListener);
        } else {
          this.removeClickListener();
        }
      }

      if (this.borderColor) {
        this.element.style.borderColor = newVal ? this.borderColor : null;
      } // Focus on the tool when opening the popover.


      if (!oldVal) {
        this.$nextTick(function () {
          _this.element.focus();
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeClickListener();
  },
  methods: {
    /**
     * close the popover if someone clicks outside of it
     *
     * @param {event} event
     */
    outsideClickListener: function outsideClickListener(event) {
      if (!this.element.contains(event.target) && this.showPopper) {
        this.removeClickListener();
        this.doClose();
      }
    },

    /**
     * remove the click listener when this is destroyed
     */
    removeClickListener: function removeClickListener() {
      document.removeEventListener('click', this.outsideClickListener);
    }
  }
};

/* script */
const __vue_script__$Q = script$Q;

/* template */

  /* style */
  const __vue_inject_styles__$Q = undefined;
  /* scoped */
  const __vue_scope_id__$Q = undefined;
  /* module identifier */
  const __vue_module_identifier__$Q = undefined;
  /* functional template */
  const __vue_is_functional_template__$Q = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Q = /*#__PURE__*/normalizeComponent_1(
    {},
    __vue_inject_styles__$Q,
    __vue_script__$Q,
    __vue_scope_id__$Q,
    __vue_is_functional_template__$Q,
    __vue_module_identifier__$Q,
    false,
    undefined,
    undefined,
    undefined
  );

var script$R = {
  name: 'TfSubmenu',
  extends: Submenu,
  props: {
    closeOnOutsideClick: {
      type: Boolean,
      default: false
    },
    popperClassName: {
      type: String,
      default: 'tf-hamburger-popper'
    }
  },
  data: function data() {
    return {
      element: null
    };
  },
  watch: {
    /**
     * Watch when the menu opens/closes
     *
     * @param {boolean} newVal
     */
    opened: function opened(newVal) {
      var _this = this;

      if (newVal && this.closeOnOutsideClick) {
        var _document$getElements = document.getElementsByClassName(this.popperClassName),
            _document$getElements2 = _slicedToArray(_document$getElements, 1),
            element = _document$getElements2[0];

        this.element = element; // Add a little delay for this
        // There's an issue on carrier that is emitting on initial trigger

        setTimeout(function () {
          document.addEventListener('click', _this.outsideClickListener);
        }, 10);
      } else {
        this.removeClickListener();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeClickListener();
  },
  methods: {
    /**
     * If a user clicks outside the menu we want to hide it
     *
     * @param {event} event
     */
    outsideClickListener: function outsideClickListener(event) {
      if (this.opened && !this.element.contains(event.target)) {
        this.removeClickListener();
        this.$emit('hide');
      }
    },

    /**
     * We want to remove our listener when the component is destroyed
     */
    removeClickListener: function removeClickListener() {
      document.removeEventListener('click', this.outsideClickListener);
    }
  }
};

/* script */
const __vue_script__$R = script$R;

/* template */

  /* style */
  const __vue_inject_styles__$R = undefined;
  /* scoped */
  const __vue_scope_id__$R = undefined;
  /* module identifier */
  const __vue_module_identifier__$R = undefined;
  /* functional template */
  const __vue_is_functional_template__$R = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$R = /*#__PURE__*/normalizeComponent_1(
    {},
    __vue_inject_styles__$R,
    __vue_script__$R,
    __vue_scope_id__$R,
    __vue_is_functional_template__$R,
    __vue_module_identifier__$R,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$S = {
  name: 'TfTooltip',
  inheritAttrs: false,
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    },
    closePosition: {
      type: Object,
      default: function _default() {
        return {
          top: 4,
          right: 4
        };
      }
    },
    forceShow: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showClose: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: 'tf-fade-in-linear'
    },
    trigger: {
      type: String,
      default: 'hover'
    }
  },
  data: function data() {
    return {
      showTooltip: false
    };
  },
  watch: {
    /**
     * Close the tooltip if showClose is changed from the parent.
     */
    showClose: function showClose() {
      if (!this.showClose) {
        this.$refs['tf-tooltip'].doClose();
      }
    }
  }
};

/* script */
const __vue_script__$S = script$S;

/* template */
var __vue_render__$P = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "transition",
    { attrs: { name: _vm.transition } },
    [
      _c(
        "popper",
        _vm._g(
          _vm._b(
            {
              ref: "tf-tooltip",
              class: { "with-close": _vm.showClose },
              on: {
                show: function($event) {
                  _vm.showTooltip = _vm.showClose;
                }
              }
            },
            "popper",
            Object.assign({}, _vm.$attrs, _vm.$props, {
              forceShow: _vm.forceShow || _vm.showTooltip
            }),
            false
          ),
          _vm.$listeners
        ),
        [
          _c(
            "div",
            { staticClass: "tf-popper tf-tooltip wt-popper wt-tooltip" },
            [
              _c("div", [_vm._t("default")], 2),
              _vm._v(" "),
              _vm.showClose
                ? _c("tf-button", {
                    staticClass: "btn-popper-close",
                    style: {
                      top: _vm.closePosition.top + "px",
                      right: _vm.closePosition.right + "px"
                    },
                    attrs: {
                      icon: "times",
                      size: "icon-no-fill",
                      type: "primary",
                      "no-padding": ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.$refs["tf-tooltip"].doClose()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "reference" }, [_vm._t("reference")], 2)
        ],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$P = [];
__vue_render__$P._withStripped = true;

  /* style */
  const __vue_inject_styles__$S = function (inject) {
    if (!inject) return
    inject("data-v-2e0d7967_0", { source: ".tf-popper.tf-tooltip,\n.wt-popper.wt-tooltip {\n  box-sizing: border-box;\n  padding: 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n.btn-popper-close {\n  position: absolute;\n}\n\n/*# sourceMappingURL=TfTooltip.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/TfTooltip.vue","TfTooltip.vue"],"names":[],"mappings":"AAoGA;;EAEA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;ACnGA;ADsGA;EACA,kBAAA;ACnGA;;AAEA,wCAAwC","file":"TfTooltip.vue","sourcesContent":["<template>\n  <transition :name=\"transition\">\n    <!--\n      v-on=\"$listeners\" is getting depricated in vue 3 so this will need to updated as well.\n      https://v3.vuejs.org/guide/migration/listeners-removed.html#listeners-removed\n    -->\n    <popper\n      ref=\"tf-tooltip\"\n      :class=\"{ 'with-close': showClose }\"\n      v-bind=\"{\n        ...$attrs,\n        ...$props,\n        forceShow: forceShow || showTooltip\n      }\"\n      v-on=\"$listeners\"\n      @show=\"showTooltip = showClose\"\n    >\n      <div class=\"tf-popper tf-tooltip wt-popper wt-tooltip\">\n        <div>\n          <slot />\n        </div>\n\n        <tf-button\n          v-if=\"showClose\"\n          :style=\"{\n            top: `${closePosition.top}px`,\n            right: `${closePosition.right}px`\n          }\"\n          class=\"btn-popper-close\"\n          icon=\"times\"\n          size=\"icon-no-fill\"\n          type=\"primary\"\n          no-padding\n          @click=\"$refs['tf-tooltip'].doClose()\"\n        />\n      </div>\n\n      <template slot=\"reference\">\n        <slot name=\"reference\" />\n      </template>\n    undefined>\n  </transition>\n</template>\n\n<script>\n  export default {\n    name: 'TfTooltip',\n    inheritAttrs: false,\n    props: {\n      appendToBody: {\n        type: Boolean,\n        default: false,\n      },\n      closePosition: {\n        type: Object,\n        default: () => ({\n          top: 4,\n          right: 4,\n        }),\n      },\n      forceShow: {\n        type: Boolean,\n        default: false,\n      },\n      options: {\n        type: Object,\n        default: () => ({}),\n      },\n      showClose: {\n        type: Boolean,\n        default: false,\n      },\n      transition: {\n        type: String,\n        default: 'tf-fade-in-linear',\n      },\n      trigger: {\n        type: String,\n        default: 'hover',\n      },\n    },\n\n    data: () => ({\n      showTooltip: false,\n    }),\n\n    watch: {\n      /**\n       * Close the tooltip if showClose is changed from the parent.\n       */\n      showClose() {\n        if (!this.showClose) {\n          this.$refs['tf-tooltip'].doClose();\n        }\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\">\n  .tf-popper.tf-tooltip,\n  .wt-popper.wt-tooltip {\n    box-sizing: border-box;\n    padding: 10px;\n    font-size: 12px;\n    border-radius: 3px;\n  }\n\n  .btn-popper-close {\n    position: absolute;\n  }\n</style>\n",".tf-popper.tf-tooltip,\n.wt-popper.wt-tooltip {\n  box-sizing: border-box;\n  padding: 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n\n.btn-popper-close {\n  position: absolute;\n}\n\n/*# sourceMappingURL=TfTooltip.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$S = undefined;
  /* module identifier */
  const __vue_module_identifier__$S = undefined;
  /* functional template */
  const __vue_is_functional_template__$S = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$S = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$P, staticRenderFns: __vue_staticRenderFns__$P },
    __vue_inject_styles__$S,
    __vue_script__$S,
    __vue_scope_id__$S,
    __vue_is_functional_template__$S,
    __vue_module_identifier__$S,
    false,
    browser,
    undefined,
    undefined
  );

var $sort = [].sort;
var test = [1, 2, 3];

_export(_export.P + _export.F * (_fails(function () {
  // IE8-
  test.sort(undefined);
}) || !_fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !_strictMethod($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(_toObject(this))
      : $sort.call(_toObject(this), _aFunction(comparefn));
  }
});

// https://github.com/tc39/proposal-object-values-entries

var $entries = _objectToArray(true);

_export(_export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$T = {
  name: 'TfTableChildRow',
  props: {
    childRowData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    childColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};

/* script */
const __vue_script__$T = script$T;

/* template */
var __vue_render__$Q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tr",
    _vm._l(_vm.childColumns, function(column) {
      return _c("td", {
        key: column.label,
        domProps: {
          innerHTML: _vm._s(
            column.formatMethod
              ? column.formatMethod(_vm.childRowData[column.prop])
              : _vm.childRowData[column.prop]
          )
        }
      })
    }),
    0
  )
};
var __vue_staticRenderFns__$Q = [];
__vue_render__$Q._withStripped = true;

  /* style */
  const __vue_inject_styles__$T = undefined;
  /* scoped */
  const __vue_scope_id__$T = undefined;
  /* module identifier */
  const __vue_module_identifier__$T = undefined;
  /* functional template */
  const __vue_is_functional_template__$T = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$T = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$Q, staticRenderFns: __vue_staticRenderFns__$Q },
    __vue_inject_styles__$T,
    __vue_script__$T,
    __vue_scope_id__$T,
    __vue_is_functional_template__$T,
    __vue_module_identifier__$T,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$U = {
  name: 'TfTableChildTable',
  props: {
    childData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    childColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    colspan: {
      type: Number,
      default: 1
    }
  }
};

/* script */
const __vue_script__$U = script$U;

/* template */
var __vue_render__$R = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("tr", { staticClass: "row row-parent is-expanded" }, [
    _c(
      "td",
      { staticClass: "cell-child-table", attrs: { colspan: _vm.colspan } },
      [
        _vm._t("childTable", null, {
          data: _vm.childData,
          columns: _vm.childColumns
        })
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__$R = [];
__vue_render__$R._withStripped = true;

  /* style */
  const __vue_inject_styles__$U = undefined;
  /* scoped */
  const __vue_scope_id__$U = undefined;
  /* module identifier */
  const __vue_module_identifier__$U = undefined;
  /* functional template */
  const __vue_is_functional_template__$U = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$U = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$R, staticRenderFns: __vue_staticRenderFns__$R },
    __vue_inject_styles__$U,
    __vue_script__$U,
    __vue_scope_id__$U,
    __vue_is_functional_template__$U,
    __vue_module_identifier__$U,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableFilters is a component that is used as a child of the TfTable component and controls the filters using the TfFilter component.
 *
 * @vuedoc
 * @exports TfTable/Filters
 * @category Components
 */
var script$V = {
  name: 'TfTableFilters',
  inject: ['TfTable'],
  computed: {
    /**
     * Evaluate the TfTable table data and sorting to return boolean for the template.
     *
     * @returns {boolean}
     */
    disableFilters: function disableFilters() {
      return !this.TfTable.tableData.length || this.TfTable.isSorting;
    },

    /**
     * Evaulate the TfTable localFilterValues values to see if there are any values.
     *
     * @returns {boolean}
     */
    hasFilterValues: function hasFilterValues() {
      return Object.values(this.TfTable.localFilterValues).some(function (value) {
        return value.length;
      });
    }
  }
};

/* script */
const __vue_script__$V = script$V;

/* template */
var __vue_render__$S = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: {
        "label-visible":
          _vm.TfTable.$slots.filterLabel || _vm.TfTable.showFilterLabel
      }
    },
    [
      _vm.TfTable.$slots.filterLabel || _vm.TfTable.showFilterLabel
        ? _c(
            "h3",
            [
              _vm._t("filterLabel", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$slots.filterLabel || "Filters:") +
                    "\n    "
                )
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm._l(_vm.TfTable.filters, function(filter) {
            return _c(
              "div",
              {
                key: filter.prop,
                staticClass: "filter-column",
                style: { width: "" + filter.width }
              },
              [
                _c(
                  "tf-filter",
                  _vm._b(
                    {
                      on: {
                        changeDateFilterType: function($event) {
                          return _vm.TfTable.onChangeDateFilterType(
                            filter.prop,
                            $event
                          )
                        },
                        input: function($event) {
                          return _vm.TfTable.onChangeFilterValue({
                            prop: filter.prop,
                            value: $event
                          })
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "noValue",
                            fn: function() {
                              return [
                                _vm._t("emptyCell", [
                                  _vm._v("\n            —\n          ")
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "tf-filter",
                    {
                      disabled: _vm.disableFilters,
                      filter: filter,
                      value: _vm.TfTable.localFilterValues[filter.prop]
                    },
                    false
                  )
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("tf-button", {
            attrs: {
              disabled: _vm.disableFilters || !_vm.hasFilterValues,
              size: "text",
              type: "primary"
            },
            domProps: { textContent: _vm._s("Reset All") },
            on: { click: _vm.TfTable.onResetFilters }
          })
        ],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__$S = [];
__vue_render__$S._withStripped = true;

  /* style */
  const __vue_inject_styles__$V = function (inject) {
    if (!inject) return
    inject("data-v-2828da2c_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nh3[data-v-2828da2c] {\n  padding-top: 20px;\n}\n.filter-container[data-v-2828da2c] {\n  display: flex;\n  align-items: baseline;\n  margin: 20px 0 35px;\n}\n.label-visible .filter-container[data-v-2828da2c] {\n  margin-top: 0;\n}\n.filter-column[data-v-2828da2c] {\n  margin-right: 13px;\n}\n\n/*# sourceMappingURL=Filters.vue.map */", map: {"version":3,"sources":["Filters.vue","/home/circleci/repo/src/components/TfTable/Filters.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACyEpC;EACA,iBAAA;ADvEA;AC2EA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;ADxEA;AC0EA;EACA,aAAA;ADxEA;AC4EA;EACA,kBAAA;AD1EA;;AAEA,sCAAsC","file":"Filters.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\nh3 {\n  padding-top: 20px;\n}\n\n.filter-container {\n  display: flex;\n  align-items: baseline;\n  margin: 20px 0 35px;\n}\n.label-visible .filter-container {\n  margin-top: 0;\n}\n.filter-column {\n  margin-right: 13px;\n}\n\n/*# sourceMappingURL=Filters.vue.map */","<template>\n  <div :class=\"{ 'label-visible': TfTable.$slots.filterLabel || TfTable.showFilterLabel }\">\n    <h3 v-if=\"TfTable.$slots.filterLabel || TfTable.showFilterLabel\">\n      <slot name=\"filterLabel\">\n        {{ $slots.filterLabel || 'Filters:' }}\n      </slot>\n    </h3>\n    <div class=\"filter-container\">\n      <div\n        v-for=\"filter in TfTable.filters\"\n        :key=\"filter.prop\"\n        :style=\"{ width: `${filter.width}` }\"\n        class=\"filter-column\"\n      >\n        <tf-filter\n          v-bind=\"{\n            disabled: disableFilters,\n            filter,\n            value: TfTable.localFilterValues[filter.prop]\n          }\"\n          @changeDateFilterType=\"TfTable.onChangeDateFilterType(filter.prop, $event)\"\n          @input=\"TfTable.onChangeFilterValue({\n            prop: filter.prop,\n            value: $event\n          })\"\n        >\n          <template #noValue>\n            <slot name=\"emptyCell\">\n              &mdash;\n            </slot>\n          </template>\n        </tf-filter>\n      </div>\n      <tf-button\n        :disabled=\"disableFilters || !hasFilterValues\"\n        size=\"text\"\n        type=\"primary\"\n        @click=\"TfTable.onResetFilters\"\n        v-text=\"'Reset All'\"\n      />\n    </div>\n  </div>\n</template>\n<script>\n  /**\n   * TfTableFilters is a component that is used as a child of the TfTable component and controls the filters using the TfFilter component.\n   *\n   * @vuedoc\n   * @exports TfTable/Filters\n   * @category Components\n   */\n  export default {\n    name: 'TfTableFilters',\n    inject: ['TfTable'],\n    computed: {\n      /**\n       * Evaluate the TfTable table data and sorting to return boolean for the template.\n       *\n       * @returns {boolean}\n       */\n      disableFilters() {\n        return !this.TfTable.tableData.length || this.TfTable.isSorting;\n      },\n      /**\n       * Evaulate the TfTable localFilterValues values to see if there are any values.\n       *\n       * @returns {boolean}\n       */\n      hasFilterValues() {\n        return Object.values(this.TfTable.localFilterValues).some((value) => value.length);\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  h3 {\n    padding-top: 20px;\n  }\n\n  .filter {\n    &-container {\n      display: flex;\n      align-items: baseline;\n      margin: 20px 0 35px;\n\n      .label-visible & {\n        margin-top: 0;\n      }\n    }\n\n    &-column {\n      margin-right: 13px;\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$V = "data-v-2828da2c";
  /* module identifier */
  const __vue_module_identifier__$V = undefined;
  /* functional template */
  const __vue_is_functional_template__$V = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$V = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$S, staticRenderFns: __vue_staticRenderFns__$S },
    __vue_inject_styles__$V,
    __vue_script__$V,
    __vue_scope_id__$V,
    __vue_is_functional_template__$V,
    __vue_module_identifier__$V,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableHead is a component that is used within the TfTable component and controls the th columns and its sorting logic.
 *
 * @vuedoc
 * @exports TfTable/Head
 * @category Components
 */
var script$W = {
  name: 'TfTableHead',
  inject: ['TfTable']
};

/* script */
const __vue_script__$W = script$W;

/* template */
var __vue_render__$T = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.TfTable.tableData.length
    ? _c("thead", [
        _c(
          "tr",
          [
            _vm._l(_vm.TfTable.tableMeta.columns, function(column) {
              return _c(
                "th",
                { key: column.label, attrs: { width: column.width || "auto" } },
                [
                  column.sortable
                    ? _c(
                        "tf-button",
                        {
                          class: {
                            "is-active": _vm.TfTable.sortColumn === column.prop
                          },
                          attrs: {
                            direction: _vm.TfTable.sortDirection,
                            selected: _vm.TfTable.sortColumn === column.prop,
                            type: "table-sort"
                          },
                          on: {
                            click: function($event) {
                              return _vm.TfTable.changeSortCriteria(column)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(column.label) + "\n      "
                          )
                        ]
                      )
                    : _c("span", {
                        domProps: { textContent: _vm._s(column.label) }
                      })
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.TfTable.hasChildren
              ? _c("th", {
                  staticClass: "child-toggle",
                  attrs: { width: "51" }
                })
              : _vm._e()
          ],
          2
        )
      ])
    : _vm._e()
};
var __vue_staticRenderFns__$T = [];
__vue_render__$T._withStripped = true;

  /* style */
  const __vue_inject_styles__$W = function (inject) {
    if (!inject) return
    inject("data-v-f0bd5cbe_0", { source: "th.child-toggle[data-v-f0bd5cbe] {\n  padding: 0;\n}\nth .tf-button[data-v-f0bd5cbe],\nth .wt-button[data-v-f0bd5cbe] {\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=Head.vue.map */", map: {"version":3,"sources":["/home/circleci/repo/src/components/TfTable/Head.vue","Head.vue"],"names":[],"mappings":"AAgDA;EACA,UAAA;AC/CA;ADkDA;;EAEA,gBAAA;AChDA;;AAEA,mCAAmC","file":"Head.vue","sourcesContent":["<template>\n  <thead v-if=\"TfTable.tableData.length\">\n    <tr>\n      <th\n        v-for=\"column in TfTable.tableMeta.columns\"\n        :key=\"column.label\"\n        :width=\"column.width || 'auto'\"\n      >\n        <tf-button\n          v-if=\"column.sortable\"\n          :class=\"{ 'is-active': TfTable.sortColumn === column.prop }\"\n          :direction=\"TfTable.sortDirection\"\n          :selected=\"TfTable.sortColumn === column.prop\"\n          type=\"table-sort\"\n          @click=\"TfTable.changeSortCriteria(column)\"\n        >\n          {{ column.label }}\n        </tf-button>\n        <span\n          v-else\n          v-text=\"column.label\"\n        />\n      </th>\n      <th\n        v-if=\"TfTable.hasChildren\"\n        class=\"child-toggle\"\n        width=\"51\"\n      />\n    </tr>\n  </thead>\n</template>\n\n<script>\n  /**\n   * TfTableHead is a component that is used within the TfTable component and controls the th columns and its sorting logic.\n   *\n   * @vuedoc\n   * @exports TfTable/Head\n   * @category Components\n   */\n  export default {\n    name: 'TfTableHead',\n    inject: ['TfTable'],\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  th {\n    &.child-toggle {\n      padding: 0;\n    }\n\n    .tf-button,\n    .wt-button {\n      font-weight: 700;\n    }\n  }\n</style>\n","th.child-toggle {\n  padding: 0;\n}\nth .tf-button,\nth .wt-button {\n  font-weight: 700;\n}\n\n/*# sourceMappingURL=Head.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$W = "data-v-f0bd5cbe";
  /* module identifier */
  const __vue_module_identifier__$W = undefined;
  /* functional template */
  const __vue_is_functional_template__$W = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$W = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$T, staticRenderFns: __vue_staticRenderFns__$T },
    __vue_inject_styles__$W,
    __vue_script__$W,
    __vue_scope_id__$W,
    __vue_is_functional_template__$W,
    __vue_module_identifier__$W,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTablePagination is a component that is used within the TfTable component and controls the template and logic for the table pagingation.
 *
 * @vuedoc
 * @exports TfTable/Pagination
 * @category Components
 */
var script$X = {
  name: 'TfTablePagination',
  inject: ['TfTable'],
  computed: {
    /**
     * Evaluate the page limit and localPageSelected to show the first result count in the template.
     *
     * @returns {number}
     */
    countStart: function countStart() {
      return this.TfTable.localPageSelected * this.TfTable.pageLimit - this.TfTable.pageLimit + 1;
    },

    /**
     * Evaluate the page limit and countStart to show the final result count in the template.
     *
     * @returns {number}
     */
    countEnd: function countEnd() {
      var countEnd = this.countStart + this.TfTable.pageLimit;
      return countEnd > this.totalLength ? this.totalLength : countEnd - 1;
    },

    /**
     * Cache the filteredTableDataIndexes from the parent to be used through the template and logic.
     *
     * @returns {number}
     */
    totalLength: function totalLength() {
      return this.TfTable.filteredTableDataIndexes.length;
    }
  }
};

/* script */
const __vue_script__$X = script$X;

/* template */
var __vue_render__$U = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "container-pagination" },
    [
      _vm.TfTable.showPageResults
        ? _c("p", [
            _vm._v(
              "\n    Showing " +
                _vm._s(_vm.countStart) +
                "-" +
                _vm._s(_vm.countEnd) +
                " of " +
                _vm._s(_vm.totalLength) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.TfTable.tableRowIndexes.length
        ? _c(
            "tf-pagination",
            _vm._b(
              { on: { input: _vm.TfTable.onPageSelected } },
              "tf-pagination",
              {
                isDisabled: !_vm.TfTable.isLoaded || _vm.TfTable.isSorting,
                totalPages: _vm.TfTable.totalPages,
                value: _vm.TfTable.localPageSelected
              },
              false
            )
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$U = [];
__vue_render__$U._withStripped = true;

  /* style */
  const __vue_inject_styles__$X = function (inject) {
    if (!inject) return
    inject("data-v-821b9e18_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.container-pagination[data-v-821b9e18] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.table + .container-pagination[data-v-821b9e18], .tf-table-footer + .container-pagination[data-v-821b9e18], .wt-table-footer + .container-pagination[data-v-821b9e18] {\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n.pagination-container[data-v-821b9e18] {\n  margin-left: auto;\n}\np[data-v-821b9e18] {\n  margin-bottom: 0;\n  color: #999;\n}\n\n/*# sourceMappingURL=Pagination.vue.map */", map: {"version":3,"sources":["Pagination.vue","/home/circleci/repo/src/components/TfTable/Pagination.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC4DpC;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AD1DA;AC4DA;EAIA,gBAAA;EACA,gBAAA;AD7DA;ACkEA;EACA,iBAAA;AD/DA;ACkEA;EACA,gBAAA;EACA,WAAA;AD/DA;;AAEA,yCAAyC","file":"Pagination.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.container-pagination {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.table + .container-pagination, .tf-table-footer + .container-pagination, .wt-table-footer + .container-pagination {\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n\n.pagination-container {\n  margin-left: auto;\n}\n\np {\n  margin-bottom: 0;\n  color: #999;\n}\n\n/*# sourceMappingURL=Pagination.vue.map */","<template>\n  <div class=\"container-pagination\">\n    <p v-if=\"TfTable.showPageResults\">\n      Showing {{ countStart }}-{{ countEnd }} of {{ totalLength }}\n    </p>\n    <tf-pagination\n      v-if=\"TfTable.tableRowIndexes.length\"\n      v-bind=\"{\n        isDisabled: !TfTable.isLoaded || TfTable.isSorting,\n        totalPages: TfTable.totalPages,\n        value: TfTable.localPageSelected,\n      }\"\n      @input=\"TfTable.onPageSelected\"\n    />\n  </div>\n</template>\n<script>\n  /**\n   * TfTablePagination is a component that is used within the TfTable component and controls the template and logic for the table pagingation.\n   *\n   * @vuedoc\n   * @exports TfTable/Pagination\n   * @category Components\n   */\n  export default {\n    name: 'TfTablePagination',\n    inject: ['TfTable'],\n    computed: {\n      /**\n       * Evaluate the page limit and localPageSelected to show the first result count in the template.\n       *\n       * @returns {number}\n       */\n      countStart() {\n        return (\n          (this.TfTable.localPageSelected * this.TfTable.pageLimit) - this.TfTable.pageLimit\n        ) + 1;\n      },\n      /**\n       * Evaluate the page limit and countStart to show the final result count in the template.\n       *\n       * @returns {number}\n       */\n      countEnd() {\n        const countEnd = this.countStart + this.TfTable.pageLimit;\n\n        return countEnd > this.totalLength\n          ? this.totalLength\n          : countEnd - 1;\n      },\n      /**\n       * Cache the filteredTableDataIndexes from the parent to be used through the template and logic.\n       *\n       * @returns {number}\n       */\n      totalLength() {\n        return this.TfTable.filteredTableDataIndexes.length;\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  .container-pagination {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n\n    .table + &,\n    .tf-table-footer + &,\n    .wt-table-footer + & {\n      margin: {\n        top: 15px;\n        bottom: 0;\n      }\n    }\n  }\n\n  .pagination-container {\n    margin-left: auto;\n  }\n\n  p {\n    margin-bottom: 0;\n    color: $tf-medium-gray;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$X = "data-v-821b9e18";
  /* module identifier */
  const __vue_module_identifier__$X = undefined;
  /* functional template */
  const __vue_is_functional_template__$X = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$X = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$U, staticRenderFns: __vue_staticRenderFns__$U },
    __vue_inject_styles__$X,
    __vue_script__$X,
    __vue_scope_id__$X,
    __vue_is_functional_template__$X,
    __vue_module_identifier__$X,
    false,
    browser,
    undefined,
    undefined
  );

var script$Y = {
  name: 'TfTable',
  components: {
    TfChildRow: __vue_component__$T,
    TfChildTable: __vue_component__$U,
    TfTableFilters: __vue_component__$V,
    TfTableHead: __vue_component__$W,
    TfTablePagination: __vue_component__$X
  },
  provide: function provide() {
    return {
      TfTable: this
    };
  },
  props: {
    /**
     * filterValues should be a URL encoded string if ever used.
     * required if `parentalControls` is true.
     */
    filterValues: {
      type: String,
      default: ''
    },

    /**
     * findIndexBy is a unique id for various logic to point to the original data.
     * Most data has an 'id' key so that's the default.
     */
    findIndexBy: {
      type: String,
      default: 'id'
    },

    /**
     * pageLimit sets the number of rows to show per page.
     */
    pageLimit: {
      type: Number,
      default: 50
    },

    /**
     * pageSelected dictates what page to show for paginated data.
     * required if `parentalControls` is true.
     */
    pageSelected: {
      type: Number,
      default: 1
    },

    /**
     * Setting `pagination` to `true` will evaluate various data/props and render a tfPagination component at the bottom and top of the table.
     */
    pagination: {
      type: Boolean,
      default: false
    },

    /**
     * `parentalControls` is really just the way to control the table via a route string.
     * Setting this to `true` will control filters updates, the selected page, and the sorting order.
     */
    parentalControls: {
      type: Boolean,
      default: false
    },

    /**
     * `showPageResults` will determine if the page results should be shown in the table pagination component.
     */
    showPageResults: {
      type: Boolean,
      default: false
    },

    /**
     * `showFilterLabel` will determine if the table filter component should render the default label.
     */
    showFilterLabel: {
      type: Boolean,
      default: false
    },

    /**
     * `tableData` is an array of objects to be evaluated and rendered in the table.
     */
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * `tableMeta` contains each column's metaData (like the `prop`, `label`, `sortable`, etc) and the table sort order and prop.
     */
    tableMeta: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data(vm) {
    return {
      expandedChildren: [],
      isSorting: false,
      isLoaded: false,
      filters: [],
      filteredTableDataIndexes: [],
      localPageSelected: vm.pageSelected,
      localFilterValues: {},
      sortColumn: null,
      sortDirection: null,
      sortProp: null,
      tableRows: [],
      tableRowIndexes: [],
      totalPages: 0
    };
  },
  computed: {
    /**
     * Evaulates the table data to see if any of the rows have children with length.
     *
     * @returns {boolean}
     */
    hasChildren: function hasChildren() {
      return this.tableData.some(function (rowData) {
        return rowData.children;
      });
    }
  },
  watch: {
    /**
     * Watch the filterValues prop to apply new values from the parent.
     */
    filterValues: function filterValues() {
      var filterValues = {};

      if (this.filterValues) {
        filterValues = JSON.parse(decodeURI(this.filterValues));
        Object.entries(filterValues).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          filterValues[key] = value;
        });
      }

      this.$set(this, 'localFilterValues', filterValues);
      this.sortData({
        updateData: true
      });
    },

    /**
     * Watcher for pageSelected from parent when using routes.
     *
     * @param {string} newPage
     */
    pageSelected: function pageSelected(newPage) {
      this.localPageSelected = newPage;
      this.setTableRows();
    },

    /**
     * Watch the tableData prop to sort any new data from the parent.
     */
    tableData: function tableData() {
      this.sortData({
        updateData: true
      });
    },

    /**
     * Update sortColumn, sortDirection, sortProp when using parental controls.
     * Then emit pageSelected and sort based on conditions.
     * Notes: When using $router.push({ params: pageSelected })
     * The sort can potentially be flagged as new as well
     * so we need to test the old/new props to prevent the sort from firing.
     *
     * @param {object} newValue
     * @param {string} newValue.direction
     * @param {string} newValue.prop
     * @param {object} oldValue
     * @param {string} oldValue.direction
     * @param {string} oldValue.prop
     *
     * @returns {void}
     */
    'tableMeta.sort': function tableMetaSort(_ref3, _ref4) {
      var direction = _ref3.direction,
          prop = _ref3.prop;
      var oldDirection = _ref4.direction,
          oldProp = _ref4.prop;

      if (oldDirection === direction && oldProp === prop) {
        return;
      }

      var reverseDirection = oldProp === prop;
      this.sortColumn = prop;
      this.sortDirection = direction;
      this.sortProp = prop; // If we need to reset the page here, we emit up pageSelected with 1.
      // The watcher for pageSelected will then sort the data.
      // If we don't need to reset the pageSelected, we sort the data.

      if (this.localPageSelected !== 1) {
        this.$emit('pageSelected', 1);
        this.sortData({
          updateData: !reverseDirection,
          reverseDirection: reverseDirection
        });
        return;
      }

      this.sortData({
        updateData: !reverseDirection,
        reverseDirection: reverseDirection
      });
    }
  },

  /**
   * On created, we want to set up the local sort and filter data appropriately.
   * Once all of that is taken care of, we wait for forceNextTick to sort all the data and loaded states.
   * the $nextTick() isn't working correctly and there's more info on https://github.com/vuejs/vue/issues/9200.
   */
  created: function created() {
    var _this = this;

    if (this.tableMeta.sort) {
      var _this$tableMeta$colum = this.tableMeta.columns.find(function (columnObj) {
        return (// If targeted sorting, we need to return the column where 'sortable' matches the sort prop.
          // Otherwise find column where the prop is is the sort prop.
          columnObj.sortable === _this.tableMeta.sort.prop || columnObj.prop === _this.tableMeta.sort.prop
        );
      }),
          prop = _this$tableMeta$colum.prop,
          sortable = _this$tableMeta$colum.sortable;

      var sortColumn = prop;
      var sortProp = prop;

      if (sortable && typeof sortable === 'string') {
        sortProp = sortable;
      }

      this.sortColumn = sortColumn;
      this.sortDirection = this.tableMeta.sort.direction;
      this.sortProp = sortProp;
    } // Check to see if any filters exist and create this.localFilterValues and this.filters


    var filters = this.tableMeta.columns.filter(function (_ref5) {
      var filter = _ref5.filter;
      return filter;
    });

    if (filters.length || this.filterValues) {
      // Create the localFilterValues
      var filterValues = Object.assign.apply(Object, [{}].concat(_toConsumableArray(filters.map(function (_ref6) {
        var prop = _ref6.prop;
        return _defineProperty({}, prop, []);
      }))));
      var existingFilters = {}; // Override any empty values with filterValues prop.

      if (this.parentalControls && this.filterValues) {
        existingFilters = JSON.parse(decodeURI(this.filterValues));
        Object.entries(existingFilters).forEach(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
              key = _ref9[0],
              value = _ref9[1];

          filterValues[key] = value;
        });
      }

      this.$set(this, 'localFilterValues', filterValues); // Create the filters array

      filters = filters.map(function (_ref10, filterIndex) {
        var filter = _ref10.filter,
            label = _ref10.label,
            prop = _ref10.prop;
        // If no order is provided, the index will be applied
        // to the filter hierarchy
        var order = Number.isNaN(filter.order) ? filterIndex : filter.order;
        var type = filter.type;
        var options = filter.options;
        var dateType; // If no options are provided and the prop isn't string/range,
        // create an array of unique IDs and map with label/value

        if (!options && ['string', 'range'].includes(type)) {
          var uniqOptions = _toConsumableArray(new Set(_this.tableData.map(function (dataObj) {
            return dataObj[prop];
          }))).map(function (id) {
            var value = id || '';
            return {
              label: value,
              value: value
            };
          });

          options = _this.$TF.Formatting.sortObjects(uniqOptions, 'value');
        }

        if (['month', 'date-range'].includes(type)) {
          dateType = type;
        }

        if (type === 'month-and-date-range') {
          dateType = existingFilters[prop] && Array.isArray(existingFilters[prop][0]) ? 'date-range' : 'month';
        }

        return {
          dateType: dateType,
          label: label,
          options: options,
          order: order,
          popoverWidth: filter.popoverWidth,
          prop: prop,
          type: type,
          width: filter.width
        };
      });
      var sortedFilters = this.$TF.Formatting.sortObjects(filters, 'filterOrder');
      this.$set(this, 'filters', sortedFilters);
    }

    this.$forceNextTick(function () {
      _this.isLoaded = true;

      _this.sortData({
        updateData: true
      });
    });
  },
  methods: {
    /**
     * Change the sort criteria based on what was clicked.
     * This is a method that is triggered directly in the TfTableHead child component.
     *
     * @param {object} column
     */
    changeSortCriteria: function changeSortCriteria(column) {
      var sortColumn = column.prop;
      var reverseDirection = sortColumn === this.sortProp;
      var sortDirection = 'asc';
      var sortProp = sortColumn;

      if (column.sortable && typeof column.sortable === 'string') {
        sortProp = column.sortable;
      }

      if (sortProp === this.sortProp && this.sortDirection === 'asc') {
        sortDirection = 'desc';
      }

      this.$emit('changeSortCriteria', {
        sortDirection: sortDirection,
        sortProp: sortProp
      }); // Escape if controlled by parent b/c watcher will handle updating the local props and sort.

      if (this.parentalControls) {
        return;
      }

      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
      this.sortProp = sortProp;

      if (this.localPageSelected !== 1) {
        this.localPageSelected = 1;
      }

      this.sortData({
        updateData: !reverseDirection,
        reverseDirection: reverseDirection
      });
    },

    /**
     * Find the dateType key in the appropriate filter and change the passed param.
     * This is a method that is triggered directly in the TfTableFilters child component.
     *
     * @param {string} filterProp
     * @param {string} dateFilterType
     */
    onChangeDateFilterType: function onChangeDateFilterType(filterProp, dateFilterType) {
      var index = this.filters.findIndex(function (_ref11) {
        var prop = _ref11.prop;
        return prop === filterProp;
      });
      this.filters[index].dateType = dateFilterType;
    },

    /**
     * Change the values of the appropriate filter based on the passed params
     * and emits an encoded URI to the parent.
     * This is a method that is triggered directly in the TfTableFilters child component.
     *
     * @param {object} $event
     * @param {string} $event.prop
     * @param {string} $event.value
     */
    onChangeFilterValue: function onChangeFilterValue(_ref12) {
      var prop = _ref12.prop,
          _ref12$value = _ref12.value,
          value = _ref12$value === void 0 ? [] : _ref12$value;

      if (this.localPageSelected !== 1) {
        this.onPageSelected();
      }

      var filterValues = decodeURI(this.filterValues || '');
      var filters = filterValues ? JSON.parse(filterValues) : JSON.parse("{".concat(filterValues, "}"));
      filters[prop] = value;
      this.$emit('changeFilter', JSON.stringify(filters));
      /*
        Escape if controlled by parent.
        Watcher will handle updating the localFilter and sort.
      */

      if (this.parentalControls) {
        return;
      }

      this.$set(this.localFilterValues, [prop], value);
      this.sortData({
        updateData: true
      });
    },

    /**
     * Change the selected page and shows/hide the loader appropriately.
     * This is a method that is triggered directly in the TfTablePagination child component as well as throughout the component.
     *
     * @param {number} newPage
     */
    onPageSelected: function onPageSelected() {
      var newPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.$emit('pageSelected', newPage);
      /*
        Escape if controlled by parent.
        Watcher will handle updating the local page select and sort.
      */

      if (this.parentalControls) {
        return;
      }

      this.localPageSelected = newPage;
      this.setTableRows();
    },

    /**
     * Clears out each of the localFilterValues keys and emits to the parent.
     * This is a method that is triggered directly in the TfTableFilters child component.
     */
    onResetFilters: function onResetFilters() {
      var _this2 = this;

      Object.entries(this.localFilterValues).forEach(function (_ref13) {
        var _ref14 = _slicedToArray(_ref13, 1),
            key = _ref14[0];

        _this2.$set(_this2.localFilterValues, [key], []);
      });

      if (this.localPageSelected !== 1) {
        this.onPageSelected();
      }

      this.$emit('changeFilter');
      this.sortData({
        updateData: true
      });
    },

    /**
     * Pushes or removes the parent row ID from expandedChildren.
     * This is a method that is triggered directly in the TfTableParentRow child component.
     *
     * @param {number} parentRowId
     */
    toggleChildRow: function toggleChildRow(parentRowId) {
      if (this.expandedChildren.includes(parentRowId)) {
        this.$delete(this.expandedChildren, this.expandedChildren.findIndex(function (id) {
          return id === parentRowId;
        }));
        return;
      }

      this.expandedChildren.push(parentRowId);
    },

    /**
     * Set the tableRows according to the pagination.
     */
    setTableRows: function setTableRows() {
      var _this3 = this;

      this.isSorting = true;
      this.$forceNextTick(function () {
        var tableRowIndexes = !_this3.pagination ? _this3.filteredTableDataIndexes : _this3.filteredTableDataIndexes.slice((_this3.localPageSelected - 1) * _this3.pageLimit, _this3.localPageSelected * _this3.pageLimit);
        var totalPages = _this3.pagination ? Math.ceil(_this3.filteredTableDataIndexes.length / _this3.pageLimit) : null;

        _this3.$set(_this3, 'tableRowIndexes', tableRowIndexes);

        _this3.totalPages = totalPages;
        _this3.isSorting = false;
      });
    },

    /**
     * Sort the table data by appropriate filters and sorts.
     * If updateData is passed (usually on fresh load or if changing filters), we want to filter through the localFilterValues
     *
     * @param {boolean} updateData
     */
    sortData: function sortData(_ref15) {
      var _this4 = this;

      var _ref15$reverseDirecti = _ref15.reverseDirection,
          reverseDirection = _ref15$reverseDirecti === void 0 ? false : _ref15$reverseDirecti,
          _ref15$updateData = _ref15.updateData,
          updateData = _ref15$updateData === void 0 ? false : _ref15$updateData;
      this.isSorting = true;
      this.$forceNextTick(function () {
        var useFilteredIndex = reverseDirection && !updateData;
        var filteredTableData = useFilteredIndex ? _this4.filteredTableDataIndexes : _this4.tableData;

        if (updateData && Object.values(_this4.localFilterValues).length) {
          // 1. iterate through each filter
          _this4.filters.forEach(function (_ref16) {
            var dateType = _ref16.dateType,
                prop = _ref16.prop,
                type = _ref16.type;
            var values = _this4.localFilterValues[prop];

            if (values && values.length) {
              // 2. filter filteredTableData by prop
              filteredTableData = filteredTableData.filter(function (_ref17) {
                var dataValue = _ref17[prop];

                // 3. test the value to see if it is included
                var formatDate = function formatDate(value) {
                  var outputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY/MM/DD';
                  return _this4.$TF.DatesUtils.formatSimpleDate(value, outputFormat);
                };

                var isIncluded;

                if (dataValue === null) {
                  isIncluded = false;
                } else if (type === 'string') {
                  isIncluded = values.includes(dataValue);
                } else if (type === 'range') {
                  values.forEach(function (value) {
                    var _value$split$map = value.split(',').map(function (n) {
                      return Number(n);
                    }),
                        _value$split$map2 = _slicedToArray(_value$split$map, 2),
                        min = _value$split$map2[0],
                        max = _value$split$map2[1];

                    var isWithinRange = max && dataValue >= min && dataValue <= max;
                    var isOverMin = !max && dataValue >= min;

                    if (isWithinRange || isOverMin) {
                      isIncluded = true;
                    }
                  });
                } else if (dateType === 'month') {
                  var value = formatDate(values[0], 'MMMM YYYY');
                  var filterDate = formatDate(dataValue, 'MMMM YYYY');
                  isIncluded = moment(value).isSame(filterDate, 'month');
                } else if (dateType === 'date-range') {
                  var _value = formatDate(dataValue);

                  var _values$ = _slicedToArray(values[0], 2),
                      startDate = _values$[0],
                      endDate = _values$[1];

                  startDate = formatDate(startDate);
                  endDate = formatDate(endDate); // https://momentjscom.readthedocs.io/en/latest/moment/05-query/06-is-between/
                  // moment().isBetween(moment-like, moment-like, String, String);
                  // where moment-like is Moment|String|Number|Date|Array

                  isIncluded = moment(_value).isBetween(startDate, endDate, undefined, '[]');
                }

                return isIncluded;
              });
            }
          });
        } // 4. Sort the filtered table data by the correct prop/direction and map its
        // associated table data index.


        var filteredTableDataIndexes = useFilteredIndex ? filteredTableData.reverse() : _this4.$TF.Formatting.sortObjects(filteredTableData, _this4.sortProp, _this4.sortDirection).map(function (row) {
          return _this4.tableData.findIndex(function (obj) {
            return obj[_this4.findIndexBy] === row[_this4.findIndexBy];
          });
        });

        _this4.$set(_this4, 'filteredTableDataIndexes', filteredTableDataIndexes);

        _this4.setTableRows();
      });
    }
  }
};

/* script */
const __vue_script__$Y = script$Y;

/* template */
var __vue_render__$V = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm.filters.length
        ? _c("tf-table-filters", {
            scopedSlots: _vm._u(
              [
                {
                  key: "emptyCell",
                  fn: function() {
                    return [
                      _vm._t("emptyCell", [_vm._v("\n        —\n      ")])
                    ]
                  },
                  proxy: true
                },
                _vm.$slots.filterLabel || _vm.showFilterLabel
                  ? {
                      key: "filterLabel",
                      fn: function() {
                        return [
                          _vm._t("filterLabel", [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$slots.filterLabel || "Filters:") +
                                "\n      "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tableData.length && (_vm.showPageResults || _vm.pagination)
        ? _c("tf-table-pagination")
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.title || _vm.$slots.ctaHeader || _vm.$slots.header
        ? _c(
            "div",
            {
              staticClass: "tf-table-header",
              class: { "cta-only": !_vm.$slots.title && !_vm.$slots.header },
              attrs: { "data-test-table-header": "" }
            },
            [
              _vm._t("header", [
                _vm.$slots.title ? _c("h2", [_vm._t("title")], 2) : _vm._e(),
                _vm._v(" "),
                _vm.$slots.ctaHeader
                  ? _c(
                      "div",
                      { staticClass: "btn-group" },
                      [_vm._t("ctaHeader")],
                      2
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "table table-parent" },
        [
          _c("tf-table-head"),
          _vm._v(" "),
          _c(
            "tbody",
            [
              !_vm.$slots.error && _vm.isLoaded && _vm.tableRowIndexes.length
                ? [
                    _vm._l(_vm.tableRowIndexes, function(tableDataIdx) {
                      return [
                        _vm.tableData[tableDataIdx]
                          ? [
                              _vm._t(
                                "parentRow",
                                [
                                  _c(
                                    "tf-table-parent-row",
                                    _vm._b(
                                      { key: tableDataIdx },
                                      "tf-table-parent-row",
                                      {
                                        rowData: _vm.tableData[tableDataIdx]
                                      },
                                      false
                                    ),
                                    _vm._l(_vm.tableMeta.columns, function(
                                      column
                                    ) {
                                      return _c(
                                        "tf-table-td",
                                        _vm._b(
                                          {
                                            key: column.prop,
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "emptyCell",
                                                  fn: function() {
                                                    return [
                                                      _vm._t("emptyCell", [
                                                        _vm._v(
                                                          "\n                      —\n                    "
                                                        )
                                                      ])
                                                    ]
                                                  },
                                                  proxy: true
                                                },
                                                {
                                                  key: "parentCellData",
                                                  fn: function(ref) {
                                                    var rowData = ref.rowData;
                                                    return [
                                                      _vm._t(
                                                        "parentCellData",
                                                        null,
                                                        null,
                                                        {
                                                          column: column,
                                                          rowData: rowData
                                                        }
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          "tf-table-td",
                                          {
                                            column: column,
                                            rowData: _vm.tableData[tableDataIdx]
                                          },
                                          false
                                        )
                                      )
                                    }),
                                    1
                                  )
                                ],
                                null,
                                {
                                  columns: _vm.tableMeta.columns,
                                  isExpanded: _vm.expandedChildren.includes(
                                    _vm.tableData[tableDataIdx][_vm.findIndexBy]
                                  ),
                                  rowData: _vm.tableData[tableDataIdx]
                                }
                              ),
                              _vm._v(" "),
                              _vm.expandedChildren.includes(
                                _vm.tableData[tableDataIdx][_vm.findIndexBy]
                              ) &&
                              _vm.tableData[tableDataIdx].children &&
                              _vm.tableData[tableDataIdx].children.length
                                ? _vm._l(
                                    _vm.tableData[tableDataIdx].children,
                                    function(child) {
                                      return _c("tf-child-table", {
                                        key:
                                          child.columnKey + "-" + tableDataIdx,
                                        attrs: {
                                          colspan:
                                            _vm.tableMeta.columns.length + 1,
                                          "child-data": child,
                                          "child-columns":
                                            _vm.tableMeta.childColumns[
                                              child.columnKey
                                            ]
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "childTable",
                                              fn: function(ref) {
                                                var columns = ref.columns;
                                                var data = ref.data;
                                                return [
                                                  _vm._t(
                                                    "childTable",
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "table table-child"
                                                        },
                                                        [
                                                          _c("thead", [
                                                            _c(
                                                              "tr",
                                                              _vm._l(
                                                                columns,
                                                                function(
                                                                  column
                                                                ) {
                                                                  return _c(
                                                                    "th",
                                                                    {
                                                                      key:
                                                                        column.label,
                                                                      attrs: {
                                                                        width:
                                                                          column.width
                                                                      },
                                                                      domProps: {
                                                                        textContent: _vm._s(
                                                                          column.label
                                                                        )
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tbody",
                                                            _vm._l(
                                                              child.data,
                                                              function(
                                                                childRowData,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "tf-child-row",
                                                                  {
                                                                    key:
                                                                      child.columnKey +
                                                                      "-" +
                                                                      index,
                                                                    attrs: {
                                                                      "child-row-data": childRowData,
                                                                      "child-columns":
                                                                        _vm
                                                                          .tableMeta
                                                                          .childColumns[
                                                                          child
                                                                            .columnKey
                                                                        ]
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    {
                                                      data: data,
                                                      columns: columns
                                                    }
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    }
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ]
                    })
                  ]
                : _c("tr", { staticClass: "is-empty" }, [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan: _vm.hasChildren
                            ? _vm.tableMeta.columns.length + 1
                            : _vm.tableMeta.columns.length
                        }
                      },
                      [
                        !_vm.isLoaded || _vm.isSorting
                          ? _c("div", {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: true,
                                  expression: "true"
                                }
                              ]
                            })
                          : [
                              _vm.$slots.error
                                ? _c(
                                    "el-alert",
                                    {
                                      attrs: {
                                        closable: false,
                                        "show-icon": "",
                                        type: "error"
                                      }
                                    },
                                    [_vm._t("error")],
                                    2
                                  )
                                : !_vm.tableData.length
                                ? _vm._t("empty", [
                                    _vm._v(
                                      "\n              There doesn't appear to be any data for this table.\n            "
                                    )
                                  ])
                                : _vm._t("noFilteredResults", [
                                    _vm._v(
                                      "\n              There doesn't appear to be any data that matches the selected filters.\n            "
                                    )
                                  ])
                            ]
                      ],
                      2
                    )
                  ])
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c("div", { staticClass: "tf-table-footer" }, [_vm._t("footer")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.tableData.length && (_vm.showPageResults || _vm.pagination)
        ? _c("tf-table-pagination")
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$V = [];
__vue_render__$V._withStripped = true;

  /* style */
  const __vue_inject_styles__$Y = function (inject) {
    if (!inject) return
    inject("data-v-7702d7d0_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tf-table-footer[data-v-7702d7d0] {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 13px 20px;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n}\n.tf-table-header[data-v-7702d7d0] {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 67px;\n  padding: 18px 20px;\n  border: 1px solid #c1c1c1;\n  border-bottom: 0;\n  border-radius: 6px 6px 0 0;\n}\n.tf-table-header.cta-only[data-v-7702d7d0] {\n  justify-content: flex-end;\n}\ndiv[data-v-7702d7d0] {\n  position: relative;\n}\nh2[data-v-7702d7d0] {\n  margin-bottom: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */", map: {"version":3,"sources":["index.vue","/home/circleci/repo/src/components/TfTable/index.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;ACiuBpC;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AD/tBA;ACkuBA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,0BAAA;ADjuBA;ACouBA;EACA,yBAAA;ADluBA;ACuuBA;EACA,kBAAA;ADpuBA;ACuuBA;EACA,gBAAA;ADpuBA;;AAEA,oCAAoC","file":"index.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\n.tf-table-footer {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 13px 20px;\n  border: 1px solid #c1c1c1;\n  border-top: 0;\n}\n.tf-table-header {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 67px;\n  padding: 18px 20px;\n  border: 1px solid #c1c1c1;\n  border-bottom: 0;\n  border-radius: 6px 6px 0 0;\n}\n.tf-table-header.cta-only {\n  justify-content: flex-end;\n}\n\ndiv {\n  position: relative;\n}\n\nh2 {\n  margin-bottom: 0;\n}\n\n/*# sourceMappingURL=index.vue.map */","<template>\n  <div>\n    <tf-table-filters v-if=\"filters.length\">\n      <template #emptyCell>\n        <slot name=\"emptyCell\">\n          &mdash;\n        </slot>\n      </template>\n      <template\n        v-if=\"$slots.filterLabel || showFilterLabel\"\n        #filterLabel\n      >\n        <slot name=\"filterLabel\">\n          {{ $slots.filterLabel || 'Filters:' }}\n        </slot>\n      </template>\n    </tf-table-filters>\n    <tf-table-pagination v-if=\"tableData.length && (showPageResults || pagination)\" />\n    <div\n      v-if=\"$slots.title || $slots.ctaHeader || $slots.header\"\n      :class=\"{ 'cta-only' : (!$slots.title && !$slots.header) }\"\n      data-test-table-header\n      class=\"tf-table-header\"\n    >\n      <slot name=\"header\">\n        <h2 v-if=\"$slots.title\">\n          <slot name=\"title\" />\n        </h2>\n        <div\n          v-if=\"$slots.ctaHeader\"\n          class=\"btn-group\"\n        >\n          <slot name=\"ctaHeader\" />\n        </div>\n      </slot>\n    </div>\n    <table class=\"table table-parent\">\n      <tf-table-head />\n      <tbody>\n        <template v-if=\"!$slots.error && isLoaded && tableRowIndexes.length\">\n          <template v-for=\"tableDataIdx in tableRowIndexes\">\n            <!--\n              Wrap b/c tableData[tableDataIdx] won't exist if data has been deleted from the parent.\n            -->\n            <template v-if=\"tableData[tableDataIdx]\">\n              <slot\n                name=\"parentRow\"\n                v-bind=\"{\n                  columns: tableMeta.columns,\n                  isExpanded: expandedChildren.includes(tableData[tableDataIdx][findIndexBy]),\n                  rowData: tableData[tableDataIdx],\n                }\"\n              >\n                <tf-table-parent-row\n                  :key=\"tableDataIdx\"\n                  v-bind=\"{\n                    rowData: tableData[tableDataIdx],\n                  }\"\n                >\n                  <tf-table-td\n                    v-for=\"column in tableMeta.columns\"\n                    :key=\"column.prop\"\n                    v-bind=\"{\n                      column,\n                      rowData: tableData[tableDataIdx],\n                    }\"\n                  >\n                    <template #emptyCell>\n                      <slot name=\"emptyCell\">\n                        &mdash;\n                      </slot>\n                    </template>\n                    <template #parentCellData=\"{ rowData }\">\n                      <slot\n                        name=\"parentCellData\"\n                        v-bind=\"{ column, rowData }\"\n                      />\n                    </template>\n                  </tf-table-td>\n                </tf-table-parent-row>\n              </slot>\n              <template\n                v-if=\"expandedChildren.includes(tableData[tableDataIdx][findIndexBy]) &&\n                  tableData[tableDataIdx].children &&\n                  tableData[tableDataIdx].children.length\"\n              >\n                <tf-child-table\n                  v-for=\"child in tableData[tableDataIdx].children\"\n                  :key=\"`${child.columnKey}-${tableDataIdx}`\"\n                  :colspan=\"tableMeta.columns.length + 1\"\n                  :child-data=\"child\"\n                  :child-columns=\"tableMeta.childColumns[child.columnKey]\"\n                >\n                  <template\n                    slot=\"childTable\"\n                    slot-scope=\"{ columns, data }\"\n                  >\n                    <slot\n                      name=\"childTable\"\n                      :data=\"data\"\n                      :columns=\"columns\"\n                    >\n                      <table class=\"table table-child\">\n                        <thead>\n                          <tr>\n                            <th\n                              v-for=\"column in columns\"\n                              :key=\"column.label\"\n                              :width=\"column.width\"\n                              v-text=\"column.label\"\n                            />\n                          </tr>\n                        </thead>\n                        <tbody>\n                          <tf-child-row\n                            v-for=\"(childRowData, index) in child.data\"\n                            :key=\"`${child.columnKey}-${index}`\"\n                            :child-row-data=\"childRowData\"\n                            :child-columns=\"tableMeta.childColumns[child.columnKey]\"\n                          />\n                        </tbody>\n                      </table>\n                    </slot>\n                  </template>\n                </tf-child-table>\n              </template>\n            </template>\n          </template>\n        </template>\n        <tr\n          v-else\n          class=\"is-empty\"\n        >\n          <td :colspan=\"hasChildren ? tableMeta.columns.length + 1 : tableMeta.columns.length\">\n            <div\n              v-if=\"!isLoaded || isSorting\"\n              v-loading=\"true\"\n            />\n            <template v-else>\n              <el-alert\n                v-if=\"$slots.error\"\n                :closable=\"false\"\n                show-icon\n                type=\"error\"\n              >\n                <slot name=\"error\" />\n              </el-alert>\n              <slot\n                v-else-if=\"!tableData.length\"\n                name=\"empty\"\n              >\n                There doesn't appear to be any data for this table.\n              </slot>\n              <slot\n                v-else\n                name=\"noFilteredResults\"\n              >\n                There doesn't appear to be any data that matches the selected filters.\n              </slot>\n            </template>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <div\n      v-if=\"$slots.footer\"\n      class=\"tf-table-footer\"\n    >\n      <slot name=\"footer\" />\n    </div>\n    <tf-table-pagination v-if=\"tableData.length && (showPageResults || pagination)\" />\n  </div>\n</template>\n\n<script>\n  // components\n  import moment from 'moment';\n  import TfChildRow from './ChildRow';\n  import TfChildTable from './ChildTable';\n  import TfTableFilters from './Filters';\n  import TfTableHead from './Head';\n  import TfTablePagination from './Pagination';\n\n  export default {\n    name: 'TfTable',\n    components: {\n      TfChildRow,\n      TfChildTable,\n      TfTableFilters,\n      TfTableHead,\n      TfTablePagination,\n    },\n    provide() {\n      return {\n        TfTable: this,\n      };\n    },\n    props: {\n      /**\n       * filterValues should be a URL encoded string if ever used.\n       * required if `parentalControls` is true.\n       */\n      filterValues: {\n        type: String,\n        default: '',\n      },\n      /**\n       * findIndexBy is a unique id for various logic to point to the original data.\n       * Most data has an 'id' key so that's the default.\n       */\n      findIndexBy: {\n        type: String,\n        default: 'id',\n      },\n      /**\n       * pageLimit sets the number of rows to show per page.\n       */\n      pageLimit: {\n        type: Number,\n        default: 50,\n      },\n      /**\n       * pageSelected dictates what page to show for paginated data.\n       * required if `parentalControls` is true.\n       */\n      pageSelected: {\n        type: Number,\n        default: 1,\n      },\n      /**\n       * Setting `pagination` to `true` will evaluate various data/props and render a tfPagination component at the bottom and top of the table.\n       */\n      pagination: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `parentalControls` is really just the way to control the table via a route string.\n       * Setting this to `true` will control filters updates, the selected page, and the sorting order.\n       */\n      parentalControls: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `showPageResults` will determine if the page results should be shown in the table pagination component.\n       */\n      showPageResults: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `showFilterLabel` will determine if the table filter component should render the default label.\n       */\n      showFilterLabel: {\n        type: Boolean,\n        default: false,\n      },\n      /**\n       * `tableData` is an array of objects to be evaluated and rendered in the table.\n       */\n      tableData: {\n        type: Array,\n        default: () => [],\n      },\n      /**\n       * `tableMeta` contains each column's metaData (like the `prop`, `label`, `sortable`, etc) and the table sort order and prop.\n       */\n      tableMeta: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    data: (vm) => ({\n      expandedChildren: [],\n      isSorting: false,\n      isLoaded: false,\n      filters: [],\n      filteredTableDataIndexes: [],\n      localPageSelected: vm.pageSelected,\n      localFilterValues: {},\n      sortColumn: null,\n      sortDirection: null,\n      sortProp: null,\n      tableRows: [],\n      tableRowIndexes: [],\n      totalPages: 0,\n    }),\n    computed: {\n      /**\n       * Evaulates the table data to see if any of the rows have children with length.\n       *\n       * @returns {boolean}\n       */\n      hasChildren() {\n        return this.tableData.some((rowData) => rowData.children);\n      },\n    },\n    watch: {\n      /**\n       * Watch the filterValues prop to apply new values from the parent.\n       */\n      filterValues() {\n        let filterValues = {};\n\n        if (this.filterValues) {\n          filterValues = JSON.parse(decodeURI(this.filterValues));\n\n          Object.entries(filterValues).forEach(([key, value]) => {\n            filterValues[key] = value;\n          });\n        }\n\n        this.$set(this, 'localFilterValues', filterValues);\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Watcher for pageSelected from parent when using routes.\n       *\n       * @param {string} newPage\n       */\n      pageSelected(newPage) {\n        this.localPageSelected = newPage;\n        this.setTableRows();\n      },\n      /**\n       * Watch the tableData prop to sort any new data from the parent.\n       */\n      tableData() {\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Update sortColumn, sortDirection, sortProp when using parental controls.\n       * Then emit pageSelected and sort based on conditions.\n       * Notes: When using $router.push({ params: pageSelected })\n       * The sort can potentially be flagged as new as well\n       * so we need to test the old/new props to prevent the sort from firing.\n       *\n       * @param {object} newValue\n       * @param {string} newValue.direction\n       * @param {string} newValue.prop\n       * @param {object} oldValue\n       * @param {string} oldValue.direction\n       * @param {string} oldValue.prop\n       *\n       * @returns {void}\n       */\n      'tableMeta.sort': function (\n        { direction, prop },\n        { direction: oldDirection, prop: oldProp },\n      ) {\n        if (\n          oldDirection === direction\n          && oldProp === prop\n        ) {\n          return;\n        }\n\n        const reverseDirection = oldProp === prop;\n\n        this.sortColumn = prop;\n        this.sortDirection = direction;\n        this.sortProp = prop;\n\n        // If we need to reset the page here, we emit up pageSelected with 1.\n        // The watcher for pageSelected will then sort the data.\n        // If we don't need to reset the pageSelected, we sort the data.\n        if (this.localPageSelected !== 1) {\n          this.$emit('pageSelected', 1);\n          this.sortData({ updateData: !reverseDirection, reverseDirection });\n\n          return;\n        }\n\n        this.sortData({ updateData: !reverseDirection, reverseDirection });\n      },\n    },\n    /**\n     * On created, we want to set up the local sort and filter data appropriately.\n     * Once all of that is taken care of, we wait for forceNextTick to sort all the data and loaded states.\n     * the $nextTick() isn't working correctly and there's more info on https://github.com/vuejs/vue/issues/9200.\n     */\n    created() {\n      if (this.tableMeta.sort) {\n        const { prop, sortable } = this.tableMeta.columns.find((columnObj) => (\n          // If targeted sorting, we need to return the column where 'sortable' matches the sort prop.\n          // Otherwise find column where the prop is is the sort prop.\n          columnObj.sortable === this.tableMeta.sort.prop\n          || columnObj.prop === this.tableMeta.sort.prop\n        ));\n        const sortColumn = prop;\n        let sortProp = prop;\n\n        if (sortable && typeof sortable === 'string') {\n          sortProp = sortable;\n        }\n\n        this.sortColumn = sortColumn;\n        this.sortDirection = this.tableMeta.sort.direction;\n        this.sortProp = sortProp;\n      }\n\n      // Check to see if any filters exist and create this.localFilterValues and this.filters\n      let filters = this.tableMeta.columns.filter(({ filter }) => filter);\n\n      if (filters.length || this.filterValues) {\n        // Create the localFilterValues\n        const filterValues = Object.assign(\n          {},\n          ...filters.map(({ prop }) => ({ [prop]: [] })),\n        );\n        let existingFilters = {};\n\n        // Override any empty values with filterValues prop.\n        if (this.parentalControls && this.filterValues) {\n          existingFilters = JSON.parse(decodeURI(this.filterValues));\n\n          Object.entries(existingFilters).forEach(([key, value]) => {\n            filterValues[key] = value;\n          });\n        }\n        this.$set(this, 'localFilterValues', filterValues);\n\n        // Create the filters array\n        filters = filters.map(({ filter, label, prop }, filterIndex) => {\n          // If no order is provided, the index will be applied\n          // to the filter hierarchy\n          const order = Number.isNaN(filter.order)\n            ? filterIndex\n            : filter.order;\n          const { type } = filter;\n          let { options } = filter;\n          let dateType;\n\n          // If no options are provided and the prop isn't string/range,\n          // create an array of unique IDs and map with label/value\n          if (!options && ['string', 'range'].includes(type)) {\n            const uniqOptions = [\n              ...new Set(this.tableData.map((dataObj) => dataObj[prop])),\n            ].map((id) => {\n              const value = id || '';\n\n              return {\n                label: value,\n                value,\n              };\n            });\n\n            options = this.$TF.Formatting.sortObjects(uniqOptions, 'value');\n          }\n\n          if (['month', 'date-range'].includes(type)) {\n            dateType = type;\n          }\n\n          if (type === 'month-and-date-range') {\n            dateType = existingFilters[prop] && Array.isArray(existingFilters[prop][0])\n              ? 'date-range'\n              : 'month';\n          }\n\n          return {\n            dateType,\n            label,\n            options,\n            order,\n            popoverWidth: filter.popoverWidth,\n            prop,\n            type,\n            width: filter.width,\n          };\n        });\n\n        const sortedFilters = this.$TF.Formatting.sortObjects(filters, 'filterOrder');\n\n        this.$set(this, 'filters', sortedFilters);\n      }\n\n      this.$forceNextTick(() => {\n        this.isLoaded = true;\n        this.sortData({ updateData: true });\n      });\n    },\n    methods: {\n      /**\n       * Change the sort criteria based on what was clicked.\n       * This is a method that is triggered directly in the TfTableHead child component.\n       *\n       * @param {object} column\n       */\n      changeSortCriteria(column) {\n        const sortColumn = column.prop;\n        const reverseDirection = sortColumn === this.sortProp;\n        let sortDirection = 'asc';\n        let sortProp = sortColumn;\n\n        if (column.sortable && typeof column.sortable === 'string') {\n          sortProp = column.sortable;\n        }\n\n        if (sortProp === this.sortProp && this.sortDirection === 'asc') {\n          sortDirection = 'desc';\n        }\n\n        this.$emit('changeSortCriteria', {\n          sortDirection,\n          sortProp,\n        });\n\n        // Escape if controlled by parent b/c watcher will handle updating the local props and sort.\n        if (this.parentalControls) {\n          return;\n        }\n\n        this.sortColumn = sortColumn;\n        this.sortDirection = sortDirection;\n        this.sortProp = sortProp;\n\n        if (this.localPageSelected !== 1) {\n          this.localPageSelected = 1;\n        }\n\n        this.sortData({ updateData: !reverseDirection, reverseDirection });\n      },\n      /**\n       * Find the dateType key in the appropriate filter and change the passed param.\n       * This is a method that is triggered directly in the TfTableFilters child component.\n       *\n       * @param {string} filterProp\n       * @param {string} dateFilterType\n       */\n      onChangeDateFilterType(filterProp, dateFilterType) {\n        const index = this.filters.findIndex(({ prop }) => prop === filterProp);\n\n        this.filters[index].dateType = dateFilterType;\n      },\n      /**\n       * Change the values of the appropriate filter based on the passed params\n       * and emits an encoded URI to the parent.\n       * This is a method that is triggered directly in the TfTableFilters child component.\n       *\n       * @param {object} $event\n       * @param {string} $event.prop\n       * @param {string} $event.value\n       */\n      onChangeFilterValue({ prop, value = [] }) {\n        if (this.localPageSelected !== 1) {\n          this.onPageSelected();\n        }\n\n        const filterValues = decodeURI(this.filterValues || '');\n        const filters = filterValues\n          ? JSON.parse(filterValues)\n          : JSON.parse(`{${filterValues}}`);\n\n        filters[prop] = value;\n\n        this.$emit('changeFilter', JSON.stringify(filters));\n\n        /*\n          Escape if controlled by parent.\n          Watcher will handle updating the localFilter and sort.\n        */\n        if (this.parentalControls) {\n          return;\n        }\n\n        this.$set(this.localFilterValues, [prop], value);\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Change the selected page and shows/hide the loader appropriately.\n       * This is a method that is triggered directly in the TfTablePagination child component as well as throughout the component.\n       *\n       * @param {number} newPage\n       */\n      onPageSelected(newPage = 1) {\n        this.$emit('pageSelected', newPage);\n\n        /*\n          Escape if controlled by parent.\n          Watcher will handle updating the local page select and sort.\n        */\n        if (this.parentalControls) {\n          return;\n        }\n\n        this.localPageSelected = newPage;\n        this.setTableRows();\n      },\n      /**\n       * Clears out each of the localFilterValues keys and emits to the parent.\n       * This is a method that is triggered directly in the TfTableFilters child component.\n       */\n      onResetFilters() {\n        Object.entries(this.localFilterValues).forEach(([key]) => {\n          this.$set(this.localFilterValues, [key], []);\n        });\n\n        if (this.localPageSelected !== 1) {\n          this.onPageSelected();\n        }\n\n        this.$emit('changeFilter');\n        this.sortData({ updateData: true });\n      },\n      /**\n       * Pushes or removes the parent row ID from expandedChildren.\n       * This is a method that is triggered directly in the TfTableParentRow child component.\n       *\n       * @param {number} parentRowId\n       */\n      toggleChildRow(parentRowId) {\n        if (this.expandedChildren.includes(parentRowId)) {\n          this.$delete(\n            this.expandedChildren,\n            this.expandedChildren.findIndex((id) => id === parentRowId),\n          );\n          return;\n        }\n\n        this.expandedChildren.push(parentRowId);\n      },\n      /**\n       * Set the tableRows according to the pagination.\n       */\n      setTableRows() {\n        this.isSorting = true;\n\n        this.$forceNextTick(() => {\n          const tableRowIndexes = !this.pagination\n            ? this.filteredTableDataIndexes\n            : this.filteredTableDataIndexes.slice(\n              (this.localPageSelected - 1) * this.pageLimit,\n              this.localPageSelected * this.pageLimit,\n            );\n          const totalPages = this.pagination\n            ? Math.ceil(this.filteredTableDataIndexes.length / this.pageLimit)\n            : null;\n\n          this.$set(this, 'tableRowIndexes', tableRowIndexes);\n          this.totalPages = totalPages;\n          this.isSorting = false;\n        });\n      },\n      /**\n       * Sort the table data by appropriate filters and sorts.\n       * If updateData is passed (usually on fresh load or if changing filters), we want to filter through the localFilterValues\n       *\n       * @param {boolean} updateData\n       */\n      sortData({\n        reverseDirection = false,\n        updateData = false,\n      }) {\n        this.isSorting = true;\n\n        this.$forceNextTick(() => {\n          const useFilteredIndex = reverseDirection && !updateData;\n          let filteredTableData = useFilteredIndex\n            ? this.filteredTableDataIndexes\n            : this.tableData;\n\n          if (updateData && Object.values(this.localFilterValues).length) {\n            // 1. iterate through each filter\n            this.filters.forEach(({ dateType, prop, type }) => {\n              const values = this.localFilterValues[prop];\n\n              if (values && values.length) {\n                // 2. filter filteredTableData by prop\n                filteredTableData = filteredTableData.filter(({ [prop]: dataValue }) => {\n                  // 3. test the value to see if it is included\n                  const formatDate = (value, outputFormat = 'YYYY/MM/DD') => (\n                    this.$TF.DatesUtils.formatSimpleDate(value, outputFormat)\n                  );\n                  let isIncluded;\n\n                  if (dataValue === null) {\n                    isIncluded = false;\n                  } else if (type === 'string') {\n                    isIncluded = values.includes(dataValue);\n                  } else if (type === 'range') {\n                    values.forEach((value) => {\n                      const [min, max] = value.split(',').map((n) => Number(n));\n                      const isWithinRange = max && dataValue >= min && dataValue <= max;\n                      const isOverMin = !max && dataValue >= min;\n\n                      if (isWithinRange || isOverMin) {\n                        isIncluded = true;\n                      }\n                    });\n                  } else if (dateType === 'month') {\n                    const value = formatDate(values[0], 'MMMM YYYY');\n                    const filterDate = formatDate(dataValue, 'MMMM YYYY');\n\n                    isIncluded = moment(value).isSame(filterDate, 'month');\n                  } else if (dateType === 'date-range') {\n                    const value = formatDate(dataValue);\n                    let [startDate, endDate] = values[0];\n\n                    startDate = formatDate(startDate);\n                    endDate = formatDate(endDate);\n\n                    // https://momentjscom.readthedocs.io/en/latest/moment/05-query/06-is-between/\n                    // moment().isBetween(moment-like, moment-like, String, String);\n                    // where moment-like is Moment|String|Number|Date|Array\n                    isIncluded = moment(value).isBetween(startDate, endDate, undefined, '[]');\n                  }\n\n                  return isIncluded;\n                });\n              }\n            });\n          }\n\n          // 4. Sort the filtered table data by the correct prop/direction and map its\n          // associated table data index.\n          const filteredTableDataIndexes = useFilteredIndex\n            ? filteredTableData.reverse()\n            : this.$TF.Formatting\n              .sortObjects(\n                filteredTableData,\n                this.sortProp,\n                this.sortDirection,\n              )\n              .map((row) => (\n                this.tableData.findIndex((obj) => obj[this.findIndexBy] === row[this.findIndexBy])\n              ));\n\n          this.$set(this, 'filteredTableDataIndexes', filteredTableDataIndexes);\n\n          this.setTableRows();\n        });\n      },\n    },\n  };\n</script>\n\n<style scoped lang=\"scss\">\n  @import 'src/assets/styles/variables';\n\n  .tf-table {\n    &-footer {\n      box-sizing: border-box;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      padding: 13px 20px;\n      border: 1px solid $tf-light-gray;\n      border-top: 0;\n    }\n\n    &-header {\n      box-sizing: border-box;\n      display: flex;\n      justify-content: space-between;\n      width: 100%;\n      min-height: 67px;\n      padding: 18px 20px;\n      border: 1px solid $tf-light-gray;\n      border: {\n        bottom: 0;\n        radius: 6px 6px 0 0;\n      }\n\n      &.cta-only {\n        justify-content: flex-end;\n      }\n    }\n  }\n\n  div {\n    position: relative;\n  }\n\n  h2 {\n    margin-bottom: 0;\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$Y = "data-v-7702d7d0";
  /* module identifier */
  const __vue_module_identifier__$Y = undefined;
  /* functional template */
  const __vue_is_functional_template__$Y = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Y = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$V, staticRenderFns: __vue_staticRenderFns__$V },
    __vue_inject_styles__$Y,
    __vue_script__$Y,
    __vue_scope_id__$Y,
    __vue_is_functional_template__$Y,
    __vue_module_identifier__$Y,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableParentRow is a component that is used as a child of the TfTable component. It will render a TfTableTd for each column by default.
 * It also controls the expansion logic for the row. If using #parentRow slot, the parent needs to account for showing an additional td when there are no children for the row but some data in the table does.
 *
 * @vuedoc
 * @exports TfTable/ParentRow
 * @category Components
 */
var script$Z = {
  name: 'TfTableParentRow',
  inject: ['TfTable'],
  props: {
    rowData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    /**
     * Evaluates the tables expanded children for this row's id.
     *
     * @returns {boolean}
     */
    isExpanded: function isExpanded() {
      return this.TfTable.expandedChildren.includes(this.rowData.id);
    },

    /**
     * Evaluates if the row has children.
     *
     * @returns {boolean}
     */
    rowHasChildren: function rowHasChildren() {
      return this.rowData.children && this.rowData.children.length;
    }
  }
};

/* script */
const __vue_script__$Z = script$Z;

/* template */
var __vue_render__$W = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "tr",
    { class: { "is-loading": _vm.TfTable.isSorting } },
    [
      _vm._t(
        "default",
        _vm._l(_vm.TfTable.tableMeta.columns, function(column) {
          return _c(
            "tf-table-td",
            _vm._b(
              {
                key: column.prop,
                scopedSlots: _vm._u(
                  [
                    {
                      key: "emptyCell",
                      fn: function() {
                        return [
                          _vm._t("emptyCell", [
                            _vm._v("\n          —\n        ")
                          ])
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "parentCellData",
                      fn: function() {
                        return [
                          _vm._t("parentCellData", null, null, {
                            column: column,
                            rowData: _vm.rowData
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              },
              "tf-table-td",
              { column: column, rowData: _vm.rowData },
              false
            )
          )
        })
      ),
      _vm._v(" "),
      _vm.TfTable.hasChildren || _vm.rowHasChildren
        ? _c(
            "td",
            {
              staticClass: "cell-prop-toggle",
              class: { "show-toggle": _vm.rowHasChildren },
              attrs: { width: "50" }
            },
            [
              _vm.rowHasChildren
                ? _c("tf-button", {
                    class: [
                      "btn-toggle-row",
                      { "is-expanded": _vm.isExpanded }
                    ],
                    attrs: {
                      type: _vm.isExpanded ? "primary" : "secondary",
                      "no-border": true,
                      icon: "angle-up",
                      size: "icon-no-fill"
                    },
                    on: {
                      click: function($event) {
                        return _vm.TfTable.toggleChildRow(_vm.rowData.id)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__$W = [];
__vue_render__$W._withStripped = true;

  /* style */
  const __vue_inject_styles__$Z = function (inject) {
    if (!inject) return
    inject("data-v-3f46448c_0", { source: "/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\ntr.is-loading[data-v-3f46448c] {\n  opacity: 0.5;\n}\n.cell-prop-toggle[data-v-3f46448c] {\n  position: relative;\n}\n.cell-prop-toggle.show-toggle[data-v-3f46448c] {\n  border-left: 1px solid #efefef;\n}\n.table-parent .cell-prop-toggle[data-v-3f46448c] {\n  padding: 0;\n}\n[data-v-3f46448c].tf-button.btn-toggle-row,[data-v-3f46448c].wt-button.btn-toggle-row {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50px;\n  min-height: 50px;\n  color: #42474c;\n}\n[data-v-3f46448c].tf-button.btn-toggle-row:hover,[data-v-3f46448c].wt-button.btn-toggle-row:hover {\n  border: none;\n}\n[data-v-3f46448c].tf-button.btn-toggle-row svg,[data-v-3f46448c].wt-button.btn-toggle-row svg {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s;\n}\n[data-v-3f46448c].tf-button.btn-toggle-row:not(.is-expanded),[data-v-3f46448c].wt-button.btn-toggle-row:not(.is-expanded) {\n  color: #2638a6;\n}\n[data-v-3f46448c].tf-button.btn-toggle-row:not(.is-expanded) svg,[data-v-3f46448c].wt-button.btn-toggle-row:not(.is-expanded) svg {\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ParentRow.vue.map */", map: {"version":3,"sources":["ParentRow.vue","/home/circleci/repo/src/components/TfTable/ParentRow.vue"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;;oCAEoC;AC8EpC;EACA,YAAA;AD5EA;ACgFA;EACA,kBAAA;AD7EA;AC+EA;EACA,8BAAA;AD7EA;ACgFA;EACA,UAAA;AD9EA;ACkFA;EAEA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EAGA,gBAAA;EACA,cAAA;ADjFA;ACmFA;EACA,YAAA;ADhFA;ACmFA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;ADhFA;ACmFA;EACA,cAAA;ADhFA;ACkFA;EACA,0BAAA;AD/EA;;AAEA,wCAAwC","file":"ParentRow.vue","sourcesContent":["/*********************************\n*  NEW ThreeFlow Color Variables *\n**********************************/\n/***********************************\n*  OLD Watch Tower Color Variables *\n************************************/\ntr.is-loading {\n  opacity: 0.5;\n}\n\n.cell-prop-toggle {\n  position: relative;\n}\n.cell-prop-toggle.show-toggle {\n  border-left: 1px solid #efefef;\n}\n.table-parent .cell-prop-toggle {\n  padding: 0;\n}\n\n::v-deep.tf-button.btn-toggle-row,\n::v-deep.wt-button.btn-toggle-row {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50px;\n  min-height: 50px;\n  color: #42474c;\n}\n::v-deep.tf-button.btn-toggle-row:hover,\n::v-deep.wt-button.btn-toggle-row:hover {\n  border: none;\n}\n::v-deep.tf-button.btn-toggle-row svg,\n::v-deep.wt-button.btn-toggle-row svg {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s;\n}\n::v-deep.tf-button.btn-toggle-row:not(.is-expanded),\n::v-deep.wt-button.btn-toggle-row:not(.is-expanded) {\n  color: #2638a6;\n}\n::v-deep.tf-button.btn-toggle-row:not(.is-expanded) svg,\n::v-deep.wt-button.btn-toggle-row:not(.is-expanded) svg {\n  transform: rotateZ(180deg);\n}\n\n/*# sourceMappingURL=ParentRow.vue.map */","<template>\n  <tr :class=\"{ 'is-loading': TfTable.isSorting }\">\n    <slot>\n      <tf-table-td\n        v-for=\"column in TfTable.tableMeta.columns\"\n        :key=\"column.prop\"\n        v-bind=\"{ column, rowData }\"\n      >\n        <template #emptyCell>\n          <slot name=\"emptyCell\">\n            &mdash;\n          </slot>\n        </template>\n        <template #parentCellData>\n          <slot\n            name=\"parentCellData\"\n            v-bind=\"{ column, rowData }\"\n          />\n        </template>\n      </tf-table-td>\n    </slot>\n    <td\n      v-if=\"TfTable.hasChildren || rowHasChildren\"\n      width=\"50\"\n      class=\"cell-prop-toggle\"\n      :class=\"{ 'show-toggle': rowHasChildren }\"\n    >\n      <tf-button\n        v-if=\"rowHasChildren\"\n        :class=\"['btn-toggle-row', { 'is-expanded' : isExpanded }]\"\n        :type=\"isExpanded ? 'primary' : 'secondary'\"\n        :no-border=\"true\"\n        icon=\"angle-up\"\n        size=\"icon-no-fill\"\n        @click=\"TfTable.toggleChildRow(rowData.id);\"\n      />\n    </td>\n  </tr>\n</template>\n\n<script>\n  /**\n   * TfTableParentRow is a component that is used as a child of the TfTable component. It will render a TfTableTd for each column by default.\n   * It also controls the expansion logic for the row. If using #parentRow slot, the parent needs to account for showing an additional td when there are no children for the row but some data in the table does.\n   *\n   * @vuedoc\n   * @exports TfTable/ParentRow\n   * @category Components\n   */\n  export default {\n    name: 'TfTableParentRow',\n    inject: ['TfTable'],\n    props: {\n      rowData: {\n        type: Object,\n        default: () => ({}),\n      },\n    },\n    computed: {\n      /**\n       * Evaluates the tables expanded children for this row's id.\n       *\n       * @returns {boolean}\n       */\n      isExpanded() {\n        return this.TfTable.expandedChildren.includes(this.rowData.id);\n      },\n      /**\n       * Evaluates if the row has children.\n       *\n       * @returns {boolean}\n       */\n      rowHasChildren() {\n        return this.rowData.children && this.rowData.children.length;\n      },\n    },\n  };\n</script>\n\n<style lang=\"scss\" scoped>\n  @import 'src/assets/styles/variables';\n\n  tr {\n    &.is-loading {\n      opacity: .5;\n    }\n  }\n\n  .cell-prop-toggle {\n    position: relative;\n\n    &.show-toggle {\n      border-left: 1px solid $tf-extra-light-gray-1;\n    }\n\n    .table-parent & {\n      padding: 0;\n    }\n  }\n\n  ::v-deep.tf-button.btn-toggle-row,\n  ::v-deep.wt-button.btn-toggle-row {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 50px;\n    // min-height is here to fix an IE11 issue but since\n    // we only use the toggle on the admin site AND chrome, we don't need to fully fix this yet.\n    min-height: 50px;\n    color: $tf-dark-gray;\n\n    &:hover {\n      border: none;\n    }\n\n    svg {\n      width: 22px;\n      height: 22px;\n      transition: transform .3s;\n    }\n\n    &:not(.is-expanded) {\n      color: $tf-blue;\n\n      svg {\n        transform: rotateZ(180deg);\n      }\n    }\n  }\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$Z = "data-v-3f46448c";
  /* module identifier */
  const __vue_module_identifier__$Z = undefined;
  /* functional template */
  const __vue_is_functional_template__$Z = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$Z = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$W, staticRenderFns: __vue_staticRenderFns__$W },
    __vue_inject_styles__$Z,
    __vue_script__$Z,
    __vue_scope_id__$Z,
    __vue_is_functional_template__$Z,
    __vue_module_identifier__$Z,
    false,
    browser,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * TfTableTd is a component that is used within the TfTable component and controls the template for the individual table data cell.
 *
 * @vuedoc
 * @exports TfTable/Td
 * @category Components
 */
var script$_ = {
  name: 'TfTableTd',
  props: {
    column: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rowData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};

/* script */
const __vue_script__$_ = script$_;

/* template */
var __vue_render__$X = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "td",
    {
      class:
        "wt-table-td tf-table-td " +
        (_vm.column.prop ? "cell-prop-" + _vm.column.prop : "")
    },
    [
      _vm._t("default", [
        _vm.column.format
          ? _vm._t("parentCellData", null, null, {
              column: _vm.column,
              rowData: _vm.rowData
            })
          : _vm.rowData[_vm.column.prop]
          ? [
              _vm._v(
                "\n      " + _vm._s(_vm.rowData[_vm.column.prop]) + "\n    "
              )
            ]
          : _vm._t("emptyCell", [_vm._v("\n      —\n    ")])
      ])
    ],
    2
  )
};
var __vue_staticRenderFns__$X = [];
__vue_render__$X._withStripped = true;

  /* style */
  const __vue_inject_styles__$_ = undefined;
  /* scoped */
  const __vue_scope_id__$_ = undefined;
  /* module identifier */
  const __vue_module_identifier__$_ = undefined;
  /* functional template */
  const __vue_is_functional_template__$_ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$_ = /*#__PURE__*/normalizeComponent_1(
    { render: __vue_render__$X, staticRenderFns: __vue_staticRenderFns__$X },
    __vue_inject_styles__$_,
    __vue_script__$_,
    __vue_scope_id__$_,
    __vue_is_functional_template__$_,
    __vue_module_identifier__$_,
    false,
    undefined,
    undefined,
    undefined
  );

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Analytics = {
  /**
   * Initalize Segment/ Analytics.js, and store the 'messageId' that comes from each page call that we make
   *
   * @param {string} segmentToken
   */
  initalizeSegment: function initalizeSegment(segmentToken) {
    /* eslint-disable */
    // The following block was taken from segments website: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
    var analytics = window.analytics = window.analytics || [];
    if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
      analytics.invoked = !0;
      analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"];

      analytics.factory = function (e) {
        return function () {
          var t = Array.prototype.slice.call(arguments);
          t.unshift(e);
          analytics.push(t);
          return analytics;
        };
      };

      for (var e = 0; e < analytics.methods.length; e++) {
        var key = analytics.methods[e];
        analytics[key] = analytics.factory(key);
      }

      analytics.load = function (key, e) {
        var t = document.createElement("script");
        t.type = "text/javascript";
        t.async = !0;
        t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
        var n = document.getElementsByTagName("script")[0];
        n.parentNode.insertBefore(t, n);
        analytics._loadOptions = e;
      };

      analytics._writeKey = segmentToken;
      analytics.SNIPPET_VERSION = "4.15.3";
      analytics.load(segmentToken);
      analytics.page();
    }
    /* eslint-enable */
    // Analytics Middleware Documenation: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/middleware/

    analytics.addSourceMiddleware(function (_ref) {
      var payload = _ref.payload,
          next = _ref.next;

      if (payload.obj.type === 'page') {
        // everytime a "trackPage" call is made, we want to store the messageId that is returned (we'll use this to link "page"" events to "track" events)
        window.sessionStorage.setItem('segmentPageMessageId', payload.obj.messageId);
      }

      next(payload);
    });
  },

  /**
   * When windows.analytics is available, collect various user properties to be delivered for threeflow analytics (Intercom, log rocket, etc).
   *
   * @param {object} userInfo
   */
  identify: function identify() {
    var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (window.analytics) {
      var orgName;

      if (userInfo.broker) {
        orgName = userInfo.broker.name;
      } else if (userInfo.carrier) {
        orgName = userInfo.carrier.name;
      }

      var payload = _objectSpread$5(_objectSpread$5({}, userInfo), {}, {
        org_name: orgName,
        roles: userInfo.roles ? userInfo.roles.map(function (_ref2) {
          var name = _ref2.name;
          return name;
        }).join(', ') : '',
        Site: window.location.hostname.match(/^[a-z0-9]+/i)[0].toLowerCase()
      });

      window.analytics.identify(userInfo.id, payload);
    }
  },

  /**
   * Track page view
   *
   * @param {string} route
   * @param {object} payload
   */
  trackPage: function trackPage(route, payload) {
    if (window.analytics) {
      window.analytics.page(route, payload);
    }
  },

  /**
   * Track custom event
   *
   * @param {string} eventName
   * @param {object} payload
   */
  trackEvent: function trackEvent(eventName, payload) {
    if (window.analytics) {
      window.analytics.track(eventName, _objectSpread$5(_objectSpread$5({}, payload), {}, {
        pageMessageId: window.sessionStorage.getItem('segmentPageMessageId') // add the stored "segmentPageMessageId" to each payload for every tracked event

      }));
    }
  }
};

var Cookies = {
  /**
   * Look a cookie and return results
   *
   * @param {string} cname
   * @returns {string}
   */
  getCookie: function getCookie(cname) {
    var name = "".concat(cname, "=");
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i += 1) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  },

  /**
   * Delete a specfic cookie
   *
   * @param {string} name
   */
  deleteCookie: function deleteCookie(name) {
    var domain = '';

    if (process.env.NODE_ENV !== 'development') {
      domain = "domain=".concat(window.location.href.replace(/^(?:https?:\/\/)?(?:[^/]+\.)?([^./]+\.[^./]+).*$/, '$1'), ";");
    }

    document.cookie = "".concat(name, "=; ").concat(domain, " path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    /*
      TODO: REMOVE THIS NEXT SNIPPET
      We want this in place to remove any "old" cookies,
      but we really only need it until they expire (every 24 hours)
      so by the time *you* read this, you can remove it
    */

    if (process.env.NODE_ENV !== 'development') {
      document.cookie = "".concat(name, "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    }
  },

  /**
   * Set a cookie
   *
   * @param {string} name
   * @param {string} value
   * @param {Date} expirationDate
   */
  setCookie: function setCookie(name, value) {
    var expirationDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var domain = process.env.NODE_ENV !== 'testing' ? window.location.href.replace(/^(?:https?:\/\/)?(?:[^/]+\.)?([^./]+\.[^./]+).*$/, '$1') : 'localhost';
    var cookie = "".concat(name, "=").concat(value, "; expires=").concat(expirationDate.toUTCString(), "; path=/; secure;");

    if (process.env.NODE_ENV !== 'development') {
      cookie += " domain=".concat(domain);
    }

    document.cookie = cookie;
  }
};

var AxiosConfig = {
  /**
   * Get the configuration to pass to an axios call (really just adding the auth token)
   *
   * @param {string} cookieNameSpace
   * @returns {object}
   */
  getConfig: function getConfig(cookieNameSpace) {
    var authToken;

    if (cookieNameSpace) {
      authToken = Cookies.getCookie("".concat(cookieNameSpace, "-auth-token"));
    } else {
      authToken = Cookies.getCookie('auth-token');
    }

    return {
      headers: {
        'X-API-AUTHTOKEN': "".concat(authToken)
      }
    };
  }
};

var BrowserUtils = {
  /**
   * Is the user using internet exploer
   *
   * @returns {boolean}
   */
  isIE: function isIE() {
    return !Vue.prototype.$isServer && !Number.isNaN(Number(document.documentMode));
  },

  /**
   * Is the user using edge
   *
   * @returns {boolean}
   */
  isEdge: function isEdge() {
    return !Vue.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
  }
};

moment.locale('us');
var DatesUtils = {
  /**
   * Check if this a valid date in the format of MM/DD/YYYY
   *
   * @param {string} dateString
   * @returns {boolean}
   */
  isDateValid: function isDateValid(dateString) {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    } // Parse the date parts to integers


    var parts = dateString.split('/');
    var day = Number(parts[1]);
    var month = Number(parts[0]);
    var year = Number(parts[2]); // Check the ranges of month and year

    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
      return false;
    }

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

    if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
      monthLength[1] = 29;
    } // Check the range of the day


    return day > 0 && day <= monthLength[month - 1];
  },

  /**
   * Convert a UTC javascript date to the local timezone
   * All dates from the server are in UTC format,
   * however they are not all being sent that way so we need to check.
   *
   * @param {string} dateString
   * @returns {Date}
   */
  convertUTCDateToLocalDate: function convertUTCDateToLocalDate(dateString) {
    var isUTCFormat = dateString.charAt(dateString.length - 1) === 'Z';
    var UTCDateString = isUTCFormat ? dateString : "".concat(dateString, "Z");
    var newDate = new Date(UTCDateString);
    return newDate;
  },

  /**
   * Format the ISO date to be human readable time
   *
   * @param {string} dateString
   * @returns {string}
   */
  formatDateAndTime: function formatDateAndTime(dateString) {
    if (!dateString) {
      return '';
    }

    var date = this.convertUTCDateToLocalDate(dateString);
    return moment(date).format('MM/DD/YY h:mma');
  },

  /**
   * Format the ISO date to be human readable dates. If the date string that is passed is NOT in the "YYYY-MM-DD" format, we convert it the local date. RFP Table is one instance has logic for this.
   *
   * @param {string} dateString
   * @param {string} outputFormat
   * @returns {string}
   */
  formatSimpleDate: function formatSimpleDate() {
    var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var outputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMMM Do, YYYY';

    if (!dateString) {
      return '';
    }

    var isDateTime = !moment(dateString, 'YYYY-MM-DD', true).isValid();
    var date = isDateTime ? this.convertUTCDateToLocalDate(dateString) : dateString;
    return moment(date).format(outputFormat);
  }
};

// 20.1.2.3 Number.isInteger(number)

var floor$3 = Math.floor;
var _isInteger = function isInteger(it) {
  return !_isObject(it) && isFinite(it) && floor$3(it) === it;
};

// 20.1.2.3 Number.isInteger(number)


_export(_export.S, 'Number', { isInteger: _isInteger });

var Formatting = {
  /**
   * Create an object of an array.
   *
   * @param {Array} array - The array to sort.
   * @param {string} key - The name of the key that will be used as the root parent key
   * @returns {object}
   */
  arrayToObject: function arrayToObject(array) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(array.map(function (obj) {
      return _defineProperty({}, obj[key], obj);
    }))));
  },

  /**
   * Rollup Values
   *
   * @param {Array} array
   * @returns {Array} ranges
   */
  getRanges: function getRanges(array) {
    var ranges = [];
    var rstart;
    var rend;

    for (var i = 0; i < array.length; i += 1) {
      rstart = array[i];
      rend = rstart;

      while (array[i + 1] - array[i] === 1) {
        rend = array[i + 1]; // increment the index if the numbers sequential

        i += 1;
      }

      ranges.push(rstart === rend ? "".concat(rstart) : "".concat(rstart, "-").concat(rend));
    }

    return ranges;
  },

  /**
   * Format a number with a bunch of options
   *
   * @param {number} amount
   * @param {string} prepend
   * @param {string} append
   * @param {number} decimalCountParam
   * @param {boolean} showZeroes
   * @param {string} decimalParam
   * @param {string} thousands
   * @returns {string}
   */
  formatNumber: function formatNumber(amount) {
    var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var decimalCountParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
    var showZeroes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var decimalParam = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '.';
    var thousands = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ',';

    try {
      var absDecimalCount = Math.abs(decimalCountParam);
      var decimalCount = Number.isNaN(absDecimalCount) ? 2 : absDecimalCount;
      var integers = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
      var integersSplit = integers.length > 3 ? integers.length % 3 : 0;
      var negativeSign = amount < 0 ? '-' : '';
      var decimals = decimalCount ? decimalParam + Math.abs(amount - integers).toFixed(decimalCount).slice(-decimalCount) : '';

      if (!showZeroes) {
        // trim zeroes
        decimals = decimals.replace(/0+$/, '');

        if (decimals.length === 1) {
          // if there's only a period left
          decimals = '';
        }
      }

      return negativeSign + prepend + (integersSplit ? integers.substr(0, integersSplit) + thousands : '') + integers.substr(integersSplit).replace(/(\d{3})(?=\d)/g, "$1".concat(thousands)) + decimals + append;
    } catch (error) {
      return amount;
    }
  },

  /**
   * Sort an array of objects
   *
   * @param {Array} array - The array to sort.
   * @param {string} sortKey - The name of the key that will be used to sort.
   * @param {string} sortDirection - 'asc' || 'desc'
   * I looked into adding an `isDate` here but looking through
   * https://stackoverflow.com/questions/10123953/how-to-sort-an-array-by-a-date-property,
   * using `dateA - dateB` is more of a memory hog.
   * @returns {Array}
   */
  sortObjects: function sortObjects(array) {
    var sortKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
    var sortDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
    return _toConsumableArray(array).sort(function (a, b) {
      var keyA = a[sortKey];
      var keyB = b[sortKey];

      if (sortDirection === 'desc') {
        keyA = b[sortKey];
        keyB = a[sortKey];
      } // The the value to sort by is an integer, subtract.


      if (Number.isInteger(keyA) && Number.isInteger(keyB)) {
        return keyA - keyB;
      } // The the value exists (not undefined, null, etc, uppercase strings to test.


      if (typeof keyA === 'string' && typeof keyB === 'string') {
        keyA = keyA.toUpperCase();
        keyB = keyB.toUpperCase();
      }

      if (keyA < keyB) {
        return -1;
      }

      if (keyA > keyB) {
        return 1;
      } // names must be equal


      return 0;
    });
  }
};

/**
 * Product Utility File
 *
 * @exports utils/product
 * @category Utils
 */

/**
 * Evaluate the product object and key that is passed to determine if the object passed is a stop loss product.
 *
 * @param {object} product
 * @param {string} key
 * @returns {boolean}
 */
var isStopLoss = function isStopLoss(product) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'product_type_name';
  return product[key].toLowerCase() === 'stop loss';
};
var Product = {
  isStopLoss: isStopLoss
};

/**
 * Reusable Data Utils
 *
 * @vuedoc
 * @exports ReusableData
 * @category Utils
 */
var ReusableData = {
  /**
   * Return a list of Months
   *
   * @returns {Array}
   */
  getMonths: function getMonths() {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months;
  },

  /**
   * Whether a subtype should default to compund
   *
   * @param {string} subtypeLabel
   * @returns {string}
   */
  getCompoundBySubtype: function getCompoundBySubtype(subtypeLabel) {
    var compound = null;

    switch (subtypeLabel) {
      case 'spouse':
      case 'child':
      case 'core':
      case 'buyup':
      case 'male':
      case 'female':
      case 'employee':
      case 'family':
        compound = true;
        break;

      case 'non_smoker':
      case 'smoker':
        compound = false;
        break;

      default:
        break;
    }

    return compound;
  },

  /**
   * What subtypes to show based on a products name
   *
   * @param {string} productTypeName
   * @returns {Array}
   */
  getSubtypeLabels: function getSubtypeLabels(productTypeName) {
    var smokerNonSmoker = {
      label: 'Non-Smoker/Smoker',
      subtypes: ['non_smoker', 'smoker']
    };
    var spouseChild = {
      label: 'Spouse/Child',
      subtypes: ['spouse', 'child']
    };
    var employeeFamily = {
      label: 'Employee/Family',
      subtypes: ['employee', 'family']
    };
    var coreBuyup = {
      label: 'Core/Buy-Up',
      subtypes: ['core', 'buyup']
    };
    var maleFemale = {
      label: 'Male/Female',
      subtypes: ['male', 'female']
    };
    var subtypesByProduct = {
      'Basic Life / AD&D': [],
      'Basic Dependent Life': [spouseChild],
      'Optional Life': [employeeFamily, smokerNonSmoker, maleFemale],
      'Optional AD&D': [employeeFamily, smokerNonSmoker],
      'Advice To Pay': [],
      'Statutory Plan - CA,HI,NJ,PR,RI': [coreBuyup, maleFemale],
      'Short Term Disability': [coreBuyup, maleFemale],
      'NY DBL': [maleFemale],
      'Long Term Disability': [coreBuyup]
    };
    return subtypesByProduct[productTypeName];
  },

  /**
   * What rate basis options to show based on a products int
   *
   * @param {number} productTypeId
   * @returns {Array}
   */
  getRateBasisOptions: function getRateBasisOptions(productTypeId) {
    var per10 = {
      label: 'Per $10',
      value: 10
    };
    var per25 = {
      label: 'Per $25',
      value: 25
    };
    var per50 = {
      label: 'Per $50',
      value: 50
    };
    var per75 = {
      label: 'Per $75',
      value: 75
    };
    var per100 = {
      label: 'Per $100',
      value: 100
    };
    var per1000 = {
      label: 'Per $1,000',
      value: 1000
    };
    var per2000 = {
      label: 'Per $2,000',
      value: 2000
    };
    var per5000 = {
      label: 'Per $5,000',
      value: 5000
    };
    var per10000 = {
      label: 'Per $10,000',
      value: 10000
    };
    var per15000 = {
      label: 'Per $15,000',
      value: 15000
    };
    var per20000 = {
      label: 'Per $20,000',
      value: 20000
    };
    var per30000 = {
      label: 'Per $30,000',
      value: 30000
    };
    var perUnit = {
      label: 'Per Unit',
      value: 1
    };
    var perEmployeeMonth = {
      label: 'Per Employee Per Month',
      value: 1
    }; // This is an array of the objects below so the product types using this in the rateBasisOptionsByProductTypeId object should not be in an array or they should use a spread operator to join them to another array.

    var criticalAccidentAndHospital = [perEmployeeMonth, per25, per50, per75, per1000, per2000, per5000, per10000];
    var rateBasisOptionsByProductTypeId = {
      1: [per10, per100, perEmployeeMonth],
      // short term disability
      2: [per1000],
      // basic life/AD&D
      3: [per1000, perUnit],
      // Basic Dependent Life
      4: [per1000, per2000, per5000, per10000, perUnit],
      // Voluntary Life
      5: [per1000, per2000, per5000, per10000, perUnit],
      // Optional AD&D
      7: [per100, perEmployeeMonth],
      // Long Term Disability
      8: [perEmployeeMonth],
      // Advice To Pay
      9: [per10, per100, perEmployeeMonth],
      // NY DBL
      11: [per10, per100, perEmployeeMonth],
      // NJ TDB,
      12: [perEmployeeMonth],
      // absence management
      13: [per10, per100, perEmployeeMonth],
      // HI TDI
      14: [perEmployeeMonth],
      // Dental
      15: [perEmployeeMonth],
      // Vision
      16: [].concat(criticalAccidentAndHospital, [per15000, per20000, per30000]),
      // Critical Illness
      17: criticalAccidentAndHospital,
      // Accident
      18: criticalAccidentAndHospital,
      // Hospital Indemnity
      19: [perEmployeeMonth],
      // Stop Loss
      21: [per1000, per2000, per5000, per10000, perUnit] // Voluntary Life / AD&D

    };
    return rateBasisOptionsByProductTypeId[productTypeId];
  },

  /**
   * labels to show for age banded values
   *
   * @returns {Array}
   */
  getAgeBandedValues: function getAgeBandedValues() {
    var labels = ['age_0_19', 'age_20_24', 'age_25_29', 'age_30_34', 'age_35_39', 'age_40_44', 'age_45_49', 'age_50_54', 'age_55_59', 'age_60_64', 'age_65_69', 'age_70_74', 'age_75_79', 'age_80_plus'];
    return labels;
  },

  /**
   * An array of file types we allow to be uploaded
   *
   * @returns {Array}
   */
  getAcceptableUploadFileTypes: function getAcceptableUploadFileTypes() {
    return ['application/pdf', 'application/msword', 'application/rtf', 'application/vnd.ms-excel', 'application/vnd.ms-excel.sheet.binary.macroEnabled.12', 'application/vnd.ms-excel.sheet.macroEnabled.12', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/rtf'];
  },

  /**
   * An array of file extensions we allow to be uploaded
   *
   * @returns {Array}
   */
  getAcceptableUploadFileExtensions: function getAcceptableUploadFileExtensions() {
    return ['.doc', '.docx', '.pdf', '.rtf', '.txt', '.xls', '.xlsb', '.xlsm', '.xlsx'];
  },

  /**
   * The human readable references to the type values we get from our API
   */
  projectTypes: {
    initialBuild: 'Projects::InitialEmployerBuild',
    goToMarket: 'Projects::RfpPlacementEvent',
    renewal: 'Projects::RenewalPlacementEvent'
  }
};

var dP$6 = _objectDp.f;
var gOPN$3 = _objectGopn.f;


var $RegExp = _global.RegExp;
var Base$1 = $RegExp;
var proto$3 = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (_descriptors && (!CORRECT_NEW || _fails(function () {
  re2[_wks('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = _isRegexp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : _inheritIfRequired(CORRECT_NEW
        ? new Base$1(piRE && !fiU ? p.source : p, f)
        : Base$1((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? _flags.call(p) : f)
      , tiRE ? this : proto$3, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP$6($RegExp, key, {
      configurable: true,
      get: function () { return Base$1[key]; },
      set: function (it) { Base$1[key] = it; }
    });
  };
  for (var keys$1 = gOPN$3(Base$1), i$3 = 0; keys$1.length > i$3;) proxy(keys$1[i$3++]);
  proto$3.constructor = $RegExp;
  $RegExp.prototype = proto$3;
  _redefine(_global, 'RegExp', $RegExp);
}

_setSpecies('RegExp');

/**
 * Validation Utility File
 *
 * @exports utils/validation
 * @category Utils
 */

/**
 * Evaluate the passed domain value and confirm if it is a valid domain.
 *
 * @param {string} value
 * @returns {boolean}
 */
var validateDomain = function validateDomain(value) {
  var expression = new RegExp(/^((?=[a-z0-9-]{1,63}\.)[a-z0-9-]+(-[a-z0-9-]+)*\.)+[a-z]{2,63}$/);
  return value.match(expression);
};
/**
 * Evaluate the passed value and domains to confirm if it is a valid email domain name. The domains that are passed should not include the @ symbol (Ex: ['acme.com', 'unum.com']).
 *
 * @param {string} value
 * @param {Array} domains
 * @returns {boolean}
 */

var validateEmailDomain = function validateEmailDomain(value) {
  var domains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var extension = value && value.includes('@') ? value.split('@')[1].toLowerCase() : null;
  return domains.find(function (domain) {
    return domain.toLowerCase() === extension;
  }) !== undefined;
};
var Validation = {
  validateDomain: validateDomain,
  validateEmailDomain: validateEmailDomain
};

var apiUrl$1 = process.env.VUE_APP_API_URL;
var CommentService = {
  /**
   * GET all quote level comments by document ID.
   *
   * @param {number} documentId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getComments: function getComments(documentId, applicationNamespace) {
    var axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise(function (resolve, reject) {
      var url = "".concat(apiUrl$1, "/v1/").concat(applicationNamespace, "/comments/document/").concat(documentId);
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },

  /**
   * POST a new comment.
   *
   * @param {object} param
   * @param {string} param.applicationNamespace
   * @param {number | Array} param.commentableIds
   * @param {string} param.content
   * @param {number} param.parentId
   * @returns {Promise}
   */
  postComment: function postComment(_ref) {
    var applicationNamespace = _ref.applicationNamespace,
        commentableIds = _ref.commentableIds,
        content = _ref.content,
        parentId = _ref.parentId;
    var axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise(function (resolve, reject) {
      var url = "".concat(apiUrl$1, "/v1/").concat(applicationNamespace, "/comments");
      var data = {
        commentable_type: 'Document',
        content: content,
        parent_id: parentId
      };

      if (applicationNamespace === 'broker_portal') {
        data.commentable_ids = Array.isArray(commentableIds) ? commentableIds : [commentableIds];
      }

      if (applicationNamespace === 'carrier_portal') {
        data.commentable_id = commentableIds;
      }

      axios$1.post(url, data, axiosConfig).then(function (response) {
        return resolve(response.data);
      }).catch(function (e) {
        return reject(e);
      });
    });
  },

  /**
   * GET all comments by project ID and application namespace.
   *
   * @param {string} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getCommentsByProject: function getCommentsByProject(projectId, applicationNamespace) {
    var axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise(function (resolve, reject) {
      var url = "".concat(apiUrl$1, "/v1/").concat(applicationNamespace, "/comments/project/").concat(projectId);
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  }
};

var apiUrl$2 = process.env.VUE_APP_API_URL;
var NotificationsService = {
  /**
   * See if there are any notifications for unread comments
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getCommentsNotifications: function getCommentsNotifications(projectId, applicationNamespace) {
    var axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise(function (resolve, reject) {
      var url = "".concat(apiUrl$2, "/v1/").concat(applicationNamespace, "/notifications/unread_comments/").concat(projectId);
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },

  /**
   * get notifications for unread quote edits
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getEditsNotifications: function getEditsNotifications(projectId, applicationNamespace) {
    var axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise(function (resolve, reject) {
      var url = "".concat(apiUrl$2, "/v1/").concat(applicationNamespace, "/notifications/unread_edits/").concat(projectId);
      axios$1.get(url, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },

  /**
   * Clear out the notifications for unread comments
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  clearCommentNotifications: function clearCommentNotifications(projectId, applicationNamespace) {
    var axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise(function (resolve, reject) {
      var url = "".concat(apiUrl$2, "/v1/").concat(applicationNamespace, "/notifications/mark_all_comments_as_read");
      var data = {
        project_id: projectId
      };
      axios$1.post(url, data, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },

  /**
   * Clear out the notifications for unread quote edits
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  clearEditNotifications: function clearEditNotifications(projectId, applicationNamespace) {
    var axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise(function (resolve, reject) {
      var url = "".concat(apiUrl$2, "/v1/").concat(applicationNamespace, "/notifications/mark_all_edits_as_read");
      var data = {
        project_id: projectId
      };
      axios$1.post(url, data, axiosConfig).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  }
};

var apiUrl$3 = process.env.VUE_APP_API_URL;
var SourceService = {
  /**
   * Delete source
   *
   * @param {number} sourceId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  deleteSource: function deleteSource(sourceId, applicationNamespace) {
    return new Promise(function (resolve, reject) {
      axios$1.delete("".concat(apiUrl$3, "/v1/").concat(applicationNamespace, "/sources/").concat(sourceId), AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE)).then(function (response) {
        resolve(response.data);
      }).catch(function (e) {
        reject(e);
      });
    });
  },

  /**
   * Get the encoded data for a specfic pdf to show in the fileviewer
   *
   * @param {number} sourceId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getSource: function getSource(sourceId, applicationNamespace) {
    return new Promise(function (resolve, reject) {
      axios$1.get("".concat(apiUrl$3, "/v1/").concat(applicationNamespace, "/sources/").concat(sourceId), AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE)).then(function (response) {
        resolve(response);
      }).catch(function (e) {
        reject(e);
      });
    });
  }
};

// element components
/**
 * Every component that gets installed when someone calls Vue.use for our component
 *
 * @param {object} Vue
 */

var loadThreeflowComponents = function loadThreeflowComponents(Vue) {
  // Element components
  // Vue.use(Pagination)
  Vue.use(Dialog); // Vue.use(Autocomplete)

  Vue.use(Dropdown);
  Vue.use(DropdownMenu);
  Vue.use(DropdownItem);
  Vue.use(Menu);
  Vue.use(Submenu);
  Vue.use(MenuItem);
  Vue.use(MenuItemGroup);
  Vue.use(Input); // Vue.use(InputNumber)

  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(RadioButton);
  Vue.use(Checkbox);
  Vue.use(CheckboxButton);
  Vue.use(CheckboxGroup);
  Vue.use(Switch);
  Vue.use(Select);
  Vue.use(Option);
  Vue.use(OptionGroup); // Vue.use(Button)
  // Vue.use(ButtonGroup)
  // Vue.use(Table)
  // Vue.use(TableColumn)
  // Vue.use(TimePicker)

  Vue.use(Popover);
  Vue.use(Tooltip);
  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Tabs);
  Vue.use(TabPane);
  Vue.use(Alert); // Vue.use(Slider)
  // Vue.use(Row)
  // Vue.use(Col)

  Vue.use(Upload);
  Vue.use(Progress);
  Vue.use(Spinner); // Vue.use(Steps)

  Vue.use(Step);
  Vue.use(Scrollbar);
  Vue.use(Collapse);
  Vue.use(CollapseItem);
  Vue.use(Loading.directive); // Third party libraries

  Vue.component('Popper', vuePopper_min);
  Vue.use(VueForceNextTick); // Alias element-ui elements; leave as-is for now

  Vue.component('TfSelect', Select);
  Vue.component('TfOption', Option);
  Vue.component('TfOptionGroup', OptionGroup);
  Vue.component('ElTabs', Tabs);
  Vue.component('TfTabs', __vue_component__);
  Vue.component('TfTabPane', TabPane);
  Vue.component('TfMenu', Menu);
  Vue.component('TfMenuItem', MenuItem);
  Vue.component('TfMenuItemGroup', MenuItemGroup);
  Vue.component('TfSubmenu', __vue_component__$R);
  Vue.component('TfUpload', Upload);
  Vue.component('TfRadio', Radio);
  Vue.component('TfRadioGroup', RadioGroup);
  Vue.component('TfRadioButton', RadioButton);
  Vue.component('TfCheckboxGroup', CheckboxGroup);
  Vue.component('TfCheckboxButton', CheckboxButton);
  Vue.component('TfInput', Input);
  Vue.component('TfForm', Form);
  Vue.component('TfFormItem', FormItem); // custom components

  Vue.component('Comment', __vue_component__$w);
  Vue.component('CommentInput', __vue_component__$x);
  Vue.component('CopyLinkContainer', __vue_component__$y);
  Vue.component('Datepicker', Datepicker);
  Vue.component('DocumentManagerCategory', __vue_component__$z);
  Vue.component('DocumentManagerItem', __vue_component__$A);
  Vue.component('HistoryItem', __vue_component__$B);
  Vue.component('TfPagination', __vue_component__$D);
  Vue.component('RfpTable', __vue_component__$C);
  Vue.component('ThreeflowWordmark', __vue_component__$E);
  Vue.component('TfBidEditsExport', __vue_component__$o);
  Vue.component('TfBadge', __vue_component__$F);
  Vue.component('TfButton', __vue_component__$G);
  Vue.component('TfCheckbox', __vue_component__$g);
  Vue.component('TfCommentsExport', __vue_component__$p);
  Vue.component('TfCtaEmailSupport', __vue_component__$H);
  Vue.component('TfDatepicker', __vue_component__$I);
  Vue.component('TfFilter', __vue_component__$L);
  Vue.component('TfHamburgerMenu', __vue_component__$M);
  Vue.component('TfHamburgerMenuItem', __vue_component__$N);
  Vue.component('TfInputWithOptions', __vue_component__$h);
  Vue.component('TfMultiSelect', __vue_component__$i);
  Vue.component('TfPanel', __vue_component__$O);
  Vue.component('TfPanel2', __vue_component__$P);
  Vue.component('TfPdfExport', __vue_component__$r);
  Vue.component('TfPdfExportHeader', __vue_component__$n);
  Vue.component('TfPlanDesignDropdown', __vue_component__$h); // legacy and can be removed once carrier/admin update.

  Vue.component('TfPopover', __vue_component__$Q);
  Vue.component('TfProductSelector', __vue_component__$u);
  Vue.component('TfProgressIcon', __vue_component__$v);
  Vue.component('TfQuoteEditsExport', __vue_component__$o); // Alias for TFBidEditsExport for backwards compatability

  Vue.component('TfSelectText', __vue_component__$j);
  Vue.component('TfTable', __vue_component__$Y);
  Vue.component('TfTableParentRow', __vue_component__$Z);
  Vue.component('TfTableTd', __vue_component__$_);
  Vue.component('TfTag', __vue_component__$k);
  Vue.component('TfTagField', __vue_component__$l);
  Vue.component('TfTooltip', __vue_component__$S); // CP custom components - temporary until we make carrier a library as well

  Vue.component('CpCallout', __vue_component__$1); // Form elements

  Vue.component('TfInlineFormField', __vue_component__$d);
  Vue.component('TfFormBuilder', __vue_component__$e);
  Vue.component('TfFormList', __vue_component__$f); // custom - auth

  Vue.component('AppConfirmEmail', __vue_component__$2);
  Vue.component('AppForgotPasswordForm', __vue_component__$3);
  Vue.component('AppLanding', __vue_component__$4);
  Vue.component('AppLogin', __vue_component__$5);
  Vue.component('AppRegisterConfirmation', __vue_component__$6);
  Vue.component('AppRegisterForm', __vue_component__$7);
  Vue.component('AppResendConfirmation', __vue_component__$8);
  Vue.component('AppResetPasswordForm', __vue_component__$9);
  Vue.component('AppTermsOfUse', __vue_component__$a);
  Vue.component('AuthPageFooter', __vue_component__$b);
  Vue.component('AuthPageHeader', __vue_component__$c); // wt aliases #legacy

  Vue.component('WtSelect', Select);
  Vue.component('WtOption', Option);
  Vue.component('WtOptionGroup', OptionGroup);
  Vue.component('WtTabs', Tabs);
  Vue.component('WtTabPane', TabPane);
  Vue.component('WtMenu', Menu);
  Vue.component('WtMenuItem', MenuItem);
  Vue.component('WtMenuItemGroup', MenuItemGroup);
  Vue.component('WtSubmenu', __vue_component__$R);
  Vue.component('WtUpload', Upload);
  Vue.component('WtRadio', Radio);
  Vue.component('WtRadioGroup', RadioGroup);
  Vue.component('WtRadioButton', RadioButton);
  Vue.component('WtCheckboxGroup', CheckboxGroup);
  Vue.component('WtCheckboxButton', CheckboxButton);
  Vue.component('WtInput', Input);
  Vue.component('WtForm', Form);
  Vue.component('WtFormItem', FormItem);
  Vue.component('WtPagination', __vue_component__$D);
  Vue.component('WtBidEditsExport', __vue_component__$o);
  Vue.component('WtButton', __vue_component__$G);
  Vue.component('WtCheckbox', __vue_component__$g);
  Vue.component('WtCommentsExport', __vue_component__$p);
  Vue.component('WtDatepicker', __vue_component__$I);
  Vue.component('WtFilter', __vue_component__$L);
  Vue.component('WtHamburgerMenu', __vue_component__$M);
  Vue.component('WtHamburgerMenuItem', __vue_component__$N);
  Vue.component('WtInputWithOptions', __vue_component__$h);
  Vue.component('WtMultiSelect', __vue_component__$i);
  Vue.component('WtPanel', __vue_component__$O);
  Vue.component('WtPanel2', __vue_component__$P);
  Vue.component('WtPdfExport', __vue_component__$r);
  Vue.component('WtPdfExportHeader', __vue_component__$n);
  Vue.component('WtPlanDesignDropdown', __vue_component__$h); // legacy and can be removed once carrier/admin update.

  Vue.component('WtPopover', __vue_component__$Q);
  Vue.component('WtProductSelector', __vue_component__$u);
  Vue.component('WtProgressIcon', __vue_component__$v);
  Vue.component('WtQuoteEditsExport', __vue_component__$o); // Alias for TFBidEditsExport for backwards compatability

  Vue.component('WtSelectText', __vue_component__$j);
  Vue.component('WtTable', __vue_component__$Y);
  Vue.component('WtTableParentRow', __vue_component__$Z);
  Vue.component('WtTableTd', __vue_component__$_);
  Vue.component('WtTag', __vue_component__$k);
  Vue.component('WtTagField', __vue_component__$l);
  Vue.component('WtTooltip', __vue_component__$S);
  Vue.component('WtInlineFormField', __vue_component__$d);
  Vue.component('WtFormBuilder', __vue_component__$e);
  Vue.component('WtFormList', __vue_component__$f); // element magic

  /* eslint-disable no-param-reassign */

  Vue.prototype.$loading = Loading.service; // Vue.prototype.$msgbox = MessageBox;
  // Vue.prototype.$alert = MessageBox.alert;
  // Vue.prototype.$confirm = MessageBox.confirm;
  // Vue.prototype.$prompt = MessageBox.prompt;
  // Vue.prototype.$notify = Notification;

  Vue.prototype.$message = Message; // Test

  Vue.prototype.$moment = moment;
  /* eslint-enable no-param-reassign */
  // plugins

  Vue.use(vClickOutside_umd);
};

var threeflowObject = {
  Analytics: Analytics,
  AxiosConfig: AxiosConfig,
  BrowserUtils: BrowserUtils,
  CommentService: CommentService,
  Cookies: Cookies,
  DatesUtils: DatesUtils,
  Formatting: Formatting,
  NotificationsService: NotificationsService,
  Product: Product,
  ReusableData: ReusableData,
  SourceService: SourceService,
  Validation: Validation
};

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var isBuffer$1 = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
};

var toString$4 = Object.prototype.toString;

// < 0.13.0 will not have default headers set on a custom instance
var rejectWithError = !!axios$1.create().defaults.headers;

function find$1(array, predicate) {
  var length = array.length;
  for (var i = 0; i < length; i++) {
    var value = array[i];
    if (predicate(value)) return value;
  }
}

function isFunction$2(val) {
  return toString$4.call(val) === "[object Function]";
}

function isObjectOrArray(val) {
  return val !== null && typeof val === "object";
}

function isStream$1(val) {
  return isObjectOrArray(val) && isFunction$2(val.pipe);
}

function isArrayBuffer$1(val) {
  return toString$4.call(val) === "[object ArrayBuffer]";
}

function combineUrls(baseURL, url) {
  if (baseURL) {
    return baseURL.replace(/\/+$/, "") + "/" + url.replace(/^\/+/, "");
  }

  return url;
}

function findHandler(
  handlers,
  method,
  url,
  body,
  parameters,
  headers,
  baseURL
) {
  return find$1(handlers[method.toLowerCase()], function (handler) {
    if (typeof handler[0] === "string") {
      return (
        (isUrlMatching(url, handler[0]) ||
          isUrlMatching(combineUrls(baseURL, url), handler[0])) &&
        isBodyOrParametersMatching(method, body, parameters, handler[1]) &&
        isObjectMatching(headers, handler[2])
      );
    } else if (handler[0] instanceof RegExp) {
      return (
        (handler[0].test(url) || handler[0].test(combineUrls(baseURL, url))) &&
        isBodyOrParametersMatching(method, body, parameters, handler[1]) &&
        isObjectMatching(headers, handler[2])
      );
    }
  });
}

function isUrlMatching(url, required) {
  var noSlashUrl = url[0] === "/" ? url.substr(1) : url;
  var noSlashRequired = required[0] === "/" ? required.substr(1) : required;
  return noSlashUrl === noSlashRequired;
}

function isBodyOrParametersMatching(method, body, parameters, required) {
  var allowedParamsMethods = ["delete", "get", "head", "options"];
  if (allowedParamsMethods.indexOf(method.toLowerCase()) >= 0) {
    var params = required ? required.params : undefined;
    return isObjectMatching(parameters, params);
  } else {
    return isBodyMatching(body, required);
  }
}

function isObjectMatching(actual, expected) {
  if (expected === undefined) return true;
  if (typeof expected.asymmetricMatch === "function") {
    return expected.asymmetricMatch(actual);
  }
  return fastDeepEqual(actual, expected);
}

function isBodyMatching(body, requiredBody) {
  if (requiredBody === undefined) {
    return true;
  }
  var parsedBody;
  try {
    parsedBody = JSON.parse(body);
  } catch (e) {}

  return isObjectMatching(parsedBody ? parsedBody : body, requiredBody);
}

function purgeIfReplyOnce(mock, handler) {
  Object.keys(mock.handlers).forEach(function (key) {
    var index = mock.handlers[key].indexOf(handler);
    if (index > -1) {
      mock.handlers[key].splice(index, 1);
    }
  });
}

function settle$1(resolve, reject, response, delay) {
  if (delay > 0) {
    setTimeout(function () {
      settle$1(resolve, reject, response);
    }, delay);
    return;
  }

  if (response.config && response.config.validateStatus) {
    response.config.validateStatus(response.status)
      ? resolve(response)
      : reject(
          createAxiosError(
            "Request failed with status code " + response.status,
            response.config,
            response
          )
        );
    return;
  }

  // Support for axios < 0.11
  if (response.status >= 200 && response.status < 300) {
    resolve(response);
  } else {
    reject(response);
  }
}

function createAxiosError(message, config, response, code) {
  // Support for axios < 0.13.0
  if (!rejectWithError) return response;

  var error = new Error(message);
  error.isAxiosError = true;
  error.config = config;
  if (response !== undefined) {
    error.response = response;
  }
  if (code !== undefined) {
    error.code = code;
  }

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
    };
  };
  return error;
}

function createCouldNotFindMockError(config) {
  var message =
    "Could not find mock for: \n" +
    JSON.stringify(config, ["method", "url"], 2);
  var error = new Error(message);
  error.isCouldNotFindMockError = true;
  error.url = config.url;
  error.method = config.method;
  return error;
}

var utils$2 = {
  find: find$1,
  findHandler: findHandler,
  purgeIfReplyOnce: purgeIfReplyOnce,
  settle: settle$1,
  isStream: isStream$1,
  isArrayBuffer: isArrayBuffer$1,
  isFunction: isFunction$2,
  isObjectOrArray: isObjectOrArray,
  isBuffer: isBuffer$1,
  isEqual: fastDeepEqual,
  createAxiosError: createAxiosError,
  createCouldNotFindMockError: createCouldNotFindMockError,
};

function transformRequest(data) {
  if (
    utils$2.isArrayBuffer(data) ||
    utils$2.isBuffer(data) ||
    utils$2.isStream(data)
  ) {
    return data;
  }

  // Object and Array: returns a deep copy
  if (utils$2.isObjectOrArray(data)) {
    return JSON.parse(JSON.stringify(data));
  }

  // for primitives like string, undefined, null, number
  return data;
}

function makeResponse(result, config) {
  return {
    status: result[0],
    data: transformRequest(result[1]),
    headers: result[2],
    config: config,
    request: {
      responseURL: config.url,
    },
  };
}

function handleRequest(mockAdapter, resolve, reject, config) {
  var url = config.url || "";
  // TODO we're not hitting this `if` in any of the tests, investigate
  if (
    config.baseURL &&
    url.substr(0, config.baseURL.length) === config.baseURL
  ) {
    url = url.slice(config.baseURL.length);
  }

  delete config.adapter;
  mockAdapter.history[config.method].push(config);

  var handler = utils$2.findHandler(
    mockAdapter.handlers,
    config.method,
    url,
    config.data,
    config.params,
    config.headers,
    config.baseURL
  );

  if (handler) {
    if (handler.length === 7) {
      utils$2.purgeIfReplyOnce(mockAdapter, handler);
    }

    if (handler.length === 2) {
      // passThrough handler
      mockAdapter.originalAdapter(config).then(resolve, reject);
    } else if (typeof handler[3] !== "function") {
      utils$2.settle(
        resolve,
        reject,
        makeResponse(handler.slice(3), config),
        mockAdapter.delayResponse
      );
    } else {
      var result = handler[3](config);
      // TODO throw a sane exception when return value is incorrect
      if (typeof result.then !== "function") {
        utils$2.settle(
          resolve,
          reject,
          makeResponse(result, config),
          mockAdapter.delayResponse
        );
      } else {
        result.then(
          function (result) {
            if (result.config && result.status) {
              utils$2.settle(
                resolve,
                reject,
                makeResponse(
                  [result.status, result.data, result.headers],
                  result.config
                ),
                0
              );
            } else {
              utils$2.settle(
                resolve,
                reject,
                makeResponse(result, config),
                mockAdapter.delayResponse
              );
            }
          },
          function (error) {
            if (mockAdapter.delayResponse > 0) {
              setTimeout(function () {
                reject(error);
              }, mockAdapter.delayResponse);
            } else {
              reject(error);
            }
          }
        );
      }
    }
  } else {
    // handler not found
    switch (mockAdapter.onNoMatch) {
      case "passthrough":
        mockAdapter.originalAdapter(config).then(resolve, reject);
        break;
      case "throwException":
        throw utils$2.createCouldNotFindMockError(config);
      default:
        utils$2.settle(
          resolve,
          reject,
          {
            status: 404,
            config: config,
          },
          mockAdapter.delayResponse
        );
    }
  }
}

var handle_request = handleRequest;

var VERBS = [
  "get",
  "post",
  "head",
  "delete",
  "patch",
  "put",
  "options",
  "list",
];

function adapter() {
  return function (config) {
    var mockAdapter = this;
    // axios >= 0.13.0 only passes the config and expects a promise to be
    // returned. axios < 0.13.0 passes (config, resolve, reject).
    if (arguments.length === 3) {
      handle_request(mockAdapter, arguments[0], arguments[1], arguments[2]);
    } else {
      return new Promise(function (resolve, reject) {
        handle_request(mockAdapter, resolve, reject, config);
      });
    }
  }.bind(this);
}

function getVerbObject() {
  return VERBS.reduce(function (accumulator, verb) {
    accumulator[verb] = [];
    return accumulator;
  }, {});
}

function reset() {
  resetHandlers.call(this);
  resetHistory.call(this);
}

function resetHandlers() {
  this.handlers = getVerbObject();
}

function resetHistory() {
  this.history = getVerbObject();
}

function MockAdapter(axiosInstance, options) {
  reset.call(this);

  // TODO throw error instead when no axios instance is provided
  if (axiosInstance) {
    this.axiosInstance = axiosInstance;
    this.originalAdapter = axiosInstance.defaults.adapter;
    this.delayResponse =
      options && options.delayResponse > 0 ? options.delayResponse : null;
    this.onNoMatch = (options && options.onNoMatch) || null;
    axiosInstance.defaults.adapter = this.adapter.call(this);
  }
}

MockAdapter.prototype.adapter = adapter;

MockAdapter.prototype.restore = function restore() {
  if (this.axiosInstance) {
    this.axiosInstance.defaults.adapter = this.originalAdapter;
    this.axiosInstance = undefined;
  }
};

MockAdapter.prototype.reset = reset;
MockAdapter.prototype.resetHandlers = resetHandlers;
MockAdapter.prototype.resetHistory = resetHistory;

VERBS.concat("any").forEach(function (method) {
  var methodName = "on" + method.charAt(0).toUpperCase() + method.slice(1);
  MockAdapter.prototype[methodName] = function (matcher, body, requestHeaders) {
    var _this = this;
    var matcher = matcher === undefined ? /.*/ : matcher;

    function reply(code, response, headers) {
      var handler = [matcher, body, requestHeaders, code, response, headers];
      addHandler(method, _this.handlers, handler);
      return _this;
    }

    function replyOnce(code, response, headers) {
      var handler = [
        matcher,
        body,
        requestHeaders,
        code,
        response,
        headers,
        true,
      ];
      addHandler(method, _this.handlers, handler);
      return _this;
    }

    return {
      reply: reply,

      replyOnce: replyOnce,

      passThrough: function passThrough() {
        var handler = [matcher, body];
        addHandler(method, _this.handlers, handler);
        return _this;
      },

      abortRequest: function () {
        return reply(function (config) {
          var error = utils$2.createAxiosError(
            "Request aborted",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },

      abortRequestOnce: function () {
        return replyOnce(function (config) {
          var error = utils$2.createAxiosError(
            "Request aborted",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },

      networkError: function () {
        return reply(function (config) {
          var error = utils$2.createAxiosError("Network Error", config);
          return Promise.reject(error);
        });
      },

      networkErrorOnce: function () {
        return replyOnce(function (config) {
          var error = utils$2.createAxiosError("Network Error", config);
          return Promise.reject(error);
        });
      },

      timeout: function () {
        return reply(function (config) {
          var error = utils$2.createAxiosError(
            config.timeoutErrorMessage ||
              "timeout of " + config.timeout + "ms exceeded",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },

      timeoutOnce: function () {
        return replyOnce(function (config) {
          var error = utils$2.createAxiosError(
            config.timeoutErrorMessage ||
              "timeout of " + config.timeout + "ms exceeded",
            config,
            undefined,
            "ECONNABORTED"
          );
          return Promise.reject(error);
        });
      },
    };
  };
});

function findInHandlers(method, handlers, handler) {
  var index = -1;
  for (var i = 0; i < handlers[method].length; i += 1) {
    var item = handlers[method][i];
    var isReplyOnce = item.length === 7;
    var comparePaths =
      item[0] instanceof RegExp && handler[0] instanceof RegExp
        ? String(item[0]) === String(handler[0])
        : item[0] === handler[0];
    var isSame =
      comparePaths &&
      utils$2.isEqual(item[1], handler[1]) &&
      utils$2.isEqual(item[2], handler[2]);
    if (isSame && !isReplyOnce) {
      index = i;
    }
  }
  return index;
}

function addHandler(method, handlers, handler) {
  if (method === "any") {
    VERBS.forEach(function (verb) {
      handlers[verb].push(handler);
    });
  } else {
    var indexOfExistingHandler = findInHandlers(method, handlers, handler);
    if (indexOfExistingHandler > -1 && handler.length < 7) {
      handlers[method].splice(indexOfExistingHandler, 1, handler);
    } else {
      handlers[method].push(handler);
    }
  }
}

var src = MockAdapter;
var default_1$1 = MockAdapter;
src.default = default_1$1;

var apiUrl$4 = process.env.VUE_APP_API_URL;
var Interceptor = {
  /**
   * load mocks and monitor api calls for 4012/403s
   *
   * @param {object} applicationOptions
   */
  activate: function activate() {
    var applicationOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // create a list of api calls that we need to mock and the responses we want
    var environment = process.env.NODE_ENV;

    if (environment === 'testing') {
      var v1 = "".concat(apiUrl$4, "/v1");
      var mock = new src(axios$1);
      mock.onDelete("".concat(v1, "/sources/3021")).reply(200, {});
      mock.onPost("".concat(v1, "/notifications/unread_edits/999")).reply(200, {});
      mock.onGet("".concat(v1, "/notifications/unread_edits/999")).reply(200, {
        unread_notifications: 0
      }); // Comments

      var replyComment = {
        comment: {
          id: 208,
          commentable_id: 1508,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 80,
          created_at: '2018-02-26T21: 11:14.187508',
          updated_at: '2018-02-26T21: 11:14.187508',
          replies: [],
          user: {
            id: 80,
            email: 'droti@watchtowerbenefits.com',
            first_name: 'Domenic',
            last_name: 'Roti',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          }
        }
      };
      var carrierComments = {
        comments: [{
          id: 62,
          commentable_id: 1508,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 80,
          created_at: '2018-02-19T17: 29:38.741478',
          updated_at: '2018-02-19T17: 29:38.741478',
          replies: [{
            id: 67,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:00:47.00357',
            updated_at: '2018-02-19T22:00:47.00357',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 68,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply 2',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:25:16.885177',
            updated_at: '2018-02-19T22:25:16.885177',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 69,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply 3',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:29:54.553554',
            updated_at: '2018-02-19T22:29:54.553554',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 70,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'reply 4',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T22:31:33.176935',
            updated_at: '2018-02-19T22:31:33.176935',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 71,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'new reply',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T23:00:46.547529',
            updated_at: '2018-02-19T23:00:46.547529',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }, {
            id: 72,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'test reply',
            parent_id: '62',
            user_id: 80,
            created_at: '2018-02-19T23:01:50.28123',
            updated_at: '2018-02-19T23:01:50.28123',
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            }
          }],
          user: {
            id: 80,
            email: 'droti@watchtowerbenefits.com',
            first_name: 'Domenic',
            last_name: 'Roti',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          }
        }]
      };
      var brokerComments = {
        comments: [{
          id: 119,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'Comment to broker',
          parent_id: null,
          user_id: 107,
          created_at: '2018-03-26T21: 04: 37.493686',
          updated_at: '2018-03-26T21: 04: 37.493686',
          replies: [{
            id: 120,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'Reply from broker',
            parent_id: '119',
            user_id: 150,
            created_at: '2018-03-26T21: 10: 27.405564',
            updated_at: '2018-03-26T21: 10: 27.405564',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: false
          }, {
            id: 121,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'Reply from carrier',
            parent_id: '119',
            user_id: 107,
            created_at: '2018-03-26T21: 10: 46.942491',
            updated_at: '2018-03-26T21: 10: 46.942491',
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            },
            is_new: false
          }, {
            id: 122,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'reply from broker',
            parent_id: '119',
            user_id: 150,
            created_at: '2018-03-26T21: 11: 33.467593',
            updated_at: '2018-03-26T21: 11: 33.467593',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: false
          }, {
            id: 123,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '119',
            user_id: 107,
            created_at: '2018-03-26T21: 12: 53.267896',
            updated_at: '2018-03-26T21: 12: 53.267896',
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            },
            is_new: false
          }, {
            id: 125,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '119',
            user_id: 150,
            created_at: '2018-03-26T21: 15: 13.582766',
            updated_at: '2018-03-26T21: 15: 13.582766',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: false
          }, {
            id: 127,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '119',
            user_id: 107,
            created_at: '2018-03-26T21: 16: 55.036569',
            updated_at: '2018-03-26T21: 16: 55.036569',
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
              },
              broker: {}
            },
            is_new: false
          }],
          user: {
            id: 107,
            email: 'guardian@watchtowerbenefits.com',
            first_name: 'Guardian ',
            last_name: 'User',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          },
          is_new: false
        }, {
          id: 124,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 107,
          created_at: '2018-03-26T21: 15: 00.193088',
          updated_at: '2018-03-26T21: 15: 00.193088',
          replies: [],
          user: {
            id: 107,
            email: 'guardian@watchtowerbenefits.com',
            first_name: 'Guardian ',
            last_name: 'User',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          },
          is_new: false
        }, {
          id: 126,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 107,
          created_at: '2018-03-26T21: 16: 44.809758',
          updated_at: '2018-03-26T21: 16: 44.809758',
          replies: [],
          user: {
            id: 107,
            email: 'guardian@watchtowerbenefits.com',
            first_name: 'Guardian ',
            last_name: 'User',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg'
            },
            broker: {}
          },
          is_new: false
        }, {
          id: 128,
          commentable_id: 2749,
          commentable_type: 'Document',
          content: 'testest',
          parent_id: null,
          user_id: 150,
          created_at: '2018-03-26T21: 17: 08.283382',
          updated_at: '2018-03-26T21: 17: 08.283382',
          replies: [{
            id: 129,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: '128',
            user_id: 150,
            created_at: '2018-03-26T21: 17: 17.246196',
            updated_at: '2018-03-26T21: 17: 17.246196',
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
              }
            },
            is_new: true
          }],
          user: {
            id: 150,
            email: 'broker@watchtowerbenefits.com',
            first_name: 'Watch',
            last_name: 'Tower',
            carrier: {},
            broker: {
              id: 6,
              name: 'Watchtower Demo Broker',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png'
            }
          },
          is_new: true
        }]
      };
      mock.onPost("".concat(v1, "/carrier_portal/comments")).reply(200, replyComment);
      mock.onPost("".concat(v1, "/broker_portal/comments")).reply(200, replyComment); // this needs to be updated with a namespaced one at some point

      mock.onPost("".concat(v1, "/notifications/mark_all_comments_as_read")).reply(200, {});
      mock.onGet("".concat(v1, "/carrier_portal/comments/document/1508")).reply(200, carrierComments);
      mock.onGet("".concat(v1, "/broker_portal/comments/project/999")).reply(200, brokerComments);
      mock.onGet("".concat(v1, "/notifications/unread_comments/999")).reply(200, {
        unread_notifications: 0
      });
    }

    axios$1.interceptors.response.use(undefined, function (err) {
      var res = err.response;

      if ((!res || res.status === 401 || res.status === 403) && applicationOptions.inactiveLogout) {
        applicationOptions.inactiveLogout();
      }

      return Promise.reject(err);
    });
  }
};

var runtime = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime =  module.exports ;

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);
});

var _anInstance$1 = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

var _forOf$1 = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx$1(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength$1(iterable.length); length > index; index++) {
    result = entries ? f(_anObject$1(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES$4 = _wks$1('species');
var _speciesConstructor$1 = function (O, D) {
  var C = _anObject$1(O).constructor;
  var S;
  return C === undefined || (S = _anObject$1(C)[SPECIES$4]) == undefined ? D : _aFunction$1(S);
};

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var process$1 = _global$1.process;
var setTask = _global$1.setImmediate;
var clearTask = _global$1.clearImmediate;
var MessageChannel = _global$1.MessageChannel;
var Dispatch = _global$1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof$1(process$1) == 'process') {
    defer = function (id) {
      process$1.nextTick(_ctx$1(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx$1(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx$1(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global$1.addEventListener && typeof postMessage == 'function' && !_global$1.importScripts) {
    defer = function (id) {
      _global$1.postMessage(id + '', '*');
    };
    _global$1.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate$1('script')) {
    defer = function (id) {
      _html$1.appendChild(_domCreate$1('script'))[ONREADYSTATECHANGE] = function () {
        _html$1.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx$1(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global$1.MutationObserver || _global$1.WebKitMutationObserver;
var process$2 = _global$1.process;
var Promise$1 = _global$1.Promise;
var isNode = _cof$1(process$2) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global$1.navigator && _global$1.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global$1, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction$1(resolve);
  this.reject = _aFunction$1(reject);
}

var f$c = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$c
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator$1 = _global$1.navigator;

var _userAgent = navigator$1 && navigator$1.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject$1(C);
  if (_isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll$1 = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else _hide$1(target, key, src[key]);
  } return target;
};

var SPECIES$5 = _wks$1('species');

var _setSpecies$1 = function (KEY) {
  var C = typeof _core$1[KEY] == 'function' ? _core$1[KEY] : _global$1[KEY];
  if (_descriptors$1 && C && !C[SPECIES$5]) _objectDp$1.f(C, SPECIES$5, {
    configurable: true,
    get: function () { return this; }
  });
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global$1.TypeError;
var process$3 = _global$1.process;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global$1[PROMISE];
var isNode$1 = _classof$1(process$3) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE$1 = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks$1('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject$1(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global$1, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else if (handler = _global$1.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global$1.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global$1, function () {
    var handler;
    if (isNode$1) {
      process$3.emit('rejectionHandled', promise);
    } else if (handler = _global$1.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx$1($resolve, wrapper, 1), _ctx$1($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE$1) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance$1(this, $Promise, PROMISE, '_h');
    _aFunction$1(executor);
    Internal.call(this);
    try {
      executor(_ctx$1($resolve, this, 1), _ctx$1($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll$1($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor$1(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$3.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx$1($resolve, promise, 1);
    this.reject = _ctx$1($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export$1(_export$1.G + _export$1.W + _export$1.F * !USE_NATIVE$1, { Promise: $Promise });
_setToStringTag$1($Promise, PROMISE);
_setSpecies$1(PROMISE);
Wrapper = _core$1[PROMISE];

// statics
_export$1(_export$1.S + _export$1.F * !USE_NATIVE$1, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export$1(_export$1.S + _export$1.F * (_library$1 ), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve( this === Wrapper ? $Promise : this, x);
  }
});
_export$1(_export$1.S + _export$1.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf$1(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf$1(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

_export$1(_export$1.P + _export$1.R, 'Promise', { 'finally': function (onFinally) {
  var C = _speciesConstructor$1(this, _core$1.Promise || _global$1.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

// https://github.com/tc39/proposal-promise-try




_export$1(_export$1.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = _newPromiseCapability.f(this);
  var result = _perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

var promise = _core$1.Promise;

var promise$1 = promise;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    promise$1.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new promise$1(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var apiNamespace = process.env.VUE_APP_API_NAMESPACE;

var axiosConfig = function axiosConfig() {
  return AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
};

var normalizedEndpoint = "".concat(process.env.VUE_APP_API_URL, "/v1/").concat(apiNamespace, "/products");
/**
 * Retrieve all call outs from a given product using productId. Destructure the data from the response
 * which is a single property called callout that is an array of callouts.
 *
 * @param {number} productId
 * @returns {Promise}
 */

var readCallouts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(productId) {
    var url, _yield$axios$get, callout;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(normalizedEndpoint, "/").concat(productId, "/callouts");
            _context.next = 3;
            return axios$1.get(url, axiosConfig());

          case 3:
            _yield$axios$get = _context.sent;
            callout = _yield$axios$get.data.callout;
            return _context.abrupt("return", callout);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readCallouts(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * create a single callout with provided note onto specific plan design value. Destructure the data from the response
 * which is a single property called callout that is the newly created callout.
 *
 * @param {number} productId
 * @param {number} planDesignValueId
 * @param {string} note
 * @returns {Promise}
 */

var createCallout = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(productId, planDesignValueId, note) {
    var url, body, _yield$axios$post, callout;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = "".concat(normalizedEndpoint, "/").concat(productId, "/callouts");
            body = {
              plan_design_value_id: planDesignValueId,
              note: note
            };
            _context2.next = 4;
            return axios$1.post(url, body, axiosConfig());

          case 4:
            _yield$axios$post = _context2.sent;
            callout = _yield$axios$post.data.callout;
            return _context2.abrupt("return", callout);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createCallout(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * update a single callout. Destructure the data from the response
 * which is a single property called callout that is the updated callout.
 *
 * @param {number} productId
 * @param {number} calloutId
 * @param {string} note
 * @returns {Promise}
 */

var updateCallout = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(productId, calloutId, note) {
    var url, body, _yield$axios$patch, callout;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = "".concat(normalizedEndpoint, "/").concat(productId, "/callouts/").concat(calloutId);
            body = {
              note: note
            };
            _context3.next = 4;
            return axios$1.patch(url, body, axiosConfig());

          case 4:
            _yield$axios$patch = _context3.sent;
            callout = _yield$axios$patch.data.callout;
            return _context3.abrupt("return", callout);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateCallout(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Delete a single callout and return the response.
 *
 * @param {number} productId
 * @param {number} calloutId
 * @returns {Promise}
 */

var deleteCallout = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(productId, calloutId) {
    var url, response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = "".concat(normalizedEndpoint, "/").concat(productId, "/callouts/").concat(calloutId);
            _context4.next = 3;
            return axios$1.delete(url, axiosConfig());

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function deleteCallout(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();

var callouts = /*#__PURE__*/Object.freeze({
	__proto__: null,
	readCallouts: readCallouts,
	createCallout: createCallout,
	updateCallout: updateCallout,
	deleteCallout: deleteCallout
});

var getDefaultState = function getDefaultState() {
  return {
    callouts: []
  };
};

var moduleState = getDefaultState();
var moduleGetters = {
  getSingleCallout: function getSingleCallout(state) {
    return function (pdvId) {
      return state.callouts.find(function (callout) {
        return callout.plan_design_value_id === pdvId;
      });
    };
  }
};
var moduleActions = {
  /**
   * Takes an array of product ids and makes an api call for each.
   * Service should return an array of callouts per call.
   *
   * @param {object} vuex
   * @param {Function} vuex.commit
   * @param {Array} productIds
   */
  getCallouts: function () {
    var _getCallouts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref, productIds) {
      var commit, allCallouts;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref.commit;
              _context2.next = 3;
              return productIds.reduce( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accPromise, productId) {
                  var acc, callouts;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return accPromise;

                        case 2:
                          acc = _context.sent;
                          _context.next = 5;
                          return readCallouts(productId);

                        case 5:
                          callouts = _context.sent;
                          return _context.abrupt("return", [].concat(_toConsumableArray(acc), _toConsumableArray(callouts)));

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3, _x4) {
                  return _ref2.apply(this, arguments);
                };
              }(), []);

            case 3:
              allCallouts = _context2.sent;
              commit('setCallouts', allCallouts);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getCallouts(_x, _x2) {
      return _getCallouts.apply(this, arguments);
    }

    return getCallouts;
  }()
};
var moduleMutations = {
  setCallouts: function setCallouts(state, newCallouts) {
    state.callouts = newCallouts;
  }
};
var callouts$1 = {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
  actions: moduleActions,
  mutations: moduleMutations
};

var Store = {
  callouts: callouts$1
};
var Threeflow = {
  /**
   * Install our component
   *
   * @param {object} Vue
   * @param {object} options
   */
  install: function install(Vue, options) {
    // #legacy: Remove when all apps have switched to TF naming convention.
    Object.defineProperty(Vue.prototype, '$WT', {
      value: threeflowObject
    });
    Object.defineProperty(Vue.prototype, '$TF', {
      value: threeflowObject
    });
    Interceptor.activate(options);
    loadThreeflowComponents(Vue);
    locale$1.use(lang);
  }
};

export { Analytics, AxiosConfig, callouts as CalloutsService, CommentService, Cookies, DatesUtils, Formatting, NotificationsService, Product, ReusableData, SourceService, Store, Threeflow, Threeflow as WatchtowerBenefits };
//# sourceMappingURL=watchtower-shared-components.js.map
